import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type AccessGroup = {
  __typename?: 'AccessGroup';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  members: Array<AccessGroupMember>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AccessGroupMember = {
  __typename?: 'AccessGroupMember';
  apiKeyId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type AccessGroupPrincipalsInput = {
  accessGroupId: Scalars['ID']['input'];
  apiKeyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Account = {
  __typename?: 'Account';
  accountSettings: AccountSettings;
  accountSettingsId: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentUserPermissions: Array<Scalars['String']['output']>;
  currentUserRole: Role;
  dataWarehouse?: Maybe<DataWarehouse>;
  dataWarehouseConnection?: Maybe<Connection>;
  dataWarehouseConnectionId?: Maybe<Scalars['String']['output']>;
  dataWarehouseSubTitle?: Maybe<Scalars['String']['output']>;
  dataWarehouseTitle?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  dwhFairUsageViolatedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isTest: Scalars['Boolean']['output'];
  members: Array<AccountMember>;
  name?: Maybe<Scalars['String']['output']>;
  notificationEmails: Array<Scalars['String']['output']>;
  plan: WeldPlan;
  scheduledForDeletionAt?: Maybe<Scalars['DateTime']['output']>;
  slackNotificationInfo?: Maybe<SlackNotificationInfo>;
  slug: Scalars['String']['output'];
  stripeCustomer?: Maybe<Customer>;
  stripeSubscription?: Maybe<StripeSubscription>;
  teamsNotificationInfo?: Maybe<TeamsNotificationInfo>;
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AccountEffectiveFeaturesDto = {
  __typename?: 'AccountEffectiveFeaturesDto';
  accountId: Scalars['ID']['output'];
  features: Array<EffectiveFeatureDto>;
  planIsRanked: Scalars['Boolean']['output'];
  planName: PlanName;
  revokedEntitlements: Array<FeatureEntitlementDto>;
};

export type AccountEltDestination = {
  __typename?: 'AccountEltDestination';
  /** Applies the deletes a Postgres change data capture run reports. */
  cdcDeletesSupported: Scalars['Boolean']['output'];
  connection?: Maybe<Connection>;
  connectionId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  historyTablesSupported: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  integrationId: Scalars['String']['output'];
  /** Names the ELT Destination. Unique among the account's ELT Destinations. */
  label: Scalars['String']['output'];
  /** This destination's settings, answering the settings schema of its integration. */
  settings: Scalars['JSONObject']['output'];
  softDeletesSupported: Scalars['Boolean']['output'];
  /** How many ELT Syncs load into this destination. While any do, only its label can change. */
  syncCount: Scalars['Int']['output'];
  /** Whether ELT Syncs created without a list of additional destinations also load into this destination. Syncs that already exist are not changed. */
  useForNewSyncs: Scalars['Boolean']['output'];
};

export type AccountMember = {
  __typename?: 'AccountMember';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastLogin: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  role: Role;
};

export type AccountSettings = {
  __typename?: 'AccountSettings';
  aiMetadataOnly: Scalars['Boolean']['output'];
  deactivateELTSyncs: Scalars['Boolean']['output'];
  deactivateReverseELTSyncs: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  maxBillableRows?: Maybe<Scalars['Float']['output']>;
  transformTool?: Maybe<TransformTool>;
};

export type AccountUsageSummary = {
  __typename?: 'AccountUsageSummary';
  connectors: Scalars['Float']['output'];
  eltSyncs: Scalars['Float']['output'];
  reverseEtlSyncs: Scalars['Float']['output'];
  uniqueIntegrationIds: Array<Scalars['String']['output']>;
};

export type ActivateDevStatusInput = {
  devNotes: Scalars['String']['input'];
  devStatus: Scalars['String']['input'];
  syncId: Scalars['String']['input'];
};

export type ActivateError = {
  __typename?: 'ActivateError';
  error: Scalars['String']['output'];
  objectId: Scalars['String']['output'];
  scheduledJobId: Scalars['String']['output'];
  syncId: Scalars['String']['output'];
};

export type ActivateSyncJobResponse = {
  __typename?: 'ActivateSyncJobResponse';
  accountId?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['JSONObject']['output']>;
  destinationIntegrationId?: Maybe<Scalars['String']['output']>;
  destinationSecretId?: Maybe<Scalars['String']['output']>;
  devName?: Maybe<Scalars['String']['output']>;
  devNotes?: Maybe<Scalars['String']['output']>;
  devSelfResolvable?: Maybe<Scalars['Boolean']['output']>;
  devStatus?: Maybe<Scalars['String']['output']>;
  devTimestamp?: Maybe<Scalars['String']['output']>;
  errorsSinceLastSuccessfulRun?: Maybe<Scalars['Float']['output']>;
  forceFullSync?: Maybe<Scalars['Boolean']['output']>;
  isQuarantined?: Maybe<Scalars['Boolean']['output']>;
  lastRun?: Maybe<Scalars['Float']['output']>;
  locks?: Maybe<Array<LockResponse>>;
  nextRun?: Maybe<Scalars['Float']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  running?: Maybe<Scalars['Boolean']['output']>;
  scheduledJobId?: Maybe<Scalars['String']['output']>;
  sourceIntegrationId?: Maybe<Scalars['String']['output']>;
  sourceSecretId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  syncId?: Maybe<Scalars['String']['output']>;
};

export type ActiveSubscription = {
  __typename?: 'ActiveSubscription';
  billingInterval: RecurrenceInterval;
  billingIntervalCount: Scalars['Int']['output'];
  cancelAt?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  currentBillingPeriod: DateRange;
  currentUsagePeriod: DateRange;
  customerId: Scalars['ID']['output'];
  planName: PlanName;
  prices: PlanPrices;
  status: StripeSubscriptionStatus;
  subscriptionId: Scalars['ID']['output'];
  trialEnd?: Maybe<Scalars['DateTime']['output']>;
};

export type ActivityActor = ActivityApiKeyActor | ActivityGithubSyncActor | ActivityPersonActor | ActivityWeldSupportActor;

export enum ActivityActorKind {
  ApiKey = 'apiKey',
  GithubSync = 'githubSync',
  Person = 'person',
  WeldSupport = 'weldSupport'
}

export type ActivityApiKeyActor = {
  __typename?: 'ActivityApiKeyActor';
  apiKeyId?: Maybe<Scalars['String']['output']>;
  kind: ActivityActorKind;
  name?: Maybe<Scalars['String']['output']>;
};

export type ActivityEvent = {
  __typename?: 'ActivityEvent';
  actor: ActivityActor;
  batchId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  payload: ActivityPayload;
  resource: ActivityResource;
  type: ActivityEventType;
};

export enum ActivityEventType {
  ConnectionCreated = 'connectionCreated',
  ConnectionDeleted = 'connectionDeleted',
  ConnectionReauthorized = 'connectionReauthorized',
  ConnectionSettingsChanged = 'connectionSettingsChanged',
  EltStreamAdded = 'eltStreamAdded',
  EltStreamFullSyncRequested = 'eltStreamFullSyncRequested',
  EltStreamIntervalChanged = 'eltStreamIntervalChanged',
  EltStreamModeChanged = 'eltStreamModeChanged',
  EltStreamPaused = 'eltStreamPaused',
  EltStreamRemoved = 'eltStreamRemoved',
  EltStreamResumed = 'eltStreamResumed',
  EltStreamSettingsChanged = 'eltStreamSettingsChanged',
  EltSyncCreated = 'eltSyncCreated',
  EltSyncDeleted = 'eltSyncDeleted',
  EltSyncDestinationAdded = 'eltSyncDestinationAdded',
  EltSyncDestinationRemoved = 'eltSyncDestinationRemoved',
  EltSyncPaused = 'eltSyncPaused',
  EltSyncResumed = 'eltSyncResumed',
  EltSyncScheduleChanged = 'eltSyncScheduleChanged',
  EltSyncSettingsChanged = 'eltSyncSettingsChanged',
  EltSyncStarted = 'eltSyncStarted',
  FolderCreated = 'folderCreated',
  FolderDeleted = 'folderDeleted',
  FolderRenamed = 'folderRenamed',
  ModelTestAdded = 'modelTestAdded',
  ModelTestRemoved = 'modelTestRemoved',
  OrchestrationCreated = 'orchestrationCreated',
  OrchestrationDeleted = 'orchestrationDeleted',
  OrchestrationEdited = 'orchestrationEdited',
  OrchestrationPaused = 'orchestrationPaused',
  OrchestrationResumed = 'orchestrationResumed',
  OrchestrationScheduleChanged = 'orchestrationScheduleChanged',
  ReverseEtlSyncCreated = 'reverseEtlSyncCreated',
  ReverseEtlSyncDeleted = 'reverseEtlSyncDeleted',
  ReverseEtlSyncMappingChanged = 'reverseEtlSyncMappingChanged',
  ReverseEtlSyncPaused = 'reverseEtlSyncPaused',
  ReverseEtlSyncResumed = 'reverseEtlSyncResumed',
  ReverseEtlSyncScheduleChanged = 'reverseEtlSyncScheduleChanged',
  ReverseEtlSyncStarted = 'reverseEtlSyncStarted',
  TransformDeleted = 'transformDeleted',
  TransformDocumentationUpdated = 'transformDocumentationUpdated',
  TransformMaterializationChanged = 'transformMaterializationChanged',
  TransformMoved = 'transformMoved',
  TransformPublished = 'transformPublished',
  TransformRestored = 'transformRestored',
  TransformUnpublished = 'transformUnpublished',
  WebhookCreated = 'webhookCreated',
  WebhookDeleted = 'webhookDeleted',
  WebhookUpdated = 'webhookUpdated'
}

export type ActivityFilterInput = {
  actorKinds?: InputMaybe<Array<ActivityActorKind>>;
  actorUserId?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  resourceNameContains?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  types?: InputMaybe<Array<ActivityEventType>>;
};

export type ActivityFilterOptions = {
  __typename?: 'ActivityFilterOptions';
  /** Kinds other than person, each a filter option of its own. */
  actorKinds: Array<ActivityActorKind>;
  people: Array<ActivityPersonActor>;
  types: Array<ActivityEventType>;
};

export type ActivityGithubSyncActor = {
  __typename?: 'ActivityGithubSyncActor';
  commitSha?: Maybe<Scalars['String']['output']>;
  fileCommit?: Maybe<GithubFileCommit>;
  kind: ActivityActorKind;
  syncId?: Maybe<Scalars['String']['output']>;
  triggeredBy?: Maybe<ActivityPersonActor>;
};

export type ActivityPageInput = {
  before?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ActivityPayload = ConnectionActivityPayload | EltStreamActivityPayload | EltSyncActivityPayload | FolderActivityPayload | ModelTestActivityPayload | OrchestrationActivityPayload | ReverseEtlSyncActivityPayload | TransformChangedActivityPayload | TransformDeletedActivityPayload | TransformPublishedActivityPayload | WebhookActivityPayload;

export type ActivityPersonActor = {
  __typename?: 'ActivityPersonActor';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  kind: ActivityActorKind;
  lastName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type ActivityResource = {
  __typename?: 'ActivityResource';
  exists: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: ActivityResourceType;
};

export enum ActivityResourceType {
  Connection = 'connection',
  EltStream = 'eltStream',
  EltSync = 'eltSync',
  Folder = 'folder',
  ModelTest = 'modelTest',
  Orchestration = 'orchestration',
  ReverseEtlSync = 'reverseEtlSync',
  Transform = 'transform',
  Webhook = 'webhook'
}

export type ActivityValueChange = {
  __typename?: 'ActivityValueChange';
  after?: Maybe<Scalars['String']['output']>;
  before?: Maybe<Scalars['String']['output']>;
};

export type ActivityWeldSupportActor = {
  __typename?: 'ActivityWeldSupportActor';
  kind: ActivityActorKind;
};

export type AddEltDestinationInput = {
  connectionId: Scalars['String']['input'];
  /** Names the ELT Destination. Unique among the account's ELT Destinations. */
  label: Scalars['String']['input'];
  /** The destination's settings, answering eltDestinationSettingsSchema of the connection's integration. A setting the schema gives a default may be left out and takes that default. An integration whose schema has no properties takes an empty object. */
  settings: Scalars['JSONObject']['input'];
  /** Whether ELT Syncs created without a list of additional destinations also load into this destination. Syncs that already exist are not changed. Refused when another destination on the same connection already is. */
  useForNewSyncs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddEltSyncDestinationInput = {
  destinationSchemaName?: InputMaybe<Scalars['String']['input']>;
  eltDestinationId: Scalars['String']['input'];
  eltSyncId: Scalars['String']['input'];
  reload: EltSyncDestinationReload;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Progress stage of an agent fix prompt generation, used when polling for midway results. */
export enum AgentFixPromptStage {
  AnalyzingError = 'ANALYZING_ERROR',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  FetchingErrorLogs = 'FETCHING_ERROR_LOGS',
  GeneratingFixPrompt = 'GENERATING_FIX_PROMPT',
  IdentifyingRootCause = 'IDENTIFYING_ROOT_CAUSE',
  Pending = 'PENDING'
}

export type AgentMessageDto = {
  __typename?: 'AgentMessageDto';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** AI SDK UI message parts, as streamed. */
  parts: Scalars['JSON']['output'];
  role: AgentMessageRole;
};

export enum AgentMessageRole {
  Assistant = 'assistant',
  User = 'user'
}

export enum AgentSurface {
  ModelDocumentation = 'modelDocumentation',
  ModelEditor = 'modelEditor'
}

export type AgentThreadDto = {
  __typename?: 'AgentThreadDto';
  createdAt: Scalars['DateTime']['output'];
  draftId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  modelId?: Maybe<Scalars['String']['output']>;
  surface: AgentSurface;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AliasMetadata = {
  __typename?: 'AliasMetadata';
  documentationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ApiKeyEntity = {
  __typename?: 'ApiKeyEntity';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ApiKeyResponse = {
  __typename?: 'ApiKeyResponse';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AppliedPromo = {
  __typename?: 'AppliedPromo';
  code?: Maybe<Scalars['String']['output']>;
  source: PromoSource;
};

export enum AsyncJobStatusEnum {
  Cancelled = 'cancelled',
  Done = 'done',
  Empty = 'empty',
  Error = 'error',
  Processing = 'processing'
}

export type AsyncQueryResultResponse = {
  __typename?: 'AsyncQueryResultResponse';
  numRowsTotal: Scalars['Int']['output'];
  rows: Array<Scalars['JSONObject']['output']>;
};

export type AsyncQueryStatusResponse = {
  __typename?: 'AsyncQueryStatusResponse';
  status: QueryResultStatusEnum;
};

export type AsyncStreamsStatus = {
  __typename?: 'AsyncStreamsStatus';
  errorMessage?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Float']['output']>;
  status: AsyncJobStatusEnum;
  streams?: Maybe<Array<Stream>>;
};

export type AttachEltTemplateInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  eltSyncId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};

export enum AuditLogType {
  Auth = 'AUTH',
  Operations = 'OPERATIONS'
}

export type AvailableAuditLog = {
  __typename?: 'AvailableAuditLog';
  count: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  type: AuditLogType;
};

export type AvailableIntegration = {
  __typename?: 'AvailableIntegration';
  abilities: Array<IntegrationAbility>;
  activateDestination?: Maybe<DataConnectorMetadata>;
  aliasFor?: Maybe<Scalars['String']['output']>;
  aliasMetadata?: Maybe<AliasMetadata>;
  baseId: Scalars['String']['output'];
  biTool?: Maybe<DataConnectorMetadata>;
  categories: Array<Scalars['String']['output']>;
  config?: Maybe<IntegrationConfiguration>;
  connectorForms: Array<IntegrationFormConfig>;
  dataWarehouse?: Maybe<DataConnectorMetadata>;
  description: Scalars['String']['output'];
  documentationUrl?: Maybe<Scalars['String']['output']>;
  eltSource?: Maybe<DataConnectorMetadata>;
  id: Scalars['String']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isUtilityConnector: Scalars['Boolean']['output'];
  logo: IntegrationLogoVariants;
  meetsPlanRequirement: Scalars['Boolean']['output'];
  minRequiredPlan?: Maybe<PlanName>;
  name: Scalars['String']['output'];
  requiresAdmin?: Maybe<Scalars['Boolean']['output']>;
};

export type AvroSchemaFieldDto = {
  __typename?: 'AvroSchemaFieldDto';
  name: Scalars['String']['output'];
  nullable: Scalars['Boolean']['output'];
  type: Array<Scalars['String']['output']>;
};

export type BqUsage = {
  __typename?: 'BQUsage';
  bqBilledUsd: Scalars['Float']['output'];
  datasetId: Scalars['String']['output'];
  metabaseUsage?: Maybe<QueryUsage>;
  path: Scalars['String']['output'];
  queryUsage?: Maybe<QueryUsage>;
  tableId: Scalars['String']['output'];
  totalBytesBilled: Scalars['Float']['output'];
  totalBytesProcessed: Scalars['Float']['output'];
};

export type BackofficeConnection = {
  __typename?: 'BackofficeConnection';
  active: Scalars['Boolean']['output'];
  connectedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  eltSyncs: Array<BackofficeEltSync>;
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  label: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BackofficeEltSync = {
  __typename?: 'BackofficeEltSync';
  active: Scalars['Boolean']['output'];
  changeDataCaptureEnabled?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  destinationConnectionId: Scalars['String']['output'];
  destinationIntegrationId: Scalars['String']['output'];
  destinationSchemaName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  operationMode: OperationMode;
  sourceConnectionId: Scalars['String']['output'];
  sourceIntegrationId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  syncInterval?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BackofficeReverseEtlMapping = {
  __typename?: 'BackofficeReverseEtlMapping';
  destinationPropertyName: Scalars['String']['output'];
  destinationPropertyType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  object: Scalars['String']['output'];
  primaryKey: Scalars['Boolean']['output'];
  readonly: Scalars['Boolean']['output'];
  sourcePropertyName: Scalars['String']['output'];
  sourcePropertyType: Scalars['String']['output'];
};

export type BackofficeReverseEtlOperation = {
  __typename?: 'BackofficeReverseEtlOperation';
  id: Scalars['String']['output'];
  mappings: Array<BackofficeReverseEtlMapping>;
  objectType: Scalars['String']['output'];
  operationMode: OperationModes;
  operationType: OperationTypes;
  primaryKeyRequired: Scalars['Boolean']['output'];
};

export type BackofficeReverseEtlSync = {
  __typename?: 'BackofficeReverseEtlSync';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  destinationConnectionId: Scalars['String']['output'];
  destinationConnectionLabel?: Maybe<Scalars['String']['output']>;
  destinationIntegrationId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  job?: Maybe<ActivateSyncJobResponse>;
  modelId?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  operationMode?: Maybe<OperationModes>;
  orchestrationWorkflowId?: Maybe<Scalars['String']['output']>;
  primaryObject: Scalars['String']['output'];
  scheduledJobId: Scalars['String']['output'];
  schedulerType: OrchestrationSchedulerType;
  sourceConnectionId: Scalars['String']['output'];
  sourceConnectionLabel?: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['String']['output'];
  sourceIntegrationId: Scalars['String']['output'];
  sourceType: SourceType;
  status: Scalars['String']['output'];
  syncInterval?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BackofficeReverseEtlSyncDetails = {
  __typename?: 'BackofficeReverseEtlSyncDetails';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  destinationConnectionId: Scalars['String']['output'];
  destinationConnectionLabel?: Maybe<Scalars['String']['output']>;
  destinationIntegrationId: Scalars['String']['output'];
  destinationSettings?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['String']['output'];
  job?: Maybe<ActivateSyncJobResponse>;
  modelId?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  modelWeldSql?: Maybe<Scalars['String']['output']>;
  operationMode?: Maybe<OperationModes>;
  operations: Array<BackofficeReverseEtlOperation>;
  orchestrationWorkflowId?: Maybe<Scalars['String']['output']>;
  primaryObject: Scalars['String']['output'];
  scheduledJobId: Scalars['String']['output'];
  schedulerType: OrchestrationSchedulerType;
  sourceConnectionId: Scalars['String']['output'];
  sourceConnectionLabel?: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['String']['output'];
  sourceIntegrationId: Scalars['String']['output'];
  sourceQuery?: Maybe<Scalars['String']['output']>;
  sourceType: SourceType;
  status: Scalars['String']['output'];
  syncInterval?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BackofficeReverseEtlSyncRun = {
  __typename?: 'BackofficeReverseEtlSyncRun';
  destinationWorkerEndedAt?: Maybe<Scalars['String']['output']>;
  destinationWorkerStartedAt?: Maybe<Scalars['String']['output']>;
  distinctRecords?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  failedRecords?: Maybe<Scalars['Float']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  newRecords?: Maybe<Scalars['Float']['output']>;
  sizeSyncedMb?: Maybe<Scalars['Float']['output']>;
  sourceWorkerEndedAt?: Maybe<Scalars['String']['output']>;
  sourceWorkerStartedAt?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  syncedRecords?: Maybe<Scalars['Float']['output']>;
  totalRecords?: Maybe<Scalars['Float']['output']>;
};

export type BackofficeReverseEtlSyncRunsPage = {
  __typename?: 'BackofficeReverseEtlSyncRunsPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<BackofficeReverseEtlSyncRun>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type BaseProduct = {
  __typename?: 'BaseProduct';
  active: Scalars['Boolean']['output'];
  addOnType?: Maybe<WeldAddOnType>;
  description?: Maybe<Scalars['String']['output']>;
  features: StripePlanFeatures;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: WeldProductType;
};

export type BatchJobStatus = {
  __typename?: 'BatchJobStatus';
  runDuration: Scalars['JSONObject']['output'];
  state: Scalars['String']['output'];
  statusEvents: Array<BatchJobStatusLogEntry>;
};

export type BatchJobStatusLogEntry = {
  __typename?: 'BatchJobStatusLogEntry';
  description: Scalars['String']['output'];
  eventTime: Scalars['JSONObject']['output'];
  taskExecution?: Maybe<Scalars['String']['output']>;
  taskState: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type BigQueryStats = {
  __typename?: 'BigQueryStats';
  data: Array<BqUsage>;
};

export type BigqueryExpirationCheckStatus = {
  __typename?: 'BigqueryExpirationCheckStatus';
  accountsChecked: Scalars['Float']['output'];
  running: Scalars['Boolean']['output'];
};

export type BillingDetailsInput = {
  address: AddressInput;
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  taxIdData?: InputMaybe<TaxIdInput>;
};

export enum BillingScheme {
  PerUnit = 'PerUnit',
  Tiered = 'Tiered'
}

export type BuildPreviewSqlInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  weldTag: Scalars['String']['input'];
};

/** Response type when building the weld SQL for a table/view preview. */
export type BuildPreviewSqlResponse = {
  __typename?: 'BuildPreviewSqlResponse';
  weldSql: Scalars['String']['output'];
};

export type CancelSubscriptionInput = {
  cancellationDetails?: InputMaybe<CancellationDetails>;
  limitUsageToCurrentTier?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionId: Scalars['String']['input'];
};

export type CancelSubscriptionResponse = {
  __typename?: 'CancelSubscriptionResponse';
  id: Scalars['String']['output'];
};

export type CancellationDetails = {
  comment?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<CancellationFeedback>;
};

export enum CancellationFeedback {
  CustomerService = 'CustomerService',
  LowQuality = 'LowQuality',
  MissingFeatures = 'MissingFeatures',
  Other = 'Other',
  SwitchedService = 'SwitchedService',
  TooComplex = 'TooComplex',
  TooExpensive = 'TooExpensive',
  Unused = 'Unused'
}

export type CancelledSubscriptionDto = {
  __typename?: 'CancelledSubscriptionDto';
  account: Account;
  canceledAt: Scalars['DateTime']['output'];
  /** Stripe cancellation_details.comment */
  comment?: Maybe<Scalars['String']['output']>;
  /** Stripe cancellation_details.feedback */
  feedback?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  /** Stripe cancellation_details.reason */
  reason?: Maybe<Scalars['String']['output']>;
  stripeCustomerId: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
};

export type CancellingCustomerDto = {
  __typename?: 'CancellingCustomerDto';
  account: Account;
  cancelAt: Scalars['DateTime']['output'];
  planName: Scalars['String']['output'];
  stage: CustomerFunnelStage;
  stripeCustomerId: Scalars['String']['output'];
};

export type Card = {
  __typename?: 'Card';
  brand: CardBrand;
  expirationMonth: Scalars['Int']['output'];
  expirationYear: Scalars['Int']['output'];
  last4: Scalars['String']['output'];
};

export enum CardBrand {
  Amex = 'Amex',
  Diners = 'Diners',
  Discover = 'Discover',
  Jcb = 'JCB',
  Mastercard = 'Mastercard',
  UnionPay = 'UnionPay',
  Unknown = 'Unknown',
  Visa = 'Visa'
}

export type ChangelogGenerationResult = {
  __typename?: 'ChangelogGenerationResult';
  changelog?: Maybe<GithubMonthlyChangelog>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  processedPrs?: Maybe<Scalars['Int']['output']>;
  status: ChangelogGenerationStatus;
  totalPrs?: Maybe<Scalars['Int']['output']>;
};

export enum ChangelogGenerationStatus {
  Error = 'ERROR',
  NotFound = 'NOT_FOUND',
  Pending = 'PENDING',
  Ready = 'READY'
}

export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ClaimPromoCodeInput = {
  code: Scalars['String']['input'];
};

export type CompleteGithubConnectionInput = {
  branch?: InputMaybe<Scalars['String']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  repoName: Scalars['String']['input'];
  repoOwner: Scalars['String']['input'];
};

export type Config = {
  __typename?: 'Config';
  destinationSettings?: Maybe<Scalars['JSONObject']['output']>;
};

export type ConfigurableLimits = {
  __typename?: 'ConfigurableLimits';
  maxConnectors?: Maybe<Scalars['Float']['output']>;
  maxRows?: Maybe<Scalars['Float']['output']>;
  maxUsers?: Maybe<Scalars['Float']['output']>;
};

export type Connection = {
  __typename?: 'Connection';
  active: Scalars['Boolean']['output'];
  apiKey?: Maybe<ApiKeyEntity>;
  connectedAt: Scalars['DateTime']['output'];
  connectedExternally: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  credentials: Scalars['JSONObject']['output'];
  customInput?: Maybe<Scalars['JSONObject']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  eltSyncs: Array<EltSync>;
  formId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  label: Scalars['String']['output'];
  restricted: Scalars['Boolean']['output'];
  reverseEltSyncs: Array<Sync>;
  source: ConnectionSource;
  updatedAt: Scalars['DateTime']['output'];
  usageSummary: ConnectionUsageSummary;
  user?: Maybe<User>;
};

export type ConnectionActivityPayload = {
  __typename?: 'ConnectionActivityPayload';
  integrationId: Scalars['String']['output'];
};

export type ConnectionBridgeResponse = {
  __typename?: 'ConnectionBridgeResponse';
  authorizeUrl: Scalars['String']['output'];
  connectionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ConnectionCdcFeatures = {
  __typename?: 'ConnectionCDCFeatures';
  changeDataCaptureEnabled: Scalars['Boolean']['output'];
  supportedTables: Array<Scalars['String']['output']>;
  /** Why no table supports CDC, phrased for the customer to act on. Null when tables are supported, and when CDC has not been enabled in the source settings yet. */
  unsupportedReason?: Maybe<Scalars['String']['output']>;
};

export enum ConnectionSource {
  Api = 'API',
  App = 'APP'
}

export type ConnectionUsageSummary = {
  __typename?: 'ConnectionUsageSummary';
  numEltSyncs: Scalars['Int']['output'];
  numRevEltSyncs: Scalars['Int']['output'];
  totalSyncs: Scalars['Int']['output'];
};

export type ConnectorFormConfig = {
  __typename?: 'ConnectorFormConfig';
  id: Scalars['String']['output'];
  minRequiredPlan?: Maybe<PlanName>;
  name: Scalars['String']['output'];
};

export type ConnectorFormConfigInput = {
  id: Scalars['String']['input'];
  minRequiredPlan?: InputMaybe<PlanName>;
};

export type ConnectorMetadata = {
  __typename?: 'ConnectorMetadata';
  changeDataCaptureSupported: Scalars['Boolean']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isListedOnWebsite: Scalars['Boolean']['output'];
  minRequiredPlan?: Maybe<PlanName>;
  status?: Maybe<DevStatus>;
  tags: Array<Scalars['String']['output']>;
};

export type ConnectorPlanValidationResult = {
  __typename?: 'ConnectorPlanValidationResult';
  connectionCount: Scalars['Float']['output'];
  dataWarehouseViolation?: Maybe<ConnectorPlanViolation>;
  isConnectorLimitExceeded: Scalars['Boolean']['output'];
  maxConnections: Scalars['Float']['output'];
  valid: Scalars['Boolean']['output'];
  violations: Array<ConnectorPlanViolation>;
};

export type ConnectorPlanViolation = {
  __typename?: 'ConnectorPlanViolation';
  id: Scalars['String']['output'];
  minRequiredPlan: PlanName;
  name: Scalars['String']['output'];
};

export type ConnectorRestriction = {
  __typename?: 'ConnectorRestriction';
  accessGroups: Array<AccessGroup>;
  connectionId: Scalars['ID']['output'];
  restricted: Scalars['Boolean']['output'];
};

export enum ConnectorType {
  ActivateDestination = 'ACTIVATE_DESTINATION',
  BiTool = 'BI_TOOL',
  DataWarehouse = 'DATA_WAREHOUSE',
  EltSource = 'ELT_SOURCE',
  Utility = 'UTILITY'
}

export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  dial_code: Scalars['String']['output'];
  emoji: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CreateAccessGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateAccountInput = {
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateApiKeyInput = {
  name: Scalars['String']['input'];
};

export type CreateAsyncQueryPreviewResponse = {
  __typename?: 'CreateAsyncQueryPreviewResponse';
  dwSql: Scalars['String']['output'];
  queryExecutionId: Scalars['String']['output'];
};

export type CreateConnectionBridgeInput = {
  connectionId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type CreateConnectionInput = {
  formId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['String']['input'];
  label: Scalars['String']['input'];
  payload: Scalars['String']['input'];
};

export type CreateDailyUsageStatAdjustmentInput = {
  accountId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  rows: Scalars['Int']['input'];
  scheduledJobId: Scalars['String']['input'];
  startedAt: Scalars['String']['input'];
};

export type CreateDraftModelInput = {
  dashboardId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sourceConnectionId: Scalars['String']['input'];
  weldSql: Scalars['String']['input'];
};

export type CreateEltSyncInput = {
  /** ELT destinations the sync also loads into, next to the data warehouse. Left out, the sync loads into the ELT destinations whose useForNewSyncs is true, when the account has the multi-destination ELT feature. An empty list loads into the data warehouse only. */
  additionalDestinations?: InputMaybe<Array<EltSyncAdditionalDestinationInput>>;
  config?: InputMaybe<Scalars['String']['input']>;
  destinationConnectionId: Scalars['String']['input'];
  destinationSchemaName?: InputMaybe<Scalars['String']['input']>;
  identifierCasing?: InputMaybe<IdentifierCasing>;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  schedulerType?: OrchestrationSchedulerType;
  sourceConnectionId: Scalars['String']['input'];
  sourceStreams: Array<SourceStreamInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  syncInterval?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExampleConnectionInput = {
  SampleDataName: ExampleDatabaseTypes;
};

export type CreateFolderInput = {
  DWName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManagedWorkspaceInput = {
  dataWarehouseLocation: Scalars['String']['input'];
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceName: Scalars['String']['input'];
};

export type CreateMappingInput = {
  destinationPropertyId: Scalars['String']['input'];
  destinationPropertyName: Scalars['String']['input'];
  destinationPropertyType: Scalars['String']['input'];
  object: Scalars['String']['input'];
  operation: OperationModes;
  primaryKey: Scalars['Boolean']['input'];
  readonly: Scalars['Boolean']['input'];
  sourcePropertyId: Scalars['String']['input'];
  sourcePropertyName: Scalars['String']['input'];
  sourcePropertyType: Scalars['String']['input'];
  type: OperationTypes;
};

export type CreateModelTestInput = {
  column: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  testType: TestType;
};

export type CreateNotificationInput = {
  accountId: Scalars['String']['input'];
  accountName: Scalars['String']['input'];
  detail: Array<Scalars['JSONObject']['input']>;
  entityId: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  entityType: NotificationEntityType;
  eventId?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  isDismissable?: Scalars['Boolean']['input'];
  isLock?: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  notificationLevel: Scalars['String']['input'];
  show?: Scalars['Boolean']['input'];
  source: NotificationSources;
  type: Scalars['String']['input'];
};

export type CreateOAuthFlowInput = {
  connectionId?: InputMaybe<Scalars['String']['input']>;
  formId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['String']['input'];
  payload: Scalars['String']['input'];
};

export type CreateOperationInput = {
  id: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  mappings: Array<CreateMappingInput>;
  objectType: Scalars['String']['input'];
  objectTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrUpdateCustomerInput = {
  address: AddressInput;
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  taxIdData?: InputMaybe<TaxIdInput>;
};

export type CreatePaymentMethodCheckoutSessionInput = {
  cancelUrl: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
};

export type CreateQueryResultCsvDownloadInput = {
  /** Optional file name for the generated CSV (with extension). */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** The SQL query whose result should be exported as CSV. */
  sqlQuery: Scalars['String']['input'];
};

export type CreateReverseEtlSyncInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  destinationConnectionId: Scalars['String']['input'];
  operations: Array<CreateOperationInput>;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  primaryObject: Scalars['String']['input'];
  primaryObjectId?: InputMaybe<Scalars['String']['input']>;
  schedulerType?: OrchestrationSchedulerType;
  sourceConnectionId: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  sourceType?: SourceType;
  syncInterval?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSetupIntentResponse = {
  __typename?: 'CreateSetupIntentResponse';
  clientSecret: Scalars['String']['output'];
};

export type CreateSubscriptionResponse = {
  __typename?: 'CreateSubscriptionResponse';
  id: Scalars['String']['output'];
  paymentIntentClientSecret?: Maybe<Scalars['String']['output']>;
};

export type CreateWebhookInput = {
  data: Scalars['JSONObject']['input'];
  dependencies: Array<DependencyInput>;
  externalSystem: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orchestrationWorkflowId?: InputMaybe<Scalars['String']['input']>;
};

export type CurrencyAmountDto = {
  __typename?: 'CurrencyAmountDto';
  /** In the currency's smallest unit. */
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
};

export type CurrencyOption = {
  __typename?: 'CurrencyOption';
  currency: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  tiers?: Maybe<Array<Tier>>;
};

export type CurrentPlanState = {
  __typename?: 'CurrentPlanState';
  currentUsagePeriod: DateRange;
  plan: Plan;
  subscription?: Maybe<ActiveSubscription>;
  usagePeriodAnchor: Scalars['DateTime']['output'];
};

export type CurrentUser = {
  __typename?: 'CurrentUser';
  accounts?: Maybe<Array<Account>>;
  email: Scalars['String']['output'];
  emailValidated: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  role: Role;
  scopes: Array<EditorScope>;
  weldSuperAdmin?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomFormInput = {
  connectionId: Scalars['String']['input'];
  dependencies: Scalars['String']['input'];
};

export type CustomFormValidationInput = {
  connectionId: Scalars['String']['input'];
  payload: Scalars['String']['input'];
};

export type CustomFormValidationResult = {
  __typename?: 'CustomFormValidationResult';
  customFormValidationResult: Scalars['JSONObject']['output'];
};

export type CustomFormValues = {
  __typename?: 'CustomFormValues';
  customFormValues: Scalars['JSONObject']['output'];
};

export type Customer = {
  __typename?: 'Customer';
  accountId: Scalars['String']['output'];
  address?: Maybe<Address>;
  companyName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  taxId?: Maybe<TaxId>;
};

export type CustomerFunnelDto = {
  __typename?: 'CustomerFunnelDto';
  freeTrials: Scalars['Int']['output'];
  payingCustomers: Scalars['Int']['output'];
  subscriptionTrials: Scalars['Int']['output'];
};

export enum CustomerFunnelStage {
  PayingCustomer = 'PayingCustomer',
  SubscriptionTrial = 'SubscriptionTrial'
}

export type CustomerUsageDto = {
  __typename?: 'CustomerUsageDto';
  account: Account;
  connectors: UsageAgainstLimitDto;
  /** True on standard plans, the only ones billed for overage automatically; false on custom, enterprise and legacy plans. */
  overageBilled: Scalars['Boolean']['output'];
  /** Usage periods, oldest first; the last is still open. */
  periods: Array<CustomerUsagePeriodDto>;
  planName: Scalars['String']['output'];
  /** Monthly active rows included; null when unlimited. */
  rowsLimit?: Maybe<Scalars['Float']['output']>;
  signal?: Maybe<CustomerUsageSignal>;
  stage: CustomerFunnelStage;
  stripeCustomerId: Scalars['String']['output'];
  /** Members plus pending invitations, as the seat limit counts them. */
  users: UsageAgainstLimitDto;
};

export type CustomerUsagePeriodDto = {
  __typename?: 'CustomerUsagePeriodDto';
  activeRows: Scalars['Float']['output'];
  /** False for the period still open. */
  complete: Scalars['Boolean']['output'];
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
  /** False for a period that began before the subscription did. */
  subscribed: Scalars['Boolean']['output'];
  /** Active rows over the row limit; null when unlimited. */
  usageRatio?: Maybe<Scalars['Float']['output']>;
};

export enum CustomerUsageSignal {
  Downsell = 'Downsell',
  Upsell = 'Upsell'
}

export enum DwMigrationStatus {
  ClearedErrors = 'CLEARED_ERRORS',
  Completed = 'COMPLETED',
  DwMigrationDone = 'DW_MIGRATION_DONE',
  Failed = 'FAILED',
  ModelMigrationDone = 'MODEL_MIGRATION_DONE',
  Started = 'STARTED',
  StoppedSyncs = 'STOPPED_SYNCS',
  SyncingModels = 'SYNCING_MODELS',
  SyncingTables = 'SYNCING_TABLES',
  SyncingViews = 'SYNCING_VIEWS',
  UpdatedConnection = 'UPDATED_CONNECTION'
}

export type DailyUsageDashboardData = {
  __typename?: 'DailyUsageDashboardData';
  destinationObjects: Array<DailyUsageDestinationObjectSummary>;
  integrations: Array<DailyUsageIntegrationSummary>;
  sourceStreams: Array<DailyUsageSourceStreamSummary>;
  summary: DailyUsageTotalSummary;
  timeline: Array<DailyUsageTimelineEntry>;
};

export type DailyUsageDashboardResponse = {
  __typename?: 'DailyUsageDashboardResponse';
  data: DailyUsageDashboardData;
  period: DailyUsageStatsPeriod;
};

export type DailyUsageDestinationObjectSummary = {
  __typename?: 'DailyUsageDestinationObjectSummary';
  activeRows: Scalars['Float']['output'];
  integrationId: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  syncedRows: Scalars['Float']['output'];
};

export type DailyUsageDestinationObjectSummaryResponse = {
  __typename?: 'DailyUsageDestinationObjectSummaryResponse';
  data: Array<DailyUsageDestinationObjectSummary>;
  period: DailyUsageStatsPeriod;
};

export type DailyUsageForecastDataPoint = {
  __typename?: 'DailyUsageForecastDataPoint';
  date: Scalars['DateTime']['output'];
  /** Cumulative active rows from period start through this day */
  runningTotalActiveRows: Scalars['Float']['output'];
  /** Cumulative synced rows from period start through this day */
  runningTotalSyncedRows: Scalars['Float']['output'];
};

export enum DailyUsageForecastErrorCode {
  InsufficientData = 'InsufficientData'
}

export type DailyUsageForecastRates = {
  __typename?: 'DailyUsageForecastRates';
  activeRows: Scalars['Float']['output'];
  syncedRows: Scalars['Float']['output'];
};

export type DailyUsageForecastResult = {
  __typename?: 'DailyUsageForecastResult';
  /** EWMA-smoothed daily rate used for all forecasted days */
  dailyForecastedRate?: Maybe<DailyUsageForecastRates>;
  /** Why no forecast could be produced; the rate fields are null when this is set */
  errorCode?: Maybe<DailyUsageForecastErrorCode>;
  /** Sum of forecasted daily values only */
  forecastedRows?: Maybe<DailyUsageForecastRates>;
  /** Empty when no forecast could be produced */
  predictions: Array<DailyUsageForecastDataPoint>;
  /** Historical actuals + forecasted rows for the full period */
  projectedTotalRows?: Maybe<DailyUsageForecastRates>;
};

export type DailyUsageIntegrationSummary = {
  __typename?: 'DailyUsageIntegrationSummary';
  activeRows: Scalars['Float']['output'];
  elt: DailyUsageSyncTypeRowSummary;
  integrationId: Scalars['String']['output'];
  reverseElt: DailyUsageSyncTypeRowSummary;
  syncedRows: Scalars['Float']['output'];
};

export type DailyUsageIntegrationSummaryResponse = {
  __typename?: 'DailyUsageIntegrationSummaryResponse';
  data: Array<DailyUsageIntegrationSummary>;
  period: DailyUsageStatsPeriod;
};

export type DailyUsagePeriodInput = {
  end: Scalars['DateTime']['input'];
  endInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['DateTime']['input'];
};

export type DailyUsageRowMetric = {
  __typename?: 'DailyUsageRowMetric';
  activeRows: Scalars['Float']['output'];
  syncedRows: Scalars['Float']['output'];
};

export type DailyUsageSourceStreamSummary = {
  __typename?: 'DailyUsageSourceStreamSummary';
  activeRows: Scalars['Float']['output'];
  /** Billed rows for loading into extra ELT destinations, already included in activeRows: each extra ELT destination a run loads adds half of that run's billed rows. */
  extraDestinationActiveRows: Scalars['Float']['output'];
  historyTable?: Maybe<DailyUsageRowMetric>;
  integrationId: Scalars['String']['output'];
  mainTable: DailyUsageRowMetric;
  resource: Scalars['String']['output'];
  /** Null when no day in the period has sub-table metrics, which is not the same as no sub-tables. */
  substreams?: Maybe<DailyUsageSubstreamSummary>;
  syncIds: Array<Scalars['String']['output']>;
  syncedRows: Scalars['Float']['output'];
};

export type DailyUsageSourceStreamSummaryResponse = {
  __typename?: 'DailyUsageSourceStreamSummaryResponse';
  data: Array<DailyUsageSourceStreamSummary>;
  period: DailyUsageStatsPeriod;
};

export type DailyUsageSourceStreamTimelineEntry = {
  __typename?: 'DailyUsageSourceStreamTimelineEntry';
  activeRows: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  /** Billed rows for loading into extra ELT destinations, already included in activeRows: each extra ELT destination a run loads adds half of that run's billed rows. */
  extraDestinationActiveRows: Scalars['Float']['output'];
  historyTable?: Maybe<DailyUsageRowMetric>;
  mainTable: DailyUsageRowMetric;
  runningTotalActiveRows: Scalars['Float']['output'];
  runningTotalSyncedRows: Scalars['Float']['output'];
  scheduledJobId: Scalars['String']['output'];
  syncId: Scalars['String']['output'];
  syncedRows: Scalars['Float']['output'];
};

export type DailyUsageSourceStreamTimelineResponse = {
  __typename?: 'DailyUsageSourceStreamTimelineResponse';
  data: Array<DailyUsageSourceStreamTimelineEntry>;
  period: DailyUsageStatsPeriod;
};

export type DailyUsageStatAdjustmentDto = {
  __typename?: 'DailyUsageStatAdjustmentDto';
  accountId: Scalars['String']['output'];
  chunkCorrelationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  originalTotalRows: Scalars['Float']['output'];
  reason: Scalars['String']['output'];
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  revokedBy?: Maybe<Scalars['String']['output']>;
  rows: Scalars['Float']['output'];
  scheduledJobId: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type DailyUsageStatAdjustmentMutationResponse = {
  __typename?: 'DailyUsageStatAdjustmentMutationResponse';
  adjustment: DailyUsageStatAdjustmentDto;
  recompute?: Maybe<DailyUsageStatRecomputeDto>;
  recomputeError?: Maybe<Scalars['String']['output']>;
};

export type DailyUsageStatRecomputeDto = {
  __typename?: 'DailyUsageStatRecomputeDto';
  periodActiveRowsAfter: Scalars['Float']['output'];
  periodActiveRowsBefore: Scalars['Float']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  runFoundInAggregation: Scalars['Boolean']['output'];
};

export type DailyUsageStatsPeriod = {
  __typename?: 'DailyUsageStatsPeriod';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type DailyUsageSubstreamRows = {
  __typename?: 'DailyUsageSubstreamRows';
  destinationTableName: Scalars['String']['output'];
  substreamId: Scalars['String']['output'];
  syncedRows: Scalars['Float']['output'];
};

export type DailyUsageSubstreamSummary = {
  __typename?: 'DailyUsageSubstreamSummary';
  /** Billed sub-table rows in the period, already included in the stream's activeRows. Null when the account was not billed under the v2 MAR rules in the period: sub-table rows were then not billed. */
  activeRows?: Maybe<Scalars['Float']['output']>;
  /** False when a day with sub-table rows has no per-table counts (before 2026-09-24, or a run lacked them). bySubstream then covers only part of syncedRows; the rest, syncedRows minus its sum, is at least 0. */
  breakdownComplete: Scalars['Boolean']['output'];
  /** Rows per sub-table on the days with per-table counts, largest first. Empty means "no sub-tables" only when breakdownComplete is true. */
  bySubstream: Array<DailyUsageSubstreamRows>;
  /** Sub-table rows also written to the sub-tables' history tables in the period, on top of syncedRows. Billed, within the history-table active rows, only under the v2 MAR rules. Days aggregated before this count existed contribute 0. */
  historyTableSyncedRows: Scalars['Float']['output'];
  /** Rows synced to sub-tables in the period. Billed only when activeRows is set. */
  syncedRows: Scalars['Float']['output'];
};

export type DailyUsageSyncTypeEntry = {
  __typename?: 'DailyUsageSyncTypeEntry';
  activeRows: Scalars['Float']['output'];
  runningTotalActiveRows: Scalars['Float']['output'];
  runningTotalSyncedRows: Scalars['Float']['output'];
  syncedRows: Scalars['Float']['output'];
};

export type DailyUsageSyncTypeRowSummary = {
  __typename?: 'DailyUsageSyncTypeRowSummary';
  activeRows: Scalars['Float']['output'];
  syncedRows: Scalars['Float']['output'];
};

export type DailyUsageSyncTypeSummary = {
  __typename?: 'DailyUsageSyncTypeSummary';
  activeRows: Scalars['Float']['output'];
  activeRowsPercentage: Scalars['Float']['output'];
  syncedRows: Scalars['Float']['output'];
  syncedRowsPercentage: Scalars['Float']['output'];
};

export type DailyUsageTimelineEntry = {
  __typename?: 'DailyUsageTimelineEntry';
  activeRows: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  elt: DailyUsageSyncTypeEntry;
  reverseElt: DailyUsageSyncTypeEntry;
  runningTotalActiveRows: Scalars['Float']['output'];
  runningTotalSyncedRows: Scalars['Float']['output'];
  syncedRows: Scalars['Float']['output'];
};

export type DailyUsageTimelineResponse = {
  __typename?: 'DailyUsageTimelineResponse';
  data: Array<DailyUsageTimelineEntry>;
  period: DailyUsageStatsPeriod;
};

export type DailyUsageTotalSummary = {
  __typename?: 'DailyUsageTotalSummary';
  activeRows: Scalars['Float']['output'];
  elt: DailyUsageSyncTypeSummary;
  /** Billed rows for loading into extra ELT destinations, already included in activeRows: each extra ELT destination a run loads adds half of that run's billed rows. */
  extraDestinationActiveRows: Scalars['Float']['output'];
  reverseElt: DailyUsageSyncTypeSummary;
  syncedRows: Scalars['Float']['output'];
};

export type DailyUsageTotalSummaryResponse = {
  __typename?: 'DailyUsageTotalSummaryResponse';
  data: DailyUsageTotalSummary;
  period: DailyUsageStatsPeriod;
};

export type DataColoumn = {
  __typename?: 'DataColoumn';
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DataConnectorMetadata = {
  __typename?: 'DataConnectorMetadata';
  changeDataCaptureSupported: Scalars['Boolean']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isListedOnWebsite: Scalars['Boolean']['output'];
  minRequiredPlan?: Maybe<PlanName>;
  status: DevStatus;
  tags: Array<Scalars['String']['output']>;
};

export type DataSchema = {
  __typename?: 'DataSchema';
  name: Scalars['String']['output'];
  nullable: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type DataWarehouse = {
  __typename?: 'DataWarehouse';
  connectionId: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DataWarehouseInfo = {
  __typename?: 'DataWarehouseInfo';
  accountId: Scalars['String']['output'];
  defaultIdentifierCasing?: Maybe<IdentifierCasing>;
  landing: Scalars['String']['output'];
  modelDatabase?: Maybe<Scalars['String']['output']>;
  raw: Scalars['String']['output'];
  rawViewsDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export type DataWarehouseSchemasInput = {
  defaultIdentifierCasing?: InputMaybe<IdentifierCasing>;
  landing?: InputMaybe<Scalars['String']['input']>;
  modelDatabase?: InputMaybe<Scalars['String']['input']>;
  raw?: InputMaybe<Scalars['String']['input']>;
  /** Whether syncs skip creating raw views. A warehouse set up without it gets none. */
  rawViewsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DatawarehouseMigration = {
  __typename?: 'DatawarehouseMigration';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  failed: Scalars['Boolean']['output'];
  failedToStopSyncs: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pendingSyncs?: Maybe<Array<Scalars['String']['output']>>;
  prevDWIntegrationId: Scalars['String']['output'];
  status: DwMigrationStatus;
  stoppedSyncs: Array<Scalars['String']['output']>;
  tableMigrationResult?: Maybe<Array<TableMigrationResult>>;
  userId: Scalars['String']['output'];
  viewMigrationResult?: Maybe<Array<ViewMigrationResult>>;
};

export type DateRange = {
  __typename?: 'DateRange';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export enum DeleteAccountFeedback {
  CustomerService = 'CustomerService',
  LowQuality = 'LowQuality',
  MissingFeatures = 'MissingFeatures',
  Other = 'Other',
  SwitchedService = 'SwitchedService',
  TooComplex = 'TooComplex',
  TooExpensive = 'TooExpensive',
  Unused = 'Unused'
}

export type DeleteAccountInput = {
  deletionDetails?: InputMaybe<DeletionDetails>;
  id: Scalars['String']['input'];
};

export type DeletionDetails = {
  comment?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<DeleteAccountFeedback>;
};

export type DependencyInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export enum DependencyType {
  EltSync = 'elt_sync',
  MaterializedTable = 'materialized_table',
  MissingReference = 'missing_reference',
  ModelView = 'model_view',
  RawView = 'raw_view',
  ReverseEltSync = 'reverse_elt_sync',
  SourceStream = 'source_stream',
  Webhook = 'webhook'
}

/** Destination object type settings that needs to be selected */
export type DestinationObjectTypeSettings = {
  __typename?: 'DestinationObjectTypeSettings';
  settings?: Maybe<Scalars['JSONObject']['output']>;
};

export type DestinationPropertiesInput = {
  destinationConnectionId: Scalars['String']['input'];
  modelId?: InputMaybe<Scalars['String']['input']>;
  objectType: Scalars['String']['input'];
  operationMode: Scalars['String']['input'];
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DestinationSchemaInput = {
  destinationConnectionId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  objectTypeId?: InputMaybe<Scalars['String']['input']>;
  operationMode: Scalars['String']['input'];
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId: Scalars['String']['input'];
  sourceType: SourceType;
};

export enum DevStatus {
  Beta = 'Beta',
  None = 'None',
  Production = 'Production'
}

export type DevStatusInput = {
  devNotes: Scalars['String']['input'];
  devStatus: Scalars['String']['input'];
  eltSyncId: Scalars['String']['input'];
  scheduledJobId: Scalars['String']['input'];
};

export type Directory = {
  __typename?: 'Directory';
  children: Array<Scalars['String']['output']>;
  hasNext: Scalars['Boolean']['output'];
  typename: Scalars['String']['output'];
};

export type DiscountItem = {
  __typename?: 'DiscountItem';
  amount: Scalars['Int']['output'];
  amountOff?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<PromoDuration>;
  durationInMonths?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  percentOff?: Maybe<Scalars['Float']['output']>;
};

export enum DownloadStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type DownloadStatusByUuid = {
  __typename?: 'DownloadStatusByUuid';
  /** A human readable error message. Only present when the status is FAILED. */
  error?: Maybe<Scalars['String']['output']>;
  /** ISO timestamp at which the download expires and is removed (pinned at creation, 3 days). */
  expiresAt: Scalars['String']['output'];
  /** The file name of the generated download (with extension). */
  filename: Scalars['String']['output'];
  /** The number of rows streamed so far. Updates periodically while PROCESSING. */
  rows?: Maybe<Scalars['Int']['output']>;
  /** The current lifecycle status of the download. */
  status: DownloadStatus;
  /** ISO timestamp of when the status was last updated. */
  updatedAt: Scalars['String']['output'];
  /** The uuid of the download this status belongs to. */
  uuid: Scalars['String']['output'];
};

export type DwDirectoryItem = {
  __typename?: 'DwDirectoryItem';
  error?: Maybe<Scalars['String']['output']>;
  path: Array<Scalars['String']['output']>;
  viewId?: Maybe<Scalars['String']['output']>;
};

export enum EditorScope {
  Elt = 'elt',
  ReverseEtl = 'reverse_etl',
  Transform = 'transform'
}

export type EffectiveFeatureDto = {
  __typename?: 'EffectiveFeatureDto';
  enabled: Scalars['Boolean']['output'];
  entitlement?: Maybe<FeatureEntitlementDto>;
  entitlementStatus?: Maybe<FeatureEntitlementStatus>;
  explanation: Scalars['String']['output'];
  feature: PlanFeature;
  source: FeatureSource;
};

export type EltConfig = {
  __typename?: 'EltConfig';
  sourceSettings?: Maybe<Scalars['JSONObject']['output']>;
};

export type EltFromTemplateInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  sourceConnectionId: Scalars['String']['input'];
  sourceIntegrationId: Scalars['String']['input'];
  sourceStreams: Array<SourceStreamInput>;
  syncInterval: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};

export type EltPartialConfig = {
  __typename?: 'EltPartialConfig';
  destinationSchemaName?: Maybe<Scalars['String']['output']>;
  sourceStreams: Array<TemplateSourceStream>;
};

export type EltStreamActivityPayload = {
  __typename?: 'EltStreamActivityPayload';
  changedFields?: Maybe<Array<Scalars['String']['output']>>;
  eltSyncId: Scalars['String']['output'];
  eltSyncName: Scalars['String']['output'];
  fullSyncRequest?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<ActivityValueChange>;
  operationMode?: Maybe<Scalars['String']['output']>;
  operationModeChange?: Maybe<ActivityValueChange>;
  sourceIntegrationId: Scalars['String']['output'];
};

export type EltSync = {
  __typename?: 'EltSync';
  account?: Maybe<Account>;
  accountId: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  /** The ELT destinations the sync loads into next to the data warehouse. */
  additionalDestinations: Array<EltSyncDestination>;
  config?: Maybe<EltConfig>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  destinationConnection?: Maybe<Connection>;
  destinationConnectionId: Scalars['String']['output'];
  destinationIntegrationId: Scalars['String']['output'];
  destinationSchemaName?: Maybe<Scalars['String']['output']>;
  eltWebhook?: Maybe<EltWebhook>;
  eltWebhookId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identifierCasing?: Maybe<IdentifierCasing>;
  operationMode: OperationMode;
  orchestrationWorkflow?: Maybe<OrchestrationWorkflow>;
  schedulerType: OrchestrationSchedulerType;
  sourceConnection?: Maybe<Connection>;
  sourceConnectionId: Scalars['String']['output'];
  sourceIntegrationId: Scalars['String']['output'];
  sourceStreamJobs: Array<EltSyncJobResponse>;
  sourceStreams: Array<SourceStream>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  syncInterval?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EltSyncActivityPayload = {
  __typename?: 'EltSyncActivityPayload';
  changedFields?: Maybe<Array<Scalars['String']['output']>>;
  destination?: Maybe<EltSyncDestinationActivityRef>;
  destinationIntegrationId: Scalars['String']['output'];
  interval?: Maybe<ActivityValueChange>;
  orchestrationWorkflowId?: Maybe<ActivityValueChange>;
  reload?: Maybe<Scalars['String']['output']>;
  sourceIntegrationId: Scalars['String']['output'];
  streamCount: Scalars['Int']['output'];
  streamNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type EltSyncAdditionalDestinationInput = {
  destinationSchemaName?: InputMaybe<Scalars['String']['input']>;
  eltDestinationId: Scalars['String']['input'];
};

export type EltSyncDestination = {
  __typename?: 'EltSyncDestination';
  createdAt: Scalars['DateTime']['output'];
  destination: AccountEltDestination;
  destinationSchemaName: Scalars['String']['output'];
  eltSyncId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type EltSyncDestinationActivityRef = {
  __typename?: 'EltSyncDestinationActivityRef';
  connectionId: Scalars['String']['output'];
  connectionLabel: Scalars['String']['output'];
  eltDestinationId?: Maybe<Scalars['String']['output']>;
  integrationId: Scalars['String']['output'];
};

export enum EltSyncDestinationReload {
  /** The new destination receives what the next runs load; nothing is reloaded. */
  Continue = 'CONTINUE',
  /** Reloads every stream into every destination of the sync. */
  FullSync = 'FULL_SYNC'
}

export type EltSyncHistoryStat = {
  __typename?: 'EltSyncHistoryStat';
  chunkCorrelationId?: Maybe<Scalars['String']['output']>;
  chunkPointer?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  estimatedTotalCount?: Maybe<Scalars['Float']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  fullSyncTrigger: FullSyncTrigger;
  isChunk?: Maybe<Scalars['Boolean']['output']>;
  lastIncrementalPointer?: Maybe<Scalars['String']['output']>;
  operationMode?: Maybe<OperationMode>;
  rowsSynced: Scalars['Int']['output'];
  rowsSyncedMb: Scalars['Float']['output'];
  sourceStreamName?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<SyncJobStatus>;
  substreamRecordsSyncedBySubstream?: Maybe<Array<SubstreamRecordsSynced>>;
  substreamRowsSynced?: Maybe<Scalars['Int']['output']>;
};

export type EltSyncHistoryStatsResponse = {
  __typename?: 'EltSyncHistoryStatsResponse';
  limit?: Maybe<Scalars['Int']['output']>;
  stats: Array<EltSyncHistoryStat>;
};

export type EltSyncJobResponse = {
  __typename?: 'EltSyncJobResponse';
  accountId?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['JSONObject']['output']>;
  destinationIntegrationId?: Maybe<Scalars['String']['output']>;
  devLockExpiresAt?: Maybe<Scalars['String']['output']>;
  devLockedBy?: Maybe<Scalars['String']['output']>;
  devName?: Maybe<Scalars['String']['output']>;
  devNotes?: Maybe<Scalars['String']['output']>;
  devSelfResolvable?: Maybe<Scalars['Boolean']['output']>;
  devStatus?: Maybe<Scalars['String']['output']>;
  devTimestamp?: Maybe<Scalars['String']['output']>;
  errorsSinceLastSuccessfulRun?: Maybe<Scalars['Float']['output']>;
  forceFullSync?: Maybe<Scalars['Boolean']['output']>;
  isQuarantined?: Maybe<Scalars['Boolean']['output']>;
  lastFullSync?: Maybe<Scalars['String']['output']>;
  lastIncrementalPointer?: Maybe<Scalars['String']['output']>;
  lastRun?: Maybe<Scalars['Float']['output']>;
  lastStartedAt: Scalars['String']['output'];
  locks?: Maybe<Array<LockResponse>>;
  nextRun?: Maybe<Scalars['Float']['output']>;
  running?: Maybe<Scalars['Boolean']['output']>;
  scheduledJobId?: Maybe<Scalars['String']['output']>;
  sourceIntegrationId?: Maybe<Scalars['String']['output']>;
  sourceSecretId?: Maybe<Scalars['String']['output']>;
  sourceStreamName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  syncId?: Maybe<Scalars['String']['output']>;
  targetCloudProvider?: Maybe<Scalars['String']['output']>;
};

export type EltSyncMigrationResult = {
  __typename?: 'EltSyncMigrationResult';
  error?: Maybe<Scalars['String']['output']>;
  jobMigrationResults: Array<JobMigrationResult>;
  migrated: Scalars['Boolean']['output'];
};

export type EltSyncSnapshotState = {
  __typename?: 'EltSyncSnapshotState';
  sourceStreams: Array<SourceStreamSnapshotStates>;
  syncId: Scalars['String']['output'];
};

export type EltWebhook = {
  __typename?: 'EltWebhook';
  id: Scalars['String']['output'];
};

export type EnhancedDataConnector = {
  __typename?: 'EnhancedDataConnector';
  aliasFor?: Maybe<Scalars['String']['output']>;
  baseId: Scalars['String']['output'];
  categories: Array<Scalars['String']['output']>;
  changeDataCaptureSupported: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  documentationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isUtilityConnector: Scalars['Boolean']['output'];
  logo: IntegrationLogoVariants;
  minRequiredPlan?: Maybe<PlanName>;
  name: Scalars['String']['output'];
  requiresAdmin?: Maybe<Scalars['Boolean']['output']>;
  status: DevStatus;
  tags: Array<Scalars['String']['output']>;
  type: ConnectorType;
};

export type EnhancedIntegration = {
  __typename?: 'EnhancedIntegration';
  abilities: Array<IntegrationAbility>;
  activateDestination?: Maybe<DataConnectorMetadata>;
  aliasFor?: Maybe<Scalars['String']['output']>;
  aliasMetadata?: Maybe<AliasMetadata>;
  baseId: Scalars['String']['output'];
  biTool?: Maybe<DataConnectorMetadata>;
  categories: Array<Scalars['String']['output']>;
  config?: Maybe<IntegrationConfiguration>;
  connectorForms: Array<IntegrationFormConfig>;
  dataWarehouse?: Maybe<DataConnectorMetadata>;
  description: Scalars['String']['output'];
  documentationUrl?: Maybe<Scalars['String']['output']>;
  eltSource?: Maybe<DataConnectorMetadata>;
  id: Scalars['String']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isUtilityConnector: Scalars['Boolean']['output'];
  logo: IntegrationLogoVariants;
  minRequiredPlan?: Maybe<PlanName>;
  name: Scalars['String']['output'];
  requiresAdmin?: Maybe<Scalars['Boolean']['output']>;
};

export type ErdEdge = {
  __typename?: 'ErdEdge';
  id: Scalars['String']['output'];
  markerEnd?: Maybe<Scalars['JSONObject']['output']>;
  source: Scalars['String']['output'];
  style?: Maybe<Scalars['JSONObject']['output']>;
  target: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ErdField = {
  __typename?: 'ErdField';
  description?: Maybe<Scalars['String']['output']>;
  foreignKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isPrimaryKey: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ErdFieldInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  foreignKey?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isPrimaryKey: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ErdNode = {
  __typename?: 'ErdNode';
  data: NodeData;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  parentNode?: Maybe<Scalars['String']['output']>;
  position: NodePosition;
  type: Scalars['String']['output'];
  width?: Maybe<Scalars['Float']['output']>;
};

export type ErrorAnalyzerResponseDto = {
  __typename?: 'ErrorAnalyzerResponseDto';
  devStatus: Scalars['String']['output'];
  errorSummary: Scalars['String']['output'];
  potentialSolutions: Array<Scalars['String']['output']>;
  selfResolvable: Scalars['Boolean']['output'];
};

export type ErrorLogsResponse = {
  __typename?: 'ErrorLogsResponse';
  error_code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  log_origin?: Maybe<Scalars['String']['output']>;
  logger?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export enum ExampleDatabaseTypes {
  ECommerceSample = 'e_commerce_sample'
}

export type ExportedModel = {
  __typename?: 'ExportedModel';
  dbtSql: Scalars['String']['output'];
  dependencies: Array<ExportedModelDependency>;
  documentation?: Maybe<Scalars['String']['output']>;
  folderPath: Scalars['String']['output'];
  id: Scalars['String']['output'];
  materializationType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  weldSql: Scalars['String']['output'];
};

export type ExportedModelDependency = {
  __typename?: 'ExportedModelDependency';
  type: DependencyType;
  weldTag: Scalars['String']['output'];
};

export enum ExternalSystem {
  Api = 'API',
  DbtCloud = 'DBT_CLOUD'
}

export type FailedTablesResponse = {
  __typename?: 'FailedTablesResponse';
  errorMessage: Scalars['String']['output'];
  finishedAt: Scalars['String']['output'];
  lastSynced: Scalars['Float']['output'];
  sourceStreamName: Scalars['String']['output'];
  status: SyncJobStatus;
};

export type FeatureEntitlementDto = {
  __typename?: 'FeatureEntitlementDto';
  account?: Maybe<Account>;
  accountId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  feature: PlanFeature;
  id: Scalars['ID']['output'];
  minRequiredPlan?: Maybe<PlanName>;
  reason?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  revokedBy?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FeatureEntitlementStatus>;
};

export enum FeatureEntitlementStatus {
  Active = 'Active',
  Dormant = 'Dormant'
}

export type FeatureLimit = {
  __typename?: 'FeatureLimit';
  /** @deprecated Unused */
  isSoftLimit?: Maybe<Scalars['Boolean']['output']>;
  value: Scalars['Float']['output'];
};

export type FeatureSet = {
  __typename?: 'FeatureSet';
  aiAssistantHistoryEnabled: Scalars['Boolean']['output'];
  auditLogsEnabled: Scalars['Boolean']['output'];
  changeDataCaptureEnabled: Scalars['Boolean']['output'];
  columnHashingEnabled: Scalars['Boolean']['output'];
  externalAuthorizationEnabled: Scalars['Boolean']['output'];
  limitConnectors: FeatureLimit;
  limitRows: FeatureLimit;
  limitUsers: FeatureLimit;
  limitWorkspaces: FeatureLimit;
  lineageEnabled: Scalars['Boolean']['output'];
  minSyncIntervalInMinutes: Scalars['Int']['output'];
  modelTestingEnabled: Scalars['Boolean']['output'];
  onDemandSyncsEnabled: Scalars['Boolean']['output'];
  orchestrationEnabled: Scalars['Boolean']['output'];
};

export enum FeatureSource {
  Entitlement = 'Entitlement',
  FeatureBypassFlag = 'FeatureBypassFlag',
  None = 'None',
  Plan = 'Plan'
}

export type Features = {
  __typename?: 'Features';
  aiAssistantHistory: Scalars['Boolean']['output'];
  auditLogs: Scalars['Boolean']['output'];
  changeDataCapture: Scalars['Boolean']['output'];
  columnHashing: Scalars['Boolean']['output'];
  connectApi: Scalars['Boolean']['output'];
  externalAuthorization: Scalars['Boolean']['output'];
  lineage: Scalars['Boolean']['output'];
  /** Sub-table rows are billed and each full sync counts once per billing period. */
  marRulesV2: Scalars['Boolean']['output'];
  modelTesting: Scalars['Boolean']['output'];
  /** A sync can load into more than one ELT destination. */
  multiDestinationElt: Scalars['Boolean']['output'];
  onDemandSyncs: Scalars['Boolean']['output'];
  orchestration: Scalars['Boolean']['output'];
  softDeletes: Scalars['Boolean']['output'];
};

export type FieldMetadata = {
  __typename?: 'FieldMetadata';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FindAllAvailableAuditLogsResponse = {
  __typename?: 'FindAllAvailableAuditLogsResponse';
  logs: Array<AvailableAuditLog>;
};

export type FindAvailableOperationsResponse = {
  __typename?: 'FindAvailableOperationsResponse';
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  operationMode: OperationModes;
  operationType: OperationTypes;
  primaryKeyRequired: Scalars['Boolean']['output'];
};

export type FindFailedSyncsResponse = {
  __typename?: 'FindFailedSyncsResponse';
  destinationSchemaName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  sourceIntegrationId: Scalars['String']['output'];
  tables: Array<FailedTablesResponse>;
};

export type FindSyncHistoryResponse = {
  __typename?: 'FindSyncHistoryResponse';
  chunkCorrelationId?: Maybe<Scalars['String']['output']>;
  chunkPointer?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  distinctRecords?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  estimatedTotalCount?: Maybe<Scalars['Float']['output']>;
  failedRecords?: Maybe<Scalars['Float']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  fullSyncTrigger?: Maybe<FullSyncTrigger>;
  isChunk?: Maybe<Scalars['Boolean']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  lastIncrementalPointer?: Maybe<Scalars['String']['output']>;
  newRecords?: Maybe<Scalars['Float']['output']>;
  operationMode?: Maybe<OperationMode>;
  scheduledJobId?: Maybe<Scalars['String']['output']>;
  sizeSyncedMb?: Maybe<Scalars['Float']['output']>;
  sourceStreamName?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['String']['output'];
  status?: Maybe<SyncJobStatus>;
  substreamRecordsSyncedBySubstream?: Maybe<Array<SubstreamRecordsSynced>>;
  substreamSyncedRecords?: Maybe<Scalars['Float']['output']>;
  syncId: Scalars['String']['output'];
  syncedRecords?: Maybe<Scalars['Float']['output']>;
  totalRecords?: Maybe<Scalars['Float']['output']>;
};

export type FolderActivityPayload = {
  __typename?: 'FolderActivityPayload';
  name?: Maybe<ActivityValueChange>;
  parentFolderId?: Maybe<Scalars['String']['output']>;
};

export type ForecastedDataPoint = {
  __typename?: 'ForecastedDataPoint';
  date: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export enum FreemiumAccountsType {
  ExpiredTrial = 'EXPIRED_TRIAL',
  OngoingTrial = 'ONGOING_TRIAL'
}

export enum FullSyncTrigger {
  AlwaysFull = 'ALWAYS_FULL',
  Error = 'ERROR',
  InitialSync = 'INITIAL_SYNC',
  Lookback = 'LOOKBACK',
  Midnight = 'MIDNIGHT',
  Migration = 'MIGRATION',
  None = 'NONE',
  Scheduled = 'SCHEDULED',
  SchemaChange = 'SCHEMA_CHANGE',
  User = 'USER'
}

export type GcpBatchJob = {
  __typename?: 'GcpBatchJob';
  createTime: Scalars['JSONObject']['output'];
  eltScheduledJob?: Maybe<Scalars['JSONObject']['output']>;
  labels: Scalars['JSONObject']['output'];
  mongoEntryId?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<Array<Scalars['String']['output']>>;
  path: Scalars['String']['output'];
  queue: Scalars['String']['output'];
  status: BatchJobStatus;
  uid: Scalars['String']['output'];
  updateTime: Scalars['JSONObject']['output'];
};

export type GcpBatchJobs = {
  __typename?: 'GcpBatchJobs';
  jobs: Array<GcpBatchJob>;
  pageInfo?: Maybe<PageInfo>;
};

export type GenerateAgentFixPromptResponseDto = {
  __typename?: 'GenerateAgentFixPromptResponseDto';
  /** The error analysis used to generate the prompt. */
  analysis?: Maybe<ErrorAnalyzerResponseDto>;
  /** Error message if generation failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** The agent-ready fix prompt generated by the AI. */
  prompt?: Maybe<Scalars['String']['output']>;
  /** Current stage of the fix prompt generation, e.g. midway steps while polling. */
  status: AgentFixPromptStage;
};

export type GetAllAvroSchemasResponse = {
  __typename?: 'GetAllAvroSchemasResponse';
  schemas: Array<SchemaDto>;
};

export type GetDwDirectoryInput = {
  connectionId: Scalars['String']['input'];
  path?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetDwDirectoryItemsInput = {
  connectionId: Scalars['String']['input'];
  path: Array<Scalars['String']['input']>;
};

export type GetEltSyncMigrationRequest = {
  id: Scalars['String']['input'];
};

export type GetJobLogsResponse = {
  __typename?: 'GetJobLogsResponse';
  jobId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: JobLoggingMessageStatus;
  timestamp: Scalars['String']['output'];
};

export type GetSettingsInput = {
  formValues?: InputMaybe<Scalars['JSONObject']['input']>;
  id: Scalars['String']['input'];
};

export type GetSignupQuestionnaireResponse = {
  __typename?: 'GetSignupQuestionnaireResponse';
  result?: Maybe<SignupQuestionnaireResult>;
};

export type GetSourceStreamJobResponse = {
  __typename?: 'GetSourceStreamJobResponse';
  cdc?: Maybe<SourceStreamCdcState>;
  clearSoftDeletedRows?: Maybe<Scalars['Boolean']['output']>;
  customerFacingError?: Maybe<QuarantineExplanation>;
  errorsSinceLastSuccessfulRun?: Maybe<Scalars['Float']['output']>;
  forceFullSync?: Maybe<Scalars['Boolean']['output']>;
  forceFullSyncHistoryTable?: Maybe<Scalars['Boolean']['output']>;
  fullSyncAlways?: Maybe<Scalars['Boolean']['output']>;
  isQuarantined?: Maybe<Scalars['Boolean']['output']>;
  lastFullSync?: Maybe<Scalars['String']['output']>;
  lastIncrementalPointer?: Maybe<Scalars['JSON']['output']>;
  lastRun?: Maybe<Scalars['Float']['output']>;
  lastStartedAt?: Maybe<Scalars['String']['output']>;
  nextRun?: Maybe<Scalars['Float']['output']>;
  running?: Maybe<Scalars['Boolean']['output']>;
  scheduledJobId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type GetViewDetailsInput = {
  path: Array<Scalars['String']['input']>;
};

export type GithubApp = {
  __typename?: 'GithubApp';
  appUrl: Scalars['String']['output'];
};

export type GithubBranch = {
  __typename?: 'GithubBranch';
  isProtected: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type GithubBranchesResult = {
  __typename?: 'GithubBranchesResult';
  branches: Array<GithubBranch>;
};

export type GithubCommit = {
  __typename?: 'GithubCommit';
  author?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  sha: Scalars['String']['output'];
};

export type GithubCommitAuthor = {
  __typename?: 'GithubCommitAuthor';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GithubCompleteConnectionResult = {
  __typename?: 'GithubCompleteConnectionResult';
  branch: Scalars['String']['output'];
  branchIsEmpty: Scalars['Boolean']['output'];
  connectionId: Scalars['String']['output'];
  folderPath: Scalars['String']['output'];
  repoName: Scalars['String']['output'];
  repoOwner: Scalars['String']['output'];
};

export type GithubCompleteInstallResult = {
  __typename?: 'GithubCompleteInstallResult';
  accountId: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type GithubConnection = {
  __typename?: 'GithubConnection';
  branch: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  folderPath: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  lastSyncedCommitSha?: Maybe<Scalars['String']['output']>;
  repoName: Scalars['String']['output'];
  repoOwner: Scalars['String']['output'];
  status: GithubConnectionStatus;
};

export enum GithubConnectionStatus {
  Active = 'Active',
  Broken = 'Broken'
}

export type GithubFileCommit = {
  __typename?: 'GithubFileCommit';
  author: GithubCommitAuthor;
  authors?: Maybe<Array<GithubCommitAuthor>>;
  commitCount?: Maybe<Scalars['Int']['output']>;
  committedAt?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sha: Scalars['String']['output'];
};

export type GithubInstallUrlResult = {
  __typename?: 'GithubInstallUrlResult';
  installUrl: Scalars['String']['output'];
};

export type GithubInstallation = {
  __typename?: 'GithubInstallation';
  createdAt: Scalars['DateTime']['output'];
  githubAccountLogin: Scalars['String']['output'];
  id: Scalars['String']['output'];
  manageInstallationUrl: Scalars['String']['output'];
  status: GithubInstallationStatus;
};

export enum GithubInstallationAccountType {
  Organization = 'Organization',
  User = 'User'
}

export type GithubInstallationChoice = {
  __typename?: 'GithubInstallationChoice';
  accountType: GithubInstallationAccountType;
  githubAccountLogin: Scalars['String']['output'];
  installationId: Scalars['String']['output'];
};

export type GithubInstallationChoices = {
  __typename?: 'GithubInstallationChoices';
  choices: Array<GithubInstallationChoice>;
  installUrl: Scalars['String']['output'];
};

export enum GithubInstallationRepairOutcome {
  Healthy = 'Healthy',
  NoInstallation = 'NoInstallation',
  Removed = 'Removed'
}

export type GithubInstallationRepairResult = {
  __typename?: 'GithubInstallationRepairResult';
  outcome: GithubInstallationRepairOutcome;
};

export enum GithubInstallationStatus {
  Active = 'Active',
  Uninstalled = 'Uninstalled'
}

export type GithubMonthlyChangelog = {
  __typename?: 'GithubMonthlyChangelog';
  /** Start date (YYYY-MM-DD) when using date range */
  fromDate?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  pullRequests: Array<GithubPullRequest>;
  /** Repositories included in this changelog */
  repos: Array<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  /** End date (YYYY-MM-DD) when using date range */
  toDate?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type GithubPullRequest = {
  __typename?: 'GithubPullRequest';
  author?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  commits: Array<GithubCommit>;
  copilotSummary?: Maybe<Scalars['String']['output']>;
  mergedAt?: Maybe<Scalars['String']['output']>;
  /** Repository in owner/repo format */
  repo?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GithubRepositoriesResult = {
  __typename?: 'GithubRepositoriesResult';
  repositories: Array<GithubRepository>;
};

export type GithubRepository = {
  __typename?: 'GithubRepository';
  defaultBranch: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  isPrivate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  owner: Scalars['String']['output'];
};

export type GithubSync = {
  __typename?: 'GithubSync';
  baseCommitSha?: Maybe<Scalars['String']['output']>;
  commitRange?: Maybe<GithubSyncCommitRange>;
  commitSha?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  connectionId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  fileCommits: Array<GithubSyncFileCommit>;
  headCommitAuthor?: Maybe<GithubCommitAuthor>;
  id: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: GithubSyncStatus;
  summary: GithubSyncSummary;
  triggeredBy: GithubSyncTriggeredBy;
  triggeringDeliveryId?: Maybe<Scalars['String']['output']>;
};

export type GithubSyncAutoHealed = {
  __typename?: 'GithubSyncAutoHealed';
  attempted: Array<Scalars['String']['output']>;
  failed: Array<Scalars['String']['output']>;
};

export type GithubSyncChange = {
  __typename?: 'GithubSyncChange';
  materialization?: Maybe<Scalars['String']['output']>;
  modelId?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  previousMaterializationType?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  sourcePath?: Maybe<Scalars['String']['output']>;
  status: GithubSyncChangeStatus;
  unresolvedDependencies: Array<Scalars['String']['output']>;
  unsupportedJinja: Array<Scalars['String']['output']>;
};

export enum GithubSyncChangeStatus {
  Adopt = 'Adopt',
  Create = 'Create',
  Delete = 'Delete',
  Error = 'Error',
  NoChange = 'NoChange',
  Skip = 'Skip',
  Update = 'Update'
}

export type GithubSyncCommitOutcome = {
  __typename?: 'GithubSyncCommitOutcome';
  failed: Scalars['Int']['output'];
  succeeded: Scalars['Int']['output'];
};

export type GithubSyncCommitRange = {
  __typename?: 'GithubSyncCommitRange';
  authors: Array<GithubCommitAuthor>;
  commitCount: Scalars['Int']['output'];
};

export type GithubSyncFileCommit = {
  __typename?: 'GithubSyncFileCommit';
  commit: GithubFileCommit;
  sourcePath: Scalars['String']['output'];
};

export type GithubSyncListItem = {
  __typename?: 'GithubSyncListItem';
  commitRange?: Maybe<GithubSyncCommitRange>;
  commitSha?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  connectionId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  headCommitAuthor?: Maybe<GithubCommitAuthor>;
  id: Scalars['ID']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: GithubSyncStatus;
  summary: GithubSyncSummaryListItem;
  triggeredBy: GithubSyncTriggeredBy;
};

export enum GithubSyncStatus {
  AwaitingConfirmation = 'AwaitingConfirmation',
  Failed = 'Failed',
  Materializing = 'Materializing',
  Partial = 'Partial',
  Running = 'Running',
  Succeeded = 'Succeeded'
}

export type GithubSyncSummary = {
  __typename?: 'GithubSyncSummary';
  autoHealed?: Maybe<GithubSyncAutoHealed>;
  changes: Array<GithubSyncChange>;
  commitOutcome?: Maybe<GithubSyncCommitOutcome>;
  counts: Scalars['JSONObject']['output'];
  failedMaterializationModelIds?: Maybe<Array<Scalars['String']['output']>>;
  materializingModelIds?: Maybe<Array<Scalars['String']['output']>>;
  noModelsFound?: Maybe<Scalars['Boolean']['output']>;
  unchangedModels: Array<GithubSyncUnchangedModel>;
  warnings: Array<GithubSyncWarning>;
};

export type GithubSyncSummaryListItem = {
  __typename?: 'GithubSyncSummaryListItem';
  counts: Scalars['JSONObject']['output'];
  failedMaterializationsCount?: Maybe<Scalars['Int']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  noModelsFound?: Maybe<Scalars['Boolean']['output']>;
  warningsCount?: Maybe<Scalars['Int']['output']>;
};

export enum GithubSyncTriggeredBy {
  FirstSync = 'FirstSync',
  Manual = 'Manual',
  Webhook = 'Webhook'
}

export type GithubSyncUnchangedModel = {
  __typename?: 'GithubSyncUnchangedModel';
  modelId?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
};

export type GithubSyncWarning = {
  __typename?: 'GithubSyncWarning';
  message: Scalars['String']['output'];
  type: GithubSyncWarningType;
};

export enum GithubSyncWarningType {
  Analysis = 'Analysis',
  Failure = 'Failure',
  Legacy = 'Legacy',
  Materialization = 'Materialization',
  PostgresCleanup = 'PostgresCleanup',
  PostgresCommit = 'PostgresCommit',
  Validation = 'Validation'
}

export type GoogleProject = {
  __typename?: 'GoogleProject';
  displayName: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
};

export type GrantFeatureEntitlementInput = {
  accountId: Scalars['ID']['input'];
  feature: PlanFeature;
  minRequiredPlan?: InputMaybe<PlanName>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type GrantIntegrationEntitlementInput = {
  accountId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  minRequiredPlan?: InputMaybe<PlanName>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type HasDeletedModelsResponse = {
  __typename?: 'HasDeletedModelsResponse';
  value: Scalars['Boolean']['output'];
};

export type HistoryItem = {
  __typename?: 'HistoryItem';
  adjustments: Array<DailyUsageStatAdjustmentDto>;
  chunkCorrelationId?: Maybe<Scalars['String']['output']>;
  chunkPointer?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  estimatedTotalCount?: Maybe<Scalars['Float']['output']>;
  failedRecords?: Maybe<Scalars['Float']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  fullSyncTrigger?: Maybe<FullSyncTrigger>;
  historyTableEnabled?: Maybe<Scalars['Boolean']['output']>;
  isChunk?: Maybe<Scalars['Boolean']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  lastIncrementalPointer?: Maybe<Scalars['String']['output']>;
  operationMode?: Maybe<OperationMode>;
  recordsSynced?: Maybe<Scalars['Float']['output']>;
  scheduledJobId?: Maybe<Scalars['String']['output']>;
  sizeSyncedMb?: Maybe<Scalars['Float']['output']>;
  sourceStreamName?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['String']['output'];
  status?: Maybe<SyncJobStatus>;
  substreamRecordsSynced?: Maybe<Scalars['Float']['output']>;
  substreamRecordsSyncedBySubstream?: Maybe<Array<SubstreamRecordsSynced>>;
  syncId: Scalars['String']['output'];
};

export type HistoryStream = {
  __typename?: 'HistoryStream';
  destinationTableName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  substreamId?: Maybe<Scalars['String']['output']>;
};

/** Casing applied to schema, table and column identifiers written to the destination. */
export enum IdentifierCasing {
  Uppercase = 'UPPERCASE'
}

export type ImportDwDirectoryInput = {
  connectionId: Scalars['String']['input'];
  database?: InputMaybe<Scalars['String']['input']>;
  schema: Scalars['String']['input'];
  tables: Array<Scalars['String']['input']>;
};

export type InactiveWorkflowNotificationsByType = {
  __typename?: 'InactiveWorkflowNotificationsByType';
  count: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type InactiveWorkflowNotificationsSummary = {
  __typename?: 'InactiveWorkflowNotificationsSummary';
  accountsAffected: Scalars['Int']['output'];
  accountsChecked: Scalars['Int']['output'];
  accountsSkipped: Array<Scalars['String']['output']>;
  byType: Array<InactiveWorkflowNotificationsByType>;
  dryRun: Scalars['Boolean']['output'];
  notifications: Scalars['Int']['output'];
};

export type Incident = {
  __typename?: 'Incident';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  impact: Scalars['String']['output'];
  incidentUpdates: Array<IncidentUpdate>;
  name: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  scheduledFor: Scalars['DateTime']['output'];
  scheduledUntil: Scalars['DateTime']['output'];
  shortlink: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type IncidentUpdate = {
  __typename?: 'IncidentUpdate';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  displayAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  incidentId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum InitialSyncStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Running = 'Running',
  Scheduled = 'Scheduled'
}

export type InitialSyncStatusResponse = {
  __typename?: 'InitialSyncStatusResponse';
  duration?: Maybe<Scalars['Float']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  integrationId: Scalars['String']['output'];
  isChunkedSync: Scalars['Boolean']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: InitialSyncStatus;
  syncId: Scalars['String']['output'];
  tableStats: InitialSyncTableStats;
};

export type InitialSyncTableStats = {
  __typename?: 'InitialSyncTableStats';
  bytesSynced: Scalars['Float']['output'];
  completed: Scalars['Float']['output'];
  failed: Scalars['Float']['output'];
  recordsSynced: Scalars['Float']['output'];
  running: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type Integration = {
  __typename?: 'Integration';
  abilities: Array<IntegrationAbility>;
  integrationId: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum IntegrationAbility {
  ActivateDestination = 'ActivateDestination',
  ActivateSource = 'ActivateSource',
  CdcSource = 'CdcSource',
  DataWarehouse = 'DataWarehouse',
  EltDestination = 'EltDestination',
  EltSource = 'EltSource',
  Utility = 'Utility',
  WebHook = 'WebHook'
}

export type IntegrationConfiguration = {
  __typename?: 'IntegrationConfiguration';
  forms: Array<Scalars['JSONObject']['output']>;
  hideSelectAllTables?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  requiresConfiguration: Scalars['Boolean']['output'];
  startDateConfig?: Maybe<StartDateConfiguration>;
  supportsIdentifierCasing?: Maybe<Scalars['Boolean']['output']>;
  supportsRawViews?: Maybe<Scalars['Boolean']['output']>;
  supportsSoftDeletes?: Maybe<Scalars['Boolean']['output']>;
  supportsStartDate?: Maybe<Scalars['Boolean']['output']>;
  usesAsyncStreams?: Maybe<Scalars['Boolean']['output']>;
  usesLazySchemas?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationDataConnectorInput = {
  changeDataCaptureSupported?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailable: Scalars['Boolean']['input'];
  isListedOnWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  minRequiredPlan?: InputMaybe<PlanName>;
  status?: InputMaybe<DevStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IntegrationEntitlementDto = {
  __typename?: 'IntegrationEntitlementDto';
  account?: Maybe<Account>;
  accountId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  integration?: Maybe<EnhancedIntegration>;
  integrationId: Scalars['String']['output'];
  minRequiredPlan?: Maybe<PlanName>;
  reason?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  revokedBy?: Maybe<Scalars['String']['output']>;
  status?: Maybe<IntegrationEntitlementStatus>;
};

export enum IntegrationEntitlementStatus {
  Active = 'Active',
  Dormant = 'Dormant'
}

export type IntegrationFormConfig = {
  __typename?: 'IntegrationFormConfig';
  id: Scalars['String']['output'];
  minRequiredPlan?: Maybe<PlanName>;
  name: Scalars['String']['output'];
};

export type IntegrationLogoVariants = {
  __typename?: 'IntegrationLogoVariants';
  dark?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['String']['output']>;
};

export type IntegrationMetadata = {
  __typename?: 'IntegrationMetadata';
  activateDestination?: Maybe<ConnectorMetadata>;
  aliasFor?: Maybe<Scalars['String']['output']>;
  baseId?: Maybe<Scalars['String']['output']>;
  biTool?: Maybe<ConnectorMetadata>;
  categories: Array<Scalars['String']['output']>;
  connectorForms: Array<ConnectorFormConfig>;
  dataWarehouse?: Maybe<ConnectorMetadata>;
  description?: Maybe<Scalars['String']['output']>;
  documentationUrl?: Maybe<Scalars['String']['output']>;
  eltSource?: Maybe<ConnectorMetadata>;
  integrationId: Scalars['String']['output'];
  isAvailable: Scalars['Boolean']['output'];
  logo?: Maybe<LogoConfig>;
  name?: Maybe<Scalars['String']['output']>;
  requiresAdmin?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationResource = {
  __typename?: 'IntegrationResource';
  id: Scalars['String']['output'];
  integration?: Maybe<Integration>;
  metadata?: Maybe<IntegrationMetadata>;
};

/** Integration specific settings that needs to be selected */
export type IntegrationSettings = {
  __typename?: 'IntegrationSettings';
  connectionSettings?: Maybe<Scalars['JSONObject']['output']>;
};

export type IntegrationSyncStats = {
  __typename?: 'IntegrationSyncStats';
  elt: SyncStats;
  integrationId: Scalars['String']['output'];
  numBillableRows: Scalars['Float']['output'];
  numBillableRowsComplete: Scalars['Float']['output'];
  numRowsSynced: Scalars['Float']['output'];
  reverseElt: SyncStats;
};

export type IntegrationSyncStatsResponse = {
  __typename?: 'IntegrationSyncStatsResponse';
  data: Array<IntegrationSyncStats>;
  period: StatsPeriod;
};

export type IntegrationSyncStatsSummary = {
  __typename?: 'IntegrationSyncStatsSummary';
  activeRows: Scalars['Float']['output'];
  elt: SyncStatsSummary;
  integrationId: Scalars['String']['output'];
  reverseElt: SyncStatsSummary;
  syncedRows: Scalars['Float']['output'];
};

export type IntegrationSyncStatsSummaryResponse = {
  __typename?: 'IntegrationSyncStatsSummaryResponse';
  data: Array<IntegrationSyncStatsSummary>;
  period: StatsPeriod;
};

export type IntegrationTemplate = {
  __typename?: 'IntegrationTemplate';
  config: EltPartialConfig;
  models: Array<TemplateModel>;
  required: Scalars['Boolean']['output'];
  sourceIntegationId: Scalars['String']['output'];
};

export type Invitation = {
  __typename?: 'Invitation';
  account: Account;
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  firstName: Scalars['String']['output'];
  /** Whether this invitation occupies one of the plan's seats. Accepted, expired and Weld staff invitations do not. */
  holdsSeat: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  role?: Maybe<Role>;
  scopes: Array<EditorScope>;
  updatedAt: Scalars['DateTime']['output'];
  used: Scalars['Boolean']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  billingDate: Scalars['DateTime']['output'];
  chargeFailureMessage?: Maybe<Scalars['String']['output']>;
  chargeStatus?: Maybe<StripeChargeStatus>;
  currency: Scalars['String']['output'];
  dueDate: Scalars['DateTime']['output'];
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metadata: InvoiceMetadata;
  number?: Maybe<Scalars['String']['output']>;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  status?: Maybe<InvoiceStatus>;
  total: Scalars['Int']['output'];
};

export type InvoiceBreakdownItem = {
  __typename?: 'InvoiceBreakdownItem';
  amount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  metered?: Maybe<Scalars['Boolean']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  unitAmount?: Maybe<Scalars['Int']['output']>;
  unitQuantity?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceMetadata = {
  __typename?: 'InvoiceMetadata';
  lastSettlementDate?: Maybe<Scalars['DateTime']['output']>;
};

export type InvoicePreviewInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  numConnectors: Scalars['Float']['input'];
  numRows?: InputMaybe<Scalars['Float']['input']>;
  numUsers: Scalars['Float']['input'];
  priceId: Scalars['String']['input'];
  promoId?: InputMaybe<Scalars['String']['input']>;
};

export enum InvoiceStatus {
  Draft = 'Draft',
  Open = 'Open',
  Paid = 'Paid',
  Uncollectible = 'Uncollectible',
  Void = 'Void'
}

export type InvoiceTaxes = {
  __typename?: 'InvoiceTaxes';
  amount: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export enum JobLoggingMessageStatus {
  Error = 'ERROR',
  Log = 'LOG',
  Warn = 'WARN'
}

export type JobMigrationResult = {
  __typename?: 'JobMigrationResult';
  error?: Maybe<Scalars['String']['output']>;
  migrated: Scalars['Boolean']['output'];
  running?: Maybe<Scalars['Boolean']['output']>;
  scheduledJobId: Scalars['String']['output'];
};

export type Limits = {
  __typename?: 'Limits';
  connectors: Scalars['Int']['output'];
  minSyncIntervalInMinutes: Scalars['Int']['output'];
  rows: Scalars['Float']['output'];
  users: Scalars['Int']['output'];
  workspaces: Scalars['Int']['output'];
};

export type LineageAccess = {
  __typename?: 'LineageAccess';
  allowed: Scalars['Boolean']['output'];
  deniedSchemas: Array<Scalars['String']['output']>;
};

export type LineageGraphActivateSyncItem = LineageGraphItemBase & {
  __typename?: 'LineageGraphActivateSyncItem';
  dependencies: Array<LineageGraphDependency>;
  destinationIntegrationId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  scheduleType?: Maybe<OrchestrationSchedulerType>;
  status: Scalars['String']['output'];
  syncId: Scalars['String']['output'];
  syncInterval?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  workflow?: Maybe<OrchestrationWorkflow>;
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type LineageGraphDependency = {
  __typename?: 'LineageGraphDependency';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LineageGraphItem = LineageGraphActivateSyncItem | LineageGraphModelItem | LineageGraphRawViewItem | LineageGraphSourceStreamItem | LineageGraphWebhookItem;

export type LineageGraphItemBase = {
  id: Scalars['String']['output'];
  scheduleType?: Maybe<OrchestrationSchedulerType>;
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type LineageGraphModelItem = LineageGraphItemBase & {
  __typename?: 'LineageGraphModelItem';
  dependencies: Array<LineageGraphDependency>;
  description?: Maybe<Scalars['String']['output']>;
  dwTable?: Maybe<MaterializedTableReference>;
  folderId?: Maybe<Scalars['String']['output']>;
  folderName?: Maybe<Scalars['String']['output']>;
  folderParent?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isPublished: Scalars['Boolean']['output'];
  materializationSchedule?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  scheduleType?: Maybe<OrchestrationSchedulerType>;
  sourceConnectionId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  workflow?: Maybe<OrchestrationWorkflow>;
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type LineageGraphNode = {
  __typename?: 'LineageGraphNode';
  incoming: Array<Scalars['String']['output']>;
  item: LineageGraphItem;
  outgoing: Array<Scalars['String']['output']>;
};

export type LineageGraphRawViewItem = LineageGraphItemBase & {
  __typename?: 'LineageGraphRawViewItem';
  dependencies: Array<LineageGraphDependency>;
  id: Scalars['String']['output'];
  landingTable?: Maybe<Scalars['Boolean']['output']>;
  path: Array<Scalars['String']['output']>;
  scheduleType?: Maybe<OrchestrationSchedulerType>;
  schema: Scalars['String']['output'];
  sourceStream: Scalars['String']['output'];
  syncId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  weldTag: Scalars['String']['output'];
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type LineageGraphSourceStreamItem = LineageGraphItemBase & {
  __typename?: 'LineageGraphSourceStreamItem';
  eltSyncId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  scheduleType?: Maybe<OrchestrationSchedulerType>;
  sourceIntegrationId: Scalars['String']['output'];
  sourceStreamId: Scalars['String']['output'];
  sourceStreamName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  syncInterval?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type LineageGraphWebhookItem = LineageGraphItemBase & {
  __typename?: 'LineageGraphWebhookItem';
  dependencies: Array<LineageGraphDependency>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  scheduleType?: Maybe<OrchestrationSchedulerType>;
  type: Scalars['String']['output'];
  webhookId: Scalars['String']['output'];
  webhookType: Scalars['String']['output'];
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type LineageSourceInput = {
  sourceId: Scalars['ID']['input'];
  sourceType: SourceType;
};

export type LocalMaterializationJob = {
  __typename?: 'LocalMaterializationJob';
  cronExpression: Scalars['String']['output'];
  lastRun?: Maybe<Scalars['Float']['output']>;
  latestErrorMessage?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  nextRun: Scalars['Float']['output'];
  queryId: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export enum LockReason {
  AccountInactivityNotice_2D = 'ACCOUNT_INACTIVITY_NOTICE_2D',
  AccountInactivityNotice_14D = 'ACCOUNT_INACTIVITY_NOTICE_14D',
  ActivateBadQuery = 'ACTIVATE_BAD_QUERY',
  ActivateQuarantine = 'ACTIVATE_QUARANTINE',
  AirtableBaseAccessDenied = 'AIRTABLE_BASE_ACCESS_DENIED',
  AirtableTableNotFound = 'AIRTABLE_TABLE_NOT_FOUND',
  AmazonSellingApiClientSecretExpired = 'AMAZON_SELLING_API_CLIENT_SECRET_EXPIRED',
  AmazonVendorCentralUnsupportedReportParameter = 'AMAZON_VENDOR_CENTRAL_UNSUPPORTED_REPORT_PARAMETER',
  ApiNotEnoughPermissions = 'API_NOT_ENOUGH_PERMISSIONS',
  BigqueryAuthError = 'BIGQUERY_AUTH_ERROR',
  BigqueryBilling = 'BIGQUERY_BILLING',
  BigqueryExpirationFound = 'BIGQUERY_EXPIRATION_FOUND',
  BigqueryNotEnabled = 'BIGQUERY_NOT_ENABLED',
  BigqueryQueryQuotaExceeded = 'BIGQUERY_QUERY_QUOTA_EXCEEDED',
  BusinessCentralDataUpgradeNeeded = 'BUSINESS_CENTRAL_DATA_UPGRADE_NEEDED',
  CargosonReferenceTableMisconfigured = 'CARGOSON_REFERENCE_TABLE_MISCONFIGURED',
  CdcPostgresReplicationLag = 'CDC_POSTGRES_REPLICATION_LAG',
  ChargebeeApiRestricted = 'CHARGEBEE_API_RESTRICTED',
  ConnectionCreatedByExternalUser = 'CONNECTION_CREATED_BY_EXTERNAL_USER',
  ConnectionUpdatedByExternalUser = 'CONNECTION_UPDATED_BY_EXTERNAL_USER',
  ConnectorAccountNotFound = 'CONNECTOR_ACCOUNT_NOT_FOUND',
  ConnectorBadApiKey = 'CONNECTOR_BAD_API_KEY',
  ConnectorBadOauth = 'CONNECTOR_BAD_OAUTH',
  ConnectorPlanRequirementViolation = 'CONNECTOR_PLAN_REQUIREMENT_VIOLATION',
  CreateRawViewFailed = 'CREATE_RAW_VIEW_FAILED',
  CustomConnectorFailedRequest = 'CUSTOM_CONNECTOR_FAILED_REQUEST',
  CustomConnectorInvalidResponse = 'CUSTOM_CONNECTOR_INVALID_RESPONSE',
  CustomConnectorMissingSchema = 'CUSTOM_CONNECTOR_MISSING_SCHEMA',
  CustomConnectorWrongSchema = 'CUSTOM_CONNECTOR_WRONG_SCHEMA',
  DatabaseAuthError = 'DATABASE_AUTH_ERROR',
  DatabaseConnectionError = 'DATABASE_CONNECTION_ERROR',
  DatabaseIncrementalMisconfigured = 'DATABASE_INCREMENTAL_MISCONFIGURED',
  DatabaseTableNotExist = 'DATABASE_TABLE_NOT_EXIST',
  DatabaseTableNotFound = 'DATABASE_TABLE_NOT_FOUND',
  DeprecatedHistoryTableMigrated = 'DEPRECATED_HISTORY_TABLE_MIGRATED',
  DynamoDbStreamNotEnabled = 'DYNAMO_DB_STREAM_NOT_ENABLED',
  Example = 'EXAMPLE',
  ExcelDatasetNotFound = 'EXCEL_DATASET_NOT_FOUND',
  ExcelDatasetTooLarge = 'EXCEL_DATASET_TOO_LARGE',
  ExcelGeneralError = 'EXCEL_GENERAL_ERROR',
  ExcelNonBlankCellOffSheet = 'EXCEL_NON_BLANK_CELL_OFF_SHEET',
  ExcelOverlappingTables = 'EXCEL_OVERLAPPING_TABLES',
  FacebookAdsLostAdAccountAccess = 'FACEBOOK_ADS_LOST_AD_ACCOUNT_ACCESS',
  FacebookPagesLostPageAccess = 'FACEBOOK_PAGES_LOST_PAGE_ACCESS',
  FreeTrialExpired = 'FREE_TRIAL_EXPIRED',
  FtpAuthError = 'FTP_AUTH_ERROR',
  GithubAppUninstalled = 'GITHUB_APP_UNINSTALLED',
  GithubRepositoryRemoved = 'GITHUB_REPOSITORY_REMOVED',
  GithubSyncIncomplete = 'GITHUB_SYNC_INCOMPLETE',
  GoogleAdsCustomerAccessLost = 'GOOGLE_ADS_CUSTOMER_ACCESS_LOST',
  GoogleAnalytics_4PropertyAccessLost = 'GOOGLE_ANALYTICS_4_PROPERTY_ACCESS_LOST',
  GoogleInvalidGrant = 'GOOGLE_INVALID_GRANT',
  GoogleSheetsBadNamedRange = 'GOOGLE_SHEETS_BAD_NAMED_RANGE',
  GoogleSheetsProcessingLimitExceeded = 'GOOGLE_SHEETS_PROCESSING_LIMIT_EXCEEDED',
  GoogleSheetsReverseEtlCellLimitExceeded = 'GOOGLE_SHEETS_REVERSE_ETL_CELL_LIMIT_EXCEEDED',
  GoogleSheetsReverseEtlInvalidGrant = 'GOOGLE_SHEETS_REVERSE_ETL_INVALID_GRANT',
  GoogleSheetsReverseEtlNoPermission = 'GOOGLE_SHEETS_REVERSE_ETL_NO_PERMISSION',
  GorgiasReportPeriodTooLarge = 'GORGIAS_REPORT_PERIOD_TOO_LARGE',
  IncompatibleSchemaForHistoryTable = 'INCOMPATIBLE_SCHEMA_FOR_HISTORY_TABLE',
  IncompatibleSchemaForSoftDeleteStream = 'INCOMPATIBLE_SCHEMA_FOR_SOFT_DELETE_STREAM',
  InstagramAuthError = 'INSTAGRAM_AUTH_ERROR',
  LinkedinMissingAccount = 'LINKEDIN_MISSING_ACCOUNT',
  ManagedBqUsageExceededLock = 'MANAGED_BQ_USAGE_EXCEEDED_LOCK',
  ManagedBqUsageExceededSoftLimit = 'MANAGED_BQ_USAGE_EXCEEDED_SOFT_LIMIT',
  MandatoryAccountTrialStarted = 'MANDATORY_ACCOUNT_TRIAL_STARTED',
  MarUsageThresholdAlert = 'MAR_USAGE_THRESHOLD_ALERT',
  MaterialisationFailure = 'MATERIALISATION_FAILURE',
  MaxRowCountExceeded = 'MAX_ROW_COUNT_EXCEEDED',
  MaxRowCountExceededYearly = 'MAX_ROW_COUNT_EXCEEDED_YEARLY',
  MicrosoftAdsAccountAccessLost = 'MICROSOFT_ADS_ACCOUNT_ACCESS_LOST',
  ModelBadQuery = 'MODEL_BAD_QUERY',
  MultiDestinationEltNotEntitled = 'MULTI_DESTINATION_ELT_NOT_ENTITLED',
  NetsuiteConcurrencyLimitExceededError = 'NETSUITE_CONCURRENCY_LIMIT_EXCEEDED_ERROR',
  NetsuiteFeatureNotEnabled = 'NETSUITE_FEATURE_NOT_ENABLED',
  OnedriveItemNotFound = 'ONEDRIVE_ITEM_NOT_FOUND',
  OrchestrationWorkflowRunFailed = 'ORCHESTRATION_WORKFLOW_RUN_FAILED',
  OverdueInvoiceReminder = 'OVERDUE_INVOICE_REMINDER',
  OverdueInvoiceServiceSuspension = 'OVERDUE_INVOICE_SERVICE_SUSPENSION',
  PostgresColumnTypeAlterationViewError = 'POSTGRES_COLUMN_TYPE_ALTERATION_VIEW_ERROR',
  PostgresDatabaseInsufficientPrivilege = 'POSTGRES_DATABASE_INSUFFICIENT_PRIVILEGE',
  PostgresDiskFull = 'POSTGRES_DISK_FULL',
  PostgresFailedConnection = 'POSTGRES_FAILED_CONNECTION',
  PostgresTableInsufficientPrivilege = 'POSTGRES_TABLE_INSUFFICIENT_PRIVILEGE',
  PrimaryKeyNotUnique = 'PRIMARY_KEY_NOT_UNIQUE',
  ProtectedStreamFullSync = 'PROTECTED_STREAM_FULL_SYNC',
  Quarantine = 'QUARANTINE',
  ReadReplicaRecoveryConflict = 'READ_REPLICA_RECOVERY_CONFLICT',
  RedshiftStagingBucketMissing = 'REDSHIFT_STAGING_BUCKET_MISSING',
  ReverseEtlReauthenticationRequired = 'REVERSE_ETL_REAUTHENTICATION_REQUIRED',
  ShopifyPaymentRequired = 'SHOPIFY_PAYMENT_REQUIRED',
  SnowflakeAccountBilling = 'SNOWFLAKE_ACCOUNT_BILLING',
  SnowflakeAccountLocked = 'SNOWFLAKE_ACCOUNT_LOCKED',
  SnowflakeAuthError = 'SNOWFLAKE_AUTH_ERROR',
  StreamDeprecationWarning = 'STREAM_DEPRECATION_WARNING',
  StreamIsDeprecated = 'STREAM_IS_DEPRECATED',
  SubscriptionCancelationReverted = 'SUBSCRIPTION_CANCELATION_REVERTED',
  SubscriptionCanceled = 'SUBSCRIPTION_CANCELED',
  SubscriptionCreated = 'SUBSCRIPTION_CREATED',
  SubscriptionPlanMigrationConfirmation = 'SUBSCRIPTION_PLAN_MIGRATION_CONFIRMATION',
  SubscriptionUpgraded = 'SUBSCRIPTION_UPGRADED',
  SyncFrequencyForced = 'SYNC_FREQUENCY_FORCED',
  TemplateReady = 'TEMPLATE_READY',
  TiktokShopProductAnalyticsUnavailable = 'TIKTOK_SHOP_PRODUCT_ANALYTICS_UNAVAILABLE',
  TiktokShopSellerInactive = 'TIKTOK_SHOP_SELLER_INACTIVE',
  ToastAnalyticsRestaurantsSkipped = 'TOAST_ANALYTICS_RESTAURANTS_SKIPPED',
  TraedeOrderLinesUnavailable = 'TRAEDE_ORDER_LINES_UNAVAILABLE',
  Unknown = 'UNKNOWN',
  XeroMissingScope = 'XERO_MISSING_SCOPE',
  YoutubeReportTypeNotFound = 'YOUTUBE_REPORT_TYPE_NOT_FOUND'
}

export type LockResponse = {
  __typename?: 'LockResponse';
  id: Scalars['String']['output'];
  reasons: Array<LockReason>;
  target: LockTargets;
};

export enum LockTargets {
  Account = 'ACCOUNT',
  Connector = 'CONNECTOR',
  Stream = 'STREAM',
  Sync = 'SYNC'
}

export type LogoConfig = {
  __typename?: 'LogoConfig';
  dark?: Maybe<Scalars['String']['output']>;
  light?: Maybe<Scalars['String']['output']>;
};

export type LogoConfigInput = {
  dark?: InputMaybe<Scalars['String']['input']>;
  light?: InputMaybe<Scalars['String']['input']>;
};

export type MfaInfoResult = {
  __typename?: 'MFAInfoResult';
  hasMFA: Scalars['Boolean']['output'];
  mfaMethods: Array<MfaMetod>;
};

export type MfaMetod = {
  __typename?: 'MFAMetod';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Mapping = {
  __typename?: 'Mapping';
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  destinationPropertyId: Scalars['String']['output'];
  destinationPropertyName: Scalars['String']['output'];
  destinationPropertyType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  object: Scalars['String']['output'];
  operationMode: Operation;
  primaryKey: Scalars['Boolean']['output'];
  readonly: Scalars['Boolean']['output'];
  sourcePropertyId: Scalars['String']['output'];
  sourcePropertyName: Scalars['String']['output'];
  sourcePropertyType: Scalars['String']['output'];
  sync: Sync;
};

export enum MaterialisationStatus {
  Failed = 'FAILED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

export enum MaterializationType {
  Table = 'table',
  View = 'view'
}

export type MaterializedTableReference = {
  __typename?: 'MaterializedTableReference';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  dwSqlReference: Scalars['String']['output'];
  latestCreated?: Maybe<TableReference>;
  latestRunErrorMessage?: Maybe<Scalars['String']['output']>;
  latestSyncTime?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  modelTestRuns: Array<ModelTestRun>;
  path: Array<Scalars['String']['output']>;
  queryId: Scalars['String']['output'];
  status?: Maybe<MaterialisationStatus>;
  tableMetadata?: Maybe<TableMetadata>;
  type: DependencyType;
  weldTag: Scalars['String']['output'];
};

export type MetricColumn = {
  __typename?: 'MetricColumn';
  columnName: Scalars['String']['output'];
  columnType: MetricColumnType;
  description: Scalars['String']['output'];
};

export enum MetricColumnType {
  Dimension = 'Dimension',
  MetricAvg = 'MetricAvg',
  MetricSum = 'MetricSum'
}

export type MetricConfig = {
  __typename?: 'MetricConfig';
  folderName: Scalars['String']['output'];
  templateItemId: Scalars['String']['output'];
};

export type MigrateAccountsRequest = {
  ids: Array<Scalars['String']['input']>;
};

export type MigrateEltSyncRequest = {
  ids: Array<Scalars['String']['input']>;
};

export type MigrateSecretsForAccountRequest = {
  accountId: Scalars['String']['input'];
  runAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Model = {
  __typename?: 'Model';
  account: Account;
  clusteringColumns?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dashboardId?: Maybe<Scalars['String']['output']>;
  deletedAt: Scalars['DateTime']['output'];
  documentation?: Maybe<Scalars['String']['output']>;
  dwSync?: Maybe<ModelViewReference>;
  dwTable?: Maybe<MaterializedTableReference>;
  emoji?: Maybe<Scalars['String']['output']>;
  folder?: Maybe<ModelFolder>;
  folderId?: Maybe<Scalars['String']['output']>;
  folderPath?: Maybe<Array<ModelFolder>>;
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  localMaterializationJob?: Maybe<LocalMaterializationJob>;
  materializationSchedule?: Maybe<Scalars['String']['output']>;
  materializationType: MaterializationType;
  modelTests: Array<ModelTest>;
  name: Scalars['String']['output'];
  orchestrationScheduler?: Maybe<OrchestrationSchedulerType>;
  orchestrationWorkflow?: Maybe<OrchestrationWorkflow>;
  partitionExpression?: Maybe<Scalars['String']['output']>;
  publishedQuery?: Maybe<SqlQuery>;
  publishedQueryId?: Maybe<Scalars['String']['output']>;
  rebuildTrigger: RebuildTrigger;
  sourceConnection: Connection;
  sourceConnectionId: Scalars['String']['output'];
  sourcePath?: Maybe<Scalars['String']['output']>;
  sqlQueries: Array<SqlQuery>;
  syncs?: Maybe<Array<Sync>>;
  template?: Maybe<Template>;
  templateId?: Maybe<Scalars['String']['output']>;
  templateItemId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ModelType>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ModelCleanupAnalysis = {
  __typename?: 'ModelCleanupAnalysis';
  analysedAt: Scalars['DateTime']['output'];
  analysisWindowDays: Scalars['Int']['output'];
  detection: TableUsageDetection;
  /** Days without a read, and of age, for a model to count as unused. */
  thresholdDays: Scalars['Int']['output'];
  /** In deletion order: each model before the unused models it reads from, except within a dependency cycle. */
  unused: Array<UnusedModel>;
  /** Never read first, then oldest read first. */
  used: Array<UsedModel>;
};

export type ModelCountsBackOffice = {
  __typename?: 'ModelCountsBackOffice';
  lastPublished?: Maybe<Scalars['DateTime']['output']>;
  publishedCount: Scalars['Int']['output'];
  savedDraftCount: Scalars['Int']['output'];
};

export type ModelExportBundle = {
  __typename?: 'ModelExportBundle';
  exportedAt: Scalars['String']['output'];
  models: Array<ExportedModel>;
};

export type ModelFolder = {
  __typename?: 'ModelFolder';
  DWName: Scalars['String']['output'];
  account?: Maybe<Account>;
  deletedAt: Scalars['DateTime']['output'];
  emoji?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  models?: Maybe<Array<Model>>;
  name: Scalars['String']['output'];
  parent?: Maybe<ModelFolder>;
  parentId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ModelType>;
};

export type ModelMaterializationFailure = {
  __typename?: 'ModelMaterializationFailure';
  error: Scalars['String']['output'];
  modelId: Scalars['ID']['output'];
  modelName: Scalars['String']['output'];
};

export type ModelTest = {
  __typename?: 'ModelTest';
  column: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  type: TestType;
};

export type ModelTestActivityPayload = {
  __typename?: 'ModelTestActivityPayload';
  column: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  modelName: Scalars['String']['output'];
  testType: Scalars['String']['output'];
};

export type ModelTestResult = {
  __typename?: 'ModelTestResult';
  error?: Maybe<Scalars['String']['output']>;
  failedRows?: Maybe<Array<Scalars['JSONObject']['output']>>;
  modelTestId: Scalars['String']['output'];
  modelTestWeldSql?: Maybe<Scalars['String']['output']>;
  queryExecutionId?: Maybe<Scalars['String']['output']>;
  status: TestStatus;
};

export type ModelTestRun = {
  __typename?: 'ModelTestRun';
  modelTest: ModelTest;
  modelTestId: Scalars['ID']['output'];
  result?: Maybe<ModelTestRunResult>;
  workflowRunId: Scalars['ID']['output'];
};

export type ModelTestRunResult = {
  __typename?: 'ModelTestRunResult';
  error?: Maybe<Scalars['String']['output']>;
  numRowsTotal?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Scalars['JSONObject']['output']>>;
  status: ModelTestStatus;
};

export enum ModelTestStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

export enum ModelType {
  Analytics = 'analytics',
  Core = 'core',
  Staging = 'staging'
}

export type ModelUsage = {
  __typename?: 'ModelUsage';
  /** Null when nothing read the model inside the history window. */
  lastReadAt?: Maybe<Scalars['DateTime']['output']>;
  modelId: Scalars['String']['output'];
  /** The model's warehouse object, unquoted: its table when it has one, else its view. Reads of both are counted. */
  path: Scalars['String']['output'];
  readCount: Scalars['Int']['output'];
};

export type ModelUsageStats = {
  __typename?: 'ModelUsageStats';
  analysedAt: Scalars['DateTime']['output'];
  analysisWindowDays: Scalars['Int']['output'];
  detection: TableUsageDetection;
  /** One row per published model that has a warehouse object. */
  models: Array<ModelUsage>;
};

export type ModelUsageSummaryDto = {
  __typename?: 'ModelUsageSummaryDto';
  draftModels: Scalars['Float']['output'];
  publishedModels: Scalars['Float']['output'];
};

/** READ: a query read it within the threshold. YOUNG: created within the threshold. DEPENDENT: a used model selects from it. */
export enum ModelUsedReason {
  Dependent = 'DEPENDENT',
  Read = 'READ',
  Young = 'YOUNG'
}

export type ModelViewReference = {
  __typename?: 'ModelViewReference';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  dwSqlReference: Scalars['String']['output'];
  latestSyncTime: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  modelTestRuns: Array<ModelTestRun>;
  path: Array<Scalars['String']['output']>;
  queryId: Scalars['String']['output'];
  type: DependencyType;
  weldTag: Scalars['String']['output'];
};

export type MonthlyActiveRowsEntry = {
  __typename?: 'MonthlyActiveRowsEntry';
  activeRows: Scalars['Float']['output'];
  elt: MonthlySyncTypeBar;
  period: DailyUsageStatsPeriod;
  reverseElt: MonthlySyncTypeBar;
  syncedRows: Scalars['Float']['output'];
};

export type MonthlyIntegrationEntry = {
  __typename?: 'MonthlyIntegrationEntry';
  activeRows: Scalars['Float']['output'];
  activeRowsPercentage: Scalars['Float']['output'];
  integrationId: Scalars['String']['output'];
  syncedRows: Scalars['Float']['output'];
  syncedRowsPercentage: Scalars['Float']['output'];
};

export type MonthlySyncTypeBar = {
  __typename?: 'MonthlySyncTypeBar';
  activeRows: Scalars['Float']['output'];
  integrations: Array<MonthlyIntegrationEntry>;
  syncedRows: Scalars['Float']['output'];
};

export type MoveModelInput = {
  id: Scalars['String']['input'];
  modelFolderId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addAccessGroupPrincipals: AccessGroup;
  addCurrentUserToAccountBackoffice: Scalars['Boolean']['output'];
  addEltDestination: AccountEltDestination;
  addEltSyncDestination: EltSyncDestination;
  addNotificationEmail: Account;
  attachEltSyncToTemplate: EltSync;
  backfillShopifyEltSettings: Scalars['Boolean']['output'];
  batchSwitchPlanPrice: SubscriptionAdminResult;
  cancelCurrentWorkflowRun: OrchestrationWorkflow;
  cancelDownload: Array<DownloadStatusByUuid>;
  cancelGithubSync: GithubSync;
  cancelStreamsAsyncJob: AsyncStreamsStatus;
  cancelWeldSubscription: CancelSubscriptionResponse;
  claimPromoCode: Scalars['Boolean']['output'];
  completeGithubConnection: GithubCompleteConnectionResult;
  confirmFirstGithubSync: GithubSync;
  copyConnectionToAccountBackoffice: Connection;
  createAccessGroup: AccessGroup;
  createAccount: Account;
  createApiKey: ApiKeyResponse;
  createAsyncQueryPreview: CreateAsyncQueryPreviewResponse;
  createAsyncQueryResultCsvDownload: DownloadStatusByUuid;
  createAuditLogsCsvDownload: DownloadStatusByUuid;
  createConnection: Connection;
  createConnectionBridge: ConnectionBridgeResponse;
  createDailyUsageStatAdjustmentBackOffice: DailyUsageStatAdjustmentMutationResponse;
  createDbtConnection: Connection;
  createDraftModel: Model;
  createEltSync: EltSync;
  createEltSyncFromTemplate: EltSync;
  createExampleConnection: Connection;
  createFuturePaymentsSetupIntent: CreateSetupIntentResponse;
  createIntegrationEntitlementBackoffice: IntegrationEntitlementDto;
  createIntegrationMetadataBackoffice: Scalars['Boolean']['output'];
  createModelFolder: ModelFolder;
  createModelTest: ModelTest;
  createNotificationBackoffice: Notification;
  createNotificationThroughQueueBackoffice: Scalars['Boolean']['output'];
  createOrUpdateCustomer: Customer;
  createOrUpdateWeldSubscription: CreateSubscriptionResponse;
  createPaymentMethodCheckoutSession: CheckoutSession;
  createReverseEtlSync: Sync;
  createSecretBackoffice: Scalars['String']['output'];
  createSplitTableInSync: Array<Scalars['String']['output']>;
  createTemplate: Template;
  createWebhook: WebhookResponse;
  createWorkflow: OrchestrationWorkflow;
  createWorkspaceWithManagedDatawarehouse: Account;
  declineOwnInvitation: Invitation;
  deleteAccessGroup: Scalars['Boolean']['output'];
  deleteAccount: Account;
  deleteAgentThread: Scalars['Boolean']['output'];
  deleteApiKey?: Maybe<Scalars['Boolean']['output']>;
  deleteConnectionBridge: Scalars['Boolean']['output'];
  deleteDbtConnection: Connection;
  deleteDownload: Array<Scalars['String']['output']>;
  deleteFolderWithContent: Scalars['String']['output'];
  deleteIntegrationEntitlementBackoffice: Scalars['Boolean']['output'];
  deleteIntegrationMetadataBackoffice: Scalars['Boolean']['output'];
  deleteInvitation: Invitation;
  deleteModelFolder: ModelFolder;
  deleteRawView?: Maybe<Scalars['Boolean']['output']>;
  deleteUser: User;
  deleteWebhook: Scalars['Boolean']['output'];
  deleteWorkflow: Scalars['ID']['output'];
  disconnectSlackNotifications: Account;
  disconnectTeamsNotifications: Account;
  dismissAllNotifications: Scalars['Boolean']['output'];
  dismissProductNPS: SurveyResponse;
  editWorkflow: OrchestrationWorkflow;
  enforceScheduleLimitsForAccountBackOffice: Scalars['Boolean']['output'];
  generateAgentFixPromptActivateBackoffice: Scalars['Boolean']['output'];
  generateAgentFixPromptBackoffice: Scalars['Boolean']['output'];
  /** Start changelog generation. Returns true immediately. */
  generateChangelogBackoffice: Scalars['Boolean']['output'];
  githubInstallUrl: GithubInstallUrlResult;
  githubSelectInstallation: GithubCompleteInstallResult;
  grantFeatureEntitlementBackoffice: FeatureEntitlementDto;
  importDWDirectory: Array<DwDirectoryItem>;
  invalidateIntegrationsCacheBackoffice: Scalars['Boolean']['output'];
  markActivityLooked?: Maybe<Scalars['DateTime']['output']>;
  migrateAccountsBackToAWSBackoffice: Scalars['Boolean']['output'];
  migrateAccountsBackoffice: Scalars['Boolean']['output'];
  migrateAdyenWebhooks: Scalars['Boolean']['output'];
  migrateAllDwMaterialisationJobs: Scalars['Boolean']['output'];
  migrateEltSyncBackoffice: Scalars['Boolean']['output'];
  migrateEltSyncDirectlyBackoffice: EltSyncMigrationResult;
  migrateSecretsBackoffice: Scalars['Boolean']['output'];
  migrateSecretsForAccountBackoffice: Scalars['Boolean']['output'];
  moveModel: Model;
  pauseSourceStreamSchedule: SourceStream;
  processOverdueInvoicesOnAllCustomers: Scalars['JSONObject']['output'];
  processOverdueInvoicesOnCustomer?: Maybe<Scalars['JSONObject']['output']>;
  publishModelAsync: Scalars['String']['output'];
  recomputeDailyUsageStatAdjustmentBackOffice: DailyUsageStatAdjustmentMutationResponse;
  reconcileStaleMaterialization: ReconcileStaleMaterializationsResult;
  reconcileStaleMaterializations: ReconcileStaleMaterializationsResult;
  recreateDestinationView: RecreateViewResponse;
  recreateDestinationViewBackoffice: RecreateViewResponse;
  refreshDataWarehouseTitleBackoffice: Account;
  refreshDestination: Connection;
  /** Invalidate cache and regenerate the changelog. */
  regenerateChangelogBackoffice: Scalars['Boolean']['output'];
  rematerializeNow: Model;
  removeAccessGroupPrincipals: AccessGroup;
  removeConnection: Connection;
  removeCurrentUserFromAccountBackoffice: Scalars['Boolean']['output'];
  removeDashboardModels: Array<Model>;
  removeEltDestination: AccountEltDestination;
  removeEltSync: RemoveEltSyncResponse;
  removeEltSyncDestination: EltSyncDestination;
  removeModel: Model;
  removeModelTest: ModelTest;
  removeNotification: Notification;
  removeNotificationBackoffice: Scalars['String']['output'];
  removeNotificationEmail: Account;
  removeSync: Sync;
  removeTableFromSync: RemoveTableResponse;
  renameModelFolder: ModelFolder;
  repairGithubInstallation: GithubInstallationRepairResult;
  requestBetaConnectorAccess: Scalars['Boolean']['output'];
  requestConnector: Scalars['Boolean']['output'];
  requestDestination: Scalars['Boolean']['output'];
  resendOwnInvitation: Invitation;
  resendVerificationEmail: Scalars['Boolean']['output'];
  resetActivateSyncBackoffice: ResetActivateSyncResponse;
  resetAllErrors: Scalars['Boolean']['output'];
  resetErrors: Scalars['Boolean']['output'];
  resetSyncBackOffice: ResetSyncResponse;
  resolveInactiveWorkflowNotificationsBackoffice: InactiveWorkflowNotificationsSummary;
  resolveOrphanedStreamNotificationsBackoffice: OrphanedStreamNotificationsSummary;
  restoreDeletedModel: Model;
  resumeSourceStreamSchedule: SourceStream;
  retryGithubSyncMaterializations: GithubSync;
  revertCloudProviderOnSourceStreams: Scalars['Boolean']['output'];
  revertSubscriptionCancelation: CancelSubscriptionResponse;
  revokeDailyUsageStatAdjustmentBackOffice: DailyUsageStatAdjustmentMutationResponse;
  revokeFeatureEntitlementBackoffice: Scalars['Boolean']['output'];
  runJobNow?: Maybe<Scalars['Boolean']['output']>;
  runOrchestrationWorkflowNow: OrchestrationWorkflow;
  runOrchestrationWorkflowNowBackoffice: OrchestrationWorkflow;
  runSyncNow?: Maybe<Scalars['Boolean']['output']>;
  runSyncNowBackOffice: Scalars['Boolean']['output'];
  saveErdForIntegration: StoredErd;
  saveSignupQuestionnaireResult: Scalars['Boolean']['output'];
  seedDataWarehouse: SeedDatawarehouseResponse;
  sendInvitation: Invitation;
  sendWSEvent: Scalars['Boolean']['output'];
  sessionStarted: Scalars['Boolean']['output'];
  setActivateDevStatus: Scalars['Boolean']['output'];
  setAiMetadataOnly: Account;
  setCdcBackfill: SourceStream;
  setConnectorRestriction: ConnectorRestriction;
  setDatawarehouse: Scalars['Boolean']['output'];
  setDevStatus: Scalars['Boolean']['output'];
  setMFA: Scalars['Boolean']['output'];
  setNextSyncToFullSync: SourceStream;
  setSourceStreamSyncInterval: SourceStream;
  setTransformTool: Account;
  setTrialEndDateBackoffice: Account;
  setWorkflowActive: OrchestrationWorkflow;
  setupSlackNotifications: Account;
  setupTeamsNotifications: Account;
  setupTemplate: Scalars['Boolean']['output'];
  startDatawarehouseMigration: DatawarehouseMigration;
  startEltSync: EltSync;
  startSelfOnboardingProcess: Scalars['Boolean']['output'];
  startSync: Sync;
  stopEltSync: EltSync;
  stopSync: Sync;
  submitProductNPS: SurveyResponse;
  syncSubscriptionFromStripe: Scalars['Boolean']['output'];
  syncUserDetails: Scalars['Boolean']['output'];
  terminateGcpBatchJob: Scalars['Boolean']['output'];
  triggerBigQueryExpirationCheck: Scalars['Boolean']['output'];
  triggerGithubSync?: Maybe<GithubSync>;
  unpublishModel: Model;
  updateAccessGroup: AccessGroup;
  updateBillingDetails: Customer;
  updateConnection: Connection;
  updateDefaultIdentifierCasing: DataWarehouseInfo;
  updateDraftModelName: Model;
  updateEltDestination: AccountEltDestination;
  updateEltSync: EltSync;
  updateFolderEmoji: Scalars['Boolean']['output'];
  updateIntegrationMetadataBackoffice: Scalars['Boolean']['output'];
  updateLastIncrementalPointer: Scalars['Boolean']['output'];
  updateLastIncrementalPointerBackOffice: Scalars['Boolean']['output'];
  updateModelDocumentation: Model;
  updateModelEmoji: Model;
  updateModelTest: ModelTest;
  updatePublishedModelMaterialization: Model;
  updatePublishedModelQueryAsync: Scalars['String']['output'];
  updateRawViewsDisabled: DataWarehouseInfo;
  updateSourceStream: SourceStream;
  updateStartDateBackOffice: Scalars['Boolean']['output'];
  updateSync: Sync;
  updateUnpublishedModelSqlQuery: SqlQuery;
  updateUser: User;
  updateUserAccountRole: User;
  updateWebhook: WebhookResponse;
  upsertUserSignupInfo: UserSignupInfo;
  useInvitation: UseInvitationResponse;
};


export type MutationAddAccessGroupPrincipalsArgs = {
  input: AccessGroupPrincipalsInput;
};


export type MutationAddCurrentUserToAccountBackofficeArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationAddEltDestinationArgs = {
  input: AddEltDestinationInput;
};


export type MutationAddEltSyncDestinationArgs = {
  input: AddEltSyncDestinationInput;
};


export type MutationAddNotificationEmailArgs = {
  input: NotificationEmailInput;
};


export type MutationAttachEltSyncToTemplateArgs = {
  input: AttachEltTemplateInput;
};


export type MutationBackfillShopifyEltSettingsArgs = {
  accountIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationBatchSwitchPlanPriceArgs = {
  currentPriceId: Scalars['String']['input'];
  newPriceId: Scalars['String']['input'];
};


export type MutationCancelCurrentWorkflowRunArgs = {
  workflowId: Scalars['ID']['input'];
};


export type MutationCancelDownloadArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type MutationCancelGithubSyncArgs = {
  syncId: Scalars['String']['input'];
};


export type MutationCancelStreamsAsyncJobArgs = {
  connectionId: Scalars['String']['input'];
};


export type MutationCancelWeldSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationClaimPromoCodeArgs = {
  input: ClaimPromoCodeInput;
};


export type MutationCompleteGithubConnectionArgs = {
  input: CompleteGithubConnectionInput;
};


export type MutationConfirmFirstGithubSyncArgs = {
  syncId: Scalars['String']['input'];
};


export type MutationCopyConnectionToAccountBackofficeArgs = {
  connectionId: Scalars['String']['input'];
  destinationAccountId: Scalars['String']['input'];
  sourceAccountId: Scalars['String']['input'];
};


export type MutationCreateAccessGroupArgs = {
  input: CreateAccessGroupInput;
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};


export type MutationCreateAsyncQueryPreviewArgs = {
  dependencies: Array<QueryDependencyInput>;
  weldSql: Scalars['String']['input'];
};


export type MutationCreateAsyncQueryResultCsvDownloadArgs = {
  input: CreateQueryResultCsvDownloadInput;
};


export type MutationCreateAuditLogsCsvDownloadArgs = {
  date: Scalars['String']['input'];
};


export type MutationCreateConnectionArgs = {
  input: CreateConnectionInput;
};


export type MutationCreateConnectionBridgeArgs = {
  input: CreateConnectionBridgeInput;
};


export type MutationCreateDailyUsageStatAdjustmentBackOfficeArgs = {
  input: CreateDailyUsageStatAdjustmentInput;
};


export type MutationCreateDbtConnectionArgs = {
  data: Scalars['String']['input'];
};


export type MutationCreateDraftModelArgs = {
  input: CreateDraftModelInput;
};


export type MutationCreateEltSyncArgs = {
  input: CreateEltSyncInput;
};


export type MutationCreateEltSyncFromTemplateArgs = {
  input: EltFromTemplateInput;
};


export type MutationCreateExampleConnectionArgs = {
  input: CreateExampleConnectionInput;
};


export type MutationCreateFuturePaymentsSetupIntentArgs = {
  customerId: Scalars['String']['input'];
};


export type MutationCreateIntegrationEntitlementBackofficeArgs = {
  input: GrantIntegrationEntitlementInput;
};


export type MutationCreateIntegrationMetadataBackofficeArgs = {
  input: SaveIntegrationMetadataInput;
};


export type MutationCreateModelFolderArgs = {
  createFolderInput: CreateFolderInput;
};


export type MutationCreateModelTestArgs = {
  createModelTestInput: CreateModelTestInput;
};


export type MutationCreateNotificationBackofficeArgs = {
  input: CreateNotificationInput;
};


export type MutationCreateOrUpdateCustomerArgs = {
  input: CreateOrUpdateCustomerInput;
};


export type MutationCreateOrUpdateWeldSubscriptionArgs = {
  currency: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  numConnectors: Scalars['Int']['input'];
  numRows?: InputMaybe<Scalars['Int']['input']>;
  numUsers: Scalars['Int']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  priceId: Scalars['String']['input'];
  promoId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreatePaymentMethodCheckoutSessionArgs = {
  input: CreatePaymentMethodCheckoutSessionInput;
};


export type MutationCreateReverseEtlSyncArgs = {
  input: CreateReverseEtlSyncInput;
};


export type MutationCreateSecretBackofficeArgs = {
  secretName: Scalars['String']['input'];
  secretString: Scalars['String']['input'];
};


export type MutationCreateSplitTableInSyncArgs = {
  accountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  baseSourceStreamName: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  newSourceStreamName: Scalars['String']['input'];
};


export type MutationCreateTemplateArgs = {
  accountId: Scalars['String']['input'];
  template: TemplatesEnum;
};


export type MutationCreateWebhookArgs = {
  data: CreateWebhookInput;
};


export type MutationCreateWorkflowArgs = {
  cronExpression: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateWorkspaceWithManagedDatawarehouseArgs = {
  input: CreateManagedWorkspaceInput;
};


export type MutationDeclineOwnInvitationArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationDeleteAccessGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDeleteAgentThreadArgs = {
  threadId: Scalars['ID']['input'];
};


export type MutationDeleteApiKeyArgs = {
  apiKeyId: Scalars['String']['input'];
};


export type MutationDeleteConnectionBridgeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDownloadArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type MutationDeleteFolderWithContentArgs = {
  folderId: Scalars['String']['input'];
};


export type MutationDeleteIntegrationEntitlementBackofficeArgs = {
  accountId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
};


export type MutationDeleteIntegrationMetadataBackofficeArgs = {
  integrationId: Scalars['String']['input'];
};


export type MutationDeleteInvitationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteModelFolderArgs = {
  folderId: Scalars['String']['input'];
};


export type MutationDeleteRawViewArgs = {
  viewId: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteWebhookArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteWorkflowArgs = {
  cronSchedule: Scalars['String']['input'];
  workflowId: Scalars['ID']['input'];
};


export type MutationEditWorkflowArgs = {
  cronExpression?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  workflowId: Scalars['ID']['input'];
};


export type MutationEnforceScheduleLimitsForAccountBackOfficeArgs = {
  accountId: Scalars['ID']['input'];
};


export type MutationGenerateAgentFixPromptActivateBackofficeArgs = {
  scheduledJobId: Scalars['String']['input'];
};


export type MutationGenerateAgentFixPromptBackofficeArgs = {
  llmProvider?: InputMaybe<Scalars['String']['input']>;
  scheduledJobId: Scalars['String']['input'];
};


export type MutationGenerateChangelogBackofficeArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  repos?: InputMaybe<Array<Scalars['String']['input']>>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationGithubSelectInstallationArgs = {
  installationId: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type MutationGrantFeatureEntitlementBackofficeArgs = {
  input: GrantFeatureEntitlementInput;
};


export type MutationImportDwDirectoryArgs = {
  input: ImportDwDirectoryInput;
};


export type MutationMarkActivityLookedArgs = {
  upTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationMigrateAccountsBackToAwsBackofficeArgs = {
  input: MigrateAccountsRequest;
};


export type MutationMigrateAccountsBackofficeArgs = {
  input: MigrateAccountsRequest;
};


export type MutationMigrateAdyenWebhooksArgs = {
  accountIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationMigrateEltSyncBackofficeArgs = {
  input: MigrateEltSyncRequest;
};


export type MutationMigrateEltSyncDirectlyBackofficeArgs = {
  input: GetEltSyncMigrationRequest;
};


export type MutationMigrateSecretsForAccountBackofficeArgs = {
  input: MigrateSecretsForAccountRequest;
};


export type MutationMoveModelArgs = {
  input: MoveModelInput;
};


export type MutationPauseSourceStreamScheduleArgs = {
  eltSyncId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
};


export type MutationProcessOverdueInvoicesOnCustomerArgs = {
  customerId: Scalars['String']['input'];
  referenceDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationPublishModelAsyncArgs = {
  input: PublishModelInput;
};


export type MutationRecomputeDailyUsageStatAdjustmentBackOfficeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReconcileStaleMaterializationArgs = {
  modelId: Scalars['String']['input'];
};


export type MutationRecreateDestinationViewArgs = {
  eltSyncId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
};


export type MutationRecreateDestinationViewBackofficeArgs = {
  eltSyncId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
};


export type MutationRefreshDataWarehouseTitleBackofficeArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationRefreshDestinationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRegenerateChangelogBackofficeArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  repos?: InputMaybe<Array<Scalars['String']['input']>>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRematerializeNowArgs = {
  modelId: Scalars['String']['input'];
};


export type MutationRemoveAccessGroupPrincipalsArgs = {
  input: AccessGroupPrincipalsInput;
};


export type MutationRemoveConnectionArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveCurrentUserFromAccountBackofficeArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationRemoveDashboardModelsArgs = {
  dashboardId: Scalars['String']['input'];
};


export type MutationRemoveEltDestinationArgs = {
  forceRemove?: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};


export type MutationRemoveEltSyncArgs = {
  input: RemoveEltSyncInput;
};


export type MutationRemoveEltSyncDestinationArgs = {
  input: RemoveEltSyncDestinationInput;
};


export type MutationRemoveModelArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveModelTestArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveNotificationArgs = {
  input: RemoveNotificationInput;
};


export type MutationRemoveNotificationBackofficeArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveNotificationEmailArgs = {
  input: NotificationEmailInput;
};


export type MutationRemoveSyncArgs = {
  input: StartSyncInput;
};


export type MutationRemoveTableFromSyncArgs = {
  input: RemoveTableFromSyncInput;
};


export type MutationRenameModelFolderArgs = {
  updateFolderInput: UpdateFolderInput;
};


export type MutationRequestBetaConnectorAccessArgs = {
  integrationId: Scalars['String']['input'];
};


export type MutationRequestConnectorArgs = {
  integrationName: Scalars['String']['input'];
  integrationTypes: Array<Scalars['String']['input']>;
};


export type MutationRequestDestinationArgs = {
  integrationId: Scalars['String']['input'];
};


export type MutationResendOwnInvitationArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationResetActivateSyncBackofficeArgs = {
  input: ResetActivateSyncInput;
};


export type MutationResetAllErrorsArgs = {
  id: Scalars['String']['input'];
};


export type MutationResetErrorsArgs = {
  id: Scalars['String']['input'];
  objectIds: Array<Scalars['String']['input']>;
};


export type MutationResetSyncBackOfficeArgs = {
  input: ResetEltSyncInput;
};


export type MutationResolveInactiveWorkflowNotificationsBackofficeArgs = {
  dryRun?: Scalars['Boolean']['input'];
};


export type MutationResolveOrphanedStreamNotificationsBackofficeArgs = {
  dryRun?: Scalars['Boolean']['input'];
};


export type MutationRestoreDeletedModelArgs = {
  id: Scalars['String']['input'];
};


export type MutationResumeSourceStreamScheduleArgs = {
  eltSyncId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
};


export type MutationRetryGithubSyncMaterializationsArgs = {
  syncId: Scalars['String']['input'];
};


export type MutationRevertCloudProviderOnSourceStreamsArgs = {
  input: RevertSourceStreamInput;
};


export type MutationRevertSubscriptionCancelationArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type MutationRevokeDailyUsageStatAdjustmentBackOfficeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevokeFeatureEntitlementBackofficeArgs = {
  accountId: Scalars['ID']['input'];
  feature: PlanFeature;
};


export type MutationRunJobNowArgs = {
  input: RunJobNowInput;
};


export type MutationRunOrchestrationWorkflowNowArgs = {
  workflowId: Scalars['ID']['input'];
};


export type MutationRunOrchestrationWorkflowNowBackofficeArgs = {
  workflowId: Scalars['ID']['input'];
};


export type MutationRunSyncNowArgs = {
  input: StartSyncInput;
};


export type MutationRunSyncNowBackOfficeArgs = {
  scheduledJobId: Scalars['String']['input'];
};


export type MutationSaveErdForIntegrationArgs = {
  input: StoredErdInput;
};


export type MutationSaveSignupQuestionnaireResultArgs = {
  input: SaveSignupQuestionnaireResultInput;
};


export type MutationSendInvitationArgs = {
  input: SendInvitationInput;
};


export type MutationSendWsEventArgs = {
  accountId: Scalars['String']['input'];
  data: Scalars['JSONObject']['input'];
  eventName: Scalars['String']['input'];
};


export type MutationSetActivateDevStatusArgs = {
  input: ActivateDevStatusInput;
};


export type MutationSetAiMetadataOnlyArgs = {
  value: Scalars['Boolean']['input'];
};


export type MutationSetCdcBackfillArgs = {
  setBackfill: Scalars['Boolean']['input'];
  sourceStreamId: Scalars['String']['input'];
};


export type MutationSetConnectorRestrictionArgs = {
  input: SetConnectorRestrictionInput;
};


export type MutationSetDatawarehouseArgs = {
  createConnectionInput: CreateConnectionInput;
  dataWarehouseSchemas?: InputMaybe<DataWarehouseSchemasInput>;
};


export type MutationSetDevStatusArgs = {
  input: DevStatusInput;
};


export type MutationSetMfaArgs = {
  use_mfa: Scalars['Boolean']['input'];
};


export type MutationSetNextSyncToFullSyncArgs = {
  clearSoftDeletedRows?: InputMaybe<Scalars['Boolean']['input']>;
  forceFullSync: Scalars['Boolean']['input'];
  forceFullSyncHistoryTable?: InputMaybe<Scalars['Boolean']['input']>;
  sourceStreamId: Scalars['String']['input'];
};


export type MutationSetSourceStreamSyncIntervalArgs = {
  input: UpdateSourceStreamSyncIntervalInput;
};


export type MutationSetTransformToolArgs = {
  value: TransformTool;
};


export type MutationSetTrialEndDateBackofficeArgs = {
  accountId: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
};


export type MutationSetWorkflowActiveArgs = {
  active: Scalars['Boolean']['input'];
  workflowId: Scalars['ID']['input'];
};


export type MutationSetupSlackNotificationsArgs = {
  input: SetupSlackInput;
};


export type MutationSetupTeamsNotificationsArgs = {
  input: SetupTeamsInput;
};


export type MutationSetupTemplateArgs = {
  templateId: Scalars['String']['input'];
};


export type MutationStartDatawarehouseMigrationArgs = {
  createConnectionInput: CreateConnectionInput;
};


export type MutationStartEltSyncArgs = {
  input: StartEltSyncInput;
};


export type MutationStartSelfOnboardingProcessArgs = {
  location: Scalars['String']['input'];
};


export type MutationStartSyncArgs = {
  input: StartSyncInput;
};


export type MutationStopEltSyncArgs = {
  input: StartEltSyncInput;
};


export type MutationStopSyncArgs = {
  input: StartSyncInput;
};


export type MutationSubmitProductNpsArgs = {
  input: SubmitSurveyInput;
};


export type MutationSyncSubscriptionFromStripeArgs = {
  accountId: Scalars['ID']['input'];
};


export type MutationTerminateGcpBatchJobArgs = {
  id: Scalars['String']['input'];
};


export type MutationUnpublishModelArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateAccessGroupArgs = {
  input: UpdateAccessGroupInput;
};


export type MutationUpdateBillingDetailsArgs = {
  billingDetails: BillingDetailsInput;
  customerId: Scalars['ID']['input'];
};


export type MutationUpdateConnectionArgs = {
  input: UpdateConnectionInput;
};


export type MutationUpdateDefaultIdentifierCasingArgs = {
  defaultIdentifierCasing?: InputMaybe<IdentifierCasing>;
};


export type MutationUpdateDraftModelNameArgs = {
  input: UpdateDraftModelNameInput;
};


export type MutationUpdateEltDestinationArgs = {
  input: UpdateEltDestinationInput;
};


export type MutationUpdateEltSyncArgs = {
  input: UpdateEltSyncInput;
};


export type MutationUpdateFolderEmojiArgs = {
  emoji?: InputMaybe<Scalars['String']['input']>;
  folderId: Scalars['String']['input'];
};


export type MutationUpdateIntegrationMetadataBackofficeArgs = {
  input: SaveIntegrationMetadataInput;
};


export type MutationUpdateLastIncrementalPointerArgs = {
  input: UpdateSourceStreamLastIncrementalPointerInput;
};


export type MutationUpdateLastIncrementalPointerBackOfficeArgs = {
  newLastIncrementalPointer: Scalars['String']['input'];
  scheduledJobId: Scalars['String']['input'];
};


export type MutationUpdateModelDocumentationArgs = {
  input: UpdateModelDocumentationInput;
};


export type MutationUpdateModelEmojiArgs = {
  emoji?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
};


export type MutationUpdateModelTestArgs = {
  updateModelTestInput: UpdateModelTestInput;
};


export type MutationUpdatePublishedModelMaterializationArgs = {
  input: UpdatePublishedModelMaterializationInput;
};


export type MutationUpdatePublishedModelQueryAsyncArgs = {
  input: UpdateModelQueryInput;
};


export type MutationUpdateRawViewsDisabledArgs = {
  rawViewsDisabled: Scalars['Boolean']['input'];
};


export type MutationUpdateSourceStreamArgs = {
  input: UpdateSourceStreamInput;
  sourceStreamId: Scalars['String']['input'];
};


export type MutationUpdateStartDateBackOfficeArgs = {
  accountId: Scalars['String']['input'];
  eltSyncId: Scalars['String']['input'];
  newStartDate: Scalars['String']['input'];
  resetIncrementalPointer: Scalars['Boolean']['input'];
};


export type MutationUpdateSyncArgs = {
  input: UpdateSyncInput;
};


export type MutationUpdateUnpublishedModelSqlQueryArgs = {
  input: UpdateModelQueryInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserAccountRoleArgs = {
  role: Role;
  scopes?: InputMaybe<Array<EditorScope>>;
  userId: Scalars['String']['input'];
};


export type MutationUpdateWebhookArgs = {
  data: UpdateWebhookInput;
};


export type MutationUpsertUserSignupInfoArgs = {
  input: UpsertUserSignupInfoInput;
};


export type MutationUseInvitationArgs = {
  invitationId: Scalars['String']['input'];
};

export type NewCustomerDto = {
  __typename?: 'NewCustomerDto';
  account: Account;
  planName: Scalars['String']['output'];
  /** The Stripe customer held an earlier Weld subscription that got past checkout. */
  returning: Scalars['Boolean']['output'];
  stage: CustomerFunnelStage;
  startedAt: Scalars['DateTime']['output'];
  stripeCustomerId: Scalars['String']['output'];
};

export type NodeData = {
  __typename?: 'NodeData';
  childOf?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<ErdField>;
  isSubTable?: Maybe<Scalars['Boolean']['output']>;
  tableName: Scalars['String']['output'];
};

export type NodeDataInput = {
  childOf?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields: Array<ErdFieldInput>;
  isSubTable?: InputMaybe<Scalars['Boolean']['input']>;
  tableName: Scalars['String']['input'];
};

export type NodePosition = {
  __typename?: 'NodePosition';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type NodePositionInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type Notification = {
  __typename?: 'Notification';
  accountId: Scalars['String']['output'];
  accountName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  detail: Scalars['JSONObject']['output'];
  entityId: Scalars['String']['output'];
  entityName?: Maybe<Scalars['String']['output']>;
  entityType: NotificationEntityType;
  expiration?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isDismissable: Scalars['Boolean']['output'];
  isLock: Scalars['Boolean']['output'];
  lastOccurence: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  messageData?: Maybe<Scalars['JSONObject']['output']>;
  notificationLevel: NotificationLevel;
  source: NotificationSources;
  type: NotificationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationEmailInput = {
  notificationEmail: Scalars['String']['input'];
};

export enum NotificationEntityType {
  Account = 'ACCOUNT',
  Connector = 'CONNECTOR',
  Materialisation = 'MATERIALISATION',
  Stream = 'STREAM',
  Sync = 'SYNC',
  Template = 'TEMPLATE',
  Workflow = 'WORKFLOW'
}

export enum NotificationLevel {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export enum NotificationSources {
  ActivateDestinationWorker = 'ACTIVATE_DESTINATION_WORKER',
  ActivateScheduler = 'ACTIVATE_SCHEDULER',
  ActivateSourceWorker = 'ACTIVATE_SOURCE_WORKER',
  Backend = 'BACKEND',
  BillingApi = 'BILLING_API',
  DataWarehouseApi = 'DATA_WAREHOUSE_API',
  DownloadApi = 'DOWNLOAD_API',
  EltDestinationWorker = 'ELT_DESTINATION_WORKER',
  EltScheduler = 'ELT_SCHEDULER',
  EltSourceWorker = 'ELT_SOURCE_WORKER',
  Global = 'GLOBAL',
  NotificationApi = 'NOTIFICATION_API',
  Orchestrator = 'ORCHESTRATOR',
  Test = 'TEST'
}

export enum NotificationType {
  AccountInactivityNotice_2D = 'ACCOUNT_INACTIVITY_NOTICE_2D',
  AccountInactivityNotice_14D = 'ACCOUNT_INACTIVITY_NOTICE_14D',
  ActivateBadQuery = 'ACTIVATE_BAD_QUERY',
  ActivateQuarantine = 'ACTIVATE_QUARANTINE',
  AirtableBaseAccessDenied = 'AIRTABLE_BASE_ACCESS_DENIED',
  AirtableTableNotFound = 'AIRTABLE_TABLE_NOT_FOUND',
  AmazonSellingApiClientSecretExpired = 'AMAZON_SELLING_API_CLIENT_SECRET_EXPIRED',
  AmazonVendorCentralUnsupportedReportParameter = 'AMAZON_VENDOR_CENTRAL_UNSUPPORTED_REPORT_PARAMETER',
  ApiNotEnoughPermissions = 'API_NOT_ENOUGH_PERMISSIONS',
  BigqueryAuthError = 'BIGQUERY_AUTH_ERROR',
  BigqueryBilling = 'BIGQUERY_BILLING',
  BigqueryExpirationFound = 'BIGQUERY_EXPIRATION_FOUND',
  BigqueryNotEnabled = 'BIGQUERY_NOT_ENABLED',
  BigqueryQueryQuotaExceeded = 'BIGQUERY_QUERY_QUOTA_EXCEEDED',
  BusinessCentralDataUpgradeNeeded = 'BUSINESS_CENTRAL_DATA_UPGRADE_NEEDED',
  CargosonReferenceTableMisconfigured = 'CARGOSON_REFERENCE_TABLE_MISCONFIGURED',
  CdcPostgresReplicationLag = 'CDC_POSTGRES_REPLICATION_LAG',
  ChargebeeApiRestricted = 'CHARGEBEE_API_RESTRICTED',
  ConnectionCreatedByExternalUser = 'CONNECTION_CREATED_BY_EXTERNAL_USER',
  ConnectionUpdatedByExternalUser = 'CONNECTION_UPDATED_BY_EXTERNAL_USER',
  ConnectorAccountNotFound = 'CONNECTOR_ACCOUNT_NOT_FOUND',
  ConnectorBadApiKey = 'CONNECTOR_BAD_API_KEY',
  ConnectorBadOauth = 'CONNECTOR_BAD_OAUTH',
  ConnectorPlanRequirementViolation = 'CONNECTOR_PLAN_REQUIREMENT_VIOLATION',
  CreateRawViewFailed = 'CREATE_RAW_VIEW_FAILED',
  CustomConnectorFailedRequest = 'CUSTOM_CONNECTOR_FAILED_REQUEST',
  CustomConnectorInvalidResponse = 'CUSTOM_CONNECTOR_INVALID_RESPONSE',
  CustomConnectorMissingSchema = 'CUSTOM_CONNECTOR_MISSING_SCHEMA',
  CustomConnectorWrongSchema = 'CUSTOM_CONNECTOR_WRONG_SCHEMA',
  DatabaseAuthError = 'DATABASE_AUTH_ERROR',
  DatabaseConnectionError = 'DATABASE_CONNECTION_ERROR',
  DatabaseIncrementalMisconfigured = 'DATABASE_INCREMENTAL_MISCONFIGURED',
  DatabaseTableNotExist = 'DATABASE_TABLE_NOT_EXIST',
  DatabaseTableNotFound = 'DATABASE_TABLE_NOT_FOUND',
  DeprecatedHistoryTableMigrated = 'DEPRECATED_HISTORY_TABLE_MIGRATED',
  DynamoDbStreamNotEnabled = 'DYNAMO_DB_STREAM_NOT_ENABLED',
  Example = 'EXAMPLE',
  ExcelDatasetNotFound = 'EXCEL_DATASET_NOT_FOUND',
  ExcelDatasetTooLarge = 'EXCEL_DATASET_TOO_LARGE',
  ExcelGeneralError = 'EXCEL_GENERAL_ERROR',
  ExcelNonBlankCellOffSheet = 'EXCEL_NON_BLANK_CELL_OFF_SHEET',
  ExcelOverlappingTables = 'EXCEL_OVERLAPPING_TABLES',
  FacebookAdsLostAdAccountAccess = 'FACEBOOK_ADS_LOST_AD_ACCOUNT_ACCESS',
  FacebookPagesLostPageAccess = 'FACEBOOK_PAGES_LOST_PAGE_ACCESS',
  FreeTrialExpired = 'FREE_TRIAL_EXPIRED',
  FtpAuthError = 'FTP_AUTH_ERROR',
  GithubAppUninstalled = 'GITHUB_APP_UNINSTALLED',
  GithubRepositoryRemoved = 'GITHUB_REPOSITORY_REMOVED',
  GithubSyncIncomplete = 'GITHUB_SYNC_INCOMPLETE',
  GoogleAdsCustomerAccessLost = 'GOOGLE_ADS_CUSTOMER_ACCESS_LOST',
  GoogleAnalytics_4PropertyAccessLost = 'GOOGLE_ANALYTICS_4_PROPERTY_ACCESS_LOST',
  GoogleInvalidGrant = 'GOOGLE_INVALID_GRANT',
  GoogleSheetsBadNamedRange = 'GOOGLE_SHEETS_BAD_NAMED_RANGE',
  GoogleSheetsProcessingLimitExceeded = 'GOOGLE_SHEETS_PROCESSING_LIMIT_EXCEEDED',
  GoogleSheetsReverseEtlCellLimitExceeded = 'GOOGLE_SHEETS_REVERSE_ETL_CELL_LIMIT_EXCEEDED',
  GoogleSheetsReverseEtlInvalidGrant = 'GOOGLE_SHEETS_REVERSE_ETL_INVALID_GRANT',
  GoogleSheetsReverseEtlNoPermission = 'GOOGLE_SHEETS_REVERSE_ETL_NO_PERMISSION',
  GorgiasReportPeriodTooLarge = 'GORGIAS_REPORT_PERIOD_TOO_LARGE',
  IncompatibleSchemaForHistoryTable = 'INCOMPATIBLE_SCHEMA_FOR_HISTORY_TABLE',
  IncompatibleSchemaForSoftDeleteStream = 'INCOMPATIBLE_SCHEMA_FOR_SOFT_DELETE_STREAM',
  InstagramAuthError = 'INSTAGRAM_AUTH_ERROR',
  LinkedinMissingAccount = 'LINKEDIN_MISSING_ACCOUNT',
  ManagedBqUsageExceededLock = 'MANAGED_BQ_USAGE_EXCEEDED_LOCK',
  ManagedBqUsageExceededSoftLimit = 'MANAGED_BQ_USAGE_EXCEEDED_SOFT_LIMIT',
  MandatoryAccountTrialStarted = 'MANDATORY_ACCOUNT_TRIAL_STARTED',
  MarUsageThresholdAlert = 'MAR_USAGE_THRESHOLD_ALERT',
  MaterialisationFailure = 'MATERIALISATION_FAILURE',
  MaxRowCountExceeded = 'MAX_ROW_COUNT_EXCEEDED',
  MaxRowCountExceededYearly = 'MAX_ROW_COUNT_EXCEEDED_YEARLY',
  MicrosoftAdsAccountAccessLost = 'MICROSOFT_ADS_ACCOUNT_ACCESS_LOST',
  ModelBadQuery = 'MODEL_BAD_QUERY',
  MultiDestinationEltNotEntitled = 'MULTI_DESTINATION_ELT_NOT_ENTITLED',
  NetsuiteConcurrencyLimitExceededError = 'NETSUITE_CONCURRENCY_LIMIT_EXCEEDED_ERROR',
  NetsuiteFeatureNotEnabled = 'NETSUITE_FEATURE_NOT_ENABLED',
  OnedriveItemNotFound = 'ONEDRIVE_ITEM_NOT_FOUND',
  OrchestrationWorkflowRunFailed = 'ORCHESTRATION_WORKFLOW_RUN_FAILED',
  OverdueInvoiceReminder = 'OVERDUE_INVOICE_REMINDER',
  OverdueInvoiceServiceSuspension = 'OVERDUE_INVOICE_SERVICE_SUSPENSION',
  PostgresColumnTypeAlterationViewError = 'POSTGRES_COLUMN_TYPE_ALTERATION_VIEW_ERROR',
  PostgresDatabaseInsufficientPrivilege = 'POSTGRES_DATABASE_INSUFFICIENT_PRIVILEGE',
  PostgresDiskFull = 'POSTGRES_DISK_FULL',
  PostgresFailedConnection = 'POSTGRES_FAILED_CONNECTION',
  PostgresTableInsufficientPrivilege = 'POSTGRES_TABLE_INSUFFICIENT_PRIVILEGE',
  PrimaryKeyNotUnique = 'PRIMARY_KEY_NOT_UNIQUE',
  ProtectedStreamFullSync = 'PROTECTED_STREAM_FULL_SYNC',
  Quarantine = 'QUARANTINE',
  ReadReplicaRecoveryConflict = 'READ_REPLICA_RECOVERY_CONFLICT',
  RedshiftStagingBucketMissing = 'REDSHIFT_STAGING_BUCKET_MISSING',
  ReverseEtlReauthenticationRequired = 'REVERSE_ETL_REAUTHENTICATION_REQUIRED',
  ShopifyPaymentRequired = 'SHOPIFY_PAYMENT_REQUIRED',
  SnowflakeAccountBilling = 'SNOWFLAKE_ACCOUNT_BILLING',
  SnowflakeAccountLocked = 'SNOWFLAKE_ACCOUNT_LOCKED',
  SnowflakeAuthError = 'SNOWFLAKE_AUTH_ERROR',
  StreamDeprecationWarning = 'STREAM_DEPRECATION_WARNING',
  StreamIsDeprecated = 'STREAM_IS_DEPRECATED',
  SubscriptionCancelationReverted = 'SUBSCRIPTION_CANCELATION_REVERTED',
  SubscriptionCanceled = 'SUBSCRIPTION_CANCELED',
  SubscriptionCreated = 'SUBSCRIPTION_CREATED',
  SubscriptionPlanMigrationConfirmation = 'SUBSCRIPTION_PLAN_MIGRATION_CONFIRMATION',
  SubscriptionUpgraded = 'SUBSCRIPTION_UPGRADED',
  SyncFrequencyForced = 'SYNC_FREQUENCY_FORCED',
  TemplateReady = 'TEMPLATE_READY',
  TiktokShopProductAnalyticsUnavailable = 'TIKTOK_SHOP_PRODUCT_ANALYTICS_UNAVAILABLE',
  TiktokShopSellerInactive = 'TIKTOK_SHOP_SELLER_INACTIVE',
  ToastAnalyticsRestaurantsSkipped = 'TOAST_ANALYTICS_RESTAURANTS_SKIPPED',
  TraedeOrderLinesUnavailable = 'TRAEDE_ORDER_LINES_UNAVAILABLE',
  Unknown = 'UNKNOWN',
  XeroMissingScope = 'XERO_MISSING_SCOPE',
  YoutubeReportTypeNotFound = 'YOUTUBE_REPORT_TYPE_NOT_FOUND'
}

export type ObjectType = {
  __typename?: 'ObjectType';
  associations: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  objectName: Scalars['String']['output'];
  objectTypeId: Scalars['String']['output'];
  offerOnlyPrimaryKeysAsIdentifiers?: Maybe<Scalars['Boolean']['output']>;
  supportedDestinationMapping: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type OnDemandReverseEtlSyncEligibilityResponse = {
  __typename?: 'OnDemandReverseETLSyncEligibilityResponse';
  possible: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type OnDemandSyncEligibilityResponse = {
  __typename?: 'OnDemandSyncEligibilityResponse';
  possible: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type Operation = {
  __typename?: 'Operation';
  availableOperationId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  mappings: Array<Mapping>;
  objectType: Scalars['String']['output'];
  objectTypeId?: Maybe<Scalars['String']['output']>;
  operationMode: OperationModes;
  operationType: OperationTypes;
  primaryKeyMapping?: Maybe<Mapping>;
  primaryKeyMappingId?: Maybe<Scalars['String']['output']>;
  primaryKeyRequired: Scalars['Boolean']['output'];
  sync: Sync;
  updatedAt: Scalars['DateTime']['output'];
};

export enum OperationMode {
  Append = 'APPEND',
  Full = 'FULL',
  Incremental = 'INCREMENTAL'
}

export enum OperationModes {
  Insert = 'insert',
  Mirror = 'mirror',
  Update = 'update',
  Upsert = 'upsert'
}

export enum OperationTypes {
  Association = 'association',
  Primary = 'primary'
}

export type OrchestrationActivityPayload = {
  __typename?: 'OrchestrationActivityPayload';
  changedFields?: Maybe<Array<Scalars['String']['output']>>;
  cronExpression: Scalars['String']['output'];
  cronExpressionChange?: Maybe<ActivityValueChange>;
};

export enum OrchestrationSchedulerType {
  Global = 'global',
  Local = 'local'
}

export type OrchestrationWorkflow = {
  __typename?: 'OrchestrationWorkflow';
  accountId: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  contents: OrchestrationWorkflowContents;
  cronExpression: Scalars['String']['output'];
  currentRun?: Maybe<OrchestrationWorkflowRun>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nextRun?: Maybe<OrchestrationWorkflowRun>;
  runs: Array<OrchestrationWorkflowRun>;
};


export type OrchestrationWorkflowRunsArgs = {
  offset?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

export type OrchestrationWorkflowContents = {
  __typename?: 'OrchestrationWorkflowContents';
  models: Scalars['Int']['output'];
  reverseEtlSyncs: Scalars['Int']['output'];
  sourceStreams: Scalars['Int']['output'];
  webhooks: Scalars['Int']['output'];
};

export type OrchestrationWorkflowRun = {
  __typename?: 'OrchestrationWorkflowRun';
  dueAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<WorkflowRunFailureReason>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  jobs: Array<WorkflowJob>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: WorkflowRunStatus;
};

export type OrphanedStreamNotificationsByType = {
  __typename?: 'OrphanedStreamNotificationsByType';
  count: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type OrphanedStreamNotificationsSummary = {
  __typename?: 'OrphanedStreamNotificationsSummary';
  accountsAffected: Scalars['Int']['output'];
  accountsChecked: Scalars['Int']['output'];
  accountsSkipped: Array<Scalars['String']['output']>;
  byType: Array<OrphanedStreamNotificationsByType>;
  dryRun: Scalars['Boolean']['output'];
  jobsDeleted: Scalars['Int']['output'];
  notifications: Scalars['Int']['output'];
};

export enum OverdueEscalationStage {
  DailyReminders = 'DailyReminders',
  GracePeriod = 'GracePeriod',
  Locked = 'Locked',
  Reminded = 'Reminded'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginatedActivityEvents = {
  __typename?: 'PaginatedActivityEvents';
  hasMore: Scalars['Boolean']['output'];
  items: Array<ActivityEvent>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginatedGithubSyncListItems = {
  __typename?: 'PaginatedGithubSyncListItems';
  hasMore: Scalars['Boolean']['output'];
  items: Array<GithubSyncListItem>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginatedSyncHistoryBackOfficeInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  excludeEmpty?: Scalars['Boolean']['input'];
  pageSize?: Scalars['Int']['input'];
  startedAfter?: InputMaybe<Scalars['String']['input']>;
  startedBefore?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SyncJobStatus>>;
};

export type PaginatedSyncHistoryBackOfficeResponse = {
  __typename?: 'PaginatedSyncHistoryBackOfficeResponse';
  hasMore: Scalars['Boolean']['output'];
  items: Array<HistoryItem>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginatedSyncHistoryInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  excludeEmpty?: Scalars['Boolean']['input'];
  pageSize?: Scalars['Int']['input'];
  sourceStreamName: Scalars['String']['input'];
  startedAfter?: InputMaybe<Scalars['String']['input']>;
  startedBefore?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SyncJobStatus>>;
  syncId: Scalars['String']['input'];
};

export type PaginatedSyncHistoryResponse = {
  __typename?: 'PaginatedSyncHistoryResponse';
  hasMore: Scalars['Boolean']['output'];
  items: Array<FindSyncHistoryResponse>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type PastDueCustomerDto = {
  __typename?: 'PastDueCustomerDto';
  account: Account;
  amounts: Array<CurrencyAmountDto>;
  daysOverdue: Scalars['Int']['output'];
  earliestDueDate: Scalars['DateTime']['output'];
  escalationStage: OverdueEscalationStage;
  invoiceCount: Scalars['Int']['output'];
  lastSettlementDate: Scalars['DateTime']['output'];
  stripeCustomerId: Scalars['String']['output'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  card: Card;
};

export type PeriodInput = {
  end: Scalars['DateTime']['input'];
  endInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['DateTime']['input'];
};

export type Plan = {
  __typename?: 'Plan';
  features: Features;
  isEnterprisePlan?: Maybe<Scalars['Boolean']['output']>;
  isLegacyPlan?: Maybe<Scalars['Boolean']['output']>;
  limits: Limits;
  name: PlanName;
  upgradableLimits?: Maybe<UpgradableLimits>;
};

export type PlanCountDto = {
  __typename?: 'PlanCountDto';
  count: Scalars['Int']['output'];
  /** The stored plan name, as it appears on the subscription. */
  planName: Scalars['String']['output'];
};

export type PlanDistributionEntryDto = {
  __typename?: 'PlanDistributionEntryDto';
  group: PlanGroup;
  payingCustomers: Scalars['Int']['output'];
  plans: Array<PlanCountDto>;
  subscriptionTrials: Scalars['Int']['output'];
};

export enum PlanFeature {
  AiAssistantHistoryEnabled = 'aiAssistantHistoryEnabled',
  AuditLogsEnabled = 'auditLogsEnabled',
  ChangeDataCaptureEnabled = 'changeDataCaptureEnabled',
  ColumnHashingEnabled = 'columnHashingEnabled',
  ConnectApiEnabled = 'connectApiEnabled',
  ExternalAuthorizationEnabled = 'externalAuthorizationEnabled',
  LineageEnabled = 'lineageEnabled',
  MarRulesV2Enabled = 'marRulesV2Enabled',
  ModelTestingEnabled = 'modelTestingEnabled',
  MultiDestinationEltEnabled = 'multiDestinationEltEnabled',
  OnDemandSyncsEnabled = 'onDemandSyncsEnabled',
  OrchestrationEnabled = 'orchestrationEnabled',
  SoftDeletesEnabled = 'softDeletesEnabled'
}

export enum PlanGroup {
  Basic = 'Basic',
  Business = 'Business',
  Enterprise = 'Enterprise',
  Legacy = 'Legacy',
  Premium = 'Premium',
  Unknown = 'Unknown'
}

export type PlanLimitsStatus = {
  __typename?: 'PlanLimitsStatus';
  isConnectionsLimitReached: Scalars['Boolean']['output'];
  isUsersLimitReached: Scalars['Boolean']['output'];
  seatUsage: SeatUsage;
};

export enum PlanName {
  Basic = 'Basic',
  Business = 'Business',
  Core = 'Core',
  Custom = 'Custom',
  Enterprise = 'Enterprise',
  Essential = 'Essential',
  FreeTrial = 'FreeTrial',
  Growth = 'Growth',
  Premium = 'Premium',
  Pro = 'Pro'
}

export type PlanPrices = {
  __typename?: 'PlanPrices';
  mar?: Maybe<Scalars['String']['output']>;
  marExtra?: Maybe<Scalars['String']['output']>;
  marOverage?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type PlanValidationResult = {
  __typename?: 'PlanValidationResult';
  result: Scalars['Boolean']['output'];
};

export type PreviewQueryInput = {
  dependencies: Array<QueryDependencyInput>;
  weldSql: Scalars['String']['input'];
};

/** Response type when previewing a query. */
export type PreviewQueryResponse = {
  __typename?: 'PreviewQueryResponse';
  dwSql: Scalars['String']['output'];
  response: Array<Scalars['JSONObject']['output']>;
};

export type PreviewTableDataInput = {
  dependency: QueryDependencyInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Response type when previewing a table data. */
export type PreviewTableDataResponse = {
  __typename?: 'PreviewTableDataResponse';
  dwSql: Scalars['String']['output'];
  response: Array<Scalars['JSONObject']['output']>;
  weldSql: Scalars['String']['output'];
};

export type Price = {
  __typename?: 'Price';
  billingScheme: BillingScheme;
  currency: Scalars['String']['output'];
  currencyOptions: Array<CurrencyOption>;
  id: Scalars['String']['output'];
  lookupKey?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  recurring?: Maybe<Recurring>;
  tiers?: Maybe<Array<Tier>>;
  tiersMode?: Maybe<TiersMode>;
  transformQuantity?: Maybe<TransformQuantity>;
};

export type PriceLookupKeyMap = {
  __typename?: 'PriceLookupKeyMap';
  monthly: Scalars['String']['output'];
  yearly: Scalars['String']['output'];
};

export type PriceLookupKeys = {
  __typename?: 'PriceLookupKeys';
  mar?: Maybe<RecurringPriceLookupKeys>;
  marExtra?: Maybe<RecurringPriceLookupKeys>;
  plan: RecurringPriceLookupKeys;
  user?: Maybe<RecurringPriceLookupKeys>;
};

export type Product = {
  __typename?: 'Product';
  active: Scalars['Boolean']['output'];
  addOnType?: Maybe<WeldAddOnType>;
  description?: Maybe<Scalars['String']['output']>;
  features: StripePlanFeatures;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price: Price;
  type: WeldProductType;
};

export enum PromoDuration {
  Forever = 'Forever',
  Once = 'Once',
  Repeating = 'Repeating'
}

export enum PromoSource {
  Cookie = 'Cookie',
  Input = 'Input'
}

export type PromptableSurveyResponse = {
  __typename?: 'PromptableSurveyResponse';
  survey?: Maybe<Survey>;
};

export type Property = {
  __typename?: 'Property';
  automapMatchAny: Scalars['Boolean']['output'];
  connection: Connection;
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  isPrimaryKey: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  object?: Maybe<Scalars['String']['output']>;
  propertyId: Scalars['String']['output'];
  propertyName: Scalars['String']['output'];
  propertyType: Scalars['String']['output'];
  readonly: Scalars['Boolean']['output'];
};

export type PublishModelInput = {
  clusteringColumns?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isUnsavedModel: Scalars['Boolean']['input'];
  materializationSchedule?: InputMaybe<Scalars['String']['input']>;
  materializationType: MaterializationType;
  modelFolderId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orchestrationScheduler?: InputMaybe<OrchestrationSchedulerType>;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  partitionExpression?: InputMaybe<Scalars['String']['input']>;
  query: QueryInput;
  sourceConnectionId: Scalars['String']['input'];
};

export type PurchasablePlan = {
  __typename?: 'PurchasablePlan';
  features: Features;
  isEnterprisePlan?: Maybe<Scalars['Boolean']['output']>;
  isLegacyPlan?: Maybe<Scalars['Boolean']['output']>;
  limits: Limits;
  name: PlanName;
  priceLookupKeys?: Maybe<PriceLookupKeys>;
  upgradableLimits?: Maybe<UpgradableLimits>;
};

export type QuarantineActionResponse = {
  __typename?: 'QuarantineActionResponse';
  detail: Scalars['String']['output'];
  type: QuarantineActionType;
};

/** A step the customer can take to clear a quarantined stream, rendered as a control. */
export enum QuarantineActionType {
  CheckSourceObject = 'CHECK_SOURCE_OBJECT',
  CheckSourcePermissions = 'CHECK_SOURCE_PERMISSIONS',
  ContactSupport = 'CONTACT_SUPPORT',
  FixIncrementalConfig = 'FIX_INCREMENTAL_CONFIG',
  ReduceSyncFrequency = 'REDUCE_SYNC_FREQUENCY',
  RetrySync = 'RETRY_SYNC',
  ReAuthenticate = 'RE_AUTHENTICATE',
  WaitForWeld = 'WAIT_FOR_WELD'
}

export type QuarantineExplanation = {
  __typename?: 'QuarantineExplanation';
  actions: Array<QuarantineActionResponse>;
  generatedAt: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  matchedNotificationType?: Maybe<Scalars['String']['output']>;
  responsibility: QuarantineResponsibility;
  summary: Scalars['String']['output'];
};

/** Whether the customer, Weld, or time is what clears a quarantined stream. */
export enum QuarantineResponsibility {
  Customer = 'CUSTOMER',
  Transient = 'TRANSIENT',
  Weld = 'WELD'
}

export type Query = {
  __typename?: 'Query';
  accessGroup: AccessGroup;
  accessGroups: Array<AccessGroup>;
  accountById: Account;
  accountBySlug: Account;
  accountBySlugBackoffice: Account;
  accountEffectiveFeaturesBackoffice: AccountEffectiveFeaturesDto;
  accountUsageSummary: AccountUsageSummary;
  activeInitialSyncs: Array<EltSync>;
  activityEvents: PaginatedActivityEvents;
  activityFilterOptions: ActivityFilterOptions;
  activityNewCount: Scalars['Int']['output'];
  agentThreadMessages: Array<AgentMessageDto>;
  agentThreads: Array<AgentThreadDto>;
  allConnectedAccounts: Array<Account>;
  allErds: Array<StoredErd>;
  allPlans: Array<PurchasablePlan>;
  /** @deprecated Use AvailablePlansResolver.getAllPlans instead. */
  allWeldPlans: Array<WeldPlan>;
  analyzeActivateErrorBackoffice: ErrorAnalyzerResponseDto;
  analyzeErrorBackoffice: ErrorAnalyzerResponseDto;
  apiKeys: Array<ApiKeyResponse>;
  apiSecretKey: Scalars['String']['output'];
  asyncQueryPreviewResult?: Maybe<AsyncQueryResultResponse>;
  asyncQueryStatus?: Maybe<AsyncQueryStatusResponse>;
  availableIntegrations: Array<AvailableIntegration>;
  bigQueryUsageStats: BigQueryStats;
  buildPreviewSql: BuildPreviewSqlResponse;
  canAddConnection: PlanValidationResult;
  /** Subscriptions that ended in the last 30 days and whose Account is not a customer again. */
  cancelledSubscriptionsBackoffice: Array<CancelledSubscriptionDto>;
  cancellingCustomersBackoffice: Array<CancellingCustomerDto>;
  checkMigrationCompatibility: Scalars['Boolean']['output'];
  checkOnDemandReverseEtlSyncEligibility: OnDemandReverseEtlSyncEligibilityResponse;
  /** @deprecated Use sourceStreamRunActions instead */
  checkOnDemandSyncEligibility: OnDemandSyncEligibilityResponse;
  connection: Connection;
  connectionBridges: Array<ConnectionBridgeResponse>;
  connectionCDCFeatures: ConnectionCdcFeatures;
  connectionWithConnectedBy: Connection;
  connections: Array<Connection>;
  connectorRestriction: ConnectorRestriction;
  connectors: Array<Connection>;
  countries: Array<Country>;
  current: CurrentUser;
  /** @deprecated Use usageForecastForPeriod with end of month date instead */
  currentMonthUsageForecast: UsageForecastResponse;
  /** @deprecated Use `currentPlanState` query instead */
  currentPlan: WeldPlan;
  currentPlanState: CurrentPlanState;
  currentSubscriptionState: SubscriptionState;
  customer?: Maybe<Customer>;
  customerFunnelBackoffice: CustomerFunnelDto;
  customerPlanDistributionBackoffice: Array<PlanDistributionEntryDto>;
  /** Each customer's active rows over its recent usage periods, against its plan limits. */
  customerUsageBackoffice: Array<CustomerUsageDto>;
  dailyUsageDashboard: DailyUsageDashboardResponse;
  dailyUsageDashboardBackOffice: DailyUsageDashboardResponse;
  dailyUsageDestinationObjectSummary: DailyUsageDestinationObjectSummaryResponse;
  dailyUsageDestinationObjectSummaryBackOffice: DailyUsageDestinationObjectSummaryResponse;
  dailyUsageForecast: DailyUsageForecastResult;
  dailyUsageForecastBackOffice: DailyUsageForecastResult;
  dailyUsageIntegrationSummary: DailyUsageIntegrationSummaryResponse;
  dailyUsageIntegrationSummaryBackOffice: DailyUsageIntegrationSummaryResponse;
  dailyUsageSourceStreamSummary: DailyUsageSourceStreamSummaryResponse;
  dailyUsageSourceStreamSummaryBackOffice: DailyUsageSourceStreamSummaryResponse;
  dailyUsageSourceStreamTimelineBackOffice: DailyUsageSourceStreamTimelineResponse;
  dailyUsageStatAdjustmentsBackOffice: Array<DailyUsageStatAdjustmentDto>;
  /** @deprecated Use dailyUsageStatsForPeriod instead */
  dailyUsageStatsForMonth: WorkspaceSyncStatsResponse;
  dailyUsageStatsForPeriod: WorkspaceSyncStatsTimelineResponse;
  dailyUsageStatsForPeriodBackOffice: WorkspaceSyncStatsTimelineResponse;
  dailyUsageTimeline: DailyUsageTimelineResponse;
  dailyUsageTimelineBackOffice: DailyUsageTimelineResponse;
  dailyUsageTotalSummary: DailyUsageTotalSummaryResponse;
  dailyUsageTotalSummaryBackOffice: DailyUsageTotalSummaryResponse;
  dataWarehouseSchemas?: Maybe<DataWarehouseInfo>;
  datawarehouseMigration?: Maybe<DatawarehouseMigration>;
  dbtConnection?: Maybe<Connection>;
  deletedModels: Array<Model>;
  destinationIntegrations: Array<AvailableIntegration>;
  destinationProperties: Array<Property>;
  destinationSchema: Array<Property>;
  downloadStatus: Array<DownloadStatusByUuid>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** The JSON Schema of the settings a connection takes as an ELT Destination. */
  eltDestinationSettingsSchema: Scalars['JSONObject']['output'];
  eltDestinations: Array<AccountEltDestination>;
  eltJobsCompletionStats: SyncJobsCompletionMetricResponse;
  eltSync: EltSync;
  eltSyncSnapshotState: EltSyncSnapshotState;
  eltSyncStatsHistoric: EltSyncHistoryStatsResponse;
  eltSyncStatsRecent: EltSyncHistoryStatsResponse;
  eltSyncs: Array<EltSync>;
  exportModels: ModelExportBundle;
  failedSyncs: Array<FindFailedSyncsResponse>;
  featureEntitlementsByFeatureBackoffice: Array<FeatureEntitlementDto>;
  findAllAvailableAuditLogs: FindAllAvailableAuditLogsResponse;
  findAllAvailableOperations: Array<FindAvailableOperationsResponse>;
  findAllConnectionsBackoffice: Array<BackofficeConnection>;
  findEltSyncLatestHistory: Array<FindSyncHistoryResponse>;
  findOneSync: Sync;
  findRedisKeys: Array<Scalars['String']['output']>;
  findReverseEltSyncHistory: Array<FindSyncHistoryResponse>;
  firebaseToken: Scalars['String']['output'];
  freemiumAccountsBackoffice: Array<Account>;
  generateConnectionLabel: Scalars['String']['output'];
  getActivateSettings: IntegrationSettings;
  getAgentFixPromptBackoffice?: Maybe<GenerateAgentFixPromptResponseDto>;
  getAllAccounts: Array<Account>;
  getAllAvroSchemas: GetAllAvroSchemasResponse;
  getBigQueryExpirationCheckStatus: BigqueryExpirationCheckStatus;
  getCheckoutPreview: UpcomingInvoice;
  getCurrentAdyenWebhookMigrationStatus?: Maybe<Scalars['JSONObject']['output']>;
  getCurrentShopifyBackfillStatus?: Maybe<Scalars['JSONObject']['output']>;
  getCustomFormValues: CustomFormValues;
  getDWDirectory: Directory;
  getDWDirectoryItems: Array<DwDirectoryItem>;
  getDatawarehouseSetupStatus: SetDataWarehouseResult;
  getEltSettings: IntegrationSettings;
  getEltSyncDetailsBackoffice?: Maybe<EltSync>;
  getErdForIntegration: RawErdResponse;
  getErrorLogsBackOffice: Array<ErrorLogsResponse>;
  getErrors: Array<ActivateError>;
  getGcpBatchJobs: GcpBatchJobs;
  /** Poll for the generated changelog result. */
  getGithubChangelogBackoffice: ChangelogGenerationResult;
  getIntegrationIdsForErd: Array<Scalars['String']['output']>;
  getJobLogs: Array<GetJobLogsResponse>;
  getMFA: MfaInfoResult;
  getMigrationResult: EltSyncMigrationResult;
  getOAuthURL: Scalars['String']['output'];
  getObjectTypeSettings: DestinationObjectTypeSettings;
  getPlanLimitsStatus: PlanLimitsStatus;
  getPlanProduct?: Maybe<Product>;
  getProductPriceByLookupKey: Price;
  getPromptableProductNPSSurvey: PromptableSurveyResponse;
  getRawViews: Array<RawViewReference>;
  getReverseEtlSyncBackoffice: BackofficeReverseEtlSyncDetails;
  getSelfOnboardingProcessStatus: SelfOnboardingStatus;
  getSignupQuestionnaireResult: GetSignupQuestionnaireResponse;
  getSlackChannels: Array<SlackChannel>;
  getStoredErdForIntegration?: Maybe<StoredErd>;
  getStreams: Array<Stream>;
  getStreamsAsync: AsyncStreamsStatus;
  getTemplates: Array<Template>;
  getTestResult: ModelTestResult;
  getViewDetails: ViewDetails;
  getWebhookData: WebhookDataResponse;
  githubApp: GithubApp;
  githubBranches: GithubBranchesResult;
  githubConnection?: Maybe<GithubConnection>;
  githubInstallation?: Maybe<GithubInstallation>;
  githubInstallationChoices: GithubInstallationChoices;
  githubModelLastCommit?: Maybe<GithubFileCommit>;
  githubRepositories: GithubRepositoriesResult;
  githubSync?: Maybe<GithubSync>;
  githubSyncs: PaginatedGithubSyncListItems;
  hasDeletedModels: HasDeletedModelsResponse;
  initialSyncsStatus: Array<InitialSyncStatusResponse>;
  integrationConfiguration: IntegrationConfiguration;
  integrationEntitlementsByAccountIdBackoffice: Array<IntegrationEntitlementDto>;
  integrationEntitlementsByIntegrationIdBackoffice: Array<IntegrationEntitlementDto>;
  integrationUsageStatsForPeriod: IntegrationSyncStatsSummaryResponse;
  integrationUsageStatsForPeriodBackOffice: IntegrationSyncStatsSummaryResponse;
  integrationsBackoffice: Array<IntegrationResource>;
  invitations: Array<Invitation>;
  invoices: Array<Invoice>;
  /** @deprecated This field is deprecated and will be removed in a future release. */
  latestUsageRecordSummaryBackoffice?: Maybe<UsageRecordSummary>;
  latestWebhookRuns: Array<WebhookRunResponse>;
  lineageAccess: LineageAccess;
  listEltSyncsBackoffice: Array<EltSync>;
  listFailedActivateSyncsBackoffice: Array<ActivateSyncJobResponse>;
  listFailedSyncsBackoffice: Array<EltSyncJobResponse>;
  listModelFolders: Array<ModelFolder>;
  listReverseEtlSyncRunsBackoffice: BackofficeReverseEtlSyncRunsPage;
  listReverseEtlSyncsBackoffice: Array<BackofficeReverseEtlSync>;
  listTemplateConfigurations: Array<TemplateConfig>;
  listWebhoooks: Array<WebhookResponse>;
  materializedTableReference?: Maybe<MaterializedTableReference>;
  model: Model;
  /** Which published models count as unused, and why each other one counts as used. Shares the modelUsage cache; pass refresh to query the warehouse again. */
  modelCleanup: ModelCleanupAnalysis;
  modelCountsBackOffice: ModelCountsBackOffice;
  modelTest: ModelTest;
  modelTestRun?: Maybe<ModelTestRun>;
  /** When each published model was last read by a warehouse query. Cached for a day per workspace; pass refresh to query the warehouse again. */
  modelUsage: ModelUsageStats;
  modelUsageSummary: ModelUsageSummaryDto;
  modelViewReference?: Maybe<MaterializedTableReference>;
  models: Array<Model>;
  modelsByIds: Array<Model>;
  monthlyActiveRowsBackOffice: Array<MonthlyActiveRowsEntry>;
  mostRecentPublishedModels: Array<Model>;
  myRecentlyEditedModels: Array<RecentlyEditedModel>;
  /** Customers whose current subscription was created in the last 30 days. */
  newCustomersBackoffice: Array<NewCustomerDto>;
  notifications: Array<Notification>;
  notificationsByAccountBackoffice: Array<Notification>;
  objectTypes: Array<ObjectType>;
  openInvitations: Array<Invitation>;
  orchestrationWorkflow?: Maybe<OrchestrationWorkflow>;
  orchestrationWorkflowRun: OrchestrationWorkflowRun;
  orchestrationWorkflows: Array<OrchestrationWorkflow>;
  overdueInvoices: Array<Invoice>;
  paginatedEltSyncHistory: PaginatedSyncHistoryResponse;
  paginatedEltSyncHistoryBackOffice: PaginatedSyncHistoryBackOfficeResponse;
  pastDueCustomersBackoffice: Array<PastDueCustomerDto>;
  paymentPreviewForSubscription?: Maybe<UpcomingInvoice>;
  plan: PurchasablePlan;
  planStateForAccountBackOffice: CurrentPlanState;
  /** Data source integration ids, most used first, ranked by accounts with an active data source sync. */
  popularEltSources: Array<Scalars['String']['output']>;
  /** @deprecated Use previewTableData or createAsyncQueryPreview instead. Will be removed when usage is removed from the frontend */
  previewQuery: PreviewQueryResponse;
  previewTableData: PreviewTableDataResponse;
  publishedModels: Array<Model>;
  queryModel: QueryModelResponse;
  rawView?: Maybe<RawViewReference>;
  rawViewDetails: ViewDetails;
  rawViewStats: RawViewsStats;
  resolveCountryFromTimeZone: ResolveCountryResponse;
  restrictedConnectors: Array<ConnectorRestriction>;
  retrieveRedisKey: Scalars['JSONObject']['output'];
  retrieveSecretByArn: Scalars['String']['output'];
  retrieveSecretByConnectionId: Scalars['String']['output'];
  retrieveSecretBySyncId: Scalars['String']['output'];
  reverseEtlJobsCompletionStats: SyncJobsCompletionMetricResponse;
  revokedIntegrationEntitlementsByAccountIdBackoffice: Array<IntegrationEntitlementDto>;
  savedDrafts: Array<Model>;
  scheduledIncidents: Array<Incident>;
  searchAccountsBackoffice: Array<Account>;
  searchModels: Array<Model>;
  searchSyncDestinations: Array<SearchSyncDestinationsResult>;
  sourceProperties: ViewDetails;
  sourceSchema: Array<DataSchema>;
  sourceStreamByNameBackOffice: SourceStreamBackOffice;
  sourceStreamRawJobBackOffice?: Maybe<Scalars['JSONObject']['output']>;
  sourceStreamRunActions: SourceStreamJobRunActionsResponse;
  sourceStreamUsageStatsForPeriod: SourceStreamSyncStatsSummaryResponse;
  sourceStreamUsageStatsForPeriodBackOffice: SourceStreamSyncStatsSummaryResponse;
  sourceStreamsWithSubStreams: Array<Stream>;
  sqlQuery: SqlQuery;
  staleMaterializations: StaleMaterializationsSummary;
  standardPlans: Array<PurchasablePlan>;
  startTest: ModelTestResult;
  subscriptionBackoffice?: Maybe<StripeSubscriptionDetails>;
  subscriptionDetails?: Maybe<StripeSubscriptionDetails>;
  syncs: Array<Sync>;
  taxIdsData: Array<TaxIdData>;
  throwError: Scalars['Boolean']['output'];
  totalUsageForecastForPeriod: TotalUsageForecastResponse;
  totalUsageStatsForPeriod: WorkspaceSyncStatsSummaryResponse;
  totalUsageStatsForPeriodBackOffice: WorkspaceSyncStatsSummaryResponse;
  unresolvedIncidents: Array<Incident>;
  upcomingInvoice?: Maybe<UpcomingInvoice>;
  upcomingMAROverageInvoice?: Maybe<UpcomingInvoice>;
  upcomingPlanInvoice?: Maybe<UpcomingInvoice>;
  usageForecastForPeriod: UsageForecastResult;
  user: User;
  users: Array<User>;
  validateConnectionAddition: ValidationResult;
  validateCurrentConnectionUsageAgainstPlan: ConnectorPlanValidationResult;
  validateCustomForm: CustomFormValidationResult;
  validatePromoCode: ValidatedPromoCode;
  validateQuery: QueryValidationResponse;
  verifyUnpublishedChanges: VerifyUnpublishedChangesResponse;
  viewDetailsByPath: ViewDetails;
  webhookRunHistory: Array<WebhookRunResponse>;
  websiteConnectors: Array<EnhancedDataConnector>;
  websiteIntegrations: Array<EnhancedIntegration>;
  /** @deprecated Use AvailablePlansResolver.getPlan instead. */
  weldPlan: WeldPlan;
  workspaceLineageGraph: Array<LineageGraphNode>;
  workspaceStats: WorkspaceStats;
  /** @deprecated Use totalUsageStatsForPeriod instead */
  workspaceSyncStats: WorkspaceSyncStatsResponse;
  /** @deprecated Use integrationUsageStatsForPeriod in UsageStatsResolver instead */
  workspaceSyncStatsByIntegration: IntegrationSyncStatsResponse;
  /** @deprecated use `sourceStreamUsageStatsForPeriod` in `UsageStatsResolver` instead */
  workspaceSyncStatsBySourceStream: SourceStreamSyncStatsResponse;
};


export type QueryAccessGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryAccountBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryAccountBySlugBackofficeArgs = {
  slug: Scalars['String']['input'];
};


export type QueryAccountEffectiveFeaturesBackofficeArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryAccountUsageSummaryArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryActivityEventsArgs = {
  filter?: InputMaybe<ActivityFilterInput>;
  page?: InputMaybe<ActivityPageInput>;
};


export type QueryAgentThreadMessagesArgs = {
  threadId: Scalars['ID']['input'];
};


export type QueryAgentThreadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  surface: AgentSurface;
};


export type QueryAnalyzeActivateErrorBackofficeArgs = {
  scheduledJobId: Scalars['String']['input'];
};


export type QueryAnalyzeErrorBackofficeArgs = {
  scheduledJobId: Scalars['String']['input'];
};


export type QueryApiSecretKeyArgs = {
  apiKeyId: Scalars['String']['input'];
};


export type QueryAsyncQueryPreviewResultArgs = {
  queryExecutionId: Scalars['ID']['input'];
};


export type QueryAsyncQueryStatusArgs = {
  queryExecutionId: Scalars['ID']['input'];
};


export type QueryBuildPreviewSqlArgs = {
  input: BuildPreviewSqlInput;
};


export type QueryCanAddConnectionArgs = {
  integrationId: Scalars['String']['input'];
};


export type QueryCheckMigrationCompatibilityArgs = {
  createConnectionInput: CreateConnectionInput;
};


export type QueryCheckOnDemandReverseEtlSyncEligibilityArgs = {
  input: StartSyncInput;
};


export type QueryCheckOnDemandSyncEligibilityArgs = {
  input: RunJobNowInput;
};


export type QueryConnectionArgs = {
  id: Scalars['String']['input'];
};


export type QueryConnectionCdcFeaturesArgs = {
  connectionId: Scalars['String']['input'];
  sourceSettings?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryConnectionWithConnectedByArgs = {
  id: Scalars['String']['input'];
};


export type QueryConnectorRestrictionArgs = {
  connectionId: Scalars['ID']['input'];
};


export type QueryCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryDailyUsageDashboardArgs = {
  period: DailyUsagePeriodInput;
};


export type QueryDailyUsageDashboardBackOfficeArgs = {
  accountId: Scalars['String']['input'];
  period: DailyUsagePeriodInput;
};


export type QueryDailyUsageDestinationObjectSummaryArgs = {
  period: DailyUsagePeriodInput;
};


export type QueryDailyUsageDestinationObjectSummaryBackOfficeArgs = {
  accountId: Scalars['String']['input'];
  period: DailyUsagePeriodInput;
};


export type QueryDailyUsageForecastArgs = {
  period: DailyUsagePeriodInput;
};


export type QueryDailyUsageForecastBackOfficeArgs = {
  accountId: Scalars['String']['input'];
  period: DailyUsagePeriodInput;
  referenceDate: Scalars['DateTime']['input'];
};


export type QueryDailyUsageIntegrationSummaryArgs = {
  period: DailyUsagePeriodInput;
};


export type QueryDailyUsageIntegrationSummaryBackOfficeArgs = {
  accountId: Scalars['String']['input'];
  period: DailyUsagePeriodInput;
};


export type QueryDailyUsageSourceStreamSummaryArgs = {
  period: DailyUsagePeriodInput;
};


export type QueryDailyUsageSourceStreamSummaryBackOfficeArgs = {
  accountId: Scalars['String']['input'];
  period: DailyUsagePeriodInput;
};


export type QueryDailyUsageSourceStreamTimelineBackOfficeArgs = {
  accountId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  period: DailyUsagePeriodInput;
  resource: Scalars['String']['input'];
};


export type QueryDailyUsageStatAdjustmentsBackOfficeArgs = {
  chunkCorrelationId?: InputMaybe<Scalars['String']['input']>;
  scheduledJobId: Scalars['String']['input'];
  startedAt: Scalars['String']['input'];
};


export type QueryDailyUsageStatsForMonthArgs = {
  referenceDate: Scalars['DateTime']['input'];
};


export type QueryDailyUsageStatsForPeriodArgs = {
  period: PeriodInput;
};


export type QueryDailyUsageStatsForPeriodBackOfficeArgs = {
  accountId: Scalars['String']['input'];
  period: PeriodInput;
};


export type QueryDailyUsageTimelineArgs = {
  period: DailyUsagePeriodInput;
};


export type QueryDailyUsageTimelineBackOfficeArgs = {
  accountId: Scalars['String']['input'];
  period: DailyUsagePeriodInput;
};


export type QueryDailyUsageTotalSummaryArgs = {
  period: DailyUsagePeriodInput;
};


export type QueryDailyUsageTotalSummaryBackOfficeArgs = {
  accountId: Scalars['String']['input'];
  period: DailyUsagePeriodInput;
};


export type QueryDestinationPropertiesArgs = {
  input: DestinationPropertiesInput;
};


export type QueryDestinationSchemaArgs = {
  input: DestinationSchemaInput;
};


export type QueryDownloadStatusArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryDownloadUrlArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryEltDestinationSettingsSchemaArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryEltJobsCompletionStatsArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryEltSyncArgs = {
  id: Scalars['String']['input'];
};


export type QueryEltSyncSnapshotStateArgs = {
  syncId: Scalars['String']['input'];
};


export type QueryEltSyncStatsHistoricArgs = {
  from: Scalars['DateTime']['input'];
  sourceStreamName?: InputMaybe<Scalars['String']['input']>;
  syncId: Scalars['String']['input'];
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryEltSyncStatsRecentArgs = {
  from: Scalars['DateTime']['input'];
  sourceStreamName?: InputMaybe<Scalars['String']['input']>;
  syncId: Scalars['String']['input'];
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryExportModelsArgs = {
  modelIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryFeatureEntitlementsByFeatureBackofficeArgs = {
  feature: PlanFeature;
};


export type QueryFindAllAvailableOperationsArgs = {
  connectionId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
};


export type QueryFindAllConnectionsBackofficeArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryFindEltSyncLatestHistoryArgs = {
  syncId: Scalars['String']['input'];
};


export type QueryFindOneSyncArgs = {
  id: Scalars['String']['input'];
};


export type QueryFindRedisKeysArgs = {
  pattern: Scalars['String']['input'];
};


export type QueryFindReverseEltSyncHistoryArgs = {
  syncId: Scalars['String']['input'];
};


export type QueryFreemiumAccountsBackofficeArgs = {
  type: FreemiumAccountsType;
};


export type QueryGenerateConnectionLabelArgs = {
  baseLabel: Scalars['String']['input'];
};


export type QueryGetActivateSettingsArgs = {
  input: GetSettingsInput;
};


export type QueryGetAgentFixPromptBackofficeArgs = {
  scheduledJobId: Scalars['String']['input'];
};


export type QueryGetAllAvroSchemasArgs = {
  connectionSettings: Scalars['JSONObject']['input'];
  sourceConnectionId: Scalars['String']['input'];
  sourceStreamNames: Array<Scalars['String']['input']>;
};


export type QueryGetCheckoutPreviewArgs = {
  input: InvoicePreviewInput;
};


export type QueryGetCustomFormValuesArgs = {
  input: CustomFormInput;
};


export type QueryGetDwDirectoryArgs = {
  input: GetDwDirectoryInput;
};


export type QueryGetDwDirectoryItemsArgs = {
  input: GetDwDirectoryItemsInput;
};


export type QueryGetEltSettingsArgs = {
  input: GetSettingsInput;
};


export type QueryGetEltSyncDetailsBackofficeArgs = {
  eltSyncId: Scalars['String']['input'];
};


export type QueryGetErdForIntegrationArgs = {
  integrationId: Scalars['String']['input'];
};


export type QueryGetErrorLogsBackOfficeArgs = {
  scheduledJobId: Scalars['String']['input'];
};


export type QueryGetErrorsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetGcpBatchJobsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Float']['input'];
};


export type QueryGetGithubChangelogBackofficeArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  repos?: InputMaybe<Array<Scalars['String']['input']>>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetJobLogsArgs = {
  jobId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMigrationResultArgs = {
  input: GetEltSyncMigrationRequest;
};


export type QueryGetOAuthUrlArgs = {
  input: CreateOAuthFlowInput;
};


export type QueryGetObjectTypeSettingsArgs = {
  connectionId: Scalars['String']['input'];
  formValues?: InputMaybe<Scalars['JSONObject']['input']>;
  objectType: Scalars['String']['input'];
};


export type QueryGetPlanProductArgs = {
  planName: Scalars['String']['input'];
};


export type QueryGetProductPriceByLookupKeyArgs = {
  currency: Scalars['String']['input'];
  lookupKey: Scalars['String']['input'];
};


export type QueryGetReverseEtlSyncBackofficeArgs = {
  accountId: Scalars['String']['input'];
  syncId: Scalars['String']['input'];
};


export type QueryGetSlackChannelsArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryGetStoredErdForIntegrationArgs = {
  integrationId: Scalars['String']['input'];
};


export type QueryGetStreamsArgs = {
  connectionId: Scalars['String']['input'];
  eltSyncId?: InputMaybe<Scalars['String']['input']>;
  sourceSettings: Scalars['JSONObject']['input'];
};


export type QueryGetStreamsAsyncArgs = {
  connectionId: Scalars['String']['input'];
  sourceSettings: Scalars['JSONObject']['input'];
};


export type QueryGetTestResultArgs = {
  modelTestId: Scalars['ID']['input'];
  queryExecutionId: Scalars['String']['input'];
};


export type QueryGetViewDetailsArgs = {
  input: GetViewDetailsInput;
};


export type QueryGetWebhookDataArgs = {
  type: Scalars['String']['input'];
};


export type QueryGithubBranchesArgs = {
  owner: Scalars['String']['input'];
  repo: Scalars['String']['input'];
};


export type QueryGithubInstallationChoicesArgs = {
  state: Scalars['String']['input'];
};


export type QueryGithubModelLastCommitArgs = {
  sourcePath: Scalars['String']['input'];
};


export type QueryGithubSyncArgs = {
  id: Scalars['String']['input'];
};


export type QueryGithubSyncsArgs = {
  before?: InputMaybe<Scalars['String']['input']>;
  connectionId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInitialSyncsStatusArgs = {
  syncIds: Array<Scalars['String']['input']>;
};


export type QueryIntegrationConfigurationArgs = {
  integrationId: Scalars['String']['input'];
  isDatawarehouse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryIntegrationEntitlementsByAccountIdBackofficeArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryIntegrationEntitlementsByIntegrationIdBackofficeArgs = {
  integrationId: Scalars['String']['input'];
};


export type QueryIntegrationUsageStatsForPeriodArgs = {
  period: PeriodInput;
};


export type QueryIntegrationUsageStatsForPeriodBackOfficeArgs = {
  accountId: Scalars['String']['input'];
  period: PeriodInput;
};


export type QueryInvitationsArgs = {
  getUsed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInvoicesArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryLatestUsageRecordSummaryBackofficeArgs = {
  subscriptionItemId: Scalars['String']['input'];
};


export type QueryLatestWebhookRunsArgs = {
  webhookIds: Array<Scalars['String']['input']>;
};


export type QueryLineageAccessArgs = {
  input: LineageSourceInput;
};


export type QueryListEltSyncsBackofficeArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryListFailedActivateSyncsBackofficeArgs = {
  minFailures?: Scalars['Float']['input'];
};


export type QueryListFailedSyncsBackofficeArgs = {
  minFailures?: Scalars['Float']['input'];
};


export type QueryListReverseEtlSyncRunsBackofficeArgs = {
  accountId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  syncId: Scalars['String']['input'];
};


export type QueryListReverseEtlSyncsBackofficeArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryListWebhoooksArgs = {
  orchestrationWorkflowId: Scalars['String']['input'];
};


export type QueryMaterializedTableReferenceArgs = {
  modelId: Scalars['String']['input'];
};


export type QueryModelArgs = {
  id: Scalars['String']['input'];
};


export type QueryModelCleanupArgs = {
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryModelCountsBackOfficeArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryModelTestArgs = {
  id: Scalars['String']['input'];
};


export type QueryModelTestRunArgs = {
  modelTestId: Scalars['ID']['input'];
  workflowRunId: Scalars['ID']['input'];
};


export type QueryModelUsageArgs = {
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryModelViewReferenceArgs = {
  modelId: Scalars['String']['input'];
};


export type QueryModelsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryMonthlyActiveRowsBackOfficeArgs = {
  accountId: Scalars['String']['input'];
  anchorDate: Scalars['DateTime']['input'];
  months?: Scalars['Int']['input'];
};


export type QueryMyRecentlyEditedModelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNotificationsByAccountBackofficeArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryObjectTypesArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryOrchestrationWorkflowArgs = {
  workflowId: Scalars['ID']['input'];
};


export type QueryOrchestrationWorkflowRunArgs = {
  runId: Scalars['ID']['input'];
};


export type QueryOverdueInvoicesArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryPaginatedEltSyncHistoryArgs = {
  input: PaginatedSyncHistoryInput;
};


export type QueryPaginatedEltSyncHistoryBackOfficeArgs = {
  input: PaginatedSyncHistoryBackOfficeInput;
  scheduledJobId: Scalars['String']['input'];
};


export type QueryPaymentPreviewForSubscriptionArgs = {
  customerId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};


export type QueryPlanArgs = {
  planName: Scalars['String']['input'];
};


export type QueryPlanStateForAccountBackOfficeArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryPreviewQueryArgs = {
  input: PreviewQueryInput;
};


export type QueryPreviewTableDataArgs = {
  input: PreviewTableDataInput;
};


export type QueryQueryModelArgs = {
  modelId: Scalars['String']['input'];
};


export type QueryRawViewArgs = {
  viewId: Scalars['String']['input'];
};


export type QueryRawViewDetailsArgs = {
  viewId: Scalars['String']['input'];
};


export type QueryResolveCountryFromTimeZoneArgs = {
  timeZone: Scalars['String']['input'];
};


export type QueryRetrieveRedisKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryRetrieveSecretByArnArgs = {
  secretArn: Scalars['String']['input'];
};


export type QueryRetrieveSecretByConnectionIdArgs = {
  connectionId: Scalars['String']['input'];
};


export type QueryRetrieveSecretBySyncIdArgs = {
  eltSyncId: Scalars['String']['input'];
};


export type QueryReverseEtlJobsCompletionStatsArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryRevokedIntegrationEntitlementsByAccountIdBackofficeArgs = {
  accountId: Scalars['String']['input'];
};


export type QuerySearchAccountsBackofficeArgs = {
  search: Scalars['String']['input'];
};


export type QuerySearchModelsArgs = {
  publishedOnly: Scalars['Boolean']['input'];
  query: Scalars['String']['input'];
};


export type QuerySearchSyncDestinationsArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QuerySourcePropertiesArgs = {
  modelId: Scalars['String']['input'];
};


export type QuerySourceSchemaArgs = {
  id: Scalars['String']['input'];
  type: SourceType;
};


export type QuerySourceStreamByNameBackOfficeArgs = {
  name: Scalars['String']['input'];
  syncId: Scalars['String']['input'];
};


export type QuerySourceStreamRawJobBackOfficeArgs = {
  cloudProvider: Scalars['String']['input'];
  scheduledJobId: Scalars['String']['input'];
};


export type QuerySourceStreamRunActionsArgs = {
  input: RunJobNowInput;
};


export type QuerySourceStreamUsageStatsForPeriodArgs = {
  period: PeriodInput;
};


export type QuerySourceStreamUsageStatsForPeriodBackOfficeArgs = {
  accountId: Scalars['String']['input'];
  period: PeriodInput;
};


export type QuerySourceStreamsWithSubStreamsArgs = {
  connectionId: Scalars['String']['input'];
  eltSyncId: Scalars['String']['input'];
  sourceStreamNames: Array<Scalars['String']['input']>;
};


export type QuerySqlQueryArgs = {
  id: Scalars['String']['input'];
};


export type QueryStartTestArgs = {
  modelTestId: Scalars['ID']['input'];
};


export type QuerySubscriptionBackofficeArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type QuerySubscriptionDetailsArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type QueryTotalUsageForecastForPeriodArgs = {
  period: PeriodInput;
};


export type QueryTotalUsageStatsForPeriodArgs = {
  period: PeriodInput;
};


export type QueryTotalUsageStatsForPeriodBackOfficeArgs = {
  accountId: Scalars['String']['input'];
  period: PeriodInput;
};


export type QueryUpcomingInvoiceArgs = {
  customerId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};


export type QueryUpcomingMarOverageInvoiceArgs = {
  customerId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};


export type QueryUpcomingPlanInvoiceArgs = {
  customerId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};


export type QueryUsageForecastForPeriodArgs = {
  periodEnd: Scalars['DateTime']['input'];
};


export type QueryUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryValidateConnectionAdditionArgs = {
  integrationId: Scalars['String']['input'];
};


export type QueryValidateCurrentConnectionUsageAgainstPlanArgs = {
  planName: PlanName;
};


export type QueryValidateCustomFormArgs = {
  input: CustomFormValidationInput;
};


export type QueryValidatePromoCodeArgs = {
  code: Scalars['String']['input'];
  flow?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateQueryArgs = {
  dependencies: Array<QueryDependencyInput>;
  weldSql: Scalars['String']['input'];
};


export type QueryVerifyUnpublishedChangesArgs = {
  modelId: Scalars['String']['input'];
};


export type QueryViewDetailsByPathArgs = {
  path: Array<Scalars['String']['input']>;
};


export type QueryWebhookRunHistoryArgs = {
  webhookId: Scalars['String']['input'];
};


export type QueryWeldPlanArgs = {
  planName: Scalars['String']['input'];
};


export type QueryWorkspaceSyncStatsArgs = {
  fromMonth: Scalars['DateTime']['input'];
  toMonth?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryWorkspaceSyncStatsByIntegrationArgs = {
  month: Scalars['DateTime']['input'];
};


export type QueryWorkspaceSyncStatsBySourceStreamArgs = {
  month: Scalars['DateTime']['input'];
};

export type QueryDependencyEntity = {
  __typename?: 'QueryDependencyEntity';
  dwItemId: Scalars['String']['output'];
  sqlQueryId: Scalars['String']['output'];
  type: DependencyType;
  weldTag: Scalars['String']['output'];
};

export type QueryDependencyInput = {
  dwItemId: Scalars['String']['input'];
  type: DependencyType;
  weldTag: Scalars['String']['input'];
};

export type QueryInput = {
  dependencies: Array<QueryDependencyInput>;
  weldSql: Scalars['String']['input'];
};

/** Response type when querying by Model. */
export type QueryModelResponse = {
  __typename?: 'QueryModelResponse';
  dwSql: Scalars['String']['output'];
  id: Scalars['String']['output'];
  response: Array<Scalars['JSONObject']['output']>;
};

export enum QueryResultStatusEnum {
  Done = 'DONE',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

export type QueryUsage = {
  __typename?: 'QueryUsage';
  bqBilledUsd: Scalars['Float']['output'];
  bytesBilled: Scalars['Float']['output'];
  bytesProcessed: Scalars['Float']['output'];
};

export type QueryValidationResponse = {
  __typename?: 'QueryValidationResponse';
  /** The warehouse's own message when it rejected the SQL, or null when it would run. */
  error?: Maybe<Scalars['String']['output']>;
  /** The 1-based line the warehouse blamed, when its driver reports the position as data rather than inside the message. Null otherwise, leaving the client to read the message itself. */
  line?: Maybe<Scalars['Int']['output']>;
};

export type RawErdResponse = {
  __typename?: 'RawErdResponse';
  edges: Array<ErdEdge>;
  integrationId: Scalars['String']['output'];
  nodes: Array<ErdNode>;
};

export type RawViewReference = {
  __typename?: 'RawViewReference';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  dwSqlReference: Scalars['String']['output'];
  eltTableSqlRef: Scalars['String']['output'];
  firstSyncCompleted: Scalars['Boolean']['output'];
  integrationId?: Maybe<Scalars['String']['output']>;
  landingTable?: Maybe<Scalars['Boolean']['output']>;
  latestSyncTime: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  retired: Scalars['Boolean']['output'];
  retirementDetails?: Maybe<RetirementDetails>;
  scheduledJobId?: Maybe<Scalars['String']['output']>;
  schema: Scalars['String']['output'];
  sourceStream: Scalars['String']['output'];
  syncId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  viewId: Scalars['String']['output'];
  weldTag: Scalars['String']['output'];
};

export type RawViewsStats = {
  __typename?: 'RawViewsStats';
  numFirstSyncCompleted: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** What will cause a transform to be rebuilt from now on, if anything. */
export enum RebuildTrigger {
  None = 'none',
  NotApplicable = 'not_applicable',
  NotScheduled = 'not_scheduled',
  Orchestration = 'orchestration',
  Schedule = 'schedule'
}

export type RecentlyEditedModel = {
  __typename?: 'RecentlyEditedModel';
  editedAt: Scalars['DateTime']['output'];
  model: Model;
};

export type ReconcileStaleMaterializationsResult = {
  __typename?: 'ReconcileStaleMaterializationsResult';
  failures: Array<ModelMaterializationFailure>;
  staleModelIds: Array<Scalars['ID']['output']>;
};

export type RecreateViewResponse = {
  __typename?: 'RecreateViewResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum RecurrenceInterval {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

export enum RecurrenceUsageType {
  Licensed = 'Licensed',
  Metered = 'Metered'
}

export type Recurring = {
  __typename?: 'Recurring';
  interval: RecurrenceInterval;
  intervalCount: Scalars['Int']['output'];
  usageType: RecurrenceUsageType;
};

export type RecurringPriceLookupKeys = {
  __typename?: 'RecurringPriceLookupKeys';
  monthly: Scalars['String']['output'];
  yearly: Scalars['String']['output'];
};

export type RemoveEltSyncDestinationInput = {
  eltSyncDestinationId: Scalars['String']['input'];
};

export type RemoveEltSyncInput = {
  eltSyncId: Scalars['String']['input'];
  removeDataReferences?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoveEltSyncResponse = {
  __typename?: 'RemoveEltSyncResponse';
  destinationConnectionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  sourceConnectionId: Scalars['String']['output'];
  sourceStreamNames: Array<Scalars['String']['output']>;
};

export type RemoveNotificationInput = {
  id: Scalars['String']['input'];
};

export type RemoveTableFromSyncInput = {
  sourceStreamName: Scalars['String']['input'];
  syncId: Scalars['String']['input'];
  viewId?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveTableResponse = {
  __typename?: 'RemoveTableResponse';
  sourceStreamName: Scalars['String']['output'];
};

export type ResetActivateSyncInput = {
  numberOfErrors?: InputMaybe<Scalars['Float']['input']>;
  syncId: Scalars['String']['input'];
};

export type ResetActivateSyncResponse = {
  __typename?: 'ResetActivateSyncResponse';
  job?: Maybe<Scalars['JSONObject']['output']>;
  reason: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ResetEltSyncInput = {
  eltSyncId: Scalars['String']['input'];
  numberOfErrors?: InputMaybe<Scalars['Float']['input']>;
  resetIncrementalPointer?: Scalars['Boolean']['input'];
  sourceIntegrationId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
};

export type ResetSyncResponse = {
  __typename?: 'ResetSyncResponse';
  job?: Maybe<Scalars['JSONObject']['output']>;
  reason: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ResolveCountryResponse = {
  __typename?: 'ResolveCountryResponse';
  country?: Maybe<Country>;
};

export type RetirementDetails = {
  __typename?: 'RetirementDetails';
  details?: Maybe<Scalars['String']['output']>;
  inFavorOf?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  removalDate?: Maybe<Scalars['String']['output']>;
};

export type ReverseEtlJobResponse = {
  __typename?: 'ReverseEtlJobResponse';
  isQuarantined?: Maybe<Scalars['Boolean']['output']>;
  lastRun?: Maybe<Scalars['Float']['output']>;
  nextRun?: Maybe<Scalars['Float']['output']>;
  running?: Maybe<Scalars['Boolean']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ReverseEtlSyncActivityPayload = {
  __typename?: 'ReverseEtlSyncActivityPayload';
  changedFields?: Maybe<Array<Scalars['String']['output']>>;
  destinationIntegrationId: Scalars['String']['output'];
  interval?: Maybe<ActivityValueChange>;
  modelId?: Maybe<Scalars['String']['output']>;
  orchestrationWorkflowId?: Maybe<ActivityValueChange>;
  primaryObject: Scalars['String']['output'];
  sourceIntegrationId: Scalars['String']['output'];
};

export type RevertSourceStreamInput = {
  eltSyncId: Scalars['String']['input'];
  names: Array<Scalars['String']['input']>;
};

export enum Role {
  Admin = 'admin',
  Editor = 'editor',
  None = 'none',
  Viewer = 'viewer'
}

export enum RunAction {
  Retry = 'Retry',
  Run = 'Run'
}

export type RunJobNowInput = {
  eltSyncId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
};

export type RunValidationError = {
  __typename?: 'RunValidationError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type SaveIntegrationMetadataInput = {
  activateDestination?: InputMaybe<IntegrationDataConnectorInput>;
  aliasFor?: InputMaybe<Scalars['String']['input']>;
  baseId?: InputMaybe<Scalars['String']['input']>;
  biTool?: InputMaybe<IntegrationDataConnectorInput>;
  categories: Array<Scalars['String']['input']>;
  connectorForms?: InputMaybe<Array<ConnectorFormConfigInput>>;
  dataWarehouse?: InputMaybe<IntegrationDataConnectorInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentationUrl?: InputMaybe<Scalars['String']['input']>;
  eltSource?: InputMaybe<IntegrationDataConnectorInput>;
  integrationId: Scalars['String']['input'];
  isAvailable: Scalars['Boolean']['input'];
  logo?: InputMaybe<LogoConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiresAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveSignupQuestionnaireResultInput = {
  result: Scalars['JSONObject']['input'];
};

export type SchemaDto = {
  __typename?: 'SchemaDto';
  cursor?: Maybe<Scalars['String']['output']>;
  fields: Array<AvroSchemaFieldDto>;
  primaryKeys?: Maybe<Array<Scalars['String']['output']>>;
  sourceStreamName: Scalars['String']['output'];
};

export type SearchSyncDestinationsResult = {
  __typename?: 'SearchSyncDestinationsResult';
  integrationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  schemaName: Scalars['String']['output'];
  viewId: Scalars['String']['output'];
};

/** The breakdown the user limit is enforced on. Weld staff hold no seat; a pending invitation does. */
export type SeatUsage = {
  __typename?: 'SeatUsage';
  isLimitReached: Scalars['Boolean']['output'];
  /** Null when nothing is enforced: an unlimited plan, or no subscription. */
  limit?: Maybe<Scalars['Int']['output']>;
  members: Scalars['Int']['output'];
  /** Unexpired and unaccepted. */
  pendingInvitations: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

export type SeedDatawarehouseResponse = {
  __typename?: 'SeedDatawarehouseResponse';
  models: Array<SeededModel>;
};

export type SeededModel = {
  __typename?: 'SeededModel';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SelfOnboardingStatus = {
  __typename?: 'SelfOnboardingStatus';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<GoogleProject>;
  status: AsyncJobStatusEnum;
};

export type SendInvitationInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role: Role;
  scopes?: InputMaybe<Array<EditorScope>>;
};

export type SetConnectorRestrictionInput = {
  accessGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  connectionId: Scalars['ID']['input'];
  restricted: Scalars['Boolean']['input'];
};

export type SetDataWarehouseResult = {
  __typename?: 'SetDataWarehouseResult';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  status: AsyncJobStatusEnum;
};

export type SetupSlackInput = {
  channelId: Scalars['String']['input'];
  channelName: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
};

export type SetupTeamsInput = {
  channelName: Scalars['String']['input'];
  webhookUrl: Scalars['String']['input'];
};

export type SignupQuestionnaireResult = {
  __typename?: 'SignupQuestionnaireResult';
  result: Scalars['JSONObject']['output'];
  timestamp: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
};

export type SlackChannel = {
  __typename?: 'SlackChannel';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SlackNotificationInfo = {
  __typename?: 'SlackNotificationInfo';
  channelId: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  connectionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type SourceStream = {
  __typename?: 'SourceStream';
  additionalIncrementalPointerIds: Array<Scalars['String']['output']>;
  changeDataCaptureEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  dataFilters: Array<SourceStreamDataFilter>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  eltSync: EltSync;
  enabledHistoryTable?: Maybe<Scalars['Boolean']['output']>;
  excludedSubstreams?: Maybe<Array<Scalars['String']['output']>>;
  fullSyncAlways: Scalars['Boolean']['output'];
  /** @deprecated Superseded by `fullSyncSchedule`, where it is the cron `0 0 * * *`. */
  fullSyncAtMidnight?: Maybe<Scalars['Boolean']['output']>;
  fullSyncSchedule?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  incrementalPointerId?: Maybe<Scalars['String']['output']>;
  incrementalPrimaryKeyName?: Maybe<Array<Scalars['String']['output']>>;
  job?: Maybe<GetSourceStreamJobResponse>;
  name: Scalars['String']['output'];
  operationMode: OperationMode;
  prioritized: Scalars['Boolean']['output'];
  protectedFromFullSync: Scalars['Boolean']['output'];
  softDeleteEnabled?: Maybe<Scalars['Boolean']['output']>;
  substreams: Array<Substream>;
  syncInterval?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SourceStreamBackOffice = {
  __typename?: 'SourceStreamBackOffice';
  changeDataCaptureEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  eltSyncId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  job?: Maybe<GetSourceStreamJobResponse>;
  name: Scalars['String']['output'];
  operationMode: OperationMode;
  targetCloudProvider: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SourceStreamCdcState = {
  __typename?: 'SourceStreamCdcState';
  awaitingInitialSnapshot?: Maybe<Scalars['Boolean']['output']>;
  heartBeat?: Maybe<Scalars['Float']['output']>;
  incrementalSnapshotInProgress?: Maybe<Scalars['Boolean']['output']>;
  initialSnapshotTableNames?: Maybe<Array<Scalars['String']['output']>>;
  isFirstRun?: Maybe<Scalars['Boolean']['output']>;
  lastStartedAt?: Maybe<Scalars['String']['output']>;
  running?: Maybe<Scalars['Boolean']['output']>;
};

export type SourceStreamDataFilter = {
  __typename?: 'SourceStreamDataFilter';
  sourceStreamObjectKey: Scalars['String']['output'];
  transformation: Scalars['String']['output'];
};

export type SourceStreamInput = {
  additionalIncrementalPointerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  changeDataCaptureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledHistoryTable?: InputMaybe<Scalars['Boolean']['input']>;
  excludedColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  excludedSubstreams?: InputMaybe<Array<Scalars['String']['input']>>;
  fullSyncAlways?: InputMaybe<Scalars['Boolean']['input']>;
  fullSyncSchedule?: InputMaybe<Scalars['String']['input']>;
  hashedColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  incrementalPointerId?: InputMaybe<Scalars['String']['input']>;
  mode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  protectedFromFullSync?: InputMaybe<Scalars['Boolean']['input']>;
  softDeleteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  substreams: Array<SubstreamInput>;
};

export type SourceStreamJobRunActionsResponse = {
  __typename?: 'SourceStreamJobRunActionsResponse';
  availableActions: Array<RunAction>;
  errors: Array<RunValidationError>;
};

export type SourceStreamSnapshot = {
  __typename?: 'SourceStreamSnapshot';
  bytesSynced: Scalars['Float']['output'];
  details?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  estimatedTotalCount?: Maybe<Scalars['Float']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  fullSyncTrigger?: Maybe<FullSyncTrigger>;
  isChunk?: Maybe<Scalars['Boolean']['output']>;
  operationMode?: Maybe<OperationMode>;
  recordsSynced?: Maybe<Scalars['Float']['output']>;
  retryAttempt?: Maybe<Scalars['Float']['output']>;
  scheduledJobId?: Maybe<Scalars['String']['output']>;
  sourceStreamName?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SyncJobStatus>;
  substreamRecordsSynced?: Maybe<Scalars['Float']['output']>;
  substreamRecordsSyncedBySubstream?: Maybe<Array<SubstreamRecordsSynced>>;
  syncId?: Maybe<Scalars['String']['output']>;
};

export type SourceStreamSnapshotStates = {
  __typename?: 'SourceStreamSnapshotStates';
  activeSync?: Maybe<SourceStreamSnapshot>;
  latestSync?: Maybe<SourceStreamSnapshot>;
  name: Scalars['String']['output'];
  scheduledJobId: Scalars['String']['output'];
};

export type SourceStreamSyncStats = {
  __typename?: 'SourceStreamSyncStats';
  integrationId: Scalars['String']['output'];
  numBillableRows: Scalars['Float']['output'];
  numBillableRowsComplete: Scalars['Float']['output'];
  numRowsSynced: Scalars['Float']['output'];
  sourceStreamName: Scalars['String']['output'];
};

export type SourceStreamSyncStatsResponse = {
  __typename?: 'SourceStreamSyncStatsResponse';
  data: Array<SourceStreamSyncStats>;
  period: StatsPeriod;
};

export type SourceStreamSyncStatsSummary = {
  __typename?: 'SourceStreamSyncStatsSummary';
  activeRows: Scalars['Float']['output'];
  integrationId: Scalars['String']['output'];
  sourceStreamName: Scalars['String']['output'];
  syncedRows: Scalars['Float']['output'];
};

export type SourceStreamSyncStatsSummaryResponse = {
  __typename?: 'SourceStreamSyncStatsSummaryResponse';
  data: Array<SourceStreamSyncStatsSummary>;
  period: StatsPeriod;
};

/** Type of the source for the sync */
export enum SourceType {
  Model = 'Model',
  RawView = 'RawView'
}

export type SqlQuery = {
  __typename?: 'SqlQuery';
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  deletedAt: Scalars['DateTime']['output'];
  dependencies?: Maybe<Array<QueryDependencyEntity>>;
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
  weldSql: Scalars['String']['output'];
};

export type StaleMaterializationsSummary = {
  __typename?: 'StaleMaterializationsSummary';
  staleModels: Array<StaleModel>;
};

export type StaleModel = {
  __typename?: 'StaleModel';
  id: Scalars['ID']['output'];
  lastMaterialisedAt?: Maybe<Scalars['DateTime']['output']>;
  materializationType: MaterializationType;
  name: Scalars['String']['output'];
  sourcePath?: Maybe<Scalars['String']['output']>;
};

export type StartDateConfiguration = {
  __typename?: 'StartDateConfiguration';
  defaultLookbackDays?: Maybe<Scalars['Float']['output']>;
  maxLookbackDays?: Maybe<Scalars['Float']['output']>;
  maxLookbackDaysDescription?: Maybe<Scalars['String']['output']>;
};

export type StartEltSyncInput = {
  eltSyncId: Scalars['String']['input'];
};

export type StartSyncInput = {
  id: Scalars['String']['input'];
};

export type StatsPeriod = {
  __typename?: 'StatsPeriod';
  end: Scalars['DateTime']['output'];
  endInclusive?: Maybe<Scalars['Boolean']['output']>;
  start: Scalars['DateTime']['output'];
};

export type StoredErd = {
  __typename?: 'StoredErd';
  createdAt: Scalars['String']['output'];
  edges: Array<ErdEdge>;
  hideDiagram?: Maybe<Scalars['Boolean']['output']>;
  integrationId: Scalars['String']['output'];
  nodes: Array<ErdNode>;
  updatedAt: Scalars['String']['output'];
};

export type StoredErdEdgeInput = {
  id: Scalars['String']['input'];
  markerEnd?: InputMaybe<Scalars['JSONObject']['input']>;
  source: Scalars['String']['input'];
  style?: InputMaybe<Scalars['JSONObject']['input']>;
  target: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type StoredErdInput = {
  edges: Array<StoredErdEdgeInput>;
  hideDiagram?: InputMaybe<Scalars['Boolean']['input']>;
  integrationId: Scalars['String']['input'];
  nodes: Array<StoredErdNodeInput>;
};

export type StoredErdNodeInput = {
  data: NodeDataInput;
  height: Scalars['Float']['input'];
  id: Scalars['String']['input'];
  parentNode?: InputMaybe<Scalars['String']['input']>;
  position: NodePositionInput;
  type: Scalars['String']['input'];
  width: Scalars['Float']['input'];
};

export type Stream = {
  __typename?: 'Stream';
  configurableIncremental: Scalars['Boolean']['output'];
  defaultConfig: Scalars['JSONObject']['output'];
  enabledHistoryTable?: Maybe<Scalars['Boolean']['output']>;
  excludedSubstreams?: Maybe<Array<Scalars['String']['output']>>;
  historyStreams: Array<HistoryStream>;
  name: Scalars['String']['output'];
  notSelectableExplanation?: Maybe<Scalars['String']['output']>;
  preselect: Scalars['Boolean']['output'];
  primaryKeyNames: Array<Scalars['String']['output']>;
  retired: Scalars['Boolean']['output'];
  retirementDetails?: Maybe<RetirementDetails>;
  selectable: Scalars['Boolean']['output'];
  softDeleteEnabled?: Maybe<Scalars['Boolean']['output']>;
  softDeleteSupported?: Maybe<Scalars['Boolean']['output']>;
  substreams: Array<SubStream>;
  supportedModes: Array<OperationMode>;
  supportsMultipleIncrementalPointers: Scalars['Boolean']['output'];
};

export enum StripeChargeStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Succeeded = 'Succeeded'
}

export type StripePlanFeatures = {
  __typename?: 'StripePlanFeatures';
  isCustomPlan?: Maybe<Scalars['Boolean']['output']>;
  limitConnectors?: Maybe<Scalars['Int']['output']>;
  limitRows?: Maybe<Scalars['Int']['output']>;
  limitUsers?: Maybe<Scalars['Int']['output']>;
  marOverageExemptUntil?: Maybe<Scalars['DateTime']['output']>;
  minSyncIntervalInMinutes?: Maybe<Scalars['Int']['output']>;
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  stripeSubscriptionDetails: StripeSubscriptionDetails;
};

export type StripeSubscriptionDetails = {
  __typename?: 'StripeSubscriptionDetails';
  billingCycleAnchorDate: Scalars['DateTime']['output'];
  cancelDate?: Maybe<Scalars['DateTime']['output']>;
  createdDate: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  currentPeriodEndDate: Scalars['DateTime']['output'];
  currentPeriodStartDate: Scalars['DateTime']['output'];
  customerId: Scalars['ID']['output'];
  features: StripePlanFeatures;
  id: Scalars['ID']['output'];
  items: Array<StripeSubscriptionItem>;
  plan: SubscriptionPlan;
  planName: PlanName;
  status: StripeSubscriptionStatus;
  trialEndDate?: Maybe<Scalars['DateTime']['output']>;
};

export type StripeSubscriptionItem = {
  __typename?: 'StripeSubscriptionItem';
  currentPeriodEnd: Scalars['DateTime']['output'];
  currentPeriodStart: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  price: StripeSubscriptionItemPrice;
  quantity: Scalars['Int']['output'];
  tier?: Maybe<Tier>;
};

export type StripeSubscriptionItemPrice = {
  __typename?: 'StripeSubscriptionItemPrice';
  billingScheme: BillingScheme;
  currency: Scalars['String']['output'];
  currencyOptions: Array<CurrencyOption>;
  id: Scalars['String']['output'];
  lookupKey?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  product: BaseProduct;
  recurring?: Maybe<Recurring>;
  tiers?: Maybe<Array<Tier>>;
  tiersMode?: Maybe<TiersMode>;
  transformQuantity?: Maybe<TransformQuantity>;
};

export enum StripeSubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Incomplete = 'Incomplete',
  IncompleteExpired = 'IncompleteExpired',
  PastDue = 'PastDue',
  Paused = 'Paused',
  Trialing = 'Trialing',
  Unpaid = 'Unpaid'
}

export type SubStream = {
  __typename?: 'SubStream';
  avroSchema: Scalars['JSONObject']['output'];
  destinationTableName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  retired: Scalars['Boolean']['output'];
  retirementDetails?: Maybe<RetirementDetails>;
};

export type SubmitSurveyInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Int']['input'];
  surveyId: Scalars['String']['input'];
};

export type SubscriptionAdminResult = {
  __typename?: 'SubscriptionAdminResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  billingInterval: RecurrenceInterval;
  billingIntervalCount: Scalars['Float']['output'];
  features: StripePlanFeatures;
  name: PlanName;
};

export type SubscriptionState = {
  __typename?: 'SubscriptionState';
  customerId?: Maybe<Scalars['String']['output']>;
  status: SubscriptionStatus;
  subscriptionId?: Maybe<Scalars['String']['output']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Freemium = 'FREEMIUM'
}

export type Substream = {
  __typename?: 'Substream';
  excludedColumns: Array<Scalars['String']['output']>;
  hashedColumns: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type SubstreamInput = {
  excludedColumns: Array<Scalars['String']['input']>;
  hashedColumns: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type SubstreamRecordsSynced = {
  __typename?: 'SubstreamRecordsSynced';
  destinationTableName: Scalars['String']['output'];
  recordsSynced: Scalars['Float']['output'];
  substreamId: Scalars['String']['output'];
};

export type Survey = {
  __typename?: 'Survey';
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  accountId: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  score?: Maybe<Scalars['Int']['output']>;
  surveyId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type Sync = {
  __typename?: 'Sync';
  account?: Maybe<Account>;
  accountId: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  config?: Maybe<Config>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  destinationConnection: Connection;
  destinationConnectionId: Scalars['String']['output'];
  destinationIntegrationId: Scalars['String']['output'];
  errorCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  job?: Maybe<ReverseEtlJobResponse>;
  lastSync: Scalars['DateTime']['output'];
  mappings: Array<Mapping>;
  model?: Maybe<Model>;
  modelId?: Maybe<Scalars['String']['output']>;
  nextSync: Scalars['DateTime']['output'];
  operations: Array<Operation>;
  orchestrationWorkflow?: Maybe<OrchestrationWorkflow>;
  primaryObject: Scalars['String']['output'];
  primaryObjectId?: Maybe<Scalars['String']['output']>;
  rawView?: Maybe<RawViewReference>;
  schedulerType: OrchestrationSchedulerType;
  sourceConnection?: Maybe<Connection>;
  sourceConnectionId: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  sourceIntegrationId: Scalars['String']['output'];
  sourceType: SourceType;
  status: Scalars['String']['output'];
  syncInterval?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum SyncJobStatus {
  Completed = 'COMPLETED',
  Delayed = 'DELAYED',
  Failed = 'FAILED',
  Retrying = 'RETRYING',
  Running = 'RUNNING',
  Scheduled = 'SCHEDULED'
}

export type SyncJobsCompletionMetric = {
  __typename?: 'SyncJobsCompletionMetric';
  failureCount: Scalars['Float']['output'];
  failurePercent: Scalars['Float']['output'];
  successCount: Scalars['Float']['output'];
  successPercent: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type SyncJobsCompletionMetricResponse = {
  __typename?: 'SyncJobsCompletionMetricResponse';
  stats?: Maybe<SyncJobsCompletionMetric>;
};

export type SyncStats = {
  __typename?: 'SyncStats';
  numBillableRows: Scalars['Float']['output'];
  numBillableRowsComplete: Scalars['Float']['output'];
  numRowsSynced: Scalars['Float']['output'];
};

export type SyncStatsSummary = {
  __typename?: 'SyncStatsSummary';
  activeRows: Scalars['Float']['output'];
  activeRowsPercentage: Scalars['Float']['output'];
  syncedRows: Scalars['Float']['output'];
  syncedRowsPercentage: Scalars['Float']['output'];
};

export type SyncStatsTimelineEntry = {
  __typename?: 'SyncStatsTimelineEntry';
  activeRows: Scalars['Float']['output'];
  runningTotalActiveRows: Scalars['Float']['output'];
  runningTotalSyncedRows: Scalars['Float']['output'];
  syncedRows: Scalars['Float']['output'];
};

export type TableMetadata = {
  __typename?: 'TableMetadata';
  description?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Scalars['JSONObject']['output']>;
  schema?: Maybe<TableMetadataSchema>;
};

export type TableMetadataSchema = {
  __typename?: 'TableMetadataSchema';
  fields?: Maybe<Array<FieldMetadata>>;
};

export type TableMigrationResult = {
  __typename?: 'TableMigrationResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  tableId: Scalars['String']['output'];
};

export type TableReference = {
  __typename?: 'TableReference';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  dwSqlReference: Scalars['String']['output'];
  latestRunErrorMessage?: Maybe<Scalars['String']['output']>;
  latestSyncTime?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
  queryId: Scalars['String']['output'];
  tableMetadata?: Maybe<TableMetadata>;
  type: DependencyType;
  weldTag: Scalars['String']['output'];
};

/** JOB_HISTORY and ACCESS_HISTORY list the objects each query touched. QUERY_TEXT finds model names in the SQL text and is approximate. */
export enum TableUsageDetection {
  AccessHistory = 'ACCESS_HISTORY',
  JobHistory = 'JOB_HISTORY',
  QueryText = 'QUERY_TEXT'
}

export type TaxId = {
  __typename?: 'TaxId';
  country: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TaxIdData = {
  __typename?: 'TaxIdData';
  country: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /** The type of tax ID - matches Stripe.TaxId.Type */
  enum: Scalars['String']['output'];
  example: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export type TaxIdInput = {
  country: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type TeamsNotificationInfo = {
  __typename?: 'TeamsNotificationInfo';
  channelName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type Template = {
  __typename?: 'Template';
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  models?: Maybe<Array<Model>>;
  name: TemplatesEnum;
  templateEltSync: Array<TemplateEltSync>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TemplateConfig = {
  __typename?: 'TemplateConfig';
  integrations: Array<IntegrationTemplate>;
  metrics: Array<TemplateMetric>;
  useCase: TemplatesEnum;
};

export type TemplateEltSync = {
  __typename?: 'TemplateEltSync';
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  eltSync: EltSync;
  eltSyncId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  sourceIntegrationId: Scalars['String']['output'];
  template: Template;
  templateId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TemplateMetric = {
  __typename?: 'TemplateMetric';
  aiInsights: Array<Scalars['String']['output']>;
  columns?: Maybe<Array<MetricColumn>>;
  config: MetricConfig;
  description: Scalars['String']['output'];
  folder: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TemplateModel = {
  __typename?: 'TemplateModel';
  description: Scalars['String']['output'];
  folder: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  templateItemId: Scalars['String']['output'];
};

export type TemplateSourceStream = {
  __typename?: 'TemplateSourceStream';
  excludedColumns?: Maybe<Array<Scalars['String']['output']>>;
  fullSyncAlways: Scalars['Boolean']['output'];
  hashedColumns?: Maybe<Array<Scalars['String']['output']>>;
  incrementalPointerId: Scalars['String']['output'];
  mode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  primaryKeys?: Maybe<Array<Scalars['String']['output']>>;
  substreams: Array<TemplateSubstream>;
};

export type TemplateSubstream = {
  __typename?: 'TemplateSubstream';
  excludedColumns: Array<Scalars['String']['output']>;
  hashedColumns: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum TemplatesEnum {
  Marketing = 'MARKETING'
}

export enum TestStatus {
  ExecutionError = 'executionError',
  Failed = 'failed',
  Passed = 'passed',
  Running = 'running'
}

export enum TestType {
  NotNull = 'not_null',
  Uniqueness = 'uniqueness'
}

export type Tier = {
  __typename?: 'Tier';
  price?: Maybe<Scalars['Int']['output']>;
  unitAmount?: Maybe<Scalars['Int']['output']>;
  upTo?: Maybe<Scalars['Int']['output']>;
};

export enum TiersMode {
  Graduated = 'Graduated',
  Volume = 'Volume'
}

export type TotalUsageForecastResponse = {
  __typename?: 'TotalUsageForecastResponse';
  totalRows: Scalars['Float']['output'];
};

export type TransformChangedActivityPayload = {
  __typename?: 'TransformChangedActivityPayload';
  changedFields?: Maybe<Array<Scalars['String']['output']>>;
  folder?: Maybe<ActivityValueChange>;
  materializationType?: Maybe<ActivityValueChange>;
  name?: Maybe<ActivityValueChange>;
};

export type TransformDeletedActivityPayload = {
  __typename?: 'TransformDeletedActivityPayload';
  commitSha?: Maybe<Scalars['String']['output']>;
};

export type TransformPublishedActivityPayload = {
  __typename?: 'TransformPublishedActivityPayload';
  firstPublish: Scalars['Boolean']['output'];
  folderChanged: Scalars['Boolean']['output'];
  materializationChanged: Scalars['Boolean']['output'];
  nameChanged: Scalars['Boolean']['output'];
  previousPublishedQueryId?: Maybe<Scalars['String']['output']>;
  publishedQueryId: Scalars['String']['output'];
  queryChanged: Scalars['Boolean']['output'];
  scheduleChanged: Scalars['Boolean']['output'];
};

export type TransformQuantity = {
  __typename?: 'TransformQuantity';
  divideBy: Scalars['Int']['output'];
};

/** The tool used for data transformation */
export enum TransformTool {
  Dbt = 'Dbt',
  DbtCore = 'DbtCore',
  Github = 'Github',
  Other = 'Other',
  Weld = 'Weld'
}

export type UnusedModel = {
  __typename?: 'UnusedModel';
  /** Null when nothing read the model inside the history window. */
  lastReadAt?: Maybe<Scalars['DateTime']['output']>;
  modelId: Scalars['String']['output'];
  path: Scalars['String']['output'];
  readCount: Scalars['Int']['output'];
  /** Unused models that select from this one, which have to go before it. */
  unusedDependentIds: Array<Scalars['String']['output']>;
};

export type UpcomingInvoice = {
  __typename?: 'UpcomingInvoice';
  appliedPromo?: Maybe<AppliedPromo>;
  breakdown?: Maybe<Array<InvoiceBreakdownItem>>;
  createdDate: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  discounts: Array<DiscountItem>;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  subTotal: Scalars['Float']['output'];
  subscriptionStatus?: Maybe<StripeSubscriptionStatus>;
  taxes: Array<InvoiceTaxes>;
  total: Scalars['Float']['output'];
  trialEnd?: Maybe<Scalars['DateTime']['output']>;
};

export type UpdateAccessGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConnectionInput = {
  connectionId: Scalars['String']['input'];
  formId?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['String']['input'];
};

export type UpdateDraftModelNameInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateEltDestinationInput = {
  id: Scalars['String']['input'];
  /** Names the ELT Destination. Unique among the account's ELT Destinations. Left out, the label stays as it is. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The destination's settings, answering eltDestinationSettingsSchema of the connection's integration. A setting the schema gives a default may be left out and takes that default. Left out, the settings stay as they are. Refused while a sync loads into the destination, unless they are unchanged. */
  settings?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Whether ELT Syncs created without a list of additional destinations also load into this destination. Syncs that already exist are not changed. Refused when another destination on the same connection already is. Left out, it stays as it is. */
  useForNewSyncs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEltSyncInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  eltSyncId: Scalars['String']['input'];
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  schedulerType?: InputMaybe<OrchestrationSchedulerType>;
  sourceStreams?: InputMaybe<Array<SourceStreamInput>>;
  syncInterval?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFolderInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateModelDocumentationInput = {
  documentation: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type UpdateModelQueryInput = {
  id: Scalars['String']['input'];
  query: QueryInput;
};

export type UpdateModelTestInput = {
  column: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  testType: Scalars['String']['input'];
};

export type UpdatePublishedModelMaterializationInput = {
  clusteringColumns?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  materializationSchedule?: InputMaybe<Scalars['String']['input']>;
  materializationType: MaterializationType;
  orchestrationScheduler?: InputMaybe<OrchestrationSchedulerType>;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  partitionExpression?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSourceStreamInput = {
  prioritized?: InputMaybe<Scalars['Boolean']['input']>;
  protectedFromFullSync?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSourceStreamLastIncrementalPointerInput = {
  eltSyncId: Scalars['String']['input'];
  newLastIncrementalPointer?: InputMaybe<Scalars['JSON']['input']>;
  sourceStreamName: Scalars['String']['input'];
};

export type UpdateSourceStreamSyncIntervalInput = {
  eltSyncId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
  syncInterval?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSyncInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  operations: Array<CreateOperationInput>;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  schedulerType?: InputMaybe<OrchestrationSchedulerType>;
  syncId: Scalars['String']['input'];
  syncInterval?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  receiveEmails?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Role>;
};

export type UpdateWebhookInput = {
  data: Scalars['JSONObject']['input'];
  dependencies: Array<DependencyInput>;
  name: Scalars['String']['input'];
  webhookId: Scalars['String']['input'];
};

export type UpgradableLimits = {
  __typename?: 'UpgradableLimits';
  maxConnectors?: Maybe<Scalars['Float']['output']>;
  maxRows?: Maybe<Scalars['Float']['output']>;
  maxUsers?: Maybe<Scalars['Float']['output']>;
};

export type UpsertUserSignupInfoInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  companySize?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  receiveEmails?: InputMaybe<Scalars['Boolean']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  weldLandingPageLastPage?: InputMaybe<Scalars['String']['input']>;
  weldLandingPageReferrer?: InputMaybe<Scalars['String']['input']>;
};

export type UsageAgainstLimitDto = {
  __typename?: 'UsageAgainstLimitDto';
  /** Null when unlimited. */
  limit?: Maybe<Scalars['Int']['output']>;
  used: Scalars['Int']['output'];
};

export type UsageForecastResponse = {
  __typename?: 'UsageForecastResponse';
  data: Array<ForecastedDataPoint>;
};

export type UsageForecastResult = {
  __typename?: 'UsageForecastResult';
  predictions: Array<ForecastedDataPoint>;
  totalRows: Scalars['Float']['output'];
};

export type UsageRecordSummary = {
  __typename?: 'UsageRecordSummary';
  invoice?: Maybe<Scalars['String']['output']>;
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  totalUsage: Scalars['Int']['output'];
};

export type UseInvitationResponse = {
  __typename?: 'UseInvitationResponse';
  accountId: Scalars['String']['output'];
};

export type UsedModel = {
  __typename?: 'UsedModel';
  /** For DEPENDENT: the used model that selects from this one, which may itself be used through another. */
  dependentModelId?: Maybe<Scalars['String']['output']>;
  /** Null when nothing read the model inside the history window. */
  lastReadAt?: Maybe<Scalars['DateTime']['output']>;
  modelId: Scalars['String']['output'];
  path: Scalars['String']['output'];
  readCount: Scalars['Int']['output'];
  reason: ModelUsedReason;
};

export type User = {
  __typename?: 'User';
  accounts?: Maybe<Array<Account>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  emailValidated: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  /** Whether this member occupies one of the plan's seats. Weld support staff do not. */
  holdsSeat: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastLogin: Scalars['DateTime']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  receiveEmails: Scalars['Boolean']['output'];
  role: Scalars['String']['output'];
  scopes: Array<EditorScope>;
  socialLoginProvider?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userSignupInfo?: Maybe<UserSignupInfo>;
  userSignupInfoId?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
};

export type UserSignupInfo = {
  __typename?: 'UserSignupInfo';
  companyName?: Maybe<Scalars['String']['output']>;
  companySize?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmContent?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  utmTerm?: Maybe<Scalars['String']['output']>;
  weldLandingPageLastPage?: Maybe<Scalars['String']['output']>;
  weldLandingPageReferrer?: Maybe<Scalars['String']['output']>;
};

export type ValidatedPromoCode = {
  __typename?: 'ValidatedPromoCode';
  amountOff?: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  duration: PromoDuration;
  durationInMonths?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  percentOff?: Maybe<Scalars['Int']['output']>;
  promoId: Scalars['String']['output'];
};

export enum ValidationErrorCode {
  ConnectorLimitReached = 'ConnectorLimitReached',
  ConnectorNotFound = 'ConnectorNotFound',
  InsufficientPermission = 'InsufficientPermission',
  InsufficientPlan = 'InsufficientPlan'
}

export type ValidationErrorItem = {
  __typename?: 'ValidationErrorItem';
  errorCode?: Maybe<ValidationErrorCode>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type ValidationResult = {
  __typename?: 'ValidationResult';
  errors: Array<ValidationErrorItem>;
  valid: Scalars['Boolean']['output'];
};

export type VerifyUnpublishedChangesResponse = {
  __typename?: 'VerifyUnpublishedChangesResponse';
  hasUnpublishedChanges: Scalars['Boolean']['output'];
};

export type ViewDetails = {
  __typename?: 'ViewDetails';
  dataSchema: Array<DataSchema>;
};

export type ViewMigrationResult = {
  __typename?: 'ViewMigrationResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  viewId: Scalars['String']['output'];
};

export type Webhook = {
  __typename?: 'Webhook';
  account_id: Scalars['String']['output'];
  connection_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  dependencies: WebhookDependency;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  params: Scalars['JSONObject']['output'];
  type: ExternalSystem;
  updated_at: Scalars['DateTime']['output'];
};

export type WebhookActivityPayload = {
  __typename?: 'WebhookActivityPayload';
  changedFields?: Maybe<Array<Scalars['String']['output']>>;
  externalSystem: Scalars['String']['output'];
};

export type WebhookDataResponse = {
  __typename?: 'WebhookDataResponse';
  accountId: Scalars['String']['output'];
  data: Scalars['JSONObject']['output'];
  type: ExternalSystem;
};

export type WebhookDependency = {
  __typename?: 'WebhookDependency';
  account_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  item_id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  webhook: Webhook;
  webhook_id: Scalars['String']['output'];
};

export type WebhookDependencyResponse = {
  __typename?: 'WebhookDependencyResponse';
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type WebhookResponse = {
  __typename?: 'WebhookResponse';
  connectionId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dependencies: Array<WebhookDependencyResponse>;
  name: Scalars['String']['output'];
  orchestrationWorkflowId?: Maybe<Scalars['String']['output']>;
  params: Scalars['JSONObject']['output'];
  type: ExternalSystem;
  updatedAt: Scalars['DateTime']['output'];
  webhookId: Scalars['String']['output'];
};

export type WebhookRunResponse = {
  __typename?: 'WebhookRunResponse';
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalRunId?: Maybe<Scalars['String']['output']>;
  externalStatusCode?: Maybe<Scalars['Int']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  orchestrationWorkflowRunId?: Maybe<Scalars['String']['output']>;
  status: WebhookRunStatus;
  webhookId: Scalars['String']['output'];
};

export enum WebhookRunStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED',
  TimedOut = 'TIMED_OUT',
  Triggering = 'TRIGGERING'
}

export enum WeldAddOnType {
  MarExtra = 'MarExtra',
  MarOverage = 'MarOverage',
  SyncFrequency = 'SyncFrequency',
  Unknown = 'Unknown'
}

export type WeldPlan = {
  __typename?: 'WeldPlan';
  billingInterval?: Maybe<RecurrenceInterval>;
  billingIntervalCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use billingInterval instead */
  billingPeriod?: Maybe<RecurrenceInterval>;
  configurableLimits?: Maybe<ConfigurableLimits>;
  features: FeatureSet;
  isConsumptionPlan?: Maybe<Scalars['Boolean']['output']>;
  isEnterprisePlan?: Maybe<Scalars['Boolean']['output']>;
  isLegacyPlan?: Maybe<Scalars['Boolean']['output']>;
  name: PlanName;
  priceLookupKeys?: Maybe<PriceLookupKeyMap>;
  userPriceLookupKeys?: Maybe<PriceLookupKeyMap>;
};

export enum WeldProductType {
  AddOn = 'AddOn',
  MarIncluded = 'MarIncluded',
  MarOverage = 'MarOverage',
  Unknown = 'Unknown',
  UserPlan = 'UserPlan',
  WeldPlan = 'WeldPlan'
}

export type WorkflowJob = {
  __typename?: 'WorkflowJob';
  errorMessage?: Maybe<Scalars['String']['output']>;
  incomingDependencies: Array<Scalars['ID']['output']>;
  itemId: Scalars['ID']['output'];
  lastEventHandledAt?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  outgoingDependencies: Array<Scalars['ID']['output']>;
  status: WorkflowJobStatus;
  target?: Maybe<WorkflowJobTarget>;
};

export enum WorkflowJobStatus {
  Canceled = 'CANCELED',
  Done = 'DONE',
  Failed = 'FAILED',
  NotReady = 'NOT_READY',
  Ready = 'READY',
  Running = 'RUNNING'
}

export type WorkflowJobTarget = MaterializedTableReference | ModelViewReference | RawViewReference | SourceStream | Sync | Webhook;

export enum WorkflowRunFailureReason {
  FailedToStart = 'FAILED_TO_START',
  JobFailed = 'JOB_FAILED',
  KilledByStaleMonitor = 'KILLED_BY_STALE_MONITOR'
}

export enum WorkflowRunStatus {
  Canceled = 'CANCELED',
  Done = 'DONE',
  Failed = 'FAILED',
  NotStarted = 'NOT_STARTED',
  Running = 'RUNNING',
  Starting = 'STARTING'
}

export type WorkspaceStats = {
  __typename?: 'WorkspaceStats';
  numConnections: Scalars['Int']['output'];
  numUsers: Scalars['Int']['output'];
};

export type WorkspaceSyncStats = {
  __typename?: 'WorkspaceSyncStats';
  date: Scalars['DateTime']['output'];
  elt: SyncStats;
  numBillableRows: Scalars['Float']['output'];
  numBillableRowsComplete: Scalars['Float']['output'];
  numRowsSynced: Scalars['Float']['output'];
  reverseElt: SyncStats;
};

export type WorkspaceSyncStatsResponse = {
  __typename?: 'WorkspaceSyncStatsResponse';
  data: Array<WorkspaceSyncStats>;
  period: StatsPeriod;
};

export type WorkspaceSyncStatsSummary = {
  __typename?: 'WorkspaceSyncStatsSummary';
  activeRows: Scalars['Float']['output'];
  elt: SyncStatsSummary;
  reverseElt: SyncStatsSummary;
  syncedRows: Scalars['Float']['output'];
};

export type WorkspaceSyncStatsSummaryResponse = {
  __typename?: 'WorkspaceSyncStatsSummaryResponse';
  data: WorkspaceSyncStatsSummary;
  period: StatsPeriod;
};

export type WorkspaceSyncStatsTimelineResponse = {
  __typename?: 'WorkspaceSyncStatsTimelineResponse';
  data: Array<WorkspaceSyncTimelineEntry>;
  period: StatsPeriod;
};

export type WorkspaceSyncTimelineEntry = {
  __typename?: 'WorkspaceSyncTimelineEntry';
  activeRows: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  elt: SyncStatsTimelineEntry;
  reverseElt: SyncStatsTimelineEntry;
  runningTotalActiveRows: Scalars['Float']['output'];
  runningTotalSyncedRows: Scalars['Float']['output'];
  syncedRows: Scalars['Float']['output'];
};

export type AccessGroupFragment = { __typename?: 'AccessGroup', id: string, name: string, description?: string | null, createdAt: any, updatedAt: any, members: Array<{ __typename?: 'AccessGroupMember', id: string, userId?: string | null, apiKeyId?: string | null, createdAt: any }> };

export type AccessGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessGroupsQuery = { __typename?: 'Query', accessGroups: Array<{ __typename?: 'AccessGroup', id: string, name: string, description?: string | null, createdAt: any, updatedAt: any, members: Array<{ __typename?: 'AccessGroupMember', id: string, userId?: string | null, apiKeyId?: string | null, createdAt: any }> }> };

export type AccessGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AccessGroupQuery = { __typename?: 'Query', accessGroup: { __typename?: 'AccessGroup', id: string, name: string, description?: string | null, createdAt: any, updatedAt: any, members: Array<{ __typename?: 'AccessGroupMember', id: string, userId?: string | null, apiKeyId?: string | null, createdAt: any }> } };

export type CreateAccessGroupMutationVariables = Exact<{
  input: CreateAccessGroupInput;
}>;


export type CreateAccessGroupMutation = { __typename?: 'Mutation', createAccessGroup: { __typename?: 'AccessGroup', id: string, name: string, description?: string | null, createdAt: any, updatedAt: any, members: Array<{ __typename?: 'AccessGroupMember', id: string, userId?: string | null, apiKeyId?: string | null, createdAt: any }> } };

export type UpdateAccessGroupMutationVariables = Exact<{
  input: UpdateAccessGroupInput;
}>;


export type UpdateAccessGroupMutation = { __typename?: 'Mutation', updateAccessGroup: { __typename?: 'AccessGroup', id: string, name: string, description?: string | null, createdAt: any, updatedAt: any, members: Array<{ __typename?: 'AccessGroupMember', id: string, userId?: string | null, apiKeyId?: string | null, createdAt: any }> } };

export type DeleteAccessGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAccessGroupMutation = { __typename?: 'Mutation', deleteAccessGroup: boolean };

export type AddAccessGroupPrincipalsMutationVariables = Exact<{
  input: AccessGroupPrincipalsInput;
}>;


export type AddAccessGroupPrincipalsMutation = { __typename?: 'Mutation', addAccessGroupPrincipals: { __typename?: 'AccessGroup', id: string, name: string, description?: string | null, createdAt: any, updatedAt: any, members: Array<{ __typename?: 'AccessGroupMember', id: string, userId?: string | null, apiKeyId?: string | null, createdAt: any }> } };

export type RemoveAccessGroupPrincipalsMutationVariables = Exact<{
  input: AccessGroupPrincipalsInput;
}>;


export type RemoveAccessGroupPrincipalsMutation = { __typename?: 'Mutation', removeAccessGroupPrincipals: { __typename?: 'AccessGroup', id: string, name: string, description?: string | null, createdAt: any, updatedAt: any, members: Array<{ __typename?: 'AccessGroupMember', id: string, userId?: string | null, apiKeyId?: string | null, createdAt: any }> } };

export type SetTransformToolMutationVariables = Exact<{
  value: TransformTool;
}>;


export type SetTransformToolMutation = { __typename?: 'Mutation', setTransformTool: { __typename?: 'Account', id: string, accountSettings: { __typename?: 'AccountSettings', id: string, transformTool?: TransformTool | null } } };

export type SetAiMetadataOnlyMutationVariables = Exact<{
  value: Scalars['Boolean']['input'];
}>;


export type SetAiMetadataOnlyMutation = { __typename?: 'Mutation', setAiMetadataOnly: { __typename?: 'Account', id: string, accountSettings: { __typename?: 'AccountSettings', id: string, aiMetadataOnly: boolean } } };

export type DataWarehouseFragment = { __typename?: 'DataWarehouse', connectionId: string, title?: string | null, subTitle?: string | null, integrationId: string };

export type AccountSettingsFragment = { __typename?: 'AccountSettings', id: string, aiMetadataOnly: boolean, deactivateELTSyncs: boolean, deactivateReverseELTSyncs: boolean, maxBillableRows?: number | null, transformTool?: TransformTool | null };

export type SlackNotificationInfoFragment = { __typename?: 'SlackNotificationInfo', id: string, connectionId: string, channelId: string, channelName: string };

export type TeamsNotificationInfoFragment = { __typename?: 'TeamsNotificationInfo', id: string, channelName: string };

export type AccountFragment = { __typename?: 'Account', id: string, dataWarehouseConnectionId?: string | null, name?: string | null, slug: string, notificationEmails: Array<string>, createdAt: any, currentUserRole: Role, currentUserPermissions: Array<string>, trialEndsAt?: any | null, dataWarehouse?: { __typename?: 'DataWarehouse', connectionId: string, title?: string | null, subTitle?: string | null, integrationId: string } | null, accountSettings: { __typename?: 'AccountSettings', id: string, aiMetadataOnly: boolean, deactivateELTSyncs: boolean, deactivateReverseELTSyncs: boolean, maxBillableRows?: number | null, transformTool?: TransformTool | null }, slackNotificationInfo?: { __typename?: 'SlackNotificationInfo', id: string, connectionId: string, channelId: string, channelName: string } | null, teamsNotificationInfo?: { __typename?: 'TeamsNotificationInfo', id: string, channelName: string } | null };

export type CurrentUserWithAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserWithAccountsQuery = { __typename?: 'Query', current: { __typename?: 'CurrentUser', id: string, firstName?: string | null, lastName?: string | null, email: string, weldSuperAdmin?: boolean | null, accounts?: Array<{ __typename?: 'Account', id: string, dataWarehouseConnectionId?: string | null, name?: string | null, slug: string, notificationEmails: Array<string>, createdAt: any, currentUserRole: Role, currentUserPermissions: Array<string>, trialEndsAt?: any | null, dataWarehouse?: { __typename?: 'DataWarehouse', connectionId: string, title?: string | null, subTitle?: string | null, integrationId: string } | null, accountSettings: { __typename?: 'AccountSettings', id: string, aiMetadataOnly: boolean, deactivateELTSyncs: boolean, deactivateReverseELTSyncs: boolean, maxBillableRows?: number | null, transformTool?: TransformTool | null }, slackNotificationInfo?: { __typename?: 'SlackNotificationInfo', id: string, connectionId: string, channelId: string, channelName: string } | null, teamsNotificationInfo?: { __typename?: 'TeamsNotificationInfo', id: string, channelName: string } | null }> | null } };

export type UserSignupInfoQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UserSignupInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, userSignupInfo?: { __typename?: 'UserSignupInfo', jobTitle?: string | null, companyName?: string | null } | null } };

export type FirebaseTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type FirebaseTokenQuery = { __typename?: 'Query', firebaseToken: string };

export type UserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, updatedAt: any, createdAt: any, role: string } };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, updatedAt: any, createdAt: any, role: string, scopes: Array<EditorScope>, holdsSeat: boolean }> };

export type RemoveUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type RemoveUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'User', id: string } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string } };

export type UpdateUserAccountRoleMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  role: Role;
  scopes?: InputMaybe<Array<EditorScope> | EditorScope>;
}>;


export type UpdateUserAccountRoleMutation = { __typename?: 'Mutation', updateUserAccountRole: { __typename?: 'User', id: string, role: string, scopes: Array<EditorScope>, firstName?: string | null, lastName?: string | null } };

export type UpsertUserSignupInfoMutationVariables = Exact<{
  input: UpsertUserSignupInfoInput;
}>;


export type UpsertUserSignupInfoMutation = { __typename?: 'Mutation', upsertUserSignupInfo: { __typename?: 'UserSignupInfo', id: string, companyName?: string | null } };

export type InvitationsQueryVariables = Exact<{
  getUsed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InvitationsQuery = { __typename?: 'Query', invitations: Array<{ __typename?: 'Invitation', id: string, email: string, firstName: string, lastName: string, used: boolean, expiresAt: any, updatedAt: any, createdAt: any, role?: Role | null, scopes: Array<EditorScope>, holdsSeat: boolean }> };

export type OpenInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OpenInvitationsQuery = { __typename?: 'Query', openInvitations: Array<{ __typename?: 'Invitation', id: string, email: string, firstName: string, lastName: string, used: boolean, expiresAt: any, updatedAt: any, createdAt: any, role?: Role | null, account: { __typename?: 'Account', id: string, name?: string | null } }> };

export type SendInvitationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role: Role;
  scopes?: InputMaybe<Array<EditorScope> | EditorScope>;
}>;


export type SendInvitationMutation = { __typename?: 'Mutation', sendInvitation: { __typename?: 'Invitation', id: string } };

export type ResendOwnInvitationMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type ResendOwnInvitationMutation = { __typename?: 'Mutation', resendOwnInvitation: { __typename?: 'Invitation', id: string } };

export type AcceptInvitationMutationVariables = Exact<{
  invitationId: Scalars['String']['input'];
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', useInvitation: { __typename?: 'UseInvitationResponse', accountId: string } };

export type DeclineOwnInvitationMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type DeclineOwnInvitationMutation = { __typename?: 'Mutation', declineOwnInvitation: { __typename?: 'Invitation', id: string } };

export type RemoveInvitationMutationVariables = Exact<{
  invitationId: Scalars['String']['input'];
}>;


export type RemoveInvitationMutation = { __typename?: 'Mutation', deleteInvitation: { __typename?: 'Invitation', id: string } };

export type CreateAccountMutationVariables = Exact<{
  name: Scalars['String']['input'];
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount: { __typename?: 'Account', id: string, slug: string, name?: string | null } };

export type SetDatawarehouseMutationVariables = Exact<{
  createConnectionInput: CreateConnectionInput;
  dataWarehouseSchemas?: InputMaybe<DataWarehouseSchemasInput>;
}>;


export type SetDatawarehouseMutation = { __typename?: 'Mutation', setDatawarehouse: boolean };

export type GetDatawarehouseSetupStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDatawarehouseSetupStatusQuery = { __typename?: 'Query', getDatawarehouseSetupStatus: { __typename?: 'SetDataWarehouseResult', status: AsyncJobStatusEnum, error?: string | null } };

export type UpdateDefaultIdentifierCasingMutationVariables = Exact<{
  defaultIdentifierCasing?: InputMaybe<IdentifierCasing>;
}>;


export type UpdateDefaultIdentifierCasingMutation = { __typename?: 'Mutation', updateDefaultIdentifierCasing: { __typename?: 'DataWarehouseInfo', accountId: string, defaultIdentifierCasing?: IdentifierCasing | null } };

export type UpdateRawViewsDisabledMutationVariables = Exact<{
  rawViewsDisabled: Scalars['Boolean']['input'];
}>;


export type UpdateRawViewsDisabledMutation = { __typename?: 'Mutation', updateRawViewsDisabled: { __typename?: 'DataWarehouseInfo', accountId: string, rawViewsDisabled?: boolean | null } };

export type DataWarehouseSchemasQueryVariables = Exact<{ [key: string]: never; }>;


export type DataWarehouseSchemasQuery = { __typename?: 'Query', dataWarehouseSchemas?: { __typename?: 'DataWarehouseInfo', landing: string, raw: string, modelDatabase?: string | null, defaultIdentifierCasing?: IdentifierCasing | null, rawViewsDisabled?: boolean | null } | null };

export type DeleteAccountMutationVariables = Exact<{
  input: DeleteAccountInput;
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: { __typename?: 'Account', id: string } };

export type CreateWorkspaceWithManagedDatawarehouseMutationVariables = Exact<{
  workspaceName: Scalars['String']['input'];
  dataWarehouseLocation: Scalars['String']['input'];
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateWorkspaceWithManagedDatawarehouseMutation = { __typename?: 'Mutation', createWorkspaceWithManagedDatawarehouse: { __typename?: 'Account', id: string, slug: string, name?: string | null } };

export type StartSelfOnboardingProcessMutationVariables = Exact<{
  location: Scalars['String']['input'];
}>;


export type StartSelfOnboardingProcessMutation = { __typename?: 'Mutation', startSelfOnboardingProcess: boolean };

export type GetSelfOnboardingProcessStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSelfOnboardingProcessStatusQuery = { __typename?: 'Query', getSelfOnboardingProcessStatus: { __typename?: 'SelfOnboardingStatus', status: AsyncJobStatusEnum, error?: string | null } };

export type AddNotificationEmailMutationVariables = Exact<{
  notificationEmail: Scalars['String']['input'];
}>;


export type AddNotificationEmailMutation = { __typename?: 'Mutation', addNotificationEmail: { __typename?: 'Account', id: string } };

export type RemoveNotificationEmailMutationVariables = Exact<{
  notificationEmail: Scalars['String']['input'];
}>;


export type RemoveNotificationEmailMutation = { __typename?: 'Mutation', removeNotificationEmail: { __typename?: 'Account', id: string } };

export type SessionStartedMutationVariables = Exact<{ [key: string]: never; }>;


export type SessionStartedMutation = { __typename?: 'Mutation', sessionStarted: boolean };

export type SeedDataWarehouseMutationVariables = Exact<{ [key: string]: never; }>;


export type SeedDataWarehouseMutation = { __typename?: 'Mutation', seedDataWarehouse: { __typename?: 'SeedDatawarehouseResponse', models: Array<{ __typename?: 'SeededModel', id: string, name: string }> } };

export type GetSlackChannelsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type GetSlackChannelsQuery = { __typename?: 'Query', getSlackChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string }> };

export type SetupSlackNotificationsMutationVariables = Exact<{
  connectionId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  channelName: Scalars['String']['input'];
}>;


export type SetupSlackNotificationsMutation = { __typename?: 'Mutation', setupSlackNotifications: { __typename?: 'Account', id: string, slackNotificationInfo?: { __typename?: 'SlackNotificationInfo', id: string, connectionId: string, channelId: string, channelName: string } | null } };

export type DisconnectSlackNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectSlackNotificationsMutation = { __typename?: 'Mutation', disconnectSlackNotifications: { __typename?: 'Account', id: string } };

export type SetupTeamsNotificationsMutationVariables = Exact<{
  webhookUrl: Scalars['String']['input'];
  channelName: Scalars['String']['input'];
}>;


export type SetupTeamsNotificationsMutation = { __typename?: 'Mutation', setupTeamsNotifications: { __typename?: 'Account', id: string, teamsNotificationInfo?: { __typename?: 'TeamsNotificationInfo', id: string, channelName: string } | null } };

export type DisconnectTeamsNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectTeamsNotificationsMutation = { __typename?: 'Mutation', disconnectTeamsNotifications: { __typename?: 'Account', id: string } };

export type GetMfaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMfaQuery = { __typename?: 'Query', getMFA: { __typename?: 'MFAInfoResult', hasMFA: boolean, mfaMethods: Array<{ __typename?: 'MFAMetod', id: string, type: string }> } };

export type SetMfaMutationVariables = Exact<{
  mfa: Scalars['Boolean']['input'];
}>;


export type SetMfaMutation = { __typename?: 'Mutation', setMFA: boolean };

export type ApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiKeysQuery = { __typename?: 'Query', apiKeys: Array<{ __typename?: 'ApiKeyResponse', id: string, name: string, createdAt: any }> };

export type ApiSecretKeyQueryVariables = Exact<{
  apiKeyId: Scalars['String']['input'];
}>;


export type ApiSecretKeyQuery = { __typename?: 'Query', apiSecretKey: string };

export type CreateApiKeyMutationVariables = Exact<{
  input: CreateApiKeyInput;
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiKey: { __typename?: 'ApiKeyResponse', id: string, name: string, createdAt: any } };

export type DeleteApiKeyMutationVariables = Exact<{
  apiKeyId: Scalars['String']['input'];
}>;


export type DeleteApiKeyMutation = { __typename?: 'Mutation', deleteApiKey?: boolean | null };

export type ResendVerificationEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendVerificationEmail: boolean };

export type ActivityPersonActorFieldsFragment = { __typename?: 'ActivityPersonActor', userId: string, firstName?: string | null, lastName?: string | null, email?: string | null };

export type ActivityValueChangeFieldsFragment = { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null };

export type ActivityEventFieldsFragment = { __typename?: 'ActivityEvent', id: string, occurredAt: any, type: ActivityEventType, batchId?: string | null, resource: { __typename?: 'ActivityResource', type: ActivityResourceType, id: string, name: string, exists: boolean }, actor: { __typename?: 'ActivityApiKeyActor', kind: ActivityActorKind, apiKeyId?: string | null, name?: string | null } | { __typename?: 'ActivityGithubSyncActor', kind: ActivityActorKind, syncId?: string | null, commitSha?: string | null, fileCommit?: { __typename?: 'GithubFileCommit', sha: string, committedAt?: string | null, message?: string | null, commitCount?: number | null, author: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }, authors?: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> | null } | null, triggeredBy?: { __typename?: 'ActivityPersonActor', userId: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null } | { __typename?: 'ActivityPersonActor', kind: ActivityActorKind, userId: string, firstName?: string | null, lastName?: string | null, email?: string | null } | { __typename?: 'ActivityWeldSupportActor', kind: ActivityActorKind }, payload: { __typename?: 'ConnectionActivityPayload', integrationId: string } | { __typename?: 'EltStreamActivityPayload', changedFields?: Array<string> | null, eltSyncId: string, eltSyncName: string, sourceIntegrationId: string, fullSyncRequest?: string | null, operationMode?: string | null, operationModeChange?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null, interval?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null } | { __typename?: 'EltSyncActivityPayload', changedFields?: Array<string> | null, sourceIntegrationId: string, destinationIntegrationId: string, reload?: string | null, streamCount: number, streamNames?: Array<string> | null, destination?: { __typename?: 'EltSyncDestinationActivityRef', connectionLabel: string, integrationId: string } | null, interval?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null, orchestrationWorkflowId?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null } | { __typename?: 'FolderActivityPayload', parentFolderId?: string | null, name?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null } | { __typename?: 'ModelTestActivityPayload', column: string, testType: string, testedModelId: string, testedModelName: string } | { __typename?: 'OrchestrationActivityPayload', changedFields?: Array<string> | null, cronExpression: string, cronExpressionChange?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null } | { __typename?: 'ReverseEtlSyncActivityPayload', changedFields?: Array<string> | null, sourceIntegrationId: string, destinationIntegrationId: string, primaryObject: string, modelId?: string | null, interval?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null, orchestrationWorkflowId?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null } | { __typename?: 'TransformChangedActivityPayload', changedFields?: Array<string> | null, folder?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null, materializationType?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null, name?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null } | { __typename?: 'TransformDeletedActivityPayload', commitSha?: string | null } | { __typename?: 'TransformPublishedActivityPayload', firstPublish: boolean, queryChanged: boolean, materializationChanged: boolean, scheduleChanged: boolean, folderChanged: boolean, nameChanged: boolean, publishedQueryId: string, previousPublishedQueryId?: string | null } | { __typename?: 'WebhookActivityPayload', changedFields?: Array<string> | null, externalSystem: string } };

export type ActivityEventsQueryVariables = Exact<{
  filter?: InputMaybe<ActivityFilterInput>;
  page?: InputMaybe<ActivityPageInput>;
}>;


export type ActivityEventsQuery = { __typename?: 'Query', activityEvents: { __typename?: 'PaginatedActivityEvents', nextCursor?: string | null, hasMore: boolean, items: Array<{ __typename?: 'ActivityEvent', id: string, occurredAt: any, type: ActivityEventType, batchId?: string | null, resource: { __typename?: 'ActivityResource', type: ActivityResourceType, id: string, name: string, exists: boolean }, actor: { __typename?: 'ActivityApiKeyActor', kind: ActivityActorKind, apiKeyId?: string | null, name?: string | null } | { __typename?: 'ActivityGithubSyncActor', kind: ActivityActorKind, syncId?: string | null, commitSha?: string | null, fileCommit?: { __typename?: 'GithubFileCommit', sha: string, committedAt?: string | null, message?: string | null, commitCount?: number | null, author: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }, authors?: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> | null } | null, triggeredBy?: { __typename?: 'ActivityPersonActor', userId: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null } | { __typename?: 'ActivityPersonActor', kind: ActivityActorKind, userId: string, firstName?: string | null, lastName?: string | null, email?: string | null } | { __typename?: 'ActivityWeldSupportActor', kind: ActivityActorKind }, payload: { __typename?: 'ConnectionActivityPayload', integrationId: string } | { __typename?: 'EltStreamActivityPayload', changedFields?: Array<string> | null, eltSyncId: string, eltSyncName: string, sourceIntegrationId: string, fullSyncRequest?: string | null, operationMode?: string | null, operationModeChange?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null, interval?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null } | { __typename?: 'EltSyncActivityPayload', changedFields?: Array<string> | null, sourceIntegrationId: string, destinationIntegrationId: string, reload?: string | null, streamCount: number, streamNames?: Array<string> | null, destination?: { __typename?: 'EltSyncDestinationActivityRef', connectionLabel: string, integrationId: string } | null, interval?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null, orchestrationWorkflowId?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null } | { __typename?: 'FolderActivityPayload', parentFolderId?: string | null, name?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null } | { __typename?: 'ModelTestActivityPayload', column: string, testType: string, testedModelId: string, testedModelName: string } | { __typename?: 'OrchestrationActivityPayload', changedFields?: Array<string> | null, cronExpression: string, cronExpressionChange?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null } | { __typename?: 'ReverseEtlSyncActivityPayload', changedFields?: Array<string> | null, sourceIntegrationId: string, destinationIntegrationId: string, primaryObject: string, modelId?: string | null, interval?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null, orchestrationWorkflowId?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null } | { __typename?: 'TransformChangedActivityPayload', changedFields?: Array<string> | null, folder?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null, materializationType?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null, name?: { __typename?: 'ActivityValueChange', before?: string | null, after?: string | null } | null } | { __typename?: 'TransformDeletedActivityPayload', commitSha?: string | null } | { __typename?: 'TransformPublishedActivityPayload', firstPublish: boolean, queryChanged: boolean, materializationChanged: boolean, scheduleChanged: boolean, folderChanged: boolean, nameChanged: boolean, publishedQueryId: string, previousPublishedQueryId?: string | null } | { __typename?: 'WebhookActivityPayload', changedFields?: Array<string> | null, externalSystem: string } }> } };

export type ActivityFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivityFilterOptionsQuery = { __typename?: 'Query', activityFilterOptions: { __typename?: 'ActivityFilterOptions', types: Array<ActivityEventType>, actorKinds: Array<ActivityActorKind>, people: Array<{ __typename?: 'ActivityPersonActor', userId: string, firstName?: string | null, lastName?: string | null, email?: string | null }> } };

export type ActivityNewCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivityNewCountQuery = { __typename?: 'Query', activityNewCount: number };

export type MarkActivityLookedMutationVariables = Exact<{
  upTo?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type MarkActivityLookedMutation = { __typename?: 'Mutation', markActivityLooked?: any | null };

export type AgentThreadsQueryVariables = Exact<{
  surface: AgentSurface;
}>;


export type AgentThreadsQuery = { __typename?: 'Query', agentThreads: Array<{ __typename?: 'AgentThreadDto', id: string, title: string, modelId?: string | null, draftId?: string | null, createdAt: any, updatedAt: any }> };

export type AgentThreadMessagesQueryVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type AgentThreadMessagesQuery = { __typename?: 'Query', agentThreadMessages: Array<{ __typename?: 'AgentMessageDto', id: string, role: AgentMessageRole, parts: any, metadata?: any | null, createdAt: any }> };

export type DeleteAgentThreadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type DeleteAgentThreadMutation = { __typename?: 'Mutation', deleteAgentThread: boolean };

export type NotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: string, accountId: string, accountName: string, type: NotificationType, source: NotificationSources, detail: any, createdAt: any, updatedAt: any, deletedAt?: any | null, entityType: NotificationEntityType, entityId: string, entityName?: string | null, message: string, notificationLevel: NotificationLevel, lastOccurence: any, isDismissable: boolean, isLock: boolean, expiration?: any | null, messageData?: any | null }> };

export type RemoveNotificationMutationVariables = Exact<{
  input: RemoveNotificationInput;
}>;


export type RemoveNotificationMutation = { __typename?: 'Mutation', removeNotification: { __typename?: 'Notification', id: string } };

export type DismissAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type DismissAllNotificationsMutation = { __typename?: 'Mutation', dismissAllNotifications: boolean };

export type FindAllAvailableAuditLogsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllAvailableAuditLogsQuery = { __typename?: 'Query', findAllAvailableAuditLogs: { __typename?: 'FindAllAvailableAuditLogsResponse', logs: Array<{ __typename?: 'AvailableAuditLog', date: string, count: number, type: AuditLogType }> } };

export type ConnectionBaseFragment = { __typename?: 'Connection', id: string, integrationId: string, label: string, active: boolean, createdAt: any, updatedAt: any, connectedAt: any, formId?: string | null };

export type ConnectionWithSyncsFragment = { __typename?: 'Connection', eltSyncs: Array<{ __typename?: 'EltSync', id: string, createdAt: any, status: string, destinationSchemaName?: string | null, destinationConnection?: { __typename?: 'Connection', integrationId: string } | null }>, reverseEltSyncs: Array<{ __typename?: 'Sync', id: string, createdAt: any, status: string, primaryObject: string, primaryObjectId?: string | null, destinationConnection: { __typename?: 'Connection', integrationId: string } }> };

export type ConnectionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ConnectionQuery = { __typename?: 'Query', connection: { __typename?: 'Connection', id: string, integrationId: string, label: string, active: boolean, createdAt: any, updatedAt: any, connectedAt: any, formId?: string | null, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, email: string } | null, eltSyncs: Array<{ __typename?: 'EltSync', id: string, createdAt: any, status: string, destinationSchemaName?: string | null, destinationConnection?: { __typename?: 'Connection', integrationId: string } | null }>, reverseEltSyncs: Array<{ __typename?: 'Sync', id: string, createdAt: any, status: string, primaryObject: string, primaryObjectId?: string | null, destinationConnection: { __typename?: 'Connection', integrationId: string } }> } };

export type ConnectionWithCredentialsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ConnectionWithCredentialsQuery = { __typename?: 'Query', connection: { __typename?: 'Connection', connectedExternally: boolean, source: ConnectionSource, credentials: any, id: string, integrationId: string, label: string, active: boolean, createdAt: any, updatedAt: any, connectedAt: any, formId?: string | null, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, email: string } | null, apiKey?: { __typename?: 'ApiKeyEntity', name: string } | null, eltSyncs: Array<{ __typename?: 'EltSync', id: string, createdAt: any, status: string, destinationSchemaName?: string | null, destinationConnection?: { __typename?: 'Connection', integrationId: string } | null }>, reverseEltSyncs: Array<{ __typename?: 'Sync', id: string, createdAt: any, status: string, primaryObject: string, primaryObjectId?: string | null, destinationConnection: { __typename?: 'Connection', integrationId: string } }> } };

export type ConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectionsQuery = { __typename?: 'Query', connections: Array<{ __typename?: 'Connection', id: string, integrationId: string, label: string, active: boolean, createdAt: any, updatedAt: any, connectedAt: any, formId?: string | null }> };

export type ConnectionsWithUsageSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectionsWithUsageSummaryQuery = { __typename?: 'Query', connectors: Array<{ __typename?: 'Connection', id: string, integrationId: string, label: string, active: boolean, createdAt: any, updatedAt: any, connectedAt: any, formId?: string | null, usageSummary: { __typename?: 'ConnectionUsageSummary', numEltSyncs: number, numRevEltSyncs: number, totalSyncs: number } }> };

export type EltConnectionSettingsQueryVariables = Exact<{
  input: GetSettingsInput;
}>;


export type EltConnectionSettingsQuery = { __typename?: 'Query', getEltSettings: { __typename?: 'IntegrationSettings', connectionSettings?: any | null } };

export type ActivateConnectionSettingsQueryVariables = Exact<{
  input: GetSettingsInput;
}>;


export type ActivateConnectionSettingsQuery = { __typename?: 'Query', getActivateSettings: { __typename?: 'IntegrationSettings', connectionSettings?: any | null } };

export type ObjectTypeSettingsQueryVariables = Exact<{
  objectType: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  formValues?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type ObjectTypeSettingsQuery = { __typename?: 'Query', getObjectTypeSettings: { __typename?: 'DestinationObjectTypeSettings', settings?: any | null } };

export type RemoveConnectionMutationVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type RemoveConnectionMutation = { __typename?: 'Mutation', removeConnection: { __typename?: 'Connection', id: string } };

export type RefreshDestinationMutationVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type RefreshDestinationMutation = { __typename?: 'Mutation', refreshDestination: { __typename?: 'Connection', id: string } };

export type CreateConnectionMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
  payload: Scalars['String']['input'];
  label: Scalars['String']['input'];
  formId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateConnectionMutation = { __typename?: 'Mutation', createConnection: { __typename?: 'Connection', id: string, integrationId: string, label: string, active: boolean, createdAt: any, updatedAt: any, connectedAt: any, formId?: string | null } };

export type ConnectionBridgeBaseFragment = { __typename?: 'ConnectionBridgeResponse', id: string, integrationId: string, authorizeUrl: string, createdAt: string, expiresAt: string, label: string, connectionId?: string | null };

export type CreateConnectionBridgeMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
  connectionId?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
}>;


export type CreateConnectionBridgeMutation = { __typename?: 'Mutation', createConnectionBridge: { __typename?: 'ConnectionBridgeResponse', id: string, integrationId: string, authorizeUrl: string, createdAt: string, expiresAt: string, label: string, connectionId?: string | null } };

export type GetConnectionBridgesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConnectionBridgesQuery = { __typename?: 'Query', connectionBridges: Array<{ __typename?: 'ConnectionBridgeResponse', id: string, integrationId: string, authorizeUrl: string, createdAt: string, expiresAt: string, label: string, connectionId?: string | null }> };

export type DeleteConnectionBridgeMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteConnectionBridgeMutation = { __typename?: 'Mutation', deleteConnectionBridge: boolean };

export type GetOAuthUrlQueryVariables = Exact<{
  integrationId: Scalars['String']['input'];
  payload: Scalars['String']['input'];
  connectionId?: InputMaybe<Scalars['String']['input']>;
  formId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOAuthUrlQuery = { __typename?: 'Query', getOAuthURL: string };

export type UpdateConnectionMutationVariables = Exact<{
  connectionId: Scalars['String']['input'];
  payload: Scalars['String']['input'];
  formId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateConnectionMutation = { __typename?: 'Mutation', updateConnection: { __typename?: 'Connection', id: string, label: string, integrationId: string } };

export type CreateExampleConnectionMutationVariables = Exact<{
  input: CreateExampleConnectionInput;
}>;


export type CreateExampleConnectionMutation = { __typename?: 'Mutation', createExampleConnection: { __typename?: 'Connection', id: string, label: string, integrationId: string } };

export type PreviewTableDataQueryVariables = Exact<{
  dependency: QueryDependencyInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PreviewTableDataQuery = { __typename?: 'Query', previewTableData: { __typename?: 'PreviewTableDataResponse', response: Array<any>, dwSql: string, weldSql: string } };

export type BuildPreviewSqlQueryVariables = Exact<{
  weldTag: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BuildPreviewSqlQuery = { __typename?: 'Query', buildPreviewSql: { __typename?: 'BuildPreviewSqlResponse', weldSql: string } };

export type CreateAsyncQueryPreviewMutationVariables = Exact<{
  weldSql: Scalars['String']['input'];
  dependencies: Array<QueryDependencyInput> | QueryDependencyInput;
}>;


export type CreateAsyncQueryPreviewMutation = { __typename?: 'Mutation', createAsyncQueryPreview: { __typename?: 'CreateAsyncQueryPreviewResponse', queryExecutionId: string, dwSql: string } };

export type AsyncQueryPreviewResultQueryVariables = Exact<{
  queryExecutionId: Scalars['ID']['input'];
}>;


export type AsyncQueryPreviewResultQuery = { __typename?: 'Query', asyncQueryPreviewResult?: { __typename?: 'AsyncQueryResultResponse', rows: Array<any>, numRowsTotal: number } | null };

export type ValidateQueryQueryVariables = Exact<{
  weldSql: Scalars['String']['input'];
  dependencies: Array<QueryDependencyInput> | QueryDependencyInput;
}>;


export type ValidateQueryQuery = { __typename?: 'Query', validateQuery: { __typename?: 'QueryValidationResponse', error?: string | null, line?: number | null } };

export type AsyncQueryStatusQueryVariables = Exact<{
  queryExecutionId: Scalars['ID']['input'];
}>;


export type AsyncQueryStatusQuery = { __typename?: 'Query', asyncQueryStatus?: { __typename?: 'AsyncQueryStatusResponse', status: QueryResultStatusEnum } | null };

export type SchemasQueryVariables = Exact<{
  sourceStreamNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  sourceConnectionId: Scalars['String']['input'];
  connectionSettings: Scalars['JSONObject']['input'];
}>;


export type SchemasQuery = { __typename?: 'Query', getAllAvroSchemas: { __typename?: 'GetAllAvroSchemasResponse', schemas: Array<{ __typename?: 'SchemaDto', sourceStreamName: string, primaryKeys?: Array<string> | null, cursor?: string | null, fields: Array<{ __typename?: 'AvroSchemaFieldDto', name: string, type: Array<string>, nullable: boolean }> }> } };

export type RawViewFragment = { __typename?: 'RawViewReference', viewId: string, integrationId?: string | null, weldTag: string, path: Array<string>, createdAt: string, latestSyncTime: string, schema: string, sourceStream: string, syncId?: string | null, scheduledJobId?: string | null, firstSyncCompleted: boolean, retired: boolean, retirementDetails?: { __typename?: 'RetirementDetails', inFavorOf?: string | null, removalDate?: string | null, details?: string | null, link?: string | null } | null };

export type RawViewQueryVariables = Exact<{
  viewId: Scalars['String']['input'];
}>;


export type RawViewQuery = { __typename?: 'Query', rawView?: { __typename?: 'RawViewReference', viewId: string, integrationId?: string | null, weldTag: string, path: Array<string>, createdAt: string, latestSyncTime: string, schema: string, sourceStream: string, syncId?: string | null, scheduledJobId?: string | null, firstSyncCompleted: boolean, retired: boolean, retirementDetails?: { __typename?: 'RetirementDetails', inFavorOf?: string | null, removalDate?: string | null, details?: string | null, link?: string | null } | null } | null };

export type GetRawViewsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRawViewsQuery = { __typename?: 'Query', getRawViews: Array<{ __typename?: 'RawViewReference', viewId: string, integrationId?: string | null, weldTag: string, path: Array<string>, createdAt: string, latestSyncTime: string, schema: string, sourceStream: string, syncId?: string | null, scheduledJobId?: string | null, firstSyncCompleted: boolean, retired: boolean, retirementDetails?: { __typename?: 'RetirementDetails', inFavorOf?: string | null, removalDate?: string | null, details?: string | null, link?: string | null } | null }> };

export type ViewDetailsByPathQueryVariables = Exact<{
  path: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ViewDetailsByPathQuery = { __typename?: 'Query', viewDetailsByPath: { __typename?: 'ViewDetails', dataSchema: Array<{ __typename?: 'DataSchema', name: string, type: string, nullable: boolean }> } };

export type RawViewDetailsQueryVariables = Exact<{
  viewId: Scalars['String']['input'];
}>;


export type RawViewDetailsQuery = { __typename?: 'Query', rawViewDetails: { __typename?: 'ViewDetails', dataSchema: Array<{ __typename?: 'DataSchema', name: string, type: string, nullable: boolean }> } };

export type StreamWithSubstreamsFragment = { __typename?: 'Stream', name: string, supportedModes: Array<OperationMode>, configurableIncremental: boolean, supportsMultipleIncrementalPointers: boolean, defaultConfig: any, selectable: boolean, notSelectableExplanation?: string | null, preselect: boolean, primaryKeyNames: Array<string>, excludedSubstreams?: Array<string> | null, enabledHistoryTable?: boolean | null, softDeleteSupported?: boolean | null, softDeleteEnabled?: boolean | null, retired: boolean, historyStreams: Array<{ __typename?: 'HistoryStream', id: string, substreamId?: string | null, destinationTableName: string }>, substreams: Array<{ __typename?: 'SubStream', id: string, destinationTableName: string, avroSchema: any, retired: boolean, retirementDetails?: { __typename?: 'RetirementDetails', inFavorOf?: string | null, removalDate?: string | null, details?: string | null, link?: string | null } | null }>, retirementDetails?: { __typename?: 'RetirementDetails', inFavorOf?: string | null, removalDate?: string | null, details?: string | null, link?: string | null } | null };

export type GetStreamsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
  sourceSettings: Scalars['JSONObject']['input'];
  eltSyncId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStreamsQuery = { __typename?: 'Query', getStreams: Array<{ __typename?: 'Stream', name: string, supportedModes: Array<OperationMode>, configurableIncremental: boolean, supportsMultipleIncrementalPointers: boolean, defaultConfig: any, selectable: boolean, notSelectableExplanation?: string | null, preselect: boolean, primaryKeyNames: Array<string>, excludedSubstreams?: Array<string> | null, enabledHistoryTable?: boolean | null, softDeleteSupported?: boolean | null, softDeleteEnabled?: boolean | null, retired: boolean, historyStreams: Array<{ __typename?: 'HistoryStream', id: string, substreamId?: string | null, destinationTableName: string }>, substreams: Array<{ __typename?: 'SubStream', id: string, destinationTableName: string, avroSchema: any, retired: boolean, retirementDetails?: { __typename?: 'RetirementDetails', inFavorOf?: string | null, removalDate?: string | null, details?: string | null, link?: string | null } | null }>, retirementDetails?: { __typename?: 'RetirementDetails', inFavorOf?: string | null, removalDate?: string | null, details?: string | null, link?: string | null } | null }> };

export type GetStreamsAsyncQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
  sourceSettings: Scalars['JSONObject']['input'];
}>;


export type GetStreamsAsyncQuery = { __typename?: 'Query', getStreamsAsync: { __typename?: 'AsyncStreamsStatus', errorMessage?: string | null, status: AsyncJobStatusEnum, startedAt?: number | null, streams?: Array<{ __typename?: 'Stream', name: string, supportedModes: Array<OperationMode>, configurableIncremental: boolean, supportsMultipleIncrementalPointers: boolean, defaultConfig: any, selectable: boolean, notSelectableExplanation?: string | null, preselect: boolean, primaryKeyNames: Array<string>, excludedSubstreams?: Array<string> | null, enabledHistoryTable?: boolean | null, softDeleteSupported?: boolean | null, softDeleteEnabled?: boolean | null, retired: boolean, historyStreams: Array<{ __typename?: 'HistoryStream', id: string, substreamId?: string | null, destinationTableName: string }>, substreams: Array<{ __typename?: 'SubStream', id: string, destinationTableName: string, avroSchema: any, retired: boolean, retirementDetails?: { __typename?: 'RetirementDetails', inFavorOf?: string | null, removalDate?: string | null, details?: string | null, link?: string | null } | null }>, retirementDetails?: { __typename?: 'RetirementDetails', inFavorOf?: string | null, removalDate?: string | null, details?: string | null, link?: string | null } | null }> | null } };

export type CancelStreamsAsyncJobMutationVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type CancelStreamsAsyncJobMutation = { __typename?: 'Mutation', cancelStreamsAsyncJob: { __typename?: 'AsyncStreamsStatus', errorMessage?: string | null, status: AsyncJobStatusEnum, startedAt?: number | null, streams?: Array<{ __typename?: 'Stream', name: string, supportedModes: Array<OperationMode>, configurableIncremental: boolean, supportsMultipleIncrementalPointers: boolean, defaultConfig: any, selectable: boolean, notSelectableExplanation?: string | null, preselect: boolean, primaryKeyNames: Array<string>, excludedSubstreams?: Array<string> | null, enabledHistoryTable?: boolean | null, softDeleteSupported?: boolean | null, softDeleteEnabled?: boolean | null, retired: boolean, historyStreams: Array<{ __typename?: 'HistoryStream', id: string, substreamId?: string | null, destinationTableName: string }>, substreams: Array<{ __typename?: 'SubStream', id: string, destinationTableName: string, avroSchema: any, retired: boolean, retirementDetails?: { __typename?: 'RetirementDetails', inFavorOf?: string | null, removalDate?: string | null, details?: string | null, link?: string | null } | null }>, retirementDetails?: { __typename?: 'RetirementDetails', inFavorOf?: string | null, removalDate?: string | null, details?: string | null, link?: string | null } | null }> | null } };

export type SourceStreamsWithSubStreamsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
  eltSyncId: Scalars['String']['input'];
  sourceStreamNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SourceStreamsWithSubStreamsQuery = { __typename?: 'Query', sourceStreamsWithSubStreams: Array<{ __typename?: 'Stream', name: string, supportedModes: Array<OperationMode>, configurableIncremental: boolean, supportsMultipleIncrementalPointers: boolean, defaultConfig: any, enabledHistoryTable?: boolean | null, historyStreams: Array<{ __typename?: 'HistoryStream', id: string, substreamId?: string | null, destinationTableName: string }>, substreams: Array<{ __typename?: 'SubStream', id: string, destinationTableName: string, retired: boolean, retirementDetails?: { __typename?: 'RetirementDetails', inFavorOf?: string | null, removalDate?: string | null, details?: string | null, link?: string | null } | null }> }> };

export type GetCustomFormValuesQueryVariables = Exact<{
  input: CustomFormInput;
}>;


export type GetCustomFormValuesQuery = { __typename?: 'Query', getCustomFormValues: { __typename?: 'CustomFormValues', customFormValues: any } };

export type ValidateCustomFormQueryVariables = Exact<{
  input: CustomFormValidationInput;
}>;


export type ValidateCustomFormQuery = { __typename?: 'Query', validateCustomForm: { __typename?: 'CustomFormValidationResult', customFormValidationResult: any } };

export type GenerateConnectionLabelQueryVariables = Exact<{
  baseLabel: Scalars['String']['input'];
}>;


export type GenerateConnectionLabelQuery = { __typename?: 'Query', generateConnectionLabel: string };

export type ConnectionCdcFeaturesFragment = { __typename?: 'ConnectionCDCFeatures', changeDataCaptureEnabled: boolean, supportedTables: Array<string>, unsupportedReason?: string | null };

export type ConnectionCdcFeaturesQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
  sourceSettings?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type ConnectionCdcFeaturesQuery = { __typename?: 'Query', connectionCDCFeatures: { __typename?: 'ConnectionCDCFeatures', changeDataCaptureEnabled: boolean, supportedTables: Array<string>, unsupportedReason?: string | null } };

export type ConnectorRestrictionFragment = { __typename?: 'ConnectorRestriction', connectionId: string, restricted: boolean, accessGroups: Array<{ __typename?: 'AccessGroup', id: string, name: string }> };

export type ConnectorRestrictionQueryVariables = Exact<{
  connectionId: Scalars['ID']['input'];
}>;


export type ConnectorRestrictionQuery = { __typename?: 'Query', connectorRestriction: { __typename?: 'ConnectorRestriction', connectionId: string, restricted: boolean, accessGroups: Array<{ __typename?: 'AccessGroup', id: string, name: string }> } };

export type RestrictedConnectorsQueryVariables = Exact<{ [key: string]: never; }>;


export type RestrictedConnectorsQuery = { __typename?: 'Query', restrictedConnectors: Array<{ __typename?: 'ConnectorRestriction', connectionId: string, restricted: boolean, accessGroups: Array<{ __typename?: 'AccessGroup', id: string, name: string }> }> };

export type SetConnectorRestrictionMutationVariables = Exact<{
  input: SetConnectorRestrictionInput;
}>;


export type SetConnectorRestrictionMutation = { __typename?: 'Mutation', setConnectorRestriction: { __typename?: 'ConnectorRestriction', connectionId: string, restricted: boolean, accessGroups: Array<{ __typename?: 'AccessGroup', id: string, name: string }> } };

export type StartDatawarehouseMigrationMutationVariables = Exact<{
  createConnectionInput: CreateConnectionInput;
}>;


export type StartDatawarehouseMigrationMutation = { __typename?: 'Mutation', startDatawarehouseMigration: { __typename?: 'DatawarehouseMigration', id: string, userId: string, accountId: string, status: DwMigrationStatus, errorMessage?: string | null, createdAt: any, pendingSyncs?: Array<string> | null, prevDWIntegrationId: string } };

export type DatawarehouseMigrationQueryVariables = Exact<{ [key: string]: never; }>;


export type DatawarehouseMigrationQuery = { __typename?: 'Query', datawarehouseMigration?: { __typename?: 'DatawarehouseMigration', id: string, userId: string, accountId: string, status: DwMigrationStatus, errorMessage?: string | null, createdAt: any, pendingSyncs?: Array<string> | null, prevDWIntegrationId: string, failed: boolean } | null };

export type CheckMigrationCompatibilityQueryVariables = Exact<{
  createConnectionInput: CreateConnectionInput;
}>;


export type CheckMigrationCompatibilityQuery = { __typename?: 'Query', checkMigrationCompatibility: boolean };

export type DbtConnectionQueryVariables = Exact<{ [key: string]: never; }>;


export type DbtConnectionQuery = { __typename?: 'Query', dbtConnection?: { __typename?: 'Connection', id: string, integrationId: string, label: string, active: boolean, createdAt: any, updatedAt: any, connectedAt: any, formId?: string | null } | null };

export type CreateDbtConnectionMutationVariables = Exact<{
  data: Scalars['String']['input'];
}>;


export type CreateDbtConnectionMutation = { __typename?: 'Mutation', createDbtConnection: { __typename?: 'Connection', id: string, integrationId: string, label: string, active: boolean, createdAt: any, updatedAt: any, connectedAt: any, formId?: string | null } };

export type DownloadStatusByUuidFragment = { __typename?: 'DownloadStatusByUuid', uuid: string, status: DownloadStatus, filename: string, rows?: number | null, error?: string | null, updatedAt: string, expiresAt: string };

export type CreateAsyncQueryResultCsvDownloadMutationVariables = Exact<{
  input: CreateQueryResultCsvDownloadInput;
}>;


export type CreateAsyncQueryResultCsvDownloadMutation = { __typename?: 'Mutation', createAsyncQueryResultCsvDownload: { __typename?: 'DownloadStatusByUuid', uuid: string, status: DownloadStatus, filename: string, rows?: number | null, error?: string | null, updatedAt: string, expiresAt: string } };

export type CancelDownloadMutationVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CancelDownloadMutation = { __typename?: 'Mutation', cancelDownload: Array<{ __typename?: 'DownloadStatusByUuid', uuid: string, status: DownloadStatus, filename: string, rows?: number | null, error?: string | null, updatedAt: string, expiresAt: string }> };

export type DeleteDownloadMutationVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteDownloadMutation = { __typename?: 'Mutation', deleteDownload: Array<string> };

export type DownloadStatusQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DownloadStatusQuery = { __typename?: 'Query', downloadStatus: Array<{ __typename?: 'DownloadStatusByUuid', uuid: string, status: DownloadStatus, filename: string, rows?: number | null, error?: string | null, updatedAt: string, expiresAt: string }> };

export type CreateAuditLogsCsvDownloadMutationVariables = Exact<{
  date: Scalars['String']['input'];
}>;


export type CreateAuditLogsCsvDownloadMutation = { __typename?: 'Mutation', createAuditLogsCsvDownload: { __typename?: 'DownloadStatusByUuid', uuid: string, expiresAt: string } };

export type DownloadUrlQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DownloadUrlQuery = { __typename?: 'Query', downloadUrl?: string | null };

export type AccountEltDestinationFragment = { __typename?: 'AccountEltDestination', id: string, label: string, connectionId: string, integrationId: string, settings: any, syncCount: number, useForNewSyncs: boolean, softDeletesSupported: boolean, historyTablesSupported: boolean, cdcDeletesSupported: boolean, createdAt: any, connection?: { __typename?: 'Connection', id: string, label: string, integrationId: string } | null };

export type EltDestinationsQueryVariables = Exact<{ [key: string]: never; }>;


export type EltDestinationsQuery = { __typename?: 'Query', eltDestinations: Array<{ __typename?: 'AccountEltDestination', id: string, label: string, connectionId: string, integrationId: string, settings: any, syncCount: number, useForNewSyncs: boolean, softDeletesSupported: boolean, historyTablesSupported: boolean, cdcDeletesSupported: boolean, createdAt: any, connection?: { __typename?: 'Connection', id: string, label: string, integrationId: string } | null }> };

export type AddEltDestinationMutationVariables = Exact<{
  input: AddEltDestinationInput;
}>;


export type AddEltDestinationMutation = { __typename?: 'Mutation', addEltDestination: { __typename?: 'AccountEltDestination', id: string, label: string, connectionId: string, integrationId: string, settings: any, syncCount: number, useForNewSyncs: boolean, softDeletesSupported: boolean, historyTablesSupported: boolean, cdcDeletesSupported: boolean, createdAt: any, connection?: { __typename?: 'Connection', id: string, label: string, integrationId: string } | null } };

export type EltDestinationSettingsSchemaQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type EltDestinationSettingsSchemaQuery = { __typename?: 'Query', eltDestinationSettingsSchema: any };

export type UpdateEltDestinationMutationVariables = Exact<{
  input: UpdateEltDestinationInput;
}>;


export type UpdateEltDestinationMutation = { __typename?: 'Mutation', updateEltDestination: { __typename?: 'AccountEltDestination', id: string, label: string, connectionId: string, integrationId: string, settings: any, syncCount: number, useForNewSyncs: boolean, softDeletesSupported: boolean, historyTablesSupported: boolean, cdcDeletesSupported: boolean, createdAt: any, connection?: { __typename?: 'Connection', id: string, label: string, integrationId: string } | null } };

export type RemoveEltDestinationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  forceRemove?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RemoveEltDestinationMutation = { __typename?: 'Mutation', removeEltDestination: { __typename?: 'AccountEltDestination', id: string } };

export type EltSyncDestinationFragment = { __typename?: 'EltSyncDestination', id: string, destinationSchemaName: string, destination: { __typename?: 'AccountEltDestination', id: string, label: string, connectionId: string, integrationId: string, settings: any, syncCount: number, useForNewSyncs: boolean, softDeletesSupported: boolean, historyTablesSupported: boolean, cdcDeletesSupported: boolean, createdAt: any, connection?: { __typename?: 'Connection', id: string, label: string, integrationId: string } | null } };

export type EltSyncDestinationsQueryVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
}>;


export type EltSyncDestinationsQuery = { __typename?: 'Query', eltSync: { __typename?: 'EltSync', id: string, additionalDestinations: Array<{ __typename?: 'EltSyncDestination', id: string, destinationSchemaName: string, destination: { __typename?: 'AccountEltDestination', id: string, label: string, connectionId: string, integrationId: string, settings: any, syncCount: number, useForNewSyncs: boolean, softDeletesSupported: boolean, historyTablesSupported: boolean, cdcDeletesSupported: boolean, createdAt: any, connection?: { __typename?: 'Connection', id: string, label: string, integrationId: string } | null } }> } };

export type AddEltSyncDestinationMutationVariables = Exact<{
  input: AddEltSyncDestinationInput;
}>;


export type AddEltSyncDestinationMutation = { __typename?: 'Mutation', addEltSyncDestination: { __typename?: 'EltSyncDestination', id: string, destinationSchemaName: string, destination: { __typename?: 'AccountEltDestination', id: string, label: string, connectionId: string, integrationId: string, settings: any, syncCount: number, useForNewSyncs: boolean, softDeletesSupported: boolean, historyTablesSupported: boolean, cdcDeletesSupported: boolean, createdAt: any, connection?: { __typename?: 'Connection', id: string, label: string, integrationId: string } | null } } };

export type RemoveEltSyncDestinationMutationVariables = Exact<{
  input: RemoveEltSyncDestinationInput;
}>;


export type RemoveEltSyncDestinationMutation = { __typename?: 'Mutation', removeEltSyncDestination: { __typename?: 'EltSyncDestination', id: string } };

export type SetNextSyncToFullSyncMutationVariables = Exact<{
  sourceStreamId: Scalars['String']['input'];
  forceFullSync: Scalars['Boolean']['input'];
  forceFullSyncHistoryTable?: InputMaybe<Scalars['Boolean']['input']>;
  clearSoftDeletedRows?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetNextSyncToFullSyncMutation = { __typename?: 'Mutation', setNextSyncToFullSync: { __typename?: 'SourceStream', job?: { __typename?: 'GetSourceStreamJobResponse', forceFullSync?: boolean | null, forceFullSyncHistoryTable?: boolean | null, clearSoftDeletedRows?: boolean | null } | null } };

export type SourceStreamRunActionsQueryVariables = Exact<{
  input: RunJobNowInput;
}>;


export type SourceStreamRunActionsQuery = { __typename?: 'Query', sourceStreamRunActions: { __typename?: 'SourceStreamJobRunActionsResponse', availableActions: Array<RunAction>, errors: Array<{ __typename?: 'RunValidationError', message: string, code: string }> } };

export type RunJobNowMutationVariables = Exact<{
  input: RunJobNowInput;
}>;


export type RunJobNowMutation = { __typename?: 'Mutation', runJobNow?: boolean | null };

export type UpdateSourceStreamMutationVariables = Exact<{
  sourceStreamId: Scalars['String']['input'];
  input: UpdateSourceStreamInput;
}>;


export type UpdateSourceStreamMutation = { __typename?: 'Mutation', updateSourceStream: { __typename?: 'SourceStream', id: string, name: string, protectedFromFullSync: boolean, prioritized: boolean } };

export type SetSourceStreamSyncIntervalMutationVariables = Exact<{
  input: UpdateSourceStreamSyncIntervalInput;
}>;


export type SetSourceStreamSyncIntervalMutation = { __typename?: 'Mutation', setSourceStreamSyncInterval: { __typename?: 'SourceStream', id: string } };

export type SetCdcBackfillMutationVariables = Exact<{
  sourceStreamId: Scalars['String']['input'];
  setBackfill: Scalars['Boolean']['input'];
}>;


export type SetCdcBackfillMutation = { __typename?: 'Mutation', setCdcBackfill: { __typename?: 'SourceStream', id: string } };

export type UpdateLastIncrementalPointerMutationVariables = Exact<{
  input: UpdateSourceStreamLastIncrementalPointerInput;
}>;


export type UpdateLastIncrementalPointerMutation = { __typename?: 'Mutation', updateLastIncrementalPointer: boolean };

export type PauseSourceStreamScheduleMutationVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
}>;


export type PauseSourceStreamScheduleMutation = { __typename?: 'Mutation', pauseSourceStreamSchedule: { __typename?: 'SourceStream', id: string, name: string, job?: { __typename?: 'GetSourceStreamJobResponse', status?: string | null } | null } };

export type ResumeSourceStreamScheduleMutationVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
}>;


export type ResumeSourceStreamScheduleMutation = { __typename?: 'Mutation', resumeSourceStreamSchedule: { __typename?: 'SourceStream', id: string, name: string, job?: { __typename?: 'GetSourceStreamJobResponse', status?: string | null } | null } };

export type SourceStreamJobFragment = { __typename?: 'GetSourceStreamJobResponse', nextRun?: number | null, lastRun?: number | null, lastFullSync?: string | null, lastStartedAt?: string | null, status?: string | null, isQuarantined?: boolean | null, forceFullSync?: boolean | null, forceFullSyncHistoryTable?: boolean | null, running?: boolean | null, lastIncrementalPointer?: any | null, cdc?: { __typename?: 'SourceStreamCdcState', running?: boolean | null, heartBeat?: number | null, lastStartedAt?: string | null, isFirstRun?: boolean | null, incrementalSnapshotInProgress?: boolean | null, awaitingInitialSnapshot?: boolean | null, initialSnapshotTableNames?: Array<string> | null } | null, customerFacingError?: { __typename?: 'QuarantineExplanation', headline: string, summary: string, responsibility: QuarantineResponsibility, matchedNotificationType?: string | null, generatedAt: string, actions: Array<{ __typename?: 'QuarantineActionResponse', type: QuarantineActionType, detail: string }> } | null };

export type EltSyncFragment = { __typename?: 'EltSync', id: string, active: boolean, status: string, syncInterval?: string | null, sourceIntegrationId: string, destinationIntegrationId: string, sourceConnectionId: string, destinationConnectionId: string, startDate?: any | null, destinationSchemaName?: string | null, identifierCasing?: IdentifierCasing | null, schedulerType: OrchestrationSchedulerType, eltWebhookId?: string | null, sourceStreams: Array<{ __typename?: 'SourceStream', id: string, name: string, incrementalPrimaryKeyName?: Array<string> | null, incrementalPointerId?: string | null, additionalIncrementalPointerIds: Array<string>, operationMode: OperationMode, fullSyncAlways: boolean, fullSyncAtMidnight?: boolean | null, fullSyncSchedule?: string | null, protectedFromFullSync: boolean, prioritized: boolean, changeDataCaptureEnabled: boolean, syncInterval?: string | null, excludedSubstreams?: Array<string> | null, enabledHistoryTable?: boolean | null, softDeleteEnabled?: boolean | null, dataFilters: Array<{ __typename?: 'SourceStreamDataFilter', sourceStreamObjectKey: string, transformation: string }>, job?: { __typename?: 'GetSourceStreamJobResponse', nextRun?: number | null, lastRun?: number | null, lastFullSync?: string | null, lastStartedAt?: string | null, status?: string | null, isQuarantined?: boolean | null, forceFullSync?: boolean | null, forceFullSyncHistoryTable?: boolean | null, running?: boolean | null, lastIncrementalPointer?: any | null, cdc?: { __typename?: 'SourceStreamCdcState', running?: boolean | null, heartBeat?: number | null, lastStartedAt?: string | null, isFirstRun?: boolean | null, incrementalSnapshotInProgress?: boolean | null, awaitingInitialSnapshot?: boolean | null, initialSnapshotTableNames?: Array<string> | null } | null, customerFacingError?: { __typename?: 'QuarantineExplanation', headline: string, summary: string, responsibility: QuarantineResponsibility, matchedNotificationType?: string | null, generatedAt: string, actions: Array<{ __typename?: 'QuarantineActionResponse', type: QuarantineActionType, detail: string }> } | null } | null, substreams: Array<{ __typename?: 'Substream', name: string, excludedColumns: Array<string>, hashedColumns: Array<string> }> }>, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection?: { __typename?: 'Connection', label: string, id: string } | null, config?: { __typename?: 'EltConfig', sourceSettings?: any | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, cronExpression: string } | null };

export type EltSyncLiteFragment = { __typename?: 'EltSync', id: string, active: boolean, status: string, syncInterval?: string | null, sourceIntegrationId: string, destinationIntegrationId: string, createdAt: any, destinationSchemaName?: string | null, schedulerType: OrchestrationSchedulerType, sourceConnectionId: string, sourceStreams: Array<{ __typename?: 'SourceStream', id: string, name: string, changeDataCaptureEnabled: boolean, protectedFromFullSync: boolean }>, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection?: { __typename?: 'Connection', label: string, id: string } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, cronExpression: string } | null };

export type CreateEltSyncMutationVariables = Exact<{
  sourceConnectionId: Scalars['String']['input'];
  destinationConnectionId: Scalars['String']['input'];
  syncInterval?: InputMaybe<Scalars['String']['input']>;
  sourceStreams: Array<SourceStreamInput> | SourceStreamInput;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  destinationSchemaName?: InputMaybe<Scalars['String']['input']>;
  identifierCasing?: InputMaybe<IdentifierCasing>;
  schedulerType?: InputMaybe<OrchestrationSchedulerType>;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  additionalDestinations?: InputMaybe<Array<EltSyncAdditionalDestinationInput> | EltSyncAdditionalDestinationInput>;
}>;


export type CreateEltSyncMutation = { __typename?: 'Mutation', createEltSync: { __typename?: 'EltSync', id: string, sourceConnectionId: string, destinationConnectionId: string, destinationSchemaName?: string | null, identifierCasing?: IdentifierCasing | null, additionalDestinations: Array<{ __typename?: 'EltSyncDestination', id: string, destinationSchemaName: string, destination: { __typename?: 'AccountEltDestination', id: string, label: string, connectionId: string, integrationId: string, settings: any, syncCount: number, useForNewSyncs: boolean, softDeletesSupported: boolean, historyTablesSupported: boolean, cdcDeletesSupported: boolean, createdAt: any, connection?: { __typename?: 'Connection', id: string, label: string, integrationId: string } | null } }> } };

export type UpdateEltSyncMutationVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
  syncInterval?: InputMaybe<Scalars['String']['input']>;
  sourceStreams: Array<SourceStreamInput> | SourceStreamInput;
  config?: InputMaybe<Scalars['String']['input']>;
  schedulerType: OrchestrationSchedulerType;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateEltSyncMutation = { __typename?: 'Mutation', updateEltSync: { __typename?: 'EltSync', id: string, sourceConnectionId: string, destinationConnectionId: string } };

export type StartEltSyncMutationVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
}>;


export type StartEltSyncMutation = { __typename?: 'Mutation', startEltSync: { __typename?: 'EltSync', id: string, active: boolean, status: string, syncInterval?: string | null, sourceIntegrationId: string, destinationIntegrationId: string, sourceConnectionId: string, destinationConnectionId: string, startDate?: any | null, destinationSchemaName?: string | null, identifierCasing?: IdentifierCasing | null, schedulerType: OrchestrationSchedulerType, eltWebhookId?: string | null, sourceStreams: Array<{ __typename?: 'SourceStream', id: string, name: string, incrementalPrimaryKeyName?: Array<string> | null, incrementalPointerId?: string | null, additionalIncrementalPointerIds: Array<string>, operationMode: OperationMode, fullSyncAlways: boolean, fullSyncAtMidnight?: boolean | null, fullSyncSchedule?: string | null, protectedFromFullSync: boolean, prioritized: boolean, changeDataCaptureEnabled: boolean, syncInterval?: string | null, excludedSubstreams?: Array<string> | null, enabledHistoryTable?: boolean | null, softDeleteEnabled?: boolean | null, dataFilters: Array<{ __typename?: 'SourceStreamDataFilter', sourceStreamObjectKey: string, transformation: string }>, job?: { __typename?: 'GetSourceStreamJobResponse', nextRun?: number | null, lastRun?: number | null, lastFullSync?: string | null, lastStartedAt?: string | null, status?: string | null, isQuarantined?: boolean | null, forceFullSync?: boolean | null, forceFullSyncHistoryTable?: boolean | null, running?: boolean | null, lastIncrementalPointer?: any | null, cdc?: { __typename?: 'SourceStreamCdcState', running?: boolean | null, heartBeat?: number | null, lastStartedAt?: string | null, isFirstRun?: boolean | null, incrementalSnapshotInProgress?: boolean | null, awaitingInitialSnapshot?: boolean | null, initialSnapshotTableNames?: Array<string> | null } | null, customerFacingError?: { __typename?: 'QuarantineExplanation', headline: string, summary: string, responsibility: QuarantineResponsibility, matchedNotificationType?: string | null, generatedAt: string, actions: Array<{ __typename?: 'QuarantineActionResponse', type: QuarantineActionType, detail: string }> } | null } | null, substreams: Array<{ __typename?: 'Substream', name: string, excludedColumns: Array<string>, hashedColumns: Array<string> }> }>, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection?: { __typename?: 'Connection', label: string, id: string } | null, config?: { __typename?: 'EltConfig', sourceSettings?: any | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, cronExpression: string } | null } };

export type StopEltSyncMutationVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
}>;


export type StopEltSyncMutation = { __typename?: 'Mutation', stopEltSync: { __typename?: 'EltSync', id: string, active: boolean, status: string, syncInterval?: string | null, sourceIntegrationId: string, destinationIntegrationId: string, sourceConnectionId: string, destinationConnectionId: string, startDate?: any | null, destinationSchemaName?: string | null, identifierCasing?: IdentifierCasing | null, schedulerType: OrchestrationSchedulerType, eltWebhookId?: string | null, sourceStreams: Array<{ __typename?: 'SourceStream', id: string, name: string, incrementalPrimaryKeyName?: Array<string> | null, incrementalPointerId?: string | null, additionalIncrementalPointerIds: Array<string>, operationMode: OperationMode, fullSyncAlways: boolean, fullSyncAtMidnight?: boolean | null, fullSyncSchedule?: string | null, protectedFromFullSync: boolean, prioritized: boolean, changeDataCaptureEnabled: boolean, syncInterval?: string | null, excludedSubstreams?: Array<string> | null, enabledHistoryTable?: boolean | null, softDeleteEnabled?: boolean | null, dataFilters: Array<{ __typename?: 'SourceStreamDataFilter', sourceStreamObjectKey: string, transformation: string }>, job?: { __typename?: 'GetSourceStreamJobResponse', nextRun?: number | null, lastRun?: number | null, lastFullSync?: string | null, lastStartedAt?: string | null, status?: string | null, isQuarantined?: boolean | null, forceFullSync?: boolean | null, forceFullSyncHistoryTable?: boolean | null, running?: boolean | null, lastIncrementalPointer?: any | null, cdc?: { __typename?: 'SourceStreamCdcState', running?: boolean | null, heartBeat?: number | null, lastStartedAt?: string | null, isFirstRun?: boolean | null, incrementalSnapshotInProgress?: boolean | null, awaitingInitialSnapshot?: boolean | null, initialSnapshotTableNames?: Array<string> | null } | null, customerFacingError?: { __typename?: 'QuarantineExplanation', headline: string, summary: string, responsibility: QuarantineResponsibility, matchedNotificationType?: string | null, generatedAt: string, actions: Array<{ __typename?: 'QuarantineActionResponse', type: QuarantineActionType, detail: string }> } | null } | null, substreams: Array<{ __typename?: 'Substream', name: string, excludedColumns: Array<string>, hashedColumns: Array<string> }> }>, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection?: { __typename?: 'Connection', label: string, id: string } | null, config?: { __typename?: 'EltConfig', sourceSettings?: any | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, cronExpression: string } | null } };

export type RemoveEltSyncMutationVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
  removeDataReferences?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RemoveEltSyncMutation = { __typename?: 'Mutation', removeEltSync: { __typename?: 'RemoveEltSyncResponse', id: string } };

export type RemoveTableFromSyncMutationVariables = Exact<{
  sourceStreamName: Scalars['String']['input'];
  syncId: Scalars['String']['input'];
  viewId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveTableFromSyncMutation = { __typename?: 'Mutation', removeTableFromSync: { __typename?: 'RemoveTableResponse', sourceStreamName: string } };

export type EltSyncsQueryVariables = Exact<{ [key: string]: never; }>;


export type EltSyncsQuery = { __typename?: 'Query', eltSyncs: Array<{ __typename?: 'EltSync', id: string, active: boolean, status: string, syncInterval?: string | null, sourceIntegrationId: string, destinationIntegrationId: string, createdAt: any, destinationSchemaName?: string | null, schedulerType: OrchestrationSchedulerType, sourceConnectionId: string, sourceStreams: Array<{ __typename?: 'SourceStream', id: string, name: string, changeDataCaptureEnabled: boolean, protectedFromFullSync: boolean }>, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection?: { __typename?: 'Connection', label: string, id: string } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, cronExpression: string } | null }> };

export type EltSyncJobsQueryVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
}>;


export type EltSyncJobsQuery = { __typename?: 'Query', eltSync: { __typename?: 'EltSync', id: string, sourceStreams: Array<{ __typename?: 'SourceStream', id: string, job?: { __typename?: 'GetSourceStreamJobResponse', nextRun?: number | null, lastRun?: number | null, lastFullSync?: string | null, lastStartedAt?: string | null, status?: string | null, isQuarantined?: boolean | null, forceFullSync?: boolean | null, forceFullSyncHistoryTable?: boolean | null, running?: boolean | null, lastIncrementalPointer?: any | null, cdc?: { __typename?: 'SourceStreamCdcState', running?: boolean | null, heartBeat?: number | null, lastStartedAt?: string | null, isFirstRun?: boolean | null, incrementalSnapshotInProgress?: boolean | null, awaitingInitialSnapshot?: boolean | null, initialSnapshotTableNames?: Array<string> | null } | null, customerFacingError?: { __typename?: 'QuarantineExplanation', headline: string, summary: string, responsibility: QuarantineResponsibility, matchedNotificationType?: string | null, generatedAt: string, actions: Array<{ __typename?: 'QuarantineActionResponse', type: QuarantineActionType, detail: string }> } | null } | null }> } };

export type EltSyncQueryVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
}>;


export type EltSyncQuery = { __typename?: 'Query', eltSync: { __typename?: 'EltSync', id: string, active: boolean, status: string, syncInterval?: string | null, sourceIntegrationId: string, destinationIntegrationId: string, sourceConnectionId: string, destinationConnectionId: string, startDate?: any | null, destinationSchemaName?: string | null, identifierCasing?: IdentifierCasing | null, schedulerType: OrchestrationSchedulerType, eltWebhookId?: string | null, sourceStreams: Array<{ __typename?: 'SourceStream', id: string, name: string, incrementalPrimaryKeyName?: Array<string> | null, incrementalPointerId?: string | null, additionalIncrementalPointerIds: Array<string>, operationMode: OperationMode, fullSyncAlways: boolean, fullSyncAtMidnight?: boolean | null, fullSyncSchedule?: string | null, protectedFromFullSync: boolean, prioritized: boolean, changeDataCaptureEnabled: boolean, syncInterval?: string | null, excludedSubstreams?: Array<string> | null, enabledHistoryTable?: boolean | null, softDeleteEnabled?: boolean | null, dataFilters: Array<{ __typename?: 'SourceStreamDataFilter', sourceStreamObjectKey: string, transformation: string }>, job?: { __typename?: 'GetSourceStreamJobResponse', nextRun?: number | null, lastRun?: number | null, lastFullSync?: string | null, lastStartedAt?: string | null, status?: string | null, isQuarantined?: boolean | null, forceFullSync?: boolean | null, forceFullSyncHistoryTable?: boolean | null, running?: boolean | null, lastIncrementalPointer?: any | null, cdc?: { __typename?: 'SourceStreamCdcState', running?: boolean | null, heartBeat?: number | null, lastStartedAt?: string | null, isFirstRun?: boolean | null, incrementalSnapshotInProgress?: boolean | null, awaitingInitialSnapshot?: boolean | null, initialSnapshotTableNames?: Array<string> | null } | null, customerFacingError?: { __typename?: 'QuarantineExplanation', headline: string, summary: string, responsibility: QuarantineResponsibility, matchedNotificationType?: string | null, generatedAt: string, actions: Array<{ __typename?: 'QuarantineActionResponse', type: QuarantineActionType, detail: string }> } | null } | null, substreams: Array<{ __typename?: 'Substream', name: string, excludedColumns: Array<string>, hashedColumns: Array<string> }> }>, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection?: { __typename?: 'Connection', label: string, id: string } | null, config?: { __typename?: 'EltConfig', sourceSettings?: any | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, cronExpression: string } | null } };

export type EltSyncLiteQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EltSyncLiteQuery = { __typename?: 'Query', eltSync: { __typename?: 'EltSync', id: string, active: boolean, status: string, syncInterval?: string | null, sourceIntegrationId: string, destinationIntegrationId: string, createdAt: any, destinationSchemaName?: string | null, schedulerType: OrchestrationSchedulerType, sourceConnectionId: string, sourceStreams: Array<{ __typename?: 'SourceStream', id: string, name: string, changeDataCaptureEnabled: boolean, protectedFromFullSync: boolean }>, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection?: { __typename?: 'Connection', label: string, id: string } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, cronExpression: string } | null } };

export type EltJobsCompletionStatsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type EltJobsCompletionStatsQuery = { __typename?: 'Query', eltJobsCompletionStats: { __typename?: 'SyncJobsCompletionMetricResponse', stats?: { __typename?: 'SyncJobsCompletionMetric', total: number, successCount: number, successPercent: number, failureCount: number, failurePercent: number } | null } };

export type EltSyncHistoryStatsResponseFragment = { __typename?: 'EltSyncHistoryStatsResponse', limit?: number | null, stats: Array<{ __typename?: 'EltSyncHistoryStat', startedAt?: any | null, finishedAt?: any | null, duration?: number | null, status?: SyncJobStatus | null, sourceStreamName?: string | null, rowsSynced: number, substreamRowsSynced?: number | null, rowsSyncedMb: number, operationMode?: OperationMode | null, fullSyncTrigger: FullSyncTrigger, substreamRecordsSyncedBySubstream?: Array<{ __typename?: 'SubstreamRecordsSynced', substreamId: string, destinationTableName: string, recordsSynced: number }> | null }> };

export type EltSyncStatsRecentQueryVariables = Exact<{
  syncId: Scalars['String']['input'];
  from: Scalars['DateTime']['input'];
  sourceStreamName?: InputMaybe<Scalars['String']['input']>;
}>;


export type EltSyncStatsRecentQuery = { __typename?: 'Query', eltSyncStatsRecent: { __typename?: 'EltSyncHistoryStatsResponse', limit?: number | null, stats: Array<{ __typename?: 'EltSyncHistoryStat', startedAt?: any | null, finishedAt?: any | null, duration?: number | null, status?: SyncJobStatus | null, sourceStreamName?: string | null, rowsSynced: number, substreamRowsSynced?: number | null, rowsSyncedMb: number, operationMode?: OperationMode | null, fullSyncTrigger: FullSyncTrigger, substreamRecordsSyncedBySubstream?: Array<{ __typename?: 'SubstreamRecordsSynced', substreamId: string, destinationTableName: string, recordsSynced: number }> | null }> } };

export type EltSyncStatsHistoricQueryVariables = Exact<{
  syncId: Scalars['String']['input'];
  from: Scalars['DateTime']['input'];
  sourceStreamName?: InputMaybe<Scalars['String']['input']>;
}>;


export type EltSyncStatsHistoricQuery = { __typename?: 'Query', eltSyncStatsHistoric: { __typename?: 'EltSyncHistoryStatsResponse', limit?: number | null, stats: Array<{ __typename?: 'EltSyncHistoryStat', startedAt?: any | null, finishedAt?: any | null, duration?: number | null, status?: SyncJobStatus | null, sourceStreamName?: string | null, rowsSynced: number, substreamRowsSynced?: number | null, rowsSyncedMb: number, operationMode?: OperationMode | null, fullSyncTrigger: FullSyncTrigger, substreamRecordsSyncedBySubstream?: Array<{ __typename?: 'SubstreamRecordsSynced', substreamId: string, destinationTableName: string, recordsSynced: number }> | null }> } };

export type RecreateViewMutationVariables = Exact<{
  eltSyncId: Scalars['String']['input'];
  sourceStreamName: Scalars['String']['input'];
}>;


export type RecreateViewMutation = { __typename?: 'Mutation', recreateDestinationView: { __typename?: 'RecreateViewResponse', success: boolean, error?: string | null } };

export type SearchSyncDestinationsQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type SearchSyncDestinationsQuery = { __typename?: 'Query', searchSyncDestinations: Array<{ __typename?: 'SearchSyncDestinationsResult', name: string, schemaName: string, viewId: string, integrationId: string }> };

export type WebhookFragment = { __typename?: 'WebhookResponse', webhookId: string, name: string, connectionId: string, orchestrationWorkflowId?: string | null, type: ExternalSystem, params: any, createdAt: any, updatedAt: any, dependencies: Array<{ __typename?: 'WebhookDependencyResponse', name: string, id: string, itemId: string, type: string }> };

export type WebhookRunFragment = { __typename?: 'WebhookRunResponse', id: string, webhookId: string, status: WebhookRunStatus, orchestrationWorkflowRunId?: string | null, externalRunId?: string | null, externalUrl?: string | null, externalStatusCode?: number | null, errorMessage?: string | null, createdAt: any, finishedAt?: any | null };

export type GetWebhookDataQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type GetWebhookDataQuery = { __typename?: 'Query', getWebhookData: { __typename?: 'WebhookDataResponse', data: any } };

export type CreateWebhookMutationVariables = Exact<{
  data: CreateWebhookInput;
}>;


export type CreateWebhookMutation = { __typename?: 'Mutation', createWebhook: { __typename?: 'WebhookResponse', webhookId: string, name: string, connectionId: string, orchestrationWorkflowId?: string | null, type: ExternalSystem, params: any, createdAt: any, updatedAt: any, dependencies: Array<{ __typename?: 'WebhookDependencyResponse', name: string, id: string, itemId: string, type: string }> } };

export type DeleteWebhookMutationVariables = Exact<{
  webhookId: Scalars['String']['input'];
}>;


export type DeleteWebhookMutation = { __typename?: 'Mutation', deleteWebhook: boolean };

export type ListWebhooksQueryVariables = Exact<{
  orchestrationWorkflowId: Scalars['String']['input'];
}>;


export type ListWebhooksQuery = { __typename?: 'Query', listWebhoooks: Array<{ __typename?: 'WebhookResponse', webhookId: string, name: string, connectionId: string, orchestrationWorkflowId?: string | null, type: ExternalSystem, params: any, createdAt: any, updatedAt: any, dependencies: Array<{ __typename?: 'WebhookDependencyResponse', name: string, id: string, itemId: string, type: string }> }> };

export type UpdateWebhookMutationVariables = Exact<{
  data: UpdateWebhookInput;
}>;


export type UpdateWebhookMutation = { __typename?: 'Mutation', updateWebhook: { __typename?: 'WebhookResponse', webhookId: string, name: string, connectionId: string, orchestrationWorkflowId?: string | null, type: ExternalSystem, params: any, createdAt: any, updatedAt: any, dependencies: Array<{ __typename?: 'WebhookDependencyResponse', name: string, id: string, itemId: string, type: string }> } };

export type LatestWebhookRunsQueryVariables = Exact<{
  webhookIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type LatestWebhookRunsQuery = { __typename?: 'Query', latestWebhookRuns: Array<{ __typename?: 'WebhookRunResponse', id: string, webhookId: string, status: WebhookRunStatus, orchestrationWorkflowRunId?: string | null, externalRunId?: string | null, externalUrl?: string | null, externalStatusCode?: number | null, errorMessage?: string | null, createdAt: any, finishedAt?: any | null }> };

export type RequestBetaConnectorAccessMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
}>;


export type RequestBetaConnectorAccessMutation = { __typename?: 'Mutation', requestBetaConnectorAccess: boolean };

export type RequestConnectorMutationVariables = Exact<{
  integrationName: Scalars['String']['input'];
  integrationTypes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RequestConnectorMutation = { __typename?: 'Mutation', requestConnector: boolean };

export type RequestDestinationMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
}>;


export type RequestDestinationMutation = { __typename?: 'Mutation', requestDestination: boolean };

export type GithubConnectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GithubConnectionQuery = { __typename?: 'Query', githubConnection?: { __typename?: 'GithubConnection', id: string, repoOwner: string, repoName: string, branch: string, folderPath: string, status: GithubConnectionStatus, lastSyncedCommitSha?: string | null, lastSyncedAt?: any | null, createdAt: any } | null };

export type GithubInstallationQueryVariables = Exact<{ [key: string]: never; }>;


export type GithubInstallationQuery = { __typename?: 'Query', githubApp: { __typename?: 'GithubApp', appUrl: string }, githubInstallation?: { __typename?: 'GithubInstallation', id: string, githubAccountLogin: string, manageInstallationUrl: string, status: GithubInstallationStatus, createdAt: any } | null };

export type GithubInstallUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type GithubInstallUrlMutation = { __typename?: 'Mutation', githubInstallUrl: { __typename?: 'GithubInstallUrlResult', installUrl: string } };

export type RepairGithubInstallationMutationVariables = Exact<{ [key: string]: never; }>;


export type RepairGithubInstallationMutation = { __typename?: 'Mutation', repairGithubInstallation: { __typename?: 'GithubInstallationRepairResult', outcome: GithubInstallationRepairOutcome } };

export type GithubInstallationChoicesQueryVariables = Exact<{
  state: Scalars['String']['input'];
}>;


export type GithubInstallationChoicesQuery = { __typename?: 'Query', githubApp: { __typename?: 'GithubApp', appUrl: string }, githubInstallationChoices: { __typename?: 'GithubInstallationChoices', installUrl: string, choices: Array<{ __typename?: 'GithubInstallationChoice', installationId: string, githubAccountLogin: string, accountType: GithubInstallationAccountType }> } };

export type GithubSelectInstallationMutationVariables = Exact<{
  installationId: Scalars['String']['input'];
  state: Scalars['String']['input'];
}>;


export type GithubSelectInstallationMutation = { __typename?: 'Mutation', githubSelectInstallation: { __typename?: 'GithubCompleteInstallResult', accountId: string, slug: string } };

export type GithubRepositoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GithubRepositoriesQuery = { __typename?: 'Query', githubRepositories: { __typename?: 'GithubRepositoriesResult', repositories: Array<{ __typename?: 'GithubRepository', owner: string, name: string, fullName: string, defaultBranch: string, isPrivate: boolean }> } };

export type GithubBranchesQueryVariables = Exact<{
  owner: Scalars['String']['input'];
  repo: Scalars['String']['input'];
}>;


export type GithubBranchesQuery = { __typename?: 'Query', githubBranches: { __typename?: 'GithubBranchesResult', branches: Array<{ __typename?: 'GithubBranch', name: string, isProtected: boolean }> } };

export type CompleteGithubConnectionMutationVariables = Exact<{
  input: CompleteGithubConnectionInput;
}>;


export type CompleteGithubConnectionMutation = { __typename?: 'Mutation', completeGithubConnection: { __typename?: 'GithubCompleteConnectionResult', connectionId: string, repoOwner: string, repoName: string, branch: string, folderPath: string, branchIsEmpty: boolean } };

export type GithubSyncChangeFieldsFragment = { __typename?: 'GithubSyncChange', status: GithubSyncChangeStatus, path: string, modelName?: string | null, modelId?: string | null, sourcePath?: string | null, materialization?: string | null, previousMaterializationType?: string | null, reason?: string | null, unresolvedDependencies: Array<string>, unsupportedJinja: Array<string> };

export type GithubCommitAuthorFieldsFragment = { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null };

export type GithubFileCommitFieldsFragment = { __typename?: 'GithubFileCommit', sha: string, committedAt?: string | null, message?: string | null, commitCount?: number | null, author: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }, authors?: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> | null };

export type GithubSyncCommitAttributionFieldsFragment = { __typename?: 'GithubSyncListItem', headCommitAuthor?: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null } | null, commitRange?: { __typename?: 'GithubSyncCommitRange', commitCount: number, authors: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> } | null };

export type GithubSyncListItemFieldsFragment = { __typename?: 'GithubSyncListItem', id: string, triggeredBy: GithubSyncTriggeredBy, commitSha?: string | null, status: GithubSyncStatus, startedAt: any, completedAt?: any | null, summary: { __typename?: 'GithubSyncSummaryListItem', counts: any, failureReason?: string | null, failedMaterializationsCount?: number | null, noModelsFound?: boolean | null, warningsCount?: number | null }, headCommitAuthor?: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null } | null, commitRange?: { __typename?: 'GithubSyncCommitRange', commitCount: number, authors: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> } | null };

export type GithubSyncFieldsFragment = { __typename?: 'GithubSync', id: string, createdAt: any, connectionId: string, triggeredBy: GithubSyncTriggeredBy, triggeringDeliveryId?: string | null, commitSha?: string | null, baseCommitSha?: string | null, status: GithubSyncStatus, startedAt: any, completedAt?: any | null, headCommitAuthor?: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null } | null, commitRange?: { __typename?: 'GithubSyncCommitRange', commitCount: number, authors: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> } | null, fileCommits: Array<{ __typename?: 'GithubSyncFileCommit', sourcePath: string, commit: { __typename?: 'GithubFileCommit', sha: string, committedAt?: string | null, message?: string | null, commitCount?: number | null, author: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }, authors?: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> | null } }>, summary: { __typename?: 'GithubSyncSummary', counts: any, materializingModelIds?: Array<string> | null, failedMaterializationModelIds?: Array<string> | null, noModelsFound?: boolean | null, commitOutcome?: { __typename?: 'GithubSyncCommitOutcome', succeeded: number, failed: number } | null, warnings: Array<{ __typename?: 'GithubSyncWarning', type: GithubSyncWarningType, message: string }>, autoHealed?: { __typename?: 'GithubSyncAutoHealed', attempted: Array<string>, failed: Array<string> } | null, changes: Array<{ __typename?: 'GithubSyncChange', status: GithubSyncChangeStatus, path: string, modelName?: string | null, modelId?: string | null, sourcePath?: string | null, materialization?: string | null, previousMaterializationType?: string | null, reason?: string | null, unresolvedDependencies: Array<string>, unsupportedJinja: Array<string> }>, unchangedModels: Array<{ __typename?: 'GithubSyncUnchangedModel', modelId?: string | null, modelName?: string | null, path: string }> } };

export type TriggerGithubSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerGithubSyncMutation = { __typename?: 'Mutation', triggerGithubSync?: { __typename?: 'GithubSync', id: string, createdAt: any, connectionId: string, triggeredBy: GithubSyncTriggeredBy, triggeringDeliveryId?: string | null, commitSha?: string | null, baseCommitSha?: string | null, status: GithubSyncStatus, startedAt: any, completedAt?: any | null, headCommitAuthor?: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null } | null, commitRange?: { __typename?: 'GithubSyncCommitRange', commitCount: number, authors: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> } | null, fileCommits: Array<{ __typename?: 'GithubSyncFileCommit', sourcePath: string, commit: { __typename?: 'GithubFileCommit', sha: string, committedAt?: string | null, message?: string | null, commitCount?: number | null, author: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }, authors?: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> | null } }>, summary: { __typename?: 'GithubSyncSummary', counts: any, materializingModelIds?: Array<string> | null, failedMaterializationModelIds?: Array<string> | null, noModelsFound?: boolean | null, commitOutcome?: { __typename?: 'GithubSyncCommitOutcome', succeeded: number, failed: number } | null, warnings: Array<{ __typename?: 'GithubSyncWarning', type: GithubSyncWarningType, message: string }>, autoHealed?: { __typename?: 'GithubSyncAutoHealed', attempted: Array<string>, failed: Array<string> } | null, changes: Array<{ __typename?: 'GithubSyncChange', status: GithubSyncChangeStatus, path: string, modelName?: string | null, modelId?: string | null, sourcePath?: string | null, materialization?: string | null, previousMaterializationType?: string | null, reason?: string | null, unresolvedDependencies: Array<string>, unsupportedJinja: Array<string> }>, unchangedModels: Array<{ __typename?: 'GithubSyncUnchangedModel', modelId?: string | null, modelName?: string | null, path: string }> } } | null };

export type ConfirmFirstGithubSyncMutationVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type ConfirmFirstGithubSyncMutation = { __typename?: 'Mutation', confirmFirstGithubSync: { __typename?: 'GithubSync', id: string, createdAt: any, connectionId: string, triggeredBy: GithubSyncTriggeredBy, triggeringDeliveryId?: string | null, commitSha?: string | null, baseCommitSha?: string | null, status: GithubSyncStatus, startedAt: any, completedAt?: any | null, headCommitAuthor?: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null } | null, commitRange?: { __typename?: 'GithubSyncCommitRange', commitCount: number, authors: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> } | null, fileCommits: Array<{ __typename?: 'GithubSyncFileCommit', sourcePath: string, commit: { __typename?: 'GithubFileCommit', sha: string, committedAt?: string | null, message?: string | null, commitCount?: number | null, author: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }, authors?: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> | null } }>, summary: { __typename?: 'GithubSyncSummary', counts: any, materializingModelIds?: Array<string> | null, failedMaterializationModelIds?: Array<string> | null, noModelsFound?: boolean | null, commitOutcome?: { __typename?: 'GithubSyncCommitOutcome', succeeded: number, failed: number } | null, warnings: Array<{ __typename?: 'GithubSyncWarning', type: GithubSyncWarningType, message: string }>, autoHealed?: { __typename?: 'GithubSyncAutoHealed', attempted: Array<string>, failed: Array<string> } | null, changes: Array<{ __typename?: 'GithubSyncChange', status: GithubSyncChangeStatus, path: string, modelName?: string | null, modelId?: string | null, sourcePath?: string | null, materialization?: string | null, previousMaterializationType?: string | null, reason?: string | null, unresolvedDependencies: Array<string>, unsupportedJinja: Array<string> }>, unchangedModels: Array<{ __typename?: 'GithubSyncUnchangedModel', modelId?: string | null, modelName?: string | null, path: string }> } } };

export type CancelGithubSyncMutationVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type CancelGithubSyncMutation = { __typename?: 'Mutation', cancelGithubSync: { __typename?: 'GithubSync', id: string, createdAt: any, connectionId: string, triggeredBy: GithubSyncTriggeredBy, triggeringDeliveryId?: string | null, commitSha?: string | null, baseCommitSha?: string | null, status: GithubSyncStatus, startedAt: any, completedAt?: any | null, headCommitAuthor?: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null } | null, commitRange?: { __typename?: 'GithubSyncCommitRange', commitCount: number, authors: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> } | null, fileCommits: Array<{ __typename?: 'GithubSyncFileCommit', sourcePath: string, commit: { __typename?: 'GithubFileCommit', sha: string, committedAt?: string | null, message?: string | null, commitCount?: number | null, author: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }, authors?: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> | null } }>, summary: { __typename?: 'GithubSyncSummary', counts: any, materializingModelIds?: Array<string> | null, failedMaterializationModelIds?: Array<string> | null, noModelsFound?: boolean | null, commitOutcome?: { __typename?: 'GithubSyncCommitOutcome', succeeded: number, failed: number } | null, warnings: Array<{ __typename?: 'GithubSyncWarning', type: GithubSyncWarningType, message: string }>, autoHealed?: { __typename?: 'GithubSyncAutoHealed', attempted: Array<string>, failed: Array<string> } | null, changes: Array<{ __typename?: 'GithubSyncChange', status: GithubSyncChangeStatus, path: string, modelName?: string | null, modelId?: string | null, sourcePath?: string | null, materialization?: string | null, previousMaterializationType?: string | null, reason?: string | null, unresolvedDependencies: Array<string>, unsupportedJinja: Array<string> }>, unchangedModels: Array<{ __typename?: 'GithubSyncUnchangedModel', modelId?: string | null, modelName?: string | null, path: string }> } } };

export type RetryGithubSyncMaterializationsMutationVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type RetryGithubSyncMaterializationsMutation = { __typename?: 'Mutation', retryGithubSyncMaterializations: { __typename?: 'GithubSync', id: string, createdAt: any, connectionId: string, triggeredBy: GithubSyncTriggeredBy, triggeringDeliveryId?: string | null, commitSha?: string | null, baseCommitSha?: string | null, status: GithubSyncStatus, startedAt: any, completedAt?: any | null, headCommitAuthor?: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null } | null, commitRange?: { __typename?: 'GithubSyncCommitRange', commitCount: number, authors: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> } | null, fileCommits: Array<{ __typename?: 'GithubSyncFileCommit', sourcePath: string, commit: { __typename?: 'GithubFileCommit', sha: string, committedAt?: string | null, message?: string | null, commitCount?: number | null, author: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }, authors?: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> | null } }>, summary: { __typename?: 'GithubSyncSummary', counts: any, materializingModelIds?: Array<string> | null, failedMaterializationModelIds?: Array<string> | null, noModelsFound?: boolean | null, commitOutcome?: { __typename?: 'GithubSyncCommitOutcome', succeeded: number, failed: number } | null, warnings: Array<{ __typename?: 'GithubSyncWarning', type: GithubSyncWarningType, message: string }>, autoHealed?: { __typename?: 'GithubSyncAutoHealed', attempted: Array<string>, failed: Array<string> } | null, changes: Array<{ __typename?: 'GithubSyncChange', status: GithubSyncChangeStatus, path: string, modelName?: string | null, modelId?: string | null, sourcePath?: string | null, materialization?: string | null, previousMaterializationType?: string | null, reason?: string | null, unresolvedDependencies: Array<string>, unsupportedJinja: Array<string> }>, unchangedModels: Array<{ __typename?: 'GithubSyncUnchangedModel', modelId?: string | null, modelName?: string | null, path: string }> } } };

export type GithubModelLastCommitQueryVariables = Exact<{
  sourcePath: Scalars['String']['input'];
}>;


export type GithubModelLastCommitQuery = { __typename?: 'Query', githubModelLastCommit?: { __typename?: 'GithubFileCommit', sha: string, committedAt?: string | null, message?: string | null, commitCount?: number | null, author: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }, authors?: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> | null } | null };

export type GithubSyncQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GithubSyncQuery = { __typename?: 'Query', githubSync?: { __typename?: 'GithubSync', id: string, createdAt: any, connectionId: string, triggeredBy: GithubSyncTriggeredBy, triggeringDeliveryId?: string | null, commitSha?: string | null, baseCommitSha?: string | null, status: GithubSyncStatus, startedAt: any, completedAt?: any | null, headCommitAuthor?: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null } | null, commitRange?: { __typename?: 'GithubSyncCommitRange', commitCount: number, authors: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> } | null, fileCommits: Array<{ __typename?: 'GithubSyncFileCommit', sourcePath: string, commit: { __typename?: 'GithubFileCommit', sha: string, committedAt?: string | null, message?: string | null, commitCount?: number | null, author: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }, authors?: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> | null } }>, summary: { __typename?: 'GithubSyncSummary', counts: any, materializingModelIds?: Array<string> | null, failedMaterializationModelIds?: Array<string> | null, noModelsFound?: boolean | null, commitOutcome?: { __typename?: 'GithubSyncCommitOutcome', succeeded: number, failed: number } | null, warnings: Array<{ __typename?: 'GithubSyncWarning', type: GithubSyncWarningType, message: string }>, autoHealed?: { __typename?: 'GithubSyncAutoHealed', attempted: Array<string>, failed: Array<string> } | null, changes: Array<{ __typename?: 'GithubSyncChange', status: GithubSyncChangeStatus, path: string, modelName?: string | null, modelId?: string | null, sourcePath?: string | null, materialization?: string | null, previousMaterializationType?: string | null, reason?: string | null, unresolvedDependencies: Array<string>, unsupportedJinja: Array<string> }>, unchangedModels: Array<{ __typename?: 'GithubSyncUnchangedModel', modelId?: string | null, modelName?: string | null, path: string }> } } | null };

export type GithubSyncsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type GithubSyncsQuery = { __typename?: 'Query', githubSyncs: { __typename?: 'PaginatedGithubSyncListItems', nextCursor?: string | null, hasMore: boolean, items: Array<{ __typename?: 'GithubSyncListItem', id: string, triggeredBy: GithubSyncTriggeredBy, commitSha?: string | null, status: GithubSyncStatus, startedAt: any, completedAt?: any | null, summary: { __typename?: 'GithubSyncSummaryListItem', counts: any, failureReason?: string | null, failedMaterializationsCount?: number | null, noModelsFound?: boolean | null, warningsCount?: number | null }, headCommitAuthor?: { __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null } | null, commitRange?: { __typename?: 'GithubSyncCommitRange', commitCount: number, authors: Array<{ __typename?: 'GithubCommitAuthor', login?: string | null, avatarUrl?: string | null, name?: string | null }> } | null }> } };

export type StaleModelFieldsFragment = { __typename?: 'StaleModel', id: string, name: string, materializationType: MaterializationType, lastMaterialisedAt?: any | null, sourcePath?: string | null };

export type StaleMaterializationsQueryVariables = Exact<{ [key: string]: never; }>;


export type StaleMaterializationsQuery = { __typename?: 'Query', staleMaterializations: { __typename?: 'StaleMaterializationsSummary', staleModels: Array<{ __typename?: 'StaleModel', id: string, name: string, materializationType: MaterializationType, lastMaterialisedAt?: any | null, sourcePath?: string | null }> } };

export type ReconcileStaleMaterializationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ReconcileStaleMaterializationsMutation = { __typename?: 'Mutation', reconcileStaleMaterializations: { __typename?: 'ReconcileStaleMaterializationsResult', staleModelIds: Array<string>, failures: Array<{ __typename?: 'ModelMaterializationFailure', modelId: string, modelName: string, error: string }> } };

export type ReconcileStaleMaterializationMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type ReconcileStaleMaterializationMutation = { __typename?: 'Mutation', reconcileStaleMaterialization: { __typename?: 'ReconcileStaleMaterializationsResult', staleModelIds: Array<string>, failures: Array<{ __typename?: 'ModelMaterializationFailure', modelId: string, modelName: string, error: string }> } };

export type CountryFragment = { __typename?: 'Country', code: string, name: string, currency: string, emoji: string, dial_code: string };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', code: string, name: string, currency: string, emoji: string, dial_code: string }> };

export type ResolveCountryFromTimeZoneQueryVariables = Exact<{
  timeZone: Scalars['String']['input'];
}>;


export type ResolveCountryFromTimeZoneQuery = { __typename?: 'Query', resolveCountryFromTimeZone: { __typename?: 'ResolveCountryResponse', country?: { __typename?: 'Country', code: string, name: string, currency: string, emoji: string, dial_code: string } | null } };

export type CountriesAndCurrentCountryQueryVariables = Exact<{
  timeZone: Scalars['String']['input'];
}>;


export type CountriesAndCurrentCountryQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', code: string, name: string, currency: string, emoji: string, dial_code: string }>, resolveCountryFromTimeZone: { __typename?: 'ResolveCountryResponse', country?: { __typename?: 'Country', code: string, name: string, currency: string, emoji: string, dial_code: string } | null } };

export type IntegrationConfigurationOptionsFragment = { __typename?: 'IntegrationConfiguration', hideSelectAllTables?: boolean | null, supportsStartDate?: boolean | null, usesAsyncStreams?: boolean | null, usesLazySchemas?: boolean | null, requiresConfiguration: boolean, supportsIdentifierCasing?: boolean | null, supportsRawViews?: boolean | null, supportsSoftDeletes?: boolean | null, startDateConfig?: { __typename?: 'StartDateConfiguration', defaultLookbackDays?: number | null, maxLookbackDays?: number | null, maxLookbackDaysDescription?: string | null } | null };

export type IntegrationConfigurationFragment = { __typename?: 'IntegrationConfiguration', id: string, name: string, forms: Array<any>, hideSelectAllTables?: boolean | null, supportsStartDate?: boolean | null, usesAsyncStreams?: boolean | null, usesLazySchemas?: boolean | null, requiresConfiguration: boolean, supportsIdentifierCasing?: boolean | null, supportsRawViews?: boolean | null, supportsSoftDeletes?: boolean | null, startDateConfig?: { __typename?: 'StartDateConfiguration', defaultLookbackDays?: number | null, maxLookbackDays?: number | null, maxLookbackDaysDescription?: string | null } | null };

export type IntegrationConfigurationQueryVariables = Exact<{
  id: Scalars['String']['input'];
  isDatawarehouse?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type IntegrationConfigurationQuery = { __typename?: 'Query', integrationConfiguration: { __typename?: 'IntegrationConfiguration', id: string, name: string, forms: Array<any>, hideSelectAllTables?: boolean | null, supportsStartDate?: boolean | null, usesAsyncStreams?: boolean | null, usesLazySchemas?: boolean | null, requiresConfiguration: boolean, supportsIdentifierCasing?: boolean | null, supportsRawViews?: boolean | null, supportsSoftDeletes?: boolean | null, startDateConfig?: { __typename?: 'StartDateConfiguration', defaultLookbackDays?: number | null, maxLookbackDays?: number | null, maxLookbackDaysDescription?: string | null } | null } };

export type DataConnectorMetadataFragment = { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string>, changeDataCaptureSupported: boolean };

export type AvailableIntegrationFragment = { __typename?: 'AvailableIntegration', abilities: Array<IntegrationAbility>, baseId: string, categories: Array<string>, id: string, isUtilityConnector: boolean, name: string, requiresAdmin?: boolean | null, meetsPlanRequirement: boolean, minRequiredPlan?: PlanName | null, aliasMetadata?: { __typename?: 'AliasMetadata', id: string, name: string } | null, config?: { __typename?: 'IntegrationConfiguration', hideSelectAllTables?: boolean | null, supportsStartDate?: boolean | null, usesAsyncStreams?: boolean | null, usesLazySchemas?: boolean | null, requiresConfiguration: boolean, supportsIdentifierCasing?: boolean | null, supportsRawViews?: boolean | null, supportsSoftDeletes?: boolean | null, startDateConfig?: { __typename?: 'StartDateConfiguration', defaultLookbackDays?: number | null, maxLookbackDays?: number | null, maxLookbackDaysDescription?: string | null } | null } | null, logo: { __typename?: 'IntegrationLogoVariants', default?: string | null, dark?: string | null }, eltSource?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string>, changeDataCaptureSupported: boolean } | null, activateDestination?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string>, changeDataCaptureSupported: boolean } | null, dataWarehouse?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string>, changeDataCaptureSupported: boolean } | null };

export type AvailableIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableIntegrationsQuery = { __typename?: 'Query', availableIntegrations: Array<{ __typename?: 'AvailableIntegration', abilities: Array<IntegrationAbility>, baseId: string, categories: Array<string>, id: string, isUtilityConnector: boolean, name: string, requiresAdmin?: boolean | null, meetsPlanRequirement: boolean, minRequiredPlan?: PlanName | null, aliasMetadata?: { __typename?: 'AliasMetadata', id: string, name: string } | null, config?: { __typename?: 'IntegrationConfiguration', hideSelectAllTables?: boolean | null, supportsStartDate?: boolean | null, usesAsyncStreams?: boolean | null, usesLazySchemas?: boolean | null, requiresConfiguration: boolean, supportsIdentifierCasing?: boolean | null, supportsRawViews?: boolean | null, supportsSoftDeletes?: boolean | null, startDateConfig?: { __typename?: 'StartDateConfiguration', defaultLookbackDays?: number | null, maxLookbackDays?: number | null, maxLookbackDaysDescription?: string | null } | null } | null, logo: { __typename?: 'IntegrationLogoVariants', default?: string | null, dark?: string | null }, eltSource?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string>, changeDataCaptureSupported: boolean } | null, activateDestination?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string>, changeDataCaptureSupported: boolean } | null, dataWarehouse?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string>, changeDataCaptureSupported: boolean } | null }> };

export type DestinationIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type DestinationIntegrationsQuery = { __typename?: 'Query', destinationIntegrations: Array<{ __typename?: 'AvailableIntegration', abilities: Array<IntegrationAbility>, baseId: string, categories: Array<string>, id: string, isUtilityConnector: boolean, name: string, requiresAdmin?: boolean | null, meetsPlanRequirement: boolean, minRequiredPlan?: PlanName | null, aliasMetadata?: { __typename?: 'AliasMetadata', id: string, name: string } | null, config?: { __typename?: 'IntegrationConfiguration', hideSelectAllTables?: boolean | null, supportsStartDate?: boolean | null, usesAsyncStreams?: boolean | null, usesLazySchemas?: boolean | null, requiresConfiguration: boolean, supportsIdentifierCasing?: boolean | null, supportsRawViews?: boolean | null, supportsSoftDeletes?: boolean | null, startDateConfig?: { __typename?: 'StartDateConfiguration', defaultLookbackDays?: number | null, maxLookbackDays?: number | null, maxLookbackDaysDescription?: string | null } | null } | null, logo: { __typename?: 'IntegrationLogoVariants', default?: string | null, dark?: string | null }, eltSource?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string>, changeDataCaptureSupported: boolean } | null, activateDestination?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string>, changeDataCaptureSupported: boolean } | null, dataWarehouse?: { __typename?: 'DataConnectorMetadata', minRequiredPlan?: PlanName | null, status: DevStatus, tags: Array<string>, changeDataCaptureSupported: boolean } | null }> };

export type PopularEltSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type PopularEltSourcesQuery = { __typename?: 'Query', popularEltSources: Array<string> };

export type LineageAccessQueryVariables = Exact<{
  input: LineageSourceInput;
}>;


export type LineageAccessQuery = { __typename?: 'Query', lineageAccess: { __typename?: 'LineageAccess', allowed: boolean, deniedSchemas: Array<string> } };

export type LineageGraphNodeFragment = { __typename?: 'LineageGraphNode', incoming: Array<string>, outgoing: Array<string>, item: { __typename: 'LineageGraphActivateSyncItem', id: string, scheduleType?: OrchestrationSchedulerType | null, workflowId?: string | null, type: string, syncId: string, destinationIntegrationId: string, status: string, syncInterval?: string | null, dependencies: Array<{ __typename?: 'LineageGraphDependency', id: string, type: string }>, workflow?: { __typename?: 'OrchestrationWorkflow', id: string, name: string, cronExpression: string } | null } | { __typename: 'LineageGraphModelItem', id: string, scheduleType?: OrchestrationSchedulerType | null, workflowId?: string | null, type: string, name: string, sourceConnectionId: string, folderName?: string | null, folderId?: string | null, isPublished: boolean, folderParent?: string | null, description?: string | null, materializationSchedule?: string | null, dependencies: Array<{ __typename?: 'LineageGraphDependency', id: string, type: string }>, dwTable?: { __typename?: 'MaterializedTableReference', status?: MaterialisationStatus | null, latestSyncTime?: string | null } | null, workflow?: { __typename?: 'OrchestrationWorkflow', id: string, name: string, cronExpression: string } | null } | { __typename: 'LineageGraphRawViewItem', id: string, scheduleType?: OrchestrationSchedulerType | null, workflowId?: string | null, type: string, path: Array<string>, schema: string, sourceStream: string, weldTag: string, rawViewSyncId?: string | null, dependencies: Array<{ __typename?: 'LineageGraphDependency', id: string, type: string }> } | { __typename: 'LineageGraphSourceStreamItem', id: string, scheduleType?: OrchestrationSchedulerType | null, workflowId?: string | null, type: string, sourceStreamId: string, sourceStreamName: string, eltSyncId: string, sourceIntegrationId: string, status: string, syncInterval?: string | null } | { __typename: 'LineageGraphWebhookItem', id: string, scheduleType?: OrchestrationSchedulerType | null, workflowId?: string | null, name: string, type: string, webhookId: string, webhookType: string, dependencies: Array<{ __typename?: 'LineageGraphDependency', id: string, type: string }> } };

export type WorkspaceLineageGraphQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspaceLineageGraphQuery = { __typename?: 'Query', workspaceLineageGraph: Array<{ __typename?: 'LineageGraphNode', incoming: Array<string>, outgoing: Array<string>, item: { __typename: 'LineageGraphActivateSyncItem', id: string, scheduleType?: OrchestrationSchedulerType | null, workflowId?: string | null, type: string, syncId: string, destinationIntegrationId: string, status: string, syncInterval?: string | null, dependencies: Array<{ __typename?: 'LineageGraphDependency', id: string, type: string }>, workflow?: { __typename?: 'OrchestrationWorkflow', id: string, name: string, cronExpression: string } | null } | { __typename: 'LineageGraphModelItem', id: string, scheduleType?: OrchestrationSchedulerType | null, workflowId?: string | null, type: string, name: string, sourceConnectionId: string, folderName?: string | null, folderId?: string | null, isPublished: boolean, folderParent?: string | null, description?: string | null, materializationSchedule?: string | null, dependencies: Array<{ __typename?: 'LineageGraphDependency', id: string, type: string }>, dwTable?: { __typename?: 'MaterializedTableReference', status?: MaterialisationStatus | null, latestSyncTime?: string | null } | null, workflow?: { __typename?: 'OrchestrationWorkflow', id: string, name: string, cronExpression: string } | null } | { __typename: 'LineageGraphRawViewItem', id: string, scheduleType?: OrchestrationSchedulerType | null, workflowId?: string | null, type: string, path: Array<string>, schema: string, sourceStream: string, weldTag: string, rawViewSyncId?: string | null, dependencies: Array<{ __typename?: 'LineageGraphDependency', id: string, type: string }> } | { __typename: 'LineageGraphSourceStreamItem', id: string, scheduleType?: OrchestrationSchedulerType | null, workflowId?: string | null, type: string, sourceStreamId: string, sourceStreamName: string, eltSyncId: string, sourceIntegrationId: string, status: string, syncInterval?: string | null } | { __typename: 'LineageGraphWebhookItem', id: string, scheduleType?: OrchestrationSchedulerType | null, workflowId?: string | null, name: string, type: string, webhookId: string, webhookType: string, dependencies: Array<{ __typename?: 'LineageGraphDependency', id: string, type: string }> } }> };

export type CreateModelTestMutationVariables = Exact<{
  createModelTestInput: CreateModelTestInput;
}>;


export type CreateModelTestMutation = { __typename?: 'Mutation', createModelTest: { __typename?: 'ModelTest', id: string } };

export type RemoveModelTestMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveModelTestMutation = { __typename?: 'Mutation', removeModelTest: { __typename?: 'ModelTest', id: string } };

export type ModelTestsByModelQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type ModelTestsByModelQuery = { __typename?: 'Query', model: { __typename?: 'Model', id: string, modelTests: Array<{ __typename?: 'ModelTest', id: string, column: string, type: TestType }> } };

export type StartTestQueryVariables = Exact<{
  modelTestId: Scalars['ID']['input'];
}>;


export type StartTestQuery = { __typename?: 'Query', startTest: { __typename?: 'ModelTestResult', modelTestId: string, status: TestStatus, queryExecutionId?: string | null, modelTestWeldSql?: string | null, failedRows?: Array<any> | null, error?: string | null } };

export type GetTestResultQueryVariables = Exact<{
  modelTestId: Scalars['ID']['input'];
  queryExecutionId: Scalars['String']['input'];
}>;


export type GetTestResultQuery = { __typename?: 'Query', getTestResult: { __typename?: 'ModelTestResult', modelTestId: string, status: TestStatus, queryExecutionId?: string | null, failedRows?: Array<any> | null, error?: string | null } };

export type ModelBaseFragment = { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, clusteringColumns?: string | null, partitionExpression?: string | null, publishedQueryId?: string | null, sourcePath?: string | null, rebuildTrigger: RebuildTrigger };

export type ModelViewReferenceFragmentFragment = { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string };

export type MaterializedTableReferenceFragmentFragment = { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null };

export type PublishedQueryBaseFragmentFragment = { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null };

export type PublishedQueryWithSqlFragmentFragment = { __typename?: 'SqlQuery', weldSql: string, id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null };

export type ModelPublishedFragmentFragment = { __typename?: 'Model', dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null };

export type ModelListItemFragment = { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, clusteringColumns?: string | null, partitionExpression?: string | null, publishedQueryId?: string | null, sourcePath?: string | null, rebuildTrigger: RebuildTrigger, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null };

export type CreateDraftModelMutationVariables = Exact<{
  name: Scalars['String']['input'];
  sourceConnectionId: Scalars['String']['input'];
  weldSql: Scalars['String']['input'];
  dashboardId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateDraftModelMutation = { __typename?: 'Mutation', createDraftModel: { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, clusteringColumns?: string | null, partitionExpression?: string | null, publishedQueryId?: string | null, sourcePath?: string | null, rebuildTrigger: RebuildTrigger, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null } };

export type PublishModelAsyncMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  query: QueryInput;
  materializationType: MaterializationType;
  materializationSchedule?: InputMaybe<Scalars['String']['input']>;
  modelFolderId: Scalars['String']['input'];
  orchestrationScheduler?: InputMaybe<OrchestrationSchedulerType>;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  isUnsavedModel: Scalars['Boolean']['input'];
  sourceConnectionId: Scalars['String']['input'];
  partitionExpression?: InputMaybe<Scalars['String']['input']>;
  clusteringColumns?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublishModelAsyncMutation = { __typename?: 'Mutation', publishModelAsync: string };

export type UpdatePublishedModelQueryAsyncMutationVariables = Exact<{
  id: Scalars['String']['input'];
  query: QueryInput;
}>;


export type UpdatePublishedModelQueryAsyncMutation = { __typename?: 'Mutation', updatePublishedModelQueryAsync: string };

export type UpdatePublishedModelMaterializationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  materializationType: MaterializationType;
  materializationSchedule?: InputMaybe<Scalars['String']['input']>;
  orchestrationScheduler?: InputMaybe<OrchestrationSchedulerType>;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  partitionExpression?: InputMaybe<Scalars['String']['input']>;
  clusteringColumns?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePublishedModelMaterializationMutation = { __typename?: 'Mutation', updatePublishedModelMaterialization: { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, clusteringColumns?: string | null, partitionExpression?: string | null, publishedQueryId?: string | null, sourcePath?: string | null, rebuildTrigger: RebuildTrigger, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null } };

export type UpdateDraftModelNameMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateDraftModelNameMutation = { __typename?: 'Mutation', updateDraftModelName: { __typename?: 'Model', id: string, name: string } };

export type UpdateUnpublishedModelQueryMutationVariables = Exact<{
  id: Scalars['String']['input'];
  query: QueryInput;
}>;


export type UpdateUnpublishedModelQueryMutation = { __typename?: 'Mutation', updateUnpublishedModelSqlQuery: { __typename?: 'SqlQuery', id: string } };

export type UpdateModelDocumentationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  documentation: Scalars['String']['input'];
}>;


export type UpdateModelDocumentationMutation = { __typename?: 'Mutation', updateModelDocumentation: { __typename?: 'Model', id: string, documentation?: string | null } };

export type MoveModelMutationVariables = Exact<{
  id: Scalars['String']['input'];
  modelFolderId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type MoveModelMutation = { __typename?: 'Mutation', moveModel: { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, clusteringColumns?: string | null, partitionExpression?: string | null, publishedQueryId?: string | null, sourcePath?: string | null, rebuildTrigger: RebuildTrigger, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null } };

export type RemoveModelMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type RemoveModelMutation = { __typename?: 'Mutation', removeModel: { __typename?: 'Model', id: string } };

export type RemoveDashboardModelsMutationVariables = Exact<{
  dashboardId: Scalars['String']['input'];
}>;


export type RemoveDashboardModelsMutation = { __typename?: 'Mutation', removeDashboardModels: Array<{ __typename?: 'Model', id: string }> };

export type RematerializeNowMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type RematerializeNowMutation = { __typename?: 'Mutation', rematerializeNow: { __typename?: 'Model', id: string, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null } };

export type UpdateModelEmojiMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
  emoji?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateModelEmojiMutation = { __typename?: 'Mutation', updateModelEmoji: { __typename?: 'Model', id: string, emoji?: string | null } };

export type UpdateFolderEmojiMutationVariables = Exact<{
  folderId: Scalars['String']['input'];
  emoji?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateFolderEmojiMutation = { __typename?: 'Mutation', updateFolderEmoji: boolean };

export type ModelQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type ModelQuery = { __typename?: 'Query', model: { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, clusteringColumns?: string | null, partitionExpression?: string | null, publishedQueryId?: string | null, sourcePath?: string | null, rebuildTrigger: RebuildTrigger, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null } };

export type ModelsByIdsQueryVariables = Exact<{
  modelIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ModelsByIdsQuery = { __typename?: 'Query', modelsByIds: Array<{ __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, clusteringColumns?: string | null, partitionExpression?: string | null, publishedQueryId?: string | null, sourcePath?: string | null, rebuildTrigger: RebuildTrigger, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null }> };

export type PublishedModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type PublishedModelsQuery = { __typename?: 'Query', publishedModels: Array<{ __typename?: 'Model', dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, clusteringColumns?: string | null, partitionExpression?: string | null, publishedQueryId?: string | null, sourcePath?: string | null, rebuildTrigger: RebuildTrigger, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null }> };

export type SavedDraftModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type SavedDraftModelsQuery = { __typename?: 'Query', savedDrafts: Array<{ __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, clusteringColumns?: string | null, partitionExpression?: string | null, publishedQueryId?: string | null, sourcePath?: string | null, rebuildTrigger: RebuildTrigger }> };

export type MostRecentPublishedModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type MostRecentPublishedModelsQuery = { __typename?: 'Query', mostRecentPublishedModels: Array<{ __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, clusteringColumns?: string | null, partitionExpression?: string | null, publishedQueryId?: string | null, sourcePath?: string | null, rebuildTrigger: RebuildTrigger, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null }> };

export type ModelUsageSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type ModelUsageSummaryQuery = { __typename?: 'Query', modelUsageSummary: { __typename?: 'ModelUsageSummaryDto', publishedModels: number, draftModels: number } };

export type ModelSearchResultFragment = { __typename?: 'Model', id: string, name: string, emoji?: string | null, publishedQueryId?: string | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null };

export type SearchModelsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  publishedOnly: Scalars['Boolean']['input'];
}>;


export type SearchModelsQuery = { __typename?: 'Query', searchModels: Array<{ __typename?: 'Model', id: string, name: string, emoji?: string | null, publishedQueryId?: string | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null }> };

export type ListDeletedModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListDeletedModelsQuery = { __typename?: 'Query', deletedModels: Array<{ __typename?: 'Model', id: string, name: string, integrationId: string, createdAt: any, userId?: string | null, emoji?: string | null }> };

export type HasDeletedModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type HasDeletedModelsQuery = { __typename?: 'Query', hasDeletedModels: { __typename?: 'HasDeletedModelsResponse', value: boolean } };

export type RestoreDeletedModelMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type RestoreDeletedModelMutation = { __typename?: 'Mutation', restoreDeletedModel: { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, clusteringColumns?: string | null, partitionExpression?: string | null, publishedQueryId?: string | null, sourcePath?: string | null, rebuildTrigger: RebuildTrigger, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null } };

export type UpdateModelTableReferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type UpdateModelTableReferencesQuery = { __typename?: 'Query', publishedModels: Array<{ __typename?: 'Model', dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null }> };

export type GetLocalMaterializationJobQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type GetLocalMaterializationJobQuery = { __typename?: 'Query', model: { __typename?: 'Model', id: string, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', modelId: string, queryId: string, status: string, lastRun?: number | null, nextRun: number, startedAt?: string | null, cronExpression: string, latestErrorMessage?: string | null } | null } };

export type SqlQueryQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type SqlQueryQuery = { __typename?: 'Query', model: { __typename?: 'Model', id: string, publishedQuery?: { __typename?: 'SqlQuery', weldSql: string, id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null } };

export type ModelDocumentationQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type ModelDocumentationQuery = { __typename?: 'Query', model: { __typename?: 'Model', documentation?: string | null } };

export type FindQueryHistoryQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type FindQueryHistoryQuery = { __typename?: 'Query', model: { __typename?: 'Model', id: string, sqlQueries: Array<{ __typename?: 'SqlQuery', id: string, data: string, weldSql: string, createdAt: any, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, email: string } | null }> } };

export type GetDwDirectoryQueryVariables = Exact<{
  input: GetDwDirectoryInput;
}>;


export type GetDwDirectoryQuery = { __typename?: 'Query', getDWDirectory: { __typename?: 'Directory', typename: string, children: Array<string>, hasNext: boolean } };

export type GetDwDirectoryItemsQueryVariables = Exact<{
  input: GetDwDirectoryItemsInput;
}>;


export type GetDwDirectoryItemsQuery = { __typename?: 'Query', getDWDirectoryItems: Array<{ __typename?: 'DwDirectoryItem', path: Array<string> }> };

export type ImportDwDirectoryMutationVariables = Exact<{
  input: ImportDwDirectoryInput;
}>;


export type ImportDwDirectoryMutation = { __typename?: 'Mutation', importDWDirectory: Array<{ __typename?: 'DwDirectoryItem', path: Array<string>, error?: string | null, viewId?: string | null }> };

export type ListModelFoldersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListModelFoldersQuery = { __typename?: 'Query', listModelFolders: Array<{ __typename?: 'ModelFolder', id: string, name: string, emoji?: string | null, type?: ModelType | null, parentId?: string | null, DWName: string }> };

export type VerifyUnpublishedChangesQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type VerifyUnpublishedChangesQuery = { __typename?: 'Query', verifyUnpublishedChanges: { __typename?: 'VerifyUnpublishedChangesResponse', hasUnpublishedChanges: boolean } };

export type CreateModelFolderMutationVariables = Exact<{
  input: CreateFolderInput;
}>;


export type CreateModelFolderMutation = { __typename?: 'Mutation', createModelFolder: { __typename?: 'ModelFolder', name: string, type?: ModelType | null, DWName: string, id: string } };

export type DeleteModelFolderMutationVariables = Exact<{
  folderId: Scalars['String']['input'];
}>;


export type DeleteModelFolderMutation = { __typename?: 'Mutation', deleteModelFolder: { __typename?: 'ModelFolder', name: string, type?: ModelType | null } };

export type DeleteFolderWithContentMutationVariables = Exact<{
  folderId: Scalars['String']['input'];
}>;


export type DeleteFolderWithContentMutation = { __typename?: 'Mutation', deleteFolderWithContent: string };

export type UnpublishModelMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type UnpublishModelMutation = { __typename?: 'Mutation', unpublishModel: { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, clusteringColumns?: string | null, partitionExpression?: string | null, publishedQueryId?: string | null, sourcePath?: string | null, rebuildTrigger: RebuildTrigger, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null } };

export type DeleteRawViewMutationVariables = Exact<{
  viewId: Scalars['String']['input'];
}>;


export type DeleteRawViewMutation = { __typename?: 'Mutation', deleteRawView?: boolean | null };

export type QueryModelQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type QueryModelQuery = { __typename?: 'Query', queryModel: { __typename?: 'QueryModelResponse', id: string, response: Array<any>, dwSql: string } };

export type OrchestratedModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrchestratedModelsQuery = { __typename?: 'Query', publishedModels: Array<{ __typename?: 'Model', dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, clusteringColumns?: string | null, partitionExpression?: string | null, publishedQueryId?: string | null, sourcePath?: string | null, rebuildTrigger: RebuildTrigger, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null, publishedQuery?: { __typename?: 'SqlQuery', weldSql: string, id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null }> };

export type MyRecentlyEditedModelsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyRecentlyEditedModelsQuery = { __typename?: 'Query', myRecentlyEditedModels: Array<{ __typename?: 'RecentlyEditedModel', editedAt: any, model: { __typename?: 'Model', id: string, name: string, createdAt: any, emoji?: string | null, type?: ModelType | null, materializationType: MaterializationType, clusteringColumns?: string | null, partitionExpression?: string | null, publishedQueryId?: string | null, sourcePath?: string | null, rebuildTrigger: RebuildTrigger, dashboardId?: string | null, orchestrationScheduler?: OrchestrationSchedulerType | null, materializationSchedule?: string | null, templateId?: string | null, templateItemId?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string, parentId?: string | null } | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null, publishedQuery?: { __typename?: 'SqlQuery', id: string, createdAt: any, userId?: string | null, dependencies?: Array<{ __typename?: 'QueryDependencyEntity', dwItemId: string, type: DependencyType, weldTag: string }> | null } | null, dwSync?: { __typename?: 'ModelViewReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime: string } | null, dwTable?: { __typename?: 'MaterializedTableReference', modelId: string, queryId: string, type: DependencyType, path: Array<string>, weldTag: string, dwSqlReference: string, createdAt: string, latestSyncTime?: string | null, status?: MaterialisationStatus | null, latestRunErrorMessage?: string | null } | null, localMaterializationJob?: { __typename?: 'LocalMaterializationJob', queryId: string, status: string, lastRun?: number | null, nextRun: number, cronExpression: string, latestErrorMessage?: string | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null } }> };

export type ObjectTypeFragment = { __typename?: 'ObjectType', id: string, objectName: string, objectTypeId: string, associations: Array<string>, supportedDestinationMapping: Array<string>, offerOnlyPrimaryKeysAsIdentifiers?: boolean | null };

export type ListObjectTypesQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
}>;


export type ListObjectTypesQuery = { __typename?: 'Query', objectTypes: Array<{ __typename?: 'ObjectType', id: string, objectName: string, objectTypeId: string, associations: Array<string>, supportedDestinationMapping: Array<string>, offerOnlyPrimaryKeysAsIdentifiers?: boolean | null }> };

export type IncidentUpdateFragment = { __typename?: 'IncidentUpdate', body: string, createdAt: any, displayAt: any, id: string, incidentId: string, status: string, updatedAt: string };

export type IncidentFragment = { __typename?: 'Incident', createdAt: any, id: string, impact: string, name: string, resolvedAt?: any | null, shortlink: string, status: string, updatedAt: any, scheduledFor: any, scheduledUntil: any, incidentUpdates: Array<{ __typename?: 'IncidentUpdate', body: string, createdAt: any, displayAt: any, id: string, incidentId: string, status: string, updatedAt: string }> };

export type UnresolvedIncidentsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnresolvedIncidentsQuery = { __typename?: 'Query', unresolvedIncidents: Array<{ __typename?: 'Incident', createdAt: any, id: string, impact: string, name: string, resolvedAt?: any | null, shortlink: string, status: string, updatedAt: any, scheduledFor: any, scheduledUntil: any, incidentUpdates: Array<{ __typename?: 'IncidentUpdate', body: string, createdAt: any, displayAt: any, id: string, incidentId: string, status: string, updatedAt: string }> }> };

export type ScheduledIncidentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ScheduledIncidentsQuery = { __typename?: 'Query', scheduledIncidents: Array<{ __typename?: 'Incident', createdAt: any, id: string, impact: string, name: string, resolvedAt?: any | null, shortlink: string, status: string, updatedAt: any, scheduledFor: any, scheduledUntil: any, incidentUpdates: Array<{ __typename?: 'IncidentUpdate', body: string, createdAt: any, displayAt: any, id: string, incidentId: string, status: string, updatedAt: string }> }> };

export type OperationModeOptionFragment = { __typename?: 'FindAvailableOperationsResponse', id: string, operationType: OperationTypes, operationMode: OperationModes, primaryKeyRequired: boolean, integrationId: string };

export type FindAvailableOperationsQueryVariables = Exact<{
  connectionId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
}>;


export type FindAvailableOperationsQuery = { __typename?: 'Query', findAllAvailableOperations: Array<{ __typename?: 'FindAvailableOperationsResponse', id: string, operationType: OperationTypes, operationMode: OperationModes, primaryKeyRequired: boolean, integrationId: string }> };

export type OrchestrationWorkflowRunFragment = { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus };

export type ModelTestRunFragment = { __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null };

export type OrchestrationJobFragment = { __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string } | { __typename?: 'ModelViewReference', modelId: string } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null };

export type OrchestrationWorkflowFragment = { __typename?: 'OrchestrationWorkflow', id: string, name: string, description?: string | null, active: boolean, cronExpression: string, currentRun?: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string, modelTestRuns: Array<{ __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null }> } | { __typename?: 'ModelViewReference', modelId: string, modelTestRuns: Array<{ __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null }> } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } | null, nextRun?: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string } | { __typename?: 'ModelViewReference', modelId: string } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } | null };

export type CreateWorkflowMutationVariables = Exact<{
  cronExpression: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateWorkflowMutation = { __typename?: 'Mutation', createWorkflow: { __typename?: 'OrchestrationWorkflow', id: string, name: string, description?: string | null, active: boolean, cronExpression: string, currentRun?: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string, modelTestRuns: Array<{ __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null }> } | { __typename?: 'ModelViewReference', modelId: string, modelTestRuns: Array<{ __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null }> } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } | null, nextRun?: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string } | { __typename?: 'ModelViewReference', modelId: string } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } | null } };

export type EditWorkflowMutationVariables = Exact<{
  cronExpression?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  workflowId: Scalars['ID']['input'];
}>;


export type EditWorkflowMutation = { __typename?: 'Mutation', editWorkflow: { __typename?: 'OrchestrationWorkflow', id: string, name: string, description?: string | null, active: boolean, cronExpression: string, currentRun?: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string, modelTestRuns: Array<{ __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null }> } | { __typename?: 'ModelViewReference', modelId: string, modelTestRuns: Array<{ __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null }> } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } | null, nextRun?: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string } | { __typename?: 'ModelViewReference', modelId: string } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } | null } };

export type DeleteWorkflowMutationVariables = Exact<{
  workflowId: Scalars['ID']['input'];
  cronSchedule: Scalars['String']['input'];
}>;


export type DeleteWorkflowMutation = { __typename?: 'Mutation', deleteWorkflow: string };

export type OrchestrationWorkflowHistoryQueryVariables = Exact<{
  workflowId: Scalars['ID']['input'];
}>;


export type OrchestrationWorkflowHistoryQuery = { __typename?: 'Query', orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, accountId: string, cronExpression: string, runs: Array<{ __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus }> } | null };

export type ListOrchestrationWorkflowOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOrchestrationWorkflowOptionsQuery = { __typename?: 'Query', orchestrationWorkflows: Array<{ __typename?: 'OrchestrationWorkflow', id: string, name: string, active: boolean, cronExpression: string }> };

export type ListOrchestrationWorkflowsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOrchestrationWorkflowsQuery = { __typename?: 'Query', orchestrationWorkflows: Array<{ __typename?: 'OrchestrationWorkflow', id: string, name: string, description?: string | null, active: boolean, cronExpression: string, contents: { __typename?: 'OrchestrationWorkflowContents', models: number, sourceStreams: number, reverseEtlSyncs: number, webhooks: number }, currentRun?: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string } | { __typename?: 'ModelViewReference', modelId: string } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } | null, nextRun?: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string } | { __typename?: 'ModelViewReference', modelId: string } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } | null }> };

export type OrchestrationWorkflowQueryVariables = Exact<{
  workflowId: Scalars['ID']['input'];
}>;


export type OrchestrationWorkflowQuery = { __typename?: 'Query', orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, name: string, description?: string | null, active: boolean, cronExpression: string, currentRun?: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string, modelTestRuns: Array<{ __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null }> } | { __typename?: 'ModelViewReference', modelId: string, modelTestRuns: Array<{ __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null }> } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } | null, nextRun?: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string } | { __typename?: 'ModelViewReference', modelId: string } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } | null } | null };

export type OrchestrationWorkflowRunQueryVariables = Exact<{
  runId: Scalars['ID']['input'];
}>;


export type OrchestrationWorkflowRunQuery = { __typename?: 'Query', orchestrationWorkflowRun: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string, modelTestRuns: Array<{ __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null }> } | { __typename?: 'ModelViewReference', modelId: string, modelTestRuns: Array<{ __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null }> } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } };

export type StartWorkflowNowMutationVariables = Exact<{
  workflowId: Scalars['ID']['input'];
}>;


export type StartWorkflowNowMutation = { __typename?: 'Mutation', runOrchestrationWorkflowNow: { __typename?: 'OrchestrationWorkflow', nextRun?: { __typename?: 'OrchestrationWorkflowRun', id: string } | null } };

export type CancelCurrentWorkflowRunMutationVariables = Exact<{
  workflowId: Scalars['ID']['input'];
}>;


export type CancelCurrentWorkflowRunMutation = { __typename?: 'Mutation', cancelCurrentWorkflowRun: { __typename?: 'OrchestrationWorkflow', nextRun?: { __typename?: 'OrchestrationWorkflowRun', id: string } | null } };

export type SetWorkflowActiveMutationVariables = Exact<{
  workflowId: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type SetWorkflowActiveMutation = { __typename?: 'Mutation', setWorkflowActive: { __typename?: 'OrchestrationWorkflow', id: string, name: string, description?: string | null, active: boolean, cronExpression: string, currentRun?: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string, modelTestRuns: Array<{ __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null }> } | { __typename?: 'ModelViewReference', modelId: string, modelTestRuns: Array<{ __typename?: 'ModelTestRun', workflowRunId: string, modelTestId: string, result?: { __typename?: 'ModelTestRunResult', rows?: Array<any> | null, status: ModelTestStatus, numRowsTotal?: number | null, error?: string | null } | null }> } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } | null, nextRun?: { __typename?: 'OrchestrationWorkflowRun', id: string, dueAt: any, startedAt?: any | null, finishedAt?: any | null, status: WorkflowRunStatus, jobs: Array<{ __typename?: 'WorkflowJob', itemId: string, order: number, errorMessage?: string | null, status: WorkflowJobStatus, incomingDependencies: Array<string>, outgoingDependencies: Array<string>, target?: { __typename?: 'MaterializedTableReference', modelId: string } | { __typename?: 'ModelViewReference', modelId: string } | { __typename?: 'RawViewReference', viewId: string } | { __typename?: 'SourceStream', id: string, name: string, eltSync: { __typename?: 'EltSync', id: string } } | { __typename?: 'Sync', id: string } | { __typename?: 'Webhook', id: string } | null }> } | null } };

export type ClaimPromoCodeMutationVariables = Exact<{
  input: ClaimPromoCodeInput;
}>;


export type ClaimPromoCodeMutation = { __typename?: 'Mutation', claimPromoCode: boolean };

export type ValidatePromoCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
  flow?: InputMaybe<Scalars['String']['input']>;
}>;


export type ValidatePromoCodeQuery = { __typename?: 'Query', validatePromoCode: { __typename?: 'ValidatedPromoCode', code: string, promoId: string, name: string, percentOff?: number | null, amountOff?: number | null, duration: PromoDuration, durationInMonths?: number | null } };

export type SourcePropertyFragment = { __typename?: 'DataSchema', name: string, type: string, nullable: boolean };

export type SourcePropertiesQueryVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type SourcePropertiesQuery = { __typename?: 'Query', sourceProperties: { __typename?: 'ViewDetails', dataSchema: Array<{ __typename?: 'DataSchema', name: string, type: string, nullable: boolean }> } };

export type DestinationPropertyFragment = { __typename?: 'Property', id: string, propertyId: string, propertyName: string, propertyType: string, readonly: boolean, isRequired: boolean, isPrimaryKey: boolean, automapMatchAny: boolean };

export type DestinationPropertiesQueryVariables = Exact<{
  destinationConnectionId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  operationMode: Scalars['String']['input'];
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DestinationPropertiesQuery = { __typename?: 'Query', destinationProperties: Array<{ __typename?: 'Property', id: string, propertyId: string, propertyName: string, propertyType: string, readonly: boolean, isRequired: boolean, isPrimaryKey: boolean, automapMatchAny: boolean }> };

export type DateRangeFragment = { __typename?: 'DateRange', start: any, end: any };

export type SaveSignupQuestionnaireResultMutationVariables = Exact<{
  input: SaveSignupQuestionnaireResultInput;
}>;


export type SaveSignupQuestionnaireResultMutation = { __typename?: 'Mutation', saveSignupQuestionnaireResult: boolean };

export type GetSignupQuestionnaireResultQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSignupQuestionnaireResultQuery = { __typename?: 'Query', getSignupQuestionnaireResult: { __typename?: 'GetSignupQuestionnaireResponse', result?: { __typename?: 'SignupQuestionnaireResult', userId: string, result: any, timestamp: number } | null } };

export type StripePaymentMethodFragment = { __typename?: 'PaymentMethod', card: { __typename?: 'Card', last4: string, brand: CardBrand, expirationMonth: number, expirationYear: number } };

export type StripeCustomerFragment = { __typename?: 'Customer', id: string, companyName?: string | null, email?: string | null, currency?: string | null, taxId?: { __typename?: 'TaxId', type: string, country: string, value: string } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, state?: string | null } | null, defaultPaymentMethod?: { __typename?: 'PaymentMethod', card: { __typename?: 'Card', last4: string, brand: CardBrand, expirationMonth: number, expirationYear: number } } | null };

export type PriceFragment = { __typename?: 'Price', id: string, currency: string, price: number, billingScheme: BillingScheme, tiersMode?: TiersMode | null, lookupKey?: string | null, recurring?: { __typename?: 'Recurring', interval: RecurrenceInterval, intervalCount: number, usageType: RecurrenceUsageType } | null, tiers?: Array<{ __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null }> | null, currencyOptions: Array<{ __typename?: 'CurrencyOption', currency: string, price: number }>, transformQuantity?: { __typename?: 'TransformQuantity', divideBy: number } | null };

export type StripeSubscriptionItemFragment = { __typename?: 'StripeSubscriptionItem', quantity: number, price: { __typename?: 'StripeSubscriptionItemPrice', id: string, currency: string, price: number, billingScheme: BillingScheme, lookupKey?: string | null, product: { __typename?: 'BaseProduct', id: string, name: string, description?: string | null, image?: string | null, type: WeldProductType, addOnType?: WeldAddOnType | null, active: boolean, features: { __typename?: 'StripePlanFeatures', limitRows?: number | null, limitUsers?: number | null, limitConnectors?: number | null, minSyncIntervalInMinutes?: number | null } }, recurring?: { __typename?: 'Recurring', interval: RecurrenceInterval, intervalCount: number, usageType: RecurrenceUsageType } | null, tiers?: Array<{ __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null }> | null, currencyOptions: Array<{ __typename?: 'CurrencyOption', currency: string, price: number }> }, tier?: { __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null } | null };

export type StripePlanFeaturesFragment = { __typename?: 'StripePlanFeatures', limitRows?: number | null, limitUsers?: number | null, limitConnectors?: number | null, minSyncIntervalInMinutes?: number | null };

export type StripeSubscriptionQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type StripeSubscriptionQuery = { __typename?: 'Query', accountBySlug: { __typename?: 'Account', id: string, slug: string, stripeCustomer?: { __typename?: 'Customer', id: string, companyName?: string | null, email?: string | null, currency?: string | null, taxId?: { __typename?: 'TaxId', type: string, country: string, value: string } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, state?: string | null } | null, defaultPaymentMethod?: { __typename?: 'PaymentMethod', card: { __typename?: 'Card', last4: string, brand: CardBrand, expirationMonth: number, expirationYear: number } } | null } | null, stripeSubscription?: { __typename?: 'StripeSubscription', stripeSubscriptionDetails: { __typename?: 'StripeSubscriptionDetails', id: string, status: StripeSubscriptionStatus, createdDate: any, trialEndDate?: any | null, cancelDate?: any | null, currentPeriodStartDate: any, currentPeriodEndDate: any, planName: PlanName, items: Array<{ __typename?: 'StripeSubscriptionItem', quantity: number, price: { __typename?: 'StripeSubscriptionItemPrice', id: string, currency: string, price: number, billingScheme: BillingScheme, lookupKey?: string | null, product: { __typename?: 'BaseProduct', id: string, name: string, description?: string | null, image?: string | null, type: WeldProductType, addOnType?: WeldAddOnType | null, active: boolean, features: { __typename?: 'StripePlanFeatures', limitRows?: number | null, limitUsers?: number | null, limitConnectors?: number | null, minSyncIntervalInMinutes?: number | null } }, recurring?: { __typename?: 'Recurring', interval: RecurrenceInterval, intervalCount: number, usageType: RecurrenceUsageType } | null, tiers?: Array<{ __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null }> | null, currencyOptions: Array<{ __typename?: 'CurrencyOption', currency: string, price: number }> }, tier?: { __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null } | null }> } } | null } };

export type StripeCustomerQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type StripeCustomerQuery = { __typename?: 'Query', accountBySlug: { __typename?: 'Account', stripeCustomer?: { __typename?: 'Customer', id: string, companyName?: string | null, email?: string | null, currency?: string | null, taxId?: { __typename?: 'TaxId', type: string, country: string, value: string } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, state?: string | null } | null, defaultPaymentMethod?: { __typename?: 'PaymentMethod', card: { __typename?: 'Card', last4: string, brand: CardBrand, expirationMonth: number, expirationYear: number } } | null } | null } };

export type StripeCustomerByIdQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type StripeCustomerByIdQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, companyName?: string | null, email?: string | null, currency?: string | null, taxId?: { __typename?: 'TaxId', type: string, country: string, value: string } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, state?: string | null } | null, defaultPaymentMethod?: { __typename?: 'PaymentMethod', card: { __typename?: 'Card', last4: string, brand: CardBrand, expirationMonth: number, expirationYear: number } } | null } | null };

export type CreateOrUpdateCustomerMutationVariables = Exact<{
  input: CreateOrUpdateCustomerInput;
}>;


export type CreateOrUpdateCustomerMutation = { __typename?: 'Mutation', createOrUpdateCustomer: { __typename?: 'Customer', id: string, companyName?: string | null, email?: string | null, currency?: string | null, taxId?: { __typename?: 'TaxId', type: string, country: string, value: string } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, state?: string | null } | null, defaultPaymentMethod?: { __typename?: 'PaymentMethod', card: { __typename?: 'Card', last4: string, brand: CardBrand, expirationMonth: number, expirationYear: number } } | null } };

export type CreateOrUpdateWeldSubscriptionMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  numConnectors: Scalars['Int']['input'];
  numUsers: Scalars['Int']['input'];
  numRows?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  promoId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOrUpdateWeldSubscriptionMutation = { __typename?: 'Mutation', createOrUpdateWeldSubscription: { __typename?: 'CreateSubscriptionResponse', id: string, paymentIntentClientSecret?: string | null } };

export type CancelWeldSubscriptionMutationVariables = Exact<{
  input: CancelSubscriptionInput;
}>;


export type CancelWeldSubscriptionMutation = { __typename?: 'Mutation', cancelWeldSubscription: { __typename?: 'CancelSubscriptionResponse', id: string } };

export type RevertWeldSubscriptionCancellationMutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
}>;


export type RevertWeldSubscriptionCancellationMutation = { __typename?: 'Mutation', revertSubscriptionCancelation: { __typename?: 'CancelSubscriptionResponse', id: string } };

export type UpdatePaymentMethodMutationVariables = Exact<{
  input: CreatePaymentMethodCheckoutSessionInput;
}>;


export type UpdatePaymentMethodMutation = { __typename?: 'Mutation', createPaymentMethodCheckoutSession: { __typename?: 'CheckoutSession', id: string, url: string, expiresAt: any } };

export type UpdateBillingDetailsMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  billingDetails: BillingDetailsInput;
}>;


export type UpdateBillingDetailsMutation = { __typename?: 'Mutation', updateBillingDetails: { __typename?: 'Customer', id: string, email?: string | null } };

export type ProductPriceByLookupKeyQueryVariables = Exact<{
  lookupKey: Scalars['String']['input'];
  currency: Scalars['String']['input'];
}>;


export type ProductPriceByLookupKeyQuery = { __typename?: 'Query', getProductPriceByLookupKey: { __typename?: 'Price', id: string, currency: string, price: number, billingScheme: BillingScheme, tiersMode?: TiersMode | null, lookupKey?: string | null, currencyOptions: Array<{ __typename?: 'CurrencyOption', currency: string, price: number, tiers?: Array<{ __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null }> | null }>, recurring?: { __typename?: 'Recurring', interval: RecurrenceInterval, intervalCount: number, usageType: RecurrenceUsageType } | null, tiers?: Array<{ __typename?: 'Tier', price?: number | null, upTo?: number | null, unitAmount?: number | null }> | null, transformQuantity?: { __typename?: 'TransformQuantity', divideBy: number } | null } };

export type StripeInvoiceFragment = { __typename?: 'Invoice', id: string, chargeStatus?: StripeChargeStatus | null, chargeFailureMessage?: string | null, currency: string, dueDate: any, hostedInvoiceUrl?: string | null, periodStart: any, periodEnd: any, status?: InvoiceStatus | null, total: number };

export type InvoicesQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type InvoicesQuery = { __typename?: 'Query', invoices: Array<{ __typename?: 'Invoice', id: string, chargeStatus?: StripeChargeStatus | null, chargeFailureMessage?: string | null, currency: string, dueDate: any, hostedInvoiceUrl?: string | null, periodStart: any, periodEnd: any, status?: InvoiceStatus | null, total: number }> };

export type InvoiceBreakdownItemFragment = { __typename?: 'InvoiceBreakdownItem', amount: number, unitAmount?: number | null, unitQuantity?: number | null, quantity?: number | null, label: string, description?: string | null, metered?: boolean | null };

export type InvoiceDiscountFragment = { __typename?: 'DiscountItem', amount: number, name: string, percentOff?: number | null, amountOff?: number | null, duration?: PromoDuration | null, durationInMonths?: number | null };

export type AppliedPromoFragment = { __typename?: 'AppliedPromo', code?: string | null, source: PromoSource };

export type InvoiceTaxesFragment = { __typename?: 'InvoiceTaxes', amount: number, percentage: number, displayName: string };

export type UpcomingInvoiceFragment = { __typename?: 'UpcomingInvoice', total: number, subTotal: number, currency: string, createdDate: any, periodStart: any, periodEnd: any, trialEnd?: any | null, subscriptionStatus?: StripeSubscriptionStatus | null, taxes: Array<{ __typename?: 'InvoiceTaxes', amount: number, percentage: number, displayName: string }>, breakdown?: Array<{ __typename?: 'InvoiceBreakdownItem', amount: number, unitAmount?: number | null, unitQuantity?: number | null, quantity?: number | null, label: string, description?: string | null, metered?: boolean | null }> | null, discounts: Array<{ __typename?: 'DiscountItem', amount: number, name: string, percentOff?: number | null, amountOff?: number | null, duration?: PromoDuration | null, durationInMonths?: number | null }>, appliedPromo?: { __typename?: 'AppliedPromo', code?: string | null, source: PromoSource } | null };

export type CheckoutPreviewQueryVariables = Exact<{
  input: InvoicePreviewInput;
}>;


export type CheckoutPreviewQuery = { __typename?: 'Query', getCheckoutPreview: { __typename?: 'UpcomingInvoice', total: number, subTotal: number, currency: string, createdDate: any, periodStart: any, periodEnd: any, trialEnd?: any | null, subscriptionStatus?: StripeSubscriptionStatus | null, taxes: Array<{ __typename?: 'InvoiceTaxes', amount: number, percentage: number, displayName: string }>, breakdown?: Array<{ __typename?: 'InvoiceBreakdownItem', amount: number, unitAmount?: number | null, unitQuantity?: number | null, quantity?: number | null, label: string, description?: string | null, metered?: boolean | null }> | null, discounts: Array<{ __typename?: 'DiscountItem', amount: number, name: string, percentOff?: number | null, amountOff?: number | null, duration?: PromoDuration | null, durationInMonths?: number | null }>, appliedPromo?: { __typename?: 'AppliedPromo', code?: string | null, source: PromoSource } | null } };

export type UpcomingInvoiceQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
}>;


export type UpcomingInvoiceQuery = { __typename?: 'Query', upcomingInvoice?: { __typename?: 'UpcomingInvoice', total: number, subTotal: number, currency: string, createdDate: any, periodStart: any, periodEnd: any, trialEnd?: any | null, subscriptionStatus?: StripeSubscriptionStatus | null, taxes: Array<{ __typename?: 'InvoiceTaxes', amount: number, percentage: number, displayName: string }>, breakdown?: Array<{ __typename?: 'InvoiceBreakdownItem', amount: number, unitAmount?: number | null, unitQuantity?: number | null, quantity?: number | null, label: string, description?: string | null, metered?: boolean | null }> | null, discounts: Array<{ __typename?: 'DiscountItem', amount: number, name: string, percentOff?: number | null, amountOff?: number | null, duration?: PromoDuration | null, durationInMonths?: number | null }>, appliedPromo?: { __typename?: 'AppliedPromo', code?: string | null, source: PromoSource } | null } | null };

export type UpcomingPlanInvoiceQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
}>;


export type UpcomingPlanInvoiceQuery = { __typename?: 'Query', upcomingPlanInvoice?: { __typename?: 'UpcomingInvoice', total: number, subTotal: number, currency: string, createdDate: any, periodStart: any, periodEnd: any, trialEnd?: any | null, subscriptionStatus?: StripeSubscriptionStatus | null, taxes: Array<{ __typename?: 'InvoiceTaxes', amount: number, percentage: number, displayName: string }>, breakdown?: Array<{ __typename?: 'InvoiceBreakdownItem', amount: number, unitAmount?: number | null, unitQuantity?: number | null, quantity?: number | null, label: string, description?: string | null, metered?: boolean | null }> | null, discounts: Array<{ __typename?: 'DiscountItem', amount: number, name: string, percentOff?: number | null, amountOff?: number | null, duration?: PromoDuration | null, durationInMonths?: number | null }>, appliedPromo?: { __typename?: 'AppliedPromo', code?: string | null, source: PromoSource } | null } | null };

export type UpcomingMarOverageInvoiceQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
}>;


export type UpcomingMarOverageInvoiceQuery = { __typename?: 'Query', upcomingMAROverageInvoice?: { __typename?: 'UpcomingInvoice', total: number, subTotal: number, currency: string, createdDate: any, periodStart: any, periodEnd: any, trialEnd?: any | null, subscriptionStatus?: StripeSubscriptionStatus | null, taxes: Array<{ __typename?: 'InvoiceTaxes', amount: number, percentage: number, displayName: string }>, breakdown?: Array<{ __typename?: 'InvoiceBreakdownItem', amount: number, unitAmount?: number | null, unitQuantity?: number | null, quantity?: number | null, label: string, description?: string | null, metered?: boolean | null }> | null, discounts: Array<{ __typename?: 'DiscountItem', amount: number, name: string, percentOff?: number | null, amountOff?: number | null, duration?: PromoDuration | null, durationInMonths?: number | null }>, appliedPromo?: { __typename?: 'AppliedPromo', code?: string | null, source: PromoSource } | null } | null };

export type PaymentPreviewForSubscriptionQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
}>;


export type PaymentPreviewForSubscriptionQuery = { __typename?: 'Query', paymentPreviewForSubscription?: { __typename?: 'UpcomingInvoice', total: number, subTotal: number, currency: string, createdDate: any, periodStart: any, periodEnd: any, trialEnd?: any | null, subscriptionStatus?: StripeSubscriptionStatus | null, taxes: Array<{ __typename?: 'InvoiceTaxes', amount: number, percentage: number, displayName: string }>, breakdown?: Array<{ __typename?: 'InvoiceBreakdownItem', amount: number, unitAmount?: number | null, unitQuantity?: number | null, quantity?: number | null, label: string, description?: string | null, metered?: boolean | null }> | null, discounts: Array<{ __typename?: 'DiscountItem', amount: number, name: string, percentOff?: number | null, amountOff?: number | null, duration?: PromoDuration | null, durationInMonths?: number | null }>, appliedPromo?: { __typename?: 'AppliedPromo', code?: string | null, source: PromoSource } | null } | null };

export type TaxIdsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type TaxIdsDataQuery = { __typename?: 'Query', taxIdsData: Array<{ __typename?: 'TaxIdData', country: string, countryCode: string, enum: string, shortName: string, description: string, example: string }> };

export type CreateFuturePaymentsSetupIntentMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type CreateFuturePaymentsSetupIntentMutation = { __typename?: 'Mutation', createFuturePaymentsSetupIntent: { __typename?: 'CreateSetupIntentResponse', clientSecret: string } };

export type PlanPricesFragment = { __typename?: 'PlanPrices', plan?: string | null, user?: string | null, mar?: string | null, marExtra?: string | null };

export type ActiveSubscriptionFragment = { __typename?: 'ActiveSubscription', subscriptionId: string, customerId: string, billingInterval: RecurrenceInterval, billingIntervalCount: number, cancelAt?: any | null, currency: string, status: StripeSubscriptionStatus, prices: { __typename?: 'PlanPrices', plan?: string | null, user?: string | null, mar?: string | null, marExtra?: string | null }, currentBillingPeriod: { __typename?: 'DateRange', start: any, end: any }, currentUsagePeriod: { __typename?: 'DateRange', start: any, end: any } };

export type SubmitProductNpsMutationVariables = Exact<{
  input: SubmitSurveyInput;
}>;


export type SubmitProductNpsMutation = { __typename?: 'Mutation', submitProductNPS: { __typename?: 'SurveyResponse', id: string, surveyId: string, score?: number | null } };

export type DismissProductNpsMutationVariables = Exact<{ [key: string]: never; }>;


export type DismissProductNpsMutation = { __typename?: 'Mutation', dismissProductNPS: { __typename?: 'SurveyResponse', id: string, surveyId: string, score?: number | null } };

export type GetPromptableProductNpsSurveyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPromptableProductNpsSurveyQuery = { __typename?: 'Query', getPromptableProductNPSSurvey: { __typename?: 'PromptableSurveyResponse', survey?: { __typename?: 'Survey', id: string, name: string, question: string } | null } };

export type FindSyncHistoryResponseFragment = { __typename?: 'FindSyncHistoryResponse', syncId: string, jobId?: string | null, status?: SyncJobStatus | null, startedAt: string, finishedAt?: string | null, totalRecords?: number | null, distinctRecords?: number | null, newRecords?: number | null, sizeSyncedMb?: number | null, syncedRecords?: number | null, substreamSyncedRecords?: number | null, failedRecords?: number | null, sourceStreamName?: string | null, error?: string | null, scheduledJobId?: string | null, isChunk?: boolean | null, fullSyncTrigger?: FullSyncTrigger | null, operationMode?: OperationMode | null, details?: string | null, substreamRecordsSyncedBySubstream?: Array<{ __typename?: 'SubstreamRecordsSynced', substreamId: string, destinationTableName: string, recordsSynced: number }> | null };

export type SourceStreamSnapshotFragment = { __typename?: 'SourceStreamSnapshot', bytesSynced: number, errorMessage?: string | null, estimatedTotalCount?: number | null, finishedAt?: string | null, fullSyncTrigger?: FullSyncTrigger | null, isChunk?: boolean | null, operationMode?: OperationMode | null, retryAttempt?: number | null, recordsSynced?: number | null, substreamRecordsSynced?: number | null, startedAt?: string | null, status?: SyncJobStatus | null, syncId?: string | null, sourceStreamName?: string | null, scheduledJobId?: string | null, details?: string | null, substreamRecordsSyncedBySubstream?: Array<{ __typename?: 'SubstreamRecordsSynced', substreamId: string, destinationTableName: string, recordsSynced: number }> | null };

export type SourceStreamSnapshotStatesFragment = { __typename?: 'SourceStreamSnapshotStates', name: string, scheduledJobId: string, activeSync?: { __typename?: 'SourceStreamSnapshot', bytesSynced: number, errorMessage?: string | null, estimatedTotalCount?: number | null, finishedAt?: string | null, fullSyncTrigger?: FullSyncTrigger | null, isChunk?: boolean | null, operationMode?: OperationMode | null, retryAttempt?: number | null, recordsSynced?: number | null, substreamRecordsSynced?: number | null, startedAt?: string | null, status?: SyncJobStatus | null, syncId?: string | null, sourceStreamName?: string | null, scheduledJobId?: string | null, details?: string | null, substreamRecordsSyncedBySubstream?: Array<{ __typename?: 'SubstreamRecordsSynced', substreamId: string, destinationTableName: string, recordsSynced: number }> | null } | null, latestSync?: { __typename?: 'SourceStreamSnapshot', bytesSynced: number, errorMessage?: string | null, estimatedTotalCount?: number | null, finishedAt?: string | null, fullSyncTrigger?: FullSyncTrigger | null, isChunk?: boolean | null, operationMode?: OperationMode | null, retryAttempt?: number | null, recordsSynced?: number | null, substreamRecordsSynced?: number | null, startedAt?: string | null, status?: SyncJobStatus | null, syncId?: string | null, sourceStreamName?: string | null, scheduledJobId?: string | null, details?: string | null, substreamRecordsSyncedBySubstream?: Array<{ __typename?: 'SubstreamRecordsSynced', substreamId: string, destinationTableName: string, recordsSynced: number }> | null } | null };

export type EltSyncSnapshotStateFragment = { __typename?: 'EltSyncSnapshotState', syncId: string, sourceStreams: Array<{ __typename?: 'SourceStreamSnapshotStates', name: string, scheduledJobId: string, activeSync?: { __typename?: 'SourceStreamSnapshot', bytesSynced: number, errorMessage?: string | null, estimatedTotalCount?: number | null, finishedAt?: string | null, fullSyncTrigger?: FullSyncTrigger | null, isChunk?: boolean | null, operationMode?: OperationMode | null, retryAttempt?: number | null, recordsSynced?: number | null, substreamRecordsSynced?: number | null, startedAt?: string | null, status?: SyncJobStatus | null, syncId?: string | null, sourceStreamName?: string | null, scheduledJobId?: string | null, details?: string | null, substreamRecordsSyncedBySubstream?: Array<{ __typename?: 'SubstreamRecordsSynced', substreamId: string, destinationTableName: string, recordsSynced: number }> | null } | null, latestSync?: { __typename?: 'SourceStreamSnapshot', bytesSynced: number, errorMessage?: string | null, estimatedTotalCount?: number | null, finishedAt?: string | null, fullSyncTrigger?: FullSyncTrigger | null, isChunk?: boolean | null, operationMode?: OperationMode | null, retryAttempt?: number | null, recordsSynced?: number | null, substreamRecordsSynced?: number | null, startedAt?: string | null, status?: SyncJobStatus | null, syncId?: string | null, sourceStreamName?: string | null, scheduledJobId?: string | null, details?: string | null, substreamRecordsSyncedBySubstream?: Array<{ __typename?: 'SubstreamRecordsSynced', substreamId: string, destinationTableName: string, recordsSynced: number }> | null } | null }> };

export type FindSyncHistoryQueryVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type FindSyncHistoryQuery = { __typename?: 'Query', findReverseEltSyncHistory: Array<{ __typename?: 'FindSyncHistoryResponse', syncId: string, jobId?: string | null, status?: SyncJobStatus | null, startedAt: string, finishedAt?: string | null, totalRecords?: number | null, distinctRecords?: number | null, newRecords?: number | null, sizeSyncedMb?: number | null, syncedRecords?: number | null, substreamSyncedRecords?: number | null, failedRecords?: number | null, sourceStreamName?: string | null, error?: string | null, scheduledJobId?: string | null, isChunk?: boolean | null, fullSyncTrigger?: FullSyncTrigger | null, operationMode?: OperationMode | null, details?: string | null, substreamRecordsSyncedBySubstream?: Array<{ __typename?: 'SubstreamRecordsSynced', substreamId: string, destinationTableName: string, recordsSynced: number }> | null }> };

export type EltSyncSnapshotStateQueryVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type EltSyncSnapshotStateQuery = { __typename?: 'Query', eltSyncSnapshotState: { __typename?: 'EltSyncSnapshotState', syncId: string, sourceStreams: Array<{ __typename?: 'SourceStreamSnapshotStates', name: string, scheduledJobId: string, activeSync?: { __typename?: 'SourceStreamSnapshot', bytesSynced: number, errorMessage?: string | null, estimatedTotalCount?: number | null, finishedAt?: string | null, fullSyncTrigger?: FullSyncTrigger | null, isChunk?: boolean | null, operationMode?: OperationMode | null, retryAttempt?: number | null, recordsSynced?: number | null, substreamRecordsSynced?: number | null, startedAt?: string | null, status?: SyncJobStatus | null, syncId?: string | null, sourceStreamName?: string | null, scheduledJobId?: string | null, details?: string | null, substreamRecordsSyncedBySubstream?: Array<{ __typename?: 'SubstreamRecordsSynced', substreamId: string, destinationTableName: string, recordsSynced: number }> | null } | null, latestSync?: { __typename?: 'SourceStreamSnapshot', bytesSynced: number, errorMessage?: string | null, estimatedTotalCount?: number | null, finishedAt?: string | null, fullSyncTrigger?: FullSyncTrigger | null, isChunk?: boolean | null, operationMode?: OperationMode | null, retryAttempt?: number | null, recordsSynced?: number | null, substreamRecordsSynced?: number | null, startedAt?: string | null, status?: SyncJobStatus | null, syncId?: string | null, sourceStreamName?: string | null, scheduledJobId?: string | null, details?: string | null, substreamRecordsSyncedBySubstream?: Array<{ __typename?: 'SubstreamRecordsSynced', substreamId: string, destinationTableName: string, recordsSynced: number }> | null } | null }> } };

export type PaginatedEltSyncHistoryQueryVariables = Exact<{
  input: PaginatedSyncHistoryInput;
}>;


export type PaginatedEltSyncHistoryQuery = { __typename?: 'Query', paginatedEltSyncHistory: { __typename?: 'PaginatedSyncHistoryResponse', nextCursor?: string | null, hasMore: boolean, items: Array<{ __typename?: 'FindSyncHistoryResponse', syncId: string, jobId?: string | null, status?: SyncJobStatus | null, startedAt: string, finishedAt?: string | null, totalRecords?: number | null, distinctRecords?: number | null, newRecords?: number | null, sizeSyncedMb?: number | null, syncedRecords?: number | null, substreamSyncedRecords?: number | null, failedRecords?: number | null, sourceStreamName?: string | null, error?: string | null, scheduledJobId?: string | null, isChunk?: boolean | null, fullSyncTrigger?: FullSyncTrigger | null, operationMode?: OperationMode | null, details?: string | null, substreamRecordsSyncedBySubstream?: Array<{ __typename?: 'SubstreamRecordsSynced', substreamId: string, destinationTableName: string, recordsSynced: number }> | null }> } };

export type GetJobLogsQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetJobLogsQuery = { __typename?: 'Query', getJobLogs: Array<{ __typename?: 'GetJobLogsResponse', status: JobLoggingMessageStatus, timestamp: string, message: string }> };

export type ActiveInitialSyncsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveInitialSyncsQuery = { __typename?: 'Query', activeInitialSyncs: Array<{ __typename?: 'EltSync', id: string }> };

export type InitialSyncsStatusQueryVariables = Exact<{
  syncIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InitialSyncsStatusQuery = { __typename?: 'Query', initialSyncsStatus: Array<{ __typename?: 'InitialSyncStatusResponse', syncId: string, integrationId: string, status: InitialSyncStatus, startedAt: any, finishedAt?: any | null, duration?: number | null, isChunkedSync: boolean, tableStats: { __typename?: 'InitialSyncTableStats', running: number, completed: number, failed: number, total: number, recordsSynced: number, bytesSynced: number } }> };

export type RevEtlJobStatusFragment = { __typename?: 'ReverseEtlJobResponse', nextRun?: number | null, lastRun?: number | null, status?: string | null, running?: boolean | null, startedAt?: string | null, isQuarantined?: boolean | null };

export type SyncListItemFragment = { __typename?: 'Sync', id: string, status: string, active: boolean, sourceId: string, sourceType: SourceType, sourceIntegrationId: string, destinationIntegrationId: string, sourceConnectionId: string, primaryObject: string, primaryObjectId?: string | null, createdAt: any, syncInterval?: string | null, errorCount: number, config?: { __typename?: 'Config', destinationSettings?: any | null } | null, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection: { __typename?: 'Connection', label: string, id: string }, rawView?: { __typename?: 'RawViewReference', integrationId?: string | null, path: Array<string>, schema: string, sourceStream: string, syncId?: string | null } | null, model?: { __typename?: 'Model', id: string, name: string, createdAt: any, materializationType: MaterializationType, emoji?: string | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, cronExpression: string } | null, job?: { __typename?: 'ReverseEtlJobResponse', nextRun?: number | null, lastRun?: number | null, status?: string | null, running?: boolean | null, startedAt?: string | null, isQuarantined?: boolean | null } | null };

export type ReverseEtlSyncFragment = { __typename?: 'Sync', id: string, status: string, active: boolean, primaryObject: string, primaryObjectId?: string | null, syncInterval?: string | null, sourceId: string, sourceType: SourceType, sourceConnectionId: string, destinationConnectionId: string, sourceIntegrationId: string, destinationIntegrationId: string, schedulerType: OrchestrationSchedulerType, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection: { __typename?: 'Connection', label: string, id: string }, operations: Array<{ __typename?: 'Operation', availableOperationId: string, operationMode: OperationModes, operationType: OperationTypes, objectType: string, objectTypeId?: string | null, primaryKeyRequired: boolean, primaryKeyMapping?: { __typename?: 'Mapping', id: string, sourcePropertyId: string, sourcePropertyName: string, sourcePropertyType: string, destinationPropertyId: string, destinationPropertyName: string, destinationPropertyType: string, readonly: boolean, primaryKey: boolean } | null }>, mappings: Array<{ __typename?: 'Mapping', id: string, sourcePropertyId: string, sourcePropertyName: string, sourcePropertyType: string, destinationPropertyId: string, destinationPropertyName: string, destinationPropertyType: string, readonly: boolean, primaryKey: boolean }>, rawView?: { __typename?: 'RawViewReference', integrationId?: string | null, path: Array<string>, schema: string, sourceStream: string, syncId?: string | null } | null, model?: { __typename?: 'Model', id: string, name: string, createdAt: any, materializationType: MaterializationType, emoji?: string | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null } | null, config?: { __typename?: 'Config', destinationSettings?: any | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null, job?: { __typename?: 'ReverseEtlJobResponse', nextRun?: number | null, lastRun?: number | null, status?: string | null, running?: boolean | null, startedAt?: string | null, isQuarantined?: boolean | null } | null };

export type CreateReverseEtlSyncMutationVariables = Exact<{
  sourceConnectionId: Scalars['String']['input'];
  destinationConnectionId: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  sourceType: SourceType;
  operations: Array<CreateOperationInput> | CreateOperationInput;
  primaryObject: Scalars['String']['input'];
  primaryObjectId?: InputMaybe<Scalars['String']['input']>;
  syncInterval?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  schedulerType: OrchestrationSchedulerType;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateReverseEtlSyncMutation = { __typename?: 'Mutation', createReverseEtlSync: { __typename?: 'Sync', id: string, status: string, active: boolean, primaryObject: string, primaryObjectId?: string | null, syncInterval?: string | null, sourceId: string, sourceType: SourceType, sourceConnectionId: string, destinationConnectionId: string, sourceIntegrationId: string, destinationIntegrationId: string, schedulerType: OrchestrationSchedulerType, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection: { __typename?: 'Connection', label: string, id: string }, operations: Array<{ __typename?: 'Operation', availableOperationId: string, operationMode: OperationModes, operationType: OperationTypes, objectType: string, objectTypeId?: string | null, primaryKeyRequired: boolean, primaryKeyMapping?: { __typename?: 'Mapping', id: string, sourcePropertyId: string, sourcePropertyName: string, sourcePropertyType: string, destinationPropertyId: string, destinationPropertyName: string, destinationPropertyType: string, readonly: boolean, primaryKey: boolean } | null }>, mappings: Array<{ __typename?: 'Mapping', id: string, sourcePropertyId: string, sourcePropertyName: string, sourcePropertyType: string, destinationPropertyId: string, destinationPropertyName: string, destinationPropertyType: string, readonly: boolean, primaryKey: boolean }>, rawView?: { __typename?: 'RawViewReference', integrationId?: string | null, path: Array<string>, schema: string, sourceStream: string, syncId?: string | null } | null, model?: { __typename?: 'Model', id: string, name: string, createdAt: any, materializationType: MaterializationType, emoji?: string | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null } | null, config?: { __typename?: 'Config', destinationSettings?: any | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null, job?: { __typename?: 'ReverseEtlJobResponse', nextRun?: number | null, lastRun?: number | null, status?: string | null, running?: boolean | null, startedAt?: string | null, isQuarantined?: boolean | null } | null } };

export type UpdateSyncMutationVariables = Exact<{
  syncId: Scalars['String']['input'];
  operations: Array<CreateOperationInput> | CreateOperationInput;
  syncInterval?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  schedulerType: OrchestrationSchedulerType;
  orchestrationWorkflowId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateSyncMutation = { __typename?: 'Mutation', updateSync: { __typename?: 'Sync', id: string, sourceConnectionId: string, destinationConnectionId: string } };

export type StartSyncMutationVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type StartSyncMutation = { __typename?: 'Mutation', startSync: { __typename?: 'Sync', id: string } };

export type StopSyncMutationVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type StopSyncMutation = { __typename?: 'Mutation', stopSync: { __typename?: 'Sync', id: string } };

export type CheckOnDemandReverseEtlSyncEligibilityQueryVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type CheckOnDemandReverseEtlSyncEligibilityQuery = { __typename?: 'Query', checkOnDemandReverseEtlSyncEligibility: { __typename?: 'OnDemandReverseETLSyncEligibilityResponse', possible: boolean, reason?: string | null } };

export type RunRevEtlSyncNowMutationVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type RunRevEtlSyncNowMutation = { __typename?: 'Mutation', runSyncNow?: boolean | null };

export type RemoveSyncMutationVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type RemoveSyncMutation = { __typename?: 'Mutation', removeSync: { __typename?: 'Sync', id: string } };

export type ListSyncsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListSyncsQuery = { __typename?: 'Query', syncs: Array<{ __typename?: 'Sync', id: string, status: string, active: boolean, sourceId: string, sourceType: SourceType, sourceIntegrationId: string, destinationIntegrationId: string, sourceConnectionId: string, primaryObject: string, primaryObjectId?: string | null, createdAt: any, syncInterval?: string | null, errorCount: number, config?: { __typename?: 'Config', destinationSettings?: any | null } | null, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection: { __typename?: 'Connection', label: string, id: string }, rawView?: { __typename?: 'RawViewReference', integrationId?: string | null, path: Array<string>, schema: string, sourceStream: string, syncId?: string | null } | null, model?: { __typename?: 'Model', id: string, name: string, createdAt: any, materializationType: MaterializationType, emoji?: string | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string, cronExpression: string } | null, job?: { __typename?: 'ReverseEtlJobResponse', nextRun?: number | null, lastRun?: number | null, status?: string | null, running?: boolean | null, startedAt?: string | null, isQuarantined?: boolean | null } | null }> };

export type FindOneSyncQueryVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type FindOneSyncQuery = { __typename?: 'Query', findOneSync: { __typename?: 'Sync', id: string, status: string, active: boolean, primaryObject: string, primaryObjectId?: string | null, syncInterval?: string | null, sourceId: string, sourceType: SourceType, sourceConnectionId: string, destinationConnectionId: string, sourceIntegrationId: string, destinationIntegrationId: string, schedulerType: OrchestrationSchedulerType, sourceConnection?: { __typename?: 'Connection', label: string, id: string } | null, destinationConnection: { __typename?: 'Connection', label: string, id: string }, operations: Array<{ __typename?: 'Operation', availableOperationId: string, operationMode: OperationModes, operationType: OperationTypes, objectType: string, objectTypeId?: string | null, primaryKeyRequired: boolean, primaryKeyMapping?: { __typename?: 'Mapping', id: string, sourcePropertyId: string, sourcePropertyName: string, sourcePropertyType: string, destinationPropertyId: string, destinationPropertyName: string, destinationPropertyType: string, readonly: boolean, primaryKey: boolean } | null }>, mappings: Array<{ __typename?: 'Mapping', id: string, sourcePropertyId: string, sourcePropertyName: string, sourcePropertyType: string, destinationPropertyId: string, destinationPropertyName: string, destinationPropertyType: string, readonly: boolean, primaryKey: boolean }>, rawView?: { __typename?: 'RawViewReference', integrationId?: string | null, path: Array<string>, schema: string, sourceStream: string, syncId?: string | null } | null, model?: { __typename?: 'Model', id: string, name: string, createdAt: any, materializationType: MaterializationType, emoji?: string | null, folderPath?: Array<{ __typename?: 'ModelFolder', id: string, name: string }> | null } | null, config?: { __typename?: 'Config', destinationSettings?: any | null } | null, orchestrationWorkflow?: { __typename?: 'OrchestrationWorkflow', id: string } | null, job?: { __typename?: 'ReverseEtlJobResponse', nextRun?: number | null, lastRun?: number | null, status?: string | null, running?: boolean | null, startedAt?: string | null, isQuarantined?: boolean | null } | null } };

export type GetSyncErrorsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSyncErrorsQuery = { __typename?: 'Query', getErrors: Array<{ __typename?: 'ActivateError', objectId: string, scheduledJobId: string, syncId: string, error: string }> };

export type ResetErrorsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  objectIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ResetErrorsMutation = { __typename?: 'Mutation', resetErrors: boolean };

export type ResetAllErrorsMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ResetAllErrorsMutation = { __typename?: 'Mutation', resetAllErrors: boolean };

export type ReverseEtlJobsCompletionStatsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ReverseEtlJobsCompletionStatsQuery = { __typename?: 'Query', reverseEtlJobsCompletionStats: { __typename?: 'SyncJobsCompletionMetricResponse', stats?: { __typename?: 'SyncJobsCompletionMetric', total: number, successCount: number, successPercent: number, failureCount: number, failurePercent: number } | null } };

export type ReverseEtlJobStatusQueryVariables = Exact<{
  syncId: Scalars['String']['input'];
}>;


export type ReverseEtlJobStatusQuery = { __typename?: 'Query', findOneSync: { __typename?: 'Sync', job?: { __typename?: 'ReverseEtlJobResponse', nextRun?: number | null, lastRun?: number | null, status?: string | null, running?: boolean | null, startedAt?: string | null, isQuarantined?: boolean | null } | null } };

export type SourceSchemaQueryVariables = Exact<{
  id: Scalars['String']['input'];
  type: SourceType;
}>;


export type SourceSchemaQuery = { __typename?: 'Query', sourceSchema: Array<{ __typename?: 'DataSchema', name: string, type: string, nullable: boolean }> };

export type DestinationSchemaQueryVariables = Exact<{
  input: DestinationSchemaInput;
}>;


export type DestinationSchemaQuery = { __typename?: 'Query', destinationSchema: Array<{ __typename?: 'Property', id: string, propertyId: string, propertyName: string, propertyType: string, readonly: boolean, isRequired: boolean, isPrimaryKey: boolean, automapMatchAny: boolean }> };

export type WorkspaceStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspaceStatsQuery = { __typename?: 'Query', workspaceStats: { __typename?: 'WorkspaceStats', numConnections: number, numUsers: number } };

export type BigQueryUsageStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type BigQueryUsageStatsQuery = { __typename?: 'Query', bigQueryUsageStats: { __typename?: 'BigQueryStats', data: Array<{ __typename?: 'BQUsage', datasetId: string, tableId: string, path: string, totalBytesProcessed: number, totalBytesBilled: number, bqBilledUsd: number, metabaseUsage?: { __typename?: 'QueryUsage', bytesProcessed: number, bytesBilled: number, bqBilledUsd: number } | null, queryUsage?: { __typename?: 'QueryUsage', bytesProcessed: number, bytesBilled: number, bqBilledUsd: number } | null }> } };

export type DailyUsageTotalSummaryQueryVariables = Exact<{
  period: DailyUsagePeriodInput;
}>;


export type DailyUsageTotalSummaryQuery = { __typename?: 'Query', dailyUsageTotalSummary: { __typename?: 'DailyUsageTotalSummaryResponse', data: { __typename?: 'DailyUsageTotalSummary', syncedRows: number, activeRows: number, elt: { __typename?: 'DailyUsageSyncTypeSummary', syncedRows: number, activeRows: number, syncedRowsPercentage: number, activeRowsPercentage: number }, reverseElt: { __typename?: 'DailyUsageSyncTypeSummary', syncedRows: number, activeRows: number, syncedRowsPercentage: number, activeRowsPercentage: number } } } };

export type DailyUsageDashboardQueryVariables = Exact<{
  period: DailyUsagePeriodInput;
}>;


export type DailyUsageDashboardQuery = { __typename?: 'Query', dailyUsageDashboard: { __typename?: 'DailyUsageDashboardResponse', data: { __typename?: 'DailyUsageDashboardData', summary: { __typename?: 'DailyUsageTotalSummary', syncedRows: number, activeRows: number, extraDestinationActiveRows: number, elt: { __typename?: 'DailyUsageSyncTypeSummary', syncedRows: number, activeRows: number, syncedRowsPercentage: number, activeRowsPercentage: number }, reverseElt: { __typename?: 'DailyUsageSyncTypeSummary', syncedRows: number, activeRows: number, syncedRowsPercentage: number, activeRowsPercentage: number } }, timeline: Array<{ __typename?: 'DailyUsageTimelineEntry', date: any, syncedRows: number, activeRows: number, runningTotalSyncedRows: number, runningTotalActiveRows: number, elt: { __typename?: 'DailyUsageSyncTypeEntry', syncedRows: number, activeRows: number, runningTotalSyncedRows: number, runningTotalActiveRows: number }, reverseElt: { __typename?: 'DailyUsageSyncTypeEntry', syncedRows: number, activeRows: number, runningTotalSyncedRows: number, runningTotalActiveRows: number } }>, integrations: Array<{ __typename?: 'DailyUsageIntegrationSummary', integrationId: string, syncedRows: number, activeRows: number, elt: { __typename?: 'DailyUsageSyncTypeRowSummary', syncedRows: number, activeRows: number }, reverseElt: { __typename?: 'DailyUsageSyncTypeRowSummary', syncedRows: number, activeRows: number } }>, destinationObjects: Array<{ __typename?: 'DailyUsageDestinationObjectSummary', integrationId: string, resource: string, syncedRows: number, activeRows: number }>, sourceStreams: Array<{ __typename?: 'DailyUsageSourceStreamSummary', integrationId: string, resource: string, syncedRows: number, activeRows: number, extraDestinationActiveRows: number, mainTable: { __typename?: 'DailyUsageRowMetric', activeRows: number, syncedRows: number }, historyTable?: { __typename?: 'DailyUsageRowMetric', activeRows: number, syncedRows: number } | null, substreams?: { __typename?: 'DailyUsageSubstreamSummary', syncedRows: number, activeRows?: number | null, historyTableSyncedRows: number, breakdownComplete: boolean, bySubstream: Array<{ __typename?: 'DailyUsageSubstreamRows', substreamId: string, destinationTableName: string, syncedRows: number }> } | null }> } } };

export type DailyUsageForecastQueryVariables = Exact<{
  period: DailyUsagePeriodInput;
}>;


export type DailyUsageForecastQuery = { __typename?: 'Query', dailyUsageForecast: { __typename?: 'DailyUsageForecastResult', predictions: Array<{ __typename?: 'DailyUsageForecastDataPoint', date: any, runningTotalActiveRows: number, runningTotalSyncedRows: number }>, dailyForecastedRate?: { __typename?: 'DailyUsageForecastRates', syncedRows: number, activeRows: number } | null, forecastedRows?: { __typename?: 'DailyUsageForecastRates', syncedRows: number, activeRows: number } | null, projectedTotalRows?: { __typename?: 'DailyUsageForecastRates', syncedRows: number, activeRows: number } | null } };

export type ModelCleanupQueryVariables = Exact<{
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ModelCleanupQuery = { __typename?: 'Query', modelCleanup: { __typename?: 'ModelCleanupAnalysis', detection: TableUsageDetection, analysedAt: any, analysisWindowDays: number, thresholdDays: number, unused: Array<{ __typename?: 'UnusedModel', modelId: string, path: string, lastReadAt?: any | null, unusedDependentIds: Array<string> }>, used: Array<{ __typename?: 'UsedModel', modelId: string, path: string, lastReadAt?: any | null, reason: ModelUsedReason, dependentModelId?: string | null }> } };

export type UnusedModelCandidatesQueryVariables = Exact<{ [key: string]: never; }>;


export type UnusedModelCandidatesQuery = { __typename?: 'Query', publishedModels: Array<{ __typename?: 'Model', id: string, name: string, emoji?: string | null, createdAt: any, materializationType: MaterializationType, sourcePath?: string | null, folder?: { __typename?: 'ModelFolder', id: string, name: string } | null }> };

export type LimitsFragment = { __typename?: 'Limits', users: number, connectors: number, rows: number, workspaces: number, minSyncIntervalInMinutes: number };

export type UpgradableLimitsFragment = { __typename?: 'UpgradableLimits', maxUsers?: number | null, maxConnectors?: number | null, maxRows?: number | null };

export type FeaturesFragment = { __typename?: 'Features', lineage: boolean, orchestration: boolean, modelTesting: boolean, columnHashing: boolean, aiAssistantHistory: boolean, auditLogs: boolean, onDemandSyncs: boolean, externalAuthorization: boolean, changeDataCapture: boolean, connectApi: boolean, softDeletes: boolean, marRulesV2: boolean, multiDestinationElt: boolean };

export type PlanFragmentFragment = { __typename?: 'Plan', name: PlanName, isLegacyPlan?: boolean | null, isEnterprisePlan?: boolean | null, features: { __typename?: 'Features', lineage: boolean, orchestration: boolean, modelTesting: boolean, columnHashing: boolean, aiAssistantHistory: boolean, auditLogs: boolean, onDemandSyncs: boolean, externalAuthorization: boolean, changeDataCapture: boolean, connectApi: boolean, softDeletes: boolean, marRulesV2: boolean, multiDestinationElt: boolean }, limits: { __typename?: 'Limits', users: number, connectors: number, rows: number, workspaces: number, minSyncIntervalInMinutes: number }, upgradableLimits?: { __typename?: 'UpgradableLimits', maxUsers?: number | null, maxConnectors?: number | null, maxRows?: number | null } | null };

export type PurchasablePlanFragmentFragment = { __typename?: 'PurchasablePlan', name: PlanName, isLegacyPlan?: boolean | null, isEnterprisePlan?: boolean | null, features: { __typename?: 'Features', lineage: boolean, orchestration: boolean, modelTesting: boolean, columnHashing: boolean, aiAssistantHistory: boolean, auditLogs: boolean, onDemandSyncs: boolean, externalAuthorization: boolean, changeDataCapture: boolean, connectApi: boolean, softDeletes: boolean, marRulesV2: boolean, multiDestinationElt: boolean }, limits: { __typename?: 'Limits', users: number, connectors: number, rows: number, workspaces: number, minSyncIntervalInMinutes: number }, upgradableLimits?: { __typename?: 'UpgradableLimits', maxUsers?: number | null, maxConnectors?: number | null, maxRows?: number | null } | null, priceLookupKeys?: { __typename?: 'PriceLookupKeys', plan: { __typename?: 'RecurringPriceLookupKeys', monthly: string, yearly: string }, user?: { __typename?: 'RecurringPriceLookupKeys', monthly: string, yearly: string } | null, mar?: { __typename?: 'RecurringPriceLookupKeys', monthly: string, yearly: string } | null, marExtra?: { __typename?: 'RecurringPriceLookupKeys', monthly: string, yearly: string } | null } | null };

export type RecurringPriceLookupKeysFragment = { __typename?: 'RecurringPriceLookupKeys', monthly: string, yearly: string };

export type AllPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPlansQuery = { __typename?: 'Query', allPlans: Array<{ __typename?: 'PurchasablePlan', name: PlanName, isLegacyPlan?: boolean | null, isEnterprisePlan?: boolean | null, features: { __typename?: 'Features', lineage: boolean, orchestration: boolean, modelTesting: boolean, columnHashing: boolean, aiAssistantHistory: boolean, auditLogs: boolean, onDemandSyncs: boolean, externalAuthorization: boolean, changeDataCapture: boolean, connectApi: boolean, softDeletes: boolean, marRulesV2: boolean, multiDestinationElt: boolean }, limits: { __typename?: 'Limits', users: number, connectors: number, rows: number, workspaces: number, minSyncIntervalInMinutes: number }, upgradableLimits?: { __typename?: 'UpgradableLimits', maxUsers?: number | null, maxConnectors?: number | null, maxRows?: number | null } | null, priceLookupKeys?: { __typename?: 'PriceLookupKeys', plan: { __typename?: 'RecurringPriceLookupKeys', monthly: string, yearly: string }, user?: { __typename?: 'RecurringPriceLookupKeys', monthly: string, yearly: string } | null, mar?: { __typename?: 'RecurringPriceLookupKeys', monthly: string, yearly: string } | null, marExtra?: { __typename?: 'RecurringPriceLookupKeys', monthly: string, yearly: string } | null } | null }> };

export type PlanQueryVariables = Exact<{
  planName: Scalars['String']['input'];
}>;


export type PlanQuery = { __typename?: 'Query', plan: { __typename?: 'PurchasablePlan', name: PlanName, isLegacyPlan?: boolean | null, isEnterprisePlan?: boolean | null, features: { __typename?: 'Features', lineage: boolean, orchestration: boolean, modelTesting: boolean, columnHashing: boolean, aiAssistantHistory: boolean, auditLogs: boolean, onDemandSyncs: boolean, externalAuthorization: boolean, changeDataCapture: boolean, connectApi: boolean, softDeletes: boolean, marRulesV2: boolean, multiDestinationElt: boolean }, limits: { __typename?: 'Limits', users: number, connectors: number, rows: number, workspaces: number, minSyncIntervalInMinutes: number }, upgradableLimits?: { __typename?: 'UpgradableLimits', maxUsers?: number | null, maxConnectors?: number | null, maxRows?: number | null } | null, priceLookupKeys?: { __typename?: 'PriceLookupKeys', plan: { __typename?: 'RecurringPriceLookupKeys', monthly: string, yearly: string }, user?: { __typename?: 'RecurringPriceLookupKeys', monthly: string, yearly: string } | null, mar?: { __typename?: 'RecurringPriceLookupKeys', monthly: string, yearly: string } | null, marExtra?: { __typename?: 'RecurringPriceLookupKeys', monthly: string, yearly: string } | null } | null } };

export type CurrentPlanStateQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentPlanStateQuery = { __typename?: 'Query', currentPlanState: { __typename?: 'CurrentPlanState', plan: { __typename?: 'Plan', name: PlanName, isLegacyPlan?: boolean | null, isEnterprisePlan?: boolean | null, features: { __typename?: 'Features', lineage: boolean, orchestration: boolean, modelTesting: boolean, columnHashing: boolean, aiAssistantHistory: boolean, auditLogs: boolean, onDemandSyncs: boolean, externalAuthorization: boolean, changeDataCapture: boolean, connectApi: boolean, softDeletes: boolean, marRulesV2: boolean, multiDestinationElt: boolean }, limits: { __typename?: 'Limits', users: number, connectors: number, rows: number, workspaces: number, minSyncIntervalInMinutes: number }, upgradableLimits?: { __typename?: 'UpgradableLimits', maxUsers?: number | null, maxConnectors?: number | null, maxRows?: number | null } | null }, subscription?: { __typename?: 'ActiveSubscription', subscriptionId: string, customerId: string, billingInterval: RecurrenceInterval, billingIntervalCount: number, cancelAt?: any | null, currency: string, status: StripeSubscriptionStatus, prices: { __typename?: 'PlanPrices', plan?: string | null, user?: string | null, mar?: string | null, marExtra?: string | null }, currentBillingPeriod: { __typename?: 'DateRange', start: any, end: any }, currentUsagePeriod: { __typename?: 'DateRange', start: any, end: any } } | null, currentUsagePeriod: { __typename?: 'DateRange', start: any, end: any } } };

export type CurrentSubscriptionStateQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentSubscriptionStateQuery = { __typename?: 'Query', currentSubscriptionState: { __typename?: 'SubscriptionState', status: SubscriptionStatus, customerId?: string | null, subscriptionId?: string | null } };

export type SeatUsageFragment = { __typename?: 'SeatUsage', members: number, pendingInvitations: number, used: number, limit?: number | null, isLimitReached: boolean };

export type PlanLimitsStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type PlanLimitsStatusQuery = { __typename?: 'Query', getPlanLimitsStatus: { __typename?: 'PlanLimitsStatus', isConnectionsLimitReached: boolean, isUsersLimitReached: boolean, seatUsage: { __typename?: 'SeatUsage', members: number, pendingInvitations: number, used: number, limit?: number | null, isLimitReached: boolean } } };

export type ValidateConnectionAdditionQueryVariables = Exact<{
  integrationId: Scalars['String']['input'];
}>;


export type ValidateConnectionAdditionQuery = { __typename?: 'Query', validateConnectionAddition: { __typename?: 'ValidationResult', valid: boolean, errors: Array<{ __typename?: 'ValidationErrorItem', errorCode?: ValidationErrorCode | null, reason?: string | null }> } };

export type ConnectorPlanViolationFragment = { __typename?: 'ConnectorPlanViolation', id: string, name: string, minRequiredPlan: PlanName };

export type ValidateCurrentConnectionUsageAgainstPlanQueryVariables = Exact<{
  planName: PlanName;
}>;


export type ValidateCurrentConnectionUsageAgainstPlanQuery = { __typename?: 'Query', validateCurrentConnectionUsageAgainstPlan: { __typename?: 'ConnectorPlanValidationResult', valid: boolean, connectionCount: number, maxConnections: number, isConnectorLimitExceeded: boolean, violations: Array<{ __typename?: 'ConnectorPlanViolation', id: string, name: string, minRequiredPlan: PlanName }>, dataWarehouseViolation?: { __typename?: 'ConnectorPlanViolation', id: string, name: string, minRequiredPlan: PlanName } | null } };

export const AccessGroupFragmentDoc = gql`
    fragment AccessGroup on AccessGroup {
  id
  name
  description
  createdAt
  updatedAt
  members {
    id
    userId
    apiKeyId
    createdAt
  }
}
    `;
export const DataWarehouseFragmentDoc = gql`
    fragment DataWarehouse on DataWarehouse {
  connectionId
  title
  subTitle
  integrationId
}
    `;
export const AccountSettingsFragmentDoc = gql`
    fragment AccountSettings on AccountSettings {
  id
  aiMetadataOnly
  deactivateELTSyncs
  deactivateReverseELTSyncs
  maxBillableRows
  transformTool
}
    `;
export const SlackNotificationInfoFragmentDoc = gql`
    fragment SlackNotificationInfo on SlackNotificationInfo {
  id
  connectionId
  channelId
  channelName
}
    `;
export const TeamsNotificationInfoFragmentDoc = gql`
    fragment TeamsNotificationInfo on TeamsNotificationInfo {
  id
  channelName
}
    `;
export const AccountFragmentDoc = gql`
    fragment Account on Account {
  id
  dataWarehouseConnectionId
  name
  slug
  notificationEmails
  createdAt
  currentUserRole
  currentUserPermissions
  dataWarehouse {
    ...DataWarehouse
  }
  trialEndsAt
  accountSettings {
    ...AccountSettings
  }
  slackNotificationInfo {
    ...SlackNotificationInfo
  }
  teamsNotificationInfo {
    ...TeamsNotificationInfo
  }
}
    ${DataWarehouseFragmentDoc}
${AccountSettingsFragmentDoc}
${SlackNotificationInfoFragmentDoc}
${TeamsNotificationInfoFragmentDoc}`;
export const ActivityPersonActorFieldsFragmentDoc = gql`
    fragment ActivityPersonActorFields on ActivityPersonActor {
  userId
  firstName
  lastName
  email
}
    `;
export const GithubCommitAuthorFieldsFragmentDoc = gql`
    fragment GithubCommitAuthorFields on GithubCommitAuthor {
  login
  avatarUrl
  name
}
    `;
export const GithubFileCommitFieldsFragmentDoc = gql`
    fragment GithubFileCommitFields on GithubFileCommit {
  sha
  committedAt
  message
  author {
    ...GithubCommitAuthorFields
  }
  authors {
    ...GithubCommitAuthorFields
  }
  commitCount
}
    ${GithubCommitAuthorFieldsFragmentDoc}`;
export const ActivityValueChangeFieldsFragmentDoc = gql`
    fragment ActivityValueChangeFields on ActivityValueChange {
  before
  after
}
    `;
export const ActivityEventFieldsFragmentDoc = gql`
    fragment ActivityEventFields on ActivityEvent {
  id
  occurredAt
  type
  batchId
  resource {
    type
    id
    name
    exists
  }
  actor {
    ... on ActivityPersonActor {
      kind
      ...ActivityPersonActorFields
    }
    ... on ActivityApiKeyActor {
      kind
      apiKeyId
      name
    }
    ... on ActivityGithubSyncActor {
      kind
      syncId
      commitSha
      fileCommit {
        ...GithubFileCommitFields
      }
      triggeredBy {
        ...ActivityPersonActorFields
      }
    }
    ... on ActivityWeldSupportActor {
      kind
    }
  }
  payload {
    ... on TransformPublishedActivityPayload {
      firstPublish
      queryChanged
      materializationChanged
      scheduleChanged
      folderChanged
      nameChanged
      publishedQueryId
      previousPublishedQueryId
    }
    ... on TransformDeletedActivityPayload {
      commitSha
    }
    ... on TransformChangedActivityPayload {
      changedFields
      folder {
        ...ActivityValueChangeFields
      }
      materializationType {
        ...ActivityValueChangeFields
      }
      name {
        ...ActivityValueChangeFields
      }
    }
    ... on EltSyncActivityPayload {
      changedFields
      sourceIntegrationId
      destinationIntegrationId
      destination {
        connectionLabel
        integrationId
      }
      reload
      streamCount
      streamNames
      interval {
        ...ActivityValueChangeFields
      }
      orchestrationWorkflowId {
        ...ActivityValueChangeFields
      }
    }
    ... on EltStreamActivityPayload {
      changedFields
      eltSyncId
      eltSyncName
      sourceIntegrationId
      fullSyncRequest
      operationMode
      operationModeChange {
        ...ActivityValueChangeFields
      }
      interval {
        ...ActivityValueChangeFields
      }
    }
    ... on ReverseEtlSyncActivityPayload {
      changedFields
      sourceIntegrationId
      destinationIntegrationId
      primaryObject
      modelId
      interval {
        ...ActivityValueChangeFields
      }
      orchestrationWorkflowId {
        ...ActivityValueChangeFields
      }
    }
    ... on OrchestrationActivityPayload {
      changedFields
      cronExpression
      cronExpressionChange {
        ...ActivityValueChangeFields
      }
    }
    ... on ConnectionActivityPayload {
      integrationId
    }
    ... on FolderActivityPayload {
      parentFolderId
      name {
        ...ActivityValueChangeFields
      }
    }
    ... on ModelTestActivityPayload {
      column
      testType
      testedModelId: modelId
      testedModelName: modelName
    }
    ... on WebhookActivityPayload {
      changedFields
      externalSystem
    }
  }
}
    ${ActivityPersonActorFieldsFragmentDoc}
${GithubFileCommitFieldsFragmentDoc}
${ActivityValueChangeFieldsFragmentDoc}`;
export const ConnectionBaseFragmentDoc = gql`
    fragment ConnectionBase on Connection {
  id
  integrationId
  label
  active
  createdAt
  updatedAt
  connectedAt
  formId
}
    `;
export const ConnectionWithSyncsFragmentDoc = gql`
    fragment ConnectionWithSyncs on Connection {
  eltSyncs {
    id
    createdAt
    status
    destinationSchemaName
    destinationConnection {
      integrationId
    }
  }
  reverseEltSyncs {
    id
    createdAt
    status
    primaryObject
    primaryObjectId
    destinationConnection {
      integrationId
    }
  }
}
    `;
export const ConnectionBridgeBaseFragmentDoc = gql`
    fragment ConnectionBridgeBase on ConnectionBridgeResponse {
  id
  integrationId
  authorizeUrl
  createdAt
  expiresAt
  label
  connectionId
}
    `;
export const RawViewFragmentDoc = gql`
    fragment RawView on RawViewReference {
  viewId
  integrationId
  weldTag
  path
  createdAt
  latestSyncTime
  schema
  sourceStream
  syncId
  scheduledJobId
  firstSyncCompleted
  retired
  retirementDetails {
    inFavorOf
    removalDate
    details
    link
  }
}
    `;
export const StreamWithSubstreamsFragmentDoc = gql`
    fragment StreamWithSubstreams on Stream {
  name
  supportedModes
  configurableIncremental
  supportsMultipleIncrementalPointers
  defaultConfig
  selectable
  notSelectableExplanation
  preselect
  primaryKeyNames
  excludedSubstreams
  enabledHistoryTable
  softDeleteSupported
  softDeleteEnabled
  historyStreams {
    id
    substreamId
    destinationTableName
  }
  substreams {
    id
    destinationTableName
    avroSchema
    retired
    retirementDetails {
      inFavorOf
      removalDate
      details
      link
    }
  }
  retired
  retirementDetails {
    inFavorOf
    removalDate
    details
    link
  }
}
    `;
export const ConnectionCdcFeaturesFragmentDoc = gql`
    fragment ConnectionCDCFeatures on ConnectionCDCFeatures {
  changeDataCaptureEnabled
  supportedTables
  unsupportedReason
}
    `;
export const ConnectorRestrictionFragmentDoc = gql`
    fragment ConnectorRestriction on ConnectorRestriction {
  connectionId
  restricted
  accessGroups {
    id
    name
  }
}
    `;
export const DownloadStatusByUuidFragmentDoc = gql`
    fragment DownloadStatusByUuid on DownloadStatusByUuid {
  uuid
  status
  filename
  rows
  error
  updatedAt
  expiresAt
}
    `;
export const AccountEltDestinationFragmentDoc = gql`
    fragment AccountEltDestination on AccountEltDestination {
  id
  label
  connectionId
  integrationId
  settings
  syncCount
  useForNewSyncs
  softDeletesSupported
  historyTablesSupported
  cdcDeletesSupported
  createdAt
  connection {
    id
    label
    integrationId
  }
}
    `;
export const EltSyncDestinationFragmentDoc = gql`
    fragment EltSyncDestination on EltSyncDestination {
  id
  destinationSchemaName
  destination {
    ...AccountEltDestination
  }
}
    ${AccountEltDestinationFragmentDoc}`;
export const SourceStreamJobFragmentDoc = gql`
    fragment SourceStreamJob on GetSourceStreamJobResponse {
  nextRun
  lastRun
  lastFullSync
  lastStartedAt
  status
  isQuarantined
  forceFullSync
  forceFullSyncHistoryTable
  running
  cdc {
    running
    heartBeat
    lastStartedAt
    isFirstRun
    incrementalSnapshotInProgress
    awaitingInitialSnapshot
    initialSnapshotTableNames
  }
  lastIncrementalPointer
  customerFacingError {
    headline
    summary
    responsibility
    matchedNotificationType
    generatedAt
    actions {
      type
      detail
    }
  }
}
    `;
export const EltSyncFragmentDoc = gql`
    fragment EltSync on EltSync {
  id
  active
  status
  syncInterval
  sourceIntegrationId
  destinationIntegrationId
  sourceConnectionId
  destinationConnectionId
  sourceStreams {
    id
    name
    incrementalPrimaryKeyName
    incrementalPointerId
    additionalIncrementalPointerIds
    operationMode
    fullSyncAlways
    fullSyncAtMidnight
    fullSyncSchedule
    protectedFromFullSync
    prioritized
    changeDataCaptureEnabled
    syncInterval
    excludedSubstreams
    enabledHistoryTable
    softDeleteEnabled
    dataFilters {
      sourceStreamObjectKey
      transformation
    }
    job {
      ...SourceStreamJob
    }
    substreams {
      name
      excludedColumns
      hashedColumns
    }
  }
  startDate
  sourceConnection {
    label
    id
  }
  destinationConnection {
    label
    id
  }
  config {
    sourceSettings
  }
  destinationSchemaName
  identifierCasing
  schedulerType
  orchestrationWorkflow {
    id
    cronExpression
  }
  eltWebhookId
}
    ${SourceStreamJobFragmentDoc}`;
export const EltSyncLiteFragmentDoc = gql`
    fragment EltSyncLite on EltSync {
  id
  active
  status
  syncInterval
  sourceIntegrationId
  destinationIntegrationId
  createdAt
  destinationSchemaName
  schedulerType
  sourceConnectionId
  sourceStreams {
    id
    name
    changeDataCaptureEnabled
    protectedFromFullSync
  }
  sourceConnection {
    label
    id
  }
  destinationConnection {
    label
    id
  }
  schedulerType
  orchestrationWorkflow {
    id
    cronExpression
  }
}
    `;
export const EltSyncHistoryStatsResponseFragmentDoc = gql`
    fragment EltSyncHistoryStatsResponse on EltSyncHistoryStatsResponse {
  stats {
    startedAt
    finishedAt
    duration
    status
    sourceStreamName
    rowsSynced
    substreamRowsSynced
    substreamRecordsSyncedBySubstream {
      substreamId
      destinationTableName
      recordsSynced
    }
    rowsSyncedMb
    operationMode
    fullSyncTrigger
  }
  limit
}
    `;
export const WebhookFragmentDoc = gql`
    fragment Webhook on WebhookResponse {
  webhookId
  name
  connectionId
  orchestrationWorkflowId
  type
  params
  dependencies {
    name
    id
    itemId
    type
  }
  createdAt
  updatedAt
}
    `;
export const WebhookRunFragmentDoc = gql`
    fragment WebhookRun on WebhookRunResponse {
  id
  webhookId
  status
  orchestrationWorkflowRunId
  externalRunId
  externalUrl
  externalStatusCode
  errorMessage
  createdAt
  finishedAt
}
    `;
export const GithubSyncCommitAttributionFieldsFragmentDoc = gql`
    fragment GithubSyncCommitAttributionFields on GithubSyncListItem {
  headCommitAuthor {
    ...GithubCommitAuthorFields
  }
  commitRange {
    commitCount
    authors {
      ...GithubCommitAuthorFields
    }
  }
}
    ${GithubCommitAuthorFieldsFragmentDoc}`;
export const GithubSyncListItemFieldsFragmentDoc = gql`
    fragment GithubSyncListItemFields on GithubSyncListItem {
  id
  triggeredBy
  commitSha
  ...GithubSyncCommitAttributionFields
  status
  startedAt
  completedAt
  summary {
    counts
    failureReason
    failedMaterializationsCount
    noModelsFound
    warningsCount
  }
}
    ${GithubSyncCommitAttributionFieldsFragmentDoc}`;
export const GithubSyncChangeFieldsFragmentDoc = gql`
    fragment GithubSyncChangeFields on GithubSyncChange {
  status
  path
  modelName
  modelId
  sourcePath
  materialization
  previousMaterializationType
  reason
  unresolvedDependencies
  unsupportedJinja
}
    `;
export const GithubSyncFieldsFragmentDoc = gql`
    fragment GithubSyncFields on GithubSync {
  id
  createdAt
  connectionId
  triggeredBy
  triggeringDeliveryId
  commitSha
  baseCommitSha
  headCommitAuthor {
    ...GithubCommitAuthorFields
  }
  commitRange {
    commitCount
    authors {
      ...GithubCommitAuthorFields
    }
  }
  fileCommits {
    sourcePath
    commit {
      ...GithubFileCommitFields
    }
  }
  status
  startedAt
  completedAt
  summary {
    counts
    commitOutcome {
      succeeded
      failed
    }
    warnings {
      type
      message
    }
    materializingModelIds
    failedMaterializationModelIds
    autoHealed {
      attempted
      failed
    }
    noModelsFound
    changes {
      ...GithubSyncChangeFields
    }
    unchangedModels {
      modelId
      modelName
      path
    }
  }
}
    ${GithubCommitAuthorFieldsFragmentDoc}
${GithubFileCommitFieldsFragmentDoc}
${GithubSyncChangeFieldsFragmentDoc}`;
export const StaleModelFieldsFragmentDoc = gql`
    fragment StaleModelFields on StaleModel {
  id
  name
  materializationType
  lastMaterialisedAt
  sourcePath
}
    `;
export const CountryFragmentDoc = gql`
    fragment Country on Country {
  code
  name
  currency
  emoji
  dial_code
}
    `;
export const IntegrationConfigurationOptionsFragmentDoc = gql`
    fragment IntegrationConfigurationOptions on IntegrationConfiguration {
  hideSelectAllTables
  supportsStartDate
  startDateConfig {
    defaultLookbackDays
    maxLookbackDays
    maxLookbackDaysDescription
  }
  usesAsyncStreams
  usesLazySchemas
  requiresConfiguration
  supportsIdentifierCasing
  supportsRawViews
  supportsSoftDeletes
}
    `;
export const IntegrationConfigurationFragmentDoc = gql`
    fragment IntegrationConfiguration on IntegrationConfiguration {
  ...IntegrationConfigurationOptions
  id
  name
  forms
}
    ${IntegrationConfigurationOptionsFragmentDoc}`;
export const DataConnectorMetadataFragmentDoc = gql`
    fragment DataConnectorMetadata on DataConnectorMetadata {
  minRequiredPlan
  status
  tags
  changeDataCaptureSupported
}
    `;
export const AvailableIntegrationFragmentDoc = gql`
    fragment AvailableIntegration on AvailableIntegration {
  abilities
  aliasMetadata {
    id
    name
  }
  baseId
  categories
  config {
    ...IntegrationConfigurationOptions
  }
  id
  isUtilityConnector
  logo {
    default
    dark
  }
  name
  requiresAdmin
  meetsPlanRequirement
  minRequiredPlan
  eltSource {
    ...DataConnectorMetadata
  }
  activateDestination {
    ...DataConnectorMetadata
  }
  dataWarehouse {
    ...DataConnectorMetadata
  }
}
    ${IntegrationConfigurationOptionsFragmentDoc}
${DataConnectorMetadataFragmentDoc}`;
export const LineageGraphNodeFragmentDoc = gql`
    fragment LineageGraphNode on LineageGraphNode {
  incoming
  outgoing
  item {
    __typename
    ... on LineageGraphItemBase {
      id
      scheduleType
      workflowId
    }
    ... on LineageGraphModelItem {
      id
      scheduleType
      workflowId
      type
      name
      sourceConnectionId
      folderName
      folderId
      isPublished
      folderParent
      description
      dependencies {
        id
        type
      }
      dwTable {
        status
        latestSyncTime
      }
      materializationSchedule
      workflow {
        id
        name
        cronExpression
      }
    }
    ... on LineageGraphSourceStreamItem {
      id
      scheduleType
      workflowId
      type
      sourceStreamId
      sourceStreamName
      eltSyncId
      sourceIntegrationId
      status
      syncInterval
    }
    ... on LineageGraphActivateSyncItem {
      id
      scheduleType
      workflowId
      type
      syncId
      dependencies {
        id
        type
      }
      destinationIntegrationId
      status
      syncInterval
      workflow {
        id
        name
        cronExpression
      }
    }
    ... on LineageGraphRawViewItem {
      id
      scheduleType
      workflowId
      type
      dependencies {
        id
        type
      }
      path
      schema
      sourceStream
      rawViewSyncId: syncId
      weldTag
    }
    ... on LineageGraphWebhookItem {
      id
      scheduleType
      workflowId
      name
      type
      webhookId
      webhookType
      dependencies {
        id
        type
      }
    }
  }
}
    `;
export const PublishedQueryBaseFragmentFragmentDoc = gql`
    fragment PublishedQueryBaseFragment on SqlQuery {
  id
  createdAt
  dependencies {
    dwItemId
    type
    weldTag
  }
  userId
}
    `;
export const PublishedQueryWithSqlFragmentFragmentDoc = gql`
    fragment PublishedQueryWithSQLFragment on SqlQuery {
  ...PublishedQueryBaseFragment
  weldSql
}
    ${PublishedQueryBaseFragmentFragmentDoc}`;
export const ModelBaseFragmentDoc = gql`
    fragment ModelBase on Model {
  id
  name
  createdAt
  emoji
  type
  materializationType
  clusteringColumns
  partitionExpression
  publishedQueryId
  sourcePath
  rebuildTrigger
}
    `;
export const ModelViewReferenceFragmentFragmentDoc = gql`
    fragment ModelViewReferenceFragment on ModelViewReference {
  modelId
  queryId
  type
  path
  weldTag
  dwSqlReference
  createdAt
  latestSyncTime
}
    `;
export const MaterializedTableReferenceFragmentFragmentDoc = gql`
    fragment MaterializedTableReferenceFragment on MaterializedTableReference {
  modelId
  queryId
  type
  path
  weldTag
  dwSqlReference
  createdAt
  latestSyncTime
  status
  latestRunErrorMessage
}
    `;
export const ModelPublishedFragmentFragmentDoc = gql`
    fragment ModelPublishedFragment on Model {
  folder {
    id
    name
    parentId
  }
  folderPath {
    id
    name
  }
  publishedQuery {
    ...PublishedQueryBaseFragment
  }
  dwSync {
    ...ModelViewReferenceFragment
  }
  dwTable {
    ...MaterializedTableReferenceFragment
  }
  localMaterializationJob {
    queryId
    status
    lastRun
    nextRun
    cronExpression
    latestErrorMessage
  }
  orchestrationWorkflow {
    id
  }
  dashboardId
  orchestrationScheduler
  materializationSchedule
  templateId
  templateItemId
}
    ${PublishedQueryBaseFragmentFragmentDoc}
${ModelViewReferenceFragmentFragmentDoc}
${MaterializedTableReferenceFragmentFragmentDoc}`;
export const ModelListItemFragmentDoc = gql`
    fragment ModelListItem on Model {
  ...ModelBase
  ...ModelPublishedFragment
}
    ${ModelBaseFragmentDoc}
${ModelPublishedFragmentFragmentDoc}`;
export const ModelSearchResultFragmentDoc = gql`
    fragment ModelSearchResult on Model {
  id
  name
  emoji
  folderPath {
    id
    name
  }
  publishedQueryId
}
    `;
export const ObjectTypeFragmentDoc = gql`
    fragment ObjectType on ObjectType {
  id
  objectName
  objectTypeId
  associations
  supportedDestinationMapping
  offerOnlyPrimaryKeysAsIdentifiers
}
    `;
export const IncidentUpdateFragmentDoc = gql`
    fragment IncidentUpdate on IncidentUpdate {
  body
  createdAt
  displayAt
  id
  incidentId
  status
  updatedAt
}
    `;
export const IncidentFragmentDoc = gql`
    fragment Incident on Incident {
  createdAt
  id
  impact
  incidentUpdates {
    ...IncidentUpdate
  }
  name
  resolvedAt
  shortlink
  status
  updatedAt
  scheduledFor
  scheduledUntil
}
    ${IncidentUpdateFragmentDoc}`;
export const OperationModeOptionFragmentDoc = gql`
    fragment OperationModeOption on FindAvailableOperationsResponse {
  id
  operationType
  operationMode
  primaryKeyRequired
  integrationId
}
    `;
export const OrchestrationWorkflowRunFragmentDoc = gql`
    fragment OrchestrationWorkflowRun on OrchestrationWorkflowRun {
  id
  dueAt
  startedAt
  finishedAt
  status
}
    `;
export const OrchestrationJobFragmentDoc = gql`
    fragment OrchestrationJob on WorkflowJob {
  itemId
  target {
    ... on MaterializedTableReference {
      modelId
    }
    ... on ModelViewReference {
      modelId
    }
    ... on RawViewReference {
      viewId
    }
    ... on SourceStream {
      id
      name
      eltSync {
        id
      }
    }
    ... on Sync {
      id
    }
    ... on Webhook {
      id
    }
  }
  order
  errorMessage
  status
  incomingDependencies
  outgoingDependencies
}
    `;
export const ModelTestRunFragmentDoc = gql`
    fragment ModelTestRun on ModelTestRun {
  workflowRunId
  modelTestId
  result {
    rows
    status
    numRowsTotal
    error
  }
}
    `;
export const OrchestrationWorkflowFragmentDoc = gql`
    fragment OrchestrationWorkflow on OrchestrationWorkflow {
  id
  name
  description
  active
  cronExpression
  currentRun {
    ...OrchestrationWorkflowRun
    jobs {
      ...OrchestrationJob
      target {
        ... on MaterializedTableReference {
          modelId
          modelTestRuns {
            ...ModelTestRun
          }
        }
        ... on ModelViewReference {
          modelId
          modelTestRuns {
            ...ModelTestRun
          }
        }
      }
    }
  }
  nextRun {
    ...OrchestrationWorkflowRun
    jobs {
      ...OrchestrationJob
    }
  }
}
    ${OrchestrationWorkflowRunFragmentDoc}
${OrchestrationJobFragmentDoc}
${ModelTestRunFragmentDoc}`;
export const SourcePropertyFragmentDoc = gql`
    fragment SourceProperty on DataSchema {
  name
  type
  nullable
}
    `;
export const DestinationPropertyFragmentDoc = gql`
    fragment DestinationProperty on Property {
  id
  propertyId
  propertyName
  propertyType
  readonly
  isRequired
  isPrimaryKey
  automapMatchAny
}
    `;
export const StripePaymentMethodFragmentDoc = gql`
    fragment StripePaymentMethod on PaymentMethod {
  card {
    last4
    brand
    expirationMonth
    expirationYear
  }
}
    `;
export const StripeCustomerFragmentDoc = gql`
    fragment StripeCustomer on Customer {
  id
  companyName
  email
  currency
  taxId {
    type
    country
    value
  }
  address {
    line1
    line2
    postalCode
    city
    country
    state
  }
  defaultPaymentMethod {
    ...StripePaymentMethod
  }
}
    ${StripePaymentMethodFragmentDoc}`;
export const PriceFragmentDoc = gql`
    fragment Price on Price {
  id
  currency
  price
  recurring {
    interval
    intervalCount
    usageType
  }
  billingScheme
  tiers {
    price
    upTo
    unitAmount
  }
  tiersMode
  currencyOptions {
    currency
    price
  }
  lookupKey
  transformQuantity {
    divideBy
  }
}
    `;
export const StripePlanFeaturesFragmentDoc = gql`
    fragment StripePlanFeatures on StripePlanFeatures {
  limitRows
  limitUsers
  limitConnectors
  minSyncIntervalInMinutes
}
    `;
export const StripeSubscriptionItemFragmentDoc = gql`
    fragment StripeSubscriptionItem on StripeSubscriptionItem {
  price {
    id
    product {
      id
      name
      description
      image
      type
      addOnType
      features {
        ...StripePlanFeatures
      }
      active
    }
    currency
    price
    recurring {
      interval
      intervalCount
      usageType
    }
    billingScheme
    tiers {
      price
      upTo
      unitAmount
    }
    currencyOptions {
      currency
      price
    }
    lookupKey
  }
  quantity
  tier {
    price
    upTo
    unitAmount
  }
}
    ${StripePlanFeaturesFragmentDoc}`;
export const StripeInvoiceFragmentDoc = gql`
    fragment StripeInvoice on Invoice {
  id
  chargeStatus
  chargeFailureMessage
  currency
  dueDate
  hostedInvoiceUrl
  periodStart
  periodEnd
  status
  total
}
    `;
export const InvoiceTaxesFragmentDoc = gql`
    fragment InvoiceTaxes on InvoiceTaxes {
  amount
  percentage
  displayName
}
    `;
export const InvoiceBreakdownItemFragmentDoc = gql`
    fragment InvoiceBreakdownItem on InvoiceBreakdownItem {
  amount
  unitAmount
  unitQuantity
  quantity
  label
  description
  metered
}
    `;
export const InvoiceDiscountFragmentDoc = gql`
    fragment InvoiceDiscount on DiscountItem {
  amount
  name
  percentOff
  amountOff
  duration
  durationInMonths
}
    `;
export const AppliedPromoFragmentDoc = gql`
    fragment AppliedPromo on AppliedPromo {
  code
  source
}
    `;
export const UpcomingInvoiceFragmentDoc = gql`
    fragment UpcomingInvoice on UpcomingInvoice {
  total
  subTotal
  currency
  createdDate
  periodStart
  periodEnd
  taxes {
    ...InvoiceTaxes
  }
  trialEnd
  subscriptionStatus
  breakdown {
    ...InvoiceBreakdownItem
  }
  discounts {
    ...InvoiceDiscount
  }
  appliedPromo {
    ...AppliedPromo
  }
}
    ${InvoiceTaxesFragmentDoc}
${InvoiceBreakdownItemFragmentDoc}
${InvoiceDiscountFragmentDoc}
${AppliedPromoFragmentDoc}`;
export const PlanPricesFragmentDoc = gql`
    fragment PlanPrices on PlanPrices {
  plan
  user
  mar
  marExtra
}
    `;
export const DateRangeFragmentDoc = gql`
    fragment DateRange on DateRange {
  start
  end
}
    `;
export const ActiveSubscriptionFragmentDoc = gql`
    fragment ActiveSubscription on ActiveSubscription {
  subscriptionId
  customerId
  prices {
    ...PlanPrices
  }
  billingInterval
  billingIntervalCount
  cancelAt
  currency
  currentBillingPeriod {
    start
    end
  }
  currentUsagePeriod {
    ...DateRange
  }
  status
}
    ${PlanPricesFragmentDoc}
${DateRangeFragmentDoc}`;
export const FindSyncHistoryResponseFragmentDoc = gql`
    fragment FindSyncHistoryResponse on FindSyncHistoryResponse {
  syncId
  jobId
  status
  startedAt
  finishedAt
  totalRecords
  distinctRecords
  newRecords
  sizeSyncedMb
  syncedRecords
  substreamSyncedRecords
  substreamRecordsSyncedBySubstream {
    substreamId
    destinationTableName
    recordsSynced
  }
  failedRecords
  sourceStreamName
  error
  scheduledJobId
  isChunk
  fullSyncTrigger
  operationMode
  details
}
    `;
export const SourceStreamSnapshotFragmentDoc = gql`
    fragment SourceStreamSnapshot on SourceStreamSnapshot {
  bytesSynced
  errorMessage
  estimatedTotalCount
  finishedAt
  fullSyncTrigger
  isChunk
  operationMode
  retryAttempt
  recordsSynced
  substreamRecordsSynced
  substreamRecordsSyncedBySubstream {
    substreamId
    destinationTableName
    recordsSynced
  }
  startedAt
  status
  syncId
  sourceStreamName
  scheduledJobId
  details
}
    `;
export const SourceStreamSnapshotStatesFragmentDoc = gql`
    fragment SourceStreamSnapshotStates on SourceStreamSnapshotStates {
  name
  scheduledJobId
  activeSync {
    ...SourceStreamSnapshot
  }
  latestSync {
    ...SourceStreamSnapshot
  }
}
    ${SourceStreamSnapshotFragmentDoc}`;
export const EltSyncSnapshotStateFragmentDoc = gql`
    fragment EltSyncSnapshotState on EltSyncSnapshotState {
  syncId
  sourceStreams {
    ...SourceStreamSnapshotStates
  }
}
    ${SourceStreamSnapshotStatesFragmentDoc}`;
export const RevEtlJobStatusFragmentDoc = gql`
    fragment RevEtlJobStatus on ReverseEtlJobResponse {
  nextRun
  lastRun
  status
  running
  startedAt
  isQuarantined
}
    `;
export const SyncListItemFragmentDoc = gql`
    fragment SyncListItem on Sync {
  id
  status
  active
  sourceId
  sourceType
  sourceIntegrationId
  destinationIntegrationId
  sourceConnectionId
  primaryObject
  primaryObjectId
  createdAt
  syncInterval
  config {
    destinationSettings
  }
  sourceConnection {
    label
    id
  }
  destinationConnection {
    label
    id
  }
  rawView {
    integrationId
    path
    schema
    sourceStream
    syncId
  }
  model {
    id
    name
    createdAt
    materializationType
    emoji
    folderPath {
      id
      name
    }
  }
  orchestrationWorkflow {
    id
    cronExpression
  }
  job {
    ...RevEtlJobStatus
  }
  errorCount
}
    ${RevEtlJobStatusFragmentDoc}`;
export const ReverseEtlSyncFragmentDoc = gql`
    fragment ReverseETLSync on Sync {
  id
  status
  active
  primaryObject
  primaryObjectId
  syncInterval
  sourceId
  sourceType
  sourceConnectionId
  destinationConnectionId
  sourceConnection {
    label
    id
  }
  destinationConnection {
    label
    id
  }
  operations {
    availableOperationId
    operationMode
    operationType
    objectType
    objectTypeId
    primaryKeyRequired
    primaryKeyMapping {
      id
      sourcePropertyId
      sourcePropertyName
      sourcePropertyType
      destinationPropertyId
      destinationPropertyName
      destinationPropertyType
      readonly
      primaryKey
    }
  }
  mappings {
    id
    sourcePropertyId
    sourcePropertyName
    sourcePropertyType
    destinationPropertyId
    destinationPropertyName
    destinationPropertyType
    readonly
    primaryKey
  }
  sourceIntegrationId
  destinationIntegrationId
  rawView {
    integrationId
    path
    schema
    sourceStream
    syncId
  }
  model {
    id
    name
    createdAt
    materializationType
    emoji
    folderPath {
      id
      name
    }
  }
  config {
    destinationSettings
  }
  schedulerType
  orchestrationWorkflow {
    id
  }
  job {
    ...RevEtlJobStatus
  }
}
    ${RevEtlJobStatusFragmentDoc}`;
export const FeaturesFragmentDoc = gql`
    fragment Features on Features {
  lineage
  orchestration
  modelTesting
  columnHashing
  aiAssistantHistory
  auditLogs
  onDemandSyncs
  externalAuthorization
  changeDataCapture
  connectApi
  softDeletes
  marRulesV2
  multiDestinationElt
}
    `;
export const LimitsFragmentDoc = gql`
    fragment Limits on Limits {
  users
  connectors
  rows
  workspaces
  minSyncIntervalInMinutes
}
    `;
export const UpgradableLimitsFragmentDoc = gql`
    fragment UpgradableLimits on UpgradableLimits {
  maxUsers
  maxConnectors
  maxRows
}
    `;
export const PlanFragmentFragmentDoc = gql`
    fragment PlanFragment on Plan {
  name
  features {
    ...Features
  }
  limits {
    ...Limits
  }
  upgradableLimits {
    ...UpgradableLimits
  }
  isLegacyPlan
  isEnterprisePlan
}
    ${FeaturesFragmentDoc}
${LimitsFragmentDoc}
${UpgradableLimitsFragmentDoc}`;
export const RecurringPriceLookupKeysFragmentDoc = gql`
    fragment RecurringPriceLookupKeys on RecurringPriceLookupKeys {
  monthly
  yearly
}
    `;
export const PurchasablePlanFragmentFragmentDoc = gql`
    fragment PurchasablePlanFragment on PurchasablePlan {
  name
  features {
    ...Features
  }
  limits {
    ...Limits
  }
  upgradableLimits {
    ...UpgradableLimits
  }
  isLegacyPlan
  isEnterprisePlan
  priceLookupKeys {
    plan {
      ...RecurringPriceLookupKeys
    }
    user {
      ...RecurringPriceLookupKeys
    }
    mar {
      ...RecurringPriceLookupKeys
    }
    marExtra {
      ...RecurringPriceLookupKeys
    }
  }
}
    ${FeaturesFragmentDoc}
${LimitsFragmentDoc}
${UpgradableLimitsFragmentDoc}
${RecurringPriceLookupKeysFragmentDoc}`;
export const SeatUsageFragmentDoc = gql`
    fragment SeatUsage on SeatUsage {
  members
  pendingInvitations
  used
  limit
  isLimitReached
}
    `;
export const ConnectorPlanViolationFragmentDoc = gql`
    fragment ConnectorPlanViolation on ConnectorPlanViolation {
  id
  name
  minRequiredPlan
}
    `;
export const AccessGroupsDocument = gql`
    query AccessGroups {
  accessGroups {
    ...AccessGroup
  }
}
    ${AccessGroupFragmentDoc}`;

/**
 * __useAccessGroupsQuery__
 *
 * To run a query within a React component, call `useAccessGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccessGroupsQuery(baseOptions?: Apollo.QueryHookOptions<AccessGroupsQuery, AccessGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessGroupsQuery, AccessGroupsQueryVariables>(AccessGroupsDocument, options);
      }
export function useAccessGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessGroupsQuery, AccessGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessGroupsQuery, AccessGroupsQueryVariables>(AccessGroupsDocument, options);
        }
export function useAccessGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccessGroupsQuery, AccessGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccessGroupsQuery, AccessGroupsQueryVariables>(AccessGroupsDocument, options);
        }
export type AccessGroupsQueryHookResult = ReturnType<typeof useAccessGroupsQuery>;
export type AccessGroupsLazyQueryHookResult = ReturnType<typeof useAccessGroupsLazyQuery>;
export type AccessGroupsSuspenseQueryHookResult = ReturnType<typeof useAccessGroupsSuspenseQuery>;
export type AccessGroupsQueryResult = Apollo.QueryResult<AccessGroupsQuery, AccessGroupsQueryVariables>;
export const AccessGroupDocument = gql`
    query AccessGroup($id: ID!) {
  accessGroup(id: $id) {
    ...AccessGroup
  }
}
    ${AccessGroupFragmentDoc}`;

/**
 * __useAccessGroupQuery__
 *
 * To run a query within a React component, call `useAccessGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccessGroupQuery(baseOptions: Apollo.QueryHookOptions<AccessGroupQuery, AccessGroupQueryVariables> & ({ variables: AccessGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessGroupQuery, AccessGroupQueryVariables>(AccessGroupDocument, options);
      }
export function useAccessGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessGroupQuery, AccessGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessGroupQuery, AccessGroupQueryVariables>(AccessGroupDocument, options);
        }
export function useAccessGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccessGroupQuery, AccessGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccessGroupQuery, AccessGroupQueryVariables>(AccessGroupDocument, options);
        }
export type AccessGroupQueryHookResult = ReturnType<typeof useAccessGroupQuery>;
export type AccessGroupLazyQueryHookResult = ReturnType<typeof useAccessGroupLazyQuery>;
export type AccessGroupSuspenseQueryHookResult = ReturnType<typeof useAccessGroupSuspenseQuery>;
export type AccessGroupQueryResult = Apollo.QueryResult<AccessGroupQuery, AccessGroupQueryVariables>;
export const CreateAccessGroupDocument = gql`
    mutation CreateAccessGroup($input: CreateAccessGroupInput!) {
  createAccessGroup(input: $input) {
    ...AccessGroup
  }
}
    ${AccessGroupFragmentDoc}`;
export type CreateAccessGroupMutationFn = Apollo.MutationFunction<CreateAccessGroupMutation, CreateAccessGroupMutationVariables>;

/**
 * __useCreateAccessGroupMutation__
 *
 * To run a mutation, you first call `useCreateAccessGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccessGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccessGroupMutation, { data, loading, error }] = useCreateAccessGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccessGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccessGroupMutation, CreateAccessGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccessGroupMutation, CreateAccessGroupMutationVariables>(CreateAccessGroupDocument, options);
      }
export type CreateAccessGroupMutationHookResult = ReturnType<typeof useCreateAccessGroupMutation>;
export type CreateAccessGroupMutationResult = Apollo.MutationResult<CreateAccessGroupMutation>;
export type CreateAccessGroupMutationOptions = Apollo.BaseMutationOptions<CreateAccessGroupMutation, CreateAccessGroupMutationVariables>;
export const UpdateAccessGroupDocument = gql`
    mutation UpdateAccessGroup($input: UpdateAccessGroupInput!) {
  updateAccessGroup(input: $input) {
    ...AccessGroup
  }
}
    ${AccessGroupFragmentDoc}`;
export type UpdateAccessGroupMutationFn = Apollo.MutationFunction<UpdateAccessGroupMutation, UpdateAccessGroupMutationVariables>;

/**
 * __useUpdateAccessGroupMutation__
 *
 * To run a mutation, you first call `useUpdateAccessGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccessGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccessGroupMutation, { data, loading, error }] = useUpdateAccessGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccessGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccessGroupMutation, UpdateAccessGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccessGroupMutation, UpdateAccessGroupMutationVariables>(UpdateAccessGroupDocument, options);
      }
export type UpdateAccessGroupMutationHookResult = ReturnType<typeof useUpdateAccessGroupMutation>;
export type UpdateAccessGroupMutationResult = Apollo.MutationResult<UpdateAccessGroupMutation>;
export type UpdateAccessGroupMutationOptions = Apollo.BaseMutationOptions<UpdateAccessGroupMutation, UpdateAccessGroupMutationVariables>;
export const DeleteAccessGroupDocument = gql`
    mutation DeleteAccessGroup($id: ID!) {
  deleteAccessGroup(id: $id)
}
    `;
export type DeleteAccessGroupMutationFn = Apollo.MutationFunction<DeleteAccessGroupMutation, DeleteAccessGroupMutationVariables>;

/**
 * __useDeleteAccessGroupMutation__
 *
 * To run a mutation, you first call `useDeleteAccessGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccessGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccessGroupMutation, { data, loading, error }] = useDeleteAccessGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccessGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccessGroupMutation, DeleteAccessGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccessGroupMutation, DeleteAccessGroupMutationVariables>(DeleteAccessGroupDocument, options);
      }
export type DeleteAccessGroupMutationHookResult = ReturnType<typeof useDeleteAccessGroupMutation>;
export type DeleteAccessGroupMutationResult = Apollo.MutationResult<DeleteAccessGroupMutation>;
export type DeleteAccessGroupMutationOptions = Apollo.BaseMutationOptions<DeleteAccessGroupMutation, DeleteAccessGroupMutationVariables>;
export const AddAccessGroupPrincipalsDocument = gql`
    mutation AddAccessGroupPrincipals($input: AccessGroupPrincipalsInput!) {
  addAccessGroupPrincipals(input: $input) {
    ...AccessGroup
  }
}
    ${AccessGroupFragmentDoc}`;
export type AddAccessGroupPrincipalsMutationFn = Apollo.MutationFunction<AddAccessGroupPrincipalsMutation, AddAccessGroupPrincipalsMutationVariables>;

/**
 * __useAddAccessGroupPrincipalsMutation__
 *
 * To run a mutation, you first call `useAddAccessGroupPrincipalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccessGroupPrincipalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccessGroupPrincipalsMutation, { data, loading, error }] = useAddAccessGroupPrincipalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAccessGroupPrincipalsMutation(baseOptions?: Apollo.MutationHookOptions<AddAccessGroupPrincipalsMutation, AddAccessGroupPrincipalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAccessGroupPrincipalsMutation, AddAccessGroupPrincipalsMutationVariables>(AddAccessGroupPrincipalsDocument, options);
      }
export type AddAccessGroupPrincipalsMutationHookResult = ReturnType<typeof useAddAccessGroupPrincipalsMutation>;
export type AddAccessGroupPrincipalsMutationResult = Apollo.MutationResult<AddAccessGroupPrincipalsMutation>;
export type AddAccessGroupPrincipalsMutationOptions = Apollo.BaseMutationOptions<AddAccessGroupPrincipalsMutation, AddAccessGroupPrincipalsMutationVariables>;
export const RemoveAccessGroupPrincipalsDocument = gql`
    mutation RemoveAccessGroupPrincipals($input: AccessGroupPrincipalsInput!) {
  removeAccessGroupPrincipals(input: $input) {
    ...AccessGroup
  }
}
    ${AccessGroupFragmentDoc}`;
export type RemoveAccessGroupPrincipalsMutationFn = Apollo.MutationFunction<RemoveAccessGroupPrincipalsMutation, RemoveAccessGroupPrincipalsMutationVariables>;

/**
 * __useRemoveAccessGroupPrincipalsMutation__
 *
 * To run a mutation, you first call `useRemoveAccessGroupPrincipalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAccessGroupPrincipalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAccessGroupPrincipalsMutation, { data, loading, error }] = useRemoveAccessGroupPrincipalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAccessGroupPrincipalsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAccessGroupPrincipalsMutation, RemoveAccessGroupPrincipalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAccessGroupPrincipalsMutation, RemoveAccessGroupPrincipalsMutationVariables>(RemoveAccessGroupPrincipalsDocument, options);
      }
export type RemoveAccessGroupPrincipalsMutationHookResult = ReturnType<typeof useRemoveAccessGroupPrincipalsMutation>;
export type RemoveAccessGroupPrincipalsMutationResult = Apollo.MutationResult<RemoveAccessGroupPrincipalsMutation>;
export type RemoveAccessGroupPrincipalsMutationOptions = Apollo.BaseMutationOptions<RemoveAccessGroupPrincipalsMutation, RemoveAccessGroupPrincipalsMutationVariables>;
export const SetTransformToolDocument = gql`
    mutation SetTransformTool($value: TransformTool!) {
  setTransformTool(value: $value) {
    id
    accountSettings {
      id
      transformTool
    }
  }
}
    `;
export type SetTransformToolMutationFn = Apollo.MutationFunction<SetTransformToolMutation, SetTransformToolMutationVariables>;

/**
 * __useSetTransformToolMutation__
 *
 * To run a mutation, you first call `useSetTransformToolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTransformToolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTransformToolMutation, { data, loading, error }] = useSetTransformToolMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetTransformToolMutation(baseOptions?: Apollo.MutationHookOptions<SetTransformToolMutation, SetTransformToolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTransformToolMutation, SetTransformToolMutationVariables>(SetTransformToolDocument, options);
      }
export type SetTransformToolMutationHookResult = ReturnType<typeof useSetTransformToolMutation>;
export type SetTransformToolMutationResult = Apollo.MutationResult<SetTransformToolMutation>;
export type SetTransformToolMutationOptions = Apollo.BaseMutationOptions<SetTransformToolMutation, SetTransformToolMutationVariables>;
export const SetAiMetadataOnlyDocument = gql`
    mutation SetAiMetadataOnly($value: Boolean!) {
  setAiMetadataOnly(value: $value) {
    id
    accountSettings {
      id
      aiMetadataOnly
    }
  }
}
    `;
export type SetAiMetadataOnlyMutationFn = Apollo.MutationFunction<SetAiMetadataOnlyMutation, SetAiMetadataOnlyMutationVariables>;

/**
 * __useSetAiMetadataOnlyMutation__
 *
 * To run a mutation, you first call `useSetAiMetadataOnlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAiMetadataOnlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAiMetadataOnlyMutation, { data, loading, error }] = useSetAiMetadataOnlyMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetAiMetadataOnlyMutation(baseOptions?: Apollo.MutationHookOptions<SetAiMetadataOnlyMutation, SetAiMetadataOnlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAiMetadataOnlyMutation, SetAiMetadataOnlyMutationVariables>(SetAiMetadataOnlyDocument, options);
      }
export type SetAiMetadataOnlyMutationHookResult = ReturnType<typeof useSetAiMetadataOnlyMutation>;
export type SetAiMetadataOnlyMutationResult = Apollo.MutationResult<SetAiMetadataOnlyMutation>;
export type SetAiMetadataOnlyMutationOptions = Apollo.BaseMutationOptions<SetAiMetadataOnlyMutation, SetAiMetadataOnlyMutationVariables>;
export const CurrentUserWithAccountsDocument = gql`
    query CurrentUserWithAccounts {
  current {
    id
    firstName
    lastName
    email
    weldSuperAdmin
    accounts {
      ...Account
    }
  }
}
    ${AccountFragmentDoc}`;

/**
 * __useCurrentUserWithAccountsQuery__
 *
 * To run a query within a React component, call `useCurrentUserWithAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserWithAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserWithAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserWithAccountsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserWithAccountsQuery, CurrentUserWithAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserWithAccountsQuery, CurrentUserWithAccountsQueryVariables>(CurrentUserWithAccountsDocument, options);
      }
export function useCurrentUserWithAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserWithAccountsQuery, CurrentUserWithAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserWithAccountsQuery, CurrentUserWithAccountsQueryVariables>(CurrentUserWithAccountsDocument, options);
        }
export function useCurrentUserWithAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserWithAccountsQuery, CurrentUserWithAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserWithAccountsQuery, CurrentUserWithAccountsQueryVariables>(CurrentUserWithAccountsDocument, options);
        }
export type CurrentUserWithAccountsQueryHookResult = ReturnType<typeof useCurrentUserWithAccountsQuery>;
export type CurrentUserWithAccountsLazyQueryHookResult = ReturnType<typeof useCurrentUserWithAccountsLazyQuery>;
export type CurrentUserWithAccountsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserWithAccountsSuspenseQuery>;
export type CurrentUserWithAccountsQueryResult = Apollo.QueryResult<CurrentUserWithAccountsQuery, CurrentUserWithAccountsQueryVariables>;
export const UserSignupInfoDocument = gql`
    query UserSignupInfo($userId: String!) {
  user(userId: $userId) {
    id
    userSignupInfo {
      jobTitle
      companyName
    }
  }
}
    `;

/**
 * __useUserSignupInfoQuery__
 *
 * To run a query within a React component, call `useUserSignupInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSignupInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSignupInfoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserSignupInfoQuery(baseOptions: Apollo.QueryHookOptions<UserSignupInfoQuery, UserSignupInfoQueryVariables> & ({ variables: UserSignupInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSignupInfoQuery, UserSignupInfoQueryVariables>(UserSignupInfoDocument, options);
      }
export function useUserSignupInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSignupInfoQuery, UserSignupInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSignupInfoQuery, UserSignupInfoQueryVariables>(UserSignupInfoDocument, options);
        }
export function useUserSignupInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserSignupInfoQuery, UserSignupInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserSignupInfoQuery, UserSignupInfoQueryVariables>(UserSignupInfoDocument, options);
        }
export type UserSignupInfoQueryHookResult = ReturnType<typeof useUserSignupInfoQuery>;
export type UserSignupInfoLazyQueryHookResult = ReturnType<typeof useUserSignupInfoLazyQuery>;
export type UserSignupInfoSuspenseQueryHookResult = ReturnType<typeof useUserSignupInfoSuspenseQuery>;
export type UserSignupInfoQueryResult = Apollo.QueryResult<UserSignupInfoQuery, UserSignupInfoQueryVariables>;
export const FirebaseTokenDocument = gql`
    query FirebaseToken {
  firebaseToken
}
    `;

/**
 * __useFirebaseTokenQuery__
 *
 * To run a query within a React component, call `useFirebaseTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirebaseTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirebaseTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useFirebaseTokenQuery(baseOptions?: Apollo.QueryHookOptions<FirebaseTokenQuery, FirebaseTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FirebaseTokenQuery, FirebaseTokenQueryVariables>(FirebaseTokenDocument, options);
      }
export function useFirebaseTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FirebaseTokenQuery, FirebaseTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FirebaseTokenQuery, FirebaseTokenQueryVariables>(FirebaseTokenDocument, options);
        }
export function useFirebaseTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FirebaseTokenQuery, FirebaseTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FirebaseTokenQuery, FirebaseTokenQueryVariables>(FirebaseTokenDocument, options);
        }
export type FirebaseTokenQueryHookResult = ReturnType<typeof useFirebaseTokenQuery>;
export type FirebaseTokenLazyQueryHookResult = ReturnType<typeof useFirebaseTokenLazyQuery>;
export type FirebaseTokenSuspenseQueryHookResult = ReturnType<typeof useFirebaseTokenSuspenseQuery>;
export type FirebaseTokenQueryResult = Apollo.QueryResult<FirebaseTokenQuery, FirebaseTokenQueryVariables>;
export const UserDocument = gql`
    query User($userId: String!) {
  user(userId: $userId) {
    id
    email
    firstName
    lastName
    updatedAt
    createdAt
    role
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables> & ({ variables: UserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UsersDocument = gql`
    query Users {
  users {
    id
    email
    firstName
    lastName
    updatedAt
    createdAt
    role
    scopes
    holdsSeat
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export function useUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const RemoveUserDocument = gql`
    mutation RemoveUser($userId: String!) {
  deleteUser(id: $userId) {
    id
  }
}
    `;
export type RemoveUserMutationFn = Apollo.MutationFunction<RemoveUserMutation, RemoveUserMutationVariables>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMutation, RemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(RemoveUserDocument, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResult = Apollo.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<RemoveUserMutation, RemoveUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserAccountRoleDocument = gql`
    mutation UpdateUserAccountRole($userId: String!, $role: Role!, $scopes: [EditorScope!]) {
  updateUserAccountRole(userId: $userId, role: $role, scopes: $scopes) {
    id
    role
    scopes
    firstName
    lastName
  }
}
    `;
export type UpdateUserAccountRoleMutationFn = Apollo.MutationFunction<UpdateUserAccountRoleMutation, UpdateUserAccountRoleMutationVariables>;

/**
 * __useUpdateUserAccountRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserAccountRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAccountRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAccountRoleMutation, { data, loading, error }] = useUpdateUserAccountRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *      scopes: // value for 'scopes'
 *   },
 * });
 */
export function useUpdateUserAccountRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAccountRoleMutation, UpdateUserAccountRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAccountRoleMutation, UpdateUserAccountRoleMutationVariables>(UpdateUserAccountRoleDocument, options);
      }
export type UpdateUserAccountRoleMutationHookResult = ReturnType<typeof useUpdateUserAccountRoleMutation>;
export type UpdateUserAccountRoleMutationResult = Apollo.MutationResult<UpdateUserAccountRoleMutation>;
export type UpdateUserAccountRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserAccountRoleMutation, UpdateUserAccountRoleMutationVariables>;
export const UpsertUserSignupInfoDocument = gql`
    mutation UpsertUserSignupInfo($input: UpsertUserSignupInfoInput!) {
  upsertUserSignupInfo(input: $input) {
    id
    companyName
  }
}
    `;
export type UpsertUserSignupInfoMutationFn = Apollo.MutationFunction<UpsertUserSignupInfoMutation, UpsertUserSignupInfoMutationVariables>;

/**
 * __useUpsertUserSignupInfoMutation__
 *
 * To run a mutation, you first call `useUpsertUserSignupInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserSignupInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserSignupInfoMutation, { data, loading, error }] = useUpsertUserSignupInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertUserSignupInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserSignupInfoMutation, UpsertUserSignupInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserSignupInfoMutation, UpsertUserSignupInfoMutationVariables>(UpsertUserSignupInfoDocument, options);
      }
export type UpsertUserSignupInfoMutationHookResult = ReturnType<typeof useUpsertUserSignupInfoMutation>;
export type UpsertUserSignupInfoMutationResult = Apollo.MutationResult<UpsertUserSignupInfoMutation>;
export type UpsertUserSignupInfoMutationOptions = Apollo.BaseMutationOptions<UpsertUserSignupInfoMutation, UpsertUserSignupInfoMutationVariables>;
export const InvitationsDocument = gql`
    query Invitations($getUsed: Boolean) {
  invitations(getUsed: $getUsed) {
    id
    email
    firstName
    lastName
    used
    expiresAt
    updatedAt
    createdAt
    role
    scopes
    holdsSeat
  }
}
    `;

/**
 * __useInvitationsQuery__
 *
 * To run a query within a React component, call `useInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsQuery({
 *   variables: {
 *      getUsed: // value for 'getUsed'
 *   },
 * });
 */
export function useInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<InvitationsQuery, InvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitationsQuery, InvitationsQueryVariables>(InvitationsDocument, options);
      }
export function useInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitationsQuery, InvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitationsQuery, InvitationsQueryVariables>(InvitationsDocument, options);
        }
export function useInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvitationsQuery, InvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitationsQuery, InvitationsQueryVariables>(InvitationsDocument, options);
        }
export type InvitationsQueryHookResult = ReturnType<typeof useInvitationsQuery>;
export type InvitationsLazyQueryHookResult = ReturnType<typeof useInvitationsLazyQuery>;
export type InvitationsSuspenseQueryHookResult = ReturnType<typeof useInvitationsSuspenseQuery>;
export type InvitationsQueryResult = Apollo.QueryResult<InvitationsQuery, InvitationsQueryVariables>;
export const OpenInvitationsDocument = gql`
    query OpenInvitations {
  openInvitations {
    id
    email
    firstName
    lastName
    used
    expiresAt
    updatedAt
    createdAt
    role
    account {
      id
      name
    }
  }
}
    `;

/**
 * __useOpenInvitationsQuery__
 *
 * To run a query within a React component, call `useOpenInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenInvitationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOpenInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<OpenInvitationsQuery, OpenInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenInvitationsQuery, OpenInvitationsQueryVariables>(OpenInvitationsDocument, options);
      }
export function useOpenInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenInvitationsQuery, OpenInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenInvitationsQuery, OpenInvitationsQueryVariables>(OpenInvitationsDocument, options);
        }
export function useOpenInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpenInvitationsQuery, OpenInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpenInvitationsQuery, OpenInvitationsQueryVariables>(OpenInvitationsDocument, options);
        }
export type OpenInvitationsQueryHookResult = ReturnType<typeof useOpenInvitationsQuery>;
export type OpenInvitationsLazyQueryHookResult = ReturnType<typeof useOpenInvitationsLazyQuery>;
export type OpenInvitationsSuspenseQueryHookResult = ReturnType<typeof useOpenInvitationsSuspenseQuery>;
export type OpenInvitationsQueryResult = Apollo.QueryResult<OpenInvitationsQuery, OpenInvitationsQueryVariables>;
export const SendInvitationDocument = gql`
    mutation SendInvitation($email: String!, $firstName: String, $lastName: String, $role: Role!, $scopes: [EditorScope!]) {
  sendInvitation(
    input: {email: $email, firstName: $firstName, lastName: $lastName, role: $role, scopes: $scopes}
  ) {
    id
  }
}
    `;
export type SendInvitationMutationFn = Apollo.MutationFunction<SendInvitationMutation, SendInvitationMutationVariables>;

/**
 * __useSendInvitationMutation__
 *
 * To run a mutation, you first call `useSendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitationMutation, { data, loading, error }] = useSendInvitationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      role: // value for 'role'
 *      scopes: // value for 'scopes'
 *   },
 * });
 */
export function useSendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<SendInvitationMutation, SendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvitationMutation, SendInvitationMutationVariables>(SendInvitationDocument, options);
      }
export type SendInvitationMutationHookResult = ReturnType<typeof useSendInvitationMutation>;
export type SendInvitationMutationResult = Apollo.MutationResult<SendInvitationMutation>;
export type SendInvitationMutationOptions = Apollo.BaseMutationOptions<SendInvitationMutation, SendInvitationMutationVariables>;
export const ResendOwnInvitationDocument = gql`
    mutation ResendOwnInvitation($accountId: String!) {
  resendOwnInvitation(accountId: $accountId) {
    id
  }
}
    `;
export type ResendOwnInvitationMutationFn = Apollo.MutationFunction<ResendOwnInvitationMutation, ResendOwnInvitationMutationVariables>;

/**
 * __useResendOwnInvitationMutation__
 *
 * To run a mutation, you first call `useResendOwnInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendOwnInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendOwnInvitationMutation, { data, loading, error }] = useResendOwnInvitationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useResendOwnInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendOwnInvitationMutation, ResendOwnInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendOwnInvitationMutation, ResendOwnInvitationMutationVariables>(ResendOwnInvitationDocument, options);
      }
export type ResendOwnInvitationMutationHookResult = ReturnType<typeof useResendOwnInvitationMutation>;
export type ResendOwnInvitationMutationResult = Apollo.MutationResult<ResendOwnInvitationMutation>;
export type ResendOwnInvitationMutationOptions = Apollo.BaseMutationOptions<ResendOwnInvitationMutation, ResendOwnInvitationMutationVariables>;
export const AcceptInvitationDocument = gql`
    mutation AcceptInvitation($invitationId: String!) {
  useInvitation(invitationId: $invitationId) {
    accountId
  }
}
    `;
export type AcceptInvitationMutationFn = Apollo.MutationFunction<AcceptInvitationMutation, AcceptInvitationMutationVariables>;

/**
 * __useAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitationMutation, { data, loading, error }] = useAcceptInvitationMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useAcceptInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInvitationMutation, AcceptInvitationMutationVariables>(AcceptInvitationDocument, options);
      }
export type AcceptInvitationMutationHookResult = ReturnType<typeof useAcceptInvitationMutation>;
export type AcceptInvitationMutationResult = Apollo.MutationResult<AcceptInvitationMutation>;
export type AcceptInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>;
export const DeclineOwnInvitationDocument = gql`
    mutation DeclineOwnInvitation($accountId: String!) {
  declineOwnInvitation(accountId: $accountId) {
    id
  }
}
    `;
export type DeclineOwnInvitationMutationFn = Apollo.MutationFunction<DeclineOwnInvitationMutation, DeclineOwnInvitationMutationVariables>;

/**
 * __useDeclineOwnInvitationMutation__
 *
 * To run a mutation, you first call `useDeclineOwnInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineOwnInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineOwnInvitationMutation, { data, loading, error }] = useDeclineOwnInvitationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeclineOwnInvitationMutation(baseOptions?: Apollo.MutationHookOptions<DeclineOwnInvitationMutation, DeclineOwnInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineOwnInvitationMutation, DeclineOwnInvitationMutationVariables>(DeclineOwnInvitationDocument, options);
      }
export type DeclineOwnInvitationMutationHookResult = ReturnType<typeof useDeclineOwnInvitationMutation>;
export type DeclineOwnInvitationMutationResult = Apollo.MutationResult<DeclineOwnInvitationMutation>;
export type DeclineOwnInvitationMutationOptions = Apollo.BaseMutationOptions<DeclineOwnInvitationMutation, DeclineOwnInvitationMutationVariables>;
export const RemoveInvitationDocument = gql`
    mutation RemoveInvitation($invitationId: String!) {
  deleteInvitation(id: $invitationId) {
    id
  }
}
    `;
export type RemoveInvitationMutationFn = Apollo.MutationFunction<RemoveInvitationMutation, RemoveInvitationMutationVariables>;

/**
 * __useRemoveInvitationMutation__
 *
 * To run a mutation, you first call `useRemoveInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInvitationMutation, { data, loading, error }] = useRemoveInvitationMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useRemoveInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInvitationMutation, RemoveInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInvitationMutation, RemoveInvitationMutationVariables>(RemoveInvitationDocument, options);
      }
export type RemoveInvitationMutationHookResult = ReturnType<typeof useRemoveInvitationMutation>;
export type RemoveInvitationMutationResult = Apollo.MutationResult<RemoveInvitationMutation>;
export type RemoveInvitationMutationOptions = Apollo.BaseMutationOptions<RemoveInvitationMutation, RemoveInvitationMutationVariables>;
export const CreateAccountDocument = gql`
    mutation CreateAccount($name: String!, $isTest: Boolean) {
  createAccount(input: {name: $name, isTest: $isTest}) {
    id
    slug
    name
  }
}
    `;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      name: // value for 'name'
 *      isTest: // value for 'isTest'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const SetDatawarehouseDocument = gql`
    mutation SetDatawarehouse($createConnectionInput: CreateConnectionInput!, $dataWarehouseSchemas: DataWarehouseSchemasInput) {
  setDatawarehouse(
    createConnectionInput: $createConnectionInput
    dataWarehouseSchemas: $dataWarehouseSchemas
  )
}
    `;
export type SetDatawarehouseMutationFn = Apollo.MutationFunction<SetDatawarehouseMutation, SetDatawarehouseMutationVariables>;

/**
 * __useSetDatawarehouseMutation__
 *
 * To run a mutation, you first call `useSetDatawarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDatawarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDatawarehouseMutation, { data, loading, error }] = useSetDatawarehouseMutation({
 *   variables: {
 *      createConnectionInput: // value for 'createConnectionInput'
 *      dataWarehouseSchemas: // value for 'dataWarehouseSchemas'
 *   },
 * });
 */
export function useSetDatawarehouseMutation(baseOptions?: Apollo.MutationHookOptions<SetDatawarehouseMutation, SetDatawarehouseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDatawarehouseMutation, SetDatawarehouseMutationVariables>(SetDatawarehouseDocument, options);
      }
export type SetDatawarehouseMutationHookResult = ReturnType<typeof useSetDatawarehouseMutation>;
export type SetDatawarehouseMutationResult = Apollo.MutationResult<SetDatawarehouseMutation>;
export type SetDatawarehouseMutationOptions = Apollo.BaseMutationOptions<SetDatawarehouseMutation, SetDatawarehouseMutationVariables>;
export const GetDatawarehouseSetupStatusDocument = gql`
    query GetDatawarehouseSetupStatus {
  getDatawarehouseSetupStatus {
    status
    error
  }
}
    `;

/**
 * __useGetDatawarehouseSetupStatusQuery__
 *
 * To run a query within a React component, call `useGetDatawarehouseSetupStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatawarehouseSetupStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatawarehouseSetupStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDatawarehouseSetupStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetDatawarehouseSetupStatusQuery, GetDatawarehouseSetupStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatawarehouseSetupStatusQuery, GetDatawarehouseSetupStatusQueryVariables>(GetDatawarehouseSetupStatusDocument, options);
      }
export function useGetDatawarehouseSetupStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatawarehouseSetupStatusQuery, GetDatawarehouseSetupStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatawarehouseSetupStatusQuery, GetDatawarehouseSetupStatusQueryVariables>(GetDatawarehouseSetupStatusDocument, options);
        }
export function useGetDatawarehouseSetupStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatawarehouseSetupStatusQuery, GetDatawarehouseSetupStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatawarehouseSetupStatusQuery, GetDatawarehouseSetupStatusQueryVariables>(GetDatawarehouseSetupStatusDocument, options);
        }
export type GetDatawarehouseSetupStatusQueryHookResult = ReturnType<typeof useGetDatawarehouseSetupStatusQuery>;
export type GetDatawarehouseSetupStatusLazyQueryHookResult = ReturnType<typeof useGetDatawarehouseSetupStatusLazyQuery>;
export type GetDatawarehouseSetupStatusSuspenseQueryHookResult = ReturnType<typeof useGetDatawarehouseSetupStatusSuspenseQuery>;
export type GetDatawarehouseSetupStatusQueryResult = Apollo.QueryResult<GetDatawarehouseSetupStatusQuery, GetDatawarehouseSetupStatusQueryVariables>;
export const UpdateDefaultIdentifierCasingDocument = gql`
    mutation UpdateDefaultIdentifierCasing($defaultIdentifierCasing: IdentifierCasing) {
  updateDefaultIdentifierCasing(defaultIdentifierCasing: $defaultIdentifierCasing) {
    accountId
    defaultIdentifierCasing
  }
}
    `;
export type UpdateDefaultIdentifierCasingMutationFn = Apollo.MutationFunction<UpdateDefaultIdentifierCasingMutation, UpdateDefaultIdentifierCasingMutationVariables>;

/**
 * __useUpdateDefaultIdentifierCasingMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultIdentifierCasingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultIdentifierCasingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultIdentifierCasingMutation, { data, loading, error }] = useUpdateDefaultIdentifierCasingMutation({
 *   variables: {
 *      defaultIdentifierCasing: // value for 'defaultIdentifierCasing'
 *   },
 * });
 */
export function useUpdateDefaultIdentifierCasingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDefaultIdentifierCasingMutation, UpdateDefaultIdentifierCasingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDefaultIdentifierCasingMutation, UpdateDefaultIdentifierCasingMutationVariables>(UpdateDefaultIdentifierCasingDocument, options);
      }
export type UpdateDefaultIdentifierCasingMutationHookResult = ReturnType<typeof useUpdateDefaultIdentifierCasingMutation>;
export type UpdateDefaultIdentifierCasingMutationResult = Apollo.MutationResult<UpdateDefaultIdentifierCasingMutation>;
export type UpdateDefaultIdentifierCasingMutationOptions = Apollo.BaseMutationOptions<UpdateDefaultIdentifierCasingMutation, UpdateDefaultIdentifierCasingMutationVariables>;
export const UpdateRawViewsDisabledDocument = gql`
    mutation UpdateRawViewsDisabled($rawViewsDisabled: Boolean!) {
  updateRawViewsDisabled(rawViewsDisabled: $rawViewsDisabled) {
    accountId
    rawViewsDisabled
  }
}
    `;
export type UpdateRawViewsDisabledMutationFn = Apollo.MutationFunction<UpdateRawViewsDisabledMutation, UpdateRawViewsDisabledMutationVariables>;

/**
 * __useUpdateRawViewsDisabledMutation__
 *
 * To run a mutation, you first call `useUpdateRawViewsDisabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRawViewsDisabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRawViewsDisabledMutation, { data, loading, error }] = useUpdateRawViewsDisabledMutation({
 *   variables: {
 *      rawViewsDisabled: // value for 'rawViewsDisabled'
 *   },
 * });
 */
export function useUpdateRawViewsDisabledMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRawViewsDisabledMutation, UpdateRawViewsDisabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRawViewsDisabledMutation, UpdateRawViewsDisabledMutationVariables>(UpdateRawViewsDisabledDocument, options);
      }
export type UpdateRawViewsDisabledMutationHookResult = ReturnType<typeof useUpdateRawViewsDisabledMutation>;
export type UpdateRawViewsDisabledMutationResult = Apollo.MutationResult<UpdateRawViewsDisabledMutation>;
export type UpdateRawViewsDisabledMutationOptions = Apollo.BaseMutationOptions<UpdateRawViewsDisabledMutation, UpdateRawViewsDisabledMutationVariables>;
export const DataWarehouseSchemasDocument = gql`
    query DataWarehouseSchemas {
  dataWarehouseSchemas {
    landing
    raw
    modelDatabase
    defaultIdentifierCasing
    rawViewsDisabled
  }
}
    `;

/**
 * __useDataWarehouseSchemasQuery__
 *
 * To run a query within a React component, call `useDataWarehouseSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataWarehouseSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataWarehouseSchemasQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataWarehouseSchemasQuery(baseOptions?: Apollo.QueryHookOptions<DataWarehouseSchemasQuery, DataWarehouseSchemasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataWarehouseSchemasQuery, DataWarehouseSchemasQueryVariables>(DataWarehouseSchemasDocument, options);
      }
export function useDataWarehouseSchemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataWarehouseSchemasQuery, DataWarehouseSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataWarehouseSchemasQuery, DataWarehouseSchemasQueryVariables>(DataWarehouseSchemasDocument, options);
        }
export function useDataWarehouseSchemasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DataWarehouseSchemasQuery, DataWarehouseSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataWarehouseSchemasQuery, DataWarehouseSchemasQueryVariables>(DataWarehouseSchemasDocument, options);
        }
export type DataWarehouseSchemasQueryHookResult = ReturnType<typeof useDataWarehouseSchemasQuery>;
export type DataWarehouseSchemasLazyQueryHookResult = ReturnType<typeof useDataWarehouseSchemasLazyQuery>;
export type DataWarehouseSchemasSuspenseQueryHookResult = ReturnType<typeof useDataWarehouseSchemasSuspenseQuery>;
export type DataWarehouseSchemasQueryResult = Apollo.QueryResult<DataWarehouseSchemasQuery, DataWarehouseSchemasQueryVariables>;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount($input: DeleteAccountInput!) {
  deleteAccount(input: $input) {
    id
  }
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const CreateWorkspaceWithManagedDatawarehouseDocument = gql`
    mutation CreateWorkspaceWithManagedDatawarehouse($workspaceName: String!, $dataWarehouseLocation: String!, $isTest: Boolean) {
  createWorkspaceWithManagedDatawarehouse(
    input: {workspaceName: $workspaceName, dataWarehouseLocation: $dataWarehouseLocation, isTest: $isTest}
  ) {
    id
    slug
    name
  }
}
    `;
export type CreateWorkspaceWithManagedDatawarehouseMutationFn = Apollo.MutationFunction<CreateWorkspaceWithManagedDatawarehouseMutation, CreateWorkspaceWithManagedDatawarehouseMutationVariables>;

/**
 * __useCreateWorkspaceWithManagedDatawarehouseMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceWithManagedDatawarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceWithManagedDatawarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceWithManagedDatawarehouseMutation, { data, loading, error }] = useCreateWorkspaceWithManagedDatawarehouseMutation({
 *   variables: {
 *      workspaceName: // value for 'workspaceName'
 *      dataWarehouseLocation: // value for 'dataWarehouseLocation'
 *      isTest: // value for 'isTest'
 *   },
 * });
 */
export function useCreateWorkspaceWithManagedDatawarehouseMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkspaceWithManagedDatawarehouseMutation, CreateWorkspaceWithManagedDatawarehouseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkspaceWithManagedDatawarehouseMutation, CreateWorkspaceWithManagedDatawarehouseMutationVariables>(CreateWorkspaceWithManagedDatawarehouseDocument, options);
      }
export type CreateWorkspaceWithManagedDatawarehouseMutationHookResult = ReturnType<typeof useCreateWorkspaceWithManagedDatawarehouseMutation>;
export type CreateWorkspaceWithManagedDatawarehouseMutationResult = Apollo.MutationResult<CreateWorkspaceWithManagedDatawarehouseMutation>;
export type CreateWorkspaceWithManagedDatawarehouseMutationOptions = Apollo.BaseMutationOptions<CreateWorkspaceWithManagedDatawarehouseMutation, CreateWorkspaceWithManagedDatawarehouseMutationVariables>;
export const StartSelfOnboardingProcessDocument = gql`
    mutation StartSelfOnboardingProcess($location: String!) {
  startSelfOnboardingProcess(location: $location)
}
    `;
export type StartSelfOnboardingProcessMutationFn = Apollo.MutationFunction<StartSelfOnboardingProcessMutation, StartSelfOnboardingProcessMutationVariables>;

/**
 * __useStartSelfOnboardingProcessMutation__
 *
 * To run a mutation, you first call `useStartSelfOnboardingProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSelfOnboardingProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSelfOnboardingProcessMutation, { data, loading, error }] = useStartSelfOnboardingProcessMutation({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useStartSelfOnboardingProcessMutation(baseOptions?: Apollo.MutationHookOptions<StartSelfOnboardingProcessMutation, StartSelfOnboardingProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSelfOnboardingProcessMutation, StartSelfOnboardingProcessMutationVariables>(StartSelfOnboardingProcessDocument, options);
      }
export type StartSelfOnboardingProcessMutationHookResult = ReturnType<typeof useStartSelfOnboardingProcessMutation>;
export type StartSelfOnboardingProcessMutationResult = Apollo.MutationResult<StartSelfOnboardingProcessMutation>;
export type StartSelfOnboardingProcessMutationOptions = Apollo.BaseMutationOptions<StartSelfOnboardingProcessMutation, StartSelfOnboardingProcessMutationVariables>;
export const GetSelfOnboardingProcessStatusDocument = gql`
    query GetSelfOnboardingProcessStatus {
  getSelfOnboardingProcessStatus {
    status
    error
  }
}
    `;

/**
 * __useGetSelfOnboardingProcessStatusQuery__
 *
 * To run a query within a React component, call `useGetSelfOnboardingProcessStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelfOnboardingProcessStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelfOnboardingProcessStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSelfOnboardingProcessStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetSelfOnboardingProcessStatusQuery, GetSelfOnboardingProcessStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelfOnboardingProcessStatusQuery, GetSelfOnboardingProcessStatusQueryVariables>(GetSelfOnboardingProcessStatusDocument, options);
      }
export function useGetSelfOnboardingProcessStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelfOnboardingProcessStatusQuery, GetSelfOnboardingProcessStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelfOnboardingProcessStatusQuery, GetSelfOnboardingProcessStatusQueryVariables>(GetSelfOnboardingProcessStatusDocument, options);
        }
export function useGetSelfOnboardingProcessStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSelfOnboardingProcessStatusQuery, GetSelfOnboardingProcessStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSelfOnboardingProcessStatusQuery, GetSelfOnboardingProcessStatusQueryVariables>(GetSelfOnboardingProcessStatusDocument, options);
        }
export type GetSelfOnboardingProcessStatusQueryHookResult = ReturnType<typeof useGetSelfOnboardingProcessStatusQuery>;
export type GetSelfOnboardingProcessStatusLazyQueryHookResult = ReturnType<typeof useGetSelfOnboardingProcessStatusLazyQuery>;
export type GetSelfOnboardingProcessStatusSuspenseQueryHookResult = ReturnType<typeof useGetSelfOnboardingProcessStatusSuspenseQuery>;
export type GetSelfOnboardingProcessStatusQueryResult = Apollo.QueryResult<GetSelfOnboardingProcessStatusQuery, GetSelfOnboardingProcessStatusQueryVariables>;
export const AddNotificationEmailDocument = gql`
    mutation AddNotificationEmail($notificationEmail: String!) {
  addNotificationEmail(input: {notificationEmail: $notificationEmail}) {
    id
  }
}
    `;
export type AddNotificationEmailMutationFn = Apollo.MutationFunction<AddNotificationEmailMutation, AddNotificationEmailMutationVariables>;

/**
 * __useAddNotificationEmailMutation__
 *
 * To run a mutation, you first call `useAddNotificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNotificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNotificationEmailMutation, { data, loading, error }] = useAddNotificationEmailMutation({
 *   variables: {
 *      notificationEmail: // value for 'notificationEmail'
 *   },
 * });
 */
export function useAddNotificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<AddNotificationEmailMutation, AddNotificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNotificationEmailMutation, AddNotificationEmailMutationVariables>(AddNotificationEmailDocument, options);
      }
export type AddNotificationEmailMutationHookResult = ReturnType<typeof useAddNotificationEmailMutation>;
export type AddNotificationEmailMutationResult = Apollo.MutationResult<AddNotificationEmailMutation>;
export type AddNotificationEmailMutationOptions = Apollo.BaseMutationOptions<AddNotificationEmailMutation, AddNotificationEmailMutationVariables>;
export const RemoveNotificationEmailDocument = gql`
    mutation RemoveNotificationEmail($notificationEmail: String!) {
  removeNotificationEmail(input: {notificationEmail: $notificationEmail}) {
    id
  }
}
    `;
export type RemoveNotificationEmailMutationFn = Apollo.MutationFunction<RemoveNotificationEmailMutation, RemoveNotificationEmailMutationVariables>;

/**
 * __useRemoveNotificationEmailMutation__
 *
 * To run a mutation, you first call `useRemoveNotificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNotificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNotificationEmailMutation, { data, loading, error }] = useRemoveNotificationEmailMutation({
 *   variables: {
 *      notificationEmail: // value for 'notificationEmail'
 *   },
 * });
 */
export function useRemoveNotificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<RemoveNotificationEmailMutation, RemoveNotificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveNotificationEmailMutation, RemoveNotificationEmailMutationVariables>(RemoveNotificationEmailDocument, options);
      }
export type RemoveNotificationEmailMutationHookResult = ReturnType<typeof useRemoveNotificationEmailMutation>;
export type RemoveNotificationEmailMutationResult = Apollo.MutationResult<RemoveNotificationEmailMutation>;
export type RemoveNotificationEmailMutationOptions = Apollo.BaseMutationOptions<RemoveNotificationEmailMutation, RemoveNotificationEmailMutationVariables>;
export const SessionStartedDocument = gql`
    mutation SessionStarted {
  sessionStarted
}
    `;
export type SessionStartedMutationFn = Apollo.MutationFunction<SessionStartedMutation, SessionStartedMutationVariables>;

/**
 * __useSessionStartedMutation__
 *
 * To run a mutation, you first call `useSessionStartedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSessionStartedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sessionStartedMutation, { data, loading, error }] = useSessionStartedMutation({
 *   variables: {
 *   },
 * });
 */
export function useSessionStartedMutation(baseOptions?: Apollo.MutationHookOptions<SessionStartedMutation, SessionStartedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SessionStartedMutation, SessionStartedMutationVariables>(SessionStartedDocument, options);
      }
export type SessionStartedMutationHookResult = ReturnType<typeof useSessionStartedMutation>;
export type SessionStartedMutationResult = Apollo.MutationResult<SessionStartedMutation>;
export type SessionStartedMutationOptions = Apollo.BaseMutationOptions<SessionStartedMutation, SessionStartedMutationVariables>;
export const SeedDataWarehouseDocument = gql`
    mutation SeedDataWarehouse {
  seedDataWarehouse {
    models {
      id
      name
    }
  }
}
    `;
export type SeedDataWarehouseMutationFn = Apollo.MutationFunction<SeedDataWarehouseMutation, SeedDataWarehouseMutationVariables>;

/**
 * __useSeedDataWarehouseMutation__
 *
 * To run a mutation, you first call `useSeedDataWarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeedDataWarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seedDataWarehouseMutation, { data, loading, error }] = useSeedDataWarehouseMutation({
 *   variables: {
 *   },
 * });
 */
export function useSeedDataWarehouseMutation(baseOptions?: Apollo.MutationHookOptions<SeedDataWarehouseMutation, SeedDataWarehouseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SeedDataWarehouseMutation, SeedDataWarehouseMutationVariables>(SeedDataWarehouseDocument, options);
      }
export type SeedDataWarehouseMutationHookResult = ReturnType<typeof useSeedDataWarehouseMutation>;
export type SeedDataWarehouseMutationResult = Apollo.MutationResult<SeedDataWarehouseMutation>;
export type SeedDataWarehouseMutationOptions = Apollo.BaseMutationOptions<SeedDataWarehouseMutation, SeedDataWarehouseMutationVariables>;
export const GetSlackChannelsDocument = gql`
    query GetSlackChannels($connectionId: String!) {
  getSlackChannels(connectionId: $connectionId) {
    id
    name
  }
}
    `;

/**
 * __useGetSlackChannelsQuery__
 *
 * To run a query within a React component, call `useGetSlackChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlackChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlackChannelsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useGetSlackChannelsQuery(baseOptions: Apollo.QueryHookOptions<GetSlackChannelsQuery, GetSlackChannelsQueryVariables> & ({ variables: GetSlackChannelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSlackChannelsQuery, GetSlackChannelsQueryVariables>(GetSlackChannelsDocument, options);
      }
export function useGetSlackChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSlackChannelsQuery, GetSlackChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSlackChannelsQuery, GetSlackChannelsQueryVariables>(GetSlackChannelsDocument, options);
        }
export function useGetSlackChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSlackChannelsQuery, GetSlackChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSlackChannelsQuery, GetSlackChannelsQueryVariables>(GetSlackChannelsDocument, options);
        }
export type GetSlackChannelsQueryHookResult = ReturnType<typeof useGetSlackChannelsQuery>;
export type GetSlackChannelsLazyQueryHookResult = ReturnType<typeof useGetSlackChannelsLazyQuery>;
export type GetSlackChannelsSuspenseQueryHookResult = ReturnType<typeof useGetSlackChannelsSuspenseQuery>;
export type GetSlackChannelsQueryResult = Apollo.QueryResult<GetSlackChannelsQuery, GetSlackChannelsQueryVariables>;
export const SetupSlackNotificationsDocument = gql`
    mutation SetupSlackNotifications($connectionId: String!, $channelId: String!, $channelName: String!) {
  setupSlackNotifications(
    input: {connectionId: $connectionId, channelId: $channelId, channelName: $channelName}
  ) {
    id
    slackNotificationInfo {
      id
      connectionId
      channelId
      channelName
    }
  }
}
    `;
export type SetupSlackNotificationsMutationFn = Apollo.MutationFunction<SetupSlackNotificationsMutation, SetupSlackNotificationsMutationVariables>;

/**
 * __useSetupSlackNotificationsMutation__
 *
 * To run a mutation, you first call `useSetupSlackNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupSlackNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupSlackNotificationsMutation, { data, loading, error }] = useSetupSlackNotificationsMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      channelId: // value for 'channelId'
 *      channelName: // value for 'channelName'
 *   },
 * });
 */
export function useSetupSlackNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<SetupSlackNotificationsMutation, SetupSlackNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupSlackNotificationsMutation, SetupSlackNotificationsMutationVariables>(SetupSlackNotificationsDocument, options);
      }
export type SetupSlackNotificationsMutationHookResult = ReturnType<typeof useSetupSlackNotificationsMutation>;
export type SetupSlackNotificationsMutationResult = Apollo.MutationResult<SetupSlackNotificationsMutation>;
export type SetupSlackNotificationsMutationOptions = Apollo.BaseMutationOptions<SetupSlackNotificationsMutation, SetupSlackNotificationsMutationVariables>;
export const DisconnectSlackNotificationsDocument = gql`
    mutation DisconnectSlackNotifications {
  disconnectSlackNotifications {
    id
  }
}
    `;
export type DisconnectSlackNotificationsMutationFn = Apollo.MutationFunction<DisconnectSlackNotificationsMutation, DisconnectSlackNotificationsMutationVariables>;

/**
 * __useDisconnectSlackNotificationsMutation__
 *
 * To run a mutation, you first call `useDisconnectSlackNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectSlackNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectSlackNotificationsMutation, { data, loading, error }] = useDisconnectSlackNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisconnectSlackNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectSlackNotificationsMutation, DisconnectSlackNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectSlackNotificationsMutation, DisconnectSlackNotificationsMutationVariables>(DisconnectSlackNotificationsDocument, options);
      }
export type DisconnectSlackNotificationsMutationHookResult = ReturnType<typeof useDisconnectSlackNotificationsMutation>;
export type DisconnectSlackNotificationsMutationResult = Apollo.MutationResult<DisconnectSlackNotificationsMutation>;
export type DisconnectSlackNotificationsMutationOptions = Apollo.BaseMutationOptions<DisconnectSlackNotificationsMutation, DisconnectSlackNotificationsMutationVariables>;
export const SetupTeamsNotificationsDocument = gql`
    mutation SetupTeamsNotifications($webhookUrl: String!, $channelName: String!) {
  setupTeamsNotifications(
    input: {webhookUrl: $webhookUrl, channelName: $channelName}
  ) {
    id
    teamsNotificationInfo {
      id
      channelName
    }
  }
}
    `;
export type SetupTeamsNotificationsMutationFn = Apollo.MutationFunction<SetupTeamsNotificationsMutation, SetupTeamsNotificationsMutationVariables>;

/**
 * __useSetupTeamsNotificationsMutation__
 *
 * To run a mutation, you first call `useSetupTeamsNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupTeamsNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupTeamsNotificationsMutation, { data, loading, error }] = useSetupTeamsNotificationsMutation({
 *   variables: {
 *      webhookUrl: // value for 'webhookUrl'
 *      channelName: // value for 'channelName'
 *   },
 * });
 */
export function useSetupTeamsNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<SetupTeamsNotificationsMutation, SetupTeamsNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupTeamsNotificationsMutation, SetupTeamsNotificationsMutationVariables>(SetupTeamsNotificationsDocument, options);
      }
export type SetupTeamsNotificationsMutationHookResult = ReturnType<typeof useSetupTeamsNotificationsMutation>;
export type SetupTeamsNotificationsMutationResult = Apollo.MutationResult<SetupTeamsNotificationsMutation>;
export type SetupTeamsNotificationsMutationOptions = Apollo.BaseMutationOptions<SetupTeamsNotificationsMutation, SetupTeamsNotificationsMutationVariables>;
export const DisconnectTeamsNotificationsDocument = gql`
    mutation DisconnectTeamsNotifications {
  disconnectTeamsNotifications {
    id
  }
}
    `;
export type DisconnectTeamsNotificationsMutationFn = Apollo.MutationFunction<DisconnectTeamsNotificationsMutation, DisconnectTeamsNotificationsMutationVariables>;

/**
 * __useDisconnectTeamsNotificationsMutation__
 *
 * To run a mutation, you first call `useDisconnectTeamsNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectTeamsNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectTeamsNotificationsMutation, { data, loading, error }] = useDisconnectTeamsNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisconnectTeamsNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectTeamsNotificationsMutation, DisconnectTeamsNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectTeamsNotificationsMutation, DisconnectTeamsNotificationsMutationVariables>(DisconnectTeamsNotificationsDocument, options);
      }
export type DisconnectTeamsNotificationsMutationHookResult = ReturnType<typeof useDisconnectTeamsNotificationsMutation>;
export type DisconnectTeamsNotificationsMutationResult = Apollo.MutationResult<DisconnectTeamsNotificationsMutation>;
export type DisconnectTeamsNotificationsMutationOptions = Apollo.BaseMutationOptions<DisconnectTeamsNotificationsMutation, DisconnectTeamsNotificationsMutationVariables>;
export const GetMfaDocument = gql`
    query GetMfa {
  getMFA {
    hasMFA
    mfaMethods {
      id
      type
    }
  }
}
    `;

/**
 * __useGetMfaQuery__
 *
 * To run a query within a React component, call `useGetMfaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMfaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMfaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMfaQuery(baseOptions?: Apollo.QueryHookOptions<GetMfaQuery, GetMfaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMfaQuery, GetMfaQueryVariables>(GetMfaDocument, options);
      }
export function useGetMfaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMfaQuery, GetMfaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMfaQuery, GetMfaQueryVariables>(GetMfaDocument, options);
        }
export function useGetMfaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMfaQuery, GetMfaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMfaQuery, GetMfaQueryVariables>(GetMfaDocument, options);
        }
export type GetMfaQueryHookResult = ReturnType<typeof useGetMfaQuery>;
export type GetMfaLazyQueryHookResult = ReturnType<typeof useGetMfaLazyQuery>;
export type GetMfaSuspenseQueryHookResult = ReturnType<typeof useGetMfaSuspenseQuery>;
export type GetMfaQueryResult = Apollo.QueryResult<GetMfaQuery, GetMfaQueryVariables>;
export const SetMfaDocument = gql`
    mutation setMFA($mfa: Boolean!) {
  setMFA(use_mfa: $mfa)
}
    `;
export type SetMfaMutationFn = Apollo.MutationFunction<SetMfaMutation, SetMfaMutationVariables>;

/**
 * __useSetMfaMutation__
 *
 * To run a mutation, you first call `useSetMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMfaMutation, { data, loading, error }] = useSetMfaMutation({
 *   variables: {
 *      mfa: // value for 'mfa'
 *   },
 * });
 */
export function useSetMfaMutation(baseOptions?: Apollo.MutationHookOptions<SetMfaMutation, SetMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMfaMutation, SetMfaMutationVariables>(SetMfaDocument, options);
      }
export type SetMfaMutationHookResult = ReturnType<typeof useSetMfaMutation>;
export type SetMfaMutationResult = Apollo.MutationResult<SetMfaMutation>;
export type SetMfaMutationOptions = Apollo.BaseMutationOptions<SetMfaMutation, SetMfaMutationVariables>;
export const ApiKeysDocument = gql`
    query ApiKeys {
  apiKeys {
    id
    name
    createdAt
  }
}
    `;

/**
 * __useApiKeysQuery__
 *
 * To run a query within a React component, call `useApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
      }
export function useApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
export function useApiKeysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
export type ApiKeysQueryHookResult = ReturnType<typeof useApiKeysQuery>;
export type ApiKeysLazyQueryHookResult = ReturnType<typeof useApiKeysLazyQuery>;
export type ApiKeysSuspenseQueryHookResult = ReturnType<typeof useApiKeysSuspenseQuery>;
export type ApiKeysQueryResult = Apollo.QueryResult<ApiKeysQuery, ApiKeysQueryVariables>;
export const ApiSecretKeyDocument = gql`
    query ApiSecretKey($apiKeyId: String!) {
  apiSecretKey(apiKeyId: $apiKeyId)
}
    `;

/**
 * __useApiSecretKeyQuery__
 *
 * To run a query within a React component, call `useApiSecretKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiSecretKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiSecretKeyQuery({
 *   variables: {
 *      apiKeyId: // value for 'apiKeyId'
 *   },
 * });
 */
export function useApiSecretKeyQuery(baseOptions: Apollo.QueryHookOptions<ApiSecretKeyQuery, ApiSecretKeyQueryVariables> & ({ variables: ApiSecretKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiSecretKeyQuery, ApiSecretKeyQueryVariables>(ApiSecretKeyDocument, options);
      }
export function useApiSecretKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiSecretKeyQuery, ApiSecretKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiSecretKeyQuery, ApiSecretKeyQueryVariables>(ApiSecretKeyDocument, options);
        }
export function useApiSecretKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApiSecretKeyQuery, ApiSecretKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiSecretKeyQuery, ApiSecretKeyQueryVariables>(ApiSecretKeyDocument, options);
        }
export type ApiSecretKeyQueryHookResult = ReturnType<typeof useApiSecretKeyQuery>;
export type ApiSecretKeyLazyQueryHookResult = ReturnType<typeof useApiSecretKeyLazyQuery>;
export type ApiSecretKeySuspenseQueryHookResult = ReturnType<typeof useApiSecretKeySuspenseQuery>;
export type ApiSecretKeyQueryResult = Apollo.QueryResult<ApiSecretKeyQuery, ApiSecretKeyQueryVariables>;
export const CreateApiKeyDocument = gql`
    mutation CreateApiKey($input: CreateApiKeyInput!) {
  createApiKey(input: $input) {
    id
    name
    createdAt
  }
}
    `;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const DeleteApiKeyDocument = gql`
    mutation DeleteApiKey($apiKeyId: String!) {
  deleteApiKey(apiKeyId: $apiKeyId)
}
    `;
export type DeleteApiKeyMutationFn = Apollo.MutationFunction<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;

/**
 * __useDeleteApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiKeyMutation, { data, loading, error }] = useDeleteApiKeyMutation({
 *   variables: {
 *      apiKeyId: // value for 'apiKeyId'
 *   },
 * });
 */
export function useDeleteApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>(DeleteApiKeyDocument, options);
      }
export type DeleteApiKeyMutationHookResult = ReturnType<typeof useDeleteApiKeyMutation>;
export type DeleteApiKeyMutationResult = Apollo.MutationResult<DeleteApiKeyMutation>;
export type DeleteApiKeyMutationOptions = Apollo.BaseMutationOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;
export const ResendVerificationEmailDocument = gql`
    mutation ResendVerificationEmail {
  resendVerificationEmail
}
    `;
export type ResendVerificationEmailMutationFn = Apollo.MutationFunction<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(ResendVerificationEmailDocument, options);
      }
export type ResendVerificationEmailMutationHookResult = ReturnType<typeof useResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationResult = Apollo.MutationResult<ResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const ActivityEventsDocument = gql`
    query ActivityEvents($filter: ActivityFilterInput, $page: ActivityPageInput) {
  activityEvents(filter: $filter, page: $page) {
    items {
      ...ActivityEventFields
    }
    nextCursor
    hasMore
  }
}
    ${ActivityEventFieldsFragmentDoc}`;

/**
 * __useActivityEventsQuery__
 *
 * To run a query within a React component, call `useActivityEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityEventsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useActivityEventsQuery(baseOptions?: Apollo.QueryHookOptions<ActivityEventsQuery, ActivityEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityEventsQuery, ActivityEventsQueryVariables>(ActivityEventsDocument, options);
      }
export function useActivityEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityEventsQuery, ActivityEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityEventsQuery, ActivityEventsQueryVariables>(ActivityEventsDocument, options);
        }
export function useActivityEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActivityEventsQuery, ActivityEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityEventsQuery, ActivityEventsQueryVariables>(ActivityEventsDocument, options);
        }
export type ActivityEventsQueryHookResult = ReturnType<typeof useActivityEventsQuery>;
export type ActivityEventsLazyQueryHookResult = ReturnType<typeof useActivityEventsLazyQuery>;
export type ActivityEventsSuspenseQueryHookResult = ReturnType<typeof useActivityEventsSuspenseQuery>;
export type ActivityEventsQueryResult = Apollo.QueryResult<ActivityEventsQuery, ActivityEventsQueryVariables>;
export const ActivityFilterOptionsDocument = gql`
    query ActivityFilterOptions {
  activityFilterOptions {
    types
    actorKinds
    people {
      ...ActivityPersonActorFields
    }
  }
}
    ${ActivityPersonActorFieldsFragmentDoc}`;

/**
 * __useActivityFilterOptionsQuery__
 *
 * To run a query within a React component, call `useActivityFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivityFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ActivityFilterOptionsQuery, ActivityFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityFilterOptionsQuery, ActivityFilterOptionsQueryVariables>(ActivityFilterOptionsDocument, options);
      }
export function useActivityFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityFilterOptionsQuery, ActivityFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityFilterOptionsQuery, ActivityFilterOptionsQueryVariables>(ActivityFilterOptionsDocument, options);
        }
export function useActivityFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActivityFilterOptionsQuery, ActivityFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityFilterOptionsQuery, ActivityFilterOptionsQueryVariables>(ActivityFilterOptionsDocument, options);
        }
export type ActivityFilterOptionsQueryHookResult = ReturnType<typeof useActivityFilterOptionsQuery>;
export type ActivityFilterOptionsLazyQueryHookResult = ReturnType<typeof useActivityFilterOptionsLazyQuery>;
export type ActivityFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useActivityFilterOptionsSuspenseQuery>;
export type ActivityFilterOptionsQueryResult = Apollo.QueryResult<ActivityFilterOptionsQuery, ActivityFilterOptionsQueryVariables>;
export const ActivityNewCountDocument = gql`
    query ActivityNewCount {
  activityNewCount
}
    `;

/**
 * __useActivityNewCountQuery__
 *
 * To run a query within a React component, call `useActivityNewCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityNewCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityNewCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivityNewCountQuery(baseOptions?: Apollo.QueryHookOptions<ActivityNewCountQuery, ActivityNewCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityNewCountQuery, ActivityNewCountQueryVariables>(ActivityNewCountDocument, options);
      }
export function useActivityNewCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityNewCountQuery, ActivityNewCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityNewCountQuery, ActivityNewCountQueryVariables>(ActivityNewCountDocument, options);
        }
export function useActivityNewCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActivityNewCountQuery, ActivityNewCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityNewCountQuery, ActivityNewCountQueryVariables>(ActivityNewCountDocument, options);
        }
export type ActivityNewCountQueryHookResult = ReturnType<typeof useActivityNewCountQuery>;
export type ActivityNewCountLazyQueryHookResult = ReturnType<typeof useActivityNewCountLazyQuery>;
export type ActivityNewCountSuspenseQueryHookResult = ReturnType<typeof useActivityNewCountSuspenseQuery>;
export type ActivityNewCountQueryResult = Apollo.QueryResult<ActivityNewCountQuery, ActivityNewCountQueryVariables>;
export const MarkActivityLookedDocument = gql`
    mutation MarkActivityLooked($upTo: DateTime) {
  markActivityLooked(upTo: $upTo)
}
    `;
export type MarkActivityLookedMutationFn = Apollo.MutationFunction<MarkActivityLookedMutation, MarkActivityLookedMutationVariables>;

/**
 * __useMarkActivityLookedMutation__
 *
 * To run a mutation, you first call `useMarkActivityLookedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkActivityLookedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markActivityLookedMutation, { data, loading, error }] = useMarkActivityLookedMutation({
 *   variables: {
 *      upTo: // value for 'upTo'
 *   },
 * });
 */
export function useMarkActivityLookedMutation(baseOptions?: Apollo.MutationHookOptions<MarkActivityLookedMutation, MarkActivityLookedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkActivityLookedMutation, MarkActivityLookedMutationVariables>(MarkActivityLookedDocument, options);
      }
export type MarkActivityLookedMutationHookResult = ReturnType<typeof useMarkActivityLookedMutation>;
export type MarkActivityLookedMutationResult = Apollo.MutationResult<MarkActivityLookedMutation>;
export type MarkActivityLookedMutationOptions = Apollo.BaseMutationOptions<MarkActivityLookedMutation, MarkActivityLookedMutationVariables>;
export const AgentThreadsDocument = gql`
    query AgentThreads($surface: AgentSurface!) {
  agentThreads(surface: $surface) {
    id
    title
    modelId
    draftId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAgentThreadsQuery__
 *
 * To run a query within a React component, call `useAgentThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentThreadsQuery({
 *   variables: {
 *      surface: // value for 'surface'
 *   },
 * });
 */
export function useAgentThreadsQuery(baseOptions: Apollo.QueryHookOptions<AgentThreadsQuery, AgentThreadsQueryVariables> & ({ variables: AgentThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentThreadsQuery, AgentThreadsQueryVariables>(AgentThreadsDocument, options);
      }
export function useAgentThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentThreadsQuery, AgentThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentThreadsQuery, AgentThreadsQueryVariables>(AgentThreadsDocument, options);
        }
export function useAgentThreadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentThreadsQuery, AgentThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentThreadsQuery, AgentThreadsQueryVariables>(AgentThreadsDocument, options);
        }
export type AgentThreadsQueryHookResult = ReturnType<typeof useAgentThreadsQuery>;
export type AgentThreadsLazyQueryHookResult = ReturnType<typeof useAgentThreadsLazyQuery>;
export type AgentThreadsSuspenseQueryHookResult = ReturnType<typeof useAgentThreadsSuspenseQuery>;
export type AgentThreadsQueryResult = Apollo.QueryResult<AgentThreadsQuery, AgentThreadsQueryVariables>;
export const AgentThreadMessagesDocument = gql`
    query AgentThreadMessages($threadId: ID!) {
  agentThreadMessages(threadId: $threadId) {
    id
    role
    parts
    metadata
    createdAt
  }
}
    `;

/**
 * __useAgentThreadMessagesQuery__
 *
 * To run a query within a React component, call `useAgentThreadMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentThreadMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentThreadMessagesQuery({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useAgentThreadMessagesQuery(baseOptions: Apollo.QueryHookOptions<AgentThreadMessagesQuery, AgentThreadMessagesQueryVariables> & ({ variables: AgentThreadMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentThreadMessagesQuery, AgentThreadMessagesQueryVariables>(AgentThreadMessagesDocument, options);
      }
export function useAgentThreadMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentThreadMessagesQuery, AgentThreadMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentThreadMessagesQuery, AgentThreadMessagesQueryVariables>(AgentThreadMessagesDocument, options);
        }
export function useAgentThreadMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentThreadMessagesQuery, AgentThreadMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentThreadMessagesQuery, AgentThreadMessagesQueryVariables>(AgentThreadMessagesDocument, options);
        }
export type AgentThreadMessagesQueryHookResult = ReturnType<typeof useAgentThreadMessagesQuery>;
export type AgentThreadMessagesLazyQueryHookResult = ReturnType<typeof useAgentThreadMessagesLazyQuery>;
export type AgentThreadMessagesSuspenseQueryHookResult = ReturnType<typeof useAgentThreadMessagesSuspenseQuery>;
export type AgentThreadMessagesQueryResult = Apollo.QueryResult<AgentThreadMessagesQuery, AgentThreadMessagesQueryVariables>;
export const DeleteAgentThreadDocument = gql`
    mutation DeleteAgentThread($threadId: ID!) {
  deleteAgentThread(threadId: $threadId)
}
    `;
export type DeleteAgentThreadMutationFn = Apollo.MutationFunction<DeleteAgentThreadMutation, DeleteAgentThreadMutationVariables>;

/**
 * __useDeleteAgentThreadMutation__
 *
 * To run a mutation, you first call `useDeleteAgentThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgentThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgentThreadMutation, { data, loading, error }] = useDeleteAgentThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useDeleteAgentThreadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAgentThreadMutation, DeleteAgentThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAgentThreadMutation, DeleteAgentThreadMutationVariables>(DeleteAgentThreadDocument, options);
      }
export type DeleteAgentThreadMutationHookResult = ReturnType<typeof useDeleteAgentThreadMutation>;
export type DeleteAgentThreadMutationResult = Apollo.MutationResult<DeleteAgentThreadMutation>;
export type DeleteAgentThreadMutationOptions = Apollo.BaseMutationOptions<DeleteAgentThreadMutation, DeleteAgentThreadMutationVariables>;
export const NotificationsDocument = gql`
    query Notifications {
  notifications {
    id
    accountId
    accountName
    type
    source
    detail
    createdAt
    updatedAt
    deletedAt
    entityType
    entityId
    entityName
    message
    notificationLevel
    lastOccurence
    isDismissable
    isLock
    expiration
    messageData
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export function useNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsSuspenseQueryHookResult = ReturnType<typeof useNotificationsSuspenseQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const RemoveNotificationDocument = gql`
    mutation RemoveNotification($input: RemoveNotificationInput!) {
  removeNotification(input: $input) {
    id
  }
}
    `;
export type RemoveNotificationMutationFn = Apollo.MutationFunction<RemoveNotificationMutation, RemoveNotificationMutationVariables>;

/**
 * __useRemoveNotificationMutation__
 *
 * To run a mutation, you first call `useRemoveNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNotificationMutation, { data, loading, error }] = useRemoveNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveNotificationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveNotificationMutation, RemoveNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveNotificationMutation, RemoveNotificationMutationVariables>(RemoveNotificationDocument, options);
      }
export type RemoveNotificationMutationHookResult = ReturnType<typeof useRemoveNotificationMutation>;
export type RemoveNotificationMutationResult = Apollo.MutationResult<RemoveNotificationMutation>;
export type RemoveNotificationMutationOptions = Apollo.BaseMutationOptions<RemoveNotificationMutation, RemoveNotificationMutationVariables>;
export const DismissAllNotificationsDocument = gql`
    mutation DismissAllNotifications {
  dismissAllNotifications
}
    `;
export type DismissAllNotificationsMutationFn = Apollo.MutationFunction<DismissAllNotificationsMutation, DismissAllNotificationsMutationVariables>;

/**
 * __useDismissAllNotificationsMutation__
 *
 * To run a mutation, you first call `useDismissAllNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissAllNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissAllNotificationsMutation, { data, loading, error }] = useDismissAllNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDismissAllNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<DismissAllNotificationsMutation, DismissAllNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissAllNotificationsMutation, DismissAllNotificationsMutationVariables>(DismissAllNotificationsDocument, options);
      }
export type DismissAllNotificationsMutationHookResult = ReturnType<typeof useDismissAllNotificationsMutation>;
export type DismissAllNotificationsMutationResult = Apollo.MutationResult<DismissAllNotificationsMutation>;
export type DismissAllNotificationsMutationOptions = Apollo.BaseMutationOptions<DismissAllNotificationsMutation, DismissAllNotificationsMutationVariables>;
export const FindAllAvailableAuditLogsDocument = gql`
    query FindAllAvailableAuditLogs {
  findAllAvailableAuditLogs {
    logs {
      date
      count
      type
    }
  }
}
    `;

/**
 * __useFindAllAvailableAuditLogsQuery__
 *
 * To run a query within a React component, call `useFindAllAvailableAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllAvailableAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllAvailableAuditLogsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindAllAvailableAuditLogsQuery(baseOptions?: Apollo.QueryHookOptions<FindAllAvailableAuditLogsQuery, FindAllAvailableAuditLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllAvailableAuditLogsQuery, FindAllAvailableAuditLogsQueryVariables>(FindAllAvailableAuditLogsDocument, options);
      }
export function useFindAllAvailableAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllAvailableAuditLogsQuery, FindAllAvailableAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllAvailableAuditLogsQuery, FindAllAvailableAuditLogsQueryVariables>(FindAllAvailableAuditLogsDocument, options);
        }
export function useFindAllAvailableAuditLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAllAvailableAuditLogsQuery, FindAllAvailableAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAllAvailableAuditLogsQuery, FindAllAvailableAuditLogsQueryVariables>(FindAllAvailableAuditLogsDocument, options);
        }
export type FindAllAvailableAuditLogsQueryHookResult = ReturnType<typeof useFindAllAvailableAuditLogsQuery>;
export type FindAllAvailableAuditLogsLazyQueryHookResult = ReturnType<typeof useFindAllAvailableAuditLogsLazyQuery>;
export type FindAllAvailableAuditLogsSuspenseQueryHookResult = ReturnType<typeof useFindAllAvailableAuditLogsSuspenseQuery>;
export type FindAllAvailableAuditLogsQueryResult = Apollo.QueryResult<FindAllAvailableAuditLogsQuery, FindAllAvailableAuditLogsQueryVariables>;
export const ConnectionDocument = gql`
    query Connection($id: String!) {
  connection(id: $id) {
    ...ConnectionBase
    ...ConnectionWithSyncs
    user {
      firstName
      lastName
      email
    }
  }
}
    ${ConnectionBaseFragmentDoc}
${ConnectionWithSyncsFragmentDoc}`;

/**
 * __useConnectionQuery__
 *
 * To run a query within a React component, call `useConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConnectionQuery(baseOptions: Apollo.QueryHookOptions<ConnectionQuery, ConnectionQueryVariables> & ({ variables: ConnectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectionQuery, ConnectionQueryVariables>(ConnectionDocument, options);
      }
export function useConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectionQuery, ConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectionQuery, ConnectionQueryVariables>(ConnectionDocument, options);
        }
export function useConnectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectionQuery, ConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectionQuery, ConnectionQueryVariables>(ConnectionDocument, options);
        }
export type ConnectionQueryHookResult = ReturnType<typeof useConnectionQuery>;
export type ConnectionLazyQueryHookResult = ReturnType<typeof useConnectionLazyQuery>;
export type ConnectionSuspenseQueryHookResult = ReturnType<typeof useConnectionSuspenseQuery>;
export type ConnectionQueryResult = Apollo.QueryResult<ConnectionQuery, ConnectionQueryVariables>;
export const ConnectionWithCredentialsDocument = gql`
    query ConnectionWithCredentials($id: String!) {
  connection: connectionWithConnectedBy(id: $id) {
    ...ConnectionBase
    ...ConnectionWithSyncs
    user {
      firstName
      lastName
      email
    }
    apiKey {
      name
    }
    connectedExternally
    source
    credentials
  }
}
    ${ConnectionBaseFragmentDoc}
${ConnectionWithSyncsFragmentDoc}`;

/**
 * __useConnectionWithCredentialsQuery__
 *
 * To run a query within a React component, call `useConnectionWithCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionWithCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionWithCredentialsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConnectionWithCredentialsQuery(baseOptions: Apollo.QueryHookOptions<ConnectionWithCredentialsQuery, ConnectionWithCredentialsQueryVariables> & ({ variables: ConnectionWithCredentialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectionWithCredentialsQuery, ConnectionWithCredentialsQueryVariables>(ConnectionWithCredentialsDocument, options);
      }
export function useConnectionWithCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectionWithCredentialsQuery, ConnectionWithCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectionWithCredentialsQuery, ConnectionWithCredentialsQueryVariables>(ConnectionWithCredentialsDocument, options);
        }
export function useConnectionWithCredentialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectionWithCredentialsQuery, ConnectionWithCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectionWithCredentialsQuery, ConnectionWithCredentialsQueryVariables>(ConnectionWithCredentialsDocument, options);
        }
export type ConnectionWithCredentialsQueryHookResult = ReturnType<typeof useConnectionWithCredentialsQuery>;
export type ConnectionWithCredentialsLazyQueryHookResult = ReturnType<typeof useConnectionWithCredentialsLazyQuery>;
export type ConnectionWithCredentialsSuspenseQueryHookResult = ReturnType<typeof useConnectionWithCredentialsSuspenseQuery>;
export type ConnectionWithCredentialsQueryResult = Apollo.QueryResult<ConnectionWithCredentialsQuery, ConnectionWithCredentialsQueryVariables>;
export const ConnectionsDocument = gql`
    query Connections {
  connections {
    ...ConnectionBase
  }
}
    ${ConnectionBaseFragmentDoc}`;

/**
 * __useConnectionsQuery__
 *
 * To run a query within a React component, call `useConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<ConnectionsQuery, ConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectionsQuery, ConnectionsQueryVariables>(ConnectionsDocument, options);
      }
export function useConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectionsQuery, ConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectionsQuery, ConnectionsQueryVariables>(ConnectionsDocument, options);
        }
export function useConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectionsQuery, ConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectionsQuery, ConnectionsQueryVariables>(ConnectionsDocument, options);
        }
export type ConnectionsQueryHookResult = ReturnType<typeof useConnectionsQuery>;
export type ConnectionsLazyQueryHookResult = ReturnType<typeof useConnectionsLazyQuery>;
export type ConnectionsSuspenseQueryHookResult = ReturnType<typeof useConnectionsSuspenseQuery>;
export type ConnectionsQueryResult = Apollo.QueryResult<ConnectionsQuery, ConnectionsQueryVariables>;
export const ConnectionsWithUsageSummaryDocument = gql`
    query ConnectionsWithUsageSummary {
  connectors {
    ...ConnectionBase
    usageSummary {
      numEltSyncs
      numRevEltSyncs
      totalSyncs
    }
  }
}
    ${ConnectionBaseFragmentDoc}`;

/**
 * __useConnectionsWithUsageSummaryQuery__
 *
 * To run a query within a React component, call `useConnectionsWithUsageSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionsWithUsageSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionsWithUsageSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectionsWithUsageSummaryQuery(baseOptions?: Apollo.QueryHookOptions<ConnectionsWithUsageSummaryQuery, ConnectionsWithUsageSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectionsWithUsageSummaryQuery, ConnectionsWithUsageSummaryQueryVariables>(ConnectionsWithUsageSummaryDocument, options);
      }
export function useConnectionsWithUsageSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectionsWithUsageSummaryQuery, ConnectionsWithUsageSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectionsWithUsageSummaryQuery, ConnectionsWithUsageSummaryQueryVariables>(ConnectionsWithUsageSummaryDocument, options);
        }
export function useConnectionsWithUsageSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectionsWithUsageSummaryQuery, ConnectionsWithUsageSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectionsWithUsageSummaryQuery, ConnectionsWithUsageSummaryQueryVariables>(ConnectionsWithUsageSummaryDocument, options);
        }
export type ConnectionsWithUsageSummaryQueryHookResult = ReturnType<typeof useConnectionsWithUsageSummaryQuery>;
export type ConnectionsWithUsageSummaryLazyQueryHookResult = ReturnType<typeof useConnectionsWithUsageSummaryLazyQuery>;
export type ConnectionsWithUsageSummarySuspenseQueryHookResult = ReturnType<typeof useConnectionsWithUsageSummarySuspenseQuery>;
export type ConnectionsWithUsageSummaryQueryResult = Apollo.QueryResult<ConnectionsWithUsageSummaryQuery, ConnectionsWithUsageSummaryQueryVariables>;
export const EltConnectionSettingsDocument = gql`
    query EltConnectionSettings($input: GetSettingsInput!) {
  getEltSettings(input: $input) {
    connectionSettings
  }
}
    `;

/**
 * __useEltConnectionSettingsQuery__
 *
 * To run a query within a React component, call `useEltConnectionSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltConnectionSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltConnectionSettingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEltConnectionSettingsQuery(baseOptions: Apollo.QueryHookOptions<EltConnectionSettingsQuery, EltConnectionSettingsQueryVariables> & ({ variables: EltConnectionSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltConnectionSettingsQuery, EltConnectionSettingsQueryVariables>(EltConnectionSettingsDocument, options);
      }
export function useEltConnectionSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltConnectionSettingsQuery, EltConnectionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltConnectionSettingsQuery, EltConnectionSettingsQueryVariables>(EltConnectionSettingsDocument, options);
        }
export function useEltConnectionSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltConnectionSettingsQuery, EltConnectionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltConnectionSettingsQuery, EltConnectionSettingsQueryVariables>(EltConnectionSettingsDocument, options);
        }
export type EltConnectionSettingsQueryHookResult = ReturnType<typeof useEltConnectionSettingsQuery>;
export type EltConnectionSettingsLazyQueryHookResult = ReturnType<typeof useEltConnectionSettingsLazyQuery>;
export type EltConnectionSettingsSuspenseQueryHookResult = ReturnType<typeof useEltConnectionSettingsSuspenseQuery>;
export type EltConnectionSettingsQueryResult = Apollo.QueryResult<EltConnectionSettingsQuery, EltConnectionSettingsQueryVariables>;
export const ActivateConnectionSettingsDocument = gql`
    query activateConnectionSettings($input: GetSettingsInput!) {
  getActivateSettings(input: $input) {
    connectionSettings
  }
}
    `;

/**
 * __useActivateConnectionSettingsQuery__
 *
 * To run a query within a React component, call `useActivateConnectionSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivateConnectionSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivateConnectionSettingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateConnectionSettingsQuery(baseOptions: Apollo.QueryHookOptions<ActivateConnectionSettingsQuery, ActivateConnectionSettingsQueryVariables> & ({ variables: ActivateConnectionSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivateConnectionSettingsQuery, ActivateConnectionSettingsQueryVariables>(ActivateConnectionSettingsDocument, options);
      }
export function useActivateConnectionSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivateConnectionSettingsQuery, ActivateConnectionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivateConnectionSettingsQuery, ActivateConnectionSettingsQueryVariables>(ActivateConnectionSettingsDocument, options);
        }
export function useActivateConnectionSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActivateConnectionSettingsQuery, ActivateConnectionSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivateConnectionSettingsQuery, ActivateConnectionSettingsQueryVariables>(ActivateConnectionSettingsDocument, options);
        }
export type ActivateConnectionSettingsQueryHookResult = ReturnType<typeof useActivateConnectionSettingsQuery>;
export type ActivateConnectionSettingsLazyQueryHookResult = ReturnType<typeof useActivateConnectionSettingsLazyQuery>;
export type ActivateConnectionSettingsSuspenseQueryHookResult = ReturnType<typeof useActivateConnectionSettingsSuspenseQuery>;
export type ActivateConnectionSettingsQueryResult = Apollo.QueryResult<ActivateConnectionSettingsQuery, ActivateConnectionSettingsQueryVariables>;
export const ObjectTypeSettingsDocument = gql`
    query ObjectTypeSettings($objectType: String!, $connectionId: String!, $formValues: JSONObject) {
  getObjectTypeSettings(
    objectType: $objectType
    connectionId: $connectionId
    formValues: $formValues
  ) {
    settings
  }
}
    `;

/**
 * __useObjectTypeSettingsQuery__
 *
 * To run a query within a React component, call `useObjectTypeSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useObjectTypeSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObjectTypeSettingsQuery({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      connectionId: // value for 'connectionId'
 *      formValues: // value for 'formValues'
 *   },
 * });
 */
export function useObjectTypeSettingsQuery(baseOptions: Apollo.QueryHookOptions<ObjectTypeSettingsQuery, ObjectTypeSettingsQueryVariables> & ({ variables: ObjectTypeSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ObjectTypeSettingsQuery, ObjectTypeSettingsQueryVariables>(ObjectTypeSettingsDocument, options);
      }
export function useObjectTypeSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ObjectTypeSettingsQuery, ObjectTypeSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ObjectTypeSettingsQuery, ObjectTypeSettingsQueryVariables>(ObjectTypeSettingsDocument, options);
        }
export function useObjectTypeSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ObjectTypeSettingsQuery, ObjectTypeSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ObjectTypeSettingsQuery, ObjectTypeSettingsQueryVariables>(ObjectTypeSettingsDocument, options);
        }
export type ObjectTypeSettingsQueryHookResult = ReturnType<typeof useObjectTypeSettingsQuery>;
export type ObjectTypeSettingsLazyQueryHookResult = ReturnType<typeof useObjectTypeSettingsLazyQuery>;
export type ObjectTypeSettingsSuspenseQueryHookResult = ReturnType<typeof useObjectTypeSettingsSuspenseQuery>;
export type ObjectTypeSettingsQueryResult = Apollo.QueryResult<ObjectTypeSettingsQuery, ObjectTypeSettingsQueryVariables>;
export const RemoveConnectionDocument = gql`
    mutation RemoveConnection($connectionId: String!) {
  removeConnection(id: $connectionId) {
    id
  }
}
    `;
export type RemoveConnectionMutationFn = Apollo.MutationFunction<RemoveConnectionMutation, RemoveConnectionMutationVariables>;

/**
 * __useRemoveConnectionMutation__
 *
 * To run a mutation, you first call `useRemoveConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeConnectionMutation, { data, loading, error }] = useRemoveConnectionMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useRemoveConnectionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveConnectionMutation, RemoveConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveConnectionMutation, RemoveConnectionMutationVariables>(RemoveConnectionDocument, options);
      }
export type RemoveConnectionMutationHookResult = ReturnType<typeof useRemoveConnectionMutation>;
export type RemoveConnectionMutationResult = Apollo.MutationResult<RemoveConnectionMutation>;
export type RemoveConnectionMutationOptions = Apollo.BaseMutationOptions<RemoveConnectionMutation, RemoveConnectionMutationVariables>;
export const RefreshDestinationDocument = gql`
    mutation RefreshDestination($connectionId: String!) {
  refreshDestination(id: $connectionId) {
    id
  }
}
    `;
export type RefreshDestinationMutationFn = Apollo.MutationFunction<RefreshDestinationMutation, RefreshDestinationMutationVariables>;

/**
 * __useRefreshDestinationMutation__
 *
 * To run a mutation, you first call `useRefreshDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshDestinationMutation, { data, loading, error }] = useRefreshDestinationMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useRefreshDestinationMutation(baseOptions?: Apollo.MutationHookOptions<RefreshDestinationMutation, RefreshDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshDestinationMutation, RefreshDestinationMutationVariables>(RefreshDestinationDocument, options);
      }
export type RefreshDestinationMutationHookResult = ReturnType<typeof useRefreshDestinationMutation>;
export type RefreshDestinationMutationResult = Apollo.MutationResult<RefreshDestinationMutation>;
export type RefreshDestinationMutationOptions = Apollo.BaseMutationOptions<RefreshDestinationMutation, RefreshDestinationMutationVariables>;
export const CreateConnectionDocument = gql`
    mutation CreateConnection($integrationId: String!, $payload: String!, $label: String!, $formId: String) {
  createConnection(
    input: {integrationId: $integrationId, payload: $payload, label: $label, formId: $formId}
  ) {
    ...ConnectionBase
  }
}
    ${ConnectionBaseFragmentDoc}`;
export type CreateConnectionMutationFn = Apollo.MutationFunction<CreateConnectionMutation, CreateConnectionMutationVariables>;

/**
 * __useCreateConnectionMutation__
 *
 * To run a mutation, you first call `useCreateConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConnectionMutation, { data, loading, error }] = useCreateConnectionMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      payload: // value for 'payload'
 *      label: // value for 'label'
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useCreateConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateConnectionMutation, CreateConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConnectionMutation, CreateConnectionMutationVariables>(CreateConnectionDocument, options);
      }
export type CreateConnectionMutationHookResult = ReturnType<typeof useCreateConnectionMutation>;
export type CreateConnectionMutationResult = Apollo.MutationResult<CreateConnectionMutation>;
export type CreateConnectionMutationOptions = Apollo.BaseMutationOptions<CreateConnectionMutation, CreateConnectionMutationVariables>;
export const CreateConnectionBridgeDocument = gql`
    mutation CreateConnectionBridge($integrationId: String!, $connectionId: String, $label: String!) {
  createConnectionBridge(
    input: {connectionId: $connectionId, integrationId: $integrationId, label: $label}
  ) {
    ...ConnectionBridgeBase
  }
}
    ${ConnectionBridgeBaseFragmentDoc}`;
export type CreateConnectionBridgeMutationFn = Apollo.MutationFunction<CreateConnectionBridgeMutation, CreateConnectionBridgeMutationVariables>;

/**
 * __useCreateConnectionBridgeMutation__
 *
 * To run a mutation, you first call `useCreateConnectionBridgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectionBridgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConnectionBridgeMutation, { data, loading, error }] = useCreateConnectionBridgeMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      connectionId: // value for 'connectionId'
 *      label: // value for 'label'
 *   },
 * });
 */
export function useCreateConnectionBridgeMutation(baseOptions?: Apollo.MutationHookOptions<CreateConnectionBridgeMutation, CreateConnectionBridgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConnectionBridgeMutation, CreateConnectionBridgeMutationVariables>(CreateConnectionBridgeDocument, options);
      }
export type CreateConnectionBridgeMutationHookResult = ReturnType<typeof useCreateConnectionBridgeMutation>;
export type CreateConnectionBridgeMutationResult = Apollo.MutationResult<CreateConnectionBridgeMutation>;
export type CreateConnectionBridgeMutationOptions = Apollo.BaseMutationOptions<CreateConnectionBridgeMutation, CreateConnectionBridgeMutationVariables>;
export const GetConnectionBridgesDocument = gql`
    query GetConnectionBridges {
  connectionBridges {
    ...ConnectionBridgeBase
  }
}
    ${ConnectionBridgeBaseFragmentDoc}`;

/**
 * __useGetConnectionBridgesQuery__
 *
 * To run a query within a React component, call `useGetConnectionBridgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectionBridgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectionBridgesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConnectionBridgesQuery(baseOptions?: Apollo.QueryHookOptions<GetConnectionBridgesQuery, GetConnectionBridgesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectionBridgesQuery, GetConnectionBridgesQueryVariables>(GetConnectionBridgesDocument, options);
      }
export function useGetConnectionBridgesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectionBridgesQuery, GetConnectionBridgesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectionBridgesQuery, GetConnectionBridgesQueryVariables>(GetConnectionBridgesDocument, options);
        }
export function useGetConnectionBridgesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConnectionBridgesQuery, GetConnectionBridgesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConnectionBridgesQuery, GetConnectionBridgesQueryVariables>(GetConnectionBridgesDocument, options);
        }
export type GetConnectionBridgesQueryHookResult = ReturnType<typeof useGetConnectionBridgesQuery>;
export type GetConnectionBridgesLazyQueryHookResult = ReturnType<typeof useGetConnectionBridgesLazyQuery>;
export type GetConnectionBridgesSuspenseQueryHookResult = ReturnType<typeof useGetConnectionBridgesSuspenseQuery>;
export type GetConnectionBridgesQueryResult = Apollo.QueryResult<GetConnectionBridgesQuery, GetConnectionBridgesQueryVariables>;
export const DeleteConnectionBridgeDocument = gql`
    mutation DeleteConnectionBridge($id: String!) {
  deleteConnectionBridge(id: $id)
}
    `;
export type DeleteConnectionBridgeMutationFn = Apollo.MutationFunction<DeleteConnectionBridgeMutation, DeleteConnectionBridgeMutationVariables>;

/**
 * __useDeleteConnectionBridgeMutation__
 *
 * To run a mutation, you first call `useDeleteConnectionBridgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConnectionBridgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConnectionBridgeMutation, { data, loading, error }] = useDeleteConnectionBridgeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteConnectionBridgeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConnectionBridgeMutation, DeleteConnectionBridgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConnectionBridgeMutation, DeleteConnectionBridgeMutationVariables>(DeleteConnectionBridgeDocument, options);
      }
export type DeleteConnectionBridgeMutationHookResult = ReturnType<typeof useDeleteConnectionBridgeMutation>;
export type DeleteConnectionBridgeMutationResult = Apollo.MutationResult<DeleteConnectionBridgeMutation>;
export type DeleteConnectionBridgeMutationOptions = Apollo.BaseMutationOptions<DeleteConnectionBridgeMutation, DeleteConnectionBridgeMutationVariables>;
export const GetOAuthUrlDocument = gql`
    query GetOAuthURL($integrationId: String!, $payload: String!, $connectionId: String, $formId: String) {
  getOAuthURL(
    input: {connectionId: $connectionId, integrationId: $integrationId, payload: $payload, formId: $formId}
  )
}
    `;

/**
 * __useGetOAuthUrlQuery__
 *
 * To run a query within a React component, call `useGetOAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOAuthUrlQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      payload: // value for 'payload'
 *      connectionId: // value for 'connectionId'
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useGetOAuthUrlQuery(baseOptions: Apollo.QueryHookOptions<GetOAuthUrlQuery, GetOAuthUrlQueryVariables> & ({ variables: GetOAuthUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOAuthUrlQuery, GetOAuthUrlQueryVariables>(GetOAuthUrlDocument, options);
      }
export function useGetOAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOAuthUrlQuery, GetOAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOAuthUrlQuery, GetOAuthUrlQueryVariables>(GetOAuthUrlDocument, options);
        }
export function useGetOAuthUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOAuthUrlQuery, GetOAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOAuthUrlQuery, GetOAuthUrlQueryVariables>(GetOAuthUrlDocument, options);
        }
export type GetOAuthUrlQueryHookResult = ReturnType<typeof useGetOAuthUrlQuery>;
export type GetOAuthUrlLazyQueryHookResult = ReturnType<typeof useGetOAuthUrlLazyQuery>;
export type GetOAuthUrlSuspenseQueryHookResult = ReturnType<typeof useGetOAuthUrlSuspenseQuery>;
export type GetOAuthUrlQueryResult = Apollo.QueryResult<GetOAuthUrlQuery, GetOAuthUrlQueryVariables>;
export const UpdateConnectionDocument = gql`
    mutation UpdateConnection($connectionId: String!, $payload: String!, $formId: String) {
  updateConnection(
    input: {connectionId: $connectionId, payload: $payload, formId: $formId}
  ) {
    id
    label
    integrationId
  }
}
    `;
export type UpdateConnectionMutationFn = Apollo.MutationFunction<UpdateConnectionMutation, UpdateConnectionMutationVariables>;

/**
 * __useUpdateConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectionMutation, { data, loading, error }] = useUpdateConnectionMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      payload: // value for 'payload'
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useUpdateConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConnectionMutation, UpdateConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConnectionMutation, UpdateConnectionMutationVariables>(UpdateConnectionDocument, options);
      }
export type UpdateConnectionMutationHookResult = ReturnType<typeof useUpdateConnectionMutation>;
export type UpdateConnectionMutationResult = Apollo.MutationResult<UpdateConnectionMutation>;
export type UpdateConnectionMutationOptions = Apollo.BaseMutationOptions<UpdateConnectionMutation, UpdateConnectionMutationVariables>;
export const CreateExampleConnectionDocument = gql`
    mutation CreateExampleConnection($input: CreateExampleConnectionInput!) {
  createExampleConnection(input: $input) {
    id
    label
    integrationId
  }
}
    `;
export type CreateExampleConnectionMutationFn = Apollo.MutationFunction<CreateExampleConnectionMutation, CreateExampleConnectionMutationVariables>;

/**
 * __useCreateExampleConnectionMutation__
 *
 * To run a mutation, you first call `useCreateExampleConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExampleConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExampleConnectionMutation, { data, loading, error }] = useCreateExampleConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExampleConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateExampleConnectionMutation, CreateExampleConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExampleConnectionMutation, CreateExampleConnectionMutationVariables>(CreateExampleConnectionDocument, options);
      }
export type CreateExampleConnectionMutationHookResult = ReturnType<typeof useCreateExampleConnectionMutation>;
export type CreateExampleConnectionMutationResult = Apollo.MutationResult<CreateExampleConnectionMutation>;
export type CreateExampleConnectionMutationOptions = Apollo.BaseMutationOptions<CreateExampleConnectionMutation, CreateExampleConnectionMutationVariables>;
export const PreviewTableDataDocument = gql`
    query PreviewTableData($dependency: QueryDependencyInput!, $limit: Int) {
  previewTableData(input: {dependency: $dependency, limit: $limit}) {
    response
    dwSql
    weldSql
  }
}
    `;

/**
 * __usePreviewTableDataQuery__
 *
 * To run a query within a React component, call `usePreviewTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewTableDataQuery({
 *   variables: {
 *      dependency: // value for 'dependency'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePreviewTableDataQuery(baseOptions: Apollo.QueryHookOptions<PreviewTableDataQuery, PreviewTableDataQueryVariables> & ({ variables: PreviewTableDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewTableDataQuery, PreviewTableDataQueryVariables>(PreviewTableDataDocument, options);
      }
export function usePreviewTableDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewTableDataQuery, PreviewTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewTableDataQuery, PreviewTableDataQueryVariables>(PreviewTableDataDocument, options);
        }
export function usePreviewTableDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviewTableDataQuery, PreviewTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewTableDataQuery, PreviewTableDataQueryVariables>(PreviewTableDataDocument, options);
        }
export type PreviewTableDataQueryHookResult = ReturnType<typeof usePreviewTableDataQuery>;
export type PreviewTableDataLazyQueryHookResult = ReturnType<typeof usePreviewTableDataLazyQuery>;
export type PreviewTableDataSuspenseQueryHookResult = ReturnType<typeof usePreviewTableDataSuspenseQuery>;
export type PreviewTableDataQueryResult = Apollo.QueryResult<PreviewTableDataQuery, PreviewTableDataQueryVariables>;
export const BuildPreviewSqlDocument = gql`
    query BuildPreviewSql($weldTag: String!, $limit: Int) {
  buildPreviewSql(input: {weldTag: $weldTag, limit: $limit}) {
    weldSql
  }
}
    `;

/**
 * __useBuildPreviewSqlQuery__
 *
 * To run a query within a React component, call `useBuildPreviewSqlQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildPreviewSqlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildPreviewSqlQuery({
 *   variables: {
 *      weldTag: // value for 'weldTag'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBuildPreviewSqlQuery(baseOptions: Apollo.QueryHookOptions<BuildPreviewSqlQuery, BuildPreviewSqlQueryVariables> & ({ variables: BuildPreviewSqlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildPreviewSqlQuery, BuildPreviewSqlQueryVariables>(BuildPreviewSqlDocument, options);
      }
export function useBuildPreviewSqlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildPreviewSqlQuery, BuildPreviewSqlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildPreviewSqlQuery, BuildPreviewSqlQueryVariables>(BuildPreviewSqlDocument, options);
        }
export function useBuildPreviewSqlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BuildPreviewSqlQuery, BuildPreviewSqlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BuildPreviewSqlQuery, BuildPreviewSqlQueryVariables>(BuildPreviewSqlDocument, options);
        }
export type BuildPreviewSqlQueryHookResult = ReturnType<typeof useBuildPreviewSqlQuery>;
export type BuildPreviewSqlLazyQueryHookResult = ReturnType<typeof useBuildPreviewSqlLazyQuery>;
export type BuildPreviewSqlSuspenseQueryHookResult = ReturnType<typeof useBuildPreviewSqlSuspenseQuery>;
export type BuildPreviewSqlQueryResult = Apollo.QueryResult<BuildPreviewSqlQuery, BuildPreviewSqlQueryVariables>;
export const CreateAsyncQueryPreviewDocument = gql`
    mutation CreateAsyncQueryPreview($weldSql: String!, $dependencies: [QueryDependencyInput!]!) {
  createAsyncQueryPreview(weldSql: $weldSql, dependencies: $dependencies) {
    queryExecutionId
    dwSql
  }
}
    `;
export type CreateAsyncQueryPreviewMutationFn = Apollo.MutationFunction<CreateAsyncQueryPreviewMutation, CreateAsyncQueryPreviewMutationVariables>;

/**
 * __useCreateAsyncQueryPreviewMutation__
 *
 * To run a mutation, you first call `useCreateAsyncQueryPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAsyncQueryPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAsyncQueryPreviewMutation, { data, loading, error }] = useCreateAsyncQueryPreviewMutation({
 *   variables: {
 *      weldSql: // value for 'weldSql'
 *      dependencies: // value for 'dependencies'
 *   },
 * });
 */
export function useCreateAsyncQueryPreviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateAsyncQueryPreviewMutation, CreateAsyncQueryPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAsyncQueryPreviewMutation, CreateAsyncQueryPreviewMutationVariables>(CreateAsyncQueryPreviewDocument, options);
      }
export type CreateAsyncQueryPreviewMutationHookResult = ReturnType<typeof useCreateAsyncQueryPreviewMutation>;
export type CreateAsyncQueryPreviewMutationResult = Apollo.MutationResult<CreateAsyncQueryPreviewMutation>;
export type CreateAsyncQueryPreviewMutationOptions = Apollo.BaseMutationOptions<CreateAsyncQueryPreviewMutation, CreateAsyncQueryPreviewMutationVariables>;
export const AsyncQueryPreviewResultDocument = gql`
    query AsyncQueryPreviewResult($queryExecutionId: ID!) {
  asyncQueryPreviewResult(queryExecutionId: $queryExecutionId) {
    rows
    numRowsTotal
  }
}
    `;

/**
 * __useAsyncQueryPreviewResultQuery__
 *
 * To run a query within a React component, call `useAsyncQueryPreviewResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsyncQueryPreviewResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsyncQueryPreviewResultQuery({
 *   variables: {
 *      queryExecutionId: // value for 'queryExecutionId'
 *   },
 * });
 */
export function useAsyncQueryPreviewResultQuery(baseOptions: Apollo.QueryHookOptions<AsyncQueryPreviewResultQuery, AsyncQueryPreviewResultQueryVariables> & ({ variables: AsyncQueryPreviewResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsyncQueryPreviewResultQuery, AsyncQueryPreviewResultQueryVariables>(AsyncQueryPreviewResultDocument, options);
      }
export function useAsyncQueryPreviewResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsyncQueryPreviewResultQuery, AsyncQueryPreviewResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsyncQueryPreviewResultQuery, AsyncQueryPreviewResultQueryVariables>(AsyncQueryPreviewResultDocument, options);
        }
export function useAsyncQueryPreviewResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AsyncQueryPreviewResultQuery, AsyncQueryPreviewResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AsyncQueryPreviewResultQuery, AsyncQueryPreviewResultQueryVariables>(AsyncQueryPreviewResultDocument, options);
        }
export type AsyncQueryPreviewResultQueryHookResult = ReturnType<typeof useAsyncQueryPreviewResultQuery>;
export type AsyncQueryPreviewResultLazyQueryHookResult = ReturnType<typeof useAsyncQueryPreviewResultLazyQuery>;
export type AsyncQueryPreviewResultSuspenseQueryHookResult = ReturnType<typeof useAsyncQueryPreviewResultSuspenseQuery>;
export type AsyncQueryPreviewResultQueryResult = Apollo.QueryResult<AsyncQueryPreviewResultQuery, AsyncQueryPreviewResultQueryVariables>;
export const ValidateQueryDocument = gql`
    query ValidateQuery($weldSql: String!, $dependencies: [QueryDependencyInput!]!) {
  validateQuery(weldSql: $weldSql, dependencies: $dependencies) {
    error
    line
  }
}
    `;

/**
 * __useValidateQueryQuery__
 *
 * To run a query within a React component, call `useValidateQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateQueryQuery({
 *   variables: {
 *      weldSql: // value for 'weldSql'
 *      dependencies: // value for 'dependencies'
 *   },
 * });
 */
export function useValidateQueryQuery(baseOptions: Apollo.QueryHookOptions<ValidateQueryQuery, ValidateQueryQueryVariables> & ({ variables: ValidateQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateQueryQuery, ValidateQueryQueryVariables>(ValidateQueryDocument, options);
      }
export function useValidateQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateQueryQuery, ValidateQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateQueryQuery, ValidateQueryQueryVariables>(ValidateQueryDocument, options);
        }
export function useValidateQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateQueryQuery, ValidateQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateQueryQuery, ValidateQueryQueryVariables>(ValidateQueryDocument, options);
        }
export type ValidateQueryQueryHookResult = ReturnType<typeof useValidateQueryQuery>;
export type ValidateQueryLazyQueryHookResult = ReturnType<typeof useValidateQueryLazyQuery>;
export type ValidateQuerySuspenseQueryHookResult = ReturnType<typeof useValidateQuerySuspenseQuery>;
export type ValidateQueryQueryResult = Apollo.QueryResult<ValidateQueryQuery, ValidateQueryQueryVariables>;
export const AsyncQueryStatusDocument = gql`
    query AsyncQueryStatus($queryExecutionId: ID!) {
  asyncQueryStatus(queryExecutionId: $queryExecutionId) {
    status
  }
}
    `;

/**
 * __useAsyncQueryStatusQuery__
 *
 * To run a query within a React component, call `useAsyncQueryStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsyncQueryStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsyncQueryStatusQuery({
 *   variables: {
 *      queryExecutionId: // value for 'queryExecutionId'
 *   },
 * });
 */
export function useAsyncQueryStatusQuery(baseOptions: Apollo.QueryHookOptions<AsyncQueryStatusQuery, AsyncQueryStatusQueryVariables> & ({ variables: AsyncQueryStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsyncQueryStatusQuery, AsyncQueryStatusQueryVariables>(AsyncQueryStatusDocument, options);
      }
export function useAsyncQueryStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsyncQueryStatusQuery, AsyncQueryStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsyncQueryStatusQuery, AsyncQueryStatusQueryVariables>(AsyncQueryStatusDocument, options);
        }
export function useAsyncQueryStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AsyncQueryStatusQuery, AsyncQueryStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AsyncQueryStatusQuery, AsyncQueryStatusQueryVariables>(AsyncQueryStatusDocument, options);
        }
export type AsyncQueryStatusQueryHookResult = ReturnType<typeof useAsyncQueryStatusQuery>;
export type AsyncQueryStatusLazyQueryHookResult = ReturnType<typeof useAsyncQueryStatusLazyQuery>;
export type AsyncQueryStatusSuspenseQueryHookResult = ReturnType<typeof useAsyncQueryStatusSuspenseQuery>;
export type AsyncQueryStatusQueryResult = Apollo.QueryResult<AsyncQueryStatusQuery, AsyncQueryStatusQueryVariables>;
export const SchemasDocument = gql`
    query Schemas($sourceStreamNames: [String!]!, $sourceConnectionId: String!, $connectionSettings: JSONObject!) {
  getAllAvroSchemas(
    sourceStreamNames: $sourceStreamNames
    sourceConnectionId: $sourceConnectionId
    connectionSettings: $connectionSettings
  ) {
    schemas {
      sourceStreamName
      primaryKeys
      cursor
      fields {
        name
        type
        nullable
      }
    }
  }
}
    `;

/**
 * __useSchemasQuery__
 *
 * To run a query within a React component, call `useSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemasQuery({
 *   variables: {
 *      sourceStreamNames: // value for 'sourceStreamNames'
 *      sourceConnectionId: // value for 'sourceConnectionId'
 *      connectionSettings: // value for 'connectionSettings'
 *   },
 * });
 */
export function useSchemasQuery(baseOptions: Apollo.QueryHookOptions<SchemasQuery, SchemasQueryVariables> & ({ variables: SchemasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemasQuery, SchemasQueryVariables>(SchemasDocument, options);
      }
export function useSchemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemasQuery, SchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemasQuery, SchemasQueryVariables>(SchemasDocument, options);
        }
export function useSchemasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchemasQuery, SchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchemasQuery, SchemasQueryVariables>(SchemasDocument, options);
        }
export type SchemasQueryHookResult = ReturnType<typeof useSchemasQuery>;
export type SchemasLazyQueryHookResult = ReturnType<typeof useSchemasLazyQuery>;
export type SchemasSuspenseQueryHookResult = ReturnType<typeof useSchemasSuspenseQuery>;
export type SchemasQueryResult = Apollo.QueryResult<SchemasQuery, SchemasQueryVariables>;
export const RawViewDocument = gql`
    query RawView($viewId: String!) {
  rawView(viewId: $viewId) {
    ...RawView
  }
}
    ${RawViewFragmentDoc}`;

/**
 * __useRawViewQuery__
 *
 * To run a query within a React component, call `useRawViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRawViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRawViewQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useRawViewQuery(baseOptions: Apollo.QueryHookOptions<RawViewQuery, RawViewQueryVariables> & ({ variables: RawViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RawViewQuery, RawViewQueryVariables>(RawViewDocument, options);
      }
export function useRawViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RawViewQuery, RawViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RawViewQuery, RawViewQueryVariables>(RawViewDocument, options);
        }
export function useRawViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RawViewQuery, RawViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RawViewQuery, RawViewQueryVariables>(RawViewDocument, options);
        }
export type RawViewQueryHookResult = ReturnType<typeof useRawViewQuery>;
export type RawViewLazyQueryHookResult = ReturnType<typeof useRawViewLazyQuery>;
export type RawViewSuspenseQueryHookResult = ReturnType<typeof useRawViewSuspenseQuery>;
export type RawViewQueryResult = Apollo.QueryResult<RawViewQuery, RawViewQueryVariables>;
export const GetRawViewsDocument = gql`
    query GetRawViews {
  getRawViews {
    ...RawView
  }
}
    ${RawViewFragmentDoc}`;

/**
 * __useGetRawViewsQuery__
 *
 * To run a query within a React component, call `useGetRawViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRawViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRawViewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRawViewsQuery(baseOptions?: Apollo.QueryHookOptions<GetRawViewsQuery, GetRawViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRawViewsQuery, GetRawViewsQueryVariables>(GetRawViewsDocument, options);
      }
export function useGetRawViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRawViewsQuery, GetRawViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRawViewsQuery, GetRawViewsQueryVariables>(GetRawViewsDocument, options);
        }
export function useGetRawViewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRawViewsQuery, GetRawViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRawViewsQuery, GetRawViewsQueryVariables>(GetRawViewsDocument, options);
        }
export type GetRawViewsQueryHookResult = ReturnType<typeof useGetRawViewsQuery>;
export type GetRawViewsLazyQueryHookResult = ReturnType<typeof useGetRawViewsLazyQuery>;
export type GetRawViewsSuspenseQueryHookResult = ReturnType<typeof useGetRawViewsSuspenseQuery>;
export type GetRawViewsQueryResult = Apollo.QueryResult<GetRawViewsQuery, GetRawViewsQueryVariables>;
export const ViewDetailsByPathDocument = gql`
    query ViewDetailsByPath($path: [String!]!) {
  viewDetailsByPath(path: $path) {
    dataSchema {
      name
      type
      nullable
    }
  }
}
    `;

/**
 * __useViewDetailsByPathQuery__
 *
 * To run a query within a React component, call `useViewDetailsByPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewDetailsByPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewDetailsByPathQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useViewDetailsByPathQuery(baseOptions: Apollo.QueryHookOptions<ViewDetailsByPathQuery, ViewDetailsByPathQueryVariables> & ({ variables: ViewDetailsByPathQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewDetailsByPathQuery, ViewDetailsByPathQueryVariables>(ViewDetailsByPathDocument, options);
      }
export function useViewDetailsByPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewDetailsByPathQuery, ViewDetailsByPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewDetailsByPathQuery, ViewDetailsByPathQueryVariables>(ViewDetailsByPathDocument, options);
        }
export function useViewDetailsByPathSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewDetailsByPathQuery, ViewDetailsByPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewDetailsByPathQuery, ViewDetailsByPathQueryVariables>(ViewDetailsByPathDocument, options);
        }
export type ViewDetailsByPathQueryHookResult = ReturnType<typeof useViewDetailsByPathQuery>;
export type ViewDetailsByPathLazyQueryHookResult = ReturnType<typeof useViewDetailsByPathLazyQuery>;
export type ViewDetailsByPathSuspenseQueryHookResult = ReturnType<typeof useViewDetailsByPathSuspenseQuery>;
export type ViewDetailsByPathQueryResult = Apollo.QueryResult<ViewDetailsByPathQuery, ViewDetailsByPathQueryVariables>;
export const RawViewDetailsDocument = gql`
    query RawViewDetails($viewId: String!) {
  rawViewDetails(viewId: $viewId) {
    dataSchema {
      name
      type
      nullable
    }
  }
}
    `;

/**
 * __useRawViewDetailsQuery__
 *
 * To run a query within a React component, call `useRawViewDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRawViewDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRawViewDetailsQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useRawViewDetailsQuery(baseOptions: Apollo.QueryHookOptions<RawViewDetailsQuery, RawViewDetailsQueryVariables> & ({ variables: RawViewDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RawViewDetailsQuery, RawViewDetailsQueryVariables>(RawViewDetailsDocument, options);
      }
export function useRawViewDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RawViewDetailsQuery, RawViewDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RawViewDetailsQuery, RawViewDetailsQueryVariables>(RawViewDetailsDocument, options);
        }
export function useRawViewDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RawViewDetailsQuery, RawViewDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RawViewDetailsQuery, RawViewDetailsQueryVariables>(RawViewDetailsDocument, options);
        }
export type RawViewDetailsQueryHookResult = ReturnType<typeof useRawViewDetailsQuery>;
export type RawViewDetailsLazyQueryHookResult = ReturnType<typeof useRawViewDetailsLazyQuery>;
export type RawViewDetailsSuspenseQueryHookResult = ReturnType<typeof useRawViewDetailsSuspenseQuery>;
export type RawViewDetailsQueryResult = Apollo.QueryResult<RawViewDetailsQuery, RawViewDetailsQueryVariables>;
export const GetStreamsDocument = gql`
    query GetStreams($connectionId: String!, $sourceSettings: JSONObject!, $eltSyncId: String) {
  getStreams(
    connectionId: $connectionId
    sourceSettings: $sourceSettings
    eltSyncId: $eltSyncId
  ) {
    ...StreamWithSubstreams
  }
}
    ${StreamWithSubstreamsFragmentDoc}`;

/**
 * __useGetStreamsQuery__
 *
 * To run a query within a React component, call `useGetStreamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStreamsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      sourceSettings: // value for 'sourceSettings'
 *      eltSyncId: // value for 'eltSyncId'
 *   },
 * });
 */
export function useGetStreamsQuery(baseOptions: Apollo.QueryHookOptions<GetStreamsQuery, GetStreamsQueryVariables> & ({ variables: GetStreamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStreamsQuery, GetStreamsQueryVariables>(GetStreamsDocument, options);
      }
export function useGetStreamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStreamsQuery, GetStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStreamsQuery, GetStreamsQueryVariables>(GetStreamsDocument, options);
        }
export function useGetStreamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStreamsQuery, GetStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStreamsQuery, GetStreamsQueryVariables>(GetStreamsDocument, options);
        }
export type GetStreamsQueryHookResult = ReturnType<typeof useGetStreamsQuery>;
export type GetStreamsLazyQueryHookResult = ReturnType<typeof useGetStreamsLazyQuery>;
export type GetStreamsSuspenseQueryHookResult = ReturnType<typeof useGetStreamsSuspenseQuery>;
export type GetStreamsQueryResult = Apollo.QueryResult<GetStreamsQuery, GetStreamsQueryVariables>;
export const GetStreamsAsyncDocument = gql`
    query GetStreamsAsync($connectionId: String!, $sourceSettings: JSONObject!) {
  getStreamsAsync(connectionId: $connectionId, sourceSettings: $sourceSettings) {
    errorMessage
    status
    startedAt
    streams {
      ...StreamWithSubstreams
    }
  }
}
    ${StreamWithSubstreamsFragmentDoc}`;

/**
 * __useGetStreamsAsyncQuery__
 *
 * To run a query within a React component, call `useGetStreamsAsyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamsAsyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStreamsAsyncQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      sourceSettings: // value for 'sourceSettings'
 *   },
 * });
 */
export function useGetStreamsAsyncQuery(baseOptions: Apollo.QueryHookOptions<GetStreamsAsyncQuery, GetStreamsAsyncQueryVariables> & ({ variables: GetStreamsAsyncQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStreamsAsyncQuery, GetStreamsAsyncQueryVariables>(GetStreamsAsyncDocument, options);
      }
export function useGetStreamsAsyncLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStreamsAsyncQuery, GetStreamsAsyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStreamsAsyncQuery, GetStreamsAsyncQueryVariables>(GetStreamsAsyncDocument, options);
        }
export function useGetStreamsAsyncSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStreamsAsyncQuery, GetStreamsAsyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStreamsAsyncQuery, GetStreamsAsyncQueryVariables>(GetStreamsAsyncDocument, options);
        }
export type GetStreamsAsyncQueryHookResult = ReturnType<typeof useGetStreamsAsyncQuery>;
export type GetStreamsAsyncLazyQueryHookResult = ReturnType<typeof useGetStreamsAsyncLazyQuery>;
export type GetStreamsAsyncSuspenseQueryHookResult = ReturnType<typeof useGetStreamsAsyncSuspenseQuery>;
export type GetStreamsAsyncQueryResult = Apollo.QueryResult<GetStreamsAsyncQuery, GetStreamsAsyncQueryVariables>;
export const CancelStreamsAsyncJobDocument = gql`
    mutation CancelStreamsAsyncJob($connectionId: String!) {
  cancelStreamsAsyncJob(connectionId: $connectionId) {
    errorMessage
    status
    startedAt
    streams {
      ...StreamWithSubstreams
    }
  }
}
    ${StreamWithSubstreamsFragmentDoc}`;
export type CancelStreamsAsyncJobMutationFn = Apollo.MutationFunction<CancelStreamsAsyncJobMutation, CancelStreamsAsyncJobMutationVariables>;

/**
 * __useCancelStreamsAsyncJobMutation__
 *
 * To run a mutation, you first call `useCancelStreamsAsyncJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelStreamsAsyncJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelStreamsAsyncJobMutation, { data, loading, error }] = useCancelStreamsAsyncJobMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useCancelStreamsAsyncJobMutation(baseOptions?: Apollo.MutationHookOptions<CancelStreamsAsyncJobMutation, CancelStreamsAsyncJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelStreamsAsyncJobMutation, CancelStreamsAsyncJobMutationVariables>(CancelStreamsAsyncJobDocument, options);
      }
export type CancelStreamsAsyncJobMutationHookResult = ReturnType<typeof useCancelStreamsAsyncJobMutation>;
export type CancelStreamsAsyncJobMutationResult = Apollo.MutationResult<CancelStreamsAsyncJobMutation>;
export type CancelStreamsAsyncJobMutationOptions = Apollo.BaseMutationOptions<CancelStreamsAsyncJobMutation, CancelStreamsAsyncJobMutationVariables>;
export const SourceStreamsWithSubStreamsDocument = gql`
    query SourceStreamsWithSubStreams($connectionId: String!, $eltSyncId: String!, $sourceStreamNames: [String!]!) {
  sourceStreamsWithSubStreams(
    connectionId: $connectionId
    eltSyncId: $eltSyncId
    sourceStreamNames: $sourceStreamNames
  ) {
    name
    supportedModes
    configurableIncremental
    supportsMultipleIncrementalPointers
    defaultConfig
    enabledHistoryTable
    historyStreams {
      id
      substreamId
      destinationTableName
    }
    substreams {
      id
      destinationTableName
      retired
      retirementDetails {
        inFavorOf
        removalDate
        details
        link
      }
    }
  }
}
    `;

/**
 * __useSourceStreamsWithSubStreamsQuery__
 *
 * To run a query within a React component, call `useSourceStreamsWithSubStreamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceStreamsWithSubStreamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceStreamsWithSubStreamsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      eltSyncId: // value for 'eltSyncId'
 *      sourceStreamNames: // value for 'sourceStreamNames'
 *   },
 * });
 */
export function useSourceStreamsWithSubStreamsQuery(baseOptions: Apollo.QueryHookOptions<SourceStreamsWithSubStreamsQuery, SourceStreamsWithSubStreamsQueryVariables> & ({ variables: SourceStreamsWithSubStreamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourceStreamsWithSubStreamsQuery, SourceStreamsWithSubStreamsQueryVariables>(SourceStreamsWithSubStreamsDocument, options);
      }
export function useSourceStreamsWithSubStreamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourceStreamsWithSubStreamsQuery, SourceStreamsWithSubStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourceStreamsWithSubStreamsQuery, SourceStreamsWithSubStreamsQueryVariables>(SourceStreamsWithSubStreamsDocument, options);
        }
export function useSourceStreamsWithSubStreamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SourceStreamsWithSubStreamsQuery, SourceStreamsWithSubStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SourceStreamsWithSubStreamsQuery, SourceStreamsWithSubStreamsQueryVariables>(SourceStreamsWithSubStreamsDocument, options);
        }
export type SourceStreamsWithSubStreamsQueryHookResult = ReturnType<typeof useSourceStreamsWithSubStreamsQuery>;
export type SourceStreamsWithSubStreamsLazyQueryHookResult = ReturnType<typeof useSourceStreamsWithSubStreamsLazyQuery>;
export type SourceStreamsWithSubStreamsSuspenseQueryHookResult = ReturnType<typeof useSourceStreamsWithSubStreamsSuspenseQuery>;
export type SourceStreamsWithSubStreamsQueryResult = Apollo.QueryResult<SourceStreamsWithSubStreamsQuery, SourceStreamsWithSubStreamsQueryVariables>;
export const GetCustomFormValuesDocument = gql`
    query GetCustomFormValues($input: CustomFormInput!) {
  getCustomFormValues(input: $input) {
    customFormValues
  }
}
    `;

/**
 * __useGetCustomFormValuesQuery__
 *
 * To run a query within a React component, call `useGetCustomFormValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomFormValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomFormValuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCustomFormValuesQuery(baseOptions: Apollo.QueryHookOptions<GetCustomFormValuesQuery, GetCustomFormValuesQueryVariables> & ({ variables: GetCustomFormValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomFormValuesQuery, GetCustomFormValuesQueryVariables>(GetCustomFormValuesDocument, options);
      }
export function useGetCustomFormValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomFormValuesQuery, GetCustomFormValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomFormValuesQuery, GetCustomFormValuesQueryVariables>(GetCustomFormValuesDocument, options);
        }
export function useGetCustomFormValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomFormValuesQuery, GetCustomFormValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomFormValuesQuery, GetCustomFormValuesQueryVariables>(GetCustomFormValuesDocument, options);
        }
export type GetCustomFormValuesQueryHookResult = ReturnType<typeof useGetCustomFormValuesQuery>;
export type GetCustomFormValuesLazyQueryHookResult = ReturnType<typeof useGetCustomFormValuesLazyQuery>;
export type GetCustomFormValuesSuspenseQueryHookResult = ReturnType<typeof useGetCustomFormValuesSuspenseQuery>;
export type GetCustomFormValuesQueryResult = Apollo.QueryResult<GetCustomFormValuesQuery, GetCustomFormValuesQueryVariables>;
export const ValidateCustomFormDocument = gql`
    query ValidateCustomForm($input: CustomFormValidationInput!) {
  validateCustomForm(input: $input) {
    customFormValidationResult
  }
}
    `;

/**
 * __useValidateCustomFormQuery__
 *
 * To run a query within a React component, call `useValidateCustomFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCustomFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCustomFormQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateCustomFormQuery(baseOptions: Apollo.QueryHookOptions<ValidateCustomFormQuery, ValidateCustomFormQueryVariables> & ({ variables: ValidateCustomFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateCustomFormQuery, ValidateCustomFormQueryVariables>(ValidateCustomFormDocument, options);
      }
export function useValidateCustomFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateCustomFormQuery, ValidateCustomFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateCustomFormQuery, ValidateCustomFormQueryVariables>(ValidateCustomFormDocument, options);
        }
export function useValidateCustomFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateCustomFormQuery, ValidateCustomFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateCustomFormQuery, ValidateCustomFormQueryVariables>(ValidateCustomFormDocument, options);
        }
export type ValidateCustomFormQueryHookResult = ReturnType<typeof useValidateCustomFormQuery>;
export type ValidateCustomFormLazyQueryHookResult = ReturnType<typeof useValidateCustomFormLazyQuery>;
export type ValidateCustomFormSuspenseQueryHookResult = ReturnType<typeof useValidateCustomFormSuspenseQuery>;
export type ValidateCustomFormQueryResult = Apollo.QueryResult<ValidateCustomFormQuery, ValidateCustomFormQueryVariables>;
export const GenerateConnectionLabelDocument = gql`
    query GenerateConnectionLabel($baseLabel: String!) {
  generateConnectionLabel(baseLabel: $baseLabel)
}
    `;

/**
 * __useGenerateConnectionLabelQuery__
 *
 * To run a query within a React component, call `useGenerateConnectionLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateConnectionLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateConnectionLabelQuery({
 *   variables: {
 *      baseLabel: // value for 'baseLabel'
 *   },
 * });
 */
export function useGenerateConnectionLabelQuery(baseOptions: Apollo.QueryHookOptions<GenerateConnectionLabelQuery, GenerateConnectionLabelQueryVariables> & ({ variables: GenerateConnectionLabelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateConnectionLabelQuery, GenerateConnectionLabelQueryVariables>(GenerateConnectionLabelDocument, options);
      }
export function useGenerateConnectionLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateConnectionLabelQuery, GenerateConnectionLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateConnectionLabelQuery, GenerateConnectionLabelQueryVariables>(GenerateConnectionLabelDocument, options);
        }
export function useGenerateConnectionLabelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GenerateConnectionLabelQuery, GenerateConnectionLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateConnectionLabelQuery, GenerateConnectionLabelQueryVariables>(GenerateConnectionLabelDocument, options);
        }
export type GenerateConnectionLabelQueryHookResult = ReturnType<typeof useGenerateConnectionLabelQuery>;
export type GenerateConnectionLabelLazyQueryHookResult = ReturnType<typeof useGenerateConnectionLabelLazyQuery>;
export type GenerateConnectionLabelSuspenseQueryHookResult = ReturnType<typeof useGenerateConnectionLabelSuspenseQuery>;
export type GenerateConnectionLabelQueryResult = Apollo.QueryResult<GenerateConnectionLabelQuery, GenerateConnectionLabelQueryVariables>;
export const ConnectionCdcFeaturesDocument = gql`
    query ConnectionCDCFeatures($connectionId: String!, $sourceSettings: JSONObject) {
  connectionCDCFeatures(
    connectionId: $connectionId
    sourceSettings: $sourceSettings
  ) {
    ...ConnectionCDCFeatures
  }
}
    ${ConnectionCdcFeaturesFragmentDoc}`;

/**
 * __useConnectionCdcFeaturesQuery__
 *
 * To run a query within a React component, call `useConnectionCdcFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionCdcFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionCdcFeaturesQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      sourceSettings: // value for 'sourceSettings'
 *   },
 * });
 */
export function useConnectionCdcFeaturesQuery(baseOptions: Apollo.QueryHookOptions<ConnectionCdcFeaturesQuery, ConnectionCdcFeaturesQueryVariables> & ({ variables: ConnectionCdcFeaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectionCdcFeaturesQuery, ConnectionCdcFeaturesQueryVariables>(ConnectionCdcFeaturesDocument, options);
      }
export function useConnectionCdcFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectionCdcFeaturesQuery, ConnectionCdcFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectionCdcFeaturesQuery, ConnectionCdcFeaturesQueryVariables>(ConnectionCdcFeaturesDocument, options);
        }
export function useConnectionCdcFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectionCdcFeaturesQuery, ConnectionCdcFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectionCdcFeaturesQuery, ConnectionCdcFeaturesQueryVariables>(ConnectionCdcFeaturesDocument, options);
        }
export type ConnectionCdcFeaturesQueryHookResult = ReturnType<typeof useConnectionCdcFeaturesQuery>;
export type ConnectionCdcFeaturesLazyQueryHookResult = ReturnType<typeof useConnectionCdcFeaturesLazyQuery>;
export type ConnectionCdcFeaturesSuspenseQueryHookResult = ReturnType<typeof useConnectionCdcFeaturesSuspenseQuery>;
export type ConnectionCdcFeaturesQueryResult = Apollo.QueryResult<ConnectionCdcFeaturesQuery, ConnectionCdcFeaturesQueryVariables>;
export const ConnectorRestrictionDocument = gql`
    query ConnectorRestriction($connectionId: ID!) {
  connectorRestriction(connectionId: $connectionId) {
    ...ConnectorRestriction
  }
}
    ${ConnectorRestrictionFragmentDoc}`;

/**
 * __useConnectorRestrictionQuery__
 *
 * To run a query within a React component, call `useConnectorRestrictionQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectorRestrictionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectorRestrictionQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useConnectorRestrictionQuery(baseOptions: Apollo.QueryHookOptions<ConnectorRestrictionQuery, ConnectorRestrictionQueryVariables> & ({ variables: ConnectorRestrictionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectorRestrictionQuery, ConnectorRestrictionQueryVariables>(ConnectorRestrictionDocument, options);
      }
export function useConnectorRestrictionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectorRestrictionQuery, ConnectorRestrictionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectorRestrictionQuery, ConnectorRestrictionQueryVariables>(ConnectorRestrictionDocument, options);
        }
export function useConnectorRestrictionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectorRestrictionQuery, ConnectorRestrictionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectorRestrictionQuery, ConnectorRestrictionQueryVariables>(ConnectorRestrictionDocument, options);
        }
export type ConnectorRestrictionQueryHookResult = ReturnType<typeof useConnectorRestrictionQuery>;
export type ConnectorRestrictionLazyQueryHookResult = ReturnType<typeof useConnectorRestrictionLazyQuery>;
export type ConnectorRestrictionSuspenseQueryHookResult = ReturnType<typeof useConnectorRestrictionSuspenseQuery>;
export type ConnectorRestrictionQueryResult = Apollo.QueryResult<ConnectorRestrictionQuery, ConnectorRestrictionQueryVariables>;
export const RestrictedConnectorsDocument = gql`
    query RestrictedConnectors {
  restrictedConnectors {
    ...ConnectorRestriction
  }
}
    ${ConnectorRestrictionFragmentDoc}`;

/**
 * __useRestrictedConnectorsQuery__
 *
 * To run a query within a React component, call `useRestrictedConnectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestrictedConnectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestrictedConnectorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRestrictedConnectorsQuery(baseOptions?: Apollo.QueryHookOptions<RestrictedConnectorsQuery, RestrictedConnectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RestrictedConnectorsQuery, RestrictedConnectorsQueryVariables>(RestrictedConnectorsDocument, options);
      }
export function useRestrictedConnectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RestrictedConnectorsQuery, RestrictedConnectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RestrictedConnectorsQuery, RestrictedConnectorsQueryVariables>(RestrictedConnectorsDocument, options);
        }
export function useRestrictedConnectorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RestrictedConnectorsQuery, RestrictedConnectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RestrictedConnectorsQuery, RestrictedConnectorsQueryVariables>(RestrictedConnectorsDocument, options);
        }
export type RestrictedConnectorsQueryHookResult = ReturnType<typeof useRestrictedConnectorsQuery>;
export type RestrictedConnectorsLazyQueryHookResult = ReturnType<typeof useRestrictedConnectorsLazyQuery>;
export type RestrictedConnectorsSuspenseQueryHookResult = ReturnType<typeof useRestrictedConnectorsSuspenseQuery>;
export type RestrictedConnectorsQueryResult = Apollo.QueryResult<RestrictedConnectorsQuery, RestrictedConnectorsQueryVariables>;
export const SetConnectorRestrictionDocument = gql`
    mutation SetConnectorRestriction($input: SetConnectorRestrictionInput!) {
  setConnectorRestriction(input: $input) {
    ...ConnectorRestriction
  }
}
    ${ConnectorRestrictionFragmentDoc}`;
export type SetConnectorRestrictionMutationFn = Apollo.MutationFunction<SetConnectorRestrictionMutation, SetConnectorRestrictionMutationVariables>;

/**
 * __useSetConnectorRestrictionMutation__
 *
 * To run a mutation, you first call `useSetConnectorRestrictionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetConnectorRestrictionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setConnectorRestrictionMutation, { data, loading, error }] = useSetConnectorRestrictionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetConnectorRestrictionMutation(baseOptions?: Apollo.MutationHookOptions<SetConnectorRestrictionMutation, SetConnectorRestrictionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetConnectorRestrictionMutation, SetConnectorRestrictionMutationVariables>(SetConnectorRestrictionDocument, options);
      }
export type SetConnectorRestrictionMutationHookResult = ReturnType<typeof useSetConnectorRestrictionMutation>;
export type SetConnectorRestrictionMutationResult = Apollo.MutationResult<SetConnectorRestrictionMutation>;
export type SetConnectorRestrictionMutationOptions = Apollo.BaseMutationOptions<SetConnectorRestrictionMutation, SetConnectorRestrictionMutationVariables>;
export const StartDatawarehouseMigrationDocument = gql`
    mutation StartDatawarehouseMigration($createConnectionInput: CreateConnectionInput!) {
  startDatawarehouseMigration(createConnectionInput: $createConnectionInput) {
    id
    userId
    accountId
    status
    errorMessage
    createdAt
    pendingSyncs
    prevDWIntegrationId
  }
}
    `;
export type StartDatawarehouseMigrationMutationFn = Apollo.MutationFunction<StartDatawarehouseMigrationMutation, StartDatawarehouseMigrationMutationVariables>;

/**
 * __useStartDatawarehouseMigrationMutation__
 *
 * To run a mutation, you first call `useStartDatawarehouseMigrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartDatawarehouseMigrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startDatawarehouseMigrationMutation, { data, loading, error }] = useStartDatawarehouseMigrationMutation({
 *   variables: {
 *      createConnectionInput: // value for 'createConnectionInput'
 *   },
 * });
 */
export function useStartDatawarehouseMigrationMutation(baseOptions?: Apollo.MutationHookOptions<StartDatawarehouseMigrationMutation, StartDatawarehouseMigrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartDatawarehouseMigrationMutation, StartDatawarehouseMigrationMutationVariables>(StartDatawarehouseMigrationDocument, options);
      }
export type StartDatawarehouseMigrationMutationHookResult = ReturnType<typeof useStartDatawarehouseMigrationMutation>;
export type StartDatawarehouseMigrationMutationResult = Apollo.MutationResult<StartDatawarehouseMigrationMutation>;
export type StartDatawarehouseMigrationMutationOptions = Apollo.BaseMutationOptions<StartDatawarehouseMigrationMutation, StartDatawarehouseMigrationMutationVariables>;
export const DatawarehouseMigrationDocument = gql`
    query DatawarehouseMigration {
  datawarehouseMigration {
    id
    userId
    accountId
    status
    errorMessage
    createdAt
    pendingSyncs
    prevDWIntegrationId
    failed
  }
}
    `;

/**
 * __useDatawarehouseMigrationQuery__
 *
 * To run a query within a React component, call `useDatawarehouseMigrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatawarehouseMigrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatawarehouseMigrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useDatawarehouseMigrationQuery(baseOptions?: Apollo.QueryHookOptions<DatawarehouseMigrationQuery, DatawarehouseMigrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatawarehouseMigrationQuery, DatawarehouseMigrationQueryVariables>(DatawarehouseMigrationDocument, options);
      }
export function useDatawarehouseMigrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatawarehouseMigrationQuery, DatawarehouseMigrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatawarehouseMigrationQuery, DatawarehouseMigrationQueryVariables>(DatawarehouseMigrationDocument, options);
        }
export function useDatawarehouseMigrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DatawarehouseMigrationQuery, DatawarehouseMigrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DatawarehouseMigrationQuery, DatawarehouseMigrationQueryVariables>(DatawarehouseMigrationDocument, options);
        }
export type DatawarehouseMigrationQueryHookResult = ReturnType<typeof useDatawarehouseMigrationQuery>;
export type DatawarehouseMigrationLazyQueryHookResult = ReturnType<typeof useDatawarehouseMigrationLazyQuery>;
export type DatawarehouseMigrationSuspenseQueryHookResult = ReturnType<typeof useDatawarehouseMigrationSuspenseQuery>;
export type DatawarehouseMigrationQueryResult = Apollo.QueryResult<DatawarehouseMigrationQuery, DatawarehouseMigrationQueryVariables>;
export const CheckMigrationCompatibilityDocument = gql`
    query CheckMigrationCompatibility($createConnectionInput: CreateConnectionInput!) {
  checkMigrationCompatibility(createConnectionInput: $createConnectionInput)
}
    `;

/**
 * __useCheckMigrationCompatibilityQuery__
 *
 * To run a query within a React component, call `useCheckMigrationCompatibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckMigrationCompatibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckMigrationCompatibilityQuery({
 *   variables: {
 *      createConnectionInput: // value for 'createConnectionInput'
 *   },
 * });
 */
export function useCheckMigrationCompatibilityQuery(baseOptions: Apollo.QueryHookOptions<CheckMigrationCompatibilityQuery, CheckMigrationCompatibilityQueryVariables> & ({ variables: CheckMigrationCompatibilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckMigrationCompatibilityQuery, CheckMigrationCompatibilityQueryVariables>(CheckMigrationCompatibilityDocument, options);
      }
export function useCheckMigrationCompatibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckMigrationCompatibilityQuery, CheckMigrationCompatibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckMigrationCompatibilityQuery, CheckMigrationCompatibilityQueryVariables>(CheckMigrationCompatibilityDocument, options);
        }
export function useCheckMigrationCompatibilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckMigrationCompatibilityQuery, CheckMigrationCompatibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckMigrationCompatibilityQuery, CheckMigrationCompatibilityQueryVariables>(CheckMigrationCompatibilityDocument, options);
        }
export type CheckMigrationCompatibilityQueryHookResult = ReturnType<typeof useCheckMigrationCompatibilityQuery>;
export type CheckMigrationCompatibilityLazyQueryHookResult = ReturnType<typeof useCheckMigrationCompatibilityLazyQuery>;
export type CheckMigrationCompatibilitySuspenseQueryHookResult = ReturnType<typeof useCheckMigrationCompatibilitySuspenseQuery>;
export type CheckMigrationCompatibilityQueryResult = Apollo.QueryResult<CheckMigrationCompatibilityQuery, CheckMigrationCompatibilityQueryVariables>;
export const DbtConnectionDocument = gql`
    query DbtConnection {
  dbtConnection {
    ...ConnectionBase
  }
}
    ${ConnectionBaseFragmentDoc}`;

/**
 * __useDbtConnectionQuery__
 *
 * To run a query within a React component, call `useDbtConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDbtConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDbtConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useDbtConnectionQuery(baseOptions?: Apollo.QueryHookOptions<DbtConnectionQuery, DbtConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DbtConnectionQuery, DbtConnectionQueryVariables>(DbtConnectionDocument, options);
      }
export function useDbtConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DbtConnectionQuery, DbtConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DbtConnectionQuery, DbtConnectionQueryVariables>(DbtConnectionDocument, options);
        }
export function useDbtConnectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DbtConnectionQuery, DbtConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DbtConnectionQuery, DbtConnectionQueryVariables>(DbtConnectionDocument, options);
        }
export type DbtConnectionQueryHookResult = ReturnType<typeof useDbtConnectionQuery>;
export type DbtConnectionLazyQueryHookResult = ReturnType<typeof useDbtConnectionLazyQuery>;
export type DbtConnectionSuspenseQueryHookResult = ReturnType<typeof useDbtConnectionSuspenseQuery>;
export type DbtConnectionQueryResult = Apollo.QueryResult<DbtConnectionQuery, DbtConnectionQueryVariables>;
export const CreateDbtConnectionDocument = gql`
    mutation CreateDbtConnection($data: String!) {
  createDbtConnection(data: $data) {
    ...ConnectionBase
  }
}
    ${ConnectionBaseFragmentDoc}`;
export type CreateDbtConnectionMutationFn = Apollo.MutationFunction<CreateDbtConnectionMutation, CreateDbtConnectionMutationVariables>;

/**
 * __useCreateDbtConnectionMutation__
 *
 * To run a mutation, you first call `useCreateDbtConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDbtConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDbtConnectionMutation, { data, loading, error }] = useCreateDbtConnectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDbtConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateDbtConnectionMutation, CreateDbtConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDbtConnectionMutation, CreateDbtConnectionMutationVariables>(CreateDbtConnectionDocument, options);
      }
export type CreateDbtConnectionMutationHookResult = ReturnType<typeof useCreateDbtConnectionMutation>;
export type CreateDbtConnectionMutationResult = Apollo.MutationResult<CreateDbtConnectionMutation>;
export type CreateDbtConnectionMutationOptions = Apollo.BaseMutationOptions<CreateDbtConnectionMutation, CreateDbtConnectionMutationVariables>;
export const CreateAsyncQueryResultCsvDownloadDocument = gql`
    mutation CreateAsyncQueryResultCsvDownload($input: CreateQueryResultCsvDownloadInput!) {
  createAsyncQueryResultCsvDownload(input: $input) {
    ...DownloadStatusByUuid
  }
}
    ${DownloadStatusByUuidFragmentDoc}`;
export type CreateAsyncQueryResultCsvDownloadMutationFn = Apollo.MutationFunction<CreateAsyncQueryResultCsvDownloadMutation, CreateAsyncQueryResultCsvDownloadMutationVariables>;

/**
 * __useCreateAsyncQueryResultCsvDownloadMutation__
 *
 * To run a mutation, you first call `useCreateAsyncQueryResultCsvDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAsyncQueryResultCsvDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAsyncQueryResultCsvDownloadMutation, { data, loading, error }] = useCreateAsyncQueryResultCsvDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAsyncQueryResultCsvDownloadMutation(baseOptions?: Apollo.MutationHookOptions<CreateAsyncQueryResultCsvDownloadMutation, CreateAsyncQueryResultCsvDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAsyncQueryResultCsvDownloadMutation, CreateAsyncQueryResultCsvDownloadMutationVariables>(CreateAsyncQueryResultCsvDownloadDocument, options);
      }
export type CreateAsyncQueryResultCsvDownloadMutationHookResult = ReturnType<typeof useCreateAsyncQueryResultCsvDownloadMutation>;
export type CreateAsyncQueryResultCsvDownloadMutationResult = Apollo.MutationResult<CreateAsyncQueryResultCsvDownloadMutation>;
export type CreateAsyncQueryResultCsvDownloadMutationOptions = Apollo.BaseMutationOptions<CreateAsyncQueryResultCsvDownloadMutation, CreateAsyncQueryResultCsvDownloadMutationVariables>;
export const CancelDownloadDocument = gql`
    mutation CancelDownload($uuids: [String!]!) {
  cancelDownload(uuids: $uuids) {
    ...DownloadStatusByUuid
  }
}
    ${DownloadStatusByUuidFragmentDoc}`;
export type CancelDownloadMutationFn = Apollo.MutationFunction<CancelDownloadMutation, CancelDownloadMutationVariables>;

/**
 * __useCancelDownloadMutation__
 *
 * To run a mutation, you first call `useCancelDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDownloadMutation, { data, loading, error }] = useCancelDownloadMutation({
 *   variables: {
 *      uuids: // value for 'uuids'
 *   },
 * });
 */
export function useCancelDownloadMutation(baseOptions?: Apollo.MutationHookOptions<CancelDownloadMutation, CancelDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelDownloadMutation, CancelDownloadMutationVariables>(CancelDownloadDocument, options);
      }
export type CancelDownloadMutationHookResult = ReturnType<typeof useCancelDownloadMutation>;
export type CancelDownloadMutationResult = Apollo.MutationResult<CancelDownloadMutation>;
export type CancelDownloadMutationOptions = Apollo.BaseMutationOptions<CancelDownloadMutation, CancelDownloadMutationVariables>;
export const DeleteDownloadDocument = gql`
    mutation DeleteDownload($uuids: [String!]!) {
  deleteDownload(uuids: $uuids)
}
    `;
export type DeleteDownloadMutationFn = Apollo.MutationFunction<DeleteDownloadMutation, DeleteDownloadMutationVariables>;

/**
 * __useDeleteDownloadMutation__
 *
 * To run a mutation, you first call `useDeleteDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDownloadMutation, { data, loading, error }] = useDeleteDownloadMutation({
 *   variables: {
 *      uuids: // value for 'uuids'
 *   },
 * });
 */
export function useDeleteDownloadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDownloadMutation, DeleteDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDownloadMutation, DeleteDownloadMutationVariables>(DeleteDownloadDocument, options);
      }
export type DeleteDownloadMutationHookResult = ReturnType<typeof useDeleteDownloadMutation>;
export type DeleteDownloadMutationResult = Apollo.MutationResult<DeleteDownloadMutation>;
export type DeleteDownloadMutationOptions = Apollo.BaseMutationOptions<DeleteDownloadMutation, DeleteDownloadMutationVariables>;
export const DownloadStatusDocument = gql`
    query DownloadStatus($uuids: [String!]!) {
  downloadStatus(uuids: $uuids) {
    ...DownloadStatusByUuid
  }
}
    ${DownloadStatusByUuidFragmentDoc}`;

/**
 * __useDownloadStatusQuery__
 *
 * To run a query within a React component, call `useDownloadStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadStatusQuery({
 *   variables: {
 *      uuids: // value for 'uuids'
 *   },
 * });
 */
export function useDownloadStatusQuery(baseOptions: Apollo.QueryHookOptions<DownloadStatusQuery, DownloadStatusQueryVariables> & ({ variables: DownloadStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadStatusQuery, DownloadStatusQueryVariables>(DownloadStatusDocument, options);
      }
export function useDownloadStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadStatusQuery, DownloadStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadStatusQuery, DownloadStatusQueryVariables>(DownloadStatusDocument, options);
        }
export function useDownloadStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadStatusQuery, DownloadStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadStatusQuery, DownloadStatusQueryVariables>(DownloadStatusDocument, options);
        }
export type DownloadStatusQueryHookResult = ReturnType<typeof useDownloadStatusQuery>;
export type DownloadStatusLazyQueryHookResult = ReturnType<typeof useDownloadStatusLazyQuery>;
export type DownloadStatusSuspenseQueryHookResult = ReturnType<typeof useDownloadStatusSuspenseQuery>;
export type DownloadStatusQueryResult = Apollo.QueryResult<DownloadStatusQuery, DownloadStatusQueryVariables>;
export const CreateAuditLogsCsvDownloadDocument = gql`
    mutation CreateAuditLogsCsvDownload($date: String!) {
  createAuditLogsCsvDownload(date: $date) {
    uuid
    expiresAt
  }
}
    `;
export type CreateAuditLogsCsvDownloadMutationFn = Apollo.MutationFunction<CreateAuditLogsCsvDownloadMutation, CreateAuditLogsCsvDownloadMutationVariables>;

/**
 * __useCreateAuditLogsCsvDownloadMutation__
 *
 * To run a mutation, you first call `useCreateAuditLogsCsvDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuditLogsCsvDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuditLogsCsvDownloadMutation, { data, loading, error }] = useCreateAuditLogsCsvDownloadMutation({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useCreateAuditLogsCsvDownloadMutation(baseOptions?: Apollo.MutationHookOptions<CreateAuditLogsCsvDownloadMutation, CreateAuditLogsCsvDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAuditLogsCsvDownloadMutation, CreateAuditLogsCsvDownloadMutationVariables>(CreateAuditLogsCsvDownloadDocument, options);
      }
export type CreateAuditLogsCsvDownloadMutationHookResult = ReturnType<typeof useCreateAuditLogsCsvDownloadMutation>;
export type CreateAuditLogsCsvDownloadMutationResult = Apollo.MutationResult<CreateAuditLogsCsvDownloadMutation>;
export type CreateAuditLogsCsvDownloadMutationOptions = Apollo.BaseMutationOptions<CreateAuditLogsCsvDownloadMutation, CreateAuditLogsCsvDownloadMutationVariables>;
export const DownloadUrlDocument = gql`
    query DownloadUrl($uuid: String!) {
  downloadUrl(uuid: $uuid)
}
    `;

/**
 * __useDownloadUrlQuery__
 *
 * To run a query within a React component, call `useDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadUrlQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<DownloadUrlQuery, DownloadUrlQueryVariables> & ({ variables: DownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadUrlQuery, DownloadUrlQueryVariables>(DownloadUrlDocument, options);
      }
export function useDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadUrlQuery, DownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadUrlQuery, DownloadUrlQueryVariables>(DownloadUrlDocument, options);
        }
export function useDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadUrlQuery, DownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadUrlQuery, DownloadUrlQueryVariables>(DownloadUrlDocument, options);
        }
export type DownloadUrlQueryHookResult = ReturnType<typeof useDownloadUrlQuery>;
export type DownloadUrlLazyQueryHookResult = ReturnType<typeof useDownloadUrlLazyQuery>;
export type DownloadUrlSuspenseQueryHookResult = ReturnType<typeof useDownloadUrlSuspenseQuery>;
export type DownloadUrlQueryResult = Apollo.QueryResult<DownloadUrlQuery, DownloadUrlQueryVariables>;
export const EltDestinationsDocument = gql`
    query EltDestinations {
  eltDestinations {
    ...AccountEltDestination
  }
}
    ${AccountEltDestinationFragmentDoc}`;

/**
 * __useEltDestinationsQuery__
 *
 * To run a query within a React component, call `useEltDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltDestinationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEltDestinationsQuery(baseOptions?: Apollo.QueryHookOptions<EltDestinationsQuery, EltDestinationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltDestinationsQuery, EltDestinationsQueryVariables>(EltDestinationsDocument, options);
      }
export function useEltDestinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltDestinationsQuery, EltDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltDestinationsQuery, EltDestinationsQueryVariables>(EltDestinationsDocument, options);
        }
export function useEltDestinationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltDestinationsQuery, EltDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltDestinationsQuery, EltDestinationsQueryVariables>(EltDestinationsDocument, options);
        }
export type EltDestinationsQueryHookResult = ReturnType<typeof useEltDestinationsQuery>;
export type EltDestinationsLazyQueryHookResult = ReturnType<typeof useEltDestinationsLazyQuery>;
export type EltDestinationsSuspenseQueryHookResult = ReturnType<typeof useEltDestinationsSuspenseQuery>;
export type EltDestinationsQueryResult = Apollo.QueryResult<EltDestinationsQuery, EltDestinationsQueryVariables>;
export const AddEltDestinationDocument = gql`
    mutation AddEltDestination($input: AddEltDestinationInput!) {
  addEltDestination(input: $input) {
    ...AccountEltDestination
  }
}
    ${AccountEltDestinationFragmentDoc}`;
export type AddEltDestinationMutationFn = Apollo.MutationFunction<AddEltDestinationMutation, AddEltDestinationMutationVariables>;

/**
 * __useAddEltDestinationMutation__
 *
 * To run a mutation, you first call `useAddEltDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEltDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEltDestinationMutation, { data, loading, error }] = useAddEltDestinationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEltDestinationMutation(baseOptions?: Apollo.MutationHookOptions<AddEltDestinationMutation, AddEltDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEltDestinationMutation, AddEltDestinationMutationVariables>(AddEltDestinationDocument, options);
      }
export type AddEltDestinationMutationHookResult = ReturnType<typeof useAddEltDestinationMutation>;
export type AddEltDestinationMutationResult = Apollo.MutationResult<AddEltDestinationMutation>;
export type AddEltDestinationMutationOptions = Apollo.BaseMutationOptions<AddEltDestinationMutation, AddEltDestinationMutationVariables>;
export const EltDestinationSettingsSchemaDocument = gql`
    query EltDestinationSettingsSchema($connectionId: String!) {
  eltDestinationSettingsSchema(connectionId: $connectionId)
}
    `;

/**
 * __useEltDestinationSettingsSchemaQuery__
 *
 * To run a query within a React component, call `useEltDestinationSettingsSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltDestinationSettingsSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltDestinationSettingsSchemaQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useEltDestinationSettingsSchemaQuery(baseOptions: Apollo.QueryHookOptions<EltDestinationSettingsSchemaQuery, EltDestinationSettingsSchemaQueryVariables> & ({ variables: EltDestinationSettingsSchemaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltDestinationSettingsSchemaQuery, EltDestinationSettingsSchemaQueryVariables>(EltDestinationSettingsSchemaDocument, options);
      }
export function useEltDestinationSettingsSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltDestinationSettingsSchemaQuery, EltDestinationSettingsSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltDestinationSettingsSchemaQuery, EltDestinationSettingsSchemaQueryVariables>(EltDestinationSettingsSchemaDocument, options);
        }
export function useEltDestinationSettingsSchemaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltDestinationSettingsSchemaQuery, EltDestinationSettingsSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltDestinationSettingsSchemaQuery, EltDestinationSettingsSchemaQueryVariables>(EltDestinationSettingsSchemaDocument, options);
        }
export type EltDestinationSettingsSchemaQueryHookResult = ReturnType<typeof useEltDestinationSettingsSchemaQuery>;
export type EltDestinationSettingsSchemaLazyQueryHookResult = ReturnType<typeof useEltDestinationSettingsSchemaLazyQuery>;
export type EltDestinationSettingsSchemaSuspenseQueryHookResult = ReturnType<typeof useEltDestinationSettingsSchemaSuspenseQuery>;
export type EltDestinationSettingsSchemaQueryResult = Apollo.QueryResult<EltDestinationSettingsSchemaQuery, EltDestinationSettingsSchemaQueryVariables>;
export const UpdateEltDestinationDocument = gql`
    mutation UpdateEltDestination($input: UpdateEltDestinationInput!) {
  updateEltDestination(input: $input) {
    ...AccountEltDestination
  }
}
    ${AccountEltDestinationFragmentDoc}`;
export type UpdateEltDestinationMutationFn = Apollo.MutationFunction<UpdateEltDestinationMutation, UpdateEltDestinationMutationVariables>;

/**
 * __useUpdateEltDestinationMutation__
 *
 * To run a mutation, you first call `useUpdateEltDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEltDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEltDestinationMutation, { data, loading, error }] = useUpdateEltDestinationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEltDestinationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEltDestinationMutation, UpdateEltDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEltDestinationMutation, UpdateEltDestinationMutationVariables>(UpdateEltDestinationDocument, options);
      }
export type UpdateEltDestinationMutationHookResult = ReturnType<typeof useUpdateEltDestinationMutation>;
export type UpdateEltDestinationMutationResult = Apollo.MutationResult<UpdateEltDestinationMutation>;
export type UpdateEltDestinationMutationOptions = Apollo.BaseMutationOptions<UpdateEltDestinationMutation, UpdateEltDestinationMutationVariables>;
export const RemoveEltDestinationDocument = gql`
    mutation RemoveEltDestination($id: String!, $forceRemove: Boolean) {
  removeEltDestination(id: $id, forceRemove: $forceRemove) {
    id
  }
}
    `;
export type RemoveEltDestinationMutationFn = Apollo.MutationFunction<RemoveEltDestinationMutation, RemoveEltDestinationMutationVariables>;

/**
 * __useRemoveEltDestinationMutation__
 *
 * To run a mutation, you first call `useRemoveEltDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEltDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEltDestinationMutation, { data, loading, error }] = useRemoveEltDestinationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      forceRemove: // value for 'forceRemove'
 *   },
 * });
 */
export function useRemoveEltDestinationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEltDestinationMutation, RemoveEltDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEltDestinationMutation, RemoveEltDestinationMutationVariables>(RemoveEltDestinationDocument, options);
      }
export type RemoveEltDestinationMutationHookResult = ReturnType<typeof useRemoveEltDestinationMutation>;
export type RemoveEltDestinationMutationResult = Apollo.MutationResult<RemoveEltDestinationMutation>;
export type RemoveEltDestinationMutationOptions = Apollo.BaseMutationOptions<RemoveEltDestinationMutation, RemoveEltDestinationMutationVariables>;
export const EltSyncDestinationsDocument = gql`
    query EltSyncDestinations($eltSyncId: String!) {
  eltSync(id: $eltSyncId) {
    id
    additionalDestinations {
      ...EltSyncDestination
    }
  }
}
    ${EltSyncDestinationFragmentDoc}`;

/**
 * __useEltSyncDestinationsQuery__
 *
 * To run a query within a React component, call `useEltSyncDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltSyncDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltSyncDestinationsQuery({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *   },
 * });
 */
export function useEltSyncDestinationsQuery(baseOptions: Apollo.QueryHookOptions<EltSyncDestinationsQuery, EltSyncDestinationsQueryVariables> & ({ variables: EltSyncDestinationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltSyncDestinationsQuery, EltSyncDestinationsQueryVariables>(EltSyncDestinationsDocument, options);
      }
export function useEltSyncDestinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltSyncDestinationsQuery, EltSyncDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltSyncDestinationsQuery, EltSyncDestinationsQueryVariables>(EltSyncDestinationsDocument, options);
        }
export function useEltSyncDestinationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltSyncDestinationsQuery, EltSyncDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltSyncDestinationsQuery, EltSyncDestinationsQueryVariables>(EltSyncDestinationsDocument, options);
        }
export type EltSyncDestinationsQueryHookResult = ReturnType<typeof useEltSyncDestinationsQuery>;
export type EltSyncDestinationsLazyQueryHookResult = ReturnType<typeof useEltSyncDestinationsLazyQuery>;
export type EltSyncDestinationsSuspenseQueryHookResult = ReturnType<typeof useEltSyncDestinationsSuspenseQuery>;
export type EltSyncDestinationsQueryResult = Apollo.QueryResult<EltSyncDestinationsQuery, EltSyncDestinationsQueryVariables>;
export const AddEltSyncDestinationDocument = gql`
    mutation AddEltSyncDestination($input: AddEltSyncDestinationInput!) {
  addEltSyncDestination(input: $input) {
    ...EltSyncDestination
  }
}
    ${EltSyncDestinationFragmentDoc}`;
export type AddEltSyncDestinationMutationFn = Apollo.MutationFunction<AddEltSyncDestinationMutation, AddEltSyncDestinationMutationVariables>;

/**
 * __useAddEltSyncDestinationMutation__
 *
 * To run a mutation, you first call `useAddEltSyncDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEltSyncDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEltSyncDestinationMutation, { data, loading, error }] = useAddEltSyncDestinationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEltSyncDestinationMutation(baseOptions?: Apollo.MutationHookOptions<AddEltSyncDestinationMutation, AddEltSyncDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEltSyncDestinationMutation, AddEltSyncDestinationMutationVariables>(AddEltSyncDestinationDocument, options);
      }
export type AddEltSyncDestinationMutationHookResult = ReturnType<typeof useAddEltSyncDestinationMutation>;
export type AddEltSyncDestinationMutationResult = Apollo.MutationResult<AddEltSyncDestinationMutation>;
export type AddEltSyncDestinationMutationOptions = Apollo.BaseMutationOptions<AddEltSyncDestinationMutation, AddEltSyncDestinationMutationVariables>;
export const RemoveEltSyncDestinationDocument = gql`
    mutation RemoveEltSyncDestination($input: RemoveEltSyncDestinationInput!) {
  removeEltSyncDestination(input: $input) {
    id
  }
}
    `;
export type RemoveEltSyncDestinationMutationFn = Apollo.MutationFunction<RemoveEltSyncDestinationMutation, RemoveEltSyncDestinationMutationVariables>;

/**
 * __useRemoveEltSyncDestinationMutation__
 *
 * To run a mutation, you first call `useRemoveEltSyncDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEltSyncDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEltSyncDestinationMutation, { data, loading, error }] = useRemoveEltSyncDestinationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveEltSyncDestinationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEltSyncDestinationMutation, RemoveEltSyncDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEltSyncDestinationMutation, RemoveEltSyncDestinationMutationVariables>(RemoveEltSyncDestinationDocument, options);
      }
export type RemoveEltSyncDestinationMutationHookResult = ReturnType<typeof useRemoveEltSyncDestinationMutation>;
export type RemoveEltSyncDestinationMutationResult = Apollo.MutationResult<RemoveEltSyncDestinationMutation>;
export type RemoveEltSyncDestinationMutationOptions = Apollo.BaseMutationOptions<RemoveEltSyncDestinationMutation, RemoveEltSyncDestinationMutationVariables>;
export const SetNextSyncToFullSyncDocument = gql`
    mutation SetNextSyncToFullSync($sourceStreamId: String!, $forceFullSync: Boolean!, $forceFullSyncHistoryTable: Boolean, $clearSoftDeletedRows: Boolean) {
  setNextSyncToFullSync(
    sourceStreamId: $sourceStreamId
    forceFullSync: $forceFullSync
    forceFullSyncHistoryTable: $forceFullSyncHistoryTable
    clearSoftDeletedRows: $clearSoftDeletedRows
  ) {
    job {
      forceFullSync
      forceFullSyncHistoryTable
      clearSoftDeletedRows
    }
  }
}
    `;
export type SetNextSyncToFullSyncMutationFn = Apollo.MutationFunction<SetNextSyncToFullSyncMutation, SetNextSyncToFullSyncMutationVariables>;

/**
 * __useSetNextSyncToFullSyncMutation__
 *
 * To run a mutation, you first call `useSetNextSyncToFullSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNextSyncToFullSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNextSyncToFullSyncMutation, { data, loading, error }] = useSetNextSyncToFullSyncMutation({
 *   variables: {
 *      sourceStreamId: // value for 'sourceStreamId'
 *      forceFullSync: // value for 'forceFullSync'
 *      forceFullSyncHistoryTable: // value for 'forceFullSyncHistoryTable'
 *      clearSoftDeletedRows: // value for 'clearSoftDeletedRows'
 *   },
 * });
 */
export function useSetNextSyncToFullSyncMutation(baseOptions?: Apollo.MutationHookOptions<SetNextSyncToFullSyncMutation, SetNextSyncToFullSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNextSyncToFullSyncMutation, SetNextSyncToFullSyncMutationVariables>(SetNextSyncToFullSyncDocument, options);
      }
export type SetNextSyncToFullSyncMutationHookResult = ReturnType<typeof useSetNextSyncToFullSyncMutation>;
export type SetNextSyncToFullSyncMutationResult = Apollo.MutationResult<SetNextSyncToFullSyncMutation>;
export type SetNextSyncToFullSyncMutationOptions = Apollo.BaseMutationOptions<SetNextSyncToFullSyncMutation, SetNextSyncToFullSyncMutationVariables>;
export const SourceStreamRunActionsDocument = gql`
    query SourceStreamRunActions($input: RunJobNowInput!) {
  sourceStreamRunActions(input: $input) {
    availableActions
    errors {
      message
      code
    }
  }
}
    `;

/**
 * __useSourceStreamRunActionsQuery__
 *
 * To run a query within a React component, call `useSourceStreamRunActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceStreamRunActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceStreamRunActionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSourceStreamRunActionsQuery(baseOptions: Apollo.QueryHookOptions<SourceStreamRunActionsQuery, SourceStreamRunActionsQueryVariables> & ({ variables: SourceStreamRunActionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourceStreamRunActionsQuery, SourceStreamRunActionsQueryVariables>(SourceStreamRunActionsDocument, options);
      }
export function useSourceStreamRunActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourceStreamRunActionsQuery, SourceStreamRunActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourceStreamRunActionsQuery, SourceStreamRunActionsQueryVariables>(SourceStreamRunActionsDocument, options);
        }
export function useSourceStreamRunActionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SourceStreamRunActionsQuery, SourceStreamRunActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SourceStreamRunActionsQuery, SourceStreamRunActionsQueryVariables>(SourceStreamRunActionsDocument, options);
        }
export type SourceStreamRunActionsQueryHookResult = ReturnType<typeof useSourceStreamRunActionsQuery>;
export type SourceStreamRunActionsLazyQueryHookResult = ReturnType<typeof useSourceStreamRunActionsLazyQuery>;
export type SourceStreamRunActionsSuspenseQueryHookResult = ReturnType<typeof useSourceStreamRunActionsSuspenseQuery>;
export type SourceStreamRunActionsQueryResult = Apollo.QueryResult<SourceStreamRunActionsQuery, SourceStreamRunActionsQueryVariables>;
export const RunJobNowDocument = gql`
    mutation RunJobNow($input: RunJobNowInput!) {
  runJobNow(input: $input)
}
    `;
export type RunJobNowMutationFn = Apollo.MutationFunction<RunJobNowMutation, RunJobNowMutationVariables>;

/**
 * __useRunJobNowMutation__
 *
 * To run a mutation, you first call `useRunJobNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunJobNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runJobNowMutation, { data, loading, error }] = useRunJobNowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunJobNowMutation(baseOptions?: Apollo.MutationHookOptions<RunJobNowMutation, RunJobNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunJobNowMutation, RunJobNowMutationVariables>(RunJobNowDocument, options);
      }
export type RunJobNowMutationHookResult = ReturnType<typeof useRunJobNowMutation>;
export type RunJobNowMutationResult = Apollo.MutationResult<RunJobNowMutation>;
export type RunJobNowMutationOptions = Apollo.BaseMutationOptions<RunJobNowMutation, RunJobNowMutationVariables>;
export const UpdateSourceStreamDocument = gql`
    mutation UpdateSourceStream($sourceStreamId: String!, $input: UpdateSourceStreamInput!) {
  updateSourceStream(sourceStreamId: $sourceStreamId, input: $input) {
    id
    name
    protectedFromFullSync
    prioritized
  }
}
    `;
export type UpdateSourceStreamMutationFn = Apollo.MutationFunction<UpdateSourceStreamMutation, UpdateSourceStreamMutationVariables>;

/**
 * __useUpdateSourceStreamMutation__
 *
 * To run a mutation, you first call `useUpdateSourceStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSourceStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSourceStreamMutation, { data, loading, error }] = useUpdateSourceStreamMutation({
 *   variables: {
 *      sourceStreamId: // value for 'sourceStreamId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSourceStreamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSourceStreamMutation, UpdateSourceStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSourceStreamMutation, UpdateSourceStreamMutationVariables>(UpdateSourceStreamDocument, options);
      }
export type UpdateSourceStreamMutationHookResult = ReturnType<typeof useUpdateSourceStreamMutation>;
export type UpdateSourceStreamMutationResult = Apollo.MutationResult<UpdateSourceStreamMutation>;
export type UpdateSourceStreamMutationOptions = Apollo.BaseMutationOptions<UpdateSourceStreamMutation, UpdateSourceStreamMutationVariables>;
export const SetSourceStreamSyncIntervalDocument = gql`
    mutation SetSourceStreamSyncInterval($input: UpdateSourceStreamSyncIntervalInput!) {
  setSourceStreamSyncInterval(input: $input) {
    id
  }
}
    `;
export type SetSourceStreamSyncIntervalMutationFn = Apollo.MutationFunction<SetSourceStreamSyncIntervalMutation, SetSourceStreamSyncIntervalMutationVariables>;

/**
 * __useSetSourceStreamSyncIntervalMutation__
 *
 * To run a mutation, you first call `useSetSourceStreamSyncIntervalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSourceStreamSyncIntervalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSourceStreamSyncIntervalMutation, { data, loading, error }] = useSetSourceStreamSyncIntervalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSourceStreamSyncIntervalMutation(baseOptions?: Apollo.MutationHookOptions<SetSourceStreamSyncIntervalMutation, SetSourceStreamSyncIntervalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSourceStreamSyncIntervalMutation, SetSourceStreamSyncIntervalMutationVariables>(SetSourceStreamSyncIntervalDocument, options);
      }
export type SetSourceStreamSyncIntervalMutationHookResult = ReturnType<typeof useSetSourceStreamSyncIntervalMutation>;
export type SetSourceStreamSyncIntervalMutationResult = Apollo.MutationResult<SetSourceStreamSyncIntervalMutation>;
export type SetSourceStreamSyncIntervalMutationOptions = Apollo.BaseMutationOptions<SetSourceStreamSyncIntervalMutation, SetSourceStreamSyncIntervalMutationVariables>;
export const SetCdcBackfillDocument = gql`
    mutation SetCdcBackfill($sourceStreamId: String!, $setBackfill: Boolean!) {
  setCdcBackfill(sourceStreamId: $sourceStreamId, setBackfill: $setBackfill) {
    id
  }
}
    `;
export type SetCdcBackfillMutationFn = Apollo.MutationFunction<SetCdcBackfillMutation, SetCdcBackfillMutationVariables>;

/**
 * __useSetCdcBackfillMutation__
 *
 * To run a mutation, you first call `useSetCdcBackfillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCdcBackfillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCdcBackfillMutation, { data, loading, error }] = useSetCdcBackfillMutation({
 *   variables: {
 *      sourceStreamId: // value for 'sourceStreamId'
 *      setBackfill: // value for 'setBackfill'
 *   },
 * });
 */
export function useSetCdcBackfillMutation(baseOptions?: Apollo.MutationHookOptions<SetCdcBackfillMutation, SetCdcBackfillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCdcBackfillMutation, SetCdcBackfillMutationVariables>(SetCdcBackfillDocument, options);
      }
export type SetCdcBackfillMutationHookResult = ReturnType<typeof useSetCdcBackfillMutation>;
export type SetCdcBackfillMutationResult = Apollo.MutationResult<SetCdcBackfillMutation>;
export type SetCdcBackfillMutationOptions = Apollo.BaseMutationOptions<SetCdcBackfillMutation, SetCdcBackfillMutationVariables>;
export const UpdateLastIncrementalPointerDocument = gql`
    mutation UpdateLastIncrementalPointer($input: UpdateSourceStreamLastIncrementalPointerInput!) {
  updateLastIncrementalPointer(input: $input)
}
    `;
export type UpdateLastIncrementalPointerMutationFn = Apollo.MutationFunction<UpdateLastIncrementalPointerMutation, UpdateLastIncrementalPointerMutationVariables>;

/**
 * __useUpdateLastIncrementalPointerMutation__
 *
 * To run a mutation, you first call `useUpdateLastIncrementalPointerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLastIncrementalPointerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLastIncrementalPointerMutation, { data, loading, error }] = useUpdateLastIncrementalPointerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLastIncrementalPointerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLastIncrementalPointerMutation, UpdateLastIncrementalPointerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLastIncrementalPointerMutation, UpdateLastIncrementalPointerMutationVariables>(UpdateLastIncrementalPointerDocument, options);
      }
export type UpdateLastIncrementalPointerMutationHookResult = ReturnType<typeof useUpdateLastIncrementalPointerMutation>;
export type UpdateLastIncrementalPointerMutationResult = Apollo.MutationResult<UpdateLastIncrementalPointerMutation>;
export type UpdateLastIncrementalPointerMutationOptions = Apollo.BaseMutationOptions<UpdateLastIncrementalPointerMutation, UpdateLastIncrementalPointerMutationVariables>;
export const PauseSourceStreamScheduleDocument = gql`
    mutation PauseSourceStreamSchedule($eltSyncId: String!, $sourceStreamName: String!) {
  pauseSourceStreamSchedule(
    eltSyncId: $eltSyncId
    sourceStreamName: $sourceStreamName
  ) {
    id
    name
    job {
      status
    }
  }
}
    `;
export type PauseSourceStreamScheduleMutationFn = Apollo.MutationFunction<PauseSourceStreamScheduleMutation, PauseSourceStreamScheduleMutationVariables>;

/**
 * __usePauseSourceStreamScheduleMutation__
 *
 * To run a mutation, you first call `usePauseSourceStreamScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseSourceStreamScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseSourceStreamScheduleMutation, { data, loading, error }] = usePauseSourceStreamScheduleMutation({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *      sourceStreamName: // value for 'sourceStreamName'
 *   },
 * });
 */
export function usePauseSourceStreamScheduleMutation(baseOptions?: Apollo.MutationHookOptions<PauseSourceStreamScheduleMutation, PauseSourceStreamScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseSourceStreamScheduleMutation, PauseSourceStreamScheduleMutationVariables>(PauseSourceStreamScheduleDocument, options);
      }
export type PauseSourceStreamScheduleMutationHookResult = ReturnType<typeof usePauseSourceStreamScheduleMutation>;
export type PauseSourceStreamScheduleMutationResult = Apollo.MutationResult<PauseSourceStreamScheduleMutation>;
export type PauseSourceStreamScheduleMutationOptions = Apollo.BaseMutationOptions<PauseSourceStreamScheduleMutation, PauseSourceStreamScheduleMutationVariables>;
export const ResumeSourceStreamScheduleDocument = gql`
    mutation ResumeSourceStreamSchedule($eltSyncId: String!, $sourceStreamName: String!) {
  resumeSourceStreamSchedule(
    eltSyncId: $eltSyncId
    sourceStreamName: $sourceStreamName
  ) {
    id
    name
    job {
      status
    }
  }
}
    `;
export type ResumeSourceStreamScheduleMutationFn = Apollo.MutationFunction<ResumeSourceStreamScheduleMutation, ResumeSourceStreamScheduleMutationVariables>;

/**
 * __useResumeSourceStreamScheduleMutation__
 *
 * To run a mutation, you first call `useResumeSourceStreamScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeSourceStreamScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeSourceStreamScheduleMutation, { data, loading, error }] = useResumeSourceStreamScheduleMutation({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *      sourceStreamName: // value for 'sourceStreamName'
 *   },
 * });
 */
export function useResumeSourceStreamScheduleMutation(baseOptions?: Apollo.MutationHookOptions<ResumeSourceStreamScheduleMutation, ResumeSourceStreamScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeSourceStreamScheduleMutation, ResumeSourceStreamScheduleMutationVariables>(ResumeSourceStreamScheduleDocument, options);
      }
export type ResumeSourceStreamScheduleMutationHookResult = ReturnType<typeof useResumeSourceStreamScheduleMutation>;
export type ResumeSourceStreamScheduleMutationResult = Apollo.MutationResult<ResumeSourceStreamScheduleMutation>;
export type ResumeSourceStreamScheduleMutationOptions = Apollo.BaseMutationOptions<ResumeSourceStreamScheduleMutation, ResumeSourceStreamScheduleMutationVariables>;
export const CreateEltSyncDocument = gql`
    mutation CreateEltSync($sourceConnectionId: String!, $destinationConnectionId: String!, $syncInterval: String, $sourceStreams: [SourceStreamInput!]!, $startDate: DateTime, $config: String, $destinationSchemaName: String, $identifierCasing: IdentifierCasing, $schedulerType: OrchestrationSchedulerType, $orchestrationWorkflowId: ID, $additionalDestinations: [EltSyncAdditionalDestinationInput!]) {
  createEltSync(
    input: {sourceConnectionId: $sourceConnectionId, destinationConnectionId: $destinationConnectionId, sourceStreams: $sourceStreams, startDate: $startDate, config: $config, destinationSchemaName: $destinationSchemaName, identifierCasing: $identifierCasing, schedulerType: $schedulerType, syncInterval: $syncInterval, orchestrationWorkflowId: $orchestrationWorkflowId, additionalDestinations: $additionalDestinations}
  ) {
    id
    sourceConnectionId
    destinationConnectionId
    destinationSchemaName
    identifierCasing
    additionalDestinations {
      ...EltSyncDestination
    }
  }
}
    ${EltSyncDestinationFragmentDoc}`;
export type CreateEltSyncMutationFn = Apollo.MutationFunction<CreateEltSyncMutation, CreateEltSyncMutationVariables>;

/**
 * __useCreateEltSyncMutation__
 *
 * To run a mutation, you first call `useCreateEltSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEltSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEltSyncMutation, { data, loading, error }] = useCreateEltSyncMutation({
 *   variables: {
 *      sourceConnectionId: // value for 'sourceConnectionId'
 *      destinationConnectionId: // value for 'destinationConnectionId'
 *      syncInterval: // value for 'syncInterval'
 *      sourceStreams: // value for 'sourceStreams'
 *      startDate: // value for 'startDate'
 *      config: // value for 'config'
 *      destinationSchemaName: // value for 'destinationSchemaName'
 *      identifierCasing: // value for 'identifierCasing'
 *      schedulerType: // value for 'schedulerType'
 *      orchestrationWorkflowId: // value for 'orchestrationWorkflowId'
 *      additionalDestinations: // value for 'additionalDestinations'
 *   },
 * });
 */
export function useCreateEltSyncMutation(baseOptions?: Apollo.MutationHookOptions<CreateEltSyncMutation, CreateEltSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEltSyncMutation, CreateEltSyncMutationVariables>(CreateEltSyncDocument, options);
      }
export type CreateEltSyncMutationHookResult = ReturnType<typeof useCreateEltSyncMutation>;
export type CreateEltSyncMutationResult = Apollo.MutationResult<CreateEltSyncMutation>;
export type CreateEltSyncMutationOptions = Apollo.BaseMutationOptions<CreateEltSyncMutation, CreateEltSyncMutationVariables>;
export const UpdateEltSyncDocument = gql`
    mutation UpdateEltSync($eltSyncId: String!, $syncInterval: String, $sourceStreams: [SourceStreamInput!]!, $config: String, $schedulerType: OrchestrationSchedulerType!, $orchestrationWorkflowId: ID) {
  updateEltSync(
    input: {eltSyncId: $eltSyncId, syncInterval: $syncInterval, sourceStreams: $sourceStreams, config: $config, schedulerType: $schedulerType, orchestrationWorkflowId: $orchestrationWorkflowId}
  ) {
    id
    sourceConnectionId
    destinationConnectionId
  }
}
    `;
export type UpdateEltSyncMutationFn = Apollo.MutationFunction<UpdateEltSyncMutation, UpdateEltSyncMutationVariables>;

/**
 * __useUpdateEltSyncMutation__
 *
 * To run a mutation, you first call `useUpdateEltSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEltSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEltSyncMutation, { data, loading, error }] = useUpdateEltSyncMutation({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *      syncInterval: // value for 'syncInterval'
 *      sourceStreams: // value for 'sourceStreams'
 *      config: // value for 'config'
 *      schedulerType: // value for 'schedulerType'
 *      orchestrationWorkflowId: // value for 'orchestrationWorkflowId'
 *   },
 * });
 */
export function useUpdateEltSyncMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEltSyncMutation, UpdateEltSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEltSyncMutation, UpdateEltSyncMutationVariables>(UpdateEltSyncDocument, options);
      }
export type UpdateEltSyncMutationHookResult = ReturnType<typeof useUpdateEltSyncMutation>;
export type UpdateEltSyncMutationResult = Apollo.MutationResult<UpdateEltSyncMutation>;
export type UpdateEltSyncMutationOptions = Apollo.BaseMutationOptions<UpdateEltSyncMutation, UpdateEltSyncMutationVariables>;
export const StartEltSyncDocument = gql`
    mutation StartEltSync($eltSyncId: String!) {
  startEltSync(input: {eltSyncId: $eltSyncId}) {
    ...EltSync
  }
}
    ${EltSyncFragmentDoc}`;
export type StartEltSyncMutationFn = Apollo.MutationFunction<StartEltSyncMutation, StartEltSyncMutationVariables>;

/**
 * __useStartEltSyncMutation__
 *
 * To run a mutation, you first call `useStartEltSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEltSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEltSyncMutation, { data, loading, error }] = useStartEltSyncMutation({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *   },
 * });
 */
export function useStartEltSyncMutation(baseOptions?: Apollo.MutationHookOptions<StartEltSyncMutation, StartEltSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartEltSyncMutation, StartEltSyncMutationVariables>(StartEltSyncDocument, options);
      }
export type StartEltSyncMutationHookResult = ReturnType<typeof useStartEltSyncMutation>;
export type StartEltSyncMutationResult = Apollo.MutationResult<StartEltSyncMutation>;
export type StartEltSyncMutationOptions = Apollo.BaseMutationOptions<StartEltSyncMutation, StartEltSyncMutationVariables>;
export const StopEltSyncDocument = gql`
    mutation StopEltSync($eltSyncId: String!) {
  stopEltSync(input: {eltSyncId: $eltSyncId}) {
    ...EltSync
  }
}
    ${EltSyncFragmentDoc}`;
export type StopEltSyncMutationFn = Apollo.MutationFunction<StopEltSyncMutation, StopEltSyncMutationVariables>;

/**
 * __useStopEltSyncMutation__
 *
 * To run a mutation, you first call `useStopEltSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopEltSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopEltSyncMutation, { data, loading, error }] = useStopEltSyncMutation({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *   },
 * });
 */
export function useStopEltSyncMutation(baseOptions?: Apollo.MutationHookOptions<StopEltSyncMutation, StopEltSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopEltSyncMutation, StopEltSyncMutationVariables>(StopEltSyncDocument, options);
      }
export type StopEltSyncMutationHookResult = ReturnType<typeof useStopEltSyncMutation>;
export type StopEltSyncMutationResult = Apollo.MutationResult<StopEltSyncMutation>;
export type StopEltSyncMutationOptions = Apollo.BaseMutationOptions<StopEltSyncMutation, StopEltSyncMutationVariables>;
export const RemoveEltSyncDocument = gql`
    mutation RemoveEltSync($eltSyncId: String!, $removeDataReferences: Boolean) {
  removeEltSync(
    input: {eltSyncId: $eltSyncId, removeDataReferences: $removeDataReferences}
  ) {
    id
  }
}
    `;
export type RemoveEltSyncMutationFn = Apollo.MutationFunction<RemoveEltSyncMutation, RemoveEltSyncMutationVariables>;

/**
 * __useRemoveEltSyncMutation__
 *
 * To run a mutation, you first call `useRemoveEltSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEltSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEltSyncMutation, { data, loading, error }] = useRemoveEltSyncMutation({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *      removeDataReferences: // value for 'removeDataReferences'
 *   },
 * });
 */
export function useRemoveEltSyncMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEltSyncMutation, RemoveEltSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEltSyncMutation, RemoveEltSyncMutationVariables>(RemoveEltSyncDocument, options);
      }
export type RemoveEltSyncMutationHookResult = ReturnType<typeof useRemoveEltSyncMutation>;
export type RemoveEltSyncMutationResult = Apollo.MutationResult<RemoveEltSyncMutation>;
export type RemoveEltSyncMutationOptions = Apollo.BaseMutationOptions<RemoveEltSyncMutation, RemoveEltSyncMutationVariables>;
export const RemoveTableFromSyncDocument = gql`
    mutation RemoveTableFromSync($sourceStreamName: String!, $syncId: String!, $viewId: String) {
  removeTableFromSync(
    input: {sourceStreamName: $sourceStreamName, syncId: $syncId, viewId: $viewId}
  ) {
    sourceStreamName
  }
}
    `;
export type RemoveTableFromSyncMutationFn = Apollo.MutationFunction<RemoveTableFromSyncMutation, RemoveTableFromSyncMutationVariables>;

/**
 * __useRemoveTableFromSyncMutation__
 *
 * To run a mutation, you first call `useRemoveTableFromSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTableFromSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTableFromSyncMutation, { data, loading, error }] = useRemoveTableFromSyncMutation({
 *   variables: {
 *      sourceStreamName: // value for 'sourceStreamName'
 *      syncId: // value for 'syncId'
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useRemoveTableFromSyncMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTableFromSyncMutation, RemoveTableFromSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTableFromSyncMutation, RemoveTableFromSyncMutationVariables>(RemoveTableFromSyncDocument, options);
      }
export type RemoveTableFromSyncMutationHookResult = ReturnType<typeof useRemoveTableFromSyncMutation>;
export type RemoveTableFromSyncMutationResult = Apollo.MutationResult<RemoveTableFromSyncMutation>;
export type RemoveTableFromSyncMutationOptions = Apollo.BaseMutationOptions<RemoveTableFromSyncMutation, RemoveTableFromSyncMutationVariables>;
export const EltSyncsDocument = gql`
    query EltSyncs {
  eltSyncs {
    ...EltSyncLite
  }
}
    ${EltSyncLiteFragmentDoc}`;

/**
 * __useEltSyncsQuery__
 *
 * To run a query within a React component, call `useEltSyncsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltSyncsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltSyncsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEltSyncsQuery(baseOptions?: Apollo.QueryHookOptions<EltSyncsQuery, EltSyncsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltSyncsQuery, EltSyncsQueryVariables>(EltSyncsDocument, options);
      }
export function useEltSyncsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltSyncsQuery, EltSyncsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltSyncsQuery, EltSyncsQueryVariables>(EltSyncsDocument, options);
        }
export function useEltSyncsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltSyncsQuery, EltSyncsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltSyncsQuery, EltSyncsQueryVariables>(EltSyncsDocument, options);
        }
export type EltSyncsQueryHookResult = ReturnType<typeof useEltSyncsQuery>;
export type EltSyncsLazyQueryHookResult = ReturnType<typeof useEltSyncsLazyQuery>;
export type EltSyncsSuspenseQueryHookResult = ReturnType<typeof useEltSyncsSuspenseQuery>;
export type EltSyncsQueryResult = Apollo.QueryResult<EltSyncsQuery, EltSyncsQueryVariables>;
export const EltSyncJobsDocument = gql`
    query EltSyncJobs($eltSyncId: String!) {
  eltSync(id: $eltSyncId) {
    id
    sourceStreams {
      id
      job {
        ...SourceStreamJob
      }
    }
  }
}
    ${SourceStreamJobFragmentDoc}`;

/**
 * __useEltSyncJobsQuery__
 *
 * To run a query within a React component, call `useEltSyncJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltSyncJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltSyncJobsQuery({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *   },
 * });
 */
export function useEltSyncJobsQuery(baseOptions: Apollo.QueryHookOptions<EltSyncJobsQuery, EltSyncJobsQueryVariables> & ({ variables: EltSyncJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltSyncJobsQuery, EltSyncJobsQueryVariables>(EltSyncJobsDocument, options);
      }
export function useEltSyncJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltSyncJobsQuery, EltSyncJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltSyncJobsQuery, EltSyncJobsQueryVariables>(EltSyncJobsDocument, options);
        }
export function useEltSyncJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltSyncJobsQuery, EltSyncJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltSyncJobsQuery, EltSyncJobsQueryVariables>(EltSyncJobsDocument, options);
        }
export type EltSyncJobsQueryHookResult = ReturnType<typeof useEltSyncJobsQuery>;
export type EltSyncJobsLazyQueryHookResult = ReturnType<typeof useEltSyncJobsLazyQuery>;
export type EltSyncJobsSuspenseQueryHookResult = ReturnType<typeof useEltSyncJobsSuspenseQuery>;
export type EltSyncJobsQueryResult = Apollo.QueryResult<EltSyncJobsQuery, EltSyncJobsQueryVariables>;
export const EltSyncDocument = gql`
    query EltSync($eltSyncId: String!) {
  eltSync(id: $eltSyncId) {
    ...EltSync
  }
}
    ${EltSyncFragmentDoc}`;

/**
 * __useEltSyncQuery__
 *
 * To run a query within a React component, call `useEltSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltSyncQuery({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *   },
 * });
 */
export function useEltSyncQuery(baseOptions: Apollo.QueryHookOptions<EltSyncQuery, EltSyncQueryVariables> & ({ variables: EltSyncQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltSyncQuery, EltSyncQueryVariables>(EltSyncDocument, options);
      }
export function useEltSyncLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltSyncQuery, EltSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltSyncQuery, EltSyncQueryVariables>(EltSyncDocument, options);
        }
export function useEltSyncSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltSyncQuery, EltSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltSyncQuery, EltSyncQueryVariables>(EltSyncDocument, options);
        }
export type EltSyncQueryHookResult = ReturnType<typeof useEltSyncQuery>;
export type EltSyncLazyQueryHookResult = ReturnType<typeof useEltSyncLazyQuery>;
export type EltSyncSuspenseQueryHookResult = ReturnType<typeof useEltSyncSuspenseQuery>;
export type EltSyncQueryResult = Apollo.QueryResult<EltSyncQuery, EltSyncQueryVariables>;
export const EltSyncLiteDocument = gql`
    query EltSyncLite($id: String!) {
  eltSync(id: $id) {
    ...EltSyncLite
  }
}
    ${EltSyncLiteFragmentDoc}`;

/**
 * __useEltSyncLiteQuery__
 *
 * To run a query within a React component, call `useEltSyncLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltSyncLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltSyncLiteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEltSyncLiteQuery(baseOptions: Apollo.QueryHookOptions<EltSyncLiteQuery, EltSyncLiteQueryVariables> & ({ variables: EltSyncLiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltSyncLiteQuery, EltSyncLiteQueryVariables>(EltSyncLiteDocument, options);
      }
export function useEltSyncLiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltSyncLiteQuery, EltSyncLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltSyncLiteQuery, EltSyncLiteQueryVariables>(EltSyncLiteDocument, options);
        }
export function useEltSyncLiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltSyncLiteQuery, EltSyncLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltSyncLiteQuery, EltSyncLiteQueryVariables>(EltSyncLiteDocument, options);
        }
export type EltSyncLiteQueryHookResult = ReturnType<typeof useEltSyncLiteQuery>;
export type EltSyncLiteLazyQueryHookResult = ReturnType<typeof useEltSyncLiteLazyQuery>;
export type EltSyncLiteSuspenseQueryHookResult = ReturnType<typeof useEltSyncLiteSuspenseQuery>;
export type EltSyncLiteQueryResult = Apollo.QueryResult<EltSyncLiteQuery, EltSyncLiteQueryVariables>;
export const EltJobsCompletionStatsDocument = gql`
    query EltJobsCompletionStats($from: DateTime, $to: DateTime) {
  eltJobsCompletionStats(from: $from, to: $to) {
    stats {
      total
      successCount
      successPercent
      failureCount
      failurePercent
    }
  }
}
    `;

/**
 * __useEltJobsCompletionStatsQuery__
 *
 * To run a query within a React component, call `useEltJobsCompletionStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltJobsCompletionStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltJobsCompletionStatsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useEltJobsCompletionStatsQuery(baseOptions?: Apollo.QueryHookOptions<EltJobsCompletionStatsQuery, EltJobsCompletionStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltJobsCompletionStatsQuery, EltJobsCompletionStatsQueryVariables>(EltJobsCompletionStatsDocument, options);
      }
export function useEltJobsCompletionStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltJobsCompletionStatsQuery, EltJobsCompletionStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltJobsCompletionStatsQuery, EltJobsCompletionStatsQueryVariables>(EltJobsCompletionStatsDocument, options);
        }
export function useEltJobsCompletionStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltJobsCompletionStatsQuery, EltJobsCompletionStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltJobsCompletionStatsQuery, EltJobsCompletionStatsQueryVariables>(EltJobsCompletionStatsDocument, options);
        }
export type EltJobsCompletionStatsQueryHookResult = ReturnType<typeof useEltJobsCompletionStatsQuery>;
export type EltJobsCompletionStatsLazyQueryHookResult = ReturnType<typeof useEltJobsCompletionStatsLazyQuery>;
export type EltJobsCompletionStatsSuspenseQueryHookResult = ReturnType<typeof useEltJobsCompletionStatsSuspenseQuery>;
export type EltJobsCompletionStatsQueryResult = Apollo.QueryResult<EltJobsCompletionStatsQuery, EltJobsCompletionStatsQueryVariables>;
export const EltSyncStatsRecentDocument = gql`
    query EltSyncStatsRecent($syncId: String!, $from: DateTime!, $sourceStreamName: String) {
  eltSyncStatsRecent(
    syncId: $syncId
    from: $from
    sourceStreamName: $sourceStreamName
  ) {
    ...EltSyncHistoryStatsResponse
  }
}
    ${EltSyncHistoryStatsResponseFragmentDoc}`;

/**
 * __useEltSyncStatsRecentQuery__
 *
 * To run a query within a React component, call `useEltSyncStatsRecentQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltSyncStatsRecentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltSyncStatsRecentQuery({
 *   variables: {
 *      syncId: // value for 'syncId'
 *      from: // value for 'from'
 *      sourceStreamName: // value for 'sourceStreamName'
 *   },
 * });
 */
export function useEltSyncStatsRecentQuery(baseOptions: Apollo.QueryHookOptions<EltSyncStatsRecentQuery, EltSyncStatsRecentQueryVariables> & ({ variables: EltSyncStatsRecentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltSyncStatsRecentQuery, EltSyncStatsRecentQueryVariables>(EltSyncStatsRecentDocument, options);
      }
export function useEltSyncStatsRecentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltSyncStatsRecentQuery, EltSyncStatsRecentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltSyncStatsRecentQuery, EltSyncStatsRecentQueryVariables>(EltSyncStatsRecentDocument, options);
        }
export function useEltSyncStatsRecentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltSyncStatsRecentQuery, EltSyncStatsRecentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltSyncStatsRecentQuery, EltSyncStatsRecentQueryVariables>(EltSyncStatsRecentDocument, options);
        }
export type EltSyncStatsRecentQueryHookResult = ReturnType<typeof useEltSyncStatsRecentQuery>;
export type EltSyncStatsRecentLazyQueryHookResult = ReturnType<typeof useEltSyncStatsRecentLazyQuery>;
export type EltSyncStatsRecentSuspenseQueryHookResult = ReturnType<typeof useEltSyncStatsRecentSuspenseQuery>;
export type EltSyncStatsRecentQueryResult = Apollo.QueryResult<EltSyncStatsRecentQuery, EltSyncStatsRecentQueryVariables>;
export const EltSyncStatsHistoricDocument = gql`
    query EltSyncStatsHistoric($syncId: String!, $from: DateTime!, $sourceStreamName: String) {
  eltSyncStatsHistoric(
    syncId: $syncId
    from: $from
    sourceStreamName: $sourceStreamName
  ) {
    ...EltSyncHistoryStatsResponse
  }
}
    ${EltSyncHistoryStatsResponseFragmentDoc}`;

/**
 * __useEltSyncStatsHistoricQuery__
 *
 * To run a query within a React component, call `useEltSyncStatsHistoricQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltSyncStatsHistoricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltSyncStatsHistoricQuery({
 *   variables: {
 *      syncId: // value for 'syncId'
 *      from: // value for 'from'
 *      sourceStreamName: // value for 'sourceStreamName'
 *   },
 * });
 */
export function useEltSyncStatsHistoricQuery(baseOptions: Apollo.QueryHookOptions<EltSyncStatsHistoricQuery, EltSyncStatsHistoricQueryVariables> & ({ variables: EltSyncStatsHistoricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltSyncStatsHistoricQuery, EltSyncStatsHistoricQueryVariables>(EltSyncStatsHistoricDocument, options);
      }
export function useEltSyncStatsHistoricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltSyncStatsHistoricQuery, EltSyncStatsHistoricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltSyncStatsHistoricQuery, EltSyncStatsHistoricQueryVariables>(EltSyncStatsHistoricDocument, options);
        }
export function useEltSyncStatsHistoricSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltSyncStatsHistoricQuery, EltSyncStatsHistoricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltSyncStatsHistoricQuery, EltSyncStatsHistoricQueryVariables>(EltSyncStatsHistoricDocument, options);
        }
export type EltSyncStatsHistoricQueryHookResult = ReturnType<typeof useEltSyncStatsHistoricQuery>;
export type EltSyncStatsHistoricLazyQueryHookResult = ReturnType<typeof useEltSyncStatsHistoricLazyQuery>;
export type EltSyncStatsHistoricSuspenseQueryHookResult = ReturnType<typeof useEltSyncStatsHistoricSuspenseQuery>;
export type EltSyncStatsHistoricQueryResult = Apollo.QueryResult<EltSyncStatsHistoricQuery, EltSyncStatsHistoricQueryVariables>;
export const RecreateViewDocument = gql`
    mutation recreateView($eltSyncId: String!, $sourceStreamName: String!) {
  recreateDestinationView(
    eltSyncId: $eltSyncId
    sourceStreamName: $sourceStreamName
  ) {
    success
    error
  }
}
    `;
export type RecreateViewMutationFn = Apollo.MutationFunction<RecreateViewMutation, RecreateViewMutationVariables>;

/**
 * __useRecreateViewMutation__
 *
 * To run a mutation, you first call `useRecreateViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecreateViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recreateViewMutation, { data, loading, error }] = useRecreateViewMutation({
 *   variables: {
 *      eltSyncId: // value for 'eltSyncId'
 *      sourceStreamName: // value for 'sourceStreamName'
 *   },
 * });
 */
export function useRecreateViewMutation(baseOptions?: Apollo.MutationHookOptions<RecreateViewMutation, RecreateViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecreateViewMutation, RecreateViewMutationVariables>(RecreateViewDocument, options);
      }
export type RecreateViewMutationHookResult = ReturnType<typeof useRecreateViewMutation>;
export type RecreateViewMutationResult = Apollo.MutationResult<RecreateViewMutation>;
export type RecreateViewMutationOptions = Apollo.BaseMutationOptions<RecreateViewMutation, RecreateViewMutationVariables>;
export const SearchSyncDestinationsDocument = gql`
    query SearchSyncDestinations($searchTerm: String!) {
  searchSyncDestinations(searchTerm: $searchTerm) {
    name
    schemaName
    viewId
    integrationId
  }
}
    `;

/**
 * __useSearchSyncDestinationsQuery__
 *
 * To run a query within a React component, call `useSearchSyncDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSyncDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSyncDestinationsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchSyncDestinationsQuery(baseOptions: Apollo.QueryHookOptions<SearchSyncDestinationsQuery, SearchSyncDestinationsQueryVariables> & ({ variables: SearchSyncDestinationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSyncDestinationsQuery, SearchSyncDestinationsQueryVariables>(SearchSyncDestinationsDocument, options);
      }
export function useSearchSyncDestinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSyncDestinationsQuery, SearchSyncDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSyncDestinationsQuery, SearchSyncDestinationsQueryVariables>(SearchSyncDestinationsDocument, options);
        }
export function useSearchSyncDestinationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchSyncDestinationsQuery, SearchSyncDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSyncDestinationsQuery, SearchSyncDestinationsQueryVariables>(SearchSyncDestinationsDocument, options);
        }
export type SearchSyncDestinationsQueryHookResult = ReturnType<typeof useSearchSyncDestinationsQuery>;
export type SearchSyncDestinationsLazyQueryHookResult = ReturnType<typeof useSearchSyncDestinationsLazyQuery>;
export type SearchSyncDestinationsSuspenseQueryHookResult = ReturnType<typeof useSearchSyncDestinationsSuspenseQuery>;
export type SearchSyncDestinationsQueryResult = Apollo.QueryResult<SearchSyncDestinationsQuery, SearchSyncDestinationsQueryVariables>;
export const GetWebhookDataDocument = gql`
    query getWebhookData($type: String!) {
  getWebhookData(type: $type) {
    data
  }
}
    `;

/**
 * __useGetWebhookDataQuery__
 *
 * To run a query within a React component, call `useGetWebhookDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebhookDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebhookDataQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetWebhookDataQuery(baseOptions: Apollo.QueryHookOptions<GetWebhookDataQuery, GetWebhookDataQueryVariables> & ({ variables: GetWebhookDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebhookDataQuery, GetWebhookDataQueryVariables>(GetWebhookDataDocument, options);
      }
export function useGetWebhookDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebhookDataQuery, GetWebhookDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebhookDataQuery, GetWebhookDataQueryVariables>(GetWebhookDataDocument, options);
        }
export function useGetWebhookDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebhookDataQuery, GetWebhookDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebhookDataQuery, GetWebhookDataQueryVariables>(GetWebhookDataDocument, options);
        }
export type GetWebhookDataQueryHookResult = ReturnType<typeof useGetWebhookDataQuery>;
export type GetWebhookDataLazyQueryHookResult = ReturnType<typeof useGetWebhookDataLazyQuery>;
export type GetWebhookDataSuspenseQueryHookResult = ReturnType<typeof useGetWebhookDataSuspenseQuery>;
export type GetWebhookDataQueryResult = Apollo.QueryResult<GetWebhookDataQuery, GetWebhookDataQueryVariables>;
export const CreateWebhookDocument = gql`
    mutation createWebhook($data: CreateWebhookInput!) {
  createWebhook(data: $data) {
    ...Webhook
  }
}
    ${WebhookFragmentDoc}`;
export type CreateWebhookMutationFn = Apollo.MutationFunction<CreateWebhookMutation, CreateWebhookMutationVariables>;

/**
 * __useCreateWebhookMutation__
 *
 * To run a mutation, you first call `useCreateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebhookMutation, { data, loading, error }] = useCreateWebhookMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWebhookMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebhookMutation, CreateWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebhookMutation, CreateWebhookMutationVariables>(CreateWebhookDocument, options);
      }
export type CreateWebhookMutationHookResult = ReturnType<typeof useCreateWebhookMutation>;
export type CreateWebhookMutationResult = Apollo.MutationResult<CreateWebhookMutation>;
export type CreateWebhookMutationOptions = Apollo.BaseMutationOptions<CreateWebhookMutation, CreateWebhookMutationVariables>;
export const DeleteWebhookDocument = gql`
    mutation deleteWebhook($webhookId: String!) {
  deleteWebhook(id: $webhookId)
}
    `;
export type DeleteWebhookMutationFn = Apollo.MutationFunction<DeleteWebhookMutation, DeleteWebhookMutationVariables>;

/**
 * __useDeleteWebhookMutation__
 *
 * To run a mutation, you first call `useDeleteWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebhookMutation, { data, loading, error }] = useDeleteWebhookMutation({
 *   variables: {
 *      webhookId: // value for 'webhookId'
 *   },
 * });
 */
export function useDeleteWebhookMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWebhookMutation, DeleteWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWebhookMutation, DeleteWebhookMutationVariables>(DeleteWebhookDocument, options);
      }
export type DeleteWebhookMutationHookResult = ReturnType<typeof useDeleteWebhookMutation>;
export type DeleteWebhookMutationResult = Apollo.MutationResult<DeleteWebhookMutation>;
export type DeleteWebhookMutationOptions = Apollo.BaseMutationOptions<DeleteWebhookMutation, DeleteWebhookMutationVariables>;
export const ListWebhooksDocument = gql`
    query listWebhooks($orchestrationWorkflowId: String!) {
  listWebhoooks(orchestrationWorkflowId: $orchestrationWorkflowId) {
    ...Webhook
  }
}
    ${WebhookFragmentDoc}`;

/**
 * __useListWebhooksQuery__
 *
 * To run a query within a React component, call `useListWebhooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWebhooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWebhooksQuery({
 *   variables: {
 *      orchestrationWorkflowId: // value for 'orchestrationWorkflowId'
 *   },
 * });
 */
export function useListWebhooksQuery(baseOptions: Apollo.QueryHookOptions<ListWebhooksQuery, ListWebhooksQueryVariables> & ({ variables: ListWebhooksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWebhooksQuery, ListWebhooksQueryVariables>(ListWebhooksDocument, options);
      }
export function useListWebhooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWebhooksQuery, ListWebhooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWebhooksQuery, ListWebhooksQueryVariables>(ListWebhooksDocument, options);
        }
export function useListWebhooksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListWebhooksQuery, ListWebhooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWebhooksQuery, ListWebhooksQueryVariables>(ListWebhooksDocument, options);
        }
export type ListWebhooksQueryHookResult = ReturnType<typeof useListWebhooksQuery>;
export type ListWebhooksLazyQueryHookResult = ReturnType<typeof useListWebhooksLazyQuery>;
export type ListWebhooksSuspenseQueryHookResult = ReturnType<typeof useListWebhooksSuspenseQuery>;
export type ListWebhooksQueryResult = Apollo.QueryResult<ListWebhooksQuery, ListWebhooksQueryVariables>;
export const UpdateWebhookDocument = gql`
    mutation updateWebhook($data: UpdateWebhookInput!) {
  updateWebhook(data: $data) {
    ...Webhook
  }
}
    ${WebhookFragmentDoc}`;
export type UpdateWebhookMutationFn = Apollo.MutationFunction<UpdateWebhookMutation, UpdateWebhookMutationVariables>;

/**
 * __useUpdateWebhookMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookMutation, { data, loading, error }] = useUpdateWebhookMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWebhookMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebhookMutation, UpdateWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebhookMutation, UpdateWebhookMutationVariables>(UpdateWebhookDocument, options);
      }
export type UpdateWebhookMutationHookResult = ReturnType<typeof useUpdateWebhookMutation>;
export type UpdateWebhookMutationResult = Apollo.MutationResult<UpdateWebhookMutation>;
export type UpdateWebhookMutationOptions = Apollo.BaseMutationOptions<UpdateWebhookMutation, UpdateWebhookMutationVariables>;
export const LatestWebhookRunsDocument = gql`
    query latestWebhookRuns($webhookIds: [String!]!) {
  latestWebhookRuns(webhookIds: $webhookIds) {
    ...WebhookRun
  }
}
    ${WebhookRunFragmentDoc}`;

/**
 * __useLatestWebhookRunsQuery__
 *
 * To run a query within a React component, call `useLatestWebhookRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestWebhookRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestWebhookRunsQuery({
 *   variables: {
 *      webhookIds: // value for 'webhookIds'
 *   },
 * });
 */
export function useLatestWebhookRunsQuery(baseOptions: Apollo.QueryHookOptions<LatestWebhookRunsQuery, LatestWebhookRunsQueryVariables> & ({ variables: LatestWebhookRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestWebhookRunsQuery, LatestWebhookRunsQueryVariables>(LatestWebhookRunsDocument, options);
      }
export function useLatestWebhookRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestWebhookRunsQuery, LatestWebhookRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestWebhookRunsQuery, LatestWebhookRunsQueryVariables>(LatestWebhookRunsDocument, options);
        }
export function useLatestWebhookRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LatestWebhookRunsQuery, LatestWebhookRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LatestWebhookRunsQuery, LatestWebhookRunsQueryVariables>(LatestWebhookRunsDocument, options);
        }
export type LatestWebhookRunsQueryHookResult = ReturnType<typeof useLatestWebhookRunsQuery>;
export type LatestWebhookRunsLazyQueryHookResult = ReturnType<typeof useLatestWebhookRunsLazyQuery>;
export type LatestWebhookRunsSuspenseQueryHookResult = ReturnType<typeof useLatestWebhookRunsSuspenseQuery>;
export type LatestWebhookRunsQueryResult = Apollo.QueryResult<LatestWebhookRunsQuery, LatestWebhookRunsQueryVariables>;
export const RequestBetaConnectorAccessDocument = gql`
    mutation RequestBetaConnectorAccess($integrationId: String!) {
  requestBetaConnectorAccess(integrationId: $integrationId)
}
    `;
export type RequestBetaConnectorAccessMutationFn = Apollo.MutationFunction<RequestBetaConnectorAccessMutation, RequestBetaConnectorAccessMutationVariables>;

/**
 * __useRequestBetaConnectorAccessMutation__
 *
 * To run a mutation, you first call `useRequestBetaConnectorAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBetaConnectorAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBetaConnectorAccessMutation, { data, loading, error }] = useRequestBetaConnectorAccessMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useRequestBetaConnectorAccessMutation(baseOptions?: Apollo.MutationHookOptions<RequestBetaConnectorAccessMutation, RequestBetaConnectorAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestBetaConnectorAccessMutation, RequestBetaConnectorAccessMutationVariables>(RequestBetaConnectorAccessDocument, options);
      }
export type RequestBetaConnectorAccessMutationHookResult = ReturnType<typeof useRequestBetaConnectorAccessMutation>;
export type RequestBetaConnectorAccessMutationResult = Apollo.MutationResult<RequestBetaConnectorAccessMutation>;
export type RequestBetaConnectorAccessMutationOptions = Apollo.BaseMutationOptions<RequestBetaConnectorAccessMutation, RequestBetaConnectorAccessMutationVariables>;
export const RequestConnectorDocument = gql`
    mutation RequestConnector($integrationName: String!, $integrationTypes: [String!]!) {
  requestConnector(
    integrationName: $integrationName
    integrationTypes: $integrationTypes
  )
}
    `;
export type RequestConnectorMutationFn = Apollo.MutationFunction<RequestConnectorMutation, RequestConnectorMutationVariables>;

/**
 * __useRequestConnectorMutation__
 *
 * To run a mutation, you first call `useRequestConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestConnectorMutation, { data, loading, error }] = useRequestConnectorMutation({
 *   variables: {
 *      integrationName: // value for 'integrationName'
 *      integrationTypes: // value for 'integrationTypes'
 *   },
 * });
 */
export function useRequestConnectorMutation(baseOptions?: Apollo.MutationHookOptions<RequestConnectorMutation, RequestConnectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestConnectorMutation, RequestConnectorMutationVariables>(RequestConnectorDocument, options);
      }
export type RequestConnectorMutationHookResult = ReturnType<typeof useRequestConnectorMutation>;
export type RequestConnectorMutationResult = Apollo.MutationResult<RequestConnectorMutation>;
export type RequestConnectorMutationOptions = Apollo.BaseMutationOptions<RequestConnectorMutation, RequestConnectorMutationVariables>;
export const RequestDestinationDocument = gql`
    mutation RequestDestination($integrationId: String!) {
  requestDestination(integrationId: $integrationId)
}
    `;
export type RequestDestinationMutationFn = Apollo.MutationFunction<RequestDestinationMutation, RequestDestinationMutationVariables>;

/**
 * __useRequestDestinationMutation__
 *
 * To run a mutation, you first call `useRequestDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDestinationMutation, { data, loading, error }] = useRequestDestinationMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useRequestDestinationMutation(baseOptions?: Apollo.MutationHookOptions<RequestDestinationMutation, RequestDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestDestinationMutation, RequestDestinationMutationVariables>(RequestDestinationDocument, options);
      }
export type RequestDestinationMutationHookResult = ReturnType<typeof useRequestDestinationMutation>;
export type RequestDestinationMutationResult = Apollo.MutationResult<RequestDestinationMutation>;
export type RequestDestinationMutationOptions = Apollo.BaseMutationOptions<RequestDestinationMutation, RequestDestinationMutationVariables>;
export const GithubConnectionDocument = gql`
    query GithubConnection {
  githubConnection {
    id
    repoOwner
    repoName
    branch
    folderPath
    status
    lastSyncedCommitSha
    lastSyncedAt
    createdAt
  }
}
    `;

/**
 * __useGithubConnectionQuery__
 *
 * To run a query within a React component, call `useGithubConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGithubConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGithubConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGithubConnectionQuery(baseOptions?: Apollo.QueryHookOptions<GithubConnectionQuery, GithubConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GithubConnectionQuery, GithubConnectionQueryVariables>(GithubConnectionDocument, options);
      }
export function useGithubConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GithubConnectionQuery, GithubConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GithubConnectionQuery, GithubConnectionQueryVariables>(GithubConnectionDocument, options);
        }
export function useGithubConnectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GithubConnectionQuery, GithubConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GithubConnectionQuery, GithubConnectionQueryVariables>(GithubConnectionDocument, options);
        }
export type GithubConnectionQueryHookResult = ReturnType<typeof useGithubConnectionQuery>;
export type GithubConnectionLazyQueryHookResult = ReturnType<typeof useGithubConnectionLazyQuery>;
export type GithubConnectionSuspenseQueryHookResult = ReturnType<typeof useGithubConnectionSuspenseQuery>;
export type GithubConnectionQueryResult = Apollo.QueryResult<GithubConnectionQuery, GithubConnectionQueryVariables>;
export const GithubInstallationDocument = gql`
    query GithubInstallation {
  githubApp {
    appUrl
  }
  githubInstallation {
    id
    githubAccountLogin
    manageInstallationUrl
    status
    createdAt
  }
}
    `;

/**
 * __useGithubInstallationQuery__
 *
 * To run a query within a React component, call `useGithubInstallationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGithubInstallationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGithubInstallationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGithubInstallationQuery(baseOptions?: Apollo.QueryHookOptions<GithubInstallationQuery, GithubInstallationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GithubInstallationQuery, GithubInstallationQueryVariables>(GithubInstallationDocument, options);
      }
export function useGithubInstallationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GithubInstallationQuery, GithubInstallationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GithubInstallationQuery, GithubInstallationQueryVariables>(GithubInstallationDocument, options);
        }
export function useGithubInstallationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GithubInstallationQuery, GithubInstallationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GithubInstallationQuery, GithubInstallationQueryVariables>(GithubInstallationDocument, options);
        }
export type GithubInstallationQueryHookResult = ReturnType<typeof useGithubInstallationQuery>;
export type GithubInstallationLazyQueryHookResult = ReturnType<typeof useGithubInstallationLazyQuery>;
export type GithubInstallationSuspenseQueryHookResult = ReturnType<typeof useGithubInstallationSuspenseQuery>;
export type GithubInstallationQueryResult = Apollo.QueryResult<GithubInstallationQuery, GithubInstallationQueryVariables>;
export const GithubInstallUrlDocument = gql`
    mutation GithubInstallUrl {
  githubInstallUrl {
    installUrl
  }
}
    `;
export type GithubInstallUrlMutationFn = Apollo.MutationFunction<GithubInstallUrlMutation, GithubInstallUrlMutationVariables>;

/**
 * __useGithubInstallUrlMutation__
 *
 * To run a mutation, you first call `useGithubInstallUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGithubInstallUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [githubInstallUrlMutation, { data, loading, error }] = useGithubInstallUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useGithubInstallUrlMutation(baseOptions?: Apollo.MutationHookOptions<GithubInstallUrlMutation, GithubInstallUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GithubInstallUrlMutation, GithubInstallUrlMutationVariables>(GithubInstallUrlDocument, options);
      }
export type GithubInstallUrlMutationHookResult = ReturnType<typeof useGithubInstallUrlMutation>;
export type GithubInstallUrlMutationResult = Apollo.MutationResult<GithubInstallUrlMutation>;
export type GithubInstallUrlMutationOptions = Apollo.BaseMutationOptions<GithubInstallUrlMutation, GithubInstallUrlMutationVariables>;
export const RepairGithubInstallationDocument = gql`
    mutation RepairGithubInstallation {
  repairGithubInstallation {
    outcome
  }
}
    `;
export type RepairGithubInstallationMutationFn = Apollo.MutationFunction<RepairGithubInstallationMutation, RepairGithubInstallationMutationVariables>;

/**
 * __useRepairGithubInstallationMutation__
 *
 * To run a mutation, you first call `useRepairGithubInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepairGithubInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [repairGithubInstallationMutation, { data, loading, error }] = useRepairGithubInstallationMutation({
 *   variables: {
 *   },
 * });
 */
export function useRepairGithubInstallationMutation(baseOptions?: Apollo.MutationHookOptions<RepairGithubInstallationMutation, RepairGithubInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RepairGithubInstallationMutation, RepairGithubInstallationMutationVariables>(RepairGithubInstallationDocument, options);
      }
export type RepairGithubInstallationMutationHookResult = ReturnType<typeof useRepairGithubInstallationMutation>;
export type RepairGithubInstallationMutationResult = Apollo.MutationResult<RepairGithubInstallationMutation>;
export type RepairGithubInstallationMutationOptions = Apollo.BaseMutationOptions<RepairGithubInstallationMutation, RepairGithubInstallationMutationVariables>;
export const GithubInstallationChoicesDocument = gql`
    query GithubInstallationChoices($state: String!) {
  githubApp {
    appUrl
  }
  githubInstallationChoices(state: $state) {
    choices {
      installationId
      githubAccountLogin
      accountType
    }
    installUrl
  }
}
    `;

/**
 * __useGithubInstallationChoicesQuery__
 *
 * To run a query within a React component, call `useGithubInstallationChoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGithubInstallationChoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGithubInstallationChoicesQuery({
 *   variables: {
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGithubInstallationChoicesQuery(baseOptions: Apollo.QueryHookOptions<GithubInstallationChoicesQuery, GithubInstallationChoicesQueryVariables> & ({ variables: GithubInstallationChoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GithubInstallationChoicesQuery, GithubInstallationChoicesQueryVariables>(GithubInstallationChoicesDocument, options);
      }
export function useGithubInstallationChoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GithubInstallationChoicesQuery, GithubInstallationChoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GithubInstallationChoicesQuery, GithubInstallationChoicesQueryVariables>(GithubInstallationChoicesDocument, options);
        }
export function useGithubInstallationChoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GithubInstallationChoicesQuery, GithubInstallationChoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GithubInstallationChoicesQuery, GithubInstallationChoicesQueryVariables>(GithubInstallationChoicesDocument, options);
        }
export type GithubInstallationChoicesQueryHookResult = ReturnType<typeof useGithubInstallationChoicesQuery>;
export type GithubInstallationChoicesLazyQueryHookResult = ReturnType<typeof useGithubInstallationChoicesLazyQuery>;
export type GithubInstallationChoicesSuspenseQueryHookResult = ReturnType<typeof useGithubInstallationChoicesSuspenseQuery>;
export type GithubInstallationChoicesQueryResult = Apollo.QueryResult<GithubInstallationChoicesQuery, GithubInstallationChoicesQueryVariables>;
export const GithubSelectInstallationDocument = gql`
    mutation GithubSelectInstallation($installationId: String!, $state: String!) {
  githubSelectInstallation(installationId: $installationId, state: $state) {
    accountId
    slug
  }
}
    `;
export type GithubSelectInstallationMutationFn = Apollo.MutationFunction<GithubSelectInstallationMutation, GithubSelectInstallationMutationVariables>;

/**
 * __useGithubSelectInstallationMutation__
 *
 * To run a mutation, you first call `useGithubSelectInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGithubSelectInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [githubSelectInstallationMutation, { data, loading, error }] = useGithubSelectInstallationMutation({
 *   variables: {
 *      installationId: // value for 'installationId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGithubSelectInstallationMutation(baseOptions?: Apollo.MutationHookOptions<GithubSelectInstallationMutation, GithubSelectInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GithubSelectInstallationMutation, GithubSelectInstallationMutationVariables>(GithubSelectInstallationDocument, options);
      }
export type GithubSelectInstallationMutationHookResult = ReturnType<typeof useGithubSelectInstallationMutation>;
export type GithubSelectInstallationMutationResult = Apollo.MutationResult<GithubSelectInstallationMutation>;
export type GithubSelectInstallationMutationOptions = Apollo.BaseMutationOptions<GithubSelectInstallationMutation, GithubSelectInstallationMutationVariables>;
export const GithubRepositoriesDocument = gql`
    query GithubRepositories {
  githubRepositories {
    repositories {
      owner
      name
      fullName
      defaultBranch
      isPrivate
    }
  }
}
    `;

/**
 * __useGithubRepositoriesQuery__
 *
 * To run a query within a React component, call `useGithubRepositoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGithubRepositoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGithubRepositoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGithubRepositoriesQuery(baseOptions?: Apollo.QueryHookOptions<GithubRepositoriesQuery, GithubRepositoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GithubRepositoriesQuery, GithubRepositoriesQueryVariables>(GithubRepositoriesDocument, options);
      }
export function useGithubRepositoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GithubRepositoriesQuery, GithubRepositoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GithubRepositoriesQuery, GithubRepositoriesQueryVariables>(GithubRepositoriesDocument, options);
        }
export function useGithubRepositoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GithubRepositoriesQuery, GithubRepositoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GithubRepositoriesQuery, GithubRepositoriesQueryVariables>(GithubRepositoriesDocument, options);
        }
export type GithubRepositoriesQueryHookResult = ReturnType<typeof useGithubRepositoriesQuery>;
export type GithubRepositoriesLazyQueryHookResult = ReturnType<typeof useGithubRepositoriesLazyQuery>;
export type GithubRepositoriesSuspenseQueryHookResult = ReturnType<typeof useGithubRepositoriesSuspenseQuery>;
export type GithubRepositoriesQueryResult = Apollo.QueryResult<GithubRepositoriesQuery, GithubRepositoriesQueryVariables>;
export const GithubBranchesDocument = gql`
    query GithubBranches($owner: String!, $repo: String!) {
  githubBranches(owner: $owner, repo: $repo) {
    branches {
      name
      isProtected
    }
  }
}
    `;

/**
 * __useGithubBranchesQuery__
 *
 * To run a query within a React component, call `useGithubBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGithubBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGithubBranchesQuery({
 *   variables: {
 *      owner: // value for 'owner'
 *      repo: // value for 'repo'
 *   },
 * });
 */
export function useGithubBranchesQuery(baseOptions: Apollo.QueryHookOptions<GithubBranchesQuery, GithubBranchesQueryVariables> & ({ variables: GithubBranchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GithubBranchesQuery, GithubBranchesQueryVariables>(GithubBranchesDocument, options);
      }
export function useGithubBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GithubBranchesQuery, GithubBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GithubBranchesQuery, GithubBranchesQueryVariables>(GithubBranchesDocument, options);
        }
export function useGithubBranchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GithubBranchesQuery, GithubBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GithubBranchesQuery, GithubBranchesQueryVariables>(GithubBranchesDocument, options);
        }
export type GithubBranchesQueryHookResult = ReturnType<typeof useGithubBranchesQuery>;
export type GithubBranchesLazyQueryHookResult = ReturnType<typeof useGithubBranchesLazyQuery>;
export type GithubBranchesSuspenseQueryHookResult = ReturnType<typeof useGithubBranchesSuspenseQuery>;
export type GithubBranchesQueryResult = Apollo.QueryResult<GithubBranchesQuery, GithubBranchesQueryVariables>;
export const CompleteGithubConnectionDocument = gql`
    mutation CompleteGithubConnection($input: CompleteGithubConnectionInput!) {
  completeGithubConnection(input: $input) {
    connectionId
    repoOwner
    repoName
    branch
    folderPath
    branchIsEmpty
  }
}
    `;
export type CompleteGithubConnectionMutationFn = Apollo.MutationFunction<CompleteGithubConnectionMutation, CompleteGithubConnectionMutationVariables>;

/**
 * __useCompleteGithubConnectionMutation__
 *
 * To run a mutation, you first call `useCompleteGithubConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteGithubConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeGithubConnectionMutation, { data, loading, error }] = useCompleteGithubConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteGithubConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CompleteGithubConnectionMutation, CompleteGithubConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteGithubConnectionMutation, CompleteGithubConnectionMutationVariables>(CompleteGithubConnectionDocument, options);
      }
export type CompleteGithubConnectionMutationHookResult = ReturnType<typeof useCompleteGithubConnectionMutation>;
export type CompleteGithubConnectionMutationResult = Apollo.MutationResult<CompleteGithubConnectionMutation>;
export type CompleteGithubConnectionMutationOptions = Apollo.BaseMutationOptions<CompleteGithubConnectionMutation, CompleteGithubConnectionMutationVariables>;
export const TriggerGithubSyncDocument = gql`
    mutation TriggerGithubSync {
  triggerGithubSync {
    ...GithubSyncFields
  }
}
    ${GithubSyncFieldsFragmentDoc}`;
export type TriggerGithubSyncMutationFn = Apollo.MutationFunction<TriggerGithubSyncMutation, TriggerGithubSyncMutationVariables>;

/**
 * __useTriggerGithubSyncMutation__
 *
 * To run a mutation, you first call `useTriggerGithubSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerGithubSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerGithubSyncMutation, { data, loading, error }] = useTriggerGithubSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerGithubSyncMutation(baseOptions?: Apollo.MutationHookOptions<TriggerGithubSyncMutation, TriggerGithubSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerGithubSyncMutation, TriggerGithubSyncMutationVariables>(TriggerGithubSyncDocument, options);
      }
export type TriggerGithubSyncMutationHookResult = ReturnType<typeof useTriggerGithubSyncMutation>;
export type TriggerGithubSyncMutationResult = Apollo.MutationResult<TriggerGithubSyncMutation>;
export type TriggerGithubSyncMutationOptions = Apollo.BaseMutationOptions<TriggerGithubSyncMutation, TriggerGithubSyncMutationVariables>;
export const ConfirmFirstGithubSyncDocument = gql`
    mutation ConfirmFirstGithubSync($syncId: String!) {
  confirmFirstGithubSync(syncId: $syncId) {
    ...GithubSyncFields
  }
}
    ${GithubSyncFieldsFragmentDoc}`;
export type ConfirmFirstGithubSyncMutationFn = Apollo.MutationFunction<ConfirmFirstGithubSyncMutation, ConfirmFirstGithubSyncMutationVariables>;

/**
 * __useConfirmFirstGithubSyncMutation__
 *
 * To run a mutation, you first call `useConfirmFirstGithubSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmFirstGithubSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmFirstGithubSyncMutation, { data, loading, error }] = useConfirmFirstGithubSyncMutation({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useConfirmFirstGithubSyncMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmFirstGithubSyncMutation, ConfirmFirstGithubSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmFirstGithubSyncMutation, ConfirmFirstGithubSyncMutationVariables>(ConfirmFirstGithubSyncDocument, options);
      }
export type ConfirmFirstGithubSyncMutationHookResult = ReturnType<typeof useConfirmFirstGithubSyncMutation>;
export type ConfirmFirstGithubSyncMutationResult = Apollo.MutationResult<ConfirmFirstGithubSyncMutation>;
export type ConfirmFirstGithubSyncMutationOptions = Apollo.BaseMutationOptions<ConfirmFirstGithubSyncMutation, ConfirmFirstGithubSyncMutationVariables>;
export const CancelGithubSyncDocument = gql`
    mutation CancelGithubSync($syncId: String!) {
  cancelGithubSync(syncId: $syncId) {
    ...GithubSyncFields
  }
}
    ${GithubSyncFieldsFragmentDoc}`;
export type CancelGithubSyncMutationFn = Apollo.MutationFunction<CancelGithubSyncMutation, CancelGithubSyncMutationVariables>;

/**
 * __useCancelGithubSyncMutation__
 *
 * To run a mutation, you first call `useCancelGithubSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelGithubSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelGithubSyncMutation, { data, loading, error }] = useCancelGithubSyncMutation({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useCancelGithubSyncMutation(baseOptions?: Apollo.MutationHookOptions<CancelGithubSyncMutation, CancelGithubSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelGithubSyncMutation, CancelGithubSyncMutationVariables>(CancelGithubSyncDocument, options);
      }
export type CancelGithubSyncMutationHookResult = ReturnType<typeof useCancelGithubSyncMutation>;
export type CancelGithubSyncMutationResult = Apollo.MutationResult<CancelGithubSyncMutation>;
export type CancelGithubSyncMutationOptions = Apollo.BaseMutationOptions<CancelGithubSyncMutation, CancelGithubSyncMutationVariables>;
export const RetryGithubSyncMaterializationsDocument = gql`
    mutation RetryGithubSyncMaterializations($syncId: String!) {
  retryGithubSyncMaterializations(syncId: $syncId) {
    ...GithubSyncFields
  }
}
    ${GithubSyncFieldsFragmentDoc}`;
export type RetryGithubSyncMaterializationsMutationFn = Apollo.MutationFunction<RetryGithubSyncMaterializationsMutation, RetryGithubSyncMaterializationsMutationVariables>;

/**
 * __useRetryGithubSyncMaterializationsMutation__
 *
 * To run a mutation, you first call `useRetryGithubSyncMaterializationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryGithubSyncMaterializationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryGithubSyncMaterializationsMutation, { data, loading, error }] = useRetryGithubSyncMaterializationsMutation({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useRetryGithubSyncMaterializationsMutation(baseOptions?: Apollo.MutationHookOptions<RetryGithubSyncMaterializationsMutation, RetryGithubSyncMaterializationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryGithubSyncMaterializationsMutation, RetryGithubSyncMaterializationsMutationVariables>(RetryGithubSyncMaterializationsDocument, options);
      }
export type RetryGithubSyncMaterializationsMutationHookResult = ReturnType<typeof useRetryGithubSyncMaterializationsMutation>;
export type RetryGithubSyncMaterializationsMutationResult = Apollo.MutationResult<RetryGithubSyncMaterializationsMutation>;
export type RetryGithubSyncMaterializationsMutationOptions = Apollo.BaseMutationOptions<RetryGithubSyncMaterializationsMutation, RetryGithubSyncMaterializationsMutationVariables>;
export const GithubModelLastCommitDocument = gql`
    query GithubModelLastCommit($sourcePath: String!) {
  githubModelLastCommit(sourcePath: $sourcePath) {
    ...GithubFileCommitFields
  }
}
    ${GithubFileCommitFieldsFragmentDoc}`;

/**
 * __useGithubModelLastCommitQuery__
 *
 * To run a query within a React component, call `useGithubModelLastCommitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGithubModelLastCommitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGithubModelLastCommitQuery({
 *   variables: {
 *      sourcePath: // value for 'sourcePath'
 *   },
 * });
 */
export function useGithubModelLastCommitQuery(baseOptions: Apollo.QueryHookOptions<GithubModelLastCommitQuery, GithubModelLastCommitQueryVariables> & ({ variables: GithubModelLastCommitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GithubModelLastCommitQuery, GithubModelLastCommitQueryVariables>(GithubModelLastCommitDocument, options);
      }
export function useGithubModelLastCommitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GithubModelLastCommitQuery, GithubModelLastCommitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GithubModelLastCommitQuery, GithubModelLastCommitQueryVariables>(GithubModelLastCommitDocument, options);
        }
export function useGithubModelLastCommitSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GithubModelLastCommitQuery, GithubModelLastCommitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GithubModelLastCommitQuery, GithubModelLastCommitQueryVariables>(GithubModelLastCommitDocument, options);
        }
export type GithubModelLastCommitQueryHookResult = ReturnType<typeof useGithubModelLastCommitQuery>;
export type GithubModelLastCommitLazyQueryHookResult = ReturnType<typeof useGithubModelLastCommitLazyQuery>;
export type GithubModelLastCommitSuspenseQueryHookResult = ReturnType<typeof useGithubModelLastCommitSuspenseQuery>;
export type GithubModelLastCommitQueryResult = Apollo.QueryResult<GithubModelLastCommitQuery, GithubModelLastCommitQueryVariables>;
export const GithubSyncDocument = gql`
    query GithubSync($id: String!) {
  githubSync(id: $id) {
    ...GithubSyncFields
  }
}
    ${GithubSyncFieldsFragmentDoc}`;

/**
 * __useGithubSyncQuery__
 *
 * To run a query within a React component, call `useGithubSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useGithubSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGithubSyncQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGithubSyncQuery(baseOptions: Apollo.QueryHookOptions<GithubSyncQuery, GithubSyncQueryVariables> & ({ variables: GithubSyncQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GithubSyncQuery, GithubSyncQueryVariables>(GithubSyncDocument, options);
      }
export function useGithubSyncLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GithubSyncQuery, GithubSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GithubSyncQuery, GithubSyncQueryVariables>(GithubSyncDocument, options);
        }
export function useGithubSyncSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GithubSyncQuery, GithubSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GithubSyncQuery, GithubSyncQueryVariables>(GithubSyncDocument, options);
        }
export type GithubSyncQueryHookResult = ReturnType<typeof useGithubSyncQuery>;
export type GithubSyncLazyQueryHookResult = ReturnType<typeof useGithubSyncLazyQuery>;
export type GithubSyncSuspenseQueryHookResult = ReturnType<typeof useGithubSyncSuspenseQuery>;
export type GithubSyncQueryResult = Apollo.QueryResult<GithubSyncQuery, GithubSyncQueryVariables>;
export const GithubSyncsDocument = gql`
    query GithubSyncs($connectionId: String!, $limit: Int, $before: String) {
  githubSyncs(connectionId: $connectionId, limit: $limit, before: $before) {
    items {
      ...GithubSyncListItemFields
    }
    nextCursor
    hasMore
  }
}
    ${GithubSyncListItemFieldsFragmentDoc}`;

/**
 * __useGithubSyncsQuery__
 *
 * To run a query within a React component, call `useGithubSyncsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGithubSyncsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGithubSyncsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      limit: // value for 'limit'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGithubSyncsQuery(baseOptions: Apollo.QueryHookOptions<GithubSyncsQuery, GithubSyncsQueryVariables> & ({ variables: GithubSyncsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GithubSyncsQuery, GithubSyncsQueryVariables>(GithubSyncsDocument, options);
      }
export function useGithubSyncsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GithubSyncsQuery, GithubSyncsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GithubSyncsQuery, GithubSyncsQueryVariables>(GithubSyncsDocument, options);
        }
export function useGithubSyncsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GithubSyncsQuery, GithubSyncsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GithubSyncsQuery, GithubSyncsQueryVariables>(GithubSyncsDocument, options);
        }
export type GithubSyncsQueryHookResult = ReturnType<typeof useGithubSyncsQuery>;
export type GithubSyncsLazyQueryHookResult = ReturnType<typeof useGithubSyncsLazyQuery>;
export type GithubSyncsSuspenseQueryHookResult = ReturnType<typeof useGithubSyncsSuspenseQuery>;
export type GithubSyncsQueryResult = Apollo.QueryResult<GithubSyncsQuery, GithubSyncsQueryVariables>;
export const StaleMaterializationsDocument = gql`
    query StaleMaterializations {
  staleMaterializations {
    staleModels {
      ...StaleModelFields
    }
  }
}
    ${StaleModelFieldsFragmentDoc}`;

/**
 * __useStaleMaterializationsQuery__
 *
 * To run a query within a React component, call `useStaleMaterializationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaleMaterializationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaleMaterializationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStaleMaterializationsQuery(baseOptions?: Apollo.QueryHookOptions<StaleMaterializationsQuery, StaleMaterializationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StaleMaterializationsQuery, StaleMaterializationsQueryVariables>(StaleMaterializationsDocument, options);
      }
export function useStaleMaterializationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaleMaterializationsQuery, StaleMaterializationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StaleMaterializationsQuery, StaleMaterializationsQueryVariables>(StaleMaterializationsDocument, options);
        }
export function useStaleMaterializationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StaleMaterializationsQuery, StaleMaterializationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StaleMaterializationsQuery, StaleMaterializationsQueryVariables>(StaleMaterializationsDocument, options);
        }
export type StaleMaterializationsQueryHookResult = ReturnType<typeof useStaleMaterializationsQuery>;
export type StaleMaterializationsLazyQueryHookResult = ReturnType<typeof useStaleMaterializationsLazyQuery>;
export type StaleMaterializationsSuspenseQueryHookResult = ReturnType<typeof useStaleMaterializationsSuspenseQuery>;
export type StaleMaterializationsQueryResult = Apollo.QueryResult<StaleMaterializationsQuery, StaleMaterializationsQueryVariables>;
export const ReconcileStaleMaterializationsDocument = gql`
    mutation ReconcileStaleMaterializations {
  reconcileStaleMaterializations {
    staleModelIds
    failures {
      modelId
      modelName
      error
    }
  }
}
    `;
export type ReconcileStaleMaterializationsMutationFn = Apollo.MutationFunction<ReconcileStaleMaterializationsMutation, ReconcileStaleMaterializationsMutationVariables>;

/**
 * __useReconcileStaleMaterializationsMutation__
 *
 * To run a mutation, you first call `useReconcileStaleMaterializationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReconcileStaleMaterializationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reconcileStaleMaterializationsMutation, { data, loading, error }] = useReconcileStaleMaterializationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useReconcileStaleMaterializationsMutation(baseOptions?: Apollo.MutationHookOptions<ReconcileStaleMaterializationsMutation, ReconcileStaleMaterializationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReconcileStaleMaterializationsMutation, ReconcileStaleMaterializationsMutationVariables>(ReconcileStaleMaterializationsDocument, options);
      }
export type ReconcileStaleMaterializationsMutationHookResult = ReturnType<typeof useReconcileStaleMaterializationsMutation>;
export type ReconcileStaleMaterializationsMutationResult = Apollo.MutationResult<ReconcileStaleMaterializationsMutation>;
export type ReconcileStaleMaterializationsMutationOptions = Apollo.BaseMutationOptions<ReconcileStaleMaterializationsMutation, ReconcileStaleMaterializationsMutationVariables>;
export const ReconcileStaleMaterializationDocument = gql`
    mutation ReconcileStaleMaterialization($modelId: String!) {
  reconcileStaleMaterialization(modelId: $modelId) {
    staleModelIds
    failures {
      modelId
      modelName
      error
    }
  }
}
    `;
export type ReconcileStaleMaterializationMutationFn = Apollo.MutationFunction<ReconcileStaleMaterializationMutation, ReconcileStaleMaterializationMutationVariables>;

/**
 * __useReconcileStaleMaterializationMutation__
 *
 * To run a mutation, you first call `useReconcileStaleMaterializationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReconcileStaleMaterializationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reconcileStaleMaterializationMutation, { data, loading, error }] = useReconcileStaleMaterializationMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useReconcileStaleMaterializationMutation(baseOptions?: Apollo.MutationHookOptions<ReconcileStaleMaterializationMutation, ReconcileStaleMaterializationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReconcileStaleMaterializationMutation, ReconcileStaleMaterializationMutationVariables>(ReconcileStaleMaterializationDocument, options);
      }
export type ReconcileStaleMaterializationMutationHookResult = ReturnType<typeof useReconcileStaleMaterializationMutation>;
export type ReconcileStaleMaterializationMutationResult = Apollo.MutationResult<ReconcileStaleMaterializationMutation>;
export type ReconcileStaleMaterializationMutationOptions = Apollo.BaseMutationOptions<ReconcileStaleMaterializationMutation, ReconcileStaleMaterializationMutationVariables>;
export const CountriesDocument = gql`
    query Countries {
  countries {
    ...Country
  }
}
    ${CountryFragmentDoc}`;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export function useCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesSuspenseQueryHookResult = ReturnType<typeof useCountriesSuspenseQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const ResolveCountryFromTimeZoneDocument = gql`
    query ResolveCountryFromTimeZone($timeZone: String!) {
  resolveCountryFromTimeZone(timeZone: $timeZone) {
    country {
      ...Country
    }
  }
}
    ${CountryFragmentDoc}`;

/**
 * __useResolveCountryFromTimeZoneQuery__
 *
 * To run a query within a React component, call `useResolveCountryFromTimeZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveCountryFromTimeZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveCountryFromTimeZoneQuery({
 *   variables: {
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useResolveCountryFromTimeZoneQuery(baseOptions: Apollo.QueryHookOptions<ResolveCountryFromTimeZoneQuery, ResolveCountryFromTimeZoneQueryVariables> & ({ variables: ResolveCountryFromTimeZoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResolveCountryFromTimeZoneQuery, ResolveCountryFromTimeZoneQueryVariables>(ResolveCountryFromTimeZoneDocument, options);
      }
export function useResolveCountryFromTimeZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResolveCountryFromTimeZoneQuery, ResolveCountryFromTimeZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResolveCountryFromTimeZoneQuery, ResolveCountryFromTimeZoneQueryVariables>(ResolveCountryFromTimeZoneDocument, options);
        }
export function useResolveCountryFromTimeZoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResolveCountryFromTimeZoneQuery, ResolveCountryFromTimeZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResolveCountryFromTimeZoneQuery, ResolveCountryFromTimeZoneQueryVariables>(ResolveCountryFromTimeZoneDocument, options);
        }
export type ResolveCountryFromTimeZoneQueryHookResult = ReturnType<typeof useResolveCountryFromTimeZoneQuery>;
export type ResolveCountryFromTimeZoneLazyQueryHookResult = ReturnType<typeof useResolveCountryFromTimeZoneLazyQuery>;
export type ResolveCountryFromTimeZoneSuspenseQueryHookResult = ReturnType<typeof useResolveCountryFromTimeZoneSuspenseQuery>;
export type ResolveCountryFromTimeZoneQueryResult = Apollo.QueryResult<ResolveCountryFromTimeZoneQuery, ResolveCountryFromTimeZoneQueryVariables>;
export const CountriesAndCurrentCountryDocument = gql`
    query CountriesAndCurrentCountry($timeZone: String!) {
  countries {
    ...Country
  }
  resolveCountryFromTimeZone(timeZone: $timeZone) {
    country {
      ...Country
    }
  }
}
    ${CountryFragmentDoc}`;

/**
 * __useCountriesAndCurrentCountryQuery__
 *
 * To run a query within a React component, call `useCountriesAndCurrentCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesAndCurrentCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesAndCurrentCountryQuery({
 *   variables: {
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useCountriesAndCurrentCountryQuery(baseOptions: Apollo.QueryHookOptions<CountriesAndCurrentCountryQuery, CountriesAndCurrentCountryQueryVariables> & ({ variables: CountriesAndCurrentCountryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesAndCurrentCountryQuery, CountriesAndCurrentCountryQueryVariables>(CountriesAndCurrentCountryDocument, options);
      }
export function useCountriesAndCurrentCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesAndCurrentCountryQuery, CountriesAndCurrentCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesAndCurrentCountryQuery, CountriesAndCurrentCountryQueryVariables>(CountriesAndCurrentCountryDocument, options);
        }
export function useCountriesAndCurrentCountrySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountriesAndCurrentCountryQuery, CountriesAndCurrentCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountriesAndCurrentCountryQuery, CountriesAndCurrentCountryQueryVariables>(CountriesAndCurrentCountryDocument, options);
        }
export type CountriesAndCurrentCountryQueryHookResult = ReturnType<typeof useCountriesAndCurrentCountryQuery>;
export type CountriesAndCurrentCountryLazyQueryHookResult = ReturnType<typeof useCountriesAndCurrentCountryLazyQuery>;
export type CountriesAndCurrentCountrySuspenseQueryHookResult = ReturnType<typeof useCountriesAndCurrentCountrySuspenseQuery>;
export type CountriesAndCurrentCountryQueryResult = Apollo.QueryResult<CountriesAndCurrentCountryQuery, CountriesAndCurrentCountryQueryVariables>;
export const IntegrationConfigurationDocument = gql`
    query IntegrationConfiguration($id: String!, $isDatawarehouse: Boolean) {
  integrationConfiguration(integrationId: $id, isDatawarehouse: $isDatawarehouse) {
    ...IntegrationConfiguration
  }
}
    ${IntegrationConfigurationFragmentDoc}`;

/**
 * __useIntegrationConfigurationQuery__
 *
 * To run a query within a React component, call `useIntegrationConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationConfigurationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isDatawarehouse: // value for 'isDatawarehouse'
 *   },
 * });
 */
export function useIntegrationConfigurationQuery(baseOptions: Apollo.QueryHookOptions<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables> & ({ variables: IntegrationConfigurationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>(IntegrationConfigurationDocument, options);
      }
export function useIntegrationConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>(IntegrationConfigurationDocument, options);
        }
export function useIntegrationConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>(IntegrationConfigurationDocument, options);
        }
export type IntegrationConfigurationQueryHookResult = ReturnType<typeof useIntegrationConfigurationQuery>;
export type IntegrationConfigurationLazyQueryHookResult = ReturnType<typeof useIntegrationConfigurationLazyQuery>;
export type IntegrationConfigurationSuspenseQueryHookResult = ReturnType<typeof useIntegrationConfigurationSuspenseQuery>;
export type IntegrationConfigurationQueryResult = Apollo.QueryResult<IntegrationConfigurationQuery, IntegrationConfigurationQueryVariables>;
export const AvailableIntegrationsDocument = gql`
    query AvailableIntegrations {
  availableIntegrations {
    ...AvailableIntegration
  }
}
    ${AvailableIntegrationFragmentDoc}`;

/**
 * __useAvailableIntegrationsQuery__
 *
 * To run a query within a React component, call `useAvailableIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>(AvailableIntegrationsDocument, options);
      }
export function useAvailableIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>(AvailableIntegrationsDocument, options);
        }
export function useAvailableIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>(AvailableIntegrationsDocument, options);
        }
export type AvailableIntegrationsQueryHookResult = ReturnType<typeof useAvailableIntegrationsQuery>;
export type AvailableIntegrationsLazyQueryHookResult = ReturnType<typeof useAvailableIntegrationsLazyQuery>;
export type AvailableIntegrationsSuspenseQueryHookResult = ReturnType<typeof useAvailableIntegrationsSuspenseQuery>;
export type AvailableIntegrationsQueryResult = Apollo.QueryResult<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>;
export const DestinationIntegrationsDocument = gql`
    query DestinationIntegrations {
  destinationIntegrations {
    ...AvailableIntegration
  }
}
    ${AvailableIntegrationFragmentDoc}`;

/**
 * __useDestinationIntegrationsQuery__
 *
 * To run a query within a React component, call `useDestinationIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDestinationIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<DestinationIntegrationsQuery, DestinationIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DestinationIntegrationsQuery, DestinationIntegrationsQueryVariables>(DestinationIntegrationsDocument, options);
      }
export function useDestinationIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationIntegrationsQuery, DestinationIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DestinationIntegrationsQuery, DestinationIntegrationsQueryVariables>(DestinationIntegrationsDocument, options);
        }
export function useDestinationIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DestinationIntegrationsQuery, DestinationIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DestinationIntegrationsQuery, DestinationIntegrationsQueryVariables>(DestinationIntegrationsDocument, options);
        }
export type DestinationIntegrationsQueryHookResult = ReturnType<typeof useDestinationIntegrationsQuery>;
export type DestinationIntegrationsLazyQueryHookResult = ReturnType<typeof useDestinationIntegrationsLazyQuery>;
export type DestinationIntegrationsSuspenseQueryHookResult = ReturnType<typeof useDestinationIntegrationsSuspenseQuery>;
export type DestinationIntegrationsQueryResult = Apollo.QueryResult<DestinationIntegrationsQuery, DestinationIntegrationsQueryVariables>;
export const PopularEltSourcesDocument = gql`
    query PopularEltSources {
  popularEltSources
}
    `;

/**
 * __usePopularEltSourcesQuery__
 *
 * To run a query within a React component, call `usePopularEltSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularEltSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularEltSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePopularEltSourcesQuery(baseOptions?: Apollo.QueryHookOptions<PopularEltSourcesQuery, PopularEltSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PopularEltSourcesQuery, PopularEltSourcesQueryVariables>(PopularEltSourcesDocument, options);
      }
export function usePopularEltSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PopularEltSourcesQuery, PopularEltSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PopularEltSourcesQuery, PopularEltSourcesQueryVariables>(PopularEltSourcesDocument, options);
        }
export function usePopularEltSourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PopularEltSourcesQuery, PopularEltSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PopularEltSourcesQuery, PopularEltSourcesQueryVariables>(PopularEltSourcesDocument, options);
        }
export type PopularEltSourcesQueryHookResult = ReturnType<typeof usePopularEltSourcesQuery>;
export type PopularEltSourcesLazyQueryHookResult = ReturnType<typeof usePopularEltSourcesLazyQuery>;
export type PopularEltSourcesSuspenseQueryHookResult = ReturnType<typeof usePopularEltSourcesSuspenseQuery>;
export type PopularEltSourcesQueryResult = Apollo.QueryResult<PopularEltSourcesQuery, PopularEltSourcesQueryVariables>;
export const LineageAccessDocument = gql`
    query LineageAccess($input: LineageSourceInput!) {
  lineageAccess(input: $input) {
    allowed
    deniedSchemas
  }
}
    `;

/**
 * __useLineageAccessQuery__
 *
 * To run a query within a React component, call `useLineageAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineageAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLineageAccessQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLineageAccessQuery(baseOptions: Apollo.QueryHookOptions<LineageAccessQuery, LineageAccessQueryVariables> & ({ variables: LineageAccessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LineageAccessQuery, LineageAccessQueryVariables>(LineageAccessDocument, options);
      }
export function useLineageAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LineageAccessQuery, LineageAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LineageAccessQuery, LineageAccessQueryVariables>(LineageAccessDocument, options);
        }
export function useLineageAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LineageAccessQuery, LineageAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LineageAccessQuery, LineageAccessQueryVariables>(LineageAccessDocument, options);
        }
export type LineageAccessQueryHookResult = ReturnType<typeof useLineageAccessQuery>;
export type LineageAccessLazyQueryHookResult = ReturnType<typeof useLineageAccessLazyQuery>;
export type LineageAccessSuspenseQueryHookResult = ReturnType<typeof useLineageAccessSuspenseQuery>;
export type LineageAccessQueryResult = Apollo.QueryResult<LineageAccessQuery, LineageAccessQueryVariables>;
export const WorkspaceLineageGraphDocument = gql`
    query WorkspaceLineageGraph {
  workspaceLineageGraph {
    ...LineageGraphNode
  }
}
    ${LineageGraphNodeFragmentDoc}`;

/**
 * __useWorkspaceLineageGraphQuery__
 *
 * To run a query within a React component, call `useWorkspaceLineageGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceLineageGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceLineageGraphQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceLineageGraphQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceLineageGraphQuery, WorkspaceLineageGraphQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceLineageGraphQuery, WorkspaceLineageGraphQueryVariables>(WorkspaceLineageGraphDocument, options);
      }
export function useWorkspaceLineageGraphLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceLineageGraphQuery, WorkspaceLineageGraphQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceLineageGraphQuery, WorkspaceLineageGraphQueryVariables>(WorkspaceLineageGraphDocument, options);
        }
export function useWorkspaceLineageGraphSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceLineageGraphQuery, WorkspaceLineageGraphQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceLineageGraphQuery, WorkspaceLineageGraphQueryVariables>(WorkspaceLineageGraphDocument, options);
        }
export type WorkspaceLineageGraphQueryHookResult = ReturnType<typeof useWorkspaceLineageGraphQuery>;
export type WorkspaceLineageGraphLazyQueryHookResult = ReturnType<typeof useWorkspaceLineageGraphLazyQuery>;
export type WorkspaceLineageGraphSuspenseQueryHookResult = ReturnType<typeof useWorkspaceLineageGraphSuspenseQuery>;
export type WorkspaceLineageGraphQueryResult = Apollo.QueryResult<WorkspaceLineageGraphQuery, WorkspaceLineageGraphQueryVariables>;
export const CreateModelTestDocument = gql`
    mutation CreateModelTest($createModelTestInput: CreateModelTestInput!) {
  createModelTest(createModelTestInput: $createModelTestInput) {
    id
  }
}
    `;
export type CreateModelTestMutationFn = Apollo.MutationFunction<CreateModelTestMutation, CreateModelTestMutationVariables>;

/**
 * __useCreateModelTestMutation__
 *
 * To run a mutation, you first call `useCreateModelTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModelTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModelTestMutation, { data, loading, error }] = useCreateModelTestMutation({
 *   variables: {
 *      createModelTestInput: // value for 'createModelTestInput'
 *   },
 * });
 */
export function useCreateModelTestMutation(baseOptions?: Apollo.MutationHookOptions<CreateModelTestMutation, CreateModelTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModelTestMutation, CreateModelTestMutationVariables>(CreateModelTestDocument, options);
      }
export type CreateModelTestMutationHookResult = ReturnType<typeof useCreateModelTestMutation>;
export type CreateModelTestMutationResult = Apollo.MutationResult<CreateModelTestMutation>;
export type CreateModelTestMutationOptions = Apollo.BaseMutationOptions<CreateModelTestMutation, CreateModelTestMutationVariables>;
export const RemoveModelTestDocument = gql`
    mutation RemoveModelTest($id: String!) {
  removeModelTest(id: $id) {
    id
  }
}
    `;
export type RemoveModelTestMutationFn = Apollo.MutationFunction<RemoveModelTestMutation, RemoveModelTestMutationVariables>;

/**
 * __useRemoveModelTestMutation__
 *
 * To run a mutation, you first call `useRemoveModelTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveModelTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeModelTestMutation, { data, loading, error }] = useRemoveModelTestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveModelTestMutation(baseOptions?: Apollo.MutationHookOptions<RemoveModelTestMutation, RemoveModelTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveModelTestMutation, RemoveModelTestMutationVariables>(RemoveModelTestDocument, options);
      }
export type RemoveModelTestMutationHookResult = ReturnType<typeof useRemoveModelTestMutation>;
export type RemoveModelTestMutationResult = Apollo.MutationResult<RemoveModelTestMutation>;
export type RemoveModelTestMutationOptions = Apollo.BaseMutationOptions<RemoveModelTestMutation, RemoveModelTestMutationVariables>;
export const ModelTestsByModelDocument = gql`
    query ModelTestsByModel($modelId: String!) {
  model(id: $modelId) {
    id
    modelTests {
      id
      column
      type
    }
  }
}
    `;

/**
 * __useModelTestsByModelQuery__
 *
 * To run a query within a React component, call `useModelTestsByModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelTestsByModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelTestsByModelQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useModelTestsByModelQuery(baseOptions: Apollo.QueryHookOptions<ModelTestsByModelQuery, ModelTestsByModelQueryVariables> & ({ variables: ModelTestsByModelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelTestsByModelQuery, ModelTestsByModelQueryVariables>(ModelTestsByModelDocument, options);
      }
export function useModelTestsByModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelTestsByModelQuery, ModelTestsByModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelTestsByModelQuery, ModelTestsByModelQueryVariables>(ModelTestsByModelDocument, options);
        }
export function useModelTestsByModelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ModelTestsByModelQuery, ModelTestsByModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModelTestsByModelQuery, ModelTestsByModelQueryVariables>(ModelTestsByModelDocument, options);
        }
export type ModelTestsByModelQueryHookResult = ReturnType<typeof useModelTestsByModelQuery>;
export type ModelTestsByModelLazyQueryHookResult = ReturnType<typeof useModelTestsByModelLazyQuery>;
export type ModelTestsByModelSuspenseQueryHookResult = ReturnType<typeof useModelTestsByModelSuspenseQuery>;
export type ModelTestsByModelQueryResult = Apollo.QueryResult<ModelTestsByModelQuery, ModelTestsByModelQueryVariables>;
export const StartTestDocument = gql`
    query StartTest($modelTestId: ID!) {
  startTest(modelTestId: $modelTestId) {
    modelTestId
    status
    queryExecutionId
    modelTestWeldSql
    failedRows
    error
  }
}
    `;

/**
 * __useStartTestQuery__
 *
 * To run a query within a React component, call `useStartTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartTestQuery({
 *   variables: {
 *      modelTestId: // value for 'modelTestId'
 *   },
 * });
 */
export function useStartTestQuery(baseOptions: Apollo.QueryHookOptions<StartTestQuery, StartTestQueryVariables> & ({ variables: StartTestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StartTestQuery, StartTestQueryVariables>(StartTestDocument, options);
      }
export function useStartTestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StartTestQuery, StartTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StartTestQuery, StartTestQueryVariables>(StartTestDocument, options);
        }
export function useStartTestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StartTestQuery, StartTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StartTestQuery, StartTestQueryVariables>(StartTestDocument, options);
        }
export type StartTestQueryHookResult = ReturnType<typeof useStartTestQuery>;
export type StartTestLazyQueryHookResult = ReturnType<typeof useStartTestLazyQuery>;
export type StartTestSuspenseQueryHookResult = ReturnType<typeof useStartTestSuspenseQuery>;
export type StartTestQueryResult = Apollo.QueryResult<StartTestQuery, StartTestQueryVariables>;
export const GetTestResultDocument = gql`
    query GetTestResult($modelTestId: ID!, $queryExecutionId: String!) {
  getTestResult(modelTestId: $modelTestId, queryExecutionId: $queryExecutionId) {
    modelTestId
    status
    queryExecutionId
    failedRows
    error
  }
}
    `;

/**
 * __useGetTestResultQuery__
 *
 * To run a query within a React component, call `useGetTestResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestResultQuery({
 *   variables: {
 *      modelTestId: // value for 'modelTestId'
 *      queryExecutionId: // value for 'queryExecutionId'
 *   },
 * });
 */
export function useGetTestResultQuery(baseOptions: Apollo.QueryHookOptions<GetTestResultQuery, GetTestResultQueryVariables> & ({ variables: GetTestResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTestResultQuery, GetTestResultQueryVariables>(GetTestResultDocument, options);
      }
export function useGetTestResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTestResultQuery, GetTestResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTestResultQuery, GetTestResultQueryVariables>(GetTestResultDocument, options);
        }
export function useGetTestResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTestResultQuery, GetTestResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTestResultQuery, GetTestResultQueryVariables>(GetTestResultDocument, options);
        }
export type GetTestResultQueryHookResult = ReturnType<typeof useGetTestResultQuery>;
export type GetTestResultLazyQueryHookResult = ReturnType<typeof useGetTestResultLazyQuery>;
export type GetTestResultSuspenseQueryHookResult = ReturnType<typeof useGetTestResultSuspenseQuery>;
export type GetTestResultQueryResult = Apollo.QueryResult<GetTestResultQuery, GetTestResultQueryVariables>;
export const CreateDraftModelDocument = gql`
    mutation CreateDraftModel($name: String!, $sourceConnectionId: String!, $weldSql: String!, $dashboardId: String) {
  createDraftModel(
    input: {name: $name, sourceConnectionId: $sourceConnectionId, weldSql: $weldSql, dashboardId: $dashboardId}
  ) {
    ...ModelBase
    ...ModelPublishedFragment
  }
}
    ${ModelBaseFragmentDoc}
${ModelPublishedFragmentFragmentDoc}`;
export type CreateDraftModelMutationFn = Apollo.MutationFunction<CreateDraftModelMutation, CreateDraftModelMutationVariables>;

/**
 * __useCreateDraftModelMutation__
 *
 * To run a mutation, you first call `useCreateDraftModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftModelMutation, { data, loading, error }] = useCreateDraftModelMutation({
 *   variables: {
 *      name: // value for 'name'
 *      sourceConnectionId: // value for 'sourceConnectionId'
 *      weldSql: // value for 'weldSql'
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useCreateDraftModelMutation(baseOptions?: Apollo.MutationHookOptions<CreateDraftModelMutation, CreateDraftModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDraftModelMutation, CreateDraftModelMutationVariables>(CreateDraftModelDocument, options);
      }
export type CreateDraftModelMutationHookResult = ReturnType<typeof useCreateDraftModelMutation>;
export type CreateDraftModelMutationResult = Apollo.MutationResult<CreateDraftModelMutation>;
export type CreateDraftModelMutationOptions = Apollo.BaseMutationOptions<CreateDraftModelMutation, CreateDraftModelMutationVariables>;
export const PublishModelAsyncDocument = gql`
    mutation PublishModelAsync($id: String!, $name: String!, $query: QueryInput!, $materializationType: MaterializationType!, $materializationSchedule: String, $modelFolderId: String!, $orchestrationScheduler: OrchestrationSchedulerType, $orchestrationWorkflowId: ID, $isUnsavedModel: Boolean!, $sourceConnectionId: String!, $partitionExpression: String, $clusteringColumns: String) {
  publishModelAsync(
    input: {id: $id, name: $name, query: $query, materializationType: $materializationType, materializationSchedule: $materializationSchedule, modelFolderId: $modelFolderId, orchestrationScheduler: $orchestrationScheduler, orchestrationWorkflowId: $orchestrationWorkflowId, isUnsavedModel: $isUnsavedModel, sourceConnectionId: $sourceConnectionId, partitionExpression: $partitionExpression, clusteringColumns: $clusteringColumns}
  )
}
    `;
export type PublishModelAsyncMutationFn = Apollo.MutationFunction<PublishModelAsyncMutation, PublishModelAsyncMutationVariables>;

/**
 * __usePublishModelAsyncMutation__
 *
 * To run a mutation, you first call `usePublishModelAsyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishModelAsyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishModelAsyncMutation, { data, loading, error }] = usePublishModelAsyncMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      query: // value for 'query'
 *      materializationType: // value for 'materializationType'
 *      materializationSchedule: // value for 'materializationSchedule'
 *      modelFolderId: // value for 'modelFolderId'
 *      orchestrationScheduler: // value for 'orchestrationScheduler'
 *      orchestrationWorkflowId: // value for 'orchestrationWorkflowId'
 *      isUnsavedModel: // value for 'isUnsavedModel'
 *      sourceConnectionId: // value for 'sourceConnectionId'
 *      partitionExpression: // value for 'partitionExpression'
 *      clusteringColumns: // value for 'clusteringColumns'
 *   },
 * });
 */
export function usePublishModelAsyncMutation(baseOptions?: Apollo.MutationHookOptions<PublishModelAsyncMutation, PublishModelAsyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishModelAsyncMutation, PublishModelAsyncMutationVariables>(PublishModelAsyncDocument, options);
      }
export type PublishModelAsyncMutationHookResult = ReturnType<typeof usePublishModelAsyncMutation>;
export type PublishModelAsyncMutationResult = Apollo.MutationResult<PublishModelAsyncMutation>;
export type PublishModelAsyncMutationOptions = Apollo.BaseMutationOptions<PublishModelAsyncMutation, PublishModelAsyncMutationVariables>;
export const UpdatePublishedModelQueryAsyncDocument = gql`
    mutation UpdatePublishedModelQueryAsync($id: String!, $query: QueryInput!) {
  updatePublishedModelQueryAsync(input: {id: $id, query: $query})
}
    `;
export type UpdatePublishedModelQueryAsyncMutationFn = Apollo.MutationFunction<UpdatePublishedModelQueryAsyncMutation, UpdatePublishedModelQueryAsyncMutationVariables>;

/**
 * __useUpdatePublishedModelQueryAsyncMutation__
 *
 * To run a mutation, you first call `useUpdatePublishedModelQueryAsyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublishedModelQueryAsyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublishedModelQueryAsyncMutation, { data, loading, error }] = useUpdatePublishedModelQueryAsyncMutation({
 *   variables: {
 *      id: // value for 'id'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useUpdatePublishedModelQueryAsyncMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePublishedModelQueryAsyncMutation, UpdatePublishedModelQueryAsyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePublishedModelQueryAsyncMutation, UpdatePublishedModelQueryAsyncMutationVariables>(UpdatePublishedModelQueryAsyncDocument, options);
      }
export type UpdatePublishedModelQueryAsyncMutationHookResult = ReturnType<typeof useUpdatePublishedModelQueryAsyncMutation>;
export type UpdatePublishedModelQueryAsyncMutationResult = Apollo.MutationResult<UpdatePublishedModelQueryAsyncMutation>;
export type UpdatePublishedModelQueryAsyncMutationOptions = Apollo.BaseMutationOptions<UpdatePublishedModelQueryAsyncMutation, UpdatePublishedModelQueryAsyncMutationVariables>;
export const UpdatePublishedModelMaterializationDocument = gql`
    mutation UpdatePublishedModelMaterialization($id: String!, $materializationType: MaterializationType!, $materializationSchedule: String, $orchestrationScheduler: OrchestrationSchedulerType, $orchestrationWorkflowId: ID, $partitionExpression: String, $clusteringColumns: String) {
  updatePublishedModelMaterialization(
    input: {id: $id, materializationType: $materializationType, materializationSchedule: $materializationSchedule, orchestrationScheduler: $orchestrationScheduler, orchestrationWorkflowId: $orchestrationWorkflowId, partitionExpression: $partitionExpression, clusteringColumns: $clusteringColumns}
  ) {
    ...ModelBase
    ...ModelPublishedFragment
  }
}
    ${ModelBaseFragmentDoc}
${ModelPublishedFragmentFragmentDoc}`;
export type UpdatePublishedModelMaterializationMutationFn = Apollo.MutationFunction<UpdatePublishedModelMaterializationMutation, UpdatePublishedModelMaterializationMutationVariables>;

/**
 * __useUpdatePublishedModelMaterializationMutation__
 *
 * To run a mutation, you first call `useUpdatePublishedModelMaterializationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublishedModelMaterializationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublishedModelMaterializationMutation, { data, loading, error }] = useUpdatePublishedModelMaterializationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      materializationType: // value for 'materializationType'
 *      materializationSchedule: // value for 'materializationSchedule'
 *      orchestrationScheduler: // value for 'orchestrationScheduler'
 *      orchestrationWorkflowId: // value for 'orchestrationWorkflowId'
 *      partitionExpression: // value for 'partitionExpression'
 *      clusteringColumns: // value for 'clusteringColumns'
 *   },
 * });
 */
export function useUpdatePublishedModelMaterializationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePublishedModelMaterializationMutation, UpdatePublishedModelMaterializationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePublishedModelMaterializationMutation, UpdatePublishedModelMaterializationMutationVariables>(UpdatePublishedModelMaterializationDocument, options);
      }
export type UpdatePublishedModelMaterializationMutationHookResult = ReturnType<typeof useUpdatePublishedModelMaterializationMutation>;
export type UpdatePublishedModelMaterializationMutationResult = Apollo.MutationResult<UpdatePublishedModelMaterializationMutation>;
export type UpdatePublishedModelMaterializationMutationOptions = Apollo.BaseMutationOptions<UpdatePublishedModelMaterializationMutation, UpdatePublishedModelMaterializationMutationVariables>;
export const UpdateDraftModelNameDocument = gql`
    mutation UpdateDraftModelName($id: String!, $name: String!) {
  updateDraftModelName(input: {id: $id, name: $name}) {
    id
    name
  }
}
    `;
export type UpdateDraftModelNameMutationFn = Apollo.MutationFunction<UpdateDraftModelNameMutation, UpdateDraftModelNameMutationVariables>;

/**
 * __useUpdateDraftModelNameMutation__
 *
 * To run a mutation, you first call `useUpdateDraftModelNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftModelNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftModelNameMutation, { data, loading, error }] = useUpdateDraftModelNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateDraftModelNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftModelNameMutation, UpdateDraftModelNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftModelNameMutation, UpdateDraftModelNameMutationVariables>(UpdateDraftModelNameDocument, options);
      }
export type UpdateDraftModelNameMutationHookResult = ReturnType<typeof useUpdateDraftModelNameMutation>;
export type UpdateDraftModelNameMutationResult = Apollo.MutationResult<UpdateDraftModelNameMutation>;
export type UpdateDraftModelNameMutationOptions = Apollo.BaseMutationOptions<UpdateDraftModelNameMutation, UpdateDraftModelNameMutationVariables>;
export const UpdateUnpublishedModelQueryDocument = gql`
    mutation UpdateUnpublishedModelQuery($id: String!, $query: QueryInput!) {
  updateUnpublishedModelSqlQuery(input: {id: $id, query: $query}) {
    id
  }
}
    `;
export type UpdateUnpublishedModelQueryMutationFn = Apollo.MutationFunction<UpdateUnpublishedModelQueryMutation, UpdateUnpublishedModelQueryMutationVariables>;

/**
 * __useUpdateUnpublishedModelQueryMutation__
 *
 * To run a mutation, you first call `useUpdateUnpublishedModelQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnpublishedModelQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnpublishedModelQueryMutation, { data, loading, error }] = useUpdateUnpublishedModelQueryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useUpdateUnpublishedModelQueryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUnpublishedModelQueryMutation, UpdateUnpublishedModelQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUnpublishedModelQueryMutation, UpdateUnpublishedModelQueryMutationVariables>(UpdateUnpublishedModelQueryDocument, options);
      }
export type UpdateUnpublishedModelQueryMutationHookResult = ReturnType<typeof useUpdateUnpublishedModelQueryMutation>;
export type UpdateUnpublishedModelQueryMutationResult = Apollo.MutationResult<UpdateUnpublishedModelQueryMutation>;
export type UpdateUnpublishedModelQueryMutationOptions = Apollo.BaseMutationOptions<UpdateUnpublishedModelQueryMutation, UpdateUnpublishedModelQueryMutationVariables>;
export const UpdateModelDocumentationDocument = gql`
    mutation UpdateModelDocumentation($id: String!, $documentation: String!) {
  updateModelDocumentation(input: {id: $id, documentation: $documentation}) {
    id
    documentation
  }
}
    `;
export type UpdateModelDocumentationMutationFn = Apollo.MutationFunction<UpdateModelDocumentationMutation, UpdateModelDocumentationMutationVariables>;

/**
 * __useUpdateModelDocumentationMutation__
 *
 * To run a mutation, you first call `useUpdateModelDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModelDocumentationMutation, { data, loading, error }] = useUpdateModelDocumentationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      documentation: // value for 'documentation'
 *   },
 * });
 */
export function useUpdateModelDocumentationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModelDocumentationMutation, UpdateModelDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModelDocumentationMutation, UpdateModelDocumentationMutationVariables>(UpdateModelDocumentationDocument, options);
      }
export type UpdateModelDocumentationMutationHookResult = ReturnType<typeof useUpdateModelDocumentationMutation>;
export type UpdateModelDocumentationMutationResult = Apollo.MutationResult<UpdateModelDocumentationMutation>;
export type UpdateModelDocumentationMutationOptions = Apollo.BaseMutationOptions<UpdateModelDocumentationMutation, UpdateModelDocumentationMutationVariables>;
export const MoveModelDocument = gql`
    mutation MoveModel($id: String!, $modelFolderId: String!, $name: String!) {
  moveModel(input: {id: $id, modelFolderId: $modelFolderId, name: $name}) {
    ...ModelBase
    ...ModelPublishedFragment
  }
}
    ${ModelBaseFragmentDoc}
${ModelPublishedFragmentFragmentDoc}`;
export type MoveModelMutationFn = Apollo.MutationFunction<MoveModelMutation, MoveModelMutationVariables>;

/**
 * __useMoveModelMutation__
 *
 * To run a mutation, you first call `useMoveModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveModelMutation, { data, loading, error }] = useMoveModelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      modelFolderId: // value for 'modelFolderId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useMoveModelMutation(baseOptions?: Apollo.MutationHookOptions<MoveModelMutation, MoveModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveModelMutation, MoveModelMutationVariables>(MoveModelDocument, options);
      }
export type MoveModelMutationHookResult = ReturnType<typeof useMoveModelMutation>;
export type MoveModelMutationResult = Apollo.MutationResult<MoveModelMutation>;
export type MoveModelMutationOptions = Apollo.BaseMutationOptions<MoveModelMutation, MoveModelMutationVariables>;
export const RemoveModelDocument = gql`
    mutation RemoveModel($modelId: String!) {
  removeModel(id: $modelId) {
    id
  }
}
    `;
export type RemoveModelMutationFn = Apollo.MutationFunction<RemoveModelMutation, RemoveModelMutationVariables>;

/**
 * __useRemoveModelMutation__
 *
 * To run a mutation, you first call `useRemoveModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeModelMutation, { data, loading, error }] = useRemoveModelMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useRemoveModelMutation(baseOptions?: Apollo.MutationHookOptions<RemoveModelMutation, RemoveModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveModelMutation, RemoveModelMutationVariables>(RemoveModelDocument, options);
      }
export type RemoveModelMutationHookResult = ReturnType<typeof useRemoveModelMutation>;
export type RemoveModelMutationResult = Apollo.MutationResult<RemoveModelMutation>;
export type RemoveModelMutationOptions = Apollo.BaseMutationOptions<RemoveModelMutation, RemoveModelMutationVariables>;
export const RemoveDashboardModelsDocument = gql`
    mutation RemoveDashboardModels($dashboardId: String!) {
  removeDashboardModels(dashboardId: $dashboardId) {
    id
  }
}
    `;
export type RemoveDashboardModelsMutationFn = Apollo.MutationFunction<RemoveDashboardModelsMutation, RemoveDashboardModelsMutationVariables>;

/**
 * __useRemoveDashboardModelsMutation__
 *
 * To run a mutation, you first call `useRemoveDashboardModelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDashboardModelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDashboardModelsMutation, { data, loading, error }] = useRemoveDashboardModelsMutation({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useRemoveDashboardModelsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDashboardModelsMutation, RemoveDashboardModelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDashboardModelsMutation, RemoveDashboardModelsMutationVariables>(RemoveDashboardModelsDocument, options);
      }
export type RemoveDashboardModelsMutationHookResult = ReturnType<typeof useRemoveDashboardModelsMutation>;
export type RemoveDashboardModelsMutationResult = Apollo.MutationResult<RemoveDashboardModelsMutation>;
export type RemoveDashboardModelsMutationOptions = Apollo.BaseMutationOptions<RemoveDashboardModelsMutation, RemoveDashboardModelsMutationVariables>;
export const RematerializeNowDocument = gql`
    mutation RematerializeNow($modelId: String!) {
  rematerializeNow(modelId: $modelId) {
    id
    dwTable {
      ...MaterializedTableReferenceFragment
    }
  }
}
    ${MaterializedTableReferenceFragmentFragmentDoc}`;
export type RematerializeNowMutationFn = Apollo.MutationFunction<RematerializeNowMutation, RematerializeNowMutationVariables>;

/**
 * __useRematerializeNowMutation__
 *
 * To run a mutation, you first call `useRematerializeNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRematerializeNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rematerializeNowMutation, { data, loading, error }] = useRematerializeNowMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useRematerializeNowMutation(baseOptions?: Apollo.MutationHookOptions<RematerializeNowMutation, RematerializeNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RematerializeNowMutation, RematerializeNowMutationVariables>(RematerializeNowDocument, options);
      }
export type RematerializeNowMutationHookResult = ReturnType<typeof useRematerializeNowMutation>;
export type RematerializeNowMutationResult = Apollo.MutationResult<RematerializeNowMutation>;
export type RematerializeNowMutationOptions = Apollo.BaseMutationOptions<RematerializeNowMutation, RematerializeNowMutationVariables>;
export const UpdateModelEmojiDocument = gql`
    mutation UpdateModelEmoji($modelId: String!, $emoji: String) {
  updateModelEmoji(modelId: $modelId, emoji: $emoji) {
    id
    emoji
  }
}
    `;
export type UpdateModelEmojiMutationFn = Apollo.MutationFunction<UpdateModelEmojiMutation, UpdateModelEmojiMutationVariables>;

/**
 * __useUpdateModelEmojiMutation__
 *
 * To run a mutation, you first call `useUpdateModelEmojiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelEmojiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModelEmojiMutation, { data, loading, error }] = useUpdateModelEmojiMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      emoji: // value for 'emoji'
 *   },
 * });
 */
export function useUpdateModelEmojiMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModelEmojiMutation, UpdateModelEmojiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModelEmojiMutation, UpdateModelEmojiMutationVariables>(UpdateModelEmojiDocument, options);
      }
export type UpdateModelEmojiMutationHookResult = ReturnType<typeof useUpdateModelEmojiMutation>;
export type UpdateModelEmojiMutationResult = Apollo.MutationResult<UpdateModelEmojiMutation>;
export type UpdateModelEmojiMutationOptions = Apollo.BaseMutationOptions<UpdateModelEmojiMutation, UpdateModelEmojiMutationVariables>;
export const UpdateFolderEmojiDocument = gql`
    mutation UpdateFolderEmoji($folderId: String!, $emoji: String) {
  updateFolderEmoji(folderId: $folderId, emoji: $emoji)
}
    `;
export type UpdateFolderEmojiMutationFn = Apollo.MutationFunction<UpdateFolderEmojiMutation, UpdateFolderEmojiMutationVariables>;

/**
 * __useUpdateFolderEmojiMutation__
 *
 * To run a mutation, you first call `useUpdateFolderEmojiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFolderEmojiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFolderEmojiMutation, { data, loading, error }] = useUpdateFolderEmojiMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      emoji: // value for 'emoji'
 *   },
 * });
 */
export function useUpdateFolderEmojiMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFolderEmojiMutation, UpdateFolderEmojiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFolderEmojiMutation, UpdateFolderEmojiMutationVariables>(UpdateFolderEmojiDocument, options);
      }
export type UpdateFolderEmojiMutationHookResult = ReturnType<typeof useUpdateFolderEmojiMutation>;
export type UpdateFolderEmojiMutationResult = Apollo.MutationResult<UpdateFolderEmojiMutation>;
export type UpdateFolderEmojiMutationOptions = Apollo.BaseMutationOptions<UpdateFolderEmojiMutation, UpdateFolderEmojiMutationVariables>;
export const ModelDocument = gql`
    query Model($modelId: String!) {
  model(id: $modelId) {
    ...ModelBase
    ...ModelPublishedFragment
  }
}
    ${ModelBaseFragmentDoc}
${ModelPublishedFragmentFragmentDoc}`;

/**
 * __useModelQuery__
 *
 * To run a query within a React component, call `useModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useModelQuery(baseOptions: Apollo.QueryHookOptions<ModelQuery, ModelQueryVariables> & ({ variables: ModelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelQuery, ModelQueryVariables>(ModelDocument, options);
      }
export function useModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelQuery, ModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelQuery, ModelQueryVariables>(ModelDocument, options);
        }
export function useModelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ModelQuery, ModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModelQuery, ModelQueryVariables>(ModelDocument, options);
        }
export type ModelQueryHookResult = ReturnType<typeof useModelQuery>;
export type ModelLazyQueryHookResult = ReturnType<typeof useModelLazyQuery>;
export type ModelSuspenseQueryHookResult = ReturnType<typeof useModelSuspenseQuery>;
export type ModelQueryResult = Apollo.QueryResult<ModelQuery, ModelQueryVariables>;
export const ModelsByIdsDocument = gql`
    query ModelsByIds($modelIds: [String!]!) {
  modelsByIds(ids: $modelIds) {
    ...ModelBase
    ...ModelPublishedFragment
  }
}
    ${ModelBaseFragmentDoc}
${ModelPublishedFragmentFragmentDoc}`;

/**
 * __useModelsByIdsQuery__
 *
 * To run a query within a React component, call `useModelsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelsByIdsQuery({
 *   variables: {
 *      modelIds: // value for 'modelIds'
 *   },
 * });
 */
export function useModelsByIdsQuery(baseOptions: Apollo.QueryHookOptions<ModelsByIdsQuery, ModelsByIdsQueryVariables> & ({ variables: ModelsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelsByIdsQuery, ModelsByIdsQueryVariables>(ModelsByIdsDocument, options);
      }
export function useModelsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelsByIdsQuery, ModelsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelsByIdsQuery, ModelsByIdsQueryVariables>(ModelsByIdsDocument, options);
        }
export function useModelsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ModelsByIdsQuery, ModelsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModelsByIdsQuery, ModelsByIdsQueryVariables>(ModelsByIdsDocument, options);
        }
export type ModelsByIdsQueryHookResult = ReturnType<typeof useModelsByIdsQuery>;
export type ModelsByIdsLazyQueryHookResult = ReturnType<typeof useModelsByIdsLazyQuery>;
export type ModelsByIdsSuspenseQueryHookResult = ReturnType<typeof useModelsByIdsSuspenseQuery>;
export type ModelsByIdsQueryResult = Apollo.QueryResult<ModelsByIdsQuery, ModelsByIdsQueryVariables>;
export const PublishedModelsDocument = gql`
    query PublishedModels {
  publishedModels {
    ...ModelBase
    folder {
      id
      name
      parentId
    }
    dwSync {
      ...ModelViewReferenceFragment
    }
    dwTable {
      ...MaterializedTableReferenceFragment
    }
    localMaterializationJob {
      queryId
      status
      lastRun
      nextRun
      cronExpression
      latestErrorMessage
    }
    orchestrationWorkflow {
      id
    }
    dashboardId
    orchestrationScheduler
    materializationSchedule
    templateId
    templateItemId
  }
}
    ${ModelBaseFragmentDoc}
${ModelViewReferenceFragmentFragmentDoc}
${MaterializedTableReferenceFragmentFragmentDoc}`;

/**
 * __usePublishedModelsQuery__
 *
 * To run a query within a React component, call `usePublishedModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishedModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublishedModelsQuery(baseOptions?: Apollo.QueryHookOptions<PublishedModelsQuery, PublishedModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishedModelsQuery, PublishedModelsQueryVariables>(PublishedModelsDocument, options);
      }
export function usePublishedModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishedModelsQuery, PublishedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishedModelsQuery, PublishedModelsQueryVariables>(PublishedModelsDocument, options);
        }
export function usePublishedModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublishedModelsQuery, PublishedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublishedModelsQuery, PublishedModelsQueryVariables>(PublishedModelsDocument, options);
        }
export type PublishedModelsQueryHookResult = ReturnType<typeof usePublishedModelsQuery>;
export type PublishedModelsLazyQueryHookResult = ReturnType<typeof usePublishedModelsLazyQuery>;
export type PublishedModelsSuspenseQueryHookResult = ReturnType<typeof usePublishedModelsSuspenseQuery>;
export type PublishedModelsQueryResult = Apollo.QueryResult<PublishedModelsQuery, PublishedModelsQueryVariables>;
export const SavedDraftModelsDocument = gql`
    query SavedDraftModels {
  savedDrafts {
    ...ModelBase
  }
}
    ${ModelBaseFragmentDoc}`;

/**
 * __useSavedDraftModelsQuery__
 *
 * To run a query within a React component, call `useSavedDraftModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedDraftModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedDraftModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSavedDraftModelsQuery(baseOptions?: Apollo.QueryHookOptions<SavedDraftModelsQuery, SavedDraftModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedDraftModelsQuery, SavedDraftModelsQueryVariables>(SavedDraftModelsDocument, options);
      }
export function useSavedDraftModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedDraftModelsQuery, SavedDraftModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedDraftModelsQuery, SavedDraftModelsQueryVariables>(SavedDraftModelsDocument, options);
        }
export function useSavedDraftModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SavedDraftModelsQuery, SavedDraftModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SavedDraftModelsQuery, SavedDraftModelsQueryVariables>(SavedDraftModelsDocument, options);
        }
export type SavedDraftModelsQueryHookResult = ReturnType<typeof useSavedDraftModelsQuery>;
export type SavedDraftModelsLazyQueryHookResult = ReturnType<typeof useSavedDraftModelsLazyQuery>;
export type SavedDraftModelsSuspenseQueryHookResult = ReturnType<typeof useSavedDraftModelsSuspenseQuery>;
export type SavedDraftModelsQueryResult = Apollo.QueryResult<SavedDraftModelsQuery, SavedDraftModelsQueryVariables>;
export const MostRecentPublishedModelsDocument = gql`
    query MostRecentPublishedModels {
  mostRecentPublishedModels {
    ...ModelBase
    ...ModelPublishedFragment
  }
}
    ${ModelBaseFragmentDoc}
${ModelPublishedFragmentFragmentDoc}`;

/**
 * __useMostRecentPublishedModelsQuery__
 *
 * To run a query within a React component, call `useMostRecentPublishedModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMostRecentPublishedModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMostRecentPublishedModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMostRecentPublishedModelsQuery(baseOptions?: Apollo.QueryHookOptions<MostRecentPublishedModelsQuery, MostRecentPublishedModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MostRecentPublishedModelsQuery, MostRecentPublishedModelsQueryVariables>(MostRecentPublishedModelsDocument, options);
      }
export function useMostRecentPublishedModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MostRecentPublishedModelsQuery, MostRecentPublishedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MostRecentPublishedModelsQuery, MostRecentPublishedModelsQueryVariables>(MostRecentPublishedModelsDocument, options);
        }
export function useMostRecentPublishedModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MostRecentPublishedModelsQuery, MostRecentPublishedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MostRecentPublishedModelsQuery, MostRecentPublishedModelsQueryVariables>(MostRecentPublishedModelsDocument, options);
        }
export type MostRecentPublishedModelsQueryHookResult = ReturnType<typeof useMostRecentPublishedModelsQuery>;
export type MostRecentPublishedModelsLazyQueryHookResult = ReturnType<typeof useMostRecentPublishedModelsLazyQuery>;
export type MostRecentPublishedModelsSuspenseQueryHookResult = ReturnType<typeof useMostRecentPublishedModelsSuspenseQuery>;
export type MostRecentPublishedModelsQueryResult = Apollo.QueryResult<MostRecentPublishedModelsQuery, MostRecentPublishedModelsQueryVariables>;
export const ModelUsageSummaryDocument = gql`
    query ModelUsageSummary {
  modelUsageSummary {
    publishedModels
    draftModels
  }
}
    `;

/**
 * __useModelUsageSummaryQuery__
 *
 * To run a query within a React component, call `useModelUsageSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelUsageSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelUsageSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useModelUsageSummaryQuery(baseOptions?: Apollo.QueryHookOptions<ModelUsageSummaryQuery, ModelUsageSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelUsageSummaryQuery, ModelUsageSummaryQueryVariables>(ModelUsageSummaryDocument, options);
      }
export function useModelUsageSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelUsageSummaryQuery, ModelUsageSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelUsageSummaryQuery, ModelUsageSummaryQueryVariables>(ModelUsageSummaryDocument, options);
        }
export function useModelUsageSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ModelUsageSummaryQuery, ModelUsageSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModelUsageSummaryQuery, ModelUsageSummaryQueryVariables>(ModelUsageSummaryDocument, options);
        }
export type ModelUsageSummaryQueryHookResult = ReturnType<typeof useModelUsageSummaryQuery>;
export type ModelUsageSummaryLazyQueryHookResult = ReturnType<typeof useModelUsageSummaryLazyQuery>;
export type ModelUsageSummarySuspenseQueryHookResult = ReturnType<typeof useModelUsageSummarySuspenseQuery>;
export type ModelUsageSummaryQueryResult = Apollo.QueryResult<ModelUsageSummaryQuery, ModelUsageSummaryQueryVariables>;
export const SearchModelsDocument = gql`
    query SearchModels($query: String!, $publishedOnly: Boolean!) {
  searchModels(query: $query, publishedOnly: $publishedOnly) {
    ...ModelSearchResult
  }
}
    ${ModelSearchResultFragmentDoc}`;

/**
 * __useSearchModelsQuery__
 *
 * To run a query within a React component, call `useSearchModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchModelsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      publishedOnly: // value for 'publishedOnly'
 *   },
 * });
 */
export function useSearchModelsQuery(baseOptions: Apollo.QueryHookOptions<SearchModelsQuery, SearchModelsQueryVariables> & ({ variables: SearchModelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchModelsQuery, SearchModelsQueryVariables>(SearchModelsDocument, options);
      }
export function useSearchModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchModelsQuery, SearchModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchModelsQuery, SearchModelsQueryVariables>(SearchModelsDocument, options);
        }
export function useSearchModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchModelsQuery, SearchModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchModelsQuery, SearchModelsQueryVariables>(SearchModelsDocument, options);
        }
export type SearchModelsQueryHookResult = ReturnType<typeof useSearchModelsQuery>;
export type SearchModelsLazyQueryHookResult = ReturnType<typeof useSearchModelsLazyQuery>;
export type SearchModelsSuspenseQueryHookResult = ReturnType<typeof useSearchModelsSuspenseQuery>;
export type SearchModelsQueryResult = Apollo.QueryResult<SearchModelsQuery, SearchModelsQueryVariables>;
export const ListDeletedModelsDocument = gql`
    query ListDeletedModels {
  deletedModels {
    id
    name
    integrationId
    createdAt
    userId
    emoji
  }
}
    `;

/**
 * __useListDeletedModelsQuery__
 *
 * To run a query within a React component, call `useListDeletedModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDeletedModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDeletedModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListDeletedModelsQuery(baseOptions?: Apollo.QueryHookOptions<ListDeletedModelsQuery, ListDeletedModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDeletedModelsQuery, ListDeletedModelsQueryVariables>(ListDeletedModelsDocument, options);
      }
export function useListDeletedModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDeletedModelsQuery, ListDeletedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDeletedModelsQuery, ListDeletedModelsQueryVariables>(ListDeletedModelsDocument, options);
        }
export function useListDeletedModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListDeletedModelsQuery, ListDeletedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDeletedModelsQuery, ListDeletedModelsQueryVariables>(ListDeletedModelsDocument, options);
        }
export type ListDeletedModelsQueryHookResult = ReturnType<typeof useListDeletedModelsQuery>;
export type ListDeletedModelsLazyQueryHookResult = ReturnType<typeof useListDeletedModelsLazyQuery>;
export type ListDeletedModelsSuspenseQueryHookResult = ReturnType<typeof useListDeletedModelsSuspenseQuery>;
export type ListDeletedModelsQueryResult = Apollo.QueryResult<ListDeletedModelsQuery, ListDeletedModelsQueryVariables>;
export const HasDeletedModelsDocument = gql`
    query HasDeletedModels {
  hasDeletedModels {
    value
  }
}
    `;

/**
 * __useHasDeletedModelsQuery__
 *
 * To run a query within a React component, call `useHasDeletedModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasDeletedModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasDeletedModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasDeletedModelsQuery(baseOptions?: Apollo.QueryHookOptions<HasDeletedModelsQuery, HasDeletedModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasDeletedModelsQuery, HasDeletedModelsQueryVariables>(HasDeletedModelsDocument, options);
      }
export function useHasDeletedModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasDeletedModelsQuery, HasDeletedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasDeletedModelsQuery, HasDeletedModelsQueryVariables>(HasDeletedModelsDocument, options);
        }
export function useHasDeletedModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HasDeletedModelsQuery, HasDeletedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HasDeletedModelsQuery, HasDeletedModelsQueryVariables>(HasDeletedModelsDocument, options);
        }
export type HasDeletedModelsQueryHookResult = ReturnType<typeof useHasDeletedModelsQuery>;
export type HasDeletedModelsLazyQueryHookResult = ReturnType<typeof useHasDeletedModelsLazyQuery>;
export type HasDeletedModelsSuspenseQueryHookResult = ReturnType<typeof useHasDeletedModelsSuspenseQuery>;
export type HasDeletedModelsQueryResult = Apollo.QueryResult<HasDeletedModelsQuery, HasDeletedModelsQueryVariables>;
export const RestoreDeletedModelDocument = gql`
    mutation RestoreDeletedModel($modelId: String!) {
  restoreDeletedModel(id: $modelId) {
    ...ModelBase
    ...ModelPublishedFragment
  }
}
    ${ModelBaseFragmentDoc}
${ModelPublishedFragmentFragmentDoc}`;
export type RestoreDeletedModelMutationFn = Apollo.MutationFunction<RestoreDeletedModelMutation, RestoreDeletedModelMutationVariables>;

/**
 * __useRestoreDeletedModelMutation__
 *
 * To run a mutation, you first call `useRestoreDeletedModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDeletedModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDeletedModelMutation, { data, loading, error }] = useRestoreDeletedModelMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useRestoreDeletedModelMutation(baseOptions?: Apollo.MutationHookOptions<RestoreDeletedModelMutation, RestoreDeletedModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreDeletedModelMutation, RestoreDeletedModelMutationVariables>(RestoreDeletedModelDocument, options);
      }
export type RestoreDeletedModelMutationHookResult = ReturnType<typeof useRestoreDeletedModelMutation>;
export type RestoreDeletedModelMutationResult = Apollo.MutationResult<RestoreDeletedModelMutation>;
export type RestoreDeletedModelMutationOptions = Apollo.BaseMutationOptions<RestoreDeletedModelMutation, RestoreDeletedModelMutationVariables>;
export const UpdateModelTableReferencesDocument = gql`
    query UpdateModelTableReferences {
  publishedModels {
    dwTable {
      ...MaterializedTableReferenceFragment
    }
  }
}
    ${MaterializedTableReferenceFragmentFragmentDoc}`;

/**
 * __useUpdateModelTableReferencesQuery__
 *
 * To run a query within a React component, call `useUpdateModelTableReferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelTableReferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateModelTableReferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpdateModelTableReferencesQuery(baseOptions?: Apollo.QueryHookOptions<UpdateModelTableReferencesQuery, UpdateModelTableReferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateModelTableReferencesQuery, UpdateModelTableReferencesQueryVariables>(UpdateModelTableReferencesDocument, options);
      }
export function useUpdateModelTableReferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateModelTableReferencesQuery, UpdateModelTableReferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateModelTableReferencesQuery, UpdateModelTableReferencesQueryVariables>(UpdateModelTableReferencesDocument, options);
        }
export function useUpdateModelTableReferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpdateModelTableReferencesQuery, UpdateModelTableReferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpdateModelTableReferencesQuery, UpdateModelTableReferencesQueryVariables>(UpdateModelTableReferencesDocument, options);
        }
export type UpdateModelTableReferencesQueryHookResult = ReturnType<typeof useUpdateModelTableReferencesQuery>;
export type UpdateModelTableReferencesLazyQueryHookResult = ReturnType<typeof useUpdateModelTableReferencesLazyQuery>;
export type UpdateModelTableReferencesSuspenseQueryHookResult = ReturnType<typeof useUpdateModelTableReferencesSuspenseQuery>;
export type UpdateModelTableReferencesQueryResult = Apollo.QueryResult<UpdateModelTableReferencesQuery, UpdateModelTableReferencesQueryVariables>;
export const GetLocalMaterializationJobDocument = gql`
    query getLocalMaterializationJob($modelId: String!) {
  model(id: $modelId) {
    id
    localMaterializationJob {
      modelId
      queryId
      status
      lastRun
      nextRun
      startedAt
      cronExpression
      latestErrorMessage
    }
  }
}
    `;

/**
 * __useGetLocalMaterializationJobQuery__
 *
 * To run a query within a React component, call `useGetLocalMaterializationJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalMaterializationJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalMaterializationJobQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetLocalMaterializationJobQuery(baseOptions: Apollo.QueryHookOptions<GetLocalMaterializationJobQuery, GetLocalMaterializationJobQueryVariables> & ({ variables: GetLocalMaterializationJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocalMaterializationJobQuery, GetLocalMaterializationJobQueryVariables>(GetLocalMaterializationJobDocument, options);
      }
export function useGetLocalMaterializationJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocalMaterializationJobQuery, GetLocalMaterializationJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocalMaterializationJobQuery, GetLocalMaterializationJobQueryVariables>(GetLocalMaterializationJobDocument, options);
        }
export function useGetLocalMaterializationJobSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocalMaterializationJobQuery, GetLocalMaterializationJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocalMaterializationJobQuery, GetLocalMaterializationJobQueryVariables>(GetLocalMaterializationJobDocument, options);
        }
export type GetLocalMaterializationJobQueryHookResult = ReturnType<typeof useGetLocalMaterializationJobQuery>;
export type GetLocalMaterializationJobLazyQueryHookResult = ReturnType<typeof useGetLocalMaterializationJobLazyQuery>;
export type GetLocalMaterializationJobSuspenseQueryHookResult = ReturnType<typeof useGetLocalMaterializationJobSuspenseQuery>;
export type GetLocalMaterializationJobQueryResult = Apollo.QueryResult<GetLocalMaterializationJobQuery, GetLocalMaterializationJobQueryVariables>;
export const SqlQueryDocument = gql`
    query SqlQuery($modelId: String!) {
  model(id: $modelId) {
    id
    publishedQuery {
      ...PublishedQueryWithSQLFragment
    }
  }
}
    ${PublishedQueryWithSqlFragmentFragmentDoc}`;

/**
 * __useSqlQueryQuery__
 *
 * To run a query within a React component, call `useSqlQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSqlQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSqlQueryQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useSqlQueryQuery(baseOptions: Apollo.QueryHookOptions<SqlQueryQuery, SqlQueryQueryVariables> & ({ variables: SqlQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SqlQueryQuery, SqlQueryQueryVariables>(SqlQueryDocument, options);
      }
export function useSqlQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SqlQueryQuery, SqlQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SqlQueryQuery, SqlQueryQueryVariables>(SqlQueryDocument, options);
        }
export function useSqlQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SqlQueryQuery, SqlQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SqlQueryQuery, SqlQueryQueryVariables>(SqlQueryDocument, options);
        }
export type SqlQueryQueryHookResult = ReturnType<typeof useSqlQueryQuery>;
export type SqlQueryLazyQueryHookResult = ReturnType<typeof useSqlQueryLazyQuery>;
export type SqlQuerySuspenseQueryHookResult = ReturnType<typeof useSqlQuerySuspenseQuery>;
export type SqlQueryQueryResult = Apollo.QueryResult<SqlQueryQuery, SqlQueryQueryVariables>;
export const ModelDocumentationDocument = gql`
    query ModelDocumentation($modelId: String!) {
  model(id: $modelId) {
    documentation
  }
}
    `;

/**
 * __useModelDocumentationQuery__
 *
 * To run a query within a React component, call `useModelDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelDocumentationQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useModelDocumentationQuery(baseOptions: Apollo.QueryHookOptions<ModelDocumentationQuery, ModelDocumentationQueryVariables> & ({ variables: ModelDocumentationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelDocumentationQuery, ModelDocumentationQueryVariables>(ModelDocumentationDocument, options);
      }
export function useModelDocumentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelDocumentationQuery, ModelDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelDocumentationQuery, ModelDocumentationQueryVariables>(ModelDocumentationDocument, options);
        }
export function useModelDocumentationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ModelDocumentationQuery, ModelDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModelDocumentationQuery, ModelDocumentationQueryVariables>(ModelDocumentationDocument, options);
        }
export type ModelDocumentationQueryHookResult = ReturnType<typeof useModelDocumentationQuery>;
export type ModelDocumentationLazyQueryHookResult = ReturnType<typeof useModelDocumentationLazyQuery>;
export type ModelDocumentationSuspenseQueryHookResult = ReturnType<typeof useModelDocumentationSuspenseQuery>;
export type ModelDocumentationQueryResult = Apollo.QueryResult<ModelDocumentationQuery, ModelDocumentationQueryVariables>;
export const FindQueryHistoryDocument = gql`
    query FindQueryHistory($modelId: String!) {
  model(id: $modelId) {
    id
    sqlQueries {
      id
      data
      weldSql
      dependencies {
        dwItemId
        type
        weldTag
      }
      createdAt
      user {
        firstName
        lastName
        email
      }
    }
  }
}
    `;

/**
 * __useFindQueryHistoryQuery__
 *
 * To run a query within a React component, call `useFindQueryHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindQueryHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindQueryHistoryQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useFindQueryHistoryQuery(baseOptions: Apollo.QueryHookOptions<FindQueryHistoryQuery, FindQueryHistoryQueryVariables> & ({ variables: FindQueryHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindQueryHistoryQuery, FindQueryHistoryQueryVariables>(FindQueryHistoryDocument, options);
      }
export function useFindQueryHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindQueryHistoryQuery, FindQueryHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindQueryHistoryQuery, FindQueryHistoryQueryVariables>(FindQueryHistoryDocument, options);
        }
export function useFindQueryHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindQueryHistoryQuery, FindQueryHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindQueryHistoryQuery, FindQueryHistoryQueryVariables>(FindQueryHistoryDocument, options);
        }
export type FindQueryHistoryQueryHookResult = ReturnType<typeof useFindQueryHistoryQuery>;
export type FindQueryHistoryLazyQueryHookResult = ReturnType<typeof useFindQueryHistoryLazyQuery>;
export type FindQueryHistorySuspenseQueryHookResult = ReturnType<typeof useFindQueryHistorySuspenseQuery>;
export type FindQueryHistoryQueryResult = Apollo.QueryResult<FindQueryHistoryQuery, FindQueryHistoryQueryVariables>;
export const GetDwDirectoryDocument = gql`
    query getDWDirectory($input: GetDWDirectoryInput!) {
  getDWDirectory(input: $input) {
    typename
    children
    hasNext
  }
}
    `;

/**
 * __useGetDwDirectoryQuery__
 *
 * To run a query within a React component, call `useGetDwDirectoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDwDirectoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDwDirectoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDwDirectoryQuery(baseOptions: Apollo.QueryHookOptions<GetDwDirectoryQuery, GetDwDirectoryQueryVariables> & ({ variables: GetDwDirectoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDwDirectoryQuery, GetDwDirectoryQueryVariables>(GetDwDirectoryDocument, options);
      }
export function useGetDwDirectoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDwDirectoryQuery, GetDwDirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDwDirectoryQuery, GetDwDirectoryQueryVariables>(GetDwDirectoryDocument, options);
        }
export function useGetDwDirectorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDwDirectoryQuery, GetDwDirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDwDirectoryQuery, GetDwDirectoryQueryVariables>(GetDwDirectoryDocument, options);
        }
export type GetDwDirectoryQueryHookResult = ReturnType<typeof useGetDwDirectoryQuery>;
export type GetDwDirectoryLazyQueryHookResult = ReturnType<typeof useGetDwDirectoryLazyQuery>;
export type GetDwDirectorySuspenseQueryHookResult = ReturnType<typeof useGetDwDirectorySuspenseQuery>;
export type GetDwDirectoryQueryResult = Apollo.QueryResult<GetDwDirectoryQuery, GetDwDirectoryQueryVariables>;
export const GetDwDirectoryItemsDocument = gql`
    query getDWDirectoryItems($input: GetDWDirectoryItemsInput!) {
  getDWDirectoryItems(input: $input) {
    path
  }
}
    `;

/**
 * __useGetDwDirectoryItemsQuery__
 *
 * To run a query within a React component, call `useGetDwDirectoryItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDwDirectoryItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDwDirectoryItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDwDirectoryItemsQuery(baseOptions: Apollo.QueryHookOptions<GetDwDirectoryItemsQuery, GetDwDirectoryItemsQueryVariables> & ({ variables: GetDwDirectoryItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDwDirectoryItemsQuery, GetDwDirectoryItemsQueryVariables>(GetDwDirectoryItemsDocument, options);
      }
export function useGetDwDirectoryItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDwDirectoryItemsQuery, GetDwDirectoryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDwDirectoryItemsQuery, GetDwDirectoryItemsQueryVariables>(GetDwDirectoryItemsDocument, options);
        }
export function useGetDwDirectoryItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDwDirectoryItemsQuery, GetDwDirectoryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDwDirectoryItemsQuery, GetDwDirectoryItemsQueryVariables>(GetDwDirectoryItemsDocument, options);
        }
export type GetDwDirectoryItemsQueryHookResult = ReturnType<typeof useGetDwDirectoryItemsQuery>;
export type GetDwDirectoryItemsLazyQueryHookResult = ReturnType<typeof useGetDwDirectoryItemsLazyQuery>;
export type GetDwDirectoryItemsSuspenseQueryHookResult = ReturnType<typeof useGetDwDirectoryItemsSuspenseQuery>;
export type GetDwDirectoryItemsQueryResult = Apollo.QueryResult<GetDwDirectoryItemsQuery, GetDwDirectoryItemsQueryVariables>;
export const ImportDwDirectoryDocument = gql`
    mutation importDWDirectory($input: ImportDWDirectoryInput!) {
  importDWDirectory(input: $input) {
    path
    error
    viewId
  }
}
    `;
export type ImportDwDirectoryMutationFn = Apollo.MutationFunction<ImportDwDirectoryMutation, ImportDwDirectoryMutationVariables>;

/**
 * __useImportDwDirectoryMutation__
 *
 * To run a mutation, you first call `useImportDwDirectoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportDwDirectoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importDwDirectoryMutation, { data, loading, error }] = useImportDwDirectoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportDwDirectoryMutation(baseOptions?: Apollo.MutationHookOptions<ImportDwDirectoryMutation, ImportDwDirectoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportDwDirectoryMutation, ImportDwDirectoryMutationVariables>(ImportDwDirectoryDocument, options);
      }
export type ImportDwDirectoryMutationHookResult = ReturnType<typeof useImportDwDirectoryMutation>;
export type ImportDwDirectoryMutationResult = Apollo.MutationResult<ImportDwDirectoryMutation>;
export type ImportDwDirectoryMutationOptions = Apollo.BaseMutationOptions<ImportDwDirectoryMutation, ImportDwDirectoryMutationVariables>;
export const ListModelFoldersDocument = gql`
    query listModelFolders {
  listModelFolders {
    id
    name
    emoji
    type
    parentId
    DWName
  }
}
    `;

/**
 * __useListModelFoldersQuery__
 *
 * To run a query within a React component, call `useListModelFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListModelFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListModelFoldersQuery({
 *   variables: {
 *   },
 * });
 */
export function useListModelFoldersQuery(baseOptions?: Apollo.QueryHookOptions<ListModelFoldersQuery, ListModelFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListModelFoldersQuery, ListModelFoldersQueryVariables>(ListModelFoldersDocument, options);
      }
export function useListModelFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListModelFoldersQuery, ListModelFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListModelFoldersQuery, ListModelFoldersQueryVariables>(ListModelFoldersDocument, options);
        }
export function useListModelFoldersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListModelFoldersQuery, ListModelFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListModelFoldersQuery, ListModelFoldersQueryVariables>(ListModelFoldersDocument, options);
        }
export type ListModelFoldersQueryHookResult = ReturnType<typeof useListModelFoldersQuery>;
export type ListModelFoldersLazyQueryHookResult = ReturnType<typeof useListModelFoldersLazyQuery>;
export type ListModelFoldersSuspenseQueryHookResult = ReturnType<typeof useListModelFoldersSuspenseQuery>;
export type ListModelFoldersQueryResult = Apollo.QueryResult<ListModelFoldersQuery, ListModelFoldersQueryVariables>;
export const VerifyUnpublishedChangesDocument = gql`
    query VerifyUnpublishedChanges($modelId: String!) {
  verifyUnpublishedChanges(modelId: $modelId) {
    hasUnpublishedChanges
  }
}
    `;

/**
 * __useVerifyUnpublishedChangesQuery__
 *
 * To run a query within a React component, call `useVerifyUnpublishedChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyUnpublishedChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyUnpublishedChangesQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useVerifyUnpublishedChangesQuery(baseOptions: Apollo.QueryHookOptions<VerifyUnpublishedChangesQuery, VerifyUnpublishedChangesQueryVariables> & ({ variables: VerifyUnpublishedChangesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifyUnpublishedChangesQuery, VerifyUnpublishedChangesQueryVariables>(VerifyUnpublishedChangesDocument, options);
      }
export function useVerifyUnpublishedChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyUnpublishedChangesQuery, VerifyUnpublishedChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifyUnpublishedChangesQuery, VerifyUnpublishedChangesQueryVariables>(VerifyUnpublishedChangesDocument, options);
        }
export function useVerifyUnpublishedChangesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VerifyUnpublishedChangesQuery, VerifyUnpublishedChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerifyUnpublishedChangesQuery, VerifyUnpublishedChangesQueryVariables>(VerifyUnpublishedChangesDocument, options);
        }
export type VerifyUnpublishedChangesQueryHookResult = ReturnType<typeof useVerifyUnpublishedChangesQuery>;
export type VerifyUnpublishedChangesLazyQueryHookResult = ReturnType<typeof useVerifyUnpublishedChangesLazyQuery>;
export type VerifyUnpublishedChangesSuspenseQueryHookResult = ReturnType<typeof useVerifyUnpublishedChangesSuspenseQuery>;
export type VerifyUnpublishedChangesQueryResult = Apollo.QueryResult<VerifyUnpublishedChangesQuery, VerifyUnpublishedChangesQueryVariables>;
export const CreateModelFolderDocument = gql`
    mutation createModelFolder($input: CreateFolderInput!) {
  createModelFolder(createFolderInput: $input) {
    name
    type
    DWName
    id
  }
}
    `;
export type CreateModelFolderMutationFn = Apollo.MutationFunction<CreateModelFolderMutation, CreateModelFolderMutationVariables>;

/**
 * __useCreateModelFolderMutation__
 *
 * To run a mutation, you first call `useCreateModelFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModelFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModelFolderMutation, { data, loading, error }] = useCreateModelFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateModelFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateModelFolderMutation, CreateModelFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModelFolderMutation, CreateModelFolderMutationVariables>(CreateModelFolderDocument, options);
      }
export type CreateModelFolderMutationHookResult = ReturnType<typeof useCreateModelFolderMutation>;
export type CreateModelFolderMutationResult = Apollo.MutationResult<CreateModelFolderMutation>;
export type CreateModelFolderMutationOptions = Apollo.BaseMutationOptions<CreateModelFolderMutation, CreateModelFolderMutationVariables>;
export const DeleteModelFolderDocument = gql`
    mutation deleteModelFolder($folderId: String!) {
  deleteModelFolder(folderId: $folderId) {
    name
    type
  }
}
    `;
export type DeleteModelFolderMutationFn = Apollo.MutationFunction<DeleteModelFolderMutation, DeleteModelFolderMutationVariables>;

/**
 * __useDeleteModelFolderMutation__
 *
 * To run a mutation, you first call `useDeleteModelFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModelFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModelFolderMutation, { data, loading, error }] = useDeleteModelFolderMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useDeleteModelFolderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteModelFolderMutation, DeleteModelFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteModelFolderMutation, DeleteModelFolderMutationVariables>(DeleteModelFolderDocument, options);
      }
export type DeleteModelFolderMutationHookResult = ReturnType<typeof useDeleteModelFolderMutation>;
export type DeleteModelFolderMutationResult = Apollo.MutationResult<DeleteModelFolderMutation>;
export type DeleteModelFolderMutationOptions = Apollo.BaseMutationOptions<DeleteModelFolderMutation, DeleteModelFolderMutationVariables>;
export const DeleteFolderWithContentDocument = gql`
    mutation deleteFolderWithContent($folderId: String!) {
  deleteFolderWithContent(folderId: $folderId)
}
    `;
export type DeleteFolderWithContentMutationFn = Apollo.MutationFunction<DeleteFolderWithContentMutation, DeleteFolderWithContentMutationVariables>;

/**
 * __useDeleteFolderWithContentMutation__
 *
 * To run a mutation, you first call `useDeleteFolderWithContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderWithContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFolderWithContentMutation, { data, loading, error }] = useDeleteFolderWithContentMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useDeleteFolderWithContentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFolderWithContentMutation, DeleteFolderWithContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFolderWithContentMutation, DeleteFolderWithContentMutationVariables>(DeleteFolderWithContentDocument, options);
      }
export type DeleteFolderWithContentMutationHookResult = ReturnType<typeof useDeleteFolderWithContentMutation>;
export type DeleteFolderWithContentMutationResult = Apollo.MutationResult<DeleteFolderWithContentMutation>;
export type DeleteFolderWithContentMutationOptions = Apollo.BaseMutationOptions<DeleteFolderWithContentMutation, DeleteFolderWithContentMutationVariables>;
export const UnpublishModelDocument = gql`
    mutation UnpublishModel($modelId: String!) {
  unpublishModel(id: $modelId) {
    ...ModelBase
    ...ModelPublishedFragment
  }
}
    ${ModelBaseFragmentDoc}
${ModelPublishedFragmentFragmentDoc}`;
export type UnpublishModelMutationFn = Apollo.MutationFunction<UnpublishModelMutation, UnpublishModelMutationVariables>;

/**
 * __useUnpublishModelMutation__
 *
 * To run a mutation, you first call `useUnpublishModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishModelMutation, { data, loading, error }] = useUnpublishModelMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useUnpublishModelMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishModelMutation, UnpublishModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishModelMutation, UnpublishModelMutationVariables>(UnpublishModelDocument, options);
      }
export type UnpublishModelMutationHookResult = ReturnType<typeof useUnpublishModelMutation>;
export type UnpublishModelMutationResult = Apollo.MutationResult<UnpublishModelMutation>;
export type UnpublishModelMutationOptions = Apollo.BaseMutationOptions<UnpublishModelMutation, UnpublishModelMutationVariables>;
export const DeleteRawViewDocument = gql`
    mutation deleteRawView($viewId: String!) {
  deleteRawView(viewId: $viewId)
}
    `;
export type DeleteRawViewMutationFn = Apollo.MutationFunction<DeleteRawViewMutation, DeleteRawViewMutationVariables>;

/**
 * __useDeleteRawViewMutation__
 *
 * To run a mutation, you first call `useDeleteRawViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRawViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRawViewMutation, { data, loading, error }] = useDeleteRawViewMutation({
 *   variables: {
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useDeleteRawViewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRawViewMutation, DeleteRawViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRawViewMutation, DeleteRawViewMutationVariables>(DeleteRawViewDocument, options);
      }
export type DeleteRawViewMutationHookResult = ReturnType<typeof useDeleteRawViewMutation>;
export type DeleteRawViewMutationResult = Apollo.MutationResult<DeleteRawViewMutation>;
export type DeleteRawViewMutationOptions = Apollo.BaseMutationOptions<DeleteRawViewMutation, DeleteRawViewMutationVariables>;
export const QueryModelDocument = gql`
    query QueryModel($modelId: String!) {
  queryModel(modelId: $modelId) {
    id
    response
    dwSql
  }
}
    `;

/**
 * __useQueryModelQuery__
 *
 * To run a query within a React component, call `useQueryModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryModelQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useQueryModelQuery(baseOptions: Apollo.QueryHookOptions<QueryModelQuery, QueryModelQueryVariables> & ({ variables: QueryModelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryModelQuery, QueryModelQueryVariables>(QueryModelDocument, options);
      }
export function useQueryModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryModelQuery, QueryModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryModelQuery, QueryModelQueryVariables>(QueryModelDocument, options);
        }
export function useQueryModelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryModelQuery, QueryModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryModelQuery, QueryModelQueryVariables>(QueryModelDocument, options);
        }
export type QueryModelQueryHookResult = ReturnType<typeof useQueryModelQuery>;
export type QueryModelLazyQueryHookResult = ReturnType<typeof useQueryModelLazyQuery>;
export type QueryModelSuspenseQueryHookResult = ReturnType<typeof useQueryModelSuspenseQuery>;
export type QueryModelQueryResult = Apollo.QueryResult<QueryModelQuery, QueryModelQueryVariables>;
export const OrchestratedModelsDocument = gql`
    query OrchestratedModels {
  publishedModels {
    ...ModelBase
    dashboardId
    orchestrationScheduler
    materializationSchedule
    templateId
    templateItemId
    orchestrationWorkflow {
      id
    }
    publishedQuery {
      ...PublishedQueryWithSQLFragment
    }
  }
}
    ${ModelBaseFragmentDoc}
${PublishedQueryWithSqlFragmentFragmentDoc}`;

/**
 * __useOrchestratedModelsQuery__
 *
 * To run a query within a React component, call `useOrchestratedModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrchestratedModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrchestratedModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrchestratedModelsQuery(baseOptions?: Apollo.QueryHookOptions<OrchestratedModelsQuery, OrchestratedModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrchestratedModelsQuery, OrchestratedModelsQueryVariables>(OrchestratedModelsDocument, options);
      }
export function useOrchestratedModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrchestratedModelsQuery, OrchestratedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrchestratedModelsQuery, OrchestratedModelsQueryVariables>(OrchestratedModelsDocument, options);
        }
export function useOrchestratedModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrchestratedModelsQuery, OrchestratedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrchestratedModelsQuery, OrchestratedModelsQueryVariables>(OrchestratedModelsDocument, options);
        }
export type OrchestratedModelsQueryHookResult = ReturnType<typeof useOrchestratedModelsQuery>;
export type OrchestratedModelsLazyQueryHookResult = ReturnType<typeof useOrchestratedModelsLazyQuery>;
export type OrchestratedModelsSuspenseQueryHookResult = ReturnType<typeof useOrchestratedModelsSuspenseQuery>;
export type OrchestratedModelsQueryResult = Apollo.QueryResult<OrchestratedModelsQuery, OrchestratedModelsQueryVariables>;
export const MyRecentlyEditedModelsDocument = gql`
    query MyRecentlyEditedModels($limit: Int) {
  myRecentlyEditedModels(limit: $limit) {
    editedAt
    model {
      ...ModelBase
      ...ModelPublishedFragment
    }
  }
}
    ${ModelBaseFragmentDoc}
${ModelPublishedFragmentFragmentDoc}`;

/**
 * __useMyRecentlyEditedModelsQuery__
 *
 * To run a query within a React component, call `useMyRecentlyEditedModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyRecentlyEditedModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyRecentlyEditedModelsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMyRecentlyEditedModelsQuery(baseOptions?: Apollo.QueryHookOptions<MyRecentlyEditedModelsQuery, MyRecentlyEditedModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyRecentlyEditedModelsQuery, MyRecentlyEditedModelsQueryVariables>(MyRecentlyEditedModelsDocument, options);
      }
export function useMyRecentlyEditedModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyRecentlyEditedModelsQuery, MyRecentlyEditedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyRecentlyEditedModelsQuery, MyRecentlyEditedModelsQueryVariables>(MyRecentlyEditedModelsDocument, options);
        }
export function useMyRecentlyEditedModelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyRecentlyEditedModelsQuery, MyRecentlyEditedModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyRecentlyEditedModelsQuery, MyRecentlyEditedModelsQueryVariables>(MyRecentlyEditedModelsDocument, options);
        }
export type MyRecentlyEditedModelsQueryHookResult = ReturnType<typeof useMyRecentlyEditedModelsQuery>;
export type MyRecentlyEditedModelsLazyQueryHookResult = ReturnType<typeof useMyRecentlyEditedModelsLazyQuery>;
export type MyRecentlyEditedModelsSuspenseQueryHookResult = ReturnType<typeof useMyRecentlyEditedModelsSuspenseQuery>;
export type MyRecentlyEditedModelsQueryResult = Apollo.QueryResult<MyRecentlyEditedModelsQuery, MyRecentlyEditedModelsQueryVariables>;
export const ListObjectTypesDocument = gql`
    query ListObjectTypes($connectionId: String!) {
  objectTypes(connectionId: $connectionId) {
    ...ObjectType
  }
}
    ${ObjectTypeFragmentDoc}`;

/**
 * __useListObjectTypesQuery__
 *
 * To run a query within a React component, call `useListObjectTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListObjectTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListObjectTypesQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useListObjectTypesQuery(baseOptions: Apollo.QueryHookOptions<ListObjectTypesQuery, ListObjectTypesQueryVariables> & ({ variables: ListObjectTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListObjectTypesQuery, ListObjectTypesQueryVariables>(ListObjectTypesDocument, options);
      }
export function useListObjectTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListObjectTypesQuery, ListObjectTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListObjectTypesQuery, ListObjectTypesQueryVariables>(ListObjectTypesDocument, options);
        }
export function useListObjectTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListObjectTypesQuery, ListObjectTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListObjectTypesQuery, ListObjectTypesQueryVariables>(ListObjectTypesDocument, options);
        }
export type ListObjectTypesQueryHookResult = ReturnType<typeof useListObjectTypesQuery>;
export type ListObjectTypesLazyQueryHookResult = ReturnType<typeof useListObjectTypesLazyQuery>;
export type ListObjectTypesSuspenseQueryHookResult = ReturnType<typeof useListObjectTypesSuspenseQuery>;
export type ListObjectTypesQueryResult = Apollo.QueryResult<ListObjectTypesQuery, ListObjectTypesQueryVariables>;
export const UnresolvedIncidentsDocument = gql`
    query UnresolvedIncidents {
  unresolvedIncidents {
    ...Incident
  }
}
    ${IncidentFragmentDoc}`;

/**
 * __useUnresolvedIncidentsQuery__
 *
 * To run a query within a React component, call `useUnresolvedIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnresolvedIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnresolvedIncidentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnresolvedIncidentsQuery(baseOptions?: Apollo.QueryHookOptions<UnresolvedIncidentsQuery, UnresolvedIncidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnresolvedIncidentsQuery, UnresolvedIncidentsQueryVariables>(UnresolvedIncidentsDocument, options);
      }
export function useUnresolvedIncidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnresolvedIncidentsQuery, UnresolvedIncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnresolvedIncidentsQuery, UnresolvedIncidentsQueryVariables>(UnresolvedIncidentsDocument, options);
        }
export function useUnresolvedIncidentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnresolvedIncidentsQuery, UnresolvedIncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnresolvedIncidentsQuery, UnresolvedIncidentsQueryVariables>(UnresolvedIncidentsDocument, options);
        }
export type UnresolvedIncidentsQueryHookResult = ReturnType<typeof useUnresolvedIncidentsQuery>;
export type UnresolvedIncidentsLazyQueryHookResult = ReturnType<typeof useUnresolvedIncidentsLazyQuery>;
export type UnresolvedIncidentsSuspenseQueryHookResult = ReturnType<typeof useUnresolvedIncidentsSuspenseQuery>;
export type UnresolvedIncidentsQueryResult = Apollo.QueryResult<UnresolvedIncidentsQuery, UnresolvedIncidentsQueryVariables>;
export const ScheduledIncidentsDocument = gql`
    query ScheduledIncidents {
  scheduledIncidents {
    ...Incident
  }
}
    ${IncidentFragmentDoc}`;

/**
 * __useScheduledIncidentsQuery__
 *
 * To run a query within a React component, call `useScheduledIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledIncidentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useScheduledIncidentsQuery(baseOptions?: Apollo.QueryHookOptions<ScheduledIncidentsQuery, ScheduledIncidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledIncidentsQuery, ScheduledIncidentsQueryVariables>(ScheduledIncidentsDocument, options);
      }
export function useScheduledIncidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledIncidentsQuery, ScheduledIncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledIncidentsQuery, ScheduledIncidentsQueryVariables>(ScheduledIncidentsDocument, options);
        }
export function useScheduledIncidentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduledIncidentsQuery, ScheduledIncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduledIncidentsQuery, ScheduledIncidentsQueryVariables>(ScheduledIncidentsDocument, options);
        }
export type ScheduledIncidentsQueryHookResult = ReturnType<typeof useScheduledIncidentsQuery>;
export type ScheduledIncidentsLazyQueryHookResult = ReturnType<typeof useScheduledIncidentsLazyQuery>;
export type ScheduledIncidentsSuspenseQueryHookResult = ReturnType<typeof useScheduledIncidentsSuspenseQuery>;
export type ScheduledIncidentsQueryResult = Apollo.QueryResult<ScheduledIncidentsQuery, ScheduledIncidentsQueryVariables>;
export const FindAvailableOperationsDocument = gql`
    query FindAvailableOperations($connectionId: String!, $objectType: String!) {
  findAllAvailableOperations(connectionId: $connectionId, objectType: $objectType) {
    ...OperationModeOption
  }
}
    ${OperationModeOptionFragmentDoc}`;

/**
 * __useFindAvailableOperationsQuery__
 *
 * To run a query within a React component, call `useFindAvailableOperationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAvailableOperationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAvailableOperationsQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      objectType: // value for 'objectType'
 *   },
 * });
 */
export function useFindAvailableOperationsQuery(baseOptions: Apollo.QueryHookOptions<FindAvailableOperationsQuery, FindAvailableOperationsQueryVariables> & ({ variables: FindAvailableOperationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAvailableOperationsQuery, FindAvailableOperationsQueryVariables>(FindAvailableOperationsDocument, options);
      }
export function useFindAvailableOperationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAvailableOperationsQuery, FindAvailableOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAvailableOperationsQuery, FindAvailableOperationsQueryVariables>(FindAvailableOperationsDocument, options);
        }
export function useFindAvailableOperationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindAvailableOperationsQuery, FindAvailableOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAvailableOperationsQuery, FindAvailableOperationsQueryVariables>(FindAvailableOperationsDocument, options);
        }
export type FindAvailableOperationsQueryHookResult = ReturnType<typeof useFindAvailableOperationsQuery>;
export type FindAvailableOperationsLazyQueryHookResult = ReturnType<typeof useFindAvailableOperationsLazyQuery>;
export type FindAvailableOperationsSuspenseQueryHookResult = ReturnType<typeof useFindAvailableOperationsSuspenseQuery>;
export type FindAvailableOperationsQueryResult = Apollo.QueryResult<FindAvailableOperationsQuery, FindAvailableOperationsQueryVariables>;
export const CreateWorkflowDocument = gql`
    mutation CreateWorkflow($cronExpression: String!, $name: String!, $description: String) {
  createWorkflow(
    cronExpression: $cronExpression
    name: $name
    description: $description
  ) {
    ...OrchestrationWorkflow
  }
}
    ${OrchestrationWorkflowFragmentDoc}`;
export type CreateWorkflowMutationFn = Apollo.MutationFunction<CreateWorkflowMutation, CreateWorkflowMutationVariables>;

/**
 * __useCreateWorkflowMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowMutation, { data, loading, error }] = useCreateWorkflowMutation({
 *   variables: {
 *      cronExpression: // value for 'cronExpression'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkflowMutation, CreateWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkflowMutation, CreateWorkflowMutationVariables>(CreateWorkflowDocument, options);
      }
export type CreateWorkflowMutationHookResult = ReturnType<typeof useCreateWorkflowMutation>;
export type CreateWorkflowMutationResult = Apollo.MutationResult<CreateWorkflowMutation>;
export type CreateWorkflowMutationOptions = Apollo.BaseMutationOptions<CreateWorkflowMutation, CreateWorkflowMutationVariables>;
export const EditWorkflowDocument = gql`
    mutation EditWorkflow($cronExpression: String, $name: String, $description: String, $workflowId: ID!) {
  editWorkflow(
    cronExpression: $cronExpression
    name: $name
    description: $description
    workflowId: $workflowId
  ) {
    ...OrchestrationWorkflow
  }
}
    ${OrchestrationWorkflowFragmentDoc}`;
export type EditWorkflowMutationFn = Apollo.MutationFunction<EditWorkflowMutation, EditWorkflowMutationVariables>;

/**
 * __useEditWorkflowMutation__
 *
 * To run a mutation, you first call `useEditWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWorkflowMutation, { data, loading, error }] = useEditWorkflowMutation({
 *   variables: {
 *      cronExpression: // value for 'cronExpression'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useEditWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<EditWorkflowMutation, EditWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWorkflowMutation, EditWorkflowMutationVariables>(EditWorkflowDocument, options);
      }
export type EditWorkflowMutationHookResult = ReturnType<typeof useEditWorkflowMutation>;
export type EditWorkflowMutationResult = Apollo.MutationResult<EditWorkflowMutation>;
export type EditWorkflowMutationOptions = Apollo.BaseMutationOptions<EditWorkflowMutation, EditWorkflowMutationVariables>;
export const DeleteWorkflowDocument = gql`
    mutation DeleteWorkflow($workflowId: ID!, $cronSchedule: String!) {
  deleteWorkflow(workflowId: $workflowId, cronSchedule: $cronSchedule)
}
    `;
export type DeleteWorkflowMutationFn = Apollo.MutationFunction<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>;

/**
 * __useDeleteWorkflowMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowMutation, { data, loading, error }] = useDeleteWorkflowMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      cronSchedule: // value for 'cronSchedule'
 *   },
 * });
 */
export function useDeleteWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>(DeleteWorkflowDocument, options);
      }
export type DeleteWorkflowMutationHookResult = ReturnType<typeof useDeleteWorkflowMutation>;
export type DeleteWorkflowMutationResult = Apollo.MutationResult<DeleteWorkflowMutation>;
export type DeleteWorkflowMutationOptions = Apollo.BaseMutationOptions<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>;
export const OrchestrationWorkflowHistoryDocument = gql`
    query OrchestrationWorkflowHistory($workflowId: ID!) {
  orchestrationWorkflow(workflowId: $workflowId) {
    id
    accountId
    cronExpression
    runs {
      ...OrchestrationWorkflowRun
    }
  }
}
    ${OrchestrationWorkflowRunFragmentDoc}`;

/**
 * __useOrchestrationWorkflowHistoryQuery__
 *
 * To run a query within a React component, call `useOrchestrationWorkflowHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrchestrationWorkflowHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrchestrationWorkflowHistoryQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useOrchestrationWorkflowHistoryQuery(baseOptions: Apollo.QueryHookOptions<OrchestrationWorkflowHistoryQuery, OrchestrationWorkflowHistoryQueryVariables> & ({ variables: OrchestrationWorkflowHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrchestrationWorkflowHistoryQuery, OrchestrationWorkflowHistoryQueryVariables>(OrchestrationWorkflowHistoryDocument, options);
      }
export function useOrchestrationWorkflowHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrchestrationWorkflowHistoryQuery, OrchestrationWorkflowHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrchestrationWorkflowHistoryQuery, OrchestrationWorkflowHistoryQueryVariables>(OrchestrationWorkflowHistoryDocument, options);
        }
export function useOrchestrationWorkflowHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrchestrationWorkflowHistoryQuery, OrchestrationWorkflowHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrchestrationWorkflowHistoryQuery, OrchestrationWorkflowHistoryQueryVariables>(OrchestrationWorkflowHistoryDocument, options);
        }
export type OrchestrationWorkflowHistoryQueryHookResult = ReturnType<typeof useOrchestrationWorkflowHistoryQuery>;
export type OrchestrationWorkflowHistoryLazyQueryHookResult = ReturnType<typeof useOrchestrationWorkflowHistoryLazyQuery>;
export type OrchestrationWorkflowHistorySuspenseQueryHookResult = ReturnType<typeof useOrchestrationWorkflowHistorySuspenseQuery>;
export type OrchestrationWorkflowHistoryQueryResult = Apollo.QueryResult<OrchestrationWorkflowHistoryQuery, OrchestrationWorkflowHistoryQueryVariables>;
export const ListOrchestrationWorkflowOptionsDocument = gql`
    query ListOrchestrationWorkflowOptions {
  orchestrationWorkflows {
    id
    name
    active
    cronExpression
  }
}
    `;

/**
 * __useListOrchestrationWorkflowOptionsQuery__
 *
 * To run a query within a React component, call `useListOrchestrationWorkflowOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrchestrationWorkflowOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrchestrationWorkflowOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListOrchestrationWorkflowOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ListOrchestrationWorkflowOptionsQuery, ListOrchestrationWorkflowOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrchestrationWorkflowOptionsQuery, ListOrchestrationWorkflowOptionsQueryVariables>(ListOrchestrationWorkflowOptionsDocument, options);
      }
export function useListOrchestrationWorkflowOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrchestrationWorkflowOptionsQuery, ListOrchestrationWorkflowOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrchestrationWorkflowOptionsQuery, ListOrchestrationWorkflowOptionsQueryVariables>(ListOrchestrationWorkflowOptionsDocument, options);
        }
export function useListOrchestrationWorkflowOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListOrchestrationWorkflowOptionsQuery, ListOrchestrationWorkflowOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrchestrationWorkflowOptionsQuery, ListOrchestrationWorkflowOptionsQueryVariables>(ListOrchestrationWorkflowOptionsDocument, options);
        }
export type ListOrchestrationWorkflowOptionsQueryHookResult = ReturnType<typeof useListOrchestrationWorkflowOptionsQuery>;
export type ListOrchestrationWorkflowOptionsLazyQueryHookResult = ReturnType<typeof useListOrchestrationWorkflowOptionsLazyQuery>;
export type ListOrchestrationWorkflowOptionsSuspenseQueryHookResult = ReturnType<typeof useListOrchestrationWorkflowOptionsSuspenseQuery>;
export type ListOrchestrationWorkflowOptionsQueryResult = Apollo.QueryResult<ListOrchestrationWorkflowOptionsQuery, ListOrchestrationWorkflowOptionsQueryVariables>;
export const ListOrchestrationWorkflowsDocument = gql`
    query ListOrchestrationWorkflows {
  orchestrationWorkflows {
    id
    name
    description
    active
    cronExpression
    contents {
      models
      sourceStreams
      reverseEtlSyncs
      webhooks
    }
    currentRun {
      ...OrchestrationWorkflowRun
      jobs {
        ...OrchestrationJob
      }
    }
    nextRun {
      ...OrchestrationWorkflowRun
      jobs {
        ...OrchestrationJob
      }
    }
  }
}
    ${OrchestrationWorkflowRunFragmentDoc}
${OrchestrationJobFragmentDoc}`;

/**
 * __useListOrchestrationWorkflowsQuery__
 *
 * To run a query within a React component, call `useListOrchestrationWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrchestrationWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrchestrationWorkflowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListOrchestrationWorkflowsQuery(baseOptions?: Apollo.QueryHookOptions<ListOrchestrationWorkflowsQuery, ListOrchestrationWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrchestrationWorkflowsQuery, ListOrchestrationWorkflowsQueryVariables>(ListOrchestrationWorkflowsDocument, options);
      }
export function useListOrchestrationWorkflowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrchestrationWorkflowsQuery, ListOrchestrationWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrchestrationWorkflowsQuery, ListOrchestrationWorkflowsQueryVariables>(ListOrchestrationWorkflowsDocument, options);
        }
export function useListOrchestrationWorkflowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListOrchestrationWorkflowsQuery, ListOrchestrationWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrchestrationWorkflowsQuery, ListOrchestrationWorkflowsQueryVariables>(ListOrchestrationWorkflowsDocument, options);
        }
export type ListOrchestrationWorkflowsQueryHookResult = ReturnType<typeof useListOrchestrationWorkflowsQuery>;
export type ListOrchestrationWorkflowsLazyQueryHookResult = ReturnType<typeof useListOrchestrationWorkflowsLazyQuery>;
export type ListOrchestrationWorkflowsSuspenseQueryHookResult = ReturnType<typeof useListOrchestrationWorkflowsSuspenseQuery>;
export type ListOrchestrationWorkflowsQueryResult = Apollo.QueryResult<ListOrchestrationWorkflowsQuery, ListOrchestrationWorkflowsQueryVariables>;
export const OrchestrationWorkflowDocument = gql`
    query OrchestrationWorkflow($workflowId: ID!) {
  orchestrationWorkflow(workflowId: $workflowId) {
    ...OrchestrationWorkflow
  }
}
    ${OrchestrationWorkflowFragmentDoc}`;

/**
 * __useOrchestrationWorkflowQuery__
 *
 * To run a query within a React component, call `useOrchestrationWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrchestrationWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrchestrationWorkflowQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useOrchestrationWorkflowQuery(baseOptions: Apollo.QueryHookOptions<OrchestrationWorkflowQuery, OrchestrationWorkflowQueryVariables> & ({ variables: OrchestrationWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrchestrationWorkflowQuery, OrchestrationWorkflowQueryVariables>(OrchestrationWorkflowDocument, options);
      }
export function useOrchestrationWorkflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrchestrationWorkflowQuery, OrchestrationWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrchestrationWorkflowQuery, OrchestrationWorkflowQueryVariables>(OrchestrationWorkflowDocument, options);
        }
export function useOrchestrationWorkflowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrchestrationWorkflowQuery, OrchestrationWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrchestrationWorkflowQuery, OrchestrationWorkflowQueryVariables>(OrchestrationWorkflowDocument, options);
        }
export type OrchestrationWorkflowQueryHookResult = ReturnType<typeof useOrchestrationWorkflowQuery>;
export type OrchestrationWorkflowLazyQueryHookResult = ReturnType<typeof useOrchestrationWorkflowLazyQuery>;
export type OrchestrationWorkflowSuspenseQueryHookResult = ReturnType<typeof useOrchestrationWorkflowSuspenseQuery>;
export type OrchestrationWorkflowQueryResult = Apollo.QueryResult<OrchestrationWorkflowQuery, OrchestrationWorkflowQueryVariables>;
export const OrchestrationWorkflowRunDocument = gql`
    query OrchestrationWorkflowRun($runId: ID!) {
  orchestrationWorkflowRun(runId: $runId) {
    ...OrchestrationWorkflowRun
    jobs {
      ...OrchestrationJob
      target {
        ... on MaterializedTableReference {
          modelId
          modelTestRuns {
            ...ModelTestRun
          }
        }
        ... on ModelViewReference {
          modelId
          modelTestRuns {
            ...ModelTestRun
          }
        }
      }
    }
  }
}
    ${OrchestrationWorkflowRunFragmentDoc}
${OrchestrationJobFragmentDoc}
${ModelTestRunFragmentDoc}`;

/**
 * __useOrchestrationWorkflowRunQuery__
 *
 * To run a query within a React component, call `useOrchestrationWorkflowRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrchestrationWorkflowRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrchestrationWorkflowRunQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useOrchestrationWorkflowRunQuery(baseOptions: Apollo.QueryHookOptions<OrchestrationWorkflowRunQuery, OrchestrationWorkflowRunQueryVariables> & ({ variables: OrchestrationWorkflowRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrchestrationWorkflowRunQuery, OrchestrationWorkflowRunQueryVariables>(OrchestrationWorkflowRunDocument, options);
      }
export function useOrchestrationWorkflowRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrchestrationWorkflowRunQuery, OrchestrationWorkflowRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrchestrationWorkflowRunQuery, OrchestrationWorkflowRunQueryVariables>(OrchestrationWorkflowRunDocument, options);
        }
export function useOrchestrationWorkflowRunSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrchestrationWorkflowRunQuery, OrchestrationWorkflowRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrchestrationWorkflowRunQuery, OrchestrationWorkflowRunQueryVariables>(OrchestrationWorkflowRunDocument, options);
        }
export type OrchestrationWorkflowRunQueryHookResult = ReturnType<typeof useOrchestrationWorkflowRunQuery>;
export type OrchestrationWorkflowRunLazyQueryHookResult = ReturnType<typeof useOrchestrationWorkflowRunLazyQuery>;
export type OrchestrationWorkflowRunSuspenseQueryHookResult = ReturnType<typeof useOrchestrationWorkflowRunSuspenseQuery>;
export type OrchestrationWorkflowRunQueryResult = Apollo.QueryResult<OrchestrationWorkflowRunQuery, OrchestrationWorkflowRunQueryVariables>;
export const StartWorkflowNowDocument = gql`
    mutation StartWorkflowNow($workflowId: ID!) {
  runOrchestrationWorkflowNow(workflowId: $workflowId) {
    nextRun {
      id
    }
  }
}
    `;
export type StartWorkflowNowMutationFn = Apollo.MutationFunction<StartWorkflowNowMutation, StartWorkflowNowMutationVariables>;

/**
 * __useStartWorkflowNowMutation__
 *
 * To run a mutation, you first call `useStartWorkflowNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartWorkflowNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startWorkflowNowMutation, { data, loading, error }] = useStartWorkflowNowMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useStartWorkflowNowMutation(baseOptions?: Apollo.MutationHookOptions<StartWorkflowNowMutation, StartWorkflowNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartWorkflowNowMutation, StartWorkflowNowMutationVariables>(StartWorkflowNowDocument, options);
      }
export type StartWorkflowNowMutationHookResult = ReturnType<typeof useStartWorkflowNowMutation>;
export type StartWorkflowNowMutationResult = Apollo.MutationResult<StartWorkflowNowMutation>;
export type StartWorkflowNowMutationOptions = Apollo.BaseMutationOptions<StartWorkflowNowMutation, StartWorkflowNowMutationVariables>;
export const CancelCurrentWorkflowRunDocument = gql`
    mutation CancelCurrentWorkflowRun($workflowId: ID!) {
  cancelCurrentWorkflowRun(workflowId: $workflowId) {
    nextRun {
      id
    }
  }
}
    `;
export type CancelCurrentWorkflowRunMutationFn = Apollo.MutationFunction<CancelCurrentWorkflowRunMutation, CancelCurrentWorkflowRunMutationVariables>;

/**
 * __useCancelCurrentWorkflowRunMutation__
 *
 * To run a mutation, you first call `useCancelCurrentWorkflowRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCurrentWorkflowRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCurrentWorkflowRunMutation, { data, loading, error }] = useCancelCurrentWorkflowRunMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useCancelCurrentWorkflowRunMutation(baseOptions?: Apollo.MutationHookOptions<CancelCurrentWorkflowRunMutation, CancelCurrentWorkflowRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCurrentWorkflowRunMutation, CancelCurrentWorkflowRunMutationVariables>(CancelCurrentWorkflowRunDocument, options);
      }
export type CancelCurrentWorkflowRunMutationHookResult = ReturnType<typeof useCancelCurrentWorkflowRunMutation>;
export type CancelCurrentWorkflowRunMutationResult = Apollo.MutationResult<CancelCurrentWorkflowRunMutation>;
export type CancelCurrentWorkflowRunMutationOptions = Apollo.BaseMutationOptions<CancelCurrentWorkflowRunMutation, CancelCurrentWorkflowRunMutationVariables>;
export const SetWorkflowActiveDocument = gql`
    mutation SetWorkflowActive($workflowId: ID!, $active: Boolean!) {
  setWorkflowActive(workflowId: $workflowId, active: $active) {
    ...OrchestrationWorkflow
  }
}
    ${OrchestrationWorkflowFragmentDoc}`;
export type SetWorkflowActiveMutationFn = Apollo.MutationFunction<SetWorkflowActiveMutation, SetWorkflowActiveMutationVariables>;

/**
 * __useSetWorkflowActiveMutation__
 *
 * To run a mutation, you first call `useSetWorkflowActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkflowActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkflowActiveMutation, { data, loading, error }] = useSetWorkflowActiveMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useSetWorkflowActiveMutation(baseOptions?: Apollo.MutationHookOptions<SetWorkflowActiveMutation, SetWorkflowActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWorkflowActiveMutation, SetWorkflowActiveMutationVariables>(SetWorkflowActiveDocument, options);
      }
export type SetWorkflowActiveMutationHookResult = ReturnType<typeof useSetWorkflowActiveMutation>;
export type SetWorkflowActiveMutationResult = Apollo.MutationResult<SetWorkflowActiveMutation>;
export type SetWorkflowActiveMutationOptions = Apollo.BaseMutationOptions<SetWorkflowActiveMutation, SetWorkflowActiveMutationVariables>;
export const ClaimPromoCodeDocument = gql`
    mutation ClaimPromoCode($input: ClaimPromoCodeInput!) {
  claimPromoCode(input: $input)
}
    `;
export type ClaimPromoCodeMutationFn = Apollo.MutationFunction<ClaimPromoCodeMutation, ClaimPromoCodeMutationVariables>;

/**
 * __useClaimPromoCodeMutation__
 *
 * To run a mutation, you first call `useClaimPromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimPromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimPromoCodeMutation, { data, loading, error }] = useClaimPromoCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClaimPromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<ClaimPromoCodeMutation, ClaimPromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimPromoCodeMutation, ClaimPromoCodeMutationVariables>(ClaimPromoCodeDocument, options);
      }
export type ClaimPromoCodeMutationHookResult = ReturnType<typeof useClaimPromoCodeMutation>;
export type ClaimPromoCodeMutationResult = Apollo.MutationResult<ClaimPromoCodeMutation>;
export type ClaimPromoCodeMutationOptions = Apollo.BaseMutationOptions<ClaimPromoCodeMutation, ClaimPromoCodeMutationVariables>;
export const ValidatePromoCodeDocument = gql`
    query ValidatePromoCode($code: String!, $flow: String) {
  validatePromoCode(code: $code, flow: $flow) {
    code
    promoId
    name
    percentOff
    amountOff
    duration
    durationInMonths
  }
}
    `;

/**
 * __useValidatePromoCodeQuery__
 *
 * To run a query within a React component, call `useValidatePromoCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePromoCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePromoCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *      flow: // value for 'flow'
 *   },
 * });
 */
export function useValidatePromoCodeQuery(baseOptions: Apollo.QueryHookOptions<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables> & ({ variables: ValidatePromoCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>(ValidatePromoCodeDocument, options);
      }
export function useValidatePromoCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>(ValidatePromoCodeDocument, options);
        }
export function useValidatePromoCodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>(ValidatePromoCodeDocument, options);
        }
export type ValidatePromoCodeQueryHookResult = ReturnType<typeof useValidatePromoCodeQuery>;
export type ValidatePromoCodeLazyQueryHookResult = ReturnType<typeof useValidatePromoCodeLazyQuery>;
export type ValidatePromoCodeSuspenseQueryHookResult = ReturnType<typeof useValidatePromoCodeSuspenseQuery>;
export type ValidatePromoCodeQueryResult = Apollo.QueryResult<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>;
export const SourcePropertiesDocument = gql`
    query SourceProperties($modelId: String!) {
  sourceProperties(modelId: $modelId) {
    dataSchema {
      ...SourceProperty
    }
  }
}
    ${SourcePropertyFragmentDoc}`;

/**
 * __useSourcePropertiesQuery__
 *
 * To run a query within a React component, call `useSourcePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourcePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourcePropertiesQuery({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useSourcePropertiesQuery(baseOptions: Apollo.QueryHookOptions<SourcePropertiesQuery, SourcePropertiesQueryVariables> & ({ variables: SourcePropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourcePropertiesQuery, SourcePropertiesQueryVariables>(SourcePropertiesDocument, options);
      }
export function useSourcePropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourcePropertiesQuery, SourcePropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourcePropertiesQuery, SourcePropertiesQueryVariables>(SourcePropertiesDocument, options);
        }
export function useSourcePropertiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SourcePropertiesQuery, SourcePropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SourcePropertiesQuery, SourcePropertiesQueryVariables>(SourcePropertiesDocument, options);
        }
export type SourcePropertiesQueryHookResult = ReturnType<typeof useSourcePropertiesQuery>;
export type SourcePropertiesLazyQueryHookResult = ReturnType<typeof useSourcePropertiesLazyQuery>;
export type SourcePropertiesSuspenseQueryHookResult = ReturnType<typeof useSourcePropertiesSuspenseQuery>;
export type SourcePropertiesQueryResult = Apollo.QueryResult<SourcePropertiesQuery, SourcePropertiesQueryVariables>;
export const DestinationPropertiesDocument = gql`
    query DestinationProperties($destinationConnectionId: String!, $objectType: String!, $operationMode: String!, $readonly: Boolean, $modelId: String) {
  destinationProperties(
    input: {destinationConnectionId: $destinationConnectionId, objectType: $objectType, operationMode: $operationMode, readonly: $readonly, modelId: $modelId}
  ) {
    ...DestinationProperty
  }
}
    ${DestinationPropertyFragmentDoc}`;

/**
 * __useDestinationPropertiesQuery__
 *
 * To run a query within a React component, call `useDestinationPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationPropertiesQuery({
 *   variables: {
 *      destinationConnectionId: // value for 'destinationConnectionId'
 *      objectType: // value for 'objectType'
 *      operationMode: // value for 'operationMode'
 *      readonly: // value for 'readonly'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useDestinationPropertiesQuery(baseOptions: Apollo.QueryHookOptions<DestinationPropertiesQuery, DestinationPropertiesQueryVariables> & ({ variables: DestinationPropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DestinationPropertiesQuery, DestinationPropertiesQueryVariables>(DestinationPropertiesDocument, options);
      }
export function useDestinationPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationPropertiesQuery, DestinationPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DestinationPropertiesQuery, DestinationPropertiesQueryVariables>(DestinationPropertiesDocument, options);
        }
export function useDestinationPropertiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DestinationPropertiesQuery, DestinationPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DestinationPropertiesQuery, DestinationPropertiesQueryVariables>(DestinationPropertiesDocument, options);
        }
export type DestinationPropertiesQueryHookResult = ReturnType<typeof useDestinationPropertiesQuery>;
export type DestinationPropertiesLazyQueryHookResult = ReturnType<typeof useDestinationPropertiesLazyQuery>;
export type DestinationPropertiesSuspenseQueryHookResult = ReturnType<typeof useDestinationPropertiesSuspenseQuery>;
export type DestinationPropertiesQueryResult = Apollo.QueryResult<DestinationPropertiesQuery, DestinationPropertiesQueryVariables>;
export const SaveSignupQuestionnaireResultDocument = gql`
    mutation SaveSignupQuestionnaireResult($input: SaveSignupQuestionnaireResultInput!) {
  saveSignupQuestionnaireResult(input: $input)
}
    `;
export type SaveSignupQuestionnaireResultMutationFn = Apollo.MutationFunction<SaveSignupQuestionnaireResultMutation, SaveSignupQuestionnaireResultMutationVariables>;

/**
 * __useSaveSignupQuestionnaireResultMutation__
 *
 * To run a mutation, you first call `useSaveSignupQuestionnaireResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSignupQuestionnaireResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSignupQuestionnaireResultMutation, { data, loading, error }] = useSaveSignupQuestionnaireResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSignupQuestionnaireResultMutation(baseOptions?: Apollo.MutationHookOptions<SaveSignupQuestionnaireResultMutation, SaveSignupQuestionnaireResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSignupQuestionnaireResultMutation, SaveSignupQuestionnaireResultMutationVariables>(SaveSignupQuestionnaireResultDocument, options);
      }
export type SaveSignupQuestionnaireResultMutationHookResult = ReturnType<typeof useSaveSignupQuestionnaireResultMutation>;
export type SaveSignupQuestionnaireResultMutationResult = Apollo.MutationResult<SaveSignupQuestionnaireResultMutation>;
export type SaveSignupQuestionnaireResultMutationOptions = Apollo.BaseMutationOptions<SaveSignupQuestionnaireResultMutation, SaveSignupQuestionnaireResultMutationVariables>;
export const GetSignupQuestionnaireResultDocument = gql`
    query GetSignupQuestionnaireResult {
  getSignupQuestionnaireResult {
    result {
      userId
      result
      timestamp
    }
  }
}
    `;

/**
 * __useGetSignupQuestionnaireResultQuery__
 *
 * To run a query within a React component, call `useGetSignupQuestionnaireResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignupQuestionnaireResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignupQuestionnaireResultQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSignupQuestionnaireResultQuery(baseOptions?: Apollo.QueryHookOptions<GetSignupQuestionnaireResultQuery, GetSignupQuestionnaireResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignupQuestionnaireResultQuery, GetSignupQuestionnaireResultQueryVariables>(GetSignupQuestionnaireResultDocument, options);
      }
export function useGetSignupQuestionnaireResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignupQuestionnaireResultQuery, GetSignupQuestionnaireResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignupQuestionnaireResultQuery, GetSignupQuestionnaireResultQueryVariables>(GetSignupQuestionnaireResultDocument, options);
        }
export function useGetSignupQuestionnaireResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSignupQuestionnaireResultQuery, GetSignupQuestionnaireResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSignupQuestionnaireResultQuery, GetSignupQuestionnaireResultQueryVariables>(GetSignupQuestionnaireResultDocument, options);
        }
export type GetSignupQuestionnaireResultQueryHookResult = ReturnType<typeof useGetSignupQuestionnaireResultQuery>;
export type GetSignupQuestionnaireResultLazyQueryHookResult = ReturnType<typeof useGetSignupQuestionnaireResultLazyQuery>;
export type GetSignupQuestionnaireResultSuspenseQueryHookResult = ReturnType<typeof useGetSignupQuestionnaireResultSuspenseQuery>;
export type GetSignupQuestionnaireResultQueryResult = Apollo.QueryResult<GetSignupQuestionnaireResultQuery, GetSignupQuestionnaireResultQueryVariables>;
export const StripeSubscriptionDocument = gql`
    query StripeSubscription($slug: String!) {
  accountBySlug(slug: $slug) {
    id
    slug
    stripeCustomer {
      ...StripeCustomer
    }
    stripeSubscription {
      stripeSubscriptionDetails {
        id
        items {
          ...StripeSubscriptionItem
        }
        status
        createdDate
        trialEndDate
        cancelDate
        currentPeriodStartDate
        currentPeriodEndDate
        planName
      }
    }
  }
}
    ${StripeCustomerFragmentDoc}
${StripeSubscriptionItemFragmentDoc}`;

/**
 * __useStripeSubscriptionQuery__
 *
 * To run a query within a React component, call `useStripeSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeSubscriptionQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useStripeSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<StripeSubscriptionQuery, StripeSubscriptionQueryVariables> & ({ variables: StripeSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>(StripeSubscriptionDocument, options);
      }
export function useStripeSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>(StripeSubscriptionDocument, options);
        }
export function useStripeSubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>(StripeSubscriptionDocument, options);
        }
export type StripeSubscriptionQueryHookResult = ReturnType<typeof useStripeSubscriptionQuery>;
export type StripeSubscriptionLazyQueryHookResult = ReturnType<typeof useStripeSubscriptionLazyQuery>;
export type StripeSubscriptionSuspenseQueryHookResult = ReturnType<typeof useStripeSubscriptionSuspenseQuery>;
export type StripeSubscriptionQueryResult = Apollo.QueryResult<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>;
export const StripeCustomerDocument = gql`
    query StripeCustomer($slug: String!) {
  accountBySlug(slug: $slug) {
    stripeCustomer {
      ...StripeCustomer
    }
  }
}
    ${StripeCustomerFragmentDoc}`;

/**
 * __useStripeCustomerQuery__
 *
 * To run a query within a React component, call `useStripeCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeCustomerQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useStripeCustomerQuery(baseOptions: Apollo.QueryHookOptions<StripeCustomerQuery, StripeCustomerQueryVariables> & ({ variables: StripeCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeCustomerQuery, StripeCustomerQueryVariables>(StripeCustomerDocument, options);
      }
export function useStripeCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeCustomerQuery, StripeCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeCustomerQuery, StripeCustomerQueryVariables>(StripeCustomerDocument, options);
        }
export function useStripeCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StripeCustomerQuery, StripeCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StripeCustomerQuery, StripeCustomerQueryVariables>(StripeCustomerDocument, options);
        }
export type StripeCustomerQueryHookResult = ReturnType<typeof useStripeCustomerQuery>;
export type StripeCustomerLazyQueryHookResult = ReturnType<typeof useStripeCustomerLazyQuery>;
export type StripeCustomerSuspenseQueryHookResult = ReturnType<typeof useStripeCustomerSuspenseQuery>;
export type StripeCustomerQueryResult = Apollo.QueryResult<StripeCustomerQuery, StripeCustomerQueryVariables>;
export const StripeCustomerByIdDocument = gql`
    query StripeCustomerById($customerId: String!) {
  customer(customerId: $customerId) {
    ...StripeCustomer
  }
}
    ${StripeCustomerFragmentDoc}`;

/**
 * __useStripeCustomerByIdQuery__
 *
 * To run a query within a React component, call `useStripeCustomerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeCustomerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeCustomerByIdQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useStripeCustomerByIdQuery(baseOptions: Apollo.QueryHookOptions<StripeCustomerByIdQuery, StripeCustomerByIdQueryVariables> & ({ variables: StripeCustomerByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeCustomerByIdQuery, StripeCustomerByIdQueryVariables>(StripeCustomerByIdDocument, options);
      }
export function useStripeCustomerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeCustomerByIdQuery, StripeCustomerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeCustomerByIdQuery, StripeCustomerByIdQueryVariables>(StripeCustomerByIdDocument, options);
        }
export function useStripeCustomerByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StripeCustomerByIdQuery, StripeCustomerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StripeCustomerByIdQuery, StripeCustomerByIdQueryVariables>(StripeCustomerByIdDocument, options);
        }
export type StripeCustomerByIdQueryHookResult = ReturnType<typeof useStripeCustomerByIdQuery>;
export type StripeCustomerByIdLazyQueryHookResult = ReturnType<typeof useStripeCustomerByIdLazyQuery>;
export type StripeCustomerByIdSuspenseQueryHookResult = ReturnType<typeof useStripeCustomerByIdSuspenseQuery>;
export type StripeCustomerByIdQueryResult = Apollo.QueryResult<StripeCustomerByIdQuery, StripeCustomerByIdQueryVariables>;
export const CreateOrUpdateCustomerDocument = gql`
    mutation CreateOrUpdateCustomer($input: CreateOrUpdateCustomerInput!) {
  createOrUpdateCustomer(input: $input) {
    ...StripeCustomer
  }
}
    ${StripeCustomerFragmentDoc}`;
export type CreateOrUpdateCustomerMutationFn = Apollo.MutationFunction<CreateOrUpdateCustomerMutation, CreateOrUpdateCustomerMutationVariables>;

/**
 * __useCreateOrUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateCustomerMutation, { data, loading, error }] = useCreateOrUpdateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateCustomerMutation, CreateOrUpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateCustomerMutation, CreateOrUpdateCustomerMutationVariables>(CreateOrUpdateCustomerDocument, options);
      }
export type CreateOrUpdateCustomerMutationHookResult = ReturnType<typeof useCreateOrUpdateCustomerMutation>;
export type CreateOrUpdateCustomerMutationResult = Apollo.MutationResult<CreateOrUpdateCustomerMutation>;
export type CreateOrUpdateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateCustomerMutation, CreateOrUpdateCustomerMutationVariables>;
export const CreateOrUpdateWeldSubscriptionDocument = gql`
    mutation CreateOrUpdateWeldSubscription($customerId: String!, $priceId: String!, $currency: String!, $numConnectors: Int!, $numUsers: Int!, $numRows: Int, $paymentMethodId: String, $promoId: String) {
  createOrUpdateWeldSubscription(
    customerId: $customerId
    paymentMethodId: $paymentMethodId
    priceId: $priceId
    currency: $currency
    numConnectors: $numConnectors
    numUsers: $numUsers
    numRows: $numRows
    promoId: $promoId
  ) {
    id
    paymentIntentClientSecret
  }
}
    `;
export type CreateOrUpdateWeldSubscriptionMutationFn = Apollo.MutationFunction<CreateOrUpdateWeldSubscriptionMutation, CreateOrUpdateWeldSubscriptionMutationVariables>;

/**
 * __useCreateOrUpdateWeldSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateWeldSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateWeldSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateWeldSubscriptionMutation, { data, loading, error }] = useCreateOrUpdateWeldSubscriptionMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      priceId: // value for 'priceId'
 *      currency: // value for 'currency'
 *      numConnectors: // value for 'numConnectors'
 *      numUsers: // value for 'numUsers'
 *      numRows: // value for 'numRows'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      promoId: // value for 'promoId'
 *   },
 * });
 */
export function useCreateOrUpdateWeldSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateWeldSubscriptionMutation, CreateOrUpdateWeldSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateWeldSubscriptionMutation, CreateOrUpdateWeldSubscriptionMutationVariables>(CreateOrUpdateWeldSubscriptionDocument, options);
      }
export type CreateOrUpdateWeldSubscriptionMutationHookResult = ReturnType<typeof useCreateOrUpdateWeldSubscriptionMutation>;
export type CreateOrUpdateWeldSubscriptionMutationResult = Apollo.MutationResult<CreateOrUpdateWeldSubscriptionMutation>;
export type CreateOrUpdateWeldSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateWeldSubscriptionMutation, CreateOrUpdateWeldSubscriptionMutationVariables>;
export const CancelWeldSubscriptionDocument = gql`
    mutation CancelWeldSubscription($input: CancelSubscriptionInput!) {
  cancelWeldSubscription(input: $input) {
    id
  }
}
    `;
export type CancelWeldSubscriptionMutationFn = Apollo.MutationFunction<CancelWeldSubscriptionMutation, CancelWeldSubscriptionMutationVariables>;

/**
 * __useCancelWeldSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelWeldSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelWeldSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelWeldSubscriptionMutation, { data, loading, error }] = useCancelWeldSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelWeldSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelWeldSubscriptionMutation, CancelWeldSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelWeldSubscriptionMutation, CancelWeldSubscriptionMutationVariables>(CancelWeldSubscriptionDocument, options);
      }
export type CancelWeldSubscriptionMutationHookResult = ReturnType<typeof useCancelWeldSubscriptionMutation>;
export type CancelWeldSubscriptionMutationResult = Apollo.MutationResult<CancelWeldSubscriptionMutation>;
export type CancelWeldSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelWeldSubscriptionMutation, CancelWeldSubscriptionMutationVariables>;
export const RevertWeldSubscriptionCancellationDocument = gql`
    mutation RevertWeldSubscriptionCancellation($subscriptionId: String!) {
  revertSubscriptionCancelation(subscriptionId: $subscriptionId) {
    id
  }
}
    `;
export type RevertWeldSubscriptionCancellationMutationFn = Apollo.MutationFunction<RevertWeldSubscriptionCancellationMutation, RevertWeldSubscriptionCancellationMutationVariables>;

/**
 * __useRevertWeldSubscriptionCancellationMutation__
 *
 * To run a mutation, you first call `useRevertWeldSubscriptionCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertWeldSubscriptionCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertWeldSubscriptionCancellationMutation, { data, loading, error }] = useRevertWeldSubscriptionCancellationMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useRevertWeldSubscriptionCancellationMutation(baseOptions?: Apollo.MutationHookOptions<RevertWeldSubscriptionCancellationMutation, RevertWeldSubscriptionCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertWeldSubscriptionCancellationMutation, RevertWeldSubscriptionCancellationMutationVariables>(RevertWeldSubscriptionCancellationDocument, options);
      }
export type RevertWeldSubscriptionCancellationMutationHookResult = ReturnType<typeof useRevertWeldSubscriptionCancellationMutation>;
export type RevertWeldSubscriptionCancellationMutationResult = Apollo.MutationResult<RevertWeldSubscriptionCancellationMutation>;
export type RevertWeldSubscriptionCancellationMutationOptions = Apollo.BaseMutationOptions<RevertWeldSubscriptionCancellationMutation, RevertWeldSubscriptionCancellationMutationVariables>;
export const UpdatePaymentMethodDocument = gql`
    mutation UpdatePaymentMethod($input: CreatePaymentMethodCheckoutSessionInput!) {
  createPaymentMethodCheckoutSession(input: $input) {
    id
    url
    expiresAt
  }
}
    `;
export type UpdatePaymentMethodMutationFn = Apollo.MutationFunction<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;

/**
 * __useUpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMethodMutation, { data, loading, error }] = useUpdatePaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>(UpdatePaymentMethodDocument, options);
      }
export type UpdatePaymentMethodMutationHookResult = ReturnType<typeof useUpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationResult = Apollo.MutationResult<UpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;
export const UpdateBillingDetailsDocument = gql`
    mutation UpdateBillingDetails($customerId: ID!, $billingDetails: BillingDetailsInput!) {
  updateBillingDetails(customerId: $customerId, billingDetails: $billingDetails) {
    id
    email
  }
}
    `;
export type UpdateBillingDetailsMutationFn = Apollo.MutationFunction<UpdateBillingDetailsMutation, UpdateBillingDetailsMutationVariables>;

/**
 * __useUpdateBillingDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateBillingDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingDetailsMutation, { data, loading, error }] = useUpdateBillingDetailsMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      billingDetails: // value for 'billingDetails'
 *   },
 * });
 */
export function useUpdateBillingDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillingDetailsMutation, UpdateBillingDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillingDetailsMutation, UpdateBillingDetailsMutationVariables>(UpdateBillingDetailsDocument, options);
      }
export type UpdateBillingDetailsMutationHookResult = ReturnType<typeof useUpdateBillingDetailsMutation>;
export type UpdateBillingDetailsMutationResult = Apollo.MutationResult<UpdateBillingDetailsMutation>;
export type UpdateBillingDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateBillingDetailsMutation, UpdateBillingDetailsMutationVariables>;
export const ProductPriceByLookupKeyDocument = gql`
    query ProductPriceByLookupKey($lookupKey: String!, $currency: String!) {
  getProductPriceByLookupKey(lookupKey: $lookupKey, currency: $currency) {
    ...Price
    currencyOptions {
      currency
      price
      tiers {
        price
        upTo
        unitAmount
      }
    }
  }
}
    ${PriceFragmentDoc}`;

/**
 * __useProductPriceByLookupKeyQuery__
 *
 * To run a query within a React component, call `useProductPriceByLookupKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPriceByLookupKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPriceByLookupKeyQuery({
 *   variables: {
 *      lookupKey: // value for 'lookupKey'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useProductPriceByLookupKeyQuery(baseOptions: Apollo.QueryHookOptions<ProductPriceByLookupKeyQuery, ProductPriceByLookupKeyQueryVariables> & ({ variables: ProductPriceByLookupKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPriceByLookupKeyQuery, ProductPriceByLookupKeyQueryVariables>(ProductPriceByLookupKeyDocument, options);
      }
export function useProductPriceByLookupKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPriceByLookupKeyQuery, ProductPriceByLookupKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPriceByLookupKeyQuery, ProductPriceByLookupKeyQueryVariables>(ProductPriceByLookupKeyDocument, options);
        }
export function useProductPriceByLookupKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductPriceByLookupKeyQuery, ProductPriceByLookupKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPriceByLookupKeyQuery, ProductPriceByLookupKeyQueryVariables>(ProductPriceByLookupKeyDocument, options);
        }
export type ProductPriceByLookupKeyQueryHookResult = ReturnType<typeof useProductPriceByLookupKeyQuery>;
export type ProductPriceByLookupKeyLazyQueryHookResult = ReturnType<typeof useProductPriceByLookupKeyLazyQuery>;
export type ProductPriceByLookupKeySuspenseQueryHookResult = ReturnType<typeof useProductPriceByLookupKeySuspenseQuery>;
export type ProductPriceByLookupKeyQueryResult = Apollo.QueryResult<ProductPriceByLookupKeyQuery, ProductPriceByLookupKeyQueryVariables>;
export const InvoicesDocument = gql`
    query Invoices($customerId: String!) {
  invoices(customerId: $customerId) {
    ...StripeInvoice
  }
}
    ${StripeInvoiceFragmentDoc}`;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions: Apollo.QueryHookOptions<InvoicesQuery, InvoicesQueryVariables> & ({ variables: InvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export function useInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesSuspenseQueryHookResult = ReturnType<typeof useInvoicesSuspenseQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<InvoicesQuery, InvoicesQueryVariables>;
export const CheckoutPreviewDocument = gql`
    query CheckoutPreview($input: InvoicePreviewInput!) {
  getCheckoutPreview(input: $input) {
    ...UpcomingInvoice
  }
}
    ${UpcomingInvoiceFragmentDoc}`;

/**
 * __useCheckoutPreviewQuery__
 *
 * To run a query within a React component, call `useCheckoutPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckoutPreviewQuery(baseOptions: Apollo.QueryHookOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables> & ({ variables: CheckoutPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>(CheckoutPreviewDocument, options);
      }
export function useCheckoutPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>(CheckoutPreviewDocument, options);
        }
export function useCheckoutPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>(CheckoutPreviewDocument, options);
        }
export type CheckoutPreviewQueryHookResult = ReturnType<typeof useCheckoutPreviewQuery>;
export type CheckoutPreviewLazyQueryHookResult = ReturnType<typeof useCheckoutPreviewLazyQuery>;
export type CheckoutPreviewSuspenseQueryHookResult = ReturnType<typeof useCheckoutPreviewSuspenseQuery>;
export type CheckoutPreviewQueryResult = Apollo.QueryResult<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>;
export const UpcomingInvoiceDocument = gql`
    query UpcomingInvoice($customerId: String!, $subscriptionId: String!) {
  upcomingInvoice(customerId: $customerId, subscriptionId: $subscriptionId) {
    ...UpcomingInvoice
  }
}
    ${UpcomingInvoiceFragmentDoc}`;

/**
 * __useUpcomingInvoiceQuery__
 *
 * To run a query within a React component, call `useUpcomingInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingInvoiceQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useUpcomingInvoiceQuery(baseOptions: Apollo.QueryHookOptions<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables> & ({ variables: UpcomingInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>(UpcomingInvoiceDocument, options);
      }
export function useUpcomingInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>(UpcomingInvoiceDocument, options);
        }
export function useUpcomingInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>(UpcomingInvoiceDocument, options);
        }
export type UpcomingInvoiceQueryHookResult = ReturnType<typeof useUpcomingInvoiceQuery>;
export type UpcomingInvoiceLazyQueryHookResult = ReturnType<typeof useUpcomingInvoiceLazyQuery>;
export type UpcomingInvoiceSuspenseQueryHookResult = ReturnType<typeof useUpcomingInvoiceSuspenseQuery>;
export type UpcomingInvoiceQueryResult = Apollo.QueryResult<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>;
export const UpcomingPlanInvoiceDocument = gql`
    query UpcomingPlanInvoice($customerId: String!, $subscriptionId: String!) {
  upcomingPlanInvoice(customerId: $customerId, subscriptionId: $subscriptionId) {
    ...UpcomingInvoice
  }
}
    ${UpcomingInvoiceFragmentDoc}`;

/**
 * __useUpcomingPlanInvoiceQuery__
 *
 * To run a query within a React component, call `useUpcomingPlanInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingPlanInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingPlanInvoiceQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useUpcomingPlanInvoiceQuery(baseOptions: Apollo.QueryHookOptions<UpcomingPlanInvoiceQuery, UpcomingPlanInvoiceQueryVariables> & ({ variables: UpcomingPlanInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpcomingPlanInvoiceQuery, UpcomingPlanInvoiceQueryVariables>(UpcomingPlanInvoiceDocument, options);
      }
export function useUpcomingPlanInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpcomingPlanInvoiceQuery, UpcomingPlanInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpcomingPlanInvoiceQuery, UpcomingPlanInvoiceQueryVariables>(UpcomingPlanInvoiceDocument, options);
        }
export function useUpcomingPlanInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpcomingPlanInvoiceQuery, UpcomingPlanInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpcomingPlanInvoiceQuery, UpcomingPlanInvoiceQueryVariables>(UpcomingPlanInvoiceDocument, options);
        }
export type UpcomingPlanInvoiceQueryHookResult = ReturnType<typeof useUpcomingPlanInvoiceQuery>;
export type UpcomingPlanInvoiceLazyQueryHookResult = ReturnType<typeof useUpcomingPlanInvoiceLazyQuery>;
export type UpcomingPlanInvoiceSuspenseQueryHookResult = ReturnType<typeof useUpcomingPlanInvoiceSuspenseQuery>;
export type UpcomingPlanInvoiceQueryResult = Apollo.QueryResult<UpcomingPlanInvoiceQuery, UpcomingPlanInvoiceQueryVariables>;
export const UpcomingMarOverageInvoiceDocument = gql`
    query UpcomingMAROverageInvoice($customerId: String!, $subscriptionId: String!) {
  upcomingMAROverageInvoice(
    customerId: $customerId
    subscriptionId: $subscriptionId
  ) {
    ...UpcomingInvoice
  }
}
    ${UpcomingInvoiceFragmentDoc}`;

/**
 * __useUpcomingMarOverageInvoiceQuery__
 *
 * To run a query within a React component, call `useUpcomingMarOverageInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingMarOverageInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingMarOverageInvoiceQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useUpcomingMarOverageInvoiceQuery(baseOptions: Apollo.QueryHookOptions<UpcomingMarOverageInvoiceQuery, UpcomingMarOverageInvoiceQueryVariables> & ({ variables: UpcomingMarOverageInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpcomingMarOverageInvoiceQuery, UpcomingMarOverageInvoiceQueryVariables>(UpcomingMarOverageInvoiceDocument, options);
      }
export function useUpcomingMarOverageInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpcomingMarOverageInvoiceQuery, UpcomingMarOverageInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpcomingMarOverageInvoiceQuery, UpcomingMarOverageInvoiceQueryVariables>(UpcomingMarOverageInvoiceDocument, options);
        }
export function useUpcomingMarOverageInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpcomingMarOverageInvoiceQuery, UpcomingMarOverageInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpcomingMarOverageInvoiceQuery, UpcomingMarOverageInvoiceQueryVariables>(UpcomingMarOverageInvoiceDocument, options);
        }
export type UpcomingMarOverageInvoiceQueryHookResult = ReturnType<typeof useUpcomingMarOverageInvoiceQuery>;
export type UpcomingMarOverageInvoiceLazyQueryHookResult = ReturnType<typeof useUpcomingMarOverageInvoiceLazyQuery>;
export type UpcomingMarOverageInvoiceSuspenseQueryHookResult = ReturnType<typeof useUpcomingMarOverageInvoiceSuspenseQuery>;
export type UpcomingMarOverageInvoiceQueryResult = Apollo.QueryResult<UpcomingMarOverageInvoiceQuery, UpcomingMarOverageInvoiceQueryVariables>;
export const PaymentPreviewForSubscriptionDocument = gql`
    query PaymentPreviewForSubscription($customerId: String!, $subscriptionId: String!) {
  paymentPreviewForSubscription(
    customerId: $customerId
    subscriptionId: $subscriptionId
  ) {
    ...UpcomingInvoice
  }
}
    ${UpcomingInvoiceFragmentDoc}`;

/**
 * __usePaymentPreviewForSubscriptionQuery__
 *
 * To run a query within a React component, call `usePaymentPreviewForSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentPreviewForSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentPreviewForSubscriptionQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function usePaymentPreviewForSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<PaymentPreviewForSubscriptionQuery, PaymentPreviewForSubscriptionQueryVariables> & ({ variables: PaymentPreviewForSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentPreviewForSubscriptionQuery, PaymentPreviewForSubscriptionQueryVariables>(PaymentPreviewForSubscriptionDocument, options);
      }
export function usePaymentPreviewForSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentPreviewForSubscriptionQuery, PaymentPreviewForSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentPreviewForSubscriptionQuery, PaymentPreviewForSubscriptionQueryVariables>(PaymentPreviewForSubscriptionDocument, options);
        }
export function usePaymentPreviewForSubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentPreviewForSubscriptionQuery, PaymentPreviewForSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentPreviewForSubscriptionQuery, PaymentPreviewForSubscriptionQueryVariables>(PaymentPreviewForSubscriptionDocument, options);
        }
export type PaymentPreviewForSubscriptionQueryHookResult = ReturnType<typeof usePaymentPreviewForSubscriptionQuery>;
export type PaymentPreviewForSubscriptionLazyQueryHookResult = ReturnType<typeof usePaymentPreviewForSubscriptionLazyQuery>;
export type PaymentPreviewForSubscriptionSuspenseQueryHookResult = ReturnType<typeof usePaymentPreviewForSubscriptionSuspenseQuery>;
export type PaymentPreviewForSubscriptionQueryResult = Apollo.QueryResult<PaymentPreviewForSubscriptionQuery, PaymentPreviewForSubscriptionQueryVariables>;
export const TaxIdsDataDocument = gql`
    query TaxIdsData {
  taxIdsData {
    country
    countryCode
    enum
    shortName
    description
    example
  }
}
    `;

/**
 * __useTaxIdsDataQuery__
 *
 * To run a query within a React component, call `useTaxIdsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxIdsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxIdsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaxIdsDataQuery(baseOptions?: Apollo.QueryHookOptions<TaxIdsDataQuery, TaxIdsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxIdsDataQuery, TaxIdsDataQueryVariables>(TaxIdsDataDocument, options);
      }
export function useTaxIdsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxIdsDataQuery, TaxIdsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxIdsDataQuery, TaxIdsDataQueryVariables>(TaxIdsDataDocument, options);
        }
export function useTaxIdsDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaxIdsDataQuery, TaxIdsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxIdsDataQuery, TaxIdsDataQueryVariables>(TaxIdsDataDocument, options);
        }
export type TaxIdsDataQueryHookResult = ReturnType<typeof useTaxIdsDataQuery>;
export type TaxIdsDataLazyQueryHookResult = ReturnType<typeof useTaxIdsDataLazyQuery>;
export type TaxIdsDataSuspenseQueryHookResult = ReturnType<typeof useTaxIdsDataSuspenseQuery>;
export type TaxIdsDataQueryResult = Apollo.QueryResult<TaxIdsDataQuery, TaxIdsDataQueryVariables>;
export const CreateFuturePaymentsSetupIntentDocument = gql`
    mutation CreateFuturePaymentsSetupIntent($customerId: String!) {
  createFuturePaymentsSetupIntent(customerId: $customerId) {
    clientSecret
  }
}
    `;
export type CreateFuturePaymentsSetupIntentMutationFn = Apollo.MutationFunction<CreateFuturePaymentsSetupIntentMutation, CreateFuturePaymentsSetupIntentMutationVariables>;

/**
 * __useCreateFuturePaymentsSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateFuturePaymentsSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFuturePaymentsSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFuturePaymentsSetupIntentMutation, { data, loading, error }] = useCreateFuturePaymentsSetupIntentMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCreateFuturePaymentsSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateFuturePaymentsSetupIntentMutation, CreateFuturePaymentsSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFuturePaymentsSetupIntentMutation, CreateFuturePaymentsSetupIntentMutationVariables>(CreateFuturePaymentsSetupIntentDocument, options);
      }
export type CreateFuturePaymentsSetupIntentMutationHookResult = ReturnType<typeof useCreateFuturePaymentsSetupIntentMutation>;
export type CreateFuturePaymentsSetupIntentMutationResult = Apollo.MutationResult<CreateFuturePaymentsSetupIntentMutation>;
export type CreateFuturePaymentsSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateFuturePaymentsSetupIntentMutation, CreateFuturePaymentsSetupIntentMutationVariables>;
export const SubmitProductNpsDocument = gql`
    mutation SubmitProductNPS($input: SubmitSurveyInput!) {
  submitProductNPS(input: $input) {
    id
    surveyId
    score
  }
}
    `;
export type SubmitProductNpsMutationFn = Apollo.MutationFunction<SubmitProductNpsMutation, SubmitProductNpsMutationVariables>;

/**
 * __useSubmitProductNpsMutation__
 *
 * To run a mutation, you first call `useSubmitProductNpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitProductNpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitProductNpsMutation, { data, loading, error }] = useSubmitProductNpsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitProductNpsMutation(baseOptions?: Apollo.MutationHookOptions<SubmitProductNpsMutation, SubmitProductNpsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitProductNpsMutation, SubmitProductNpsMutationVariables>(SubmitProductNpsDocument, options);
      }
export type SubmitProductNpsMutationHookResult = ReturnType<typeof useSubmitProductNpsMutation>;
export type SubmitProductNpsMutationResult = Apollo.MutationResult<SubmitProductNpsMutation>;
export type SubmitProductNpsMutationOptions = Apollo.BaseMutationOptions<SubmitProductNpsMutation, SubmitProductNpsMutationVariables>;
export const DismissProductNpsDocument = gql`
    mutation DismissProductNPS {
  dismissProductNPS {
    id
    surveyId
    score
  }
}
    `;
export type DismissProductNpsMutationFn = Apollo.MutationFunction<DismissProductNpsMutation, DismissProductNpsMutationVariables>;

/**
 * __useDismissProductNpsMutation__
 *
 * To run a mutation, you first call `useDismissProductNpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissProductNpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissProductNpsMutation, { data, loading, error }] = useDismissProductNpsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDismissProductNpsMutation(baseOptions?: Apollo.MutationHookOptions<DismissProductNpsMutation, DismissProductNpsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissProductNpsMutation, DismissProductNpsMutationVariables>(DismissProductNpsDocument, options);
      }
export type DismissProductNpsMutationHookResult = ReturnType<typeof useDismissProductNpsMutation>;
export type DismissProductNpsMutationResult = Apollo.MutationResult<DismissProductNpsMutation>;
export type DismissProductNpsMutationOptions = Apollo.BaseMutationOptions<DismissProductNpsMutation, DismissProductNpsMutationVariables>;
export const GetPromptableProductNpsSurveyDocument = gql`
    query GetPromptableProductNPSSurvey {
  getPromptableProductNPSSurvey {
    survey {
      id
      name
      question
    }
  }
}
    `;

/**
 * __useGetPromptableProductNpsSurveyQuery__
 *
 * To run a query within a React component, call `useGetPromptableProductNpsSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromptableProductNpsSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromptableProductNpsSurveyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPromptableProductNpsSurveyQuery(baseOptions?: Apollo.QueryHookOptions<GetPromptableProductNpsSurveyQuery, GetPromptableProductNpsSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPromptableProductNpsSurveyQuery, GetPromptableProductNpsSurveyQueryVariables>(GetPromptableProductNpsSurveyDocument, options);
      }
export function useGetPromptableProductNpsSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPromptableProductNpsSurveyQuery, GetPromptableProductNpsSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPromptableProductNpsSurveyQuery, GetPromptableProductNpsSurveyQueryVariables>(GetPromptableProductNpsSurveyDocument, options);
        }
export function useGetPromptableProductNpsSurveySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPromptableProductNpsSurveyQuery, GetPromptableProductNpsSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPromptableProductNpsSurveyQuery, GetPromptableProductNpsSurveyQueryVariables>(GetPromptableProductNpsSurveyDocument, options);
        }
export type GetPromptableProductNpsSurveyQueryHookResult = ReturnType<typeof useGetPromptableProductNpsSurveyQuery>;
export type GetPromptableProductNpsSurveyLazyQueryHookResult = ReturnType<typeof useGetPromptableProductNpsSurveyLazyQuery>;
export type GetPromptableProductNpsSurveySuspenseQueryHookResult = ReturnType<typeof useGetPromptableProductNpsSurveySuspenseQuery>;
export type GetPromptableProductNpsSurveyQueryResult = Apollo.QueryResult<GetPromptableProductNpsSurveyQuery, GetPromptableProductNpsSurveyQueryVariables>;
export const FindSyncHistoryDocument = gql`
    query FindSyncHistory($syncId: String!) {
  findReverseEltSyncHistory(syncId: $syncId) {
    ...FindSyncHistoryResponse
  }
}
    ${FindSyncHistoryResponseFragmentDoc}`;

/**
 * __useFindSyncHistoryQuery__
 *
 * To run a query within a React component, call `useFindSyncHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSyncHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSyncHistoryQuery({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useFindSyncHistoryQuery(baseOptions: Apollo.QueryHookOptions<FindSyncHistoryQuery, FindSyncHistoryQueryVariables> & ({ variables: FindSyncHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSyncHistoryQuery, FindSyncHistoryQueryVariables>(FindSyncHistoryDocument, options);
      }
export function useFindSyncHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSyncHistoryQuery, FindSyncHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSyncHistoryQuery, FindSyncHistoryQueryVariables>(FindSyncHistoryDocument, options);
        }
export function useFindSyncHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindSyncHistoryQuery, FindSyncHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindSyncHistoryQuery, FindSyncHistoryQueryVariables>(FindSyncHistoryDocument, options);
        }
export type FindSyncHistoryQueryHookResult = ReturnType<typeof useFindSyncHistoryQuery>;
export type FindSyncHistoryLazyQueryHookResult = ReturnType<typeof useFindSyncHistoryLazyQuery>;
export type FindSyncHistorySuspenseQueryHookResult = ReturnType<typeof useFindSyncHistorySuspenseQuery>;
export type FindSyncHistoryQueryResult = Apollo.QueryResult<FindSyncHistoryQuery, FindSyncHistoryQueryVariables>;
export const EltSyncSnapshotStateDocument = gql`
    query EltSyncSnapshotState($syncId: String!) {
  eltSyncSnapshotState(syncId: $syncId) {
    ...EltSyncSnapshotState
  }
}
    ${EltSyncSnapshotStateFragmentDoc}`;

/**
 * __useEltSyncSnapshotStateQuery__
 *
 * To run a query within a React component, call `useEltSyncSnapshotStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEltSyncSnapshotStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEltSyncSnapshotStateQuery({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useEltSyncSnapshotStateQuery(baseOptions: Apollo.QueryHookOptions<EltSyncSnapshotStateQuery, EltSyncSnapshotStateQueryVariables> & ({ variables: EltSyncSnapshotStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EltSyncSnapshotStateQuery, EltSyncSnapshotStateQueryVariables>(EltSyncSnapshotStateDocument, options);
      }
export function useEltSyncSnapshotStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EltSyncSnapshotStateQuery, EltSyncSnapshotStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EltSyncSnapshotStateQuery, EltSyncSnapshotStateQueryVariables>(EltSyncSnapshotStateDocument, options);
        }
export function useEltSyncSnapshotStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EltSyncSnapshotStateQuery, EltSyncSnapshotStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EltSyncSnapshotStateQuery, EltSyncSnapshotStateQueryVariables>(EltSyncSnapshotStateDocument, options);
        }
export type EltSyncSnapshotStateQueryHookResult = ReturnType<typeof useEltSyncSnapshotStateQuery>;
export type EltSyncSnapshotStateLazyQueryHookResult = ReturnType<typeof useEltSyncSnapshotStateLazyQuery>;
export type EltSyncSnapshotStateSuspenseQueryHookResult = ReturnType<typeof useEltSyncSnapshotStateSuspenseQuery>;
export type EltSyncSnapshotStateQueryResult = Apollo.QueryResult<EltSyncSnapshotStateQuery, EltSyncSnapshotStateQueryVariables>;
export const PaginatedEltSyncHistoryDocument = gql`
    query PaginatedEltSyncHistory($input: PaginatedSyncHistoryInput!) {
  paginatedEltSyncHistory(input: $input) {
    items {
      ...FindSyncHistoryResponse
    }
    nextCursor
    hasMore
  }
}
    ${FindSyncHistoryResponseFragmentDoc}`;

/**
 * __usePaginatedEltSyncHistoryQuery__
 *
 * To run a query within a React component, call `usePaginatedEltSyncHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedEltSyncHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedEltSyncHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedEltSyncHistoryQuery(baseOptions: Apollo.QueryHookOptions<PaginatedEltSyncHistoryQuery, PaginatedEltSyncHistoryQueryVariables> & ({ variables: PaginatedEltSyncHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedEltSyncHistoryQuery, PaginatedEltSyncHistoryQueryVariables>(PaginatedEltSyncHistoryDocument, options);
      }
export function usePaginatedEltSyncHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedEltSyncHistoryQuery, PaginatedEltSyncHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedEltSyncHistoryQuery, PaginatedEltSyncHistoryQueryVariables>(PaginatedEltSyncHistoryDocument, options);
        }
export function usePaginatedEltSyncHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaginatedEltSyncHistoryQuery, PaginatedEltSyncHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaginatedEltSyncHistoryQuery, PaginatedEltSyncHistoryQueryVariables>(PaginatedEltSyncHistoryDocument, options);
        }
export type PaginatedEltSyncHistoryQueryHookResult = ReturnType<typeof usePaginatedEltSyncHistoryQuery>;
export type PaginatedEltSyncHistoryLazyQueryHookResult = ReturnType<typeof usePaginatedEltSyncHistoryLazyQuery>;
export type PaginatedEltSyncHistorySuspenseQueryHookResult = ReturnType<typeof usePaginatedEltSyncHistorySuspenseQuery>;
export type PaginatedEltSyncHistoryQueryResult = Apollo.QueryResult<PaginatedEltSyncHistoryQuery, PaginatedEltSyncHistoryQueryVariables>;
export const GetJobLogsDocument = gql`
    query GetJobLogs($jobId: String) {
  getJobLogs(jobId: $jobId) {
    status
    timestamp
    message
  }
}
    `;

/**
 * __useGetJobLogsQuery__
 *
 * To run a query within a React component, call `useGetJobLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobLogsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetJobLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobLogsQuery, GetJobLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobLogsQuery, GetJobLogsQueryVariables>(GetJobLogsDocument, options);
      }
export function useGetJobLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobLogsQuery, GetJobLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobLogsQuery, GetJobLogsQueryVariables>(GetJobLogsDocument, options);
        }
export function useGetJobLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobLogsQuery, GetJobLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobLogsQuery, GetJobLogsQueryVariables>(GetJobLogsDocument, options);
        }
export type GetJobLogsQueryHookResult = ReturnType<typeof useGetJobLogsQuery>;
export type GetJobLogsLazyQueryHookResult = ReturnType<typeof useGetJobLogsLazyQuery>;
export type GetJobLogsSuspenseQueryHookResult = ReturnType<typeof useGetJobLogsSuspenseQuery>;
export type GetJobLogsQueryResult = Apollo.QueryResult<GetJobLogsQuery, GetJobLogsQueryVariables>;
export const ActiveInitialSyncsDocument = gql`
    query ActiveInitialSyncs {
  activeInitialSyncs {
    id
  }
}
    `;

/**
 * __useActiveInitialSyncsQuery__
 *
 * To run a query within a React component, call `useActiveInitialSyncsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveInitialSyncsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveInitialSyncsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveInitialSyncsQuery(baseOptions?: Apollo.QueryHookOptions<ActiveInitialSyncsQuery, ActiveInitialSyncsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveInitialSyncsQuery, ActiveInitialSyncsQueryVariables>(ActiveInitialSyncsDocument, options);
      }
export function useActiveInitialSyncsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveInitialSyncsQuery, ActiveInitialSyncsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveInitialSyncsQuery, ActiveInitialSyncsQueryVariables>(ActiveInitialSyncsDocument, options);
        }
export function useActiveInitialSyncsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActiveInitialSyncsQuery, ActiveInitialSyncsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveInitialSyncsQuery, ActiveInitialSyncsQueryVariables>(ActiveInitialSyncsDocument, options);
        }
export type ActiveInitialSyncsQueryHookResult = ReturnType<typeof useActiveInitialSyncsQuery>;
export type ActiveInitialSyncsLazyQueryHookResult = ReturnType<typeof useActiveInitialSyncsLazyQuery>;
export type ActiveInitialSyncsSuspenseQueryHookResult = ReturnType<typeof useActiveInitialSyncsSuspenseQuery>;
export type ActiveInitialSyncsQueryResult = Apollo.QueryResult<ActiveInitialSyncsQuery, ActiveInitialSyncsQueryVariables>;
export const InitialSyncsStatusDocument = gql`
    query InitialSyncsStatus($syncIds: [String!]!) {
  initialSyncsStatus(syncIds: $syncIds) {
    syncId
    integrationId
    status
    startedAt
    finishedAt
    duration
    isChunkedSync
    tableStats {
      running
      completed
      failed
      total
      recordsSynced
      bytesSynced
    }
  }
}
    `;

/**
 * __useInitialSyncsStatusQuery__
 *
 * To run a query within a React component, call `useInitialSyncsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitialSyncsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitialSyncsStatusQuery({
 *   variables: {
 *      syncIds: // value for 'syncIds'
 *   },
 * });
 */
export function useInitialSyncsStatusQuery(baseOptions: Apollo.QueryHookOptions<InitialSyncsStatusQuery, InitialSyncsStatusQueryVariables> & ({ variables: InitialSyncsStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitialSyncsStatusQuery, InitialSyncsStatusQueryVariables>(InitialSyncsStatusDocument, options);
      }
export function useInitialSyncsStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitialSyncsStatusQuery, InitialSyncsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitialSyncsStatusQuery, InitialSyncsStatusQueryVariables>(InitialSyncsStatusDocument, options);
        }
export function useInitialSyncsStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InitialSyncsStatusQuery, InitialSyncsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InitialSyncsStatusQuery, InitialSyncsStatusQueryVariables>(InitialSyncsStatusDocument, options);
        }
export type InitialSyncsStatusQueryHookResult = ReturnType<typeof useInitialSyncsStatusQuery>;
export type InitialSyncsStatusLazyQueryHookResult = ReturnType<typeof useInitialSyncsStatusLazyQuery>;
export type InitialSyncsStatusSuspenseQueryHookResult = ReturnType<typeof useInitialSyncsStatusSuspenseQuery>;
export type InitialSyncsStatusQueryResult = Apollo.QueryResult<InitialSyncsStatusQuery, InitialSyncsStatusQueryVariables>;
export const CreateReverseEtlSyncDocument = gql`
    mutation CreateReverseEtlSync($sourceConnectionId: String!, $destinationConnectionId: String!, $sourceId: String!, $sourceType: SourceType!, $operations: [CreateOperationInput!]!, $primaryObject: String!, $primaryObjectId: String, $syncInterval: String, $config: String, $schedulerType: OrchestrationSchedulerType!, $orchestrationWorkflowId: ID) {
  createReverseEtlSync(
    input: {sourceConnectionId: $sourceConnectionId, destinationConnectionId: $destinationConnectionId, sourceId: $sourceId, sourceType: $sourceType, operations: $operations, primaryObject: $primaryObject, primaryObjectId: $primaryObjectId, syncInterval: $syncInterval, config: $config, schedulerType: $schedulerType, orchestrationWorkflowId: $orchestrationWorkflowId}
  ) {
    ...ReverseETLSync
  }
}
    ${ReverseEtlSyncFragmentDoc}`;
export type CreateReverseEtlSyncMutationFn = Apollo.MutationFunction<CreateReverseEtlSyncMutation, CreateReverseEtlSyncMutationVariables>;

/**
 * __useCreateReverseEtlSyncMutation__
 *
 * To run a mutation, you first call `useCreateReverseEtlSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReverseEtlSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReverseEtlSyncMutation, { data, loading, error }] = useCreateReverseEtlSyncMutation({
 *   variables: {
 *      sourceConnectionId: // value for 'sourceConnectionId'
 *      destinationConnectionId: // value for 'destinationConnectionId'
 *      sourceId: // value for 'sourceId'
 *      sourceType: // value for 'sourceType'
 *      operations: // value for 'operations'
 *      primaryObject: // value for 'primaryObject'
 *      primaryObjectId: // value for 'primaryObjectId'
 *      syncInterval: // value for 'syncInterval'
 *      config: // value for 'config'
 *      schedulerType: // value for 'schedulerType'
 *      orchestrationWorkflowId: // value for 'orchestrationWorkflowId'
 *   },
 * });
 */
export function useCreateReverseEtlSyncMutation(baseOptions?: Apollo.MutationHookOptions<CreateReverseEtlSyncMutation, CreateReverseEtlSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReverseEtlSyncMutation, CreateReverseEtlSyncMutationVariables>(CreateReverseEtlSyncDocument, options);
      }
export type CreateReverseEtlSyncMutationHookResult = ReturnType<typeof useCreateReverseEtlSyncMutation>;
export type CreateReverseEtlSyncMutationResult = Apollo.MutationResult<CreateReverseEtlSyncMutation>;
export type CreateReverseEtlSyncMutationOptions = Apollo.BaseMutationOptions<CreateReverseEtlSyncMutation, CreateReverseEtlSyncMutationVariables>;
export const UpdateSyncDocument = gql`
    mutation UpdateSync($syncId: String!, $operations: [CreateOperationInput!]!, $syncInterval: String, $config: String, $schedulerType: OrchestrationSchedulerType!, $orchestrationWorkflowId: ID) {
  updateSync(
    input: {syncId: $syncId, operations: $operations, syncInterval: $syncInterval, config: $config, schedulerType: $schedulerType, orchestrationWorkflowId: $orchestrationWorkflowId}
  ) {
    id
    sourceConnectionId
    destinationConnectionId
  }
}
    `;
export type UpdateSyncMutationFn = Apollo.MutationFunction<UpdateSyncMutation, UpdateSyncMutationVariables>;

/**
 * __useUpdateSyncMutation__
 *
 * To run a mutation, you first call `useUpdateSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSyncMutation, { data, loading, error }] = useUpdateSyncMutation({
 *   variables: {
 *      syncId: // value for 'syncId'
 *      operations: // value for 'operations'
 *      syncInterval: // value for 'syncInterval'
 *      config: // value for 'config'
 *      schedulerType: // value for 'schedulerType'
 *      orchestrationWorkflowId: // value for 'orchestrationWorkflowId'
 *   },
 * });
 */
export function useUpdateSyncMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSyncMutation, UpdateSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSyncMutation, UpdateSyncMutationVariables>(UpdateSyncDocument, options);
      }
export type UpdateSyncMutationHookResult = ReturnType<typeof useUpdateSyncMutation>;
export type UpdateSyncMutationResult = Apollo.MutationResult<UpdateSyncMutation>;
export type UpdateSyncMutationOptions = Apollo.BaseMutationOptions<UpdateSyncMutation, UpdateSyncMutationVariables>;
export const StartSyncDocument = gql`
    mutation StartSync($syncId: String!) {
  startSync(input: {id: $syncId}) {
    id
  }
}
    `;
export type StartSyncMutationFn = Apollo.MutationFunction<StartSyncMutation, StartSyncMutationVariables>;

/**
 * __useStartSyncMutation__
 *
 * To run a mutation, you first call `useStartSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSyncMutation, { data, loading, error }] = useStartSyncMutation({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useStartSyncMutation(baseOptions?: Apollo.MutationHookOptions<StartSyncMutation, StartSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSyncMutation, StartSyncMutationVariables>(StartSyncDocument, options);
      }
export type StartSyncMutationHookResult = ReturnType<typeof useStartSyncMutation>;
export type StartSyncMutationResult = Apollo.MutationResult<StartSyncMutation>;
export type StartSyncMutationOptions = Apollo.BaseMutationOptions<StartSyncMutation, StartSyncMutationVariables>;
export const StopSyncDocument = gql`
    mutation StopSync($syncId: String!) {
  stopSync(input: {id: $syncId}) {
    id
  }
}
    `;
export type StopSyncMutationFn = Apollo.MutationFunction<StopSyncMutation, StopSyncMutationVariables>;

/**
 * __useStopSyncMutation__
 *
 * To run a mutation, you first call `useStopSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopSyncMutation, { data, loading, error }] = useStopSyncMutation({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useStopSyncMutation(baseOptions?: Apollo.MutationHookOptions<StopSyncMutation, StopSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopSyncMutation, StopSyncMutationVariables>(StopSyncDocument, options);
      }
export type StopSyncMutationHookResult = ReturnType<typeof useStopSyncMutation>;
export type StopSyncMutationResult = Apollo.MutationResult<StopSyncMutation>;
export type StopSyncMutationOptions = Apollo.BaseMutationOptions<StopSyncMutation, StopSyncMutationVariables>;
export const CheckOnDemandReverseEtlSyncEligibilityDocument = gql`
    query CheckOnDemandReverseETLSyncEligibility($syncId: String!) {
  checkOnDemandReverseEtlSyncEligibility(input: {id: $syncId}) {
    possible
    reason
  }
}
    `;

/**
 * __useCheckOnDemandReverseEtlSyncEligibilityQuery__
 *
 * To run a query within a React component, call `useCheckOnDemandReverseEtlSyncEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckOnDemandReverseEtlSyncEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckOnDemandReverseEtlSyncEligibilityQuery({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useCheckOnDemandReverseEtlSyncEligibilityQuery(baseOptions: Apollo.QueryHookOptions<CheckOnDemandReverseEtlSyncEligibilityQuery, CheckOnDemandReverseEtlSyncEligibilityQueryVariables> & ({ variables: CheckOnDemandReverseEtlSyncEligibilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckOnDemandReverseEtlSyncEligibilityQuery, CheckOnDemandReverseEtlSyncEligibilityQueryVariables>(CheckOnDemandReverseEtlSyncEligibilityDocument, options);
      }
export function useCheckOnDemandReverseEtlSyncEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckOnDemandReverseEtlSyncEligibilityQuery, CheckOnDemandReverseEtlSyncEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckOnDemandReverseEtlSyncEligibilityQuery, CheckOnDemandReverseEtlSyncEligibilityQueryVariables>(CheckOnDemandReverseEtlSyncEligibilityDocument, options);
        }
export function useCheckOnDemandReverseEtlSyncEligibilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckOnDemandReverseEtlSyncEligibilityQuery, CheckOnDemandReverseEtlSyncEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckOnDemandReverseEtlSyncEligibilityQuery, CheckOnDemandReverseEtlSyncEligibilityQueryVariables>(CheckOnDemandReverseEtlSyncEligibilityDocument, options);
        }
export type CheckOnDemandReverseEtlSyncEligibilityQueryHookResult = ReturnType<typeof useCheckOnDemandReverseEtlSyncEligibilityQuery>;
export type CheckOnDemandReverseEtlSyncEligibilityLazyQueryHookResult = ReturnType<typeof useCheckOnDemandReverseEtlSyncEligibilityLazyQuery>;
export type CheckOnDemandReverseEtlSyncEligibilitySuspenseQueryHookResult = ReturnType<typeof useCheckOnDemandReverseEtlSyncEligibilitySuspenseQuery>;
export type CheckOnDemandReverseEtlSyncEligibilityQueryResult = Apollo.QueryResult<CheckOnDemandReverseEtlSyncEligibilityQuery, CheckOnDemandReverseEtlSyncEligibilityQueryVariables>;
export const RunRevEtlSyncNowDocument = gql`
    mutation RunRevEtlSyncNow($syncId: String!) {
  runSyncNow(input: {id: $syncId})
}
    `;
export type RunRevEtlSyncNowMutationFn = Apollo.MutationFunction<RunRevEtlSyncNowMutation, RunRevEtlSyncNowMutationVariables>;

/**
 * __useRunRevEtlSyncNowMutation__
 *
 * To run a mutation, you first call `useRunRevEtlSyncNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunRevEtlSyncNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runRevEtlSyncNowMutation, { data, loading, error }] = useRunRevEtlSyncNowMutation({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useRunRevEtlSyncNowMutation(baseOptions?: Apollo.MutationHookOptions<RunRevEtlSyncNowMutation, RunRevEtlSyncNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunRevEtlSyncNowMutation, RunRevEtlSyncNowMutationVariables>(RunRevEtlSyncNowDocument, options);
      }
export type RunRevEtlSyncNowMutationHookResult = ReturnType<typeof useRunRevEtlSyncNowMutation>;
export type RunRevEtlSyncNowMutationResult = Apollo.MutationResult<RunRevEtlSyncNowMutation>;
export type RunRevEtlSyncNowMutationOptions = Apollo.BaseMutationOptions<RunRevEtlSyncNowMutation, RunRevEtlSyncNowMutationVariables>;
export const RemoveSyncDocument = gql`
    mutation RemoveSync($syncId: String!) {
  removeSync(input: {id: $syncId}) {
    id
  }
}
    `;
export type RemoveSyncMutationFn = Apollo.MutationFunction<RemoveSyncMutation, RemoveSyncMutationVariables>;

/**
 * __useRemoveSyncMutation__
 *
 * To run a mutation, you first call `useRemoveSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSyncMutation, { data, loading, error }] = useRemoveSyncMutation({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useRemoveSyncMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSyncMutation, RemoveSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSyncMutation, RemoveSyncMutationVariables>(RemoveSyncDocument, options);
      }
export type RemoveSyncMutationHookResult = ReturnType<typeof useRemoveSyncMutation>;
export type RemoveSyncMutationResult = Apollo.MutationResult<RemoveSyncMutation>;
export type RemoveSyncMutationOptions = Apollo.BaseMutationOptions<RemoveSyncMutation, RemoveSyncMutationVariables>;
export const ListSyncsDocument = gql`
    query ListSyncs {
  syncs {
    ...SyncListItem
  }
}
    ${SyncListItemFragmentDoc}`;

/**
 * __useListSyncsQuery__
 *
 * To run a query within a React component, call `useListSyncsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSyncsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSyncsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListSyncsQuery(baseOptions?: Apollo.QueryHookOptions<ListSyncsQuery, ListSyncsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSyncsQuery, ListSyncsQueryVariables>(ListSyncsDocument, options);
      }
export function useListSyncsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSyncsQuery, ListSyncsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSyncsQuery, ListSyncsQueryVariables>(ListSyncsDocument, options);
        }
export function useListSyncsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSyncsQuery, ListSyncsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSyncsQuery, ListSyncsQueryVariables>(ListSyncsDocument, options);
        }
export type ListSyncsQueryHookResult = ReturnType<typeof useListSyncsQuery>;
export type ListSyncsLazyQueryHookResult = ReturnType<typeof useListSyncsLazyQuery>;
export type ListSyncsSuspenseQueryHookResult = ReturnType<typeof useListSyncsSuspenseQuery>;
export type ListSyncsQueryResult = Apollo.QueryResult<ListSyncsQuery, ListSyncsQueryVariables>;
export const FindOneSyncDocument = gql`
    query FindOneSync($syncId: String!) {
  findOneSync(id: $syncId) {
    ...ReverseETLSync
  }
}
    ${ReverseEtlSyncFragmentDoc}`;

/**
 * __useFindOneSyncQuery__
 *
 * To run a query within a React component, call `useFindOneSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOneSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOneSyncQuery({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useFindOneSyncQuery(baseOptions: Apollo.QueryHookOptions<FindOneSyncQuery, FindOneSyncQueryVariables> & ({ variables: FindOneSyncQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOneSyncQuery, FindOneSyncQueryVariables>(FindOneSyncDocument, options);
      }
export function useFindOneSyncLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOneSyncQuery, FindOneSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOneSyncQuery, FindOneSyncQueryVariables>(FindOneSyncDocument, options);
        }
export function useFindOneSyncSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindOneSyncQuery, FindOneSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindOneSyncQuery, FindOneSyncQueryVariables>(FindOneSyncDocument, options);
        }
export type FindOneSyncQueryHookResult = ReturnType<typeof useFindOneSyncQuery>;
export type FindOneSyncLazyQueryHookResult = ReturnType<typeof useFindOneSyncLazyQuery>;
export type FindOneSyncSuspenseQueryHookResult = ReturnType<typeof useFindOneSyncSuspenseQuery>;
export type FindOneSyncQueryResult = Apollo.QueryResult<FindOneSyncQuery, FindOneSyncQueryVariables>;
export const GetSyncErrorsDocument = gql`
    query GetSyncErrors($id: String!) {
  getErrors(id: $id) {
    objectId
    scheduledJobId
    syncId
    error
  }
}
    `;

/**
 * __useGetSyncErrorsQuery__
 *
 * To run a query within a React component, call `useGetSyncErrorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSyncErrorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSyncErrorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSyncErrorsQuery(baseOptions: Apollo.QueryHookOptions<GetSyncErrorsQuery, GetSyncErrorsQueryVariables> & ({ variables: GetSyncErrorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSyncErrorsQuery, GetSyncErrorsQueryVariables>(GetSyncErrorsDocument, options);
      }
export function useGetSyncErrorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSyncErrorsQuery, GetSyncErrorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSyncErrorsQuery, GetSyncErrorsQueryVariables>(GetSyncErrorsDocument, options);
        }
export function useGetSyncErrorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSyncErrorsQuery, GetSyncErrorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSyncErrorsQuery, GetSyncErrorsQueryVariables>(GetSyncErrorsDocument, options);
        }
export type GetSyncErrorsQueryHookResult = ReturnType<typeof useGetSyncErrorsQuery>;
export type GetSyncErrorsLazyQueryHookResult = ReturnType<typeof useGetSyncErrorsLazyQuery>;
export type GetSyncErrorsSuspenseQueryHookResult = ReturnType<typeof useGetSyncErrorsSuspenseQuery>;
export type GetSyncErrorsQueryResult = Apollo.QueryResult<GetSyncErrorsQuery, GetSyncErrorsQueryVariables>;
export const ResetErrorsDocument = gql`
    mutation ResetErrors($id: String!, $objectIds: [String!]!) {
  resetErrors(id: $id, objectIds: $objectIds)
}
    `;
export type ResetErrorsMutationFn = Apollo.MutationFunction<ResetErrorsMutation, ResetErrorsMutationVariables>;

/**
 * __useResetErrorsMutation__
 *
 * To run a mutation, you first call `useResetErrorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetErrorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetErrorsMutation, { data, loading, error }] = useResetErrorsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      objectIds: // value for 'objectIds'
 *   },
 * });
 */
export function useResetErrorsMutation(baseOptions?: Apollo.MutationHookOptions<ResetErrorsMutation, ResetErrorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetErrorsMutation, ResetErrorsMutationVariables>(ResetErrorsDocument, options);
      }
export type ResetErrorsMutationHookResult = ReturnType<typeof useResetErrorsMutation>;
export type ResetErrorsMutationResult = Apollo.MutationResult<ResetErrorsMutation>;
export type ResetErrorsMutationOptions = Apollo.BaseMutationOptions<ResetErrorsMutation, ResetErrorsMutationVariables>;
export const ResetAllErrorsDocument = gql`
    mutation ResetAllErrors($id: String!) {
  resetAllErrors(id: $id)
}
    `;
export type ResetAllErrorsMutationFn = Apollo.MutationFunction<ResetAllErrorsMutation, ResetAllErrorsMutationVariables>;

/**
 * __useResetAllErrorsMutation__
 *
 * To run a mutation, you first call `useResetAllErrorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAllErrorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAllErrorsMutation, { data, loading, error }] = useResetAllErrorsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetAllErrorsMutation(baseOptions?: Apollo.MutationHookOptions<ResetAllErrorsMutation, ResetAllErrorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetAllErrorsMutation, ResetAllErrorsMutationVariables>(ResetAllErrorsDocument, options);
      }
export type ResetAllErrorsMutationHookResult = ReturnType<typeof useResetAllErrorsMutation>;
export type ResetAllErrorsMutationResult = Apollo.MutationResult<ResetAllErrorsMutation>;
export type ResetAllErrorsMutationOptions = Apollo.BaseMutationOptions<ResetAllErrorsMutation, ResetAllErrorsMutationVariables>;
export const ReverseEtlJobsCompletionStatsDocument = gql`
    query ReverseEtlJobsCompletionStats($from: DateTime, $to: DateTime) {
  reverseEtlJobsCompletionStats(from: $from, to: $to) {
    stats {
      total
      successCount
      successPercent
      failureCount
      failurePercent
    }
  }
}
    `;

/**
 * __useReverseEtlJobsCompletionStatsQuery__
 *
 * To run a query within a React component, call `useReverseEtlJobsCompletionStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReverseEtlJobsCompletionStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReverseEtlJobsCompletionStatsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useReverseEtlJobsCompletionStatsQuery(baseOptions?: Apollo.QueryHookOptions<ReverseEtlJobsCompletionStatsQuery, ReverseEtlJobsCompletionStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReverseEtlJobsCompletionStatsQuery, ReverseEtlJobsCompletionStatsQueryVariables>(ReverseEtlJobsCompletionStatsDocument, options);
      }
export function useReverseEtlJobsCompletionStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReverseEtlJobsCompletionStatsQuery, ReverseEtlJobsCompletionStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReverseEtlJobsCompletionStatsQuery, ReverseEtlJobsCompletionStatsQueryVariables>(ReverseEtlJobsCompletionStatsDocument, options);
        }
export function useReverseEtlJobsCompletionStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReverseEtlJobsCompletionStatsQuery, ReverseEtlJobsCompletionStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReverseEtlJobsCompletionStatsQuery, ReverseEtlJobsCompletionStatsQueryVariables>(ReverseEtlJobsCompletionStatsDocument, options);
        }
export type ReverseEtlJobsCompletionStatsQueryHookResult = ReturnType<typeof useReverseEtlJobsCompletionStatsQuery>;
export type ReverseEtlJobsCompletionStatsLazyQueryHookResult = ReturnType<typeof useReverseEtlJobsCompletionStatsLazyQuery>;
export type ReverseEtlJobsCompletionStatsSuspenseQueryHookResult = ReturnType<typeof useReverseEtlJobsCompletionStatsSuspenseQuery>;
export type ReverseEtlJobsCompletionStatsQueryResult = Apollo.QueryResult<ReverseEtlJobsCompletionStatsQuery, ReverseEtlJobsCompletionStatsQueryVariables>;
export const ReverseEtlJobStatusDocument = gql`
    query ReverseEtlJobStatus($syncId: String!) {
  findOneSync(id: $syncId) {
    job {
      ...RevEtlJobStatus
    }
  }
}
    ${RevEtlJobStatusFragmentDoc}`;

/**
 * __useReverseEtlJobStatusQuery__
 *
 * To run a query within a React component, call `useReverseEtlJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useReverseEtlJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReverseEtlJobStatusQuery({
 *   variables: {
 *      syncId: // value for 'syncId'
 *   },
 * });
 */
export function useReverseEtlJobStatusQuery(baseOptions: Apollo.QueryHookOptions<ReverseEtlJobStatusQuery, ReverseEtlJobStatusQueryVariables> & ({ variables: ReverseEtlJobStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReverseEtlJobStatusQuery, ReverseEtlJobStatusQueryVariables>(ReverseEtlJobStatusDocument, options);
      }
export function useReverseEtlJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReverseEtlJobStatusQuery, ReverseEtlJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReverseEtlJobStatusQuery, ReverseEtlJobStatusQueryVariables>(ReverseEtlJobStatusDocument, options);
        }
export function useReverseEtlJobStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReverseEtlJobStatusQuery, ReverseEtlJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReverseEtlJobStatusQuery, ReverseEtlJobStatusQueryVariables>(ReverseEtlJobStatusDocument, options);
        }
export type ReverseEtlJobStatusQueryHookResult = ReturnType<typeof useReverseEtlJobStatusQuery>;
export type ReverseEtlJobStatusLazyQueryHookResult = ReturnType<typeof useReverseEtlJobStatusLazyQuery>;
export type ReverseEtlJobStatusSuspenseQueryHookResult = ReturnType<typeof useReverseEtlJobStatusSuspenseQuery>;
export type ReverseEtlJobStatusQueryResult = Apollo.QueryResult<ReverseEtlJobStatusQuery, ReverseEtlJobStatusQueryVariables>;
export const SourceSchemaDocument = gql`
    query SourceSchema($id: String!, $type: SourceType!) {
  sourceSchema(id: $id, type: $type) {
    name
    type
    nullable
  }
}
    `;

/**
 * __useSourceSchemaQuery__
 *
 * To run a query within a React component, call `useSourceSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceSchemaQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSourceSchemaQuery(baseOptions: Apollo.QueryHookOptions<SourceSchemaQuery, SourceSchemaQueryVariables> & ({ variables: SourceSchemaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourceSchemaQuery, SourceSchemaQueryVariables>(SourceSchemaDocument, options);
      }
export function useSourceSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourceSchemaQuery, SourceSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourceSchemaQuery, SourceSchemaQueryVariables>(SourceSchemaDocument, options);
        }
export function useSourceSchemaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SourceSchemaQuery, SourceSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SourceSchemaQuery, SourceSchemaQueryVariables>(SourceSchemaDocument, options);
        }
export type SourceSchemaQueryHookResult = ReturnType<typeof useSourceSchemaQuery>;
export type SourceSchemaLazyQueryHookResult = ReturnType<typeof useSourceSchemaLazyQuery>;
export type SourceSchemaSuspenseQueryHookResult = ReturnType<typeof useSourceSchemaSuspenseQuery>;
export type SourceSchemaQueryResult = Apollo.QueryResult<SourceSchemaQuery, SourceSchemaQueryVariables>;
export const DestinationSchemaDocument = gql`
    query DestinationSchema($input: DestinationSchemaInput!) {
  destinationSchema(input: $input) {
    id
    propertyId
    propertyName
    propertyType
    readonly
    isRequired
    isPrimaryKey
    automapMatchAny
  }
}
    `;

/**
 * __useDestinationSchemaQuery__
 *
 * To run a query within a React component, call `useDestinationSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationSchemaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDestinationSchemaQuery(baseOptions: Apollo.QueryHookOptions<DestinationSchemaQuery, DestinationSchemaQueryVariables> & ({ variables: DestinationSchemaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DestinationSchemaQuery, DestinationSchemaQueryVariables>(DestinationSchemaDocument, options);
      }
export function useDestinationSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationSchemaQuery, DestinationSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DestinationSchemaQuery, DestinationSchemaQueryVariables>(DestinationSchemaDocument, options);
        }
export function useDestinationSchemaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DestinationSchemaQuery, DestinationSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DestinationSchemaQuery, DestinationSchemaQueryVariables>(DestinationSchemaDocument, options);
        }
export type DestinationSchemaQueryHookResult = ReturnType<typeof useDestinationSchemaQuery>;
export type DestinationSchemaLazyQueryHookResult = ReturnType<typeof useDestinationSchemaLazyQuery>;
export type DestinationSchemaSuspenseQueryHookResult = ReturnType<typeof useDestinationSchemaSuspenseQuery>;
export type DestinationSchemaQueryResult = Apollo.QueryResult<DestinationSchemaQuery, DestinationSchemaQueryVariables>;
export const WorkspaceStatsDocument = gql`
    query WorkspaceStats {
  workspaceStats {
    numConnections
    numUsers
  }
}
    `;

/**
 * __useWorkspaceStatsQuery__
 *
 * To run a query within a React component, call `useWorkspaceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceStatsQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceStatsQuery, WorkspaceStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceStatsQuery, WorkspaceStatsQueryVariables>(WorkspaceStatsDocument, options);
      }
export function useWorkspaceStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceStatsQuery, WorkspaceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceStatsQuery, WorkspaceStatsQueryVariables>(WorkspaceStatsDocument, options);
        }
export function useWorkspaceStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceStatsQuery, WorkspaceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceStatsQuery, WorkspaceStatsQueryVariables>(WorkspaceStatsDocument, options);
        }
export type WorkspaceStatsQueryHookResult = ReturnType<typeof useWorkspaceStatsQuery>;
export type WorkspaceStatsLazyQueryHookResult = ReturnType<typeof useWorkspaceStatsLazyQuery>;
export type WorkspaceStatsSuspenseQueryHookResult = ReturnType<typeof useWorkspaceStatsSuspenseQuery>;
export type WorkspaceStatsQueryResult = Apollo.QueryResult<WorkspaceStatsQuery, WorkspaceStatsQueryVariables>;
export const BigQueryUsageStatsDocument = gql`
    query BigQueryUsageStats {
  bigQueryUsageStats {
    data {
      datasetId
      tableId
      path
      totalBytesProcessed
      totalBytesBilled
      bqBilledUsd
      metabaseUsage {
        bytesProcessed
        bytesBilled
        bqBilledUsd
      }
      queryUsage {
        bytesProcessed
        bytesBilled
        bqBilledUsd
      }
    }
  }
}
    `;

/**
 * __useBigQueryUsageStatsQuery__
 *
 * To run a query within a React component, call `useBigQueryUsageStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBigQueryUsageStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBigQueryUsageStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBigQueryUsageStatsQuery(baseOptions?: Apollo.QueryHookOptions<BigQueryUsageStatsQuery, BigQueryUsageStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BigQueryUsageStatsQuery, BigQueryUsageStatsQueryVariables>(BigQueryUsageStatsDocument, options);
      }
export function useBigQueryUsageStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BigQueryUsageStatsQuery, BigQueryUsageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BigQueryUsageStatsQuery, BigQueryUsageStatsQueryVariables>(BigQueryUsageStatsDocument, options);
        }
export function useBigQueryUsageStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BigQueryUsageStatsQuery, BigQueryUsageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BigQueryUsageStatsQuery, BigQueryUsageStatsQueryVariables>(BigQueryUsageStatsDocument, options);
        }
export type BigQueryUsageStatsQueryHookResult = ReturnType<typeof useBigQueryUsageStatsQuery>;
export type BigQueryUsageStatsLazyQueryHookResult = ReturnType<typeof useBigQueryUsageStatsLazyQuery>;
export type BigQueryUsageStatsSuspenseQueryHookResult = ReturnType<typeof useBigQueryUsageStatsSuspenseQuery>;
export type BigQueryUsageStatsQueryResult = Apollo.QueryResult<BigQueryUsageStatsQuery, BigQueryUsageStatsQueryVariables>;
export const DailyUsageTotalSummaryDocument = gql`
    query DailyUsageTotalSummary($period: DailyUsagePeriodInput!) {
  dailyUsageTotalSummary(period: $period) {
    data {
      syncedRows
      activeRows
      elt {
        syncedRows
        activeRows
        syncedRowsPercentage
        activeRowsPercentage
      }
      reverseElt {
        syncedRows
        activeRows
        syncedRowsPercentage
        activeRowsPercentage
      }
    }
  }
}
    `;

/**
 * __useDailyUsageTotalSummaryQuery__
 *
 * To run a query within a React component, call `useDailyUsageTotalSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyUsageTotalSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyUsageTotalSummaryQuery({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
export function useDailyUsageTotalSummaryQuery(baseOptions: Apollo.QueryHookOptions<DailyUsageTotalSummaryQuery, DailyUsageTotalSummaryQueryVariables> & ({ variables: DailyUsageTotalSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyUsageTotalSummaryQuery, DailyUsageTotalSummaryQueryVariables>(DailyUsageTotalSummaryDocument, options);
      }
export function useDailyUsageTotalSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyUsageTotalSummaryQuery, DailyUsageTotalSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyUsageTotalSummaryQuery, DailyUsageTotalSummaryQueryVariables>(DailyUsageTotalSummaryDocument, options);
        }
export function useDailyUsageTotalSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DailyUsageTotalSummaryQuery, DailyUsageTotalSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyUsageTotalSummaryQuery, DailyUsageTotalSummaryQueryVariables>(DailyUsageTotalSummaryDocument, options);
        }
export type DailyUsageTotalSummaryQueryHookResult = ReturnType<typeof useDailyUsageTotalSummaryQuery>;
export type DailyUsageTotalSummaryLazyQueryHookResult = ReturnType<typeof useDailyUsageTotalSummaryLazyQuery>;
export type DailyUsageTotalSummarySuspenseQueryHookResult = ReturnType<typeof useDailyUsageTotalSummarySuspenseQuery>;
export type DailyUsageTotalSummaryQueryResult = Apollo.QueryResult<DailyUsageTotalSummaryQuery, DailyUsageTotalSummaryQueryVariables>;
export const DailyUsageDashboardDocument = gql`
    query DailyUsageDashboard($period: DailyUsagePeriodInput!) {
  dailyUsageDashboard(period: $period) {
    data {
      summary {
        syncedRows
        activeRows
        extraDestinationActiveRows
        elt {
          syncedRows
          activeRows
          syncedRowsPercentage
          activeRowsPercentage
        }
        reverseElt {
          syncedRows
          activeRows
          syncedRowsPercentage
          activeRowsPercentage
        }
      }
      timeline {
        date
        syncedRows
        activeRows
        runningTotalSyncedRows
        runningTotalActiveRows
        elt {
          syncedRows
          activeRows
          runningTotalSyncedRows
          runningTotalActiveRows
        }
        reverseElt {
          syncedRows
          activeRows
          runningTotalSyncedRows
          runningTotalActiveRows
        }
      }
      integrations {
        integrationId
        syncedRows
        activeRows
        elt {
          syncedRows
          activeRows
        }
        reverseElt {
          syncedRows
          activeRows
        }
      }
      destinationObjects {
        integrationId
        resource
        syncedRows
        activeRows
      }
      sourceStreams {
        integrationId
        resource
        syncedRows
        activeRows
        mainTable {
          activeRows
          syncedRows
        }
        historyTable {
          activeRows
          syncedRows
        }
        substreams {
          syncedRows
          activeRows
          historyTableSyncedRows
          breakdownComplete
          bySubstream {
            substreamId
            destinationTableName
            syncedRows
          }
        }
        extraDestinationActiveRows
      }
    }
  }
}
    `;

/**
 * __useDailyUsageDashboardQuery__
 *
 * To run a query within a React component, call `useDailyUsageDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyUsageDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyUsageDashboardQuery({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
export function useDailyUsageDashboardQuery(baseOptions: Apollo.QueryHookOptions<DailyUsageDashboardQuery, DailyUsageDashboardQueryVariables> & ({ variables: DailyUsageDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyUsageDashboardQuery, DailyUsageDashboardQueryVariables>(DailyUsageDashboardDocument, options);
      }
export function useDailyUsageDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyUsageDashboardQuery, DailyUsageDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyUsageDashboardQuery, DailyUsageDashboardQueryVariables>(DailyUsageDashboardDocument, options);
        }
export function useDailyUsageDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DailyUsageDashboardQuery, DailyUsageDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyUsageDashboardQuery, DailyUsageDashboardQueryVariables>(DailyUsageDashboardDocument, options);
        }
export type DailyUsageDashboardQueryHookResult = ReturnType<typeof useDailyUsageDashboardQuery>;
export type DailyUsageDashboardLazyQueryHookResult = ReturnType<typeof useDailyUsageDashboardLazyQuery>;
export type DailyUsageDashboardSuspenseQueryHookResult = ReturnType<typeof useDailyUsageDashboardSuspenseQuery>;
export type DailyUsageDashboardQueryResult = Apollo.QueryResult<DailyUsageDashboardQuery, DailyUsageDashboardQueryVariables>;
export const DailyUsageForecastDocument = gql`
    query DailyUsageForecast($period: DailyUsagePeriodInput!) {
  dailyUsageForecast(period: $period) {
    predictions {
      date
      runningTotalActiveRows
      runningTotalSyncedRows
    }
    dailyForecastedRate {
      syncedRows
      activeRows
    }
    forecastedRows {
      syncedRows
      activeRows
    }
    projectedTotalRows {
      syncedRows
      activeRows
    }
  }
}
    `;

/**
 * __useDailyUsageForecastQuery__
 *
 * To run a query within a React component, call `useDailyUsageForecastQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyUsageForecastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyUsageForecastQuery({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
export function useDailyUsageForecastQuery(baseOptions: Apollo.QueryHookOptions<DailyUsageForecastQuery, DailyUsageForecastQueryVariables> & ({ variables: DailyUsageForecastQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyUsageForecastQuery, DailyUsageForecastQueryVariables>(DailyUsageForecastDocument, options);
      }
export function useDailyUsageForecastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyUsageForecastQuery, DailyUsageForecastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyUsageForecastQuery, DailyUsageForecastQueryVariables>(DailyUsageForecastDocument, options);
        }
export function useDailyUsageForecastSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DailyUsageForecastQuery, DailyUsageForecastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyUsageForecastQuery, DailyUsageForecastQueryVariables>(DailyUsageForecastDocument, options);
        }
export type DailyUsageForecastQueryHookResult = ReturnType<typeof useDailyUsageForecastQuery>;
export type DailyUsageForecastLazyQueryHookResult = ReturnType<typeof useDailyUsageForecastLazyQuery>;
export type DailyUsageForecastSuspenseQueryHookResult = ReturnType<typeof useDailyUsageForecastSuspenseQuery>;
export type DailyUsageForecastQueryResult = Apollo.QueryResult<DailyUsageForecastQuery, DailyUsageForecastQueryVariables>;
export const ModelCleanupDocument = gql`
    query ModelCleanup($refresh: Boolean) {
  modelCleanup(refresh: $refresh) {
    detection
    analysedAt
    analysisWindowDays
    thresholdDays
    unused {
      modelId
      path
      lastReadAt
      unusedDependentIds
    }
    used {
      modelId
      path
      lastReadAt
      reason
      dependentModelId
    }
  }
}
    `;

/**
 * __useModelCleanupQuery__
 *
 * To run a query within a React component, call `useModelCleanupQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelCleanupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelCleanupQuery({
 *   variables: {
 *      refresh: // value for 'refresh'
 *   },
 * });
 */
export function useModelCleanupQuery(baseOptions?: Apollo.QueryHookOptions<ModelCleanupQuery, ModelCleanupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelCleanupQuery, ModelCleanupQueryVariables>(ModelCleanupDocument, options);
      }
export function useModelCleanupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelCleanupQuery, ModelCleanupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelCleanupQuery, ModelCleanupQueryVariables>(ModelCleanupDocument, options);
        }
export function useModelCleanupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ModelCleanupQuery, ModelCleanupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModelCleanupQuery, ModelCleanupQueryVariables>(ModelCleanupDocument, options);
        }
export type ModelCleanupQueryHookResult = ReturnType<typeof useModelCleanupQuery>;
export type ModelCleanupLazyQueryHookResult = ReturnType<typeof useModelCleanupLazyQuery>;
export type ModelCleanupSuspenseQueryHookResult = ReturnType<typeof useModelCleanupSuspenseQuery>;
export type ModelCleanupQueryResult = Apollo.QueryResult<ModelCleanupQuery, ModelCleanupQueryVariables>;
export const UnusedModelCandidatesDocument = gql`
    query UnusedModelCandidates {
  publishedModels {
    id
    name
    emoji
    createdAt
    materializationType
    sourcePath
    folder {
      id
      name
    }
  }
}
    `;

/**
 * __useUnusedModelCandidatesQuery__
 *
 * To run a query within a React component, call `useUnusedModelCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnusedModelCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnusedModelCandidatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnusedModelCandidatesQuery(baseOptions?: Apollo.QueryHookOptions<UnusedModelCandidatesQuery, UnusedModelCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnusedModelCandidatesQuery, UnusedModelCandidatesQueryVariables>(UnusedModelCandidatesDocument, options);
      }
export function useUnusedModelCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnusedModelCandidatesQuery, UnusedModelCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnusedModelCandidatesQuery, UnusedModelCandidatesQueryVariables>(UnusedModelCandidatesDocument, options);
        }
export function useUnusedModelCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnusedModelCandidatesQuery, UnusedModelCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnusedModelCandidatesQuery, UnusedModelCandidatesQueryVariables>(UnusedModelCandidatesDocument, options);
        }
export type UnusedModelCandidatesQueryHookResult = ReturnType<typeof useUnusedModelCandidatesQuery>;
export type UnusedModelCandidatesLazyQueryHookResult = ReturnType<typeof useUnusedModelCandidatesLazyQuery>;
export type UnusedModelCandidatesSuspenseQueryHookResult = ReturnType<typeof useUnusedModelCandidatesSuspenseQuery>;
export type UnusedModelCandidatesQueryResult = Apollo.QueryResult<UnusedModelCandidatesQuery, UnusedModelCandidatesQueryVariables>;
export const AllPlansDocument = gql`
    query AllPlans {
  allPlans {
    ...PurchasablePlanFragment
  }
}
    ${PurchasablePlanFragmentFragmentDoc}`;

/**
 * __useAllPlansQuery__
 *
 * To run a query within a React component, call `useAllPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPlansQuery(baseOptions?: Apollo.QueryHookOptions<AllPlansQuery, AllPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPlansQuery, AllPlansQueryVariables>(AllPlansDocument, options);
      }
export function useAllPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPlansQuery, AllPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPlansQuery, AllPlansQueryVariables>(AllPlansDocument, options);
        }
export function useAllPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllPlansQuery, AllPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPlansQuery, AllPlansQueryVariables>(AllPlansDocument, options);
        }
export type AllPlansQueryHookResult = ReturnType<typeof useAllPlansQuery>;
export type AllPlansLazyQueryHookResult = ReturnType<typeof useAllPlansLazyQuery>;
export type AllPlansSuspenseQueryHookResult = ReturnType<typeof useAllPlansSuspenseQuery>;
export type AllPlansQueryResult = Apollo.QueryResult<AllPlansQuery, AllPlansQueryVariables>;
export const PlanDocument = gql`
    query Plan($planName: String!) {
  plan(planName: $planName) {
    ...PurchasablePlanFragment
  }
}
    ${PurchasablePlanFragmentFragmentDoc}`;

/**
 * __usePlanQuery__
 *
 * To run a query within a React component, call `usePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanQuery({
 *   variables: {
 *      planName: // value for 'planName'
 *   },
 * });
 */
export function usePlanQuery(baseOptions: Apollo.QueryHookOptions<PlanQuery, PlanQueryVariables> & ({ variables: PlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanQuery, PlanQueryVariables>(PlanDocument, options);
      }
export function usePlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanQuery, PlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanQuery, PlanQueryVariables>(PlanDocument, options);
        }
export function usePlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlanQuery, PlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanQuery, PlanQueryVariables>(PlanDocument, options);
        }
export type PlanQueryHookResult = ReturnType<typeof usePlanQuery>;
export type PlanLazyQueryHookResult = ReturnType<typeof usePlanLazyQuery>;
export type PlanSuspenseQueryHookResult = ReturnType<typeof usePlanSuspenseQuery>;
export type PlanQueryResult = Apollo.QueryResult<PlanQuery, PlanQueryVariables>;
export const CurrentPlanStateDocument = gql`
    query CurrentPlanState {
  currentPlanState {
    plan {
      ...PlanFragment
    }
    subscription {
      ...ActiveSubscription
    }
    currentUsagePeriod {
      ...DateRange
    }
  }
}
    ${PlanFragmentFragmentDoc}
${ActiveSubscriptionFragmentDoc}
${DateRangeFragmentDoc}`;

/**
 * __useCurrentPlanStateQuery__
 *
 * To run a query within a React component, call `useCurrentPlanStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentPlanStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentPlanStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentPlanStateQuery(baseOptions?: Apollo.QueryHookOptions<CurrentPlanStateQuery, CurrentPlanStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentPlanStateQuery, CurrentPlanStateQueryVariables>(CurrentPlanStateDocument, options);
      }
export function useCurrentPlanStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentPlanStateQuery, CurrentPlanStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentPlanStateQuery, CurrentPlanStateQueryVariables>(CurrentPlanStateDocument, options);
        }
export function useCurrentPlanStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentPlanStateQuery, CurrentPlanStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentPlanStateQuery, CurrentPlanStateQueryVariables>(CurrentPlanStateDocument, options);
        }
export type CurrentPlanStateQueryHookResult = ReturnType<typeof useCurrentPlanStateQuery>;
export type CurrentPlanStateLazyQueryHookResult = ReturnType<typeof useCurrentPlanStateLazyQuery>;
export type CurrentPlanStateSuspenseQueryHookResult = ReturnType<typeof useCurrentPlanStateSuspenseQuery>;
export type CurrentPlanStateQueryResult = Apollo.QueryResult<CurrentPlanStateQuery, CurrentPlanStateQueryVariables>;
export const CurrentSubscriptionStateDocument = gql`
    query CurrentSubscriptionState {
  currentSubscriptionState {
    status
    customerId
    subscriptionId
  }
}
    `;

/**
 * __useCurrentSubscriptionStateQuery__
 *
 * To run a query within a React component, call `useCurrentSubscriptionStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentSubscriptionStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentSubscriptionStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentSubscriptionStateQuery(baseOptions?: Apollo.QueryHookOptions<CurrentSubscriptionStateQuery, CurrentSubscriptionStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentSubscriptionStateQuery, CurrentSubscriptionStateQueryVariables>(CurrentSubscriptionStateDocument, options);
      }
export function useCurrentSubscriptionStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentSubscriptionStateQuery, CurrentSubscriptionStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentSubscriptionStateQuery, CurrentSubscriptionStateQueryVariables>(CurrentSubscriptionStateDocument, options);
        }
export function useCurrentSubscriptionStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentSubscriptionStateQuery, CurrentSubscriptionStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentSubscriptionStateQuery, CurrentSubscriptionStateQueryVariables>(CurrentSubscriptionStateDocument, options);
        }
export type CurrentSubscriptionStateQueryHookResult = ReturnType<typeof useCurrentSubscriptionStateQuery>;
export type CurrentSubscriptionStateLazyQueryHookResult = ReturnType<typeof useCurrentSubscriptionStateLazyQuery>;
export type CurrentSubscriptionStateSuspenseQueryHookResult = ReturnType<typeof useCurrentSubscriptionStateSuspenseQuery>;
export type CurrentSubscriptionStateQueryResult = Apollo.QueryResult<CurrentSubscriptionStateQuery, CurrentSubscriptionStateQueryVariables>;
export const PlanLimitsStatusDocument = gql`
    query PlanLimitsStatus {
  getPlanLimitsStatus {
    isConnectionsLimitReached
    isUsersLimitReached
    seatUsage {
      ...SeatUsage
    }
  }
}
    ${SeatUsageFragmentDoc}`;

/**
 * __usePlanLimitsStatusQuery__
 *
 * To run a query within a React component, call `usePlanLimitsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanLimitsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanLimitsStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlanLimitsStatusQuery(baseOptions?: Apollo.QueryHookOptions<PlanLimitsStatusQuery, PlanLimitsStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanLimitsStatusQuery, PlanLimitsStatusQueryVariables>(PlanLimitsStatusDocument, options);
      }
export function usePlanLimitsStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanLimitsStatusQuery, PlanLimitsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanLimitsStatusQuery, PlanLimitsStatusQueryVariables>(PlanLimitsStatusDocument, options);
        }
export function usePlanLimitsStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlanLimitsStatusQuery, PlanLimitsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanLimitsStatusQuery, PlanLimitsStatusQueryVariables>(PlanLimitsStatusDocument, options);
        }
export type PlanLimitsStatusQueryHookResult = ReturnType<typeof usePlanLimitsStatusQuery>;
export type PlanLimitsStatusLazyQueryHookResult = ReturnType<typeof usePlanLimitsStatusLazyQuery>;
export type PlanLimitsStatusSuspenseQueryHookResult = ReturnType<typeof usePlanLimitsStatusSuspenseQuery>;
export type PlanLimitsStatusQueryResult = Apollo.QueryResult<PlanLimitsStatusQuery, PlanLimitsStatusQueryVariables>;
export const ValidateConnectionAdditionDocument = gql`
    query ValidateConnectionAddition($integrationId: String!) {
  validateConnectionAddition(integrationId: $integrationId) {
    valid
    errors {
      errorCode
      reason
    }
  }
}
    `;

/**
 * __useValidateConnectionAdditionQuery__
 *
 * To run a query within a React component, call `useValidateConnectionAdditionQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateConnectionAdditionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateConnectionAdditionQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useValidateConnectionAdditionQuery(baseOptions: Apollo.QueryHookOptions<ValidateConnectionAdditionQuery, ValidateConnectionAdditionQueryVariables> & ({ variables: ValidateConnectionAdditionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateConnectionAdditionQuery, ValidateConnectionAdditionQueryVariables>(ValidateConnectionAdditionDocument, options);
      }
export function useValidateConnectionAdditionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateConnectionAdditionQuery, ValidateConnectionAdditionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateConnectionAdditionQuery, ValidateConnectionAdditionQueryVariables>(ValidateConnectionAdditionDocument, options);
        }
export function useValidateConnectionAdditionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateConnectionAdditionQuery, ValidateConnectionAdditionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateConnectionAdditionQuery, ValidateConnectionAdditionQueryVariables>(ValidateConnectionAdditionDocument, options);
        }
export type ValidateConnectionAdditionQueryHookResult = ReturnType<typeof useValidateConnectionAdditionQuery>;
export type ValidateConnectionAdditionLazyQueryHookResult = ReturnType<typeof useValidateConnectionAdditionLazyQuery>;
export type ValidateConnectionAdditionSuspenseQueryHookResult = ReturnType<typeof useValidateConnectionAdditionSuspenseQuery>;
export type ValidateConnectionAdditionQueryResult = Apollo.QueryResult<ValidateConnectionAdditionQuery, ValidateConnectionAdditionQueryVariables>;
export const ValidateCurrentConnectionUsageAgainstPlanDocument = gql`
    query ValidateCurrentConnectionUsageAgainstPlan($planName: PlanName!) {
  validateCurrentConnectionUsageAgainstPlan(planName: $planName) {
    valid
    connectionCount
    maxConnections
    isConnectorLimitExceeded
    violations {
      ...ConnectorPlanViolation
    }
    dataWarehouseViolation {
      ...ConnectorPlanViolation
    }
  }
}
    ${ConnectorPlanViolationFragmentDoc}`;

/**
 * __useValidateCurrentConnectionUsageAgainstPlanQuery__
 *
 * To run a query within a React component, call `useValidateCurrentConnectionUsageAgainstPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCurrentConnectionUsageAgainstPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCurrentConnectionUsageAgainstPlanQuery({
 *   variables: {
 *      planName: // value for 'planName'
 *   },
 * });
 */
export function useValidateCurrentConnectionUsageAgainstPlanQuery(baseOptions: Apollo.QueryHookOptions<ValidateCurrentConnectionUsageAgainstPlanQuery, ValidateCurrentConnectionUsageAgainstPlanQueryVariables> & ({ variables: ValidateCurrentConnectionUsageAgainstPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateCurrentConnectionUsageAgainstPlanQuery, ValidateCurrentConnectionUsageAgainstPlanQueryVariables>(ValidateCurrentConnectionUsageAgainstPlanDocument, options);
      }
export function useValidateCurrentConnectionUsageAgainstPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateCurrentConnectionUsageAgainstPlanQuery, ValidateCurrentConnectionUsageAgainstPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateCurrentConnectionUsageAgainstPlanQuery, ValidateCurrentConnectionUsageAgainstPlanQueryVariables>(ValidateCurrentConnectionUsageAgainstPlanDocument, options);
        }
export function useValidateCurrentConnectionUsageAgainstPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateCurrentConnectionUsageAgainstPlanQuery, ValidateCurrentConnectionUsageAgainstPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateCurrentConnectionUsageAgainstPlanQuery, ValidateCurrentConnectionUsageAgainstPlanQueryVariables>(ValidateCurrentConnectionUsageAgainstPlanDocument, options);
        }
export type ValidateCurrentConnectionUsageAgainstPlanQueryHookResult = ReturnType<typeof useValidateCurrentConnectionUsageAgainstPlanQuery>;
export type ValidateCurrentConnectionUsageAgainstPlanLazyQueryHookResult = ReturnType<typeof useValidateCurrentConnectionUsageAgainstPlanLazyQuery>;
export type ValidateCurrentConnectionUsageAgainstPlanSuspenseQueryHookResult = ReturnType<typeof useValidateCurrentConnectionUsageAgainstPlanSuspenseQuery>;
export type ValidateCurrentConnectionUsageAgainstPlanQueryResult = Apollo.QueryResult<ValidateCurrentConnectionUsageAgainstPlanQuery, ValidateCurrentConnectionUsageAgainstPlanQueryVariables>;